/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _BaseLayout = __webpack_require__(185);
	
	var _BaseLayout2 = _interopRequireDefault(_BaseLayout);
	
	var _promisePolyfill = __webpack_require__(294);
	
	var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);
	
	__webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	__webpack_require__(250); // Tell webpack to load favicon.ico
	
	function run() {
	  if (!window.Promise) {
	    window.Promise = _promisePolyfill2.default;
	  }
	
	  (0, _reactDom.render)(React.createElement(
	    _reactRouterDom.BrowserRouter,
	    null,
	    React.createElement(_BaseLayout2.default, null)
	  ), document.getElementById('app'));
	}
	
	if (!window.Intl) {
	
	  // Webpack parses the inside of require.ensure at build time to know that intl
	  // should be bundled separately. You could get the same effect by passing
	  // ['intl'] as the first argument.
	
	  // Ensure only makes sure the module has been downloaded and parsed.
	  // Now we actually need to run it to install the polyfill.
	  __webpack_require__(270);
	  // Carry on
	  run();
	} else {
	
	  // Polyfill wasn't needed, carry on
	  run();
	}

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(352);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 * Copyright 2016, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(473));
	var IntlMessageFormat = _interopDefault(__webpack_require__(126));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(264));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var invariant = _interopDefault(__webpack_require__(22));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(254));
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	    var data = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var locales = Array.isArray(data) ? data : [data];
	
	    locales.forEach(function (localeData) {
	        if (localeData && localeData.locale) {
	            IntlMessageFormat.__addLocaleData(localeData);
	            IntlRelativeFormat.__addLocaleData(localeData);
	        }
	    });
	}
	
	function hasLocaleData(locale) {
	    var localeParts = (locale || '').split('-');
	
	    while (localeParts.length > 0) {
	        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	            return true;
	        }
	
	        localeParts.pop();
	    }
	
	    return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	    var normalizedLocale = locale && locale.toLowerCase();
	
	    return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = React.PropTypes.bool;
	var number = React.PropTypes.number;
	var string = React.PropTypes.string;
	var func = React.PropTypes.func;
	var object = React.PropTypes.object;
	var oneOf = React.PropTypes.oneOf;
	var shape = React.PropTypes.shape;
	
	
	var intlConfigPropTypes = {
	    locale: string,
	    formats: object,
	    messages: object,
	
	    defaultLocale: string,
	    defaultFormats: object
	};
	
	var intlFormatPropTypes = {
	    formatDate: func.isRequired,
	    formatTime: func.isRequired,
	    formatRelative: func.isRequired,
	    formatNumber: func.isRequired,
	    formatPlural: func.isRequired,
	    formatMessage: func.isRequired,
	    formatHTMLMessage: func.isRequired
	};
	
	var intlShape = shape(babelHelpers$1['extends']({}, intlConfigPropTypes, intlFormatPropTypes, {
	    formatters: object,
	    now: func.isRequired
	}));
	
	var messageDescriptorPropTypes = {
	    id: string.isRequired,
	    description: string,
	    defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	    formatMatcher: oneOf(['basic', 'best fit']),
	
	    timeZone: string,
	    hour12: bool,
	
	    weekday: oneOf(['narrow', 'short', 'long']),
	    era: oneOf(['narrow', 'short', 'long']),
	    year: oneOf(['numeric', '2-digit']),
	    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	    day: oneOf(['numeric', '2-digit']),
	    hour: oneOf(['numeric', '2-digit']),
	    minute: oneOf(['numeric', '2-digit']),
	    second: oneOf(['numeric', '2-digit']),
	    timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	
	    style: oneOf(['decimal', 'currency', 'percent']),
	    currency: string,
	    currencyDisplay: oneOf(['symbol', 'code', 'name']),
	    useGrouping: bool,
	
	    minimumIntegerDigits: number,
	    minimumFractionDigits: number,
	    maximumFractionDigits: number,
	    minimumSignificantDigits: number,
	    maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	    style: oneOf(['best fit', 'numeric']),
	    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
	};
	
	var pluralFormatPropTypes = {
	    style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	    '&': '&amp;',
	    '>': '&gt;',
	    '<': '&lt;',
	    '"': '&quot;',
	    '\'': '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	        return ESCAPED_CHARS[match];
	    });
	}
	
	function filterProps(props, whitelist) {
	    var defaults = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    return whitelist.reduce(function (filtered, name) {
	        if (props.hasOwnProperty(name)) {
	            filtered[name] = props[name];
	        } else if (defaults.hasOwnProperty(name)) {
	            filtered[name] = defaults[name];
	        }
	
	        return filtered;
	    }, {});
	}
	
	function invariantIntlContext() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var intl = _ref.intl;
	
	    invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	
	    if ((typeof objA === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](objB)) !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < keysA.length; i++) {
	        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	    var props = _ref2.props;
	    var state = _ref2.state;
	    var _ref2$context = _ref2.context;
	    var context = _ref2$context === undefined ? {} : _ref2$context;
	    var nextContext = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var _context$intl = context.intl;
	    var intl = _context$intl === undefined ? {} : _context$intl;
	    var _nextContext$intl = nextContext.intl;
	    var nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component) {
	    return Component.displayName || Component.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    var _options$intlPropName = options.intlPropName;
	    var intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName;
	    var _options$withRef = options.withRef;
	    var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	    var InjectIntl = function (_Component) {
	        inherits(InjectIntl, _Component);
	
	        function InjectIntl(props, context) {
	            classCallCheck(this, InjectIntl);
	
	            var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
	
	            invariantIntlContext(context);
	            return _this;
	        }
	
	        createClass(InjectIntl, [{
	            key: 'getWrappedInstance',
	            value: function getWrappedInstance() {
	                invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	                return this.refs.wrappedInstance;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return React__default.createElement(WrappedComponent, babelHelpers$1['extends']({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	                    ref: withRef ? 'wrappedInstance' : null
	                }));
	            }
	        }]);
	        return InjectIntl;
	    }(React.Component);
	
	    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	
	    InjectIntl.contextTypes = {
	        intl: intlShape
	    };
	
	    InjectIntl.WrappedComponent = WrappedComponent;
	
	    return InjectIntl;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	    return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	    return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    classCallCheck(this, IntlPluralFormat);
	
	    var useOrdinal = options.style === 'ordinal';
	    var pluralFn = findPluralFunction(resolveLocale(locales));
	
	    this.format = function (value) {
	        return pluralFn(value, useOrdinal);
	    };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	    second: 60, // seconds to minute
	    minute: 60, // minutes to hour
	    hour: 24, // hours to day
	    day: 30, // days to month
	    month: 12 };
	
	function updateRelativeFormatThresholds(newThresholds) {
	    var thresholds = IntlRelativeFormat.thresholds;
	    thresholds.second = newThresholds.second;
	    thresholds.minute = newThresholds.minute;
	    thresholds.hour = newThresholds.hour;
	    thresholds.day = newThresholds.day;
	    thresholds.month = newThresholds.month;
	}
	
	function getNamedFormat(formats, type, name) {
	    var format = formats && formats[type] && formats[type][name];
	    if (format) {
	        return format;
	    }
	
	    if (false) {
	        console.error('[React Intl] No ' + type + ' format named: ' + name);
	    }
	}
	
	function formatDate(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'date', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting date.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatTime(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'time', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	        // Add default formatting options if hour, minute, or second isn't defined.
	        filteredOptions = babelHelpers$1['extends']({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	    }
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting time.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatRelative(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var now = new Date(options.now);
	    var defaults = format && getNamedFormat(formats, 'relative', format);
	    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults);
	
	    // Capture the current threshold values, then temporarily override them with
	    // specific values just for this render.
	    var oldThresholds = babelHelpers$1['extends']({}, IntlRelativeFormat.thresholds);
	    updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	    try {
	        return state.getRelativeFormat(locale, filteredOptions).format(date, {
	            now: isFinite(now) ? now : state.now()
	        });
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting relative time.\n' + e);
	        }
	    } finally {
	        updateRelativeFormatThresholds(oldThresholds);
	    }
	
	    return String(date);
	}
	
	function formatNumber(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var defaults = format && getNamedFormat(formats, 'number', format);
	    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getNumberFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting number.\n' + e);
	        }
	    }
	
	    return String(value);
	}
	
	function formatPlural(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	
	
	    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	
	    try {
	        return state.getPluralFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting plural.\n' + e);
	        }
	    }
	
	    return 'other';
	}
	
	function formatMessage(config, state) {
	    var messageDescriptor = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	    var values = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var messages = config.messages;
	    var defaultLocale = config.defaultLocale;
	    var defaultFormats = config.defaultFormats;
	    var id = messageDescriptor.id;
	    var defaultMessage = messageDescriptor.defaultMessage;
	
	    // `id` is a required field of a Message Descriptor.
	
	    invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	    var message = messages && messages[id];
	    var hasValues = Object.keys(values).length > 0;
	
	    // Avoid expensive message formatting for simple messages without values. In
	    // development messages will always be formatted in case of missing values.
	    if (!hasValues && ("production") === 'production') {
	        return message || defaultMessage || id;
	    }
	
	    var formattedMessage = void 0;
	
	    if (message) {
	        try {
	            var formatter = state.getMessageFormat(message, locale, formats);
	
	            formattedMessage = formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
	            }
	        }
	    } else {
	        if (false) {
	            // This prevents warnings from littering the console in development
	            // when no `messages` are passed into the <IntlProvider> for the
	            // default locale, and a default message is in the source.
	            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	
	                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
	            }
	        }
	    }
	
	    if (!formattedMessage && defaultMessage) {
	        try {
	            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	            formattedMessage = _formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
	            }
	        }
	    }
	
	    if (!formattedMessage) {
	        if (false) {
	            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
	        }
	    }
	
	    return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	    var rawValues = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	    // Process all the values before they are used when formatting the ICU
	    // Message string. Since the formatted message might be injected via
	    // `innerHTML`, all String-based values need to be HTML-escaped.
	    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	        var value = rawValues[name];
	        escaped[name] = typeof value === 'string' ? escape(value) : value;
	        return escaped;
	    }, {});
	
	    return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	
	
	var format = Object.freeze({
	    formatDate: formatDate,
	    formatTime: formatTime,
	    formatRelative: formatRelative,
	    formatNumber: formatNumber,
	    formatPlural: formatPlural,
	    formatMessage: formatMessage,
	    formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	    formats: {},
	    messages: {},
	
	    defaultLocale: 'en',
	    defaultFormats: {}
	};
	
	var IntlProvider = function (_Component) {
	    inherits(IntlProvider, _Component);
	
	    function IntlProvider(props, context) {
	        classCallCheck(this, IntlProvider);
	
	        var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
	
	        invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	        var intlContext = context.intl;
	
	        // Used to stabilize time when performing an initial rendering so that
	        // all relative times use the same reference "now" time.
	
	        var initialNow = void 0;
	        if (isFinite(props.initialNow)) {
	            initialNow = Number(props.initialNow);
	        } else {
	            // When an `initialNow` isn't provided via `props`, look to see an
	            // <IntlProvider> exists in the ancestry and call its `now()`
	            // function to propagate its value for "now".
	            initialNow = intlContext ? intlContext.now() : Date.now();
	        }
	
	        // Creating `Intl*` formatters is expensive. If there's a parent
	        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	        // memoize the `Intl*` constructors and cache them for the lifecycle of
	        // this IntlProvider instance.
	
	        var _ref = intlContext || {};
	
	        var _ref$formatters = _ref.formatters;
	        var formatters = _ref$formatters === undefined ? {
	            getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	            getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	            getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	            getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	            getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	        } : _ref$formatters;
	
	
	        _this.state = babelHelpers$1['extends']({}, formatters, {
	
	            // Wrapper to provide stable "now" time for initial render.
	            now: function now() {
	                return _this._didDisplay ? Date.now() : initialNow;
	            }
	        });
	        return _this;
	    }
	
	    createClass(IntlProvider, [{
	        key: 'getConfig',
	        value: function getConfig() {
	            var intlContext = this.context.intl;
	
	            // Build a whitelisted config object from `props`, defaults, and
	            // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	            var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	            // Apply default props. This must be applied last after the props have
	            // been resolved and inherited from any <IntlProvider> in the ancestry.
	            // This matches how React resolves `defaultProps`.
	            for (var propName in defaultProps) {
	                if (config[propName] === undefined) {
	                    config[propName] = defaultProps[propName];
	                }
	            }
	
	            if (!hasLocaleData(config.locale)) {
	                var _config = config;
	                var locale = _config.locale;
	                var defaultLocale = _config.defaultLocale;
	                var defaultFormats = _config.defaultFormats;
	
	
	                if (false) {
	                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
	                }
	
	                // Since there's no registered locale data for `locale`, this will
	                // fallback to the `defaultLocale` to make sure things can render.
	                // The `messages` are overridden to the `defaultProps` empty object
	                // to maintain referential equality across re-renders. It's assumed
	                // each <FormattedMessage> contains a `defaultMessage` prop.
	                config = babelHelpers$1['extends']({}, config, {
	                    locale: defaultLocale,
	                    formats: defaultFormats,
	                    messages: defaultProps.messages
	                });
	            }
	
	            return config;
	        }
	    }, {
	        key: 'getBoundFormatFns',
	        value: function getBoundFormatFns(config, state) {
	            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	                boundFormatFns[name] = format[name].bind(null, config, state);
	                return boundFormatFns;
	            }, {});
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var config = this.getConfig();
	
	            // Bind intl factories and current config to the format functions.
	            var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	            var _state = this.state;
	            var now = _state.now;
	            var formatters = objectWithoutProperties(_state, ['now']);
	
	
	            return {
	                intl: babelHelpers$1['extends']({}, config, boundFormatFns, {
	                    formatters: formatters,
	                    now: now
	                })
	            };
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._didDisplay = true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }]);
	    return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	
	IntlProvider.contextTypes = {
	    intl: intlShape
	};
	
	IntlProvider.childContextTypes = {
	    intl: intlShape.isRequired
	};
	
	IntlProvider.propTypes = babelHelpers$1['extends']({}, intlConfigPropTypes, {
	    children: React.PropTypes.element.isRequired,
	    initialNow: React.PropTypes.any
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	    inherits(FormattedDate, _Component);
	
	    function FormattedDate(props, context) {
	        classCallCheck(this, FormattedDate);
	
	        var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedDate, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatDate = this.context.intl.formatDate;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedDate = formatDate(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedDate);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedDate
	            );
	        }
	    }]);
	    return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	
	FormattedDate.contextTypes = {
	    intl: intlShape
	};
	
	FormattedDate.propTypes = babelHelpers$1['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	    inherits(FormattedTime, _Component);
	
	    function FormattedTime(props, context) {
	        classCallCheck(this, FormattedTime);
	
	        var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedTime, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatTime = this.context.intl.formatTime;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedTime = formatTime(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedTime);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedTime
	            );
	        }
	    }]);
	    return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	
	FormattedTime.contextTypes = {
	    intl: intlShape
	};
	
	FormattedTime.propTypes = babelHelpers$1['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	    var absDelta = Math.abs(delta);
	
	    if (absDelta < MINUTE) {
	        return 'second';
	    }
	
	    if (absDelta < HOUR) {
	        return 'minute';
	    }
	
	    if (absDelta < DAY) {
	        return 'hour';
	    }
	
	    // The maximum scheduled delay will be measured in days since the maximum
	    // timer delay is less than the number of milliseconds in 25 days.
	    return 'day';
	}
	
	function getUnitDelay(units) {
	    switch (units) {
	        case 'second':
	            return SECOND;
	        case 'minute':
	            return MINUTE;
	        case 'hour':
	            return HOUR;
	        case 'day':
	            return DAY;
	        default:
	            return MAX_TIMER_DELAY;
	    }
	}
	
	function isSameDate(a, b) {
	    if (a === b) {
	        return true;
	    }
	
	    var aTime = new Date(a).getTime();
	    var bTime = new Date(b).getTime();
	
	    return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	    inherits(FormattedRelative, _Component);
	
	    function FormattedRelative(props, context) {
	        classCallCheck(this, FormattedRelative);
	
	        var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
	
	        invariantIntlContext(context);
	
	        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	        // `now` is stored as state so that `render()` remains a function of
	        // props + state, instead of accessing `Date.now()` inside `render()`.
	        _this.state = { now: now };
	        return _this;
	    }
	
	    createClass(FormattedRelative, [{
	        key: 'scheduleNextUpdate',
	        value: function scheduleNextUpdate(props, state) {
	            var _this2 = this;
	
	            var updateInterval = props.updateInterval;
	
	            // If the `updateInterval` is falsy, including `0`, then auto updates
	            // have been turned off, so we bail and skip scheduling an update.
	
	            if (!updateInterval) {
	                return;
	            }
	
	            var time = new Date(props.value).getTime();
	            var delta = time - state.now;
	            var units = props.units || selectUnits(delta);
	
	            var unitDelay = getUnitDelay(units);
	            var unitRemainder = Math.abs(delta % unitDelay);
	
	            // We want the largest possible timer delay which will still display
	            // accurate information while reducing unnecessary re-renders. The delay
	            // should be until the next "interesting" moment, like a tick from
	            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	            clearTimeout(this._timer);
	
	            this._timer = setTimeout(function () {
	                _this2.setState({ now: _this2.context.intl.now() });
	            }, delay);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.scheduleNextUpdate(this.props, this.state);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var nextValue = _ref.value;
	
	            // When the `props.value` date changes, `state.now` needs to be updated,
	            // and the next update can be rescheduled.
	            if (!isSameDate(nextValue, this.props.value)) {
	                this.setState({ now: this.context.intl.now() });
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            this.scheduleNextUpdate(nextProps, nextState);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatRelative = this.context.intl.formatRelative;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedRelative = formatRelative(value, babelHelpers$1['extends']({}, this.props, this.state));
	
	            if (typeof children === 'function') {
	                return children(formattedRelative);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedRelative
	            );
	        }
	    }]);
	    return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	
	FormattedRelative.contextTypes = {
	    intl: intlShape
	};
	
	FormattedRelative.propTypes = babelHelpers$1['extends']({}, relativeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    updateInterval: React.PropTypes.number,
	    initialNow: React.PropTypes.any,
	    children: React.PropTypes.func
	});
	
	FormattedRelative.defaultProps = {
	    updateInterval: 1000 * 10
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	    inherits(FormattedNumber, _Component);
	
	    function FormattedNumber(props, context) {
	        classCallCheck(this, FormattedNumber);
	
	        var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedNumber, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatNumber = this.context.intl.formatNumber;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedNumber = formatNumber(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedNumber);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedNumber
	            );
	        }
	    }]);
	    return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	
	FormattedNumber.contextTypes = {
	    intl: intlShape
	};
	
	FormattedNumber.propTypes = babelHelpers$1['extends']({}, numberFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	    inherits(FormattedPlural, _Component);
	
	    function FormattedPlural(props, context) {
	        classCallCheck(this, FormattedPlural);
	
	        var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedPlural, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatPlural = this.context.intl.formatPlural;
	            var _props = this.props;
	            var value = _props.value;
	            var other = _props.other;
	            var children = _props.children;
	
	
	            var pluralCategory = formatPlural(value, this.props);
	            var formattedPlural = this.props[pluralCategory] || other;
	
	            if (typeof children === 'function') {
	                return children(formattedPlural);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedPlural
	            );
	        }
	    }]);
	    return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	
	FormattedPlural.contextTypes = {
	    intl: intlShape
	};
	
	FormattedPlural.propTypes = babelHelpers$1['extends']({}, pluralFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	
	    other: React.PropTypes.node.isRequired,
	    zero: React.PropTypes.node,
	    one: React.PropTypes.node,
	    two: React.PropTypes.node,
	    few: React.PropTypes.node,
	    many: React.PropTypes.node,
	
	    children: React.PropTypes.func
	});
	
	FormattedPlural.defaultProps = {
	    style: 'cardinal'
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedMessage = function (_Component) {
	    inherits(FormattedMessage, _Component);
	
	    function FormattedMessage(props, context) {
	        classCallCheck(this, FormattedMessage);
	
	        var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers$1['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.context.intl.formatMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var values = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var tokenDelimiter = void 0;
	            var tokenizedValues = void 0;
	            var elements = void 0;
	
	            var hasValues = values && Object.keys(values).length > 0;
	            if (hasValues) {
	                (function () {
	                    // Creates a token with a random UID that should not be guessable or
	                    // conflict with other parts of the `message` string.
	                    var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	                    var generateToken = function () {
	                        var counter = 0;
	                        return function () {
	                            return 'ELEMENT-' + uid + '-' + (counter += 1);
	                        };
	                    }();
	
	                    // Splitting with a delimiter to support IE8. When using a regex
	                    // with a capture group IE8 does not include the capture group in
	                    // the resulting array.
	                    tokenDelimiter = '@__' + uid + '__@';
	                    tokenizedValues = {};
	                    elements = {};
	
	                    // Iterates over the `props` to keep track of any React Element
	                    // values so they can be represented by the `token` as a placeholder
	                    // when the `message` is formatted. This allows the formatted
	                    // message to then be broken-up into parts with references to the
	                    // React Elements inserted back in.
	                    Object.keys(values).forEach(function (name) {
	                        var value = values[name];
	
	                        if (React.isValidElement(value)) {
	                            var token = generateToken();
	                            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	                            elements[token] = value;
	                        } else {
	                            tokenizedValues[name] = value;
	                        }
	                    });
	                })();
	            }
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);
	
	            var nodes = void 0;
	
	            var hasElements = elements && Object.keys(elements).length > 0;
	            if (hasElements) {
	                // Split the message into parts so the React Element values captured
	                // above can be inserted back into the rendered message. This
	                // approach allows messages to render with React Elements while
	                // keeping React's virtual diffing working properly.
	                nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	                    return !!part;
	                }).map(function (part) {
	                    return elements[part] || part;
	                });
	            } else {
	                nodes = [formattedMessage];
	            }
	
	            if (typeof children === 'function') {
	                return children.apply(undefined, toConsumableArray(nodes));
	            }
	
	            return React.createElement.apply(undefined, [tagName, null].concat(toConsumableArray(nodes)));
	        }
	    }]);
	    return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	
	FormattedMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedMessage.propTypes = babelHelpers$1['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	    inherits(FormattedHTMLMessage, _Component);
	
	    function FormattedHTMLMessage(props, context) {
	        classCallCheck(this, FormattedHTMLMessage);
	
	        var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedHTMLMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers$1['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatHTMLMessage = this.context.intl.formatHTMLMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var rawValues = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	            if (typeof children === 'function') {
	                return children(formattedHTMLMessage);
	            }
	
	            // Since the message presumably has HTML in it, we need to set
	            // `innerHTML` in order for it to be rendered and not escaped by React.
	            // To be safe, all string prop values were escaped when formatting the
	            // message. It is assumed that the message is not UGC, and came from the
	            // developer making it more like a template.
	            //
	            // Note: There's a perf impact of using this component since there's no
	            // way for React to do its virtual DOM diffing.
	            return React.createElement(tagName, {
	                dangerouslySetInnerHTML: {
	                    __html: formattedHTMLMessage
	                }
	            });
	        }
	    }]);
	    return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	
	FormattedHTMLMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedHTMLMessage.propTypes = babelHelpers$1['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedHTMLMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(295)();
	}


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(15);
	var isNil = __webpack_require__(25);
	var fail = __webpack_require__(422);
	var stringify = __webpack_require__(182);
	
	function assert(guard, message) {
	  if (guard !== true) {
	    if (isFunction(message)) { // handle lazy messages
	      message = message();
	    }
	    else if (isNil(message)) { // use a default message
	      message = 'Assert failed (turn on "Pause on exceptions" in your Source panel)';
	    }
	    assert.fail(message);
	  }
	}
	
	assert.fail = fail;
	assert.stringify = stringify;
	
	module.exports = assert;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(314);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(315);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(134);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(316);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(317);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(318);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(319);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(135);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(75);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(320);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(321);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(322);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(323);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMProperty = __webpack_require__(43);
	var ReactDOMComponentFlags = __webpack_require__(151);
	
	var invariant = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modeCheck = modeCheck;
	var server_url = '/';
	
	if (false) {
	  //server_url = "https://picklymenu.com/";
	  server_url = "http://127.0.0.1:8000/";
	}
	
	var API = exports.API = server_url;
	
	var mode = false;
	
	function modeCheck(variable) {
	  if (mode === false) {
	    mode = 'none';
	    var query = window.location.search.substring(1);
	    var vars = query.split("&");
	    for (var i = 0; i < vars.length; i++) {
	      var pair = vars[i].split("=");
	      if (pair[0] == variable) {
	        mode = pair[1];
	      }
	    }
	  }
	  return mode;
	}

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.post = post;
	exports.ajaxGet = ajaxGet;
	exports.ajaxPost = ajaxPost;
	exports.ajaxGetHTML = ajaxGetHTML;
	//import { browserHistory } from 'react-router'
	
	function get(url) {
	  //var parsified = url.split("/", 4);
	  // var lang = parsified[parsified.length-1];
	
	  // Return a new promise.
	  return new Promise(function (resolve, reject) {
	    // Do the usual XHR stuff
	    var req = new XMLHttpRequest();
	    req.open('GET', url);
	    req.setRequestHeader('Accept', 'application/json');
	    req.onload = function () {
	      // This is called even on 404 etc
	      // so check the status
	      if (req.status === 200) {
	        // Resolve the promise with the response text
	        resolve(req.response);
	      } else {
	        // Otherwise reject with the status text
	        // which will hopefully be a meaningful error
	        // reject(Error(req.statusText));
	        resolve('{"status": "error"}');
	      }
	    };
	
	    // Handle network errors
	    req.onerror = function () {
	      reject(Error("Network Error"));
	    };
	
	    // Make the request
	    req.send();
	  });
	}
	
	function post(url, body) {
	  // Return a new promise.
	  return new Promise(function (resolve, reject) {
	    // Do the usual XHR stuff
	    var req = new XMLHttpRequest();
	    req.open('POST', url);
	    req.setRequestHeader('Content-Type', 'application/json');
	    req.onload = function () {
	      // This is called even on 404 etc
	      // so check the status
	      if (req.status === 200 || req.status === 201) {
	        // Resolve the promise with the response text
	        resolve(req.response);
	      } else {
	        // Otherwise reject with the status text
	        // which will hopefully be a meaningful error
	        reject(Error(req.statusText));
	      }
	    };
	
	    // Handle network errors
	    req.onerror = function () {
	      reject(Error("Network Error"));
	    };
	
	    // Make the request
	    req.send(JSON.stringify(body));
	  });
	}
	
	function ajaxGet(url, self) {
	  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  get(url).then(function (response) {
	    return JSON.parse(response);
	  }).then(function (response) {
	    self.setState({ data: response }, callback);
	  });
	}
	
	function ajaxPost(url, body, self) {
	  post(url, body).then(function (response) {
	    return JSON.parse(response);
	  }).then(function (response) {
	    self.setState({ data: response });
	  });
	}
	
	function ajaxGetHTML(url, self) {
	  get(url).then(function (response) {
	    return response;
	  }).then(function (response) {
	    self.setState({ data: response });
	  });
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(16);
	var getFunctionName = __webpack_require__(52);
	
	module.exports = function getTypeName(ctor) {
	  if (isType(ctor)) {
	    return ctor.displayName;
	  }
	  return getFunctionName(ctor);
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = function isFunction(x) {
	  return typeof x === 'function';
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(15);
	var isObject = __webpack_require__(33);
	
	module.exports = function isType(x) {
	  return isFunction(x) && isObject(x.meta);
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isString = __webpack_require__(68);
	var isFunction = __webpack_require__(15);
	var forbidNewOperator = __webpack_require__(51);
	
	module.exports = function irreducible(name, predicate) {
	
	  if (false) {
	    assert(isString(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to irreducible(name, predicate) (expected a string)'; });
	    assert(isFunction(predicate), 'Invalid argument predicate ' + assert.stringify(predicate) + ' supplied to irreducible(name, predicate) (expected a function)');
	  }
	
	  function Irreducible(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Irreducible);
	      path = path || [name];
	      assert(predicate(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return value;
	  }
	
	  Irreducible.meta = {
	    kind: 'irreducible',
	    name: name,
	    predicate: predicate,
	    identity: true
	  };
	
	  Irreducible.displayName = name;
	
	  Irreducible.is = predicate;
	
	  return Irreducible;
	};


/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var isNil = __webpack_require__(25);
	var isString = __webpack_require__(68);
	
	module.exports = function isTypeName(name) {
	  return isNil(name) || isString(name);
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(36);
	
	var warning = __webpack_require__(5);
	var canDefineProperty = __webpack_require__(164);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      Object.defineProperty(element, '_shadowChildren', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: shadowChildren
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._shadowChildren = shadowChildren;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(147);
	var PooledClass = __webpack_require__(35);
	var ReactFeatureFlags = __webpack_require__(154);
	var ReactReconciler = __webpack_require__(44);
	var Transaction = __webpack_require__(50);
	
	var invariant = __webpack_require__(2);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 25 */
/***/ function(module, exports) {

	module.exports = function isNil(x) {
	  return x === null || x === void 0;
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(56);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(35);
	
	var emptyFunction = __webpack_require__(18);
	var warning = __webpack_require__(5);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(16);
	var getFunctionName = __webpack_require__(52);
	var assert = __webpack_require__(8);
	var stringify = __webpack_require__(182);
	
	// creates an instance of a type, handling the optional new operator
	module.exports = function create(type, value, path) {
	  if (isType(type)) {
	    return !type.meta.identity && typeof value === 'object' && value !== null ? new type(value, path): type(value, path);
	  }
	
	  if (false) {
	    // here type should be a class constructor and value some instance, just check membership and return the value
	    path = path || [getFunctionName(type)];
	    assert(value instanceof type, function () { return 'Invalid value ' + stringify(value) + ' supplied to ' + path.join('/'); });
	  }
	
	  return value;
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(16);
	
	// returns true if x is an instance of type
	module.exports = function is(x, type) {
	  if (isType(type)) {
	    return type.is(x);
	  }
	  return x instanceof type; // type should be a class constructor
	};


/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = function isArray(x) {
	  return Array.isArray ? Array.isArray(x) : x instanceof Array;
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var Boolean = __webpack_require__(173);
	var isType = __webpack_require__(16);
	var getTypeName = __webpack_require__(13);
	
	// return true if the type constructor behaves like the identity function
	module.exports = function isIdentity(type) {
	  if (isType(type)) {
	    if (false) {
	      assert(Boolean.is(type.meta.identity), function () { return 'Invalid meta identity ' + assert.stringify(type.meta.identity) + ' supplied to type ' + getTypeName(type); });
	    }
	    return type.meta.identity;
	  }
	  // for tcomb the other constructors, like ES6 classes, are identity-like
	  return true;
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var isNil = __webpack_require__(25);
	var isArray = __webpack_require__(31);
	
	module.exports = function isObject(x) {
	  return !isNil(x) && typeof x === 'object' && !isArray(x);
	};

/***/ },
/* 34 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PreLoader = function (_React$PureComponent) {
	  _inherits(PreLoader, _React$PureComponent);
	
	  function PreLoader() {
	    _classCallCheck(this, PreLoader);
	
	    return _possibleConstructorReturn(this, (PreLoader.__proto__ || Object.getPrototypeOf(PreLoader)).apply(this, arguments));
	  }
	
	  _createClass(PreLoader, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.loading === 'loading') {
	        // Render loading gif
	        return _react2.default.createElement(
	          'div',
	          { className: 'spinner' },
	          _react2.default.createElement('div', { className: 'cube1' }),
	          _react2.default.createElement('div', { className: 'cube2' })
	        );
	      }
	      return null;
	    }
	  }]);
	
	  return PreLoader;
	}(_react2.default.PureComponent);
	
	PreLoader.propTypes = {
	  loading: _react.PropTypes.string
	};
	exports.default = PreLoader;

/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.imagesLoaded = imagesLoaded;
	function imagesLoaded(parentNode) {
	  var imgElements = parentNode.querySelectorAll('img');
	  for (var img = 0, l = imgElements.length; img < l; img++) {
	    if (!imgElements[img].complete) {
	      return 'loading';
	    }
	  }
	  return 'loaded';
	}

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(356);


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(83);
	var setInnerHTML = __webpack_require__(65);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(97);
	var setTextContent = __webpack_require__(171);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(380);
	var ReactInstrumentation = __webpack_require__(21);
	
	var warning = __webpack_require__(5);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cookies = __webpack_require__(435);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Cookies2.default;
	module.exports = exports['default'];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventPluginRegistry = __webpack_require__(84);
	var EventPluginUtils = __webpack_require__(85);
	var ReactErrorUtils = __webpack_require__(91);
	
	var accumulateInto = __webpack_require__(163);
	var forEachAccumulated = __webpack_require__(165);
	var invariant = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(27);
	var EventPluginHub = __webpack_require__(46);
	var EventPluginUtils = __webpack_require__(85);
	
	var accumulateInto = __webpack_require__(163);
	var forEachAccumulated = __webpack_require__(165);
	var warning = __webpack_require__(5);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 48 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	var getEventTarget = __webpack_require__(100);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var getTypeName = __webpack_require__(13);
	
	module.exports = function forbidNewOperator(x, type) {
	  assert(!(x instanceof type), function () { return 'Cannot use the new operator to instantiate the type ' + getTypeName(type); });
	};

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = function getFunctionName(f) {
	  return f.displayName || f.name || '<function' + f.length + '>';
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TopBar = __webpack_require__(113);
	
	var _TopBar2 = _interopRequireDefault(_TopBar);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Error = function (_React$Component) {
	  _inherits(Error, _React$Component);
	
	  function Error() {
	    _classCallCheck(this, Error);
	
	    return _possibleConstructorReturn(this, (Error.__proto__ || Object.getPrototypeOf(Error)).apply(this, arguments));
	  }
	
	  _createClass(Error, [{
	    key: 'render',
	    value: function render() {
	      var anchor_url = 'https://picklymenu.com/';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TopBar2.default, { restaurant: this.props.restaurant, name: 'Pickly',
	          logo: this.props.logo, city: this.props.city,
	          country: this.props.country, lang: this.props.lang, wine_slug: this.props.wine_slug,
	          view: 'error' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'error-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'error-content' },
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'error_home_title1' },
	              function (message) {
	                return _react2.default.createElement(
	                  'h2',
	                  null,
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'error_home_title2' },
	              function (message) {
	                return _react2.default.createElement(
	                  'h4',
	                  null,
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'error_home_text' },
	              function (message) {
	                return _react2.default.createElement(
	                  'p',
	                  null,
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'btn secondary-btn big-btn',
	                href: anchor_url },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'error_home_link' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Error;
	}(_react2.default.Component);
	
	Error.propTypes = {
	  city: _react.PropTypes.string,
	  country: _react.PropTypes.string,
	  lang: _react.PropTypes.string,
	  logo: _react.PropTypes.string,
	  restaurant: _react.PropTypes.string,
	  wine_slug: _react.PropTypes.string
	};
	exports.default = Error;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgIcons = function (_React$PureComponent) {
	      _inherits(SvgIcons, _React$PureComponent);
	
	      function SvgIcons(props) {
	            var _React$createElement;
	
	            _classCallCheck(this, SvgIcons);
	
	            var _this = _possibleConstructorReturn(this, (SvgIcons.__proto__ || Object.getPrototypeOf(SvgIcons)).call(this, props));
	
	            _this.icons = {
	                  'beef': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M208.1 316.9c0-33.9 0-67.9 0-101.9 37.6 0 75.2 0 112.9 0 0 33.9 0 67.9 0 101.9C283.4 316.9 245.7 316.9 208.1 316.9zM232.6 244.8c-2.4 0.1-4.7 0.1-7 0.5 -5.5 0.8-9.7 4.8-10.3 10 -0.6 4.6 1.9 7.9 7.7 10.2 1.4 0.5 2.8 1.1 4.3 1.2 3.5 0.2 4.6 1.8 5 5.3 1.3 11.2 5.6 21.2 13.3 29.5 11.7 12.7 25.3 13.4 36.6 2 7.9-8 13.5-17.5 15.1-28.6 0.8-5.3 2.2-7.8 7.8-9.1 8.9-2.1 12.2-9 7.5-14.9 -2.2-2.8-6.4-4.3-10-5.6 -2.1-0.8-4.7-0.1-7.7-0.1 3.6-7.9 6.8-15.1 3.1-23.9 -5.9 4.7-11 8.9-16.1 13 -2.5 2-4.9 2.3-8.3 1.7 -5-0.9-10.6-1.9-15.2-0.4 -7.1 2.3-11.8-0.5-16.6-4.5 -1.7-1.4-3.2-3-4.9-4.2 -2.3-1.6-4.8-2.9-7.2-4.4 -0.5 3.2-1.7 6.5-1.2 9.5C229.2 236.2 231.1 240.3 232.6 244.8z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M241.4 287c-7.2-11-7.9-25.9-0.9-36.1 4.8-7.1 15.6-14 27.7-11.2 -0.3 2.2-0.8 4.5-0.8 6.7 -0.1 4.1-0.8 8.4 2.9 11.6 0.7 0.6 0.8 2.1 0.8 3.2 0.4 9.7 5.1 15 15 16.7 1.8 0.3 3.5 0.6 6.1 1 -1.1 3.3-2 6.1-3 9.2C271.5 275.6 256.8 275.4 241.4 287zM253.1 253.5c-0.7 0-1.4 0-2.1 0 -3.1 2.5-3.2 5.8-2 9.2 0.3 0.9 1.6 2 2.3 2 0.8 0 2.2-1.3 2.2-2.1C253.6 259.6 253.3 256.5 253.1 253.5z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M266.2 307.2c-8.9 0.1-20.2-7.7-22.8-15.1 -0.4-1 0.4-2.9 1.2-3.7 9.1-9 28.2-9.7 38-1.7 3.3 2.7 4.5 5.2 1.3 9.1C278.8 301.8 273.4 306.8 266.2 307.2zM255.5 288.7c-1 0-1.9-0.1-2.9-0.1 0 2.1 0 4.3 0.1 6.4 0 0.1 1.6 0.1 2.4 0.2C255.2 293 255.4 290.8 255.5 288.7zM274.8 295.7c0.8 0 1.6-0.1 2.4-0.1 -0.1-2.3-0.3-4.6-0.4-6.9 -0.7 0-1.4 0.1-2 0.1C274.8 291.1 274.8 293.4 274.8 295.7z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M231.9 263.9c-3.4-1-6.2-1.5-8.7-2.6 -5.3-2.4-5.5-7.6-0.6-10.8 3.6-2.4 9.7-2.1 12.9 1.1 -4.2 0.6-8.9-1.2-11.6 3.6 3.2 0.4 6.1 0.7 9 1C232.7 258.3 232.4 260.6 231.9 263.9z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M298.5 263.2c-2.3-7.8-2.3-7.8 7.5-8.6 -1.8-1-3.4-2.3-5.3-2.7 -2-0.5-4.2-0.1-7.6-0.1 4.9-3.5 11.1-3.9 13.9-1 1.6 1.7 3.4 5 2.7 6.7C308 262.3 303.3 262.9 298.5 263.2z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M246 239.4c-2.4 2.2-4.4 4-7.6 7 -2.5-6-4.5-11.1-6.6-16.2 0.5-0.3 1-0.6 1.6-0.9C237.3 232.5 241.4 235.8 246 239.4z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M282.6 238.9c4.5-3.6 8.5-6.7 12.5-9.9 0.5 0.3 1 0.6 1.5 0.9 -1.9 4.8-3.8 9.5-6 14.9C287.5 242.6 285.3 241 282.6 238.9z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M286.2 259.5c-0.1 1 0.1 2.2-0.4 2.9 -1.2 1.6-2.7 3-4.1 4.5 -1.4-1.5-2.9-2.9-4.1-4.5 -0.5-0.7-0.5-1.9-0.5-2.9 0.3-3.3 0.5-7.6 4.7-7.3 1.9 0.1 3.6 4.2 5.3 6.4C286.9 258.9 286.6 259.2 286.2 259.5zM284.1 253.8c-5.2 1.9-6.5 7.5-3.9 10 0.5 0.5 3.7-0.3 3.8-0.8C284.2 259.9 284.1 256.9 284.1 253.8z' }),
	                        _react2.default.createElement('ellipse', { cx: '405', cy: '270.6', rx: '20.2', ry: '34.7' }),
	                        _react2.default.createElement('ellipse', { cx: '378.5', cy: '452.7', rx: '12.7', ry: '21.8' }),
	                        _react2.default.createElement('ellipse', { cx: '257.9', cy: '452.7', rx: '12.7', ry: '21.8' }),
	                        _react2.default.createElement('ellipse', { cx: '237.7', cy: '270.6', rx: '20.2', ry: '34.7' }),
	                        _react2.default.createElement('path', { d: 'M567.8 214c-5.9-12.4-26.2-19.4-43.5-19.7 -13.7-0.9-28.9-0.6-42.5 1.1 19.4-43.1 29.1-82.3 8.7-130.4 -27.3 28.3-48.5 47.2-79.7 71.2 -13.5 11-27 12.7-45.2 9.4 -27.2-5-58.2-6.2-83.1-2.2C214.1 158 141.7 86.1 124.4 65c-7.3 16.5-8.2 42-5.6 58.5 3.7 23.5 14.3 45.9 22.5 70.1 -13.1 0.8-25.7 0.8-38.1 2.5 -30.3 4.2-53 26.5-56.6 54.6 -3.2 25 10.5 43.3 42.2 55.8 7.6 3 14.6 5.2 23.5 6.7 25.5 6.5 25 10 27.2 29.1 6.9 61.1 30.8 115.8 72.7 161.1 64 69.1 138.3 73.2 200.2 11 43.3-43.5 73.6-95.6 82.4-156.5 4.2-29 12.2-42.7 42.7-49.9C593.7 282 577.2 226.3 567.8 214zM483 100.6c1.9 18.6-6.1 77.4-25 93.3 -14.8-15.7-27.2-23.7-43.6-32.3C443.2 142.5 463.2 122.1 483 100.6zM404.7 225.5c14.5 0 26.2 20.2 26.2 45.1 0 24.9-11.7 45.1-26.2 45.1 -14.5 0-26.2-20.2-26.2-45.1C378.5 245.7 390.2 225.5 404.7 225.5zM140.4 104.4c19 22.7 47.7 44.1 74.1 59.9 -15.8 10.3-27.2 20.4-41.8 38.2C156.7 174.5 133.2 118.6 140.4 104.4zM94.2 249.9c19.9-7.3 36.5-8.9 55.8-1 -6.7 12.5-10.2 30.1-12.4 49.2 -19.4-3.7-34.1-8.1-47.7-14.4 -28.8-13.3-29.9-41.8-3.2-59.2 19.9-13 53.1-11.3 70.7 6C143.5 225.9 108.5 224 94.2 249.9zM421.8 472.1c-27.8 33.2-57.8 60.6-96.7 62.7 -48.4 0.3-110.2-42.3-124.4-82.7 -1.9-5.5 2.1-15.7 6.8-20.4 49.7-49 154.1-53.1 207.5-9.4C433 437.2 439.6 450.9 421.8 472.1zM450.2 430.1c-79.4-71.2-184.2-68.1-260.8-5.7 -39.4-59.9-42.9-141.6-5-197.6 26.3-38.9 85.4-76.4 151.3-61.3 -1.6 12.1-4.1 24.5-4.5 36.9 -0.8 22.4-4.5 45.7 16.1 63.3 3.7 3.2 4.2 11.4 4.5 17.4 2.2 53.2 27.9 82 82 91.3 9.7 1.7 19.4 3.2 33.2 5.5C464.6 398.1 458.7 413.6 450.2 430.1zM560.5 259.8c-4.8 29.7-43.9 36.2-70 37.9 -0.5-17.8-1-37.6-9.1-46.3 1.7-10.8 22.9-22.2 48.7-15.4 -4.7-4.7-7.3-7.5-17.6-10 -12-1.7-22-2-40.3 5.8 18.8-25 63.8-24.6 78.8-8.9C555.8 227.9 561.9 242.4 560.5 259.8z' })
	                  ),
	                  'pork': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M373 355c-34.6 0-69.3 0-104 0 0-28 0-55.9 0-84 34.6 0 69.3 0 104 0C373 299 373 327 373 355zM274.2 277.7c-0.2 13.9 4.3 24.6 18.2 30 -4.7 15.7-0.9 28.6 13.7 36.7 12.5 6.9 25.1 5.7 36.6-2.7 11.8-8.7 12.9-20.8 9.5-33.9 13.7-7.5 19.3-17.3 17.1-30.1 -11.2-2.1-21.4 0.3-30.3 7.4 -2.2 1.8-4 2.1-6.7 1 -6.7-2.8-13.7-2.8-20.4 0 -2.7 1.2-4.4 0.8-6.7-1C296.4 277.9 286.1 275.6 274.2 277.7z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M29 97.3c71.7-12.5 132.9 1.2 186.4 44.2 13.3 10.7 23.7 12.6 39.9 5.7 40.1-17.2 81.8-17.1 122-0.3 16.1 6.7 26.8 4.7 40.2-5.8 53.6-42.3 114.5-56.6 181.4-44.2 12.6 77-20.7 135.7-102.6 180.3 20.1 78.1 13.6 150.7-57.1 202.6 -68.8 50.5-144.4 57.6-219.1 16.3 -87.1-48.2-110-125.3-81.9-219.5C54.5 244.6 27.8 180.5 29 97.3zM313.9 495.2c94.8 1.3 165-60 167-145.6 2.2-94.5-77.8-189.8-160.9-191.7 -83.9-1.8-166.1 88.7-167.6 184.5C151 431.4 217.2 494 313.9 495.2zM554.3 146.5c-34.2 3.2-62.3 8.3-88.5 32 -13.9 12.6-15.2 32.8-2.5 46.2 12.2 14.5 20.7 23.4 39.4 20.1 44.7-17.7 78.4-73.7 72.1-126.1 -59.6-7.2-108.7 14.2-150.6 56.2 3.4 5.5 8.1 8.1 12.9 7.5 5.1-0.7 12.2-8.8 15.9-11.8C481.6 147.5 512.6 138.1 554.3 146.5zM75.6 150.9c0.7-7.6 16.8-7.6 21.8-7.8 32.1-1.5 60.5 6.9 84.5 30 5.8 5.6 12 20.1 26.2 7.5 2-1.7 3.9-3.5 4.7-5 1.5-3.7 0.5-5.4-2.4-8.3 -43.6-34-95.4-55.1-152.8-48.9 -2.7 61.7 26.2 110.3 73.9 126.3 6.4 2.1 16.5 2.7 21.2-0.9 37.9-29.1 30-53.9-10.5-78.9C123.5 153.4 103.7 150.2 75.6 150.9z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M321.8 344.2c-16.2-0.2-27.2-10.7-27-25.5 0.3-16 14-31.2 28-30.8 13.9 0.3 27.3 16.2 26.9 32C349.4 334.2 337.6 344.4 321.8 344.2zM322.4 337.5c6.9 0 11.8-3.6 11.8-8.7 0.1-6.2-6.6-14-11.9-14 -5.3 0-12.1 8-11.9 14.1C310.5 333.9 315.5 337.5 322.4 337.5zM313.6 307.6c-1.6-1.9-2.6-3.2-3.7-4.4 -0.9 1.5-2.5 3-2.6 4.6 -0.1 1.4 1.5 2.8 2.4 4.2C310.9 310.7 312 309.4 313.6 307.6zM338.1 307.9c-1.4-1.9-2.3-3.2-3.3-4.6 -1 1.5-2.6 2.9-2.7 4.5 -0.1 1.4 1.5 2.8 2.4 4.2C335.6 310.8 336.7 309.6 338.1 307.9z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M362 285.9c-7-1.4-12.2 0.2-16.9 4 -1.2 1-2.9 1.2-4.8 0.7 7-7 15.2-10.6 25.2-9.4 1 8.8-4.6 18.1-12.1 21.1 -5.2 2-5-2.9-7-5 -2.1-2.2-2-4.8 0.8-6.1C351.6 289.3 356.3 287.9 362 285.9z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M281.9 286.6c4.5 0.9 8 1.1 11.1 2.3 7.4 2.9 8.1 8.3 1.7 13.2 -0.8 0.6-2.5 0.5-3.5 0.1 -8-2.7-12.8-10.8-12.3-21.1 9.9-1.1 18.2 2.4 25.7 8.4 -0.2 0.7-0.3 1.3-0.5 2 -1.5-0.4-3.4-0.3-4.4-1.3 -4-3.9-8.8-5.3-14.1-5C284.8 285.4 283.9 285.9 281.9 286.6z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M317.5 455.1c-40.9 0.1-71-21.6-71.9-51.7 -1.1-36.2 39.7-84.3 71.3-84.1 32.3 0.3 71.9 46.7 71.5 83.7C388 433.4 358.7 455 317.5 455.1zM316.9 441c34.6 0 56.4-15.7 56.1-40.2 -0.4-28.8-33.4-69.1-56.7-69.3 -21.8-0.2-55.8 42.5-55.7 70C260.7 426.3 281.6 441 316.9 441z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M322.3 335.1c-5.9 0-9.4-2.5-9.4-6.6 0-4.6 5.7-11.7 9.3-11.7 3.9 0 9.4 6.8 9.5 11.6C331.7 332.5 328.1 335.1 322.3 335.1z' }),
	                        _react2.default.createElement('ellipse', { className: 'className=', cx: '245.8', cy: '272.8', rx: '18.3', ry: '28.8' }),
	                        _react2.default.createElement('ellipse', { className: 'className=', cx: '393.7', cy: '272.8', rx: '18.3', ry: '28.8' }),
	                        _react2.default.createElement('ellipse', { className: 'className=', cx: '293.3', cy: '397.7', rx: '8.3', ry: '22.8' }),
	                        _react2.default.createElement('ellipse', { className: 'className=', cx: '340.6', cy: '397.7', rx: '8.3', ry: '22.8' })
	                  ),
	                  'fish': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { d: 'M561.8 322.9c1.9-10.8 7.3-17.2 14.3-25.4 13.9-16.3 31.8-57.6 26.5-74.8 -39.7 2.8-87.9 30.4-130 60.4 -19.2-24.7-44.7-41.8-77.4-51.5 4.1-7.8 26.3-26.7 20.5-35.6 -71.1 3.1-126.1-43-165-65.8 -6.2 5.7-6.7 9.2-18.7 22.8 -24.7 35.3-58.1 54.4-103.5 63.2 -39.6 7.7-74.2 34.3-99.1 67.9 -17.9 24.1-16.9 50.7 0.4 76.6 25.5 38 63.6 57 104.3 73.4 23.2 6.6 19.5 6.6 30.3 3.6 27.7-20.5 65.6-59.9 72.1-87.5 1.5 0.7-11.8 55-31.6 92.5 4 10.6 78.7 12.7 85.8 3.8l23.2 47 100.6-14.2L386 417.6c31.7-10.2 62.6-27.6 92.2-52.8 0 0 12.1 12.9 21 17.7 31.1 16.8 73.4 25.3 106.1 39C617.6 403.2 569 330.2 561.8 322.9zM112.3 307.1c-10.7 0-19.5-14.3-19.5-31.9 0-17.6 8.7-31.9 19.5-31.9s19.5 14.3 19.5 31.9C131.7 292.8 123 307.1 112.3 307.1z' })
	                  ),
	                  'other-meat': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M177.1 266.6c3.2 0 6.5 0 9.7 0 0 3.2 0 6.3 0 9.5 -3.2 0-6.5 0-9.7 0C177.1 273 177.1 269.8 177.1 266.6zM178.8 270.3c-0.3 0.5-0.6 1-0.9 1.5 -0.2 0.3-0.1 0.4 0.2 0.4 0.4 0 0.8 0 1.1 0 0.2 0 0.3 0 0.3 0.2 0.1 0.4 0.3 0.7 0.4 1.1 0.2 1 0.8 1.4 1.8 1.5 1.1 0.1 1.9-0.4 2.2-1.4 0.1-0.3 0.2-0.7 0.3-1 0.1-0.3 0.2-0.4 0.5-0.4 0.3 0 0.6 0 0.9 0 0.2 0 0.3-0.1 0.2-0.3 -0.2-0.4-0.5-0.9-0.8-1.3 -0.1-0.1-0.1-0.2 0-0.4 0.4-0.5 0.4-1 0.1-1.5 -0.3-0.5-0.8-0.7-1.4-0.7 -0.2 0-0.3 0-0.5-0.1 -0.8-0.7-1.8-0.7-2.6 0 -0.1 0.1-0.3 0.1-0.4 0.1 -0.8-0.1-1.5 0.3-1.7 1.1C178.4 269.6 178.6 270 178.8 270.3z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M180.5 268.7c0.2-0.2 0.3-0.4 0.5-0.5 0.7-0.5 1.5-0.4 2.1 0.3 0.2 0.2 0.3 0.2 0.5 0.1 0.4-0.2 1 0 1.2 0.3 0.2 0.3 0.2 0.8-0.1 1.1 -0.2 0.2-0.4 0.4-0.5 0.7 -0.1 0.3-0.6 0.4-1 0.3 -0.1 0-0.3 0-0.4 0.1 -0.6 0.4-1.2 0.4-1.8 0 -0.1-0.1-0.3-0.1-0.4-0.1 -0.5 0.2-0.9-0.1-1.1-0.6 0-0.1-0.1-0.2-0.2-0.2 -0.4-0.3-0.6-0.8-0.3-1.2 0.2-0.4 0.7-0.6 1.2-0.5C180.3 268.6 180.4 268.6 180.5 268.7z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M178.4 271.8c0.2-0.4 0.5-0.8 0.7-1.1 0 0 0.1 0 0.1 0 0.1 0.4 0.1 0.8 0.2 1.2C179.1 271.8 178.8 271.8 178.4 271.8 178.4 271.8 178.4 271.8 178.4 271.8z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M185.4 271.8c-0.4 0-0.6 0-0.9 0 0-0.4 0.1-0.7 0.1-1.1 0 0 0 0 0.1 0C185 271.1 185.2 271.4 185.4 271.8z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M182 274.6c-0.1-0.1-0.1-0.1-0.2-0.2 -0.1-0.1-0.2-0.2-0.2-0.3 0-0.1 0-0.2 0-0.2 0-0.1 0.1-0.1 0.2-0.1 0.1 0 0.3 0 0.5 0 0.2 0 0.3 0.1 0.2 0.3 -0.1 0.2-0.2 0.3-0.3 0.5C182.1 274.5 182 274.5 182 274.6z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M181.3 271.9c0 0.2-0.1 0.4-0.4 0.4 -0.2 0-0.3-0.1-0.4-0.4 0-0.2 0.2-0.4 0.4-0.4C181.2 271.6 181.3 271.7 181.3 271.9z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M183.4 272c0 0.2-0.1 0.3-0.3 0.3 -0.2 0-0.4-0.1-0.4-0.4 0-0.2 0.1-0.3 0.4-0.4C183.2 271.6 183.4 271.7 183.4 272z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M611 362.4c-11.9-37.6-29.3-71.9-58.3-99.3 -8.7-8.2-10.4-15.3-1.9-26.8 27-36.2 30.5-75.9 6.3-114.4C532.5 82.7 494.8 65.6 448.6 71c-14.6 1.7-24.9 0.1-36.5-10.4C353.4 7.3 273.3 9.5 215.4 63.5c-6.9 6.4-19.6 10.6-29 9.5 -61-6.7-112.1 25.3-126.8 81.8 -8.9 34.3 3.9 63.7 20.2 87.3 -36.5 40.3-56.3 77.8-66 116.4 -5.8 23.4-6.9 28.1 18 29.4 28.7 1.6 57.4 1.9 86.1 1.1 13.4-0.4 20.6 2.8 24.6 16.4 8.3 28.2 20.6 55.4 27 84 16.2 72 63.8 103.6 133.4 111.2 80.4 8.8 140.4-29.6 163.9-106.4 8-26 17.5-51.6 24.5-77.8 5.3-19.8 14.7-28.4 36.5-26.5 22.4 1.9 45.3-0.5 67.9-2.1C612.1 386.7 616.6 380.1 611 362.4zM51 361.4c-1.9-2.1-3.8-4.3-5.8-6.4 8.9-33.7 26.5-62.5 52.9-86.3 3.5 0.4 7 0.7 10.6 1 5.5 29.7 11 59.4 16.9 91.7C99.3 361.4 75.2 361.4 51 361.4zM240.2 396.1c-16.5 0-26.4-9.8-27.2-26.8 -0.8-16.4 12.2-29.5 28-28.3 16.8 1.3 25.5 11.1 26.4 28.1C265.8 385.6 256.8 396.1 240.2 396.1zM336.3 538.5c6.5 35.6-33.8 45.4-32.5 0.9 -35.4-6-19.3-48.3 12.7-24.9 4.4 1.2 7.5-0.3 9.6-0.8C358.4 491.6 372.3 534.4 336.3 538.5zM399.4 395.7c-16.5 0.9-29.1-11.1-28.5-27.6 0.6-17 10.7-25.9 27.1-27 14.9-0.9 26.9 11.5 27.3 29.1C424.4 384.4 416.6 394.7 399.4 395.7zM489.1 274.2c-10.7 24.3-44.7 31.8-76.2 24.6 -8.7-2-21.1-0.5-28 4.6 -43.8 32.4-92.2 33.8-135.7 0.9 -11-8.3-19.5-11.1-34-6.4 -39.9 12.9-69.8-4.2-83.7-43.1 -2.3-6.5-7.6-12.8-13.2-17.1 -32.6-25.2-42.5-57.7-26.2-89.1 16.3-31.5 55.5-47.4 91.2-36.8 9.3 2.8 18.3 6.4 27 9.5 12.8-14 23.3-29.4 37.3-40.2 51.8-39.9 115.7-31.8 156.1 20.4 11.6 15 20.4 17.1 37.4 10.2 33.7-13.6 72-1.5 91.1 25.8 17.6 25.2 18.1 59.6-4.1 81.4C511.2 235.3 498.8 252.4 489.1 274.2zM515.1 361.3c2.7-28.5 5.4-56.4 8-84.3 1.8-1 3.7-2 5.5-3 24.8 24.2 43.8 50.6 52.7 87.2C553.9 361.3 534.3 361.3 515.1 361.3z' })
	                  ),
	                  'poltry': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M335 360c-28 0-56 0-83.9 0 0-32 0-64 0-95.9 28 0 56 0 83.9 0C335 296 335 328 335 360zM255.3 322.7c8.3 1.6 14.4 4.2 18.8 10 0.9 1.2 2.7 1.9 4.3 2.5 7.1 2.6 12.9 6.8 16.3 13.8 0.4 0.9 2 1.2 3 1.8 0-1.3 0.4-2.7 0-3.8 -2.6-6.5-7.5-10.5-13.8-13.6 -4.5-2.3-9.4-5.6-12-9.7 -6.5-10.1 4.4-25.4 12.7-28.1 12.3-4 22.8-0.1 29.6 11.9 3.8 6.7 6.1 14.3 9.3 21.4 0.5 1.1 1.9 1.8 2.9 2.6 0.3-1.1 1.2-2.3 0.9-3.2 -3.3-10.3-6.9-20.4-14.2-28.9 -11-12.7-32.4-13.3-41.6 2.8 -3.2 5.7-7.1 9.8-13.8 10.5 -0.2 0-0.3 0.5-0.5 1 2.2 1.3 4.4 2.5 7.4 4.2C261.3 319.5 259.1 320.7 255.3 322.7zM307.5 292.6c2.9-3 3.6-6.6 1.3-9.5 -1.8-2.3-5.2-3.4-8-4.9 -1.8-1-4.2-1.2-5.6-2.5 -4.1-4-10.6-3.8-13.8 1.1 -1.4 2.1-2.6 2.7-5 2.8 -7.2 0.4-10.9 8-7 13.8 1.8 2.6 3.5 3.3 6.6 1.2 3.5-2.4 7.4-4.5 11.4-5.7C294.5 286.8 301.2 289.1 307.5 292.6zM271.8 334.6c-2.4 4.2-3.4 8.3-1.1 12.5 0.7 1.3 2.7 2.8 4.1 2.7 1.4-0.1 3.2-1.6 3.9-3C281.3 341.6 279 337.6 271.8 334.6zM285.6 310.9c3.1-4 3.1-7.2-0.1-10.2C282.1 304.1 282.1 306.7 285.6 310.9z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M154 485.1c54.2 22.4 71.2 52.4 51.2 91.2 -5.3 10.4-18.9 22.3-29.2 22.7 -10.2 0.4-25-10.6-30.5-20.6C128.4 547.4 136.4 516.7 154 485.1z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M244.7 290.5c-9.7-16.7-9.4-30.1 0.3-44.7 5.7-8.6 18.5-8.2 23.7 0.8 7.7 13.3 8 27.3 0.6 42.8C264.4 299.5 250.2 300.1 244.7 290.5z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M30.4 396.5c28.3-14.8 45.2-23.7 68.6-35.9 -22.5-12.9-52.1-29.6-68.6-39.1 1.8-3.8 15.5-0.2 16.6-0.4 50.6-5 79.3-35.9 103.5-78.3 68.8-120.4 228.9-115.7 310.9-20.6 54.4 63.1 81.4 138.8 106.1 215.9 0.4 1.2 0.5 2.5 0.4 3.8 -0.8 10.9-13.9 16.2-22.3 9.2 -3-2.5-5.5-5.2-7-8.4 -23.8-53.2-41.4-109.7-69.8-160.2 -50.6-90-129.4-118.9-221-89.1 -61.7 20.1-143.4 134.8-94.7 210.3 20 31 56 55.6 90 72.5 47.1 23.5 83.6 53.5 103.4 102 1 2.4 1.4 5 1.5 7.7 0.5 11.6-13.5 18.3-21.6 9.9 -0.8-0.8-1.4-1.6-1.9-2.6 -25.9-52.4-68.8-83.6-122.2-103.3 -11.5-4.3-25.1-9.5-31.9-18.7C138.2 428 92.3 408.9 30.4 396.5z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M307.5 139.2c49.7 0 93.5 16 119.6 40.3 8.8-11.7 14.1-26.2 14.1-42 0-38.6-31.3-69.9-69.9-69.9 -8.4 0-16.4 1.6-23.9 4.3 -9.2-27.9-35.4-48-66.4-48 -32.2 0-59.2 21.8-67.4 51.4 -2.5-0.3-5.1-0.4-7.7-0.4 -38.6 0-69.9 31.3-69.9 69.9 0 25.1 13.3 47.1 33.2 59.4C187.6 166.5 242.6 139.2 307.5 139.2z' })
	                  ),
	                  'vegetables': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M255.9 413.1c0-67.5 0-134.9 0-202.5 50.3 0 100.6 0 151 0 0 67.4 0 135 0 202.5C356.6 413.1 306.3 413.1 255.9 413.1zM346.3 288.6l0.1 0.1c0.6-2.1 0.8-3.6-1.3-5.5 -7.2-6.4-7.6-12.6-2-20.2 0.8-1 1.3-2.4 1.5-3.7 1-6.9 4.6-11.5 11.1-14.3 1.3-0.6 2.7-3 2.7-4.5 -0.3-5.6-3.4-9.7-8.6-11.7 -5.4-2.1-10.5-1.1-14.6 3.1 -1.6 1.7-2.8 3.8-3.8 5.2 -4 0.5-7.6 0.9-12.1 1.5 5.2 6.7 6.4 12.9 3.5 19.7 -0.2 0.6-0.3 1.4-0.1 2 2.2 5.6 0.6 10.3-2.7 13.8 1 2 1.8 3.3 2.3 4.7 0.7 2.1 1.5 4.2 1.8 6.4 0.5 2.9 0.7 5.8 0.7 8.7 0 0.7-1.5 1.9-2.3 1.9 -1.1 0-2.9-0.6-3.3-1.5 -2.7-6-5-12.2-7.5-18.3 6.4-3.3 9.3-6 8.8-10.2 -0.6-4.8 0.2-9.2 0.8-13.9 1.1-7.9-4.3-13.1-14.5-15.2 -3.4-10-8.3-13.9-16.2-13 -8 0.9-11.1 5.8-12.1 19.1 -6.1 1.9-10.6 5.6-11.2 12.4 -0.8 8.2 4.8 12.2 11.3 15.2 -0.9 7.1 0.6 13.1 6.9 16.6 6.5 3.7 12.5 1.1 18.3-3.5 3 4.7 5.7 9 8.6 13.5 -1.4 0.8-2.1 1.2-2.8 1.6 -16.1 7.2-28.8 30.5-25.1 49.4 3.3 17 12.6 30.9 22.1 44.7 1.8 2.6 4.3 2.2 6.6 0 6.9-6.6 14-13.1 20.9-19.8 7.5-7.3 13.2-15.7 15.4-26.2 3.1-14.9 1.4-28.9-8.2-42 3.8-2.8 7.3-5.3 10.7-7.8 10.5 10.3 21.9 7.2 27-5.8 6.4 0.8 12.1-0.7 15.5-6.6 4.1-7.1 1.2-13.1-3.9-18.3 0.4-0.7 0.7-1.2 0.9-1.6 4.8-7.3 4-14.9-1.9-19.8 -5.7-4.7-13-3.8-19.4 2 -1.1 1-3.6 1.2-5.2 0.8 -9-2-16.6 3.3-17.6 12.5 -0.2 1.5-0.8 3.3-1.8 4.4 -4.7 5.3-4.3 12 1.2 16.7 1.5 1.3 3.1 2.4 5.3 4C349.7 286.5 348 287.6 346.3 288.6z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M310.3 384.7c-7.9-12.6-15.9-23.8-18.2-37.8 -2.4-14.8 5.3-32.1 18.2-39.8 12.2-7.3 25.6-2 30.5 12.7 4.9 14.8 3.2 29.1-6.8 41.2C327.1 369.4 318.6 376.5 310.3 384.7z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M357.7 269.6c1.9 2.5 3.1 3.9 5.3 6.7 1.8-5.8 3.2-10.5 4.9-15.9 0.6 2.2 1 3.7 1.5 5.3 3.8-2.2 7.5-4.3 11.2-6.4 0.3 0.4 0.6 0.7 0.8 1.1 -1.9 2-3.7 4.1-5.8 6.4 2 1.6 3.9 3.2 6.1 5 -4.2 1.3-9.5-4-12.3 2.8 1.7 1.5 3.4 3 5.2 4.5 -6.6-1.7-11.2 0.4-14.3 6.7C359.4 280.8 358.7 276 357.7 269.6z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M290.7 240.8c0.9 2.5 1.9 5 2.9 7.8 2.2-1.7 4-3.1 6.3-4.8 0.1 5.1-6.8 8.3-2.9 14 2-1.4 3.8-2.7 5.7-4 -4.9 6.2-3.6 12.1 0.7 17.1 -3.8 0-7.5 0-11.2 0 0.8-1.1 2-2.8 3.3-4.5 -0.9-5.2-5.7-5-10.4-6.3 2.5-1.3 4.1-2.1 5.4-2.8 -0.5-5.6-0.9-10.9-1.4-16.3C289.6 241 290.1 240.9 290.7 240.8z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M330.8 255.4c6.3-0.2 2.4-7 6.1-9.1 0.3 1.7 0.6 3.3 0.9 5.1 1.6 0 3.2 0 4.9 0 -2.2 2.4-4.1 4.6-6.9 7.7 2.8 0.4 4.1 0.5 4.6 0.6 -2.1 3.5-4.3 7.1-6.3 10.5 -0.9-1.4-2.4-3.6-3.7-5.6 0.8-1 2.9-2.4 2.8-3.7C333.3 259 331.7 257.2 330.8 255.4z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M346.3 288.6c-3.4 3.7-6.9 7.4-10.7 11.5 -1.9-0.9-3.8-1.9-5.6-2.7 -0.1-4.4 1.7-5.7 5.9-5.7 3.5 0 6.9-1.9 10.4-3C346.4 288.7 346.3 288.6 346.3 288.6z' }),
	                        _react2.default.createElement('path', { d: 'M369.8 242c2-6.7 2.2-11.7-4.7-17.8 -24.4-21.5-25.8-42.6-6.7-68.4 2.6-3.5 4.4-8.1 5-12.3 3.4-23.3 15.6-38.9 37.4-48.3 4.5-1.9 9.3-10.1 9-15.2 -1-18.9-11.5-32.6-29.1-39.5 -18.3-7.3-35.5-3.7-49.5 10.5 -5.5 5.6-9.4 12.9-12.9 17.7 -13.3-2.1-25.5 0.2-40.8 4.9 19.5 19.5 21.5 43.5 11.9 66.5 -0.8 1.9-0.9 4.7-0.2 6.6 7.4 18.8 2 34.8-9.1 46.7 3.3 6.6 6 11.2 7.8 16 2.5 7 5 14.2 6.2 21.5 1.5 9.7 2.3 19.6 2.2 29.4 0 2.4-5 6.5-7.7 6.5 -3.8 0-9.7-2.1-11-5 -9-20.4-17-41.2-25.4-61.8 21.5-11.3 31.4-20.4 29.7-34.5 -5.8-17.6-4.6-30.2 2.8-46.8 3.7-26.6-14.6-44.3-49.1-51.2 -11.7-34-28-47-54.8-43.9 -26.9 3.1-37.5 19.7-40.7 64.4 -20.7 6.3-35.7 19.1-37.9 41.9 -2.7 27.8 16.2 41.2 38.3 51.4 -3.2 23.9 2.1 44.2 23.4 56.1 22.1 12.3 42.1 3.7 61.7-11.9 10.1 16 19.3 30.4 28.9 45.6 -4.7 2.6-7 4.1-9.6 5.3 -54.4 24.4-97.2 102.9-84.8 166.8 11.2 57.5 42.7 104.3 74.8 151 6 8.8 14.6 7.3 22.3-0.2 23.4-22.4 47.3-44.3 70.5-66.9 25.4-24.7 44.5-53.1 52-88.5 10.6-50.4 4.7-97.7-27.6-141.9 12.8-9.3 24.6-17.9 36.2-26.4 35.6 34.9 73.9 24.5 91.2-19.6 21.8 2.8 40.9-2.3 52.3-22.3 13.7-23.9 3.9-44.4-13.3-62 1.4-2.5 2.2-4 3.2-5.4 16.1-24.7 13.7-50.4-6.5-66.9 -19.4-15.9-43.8-12.8-65.7 6.9 -3.7 3.4-12 3.9-17.6 2.7 -30.5-6.6-56.1 11.3-59.6 42.1 -0.6 5.1-2.7 11-6.1 14.8 -15.8 17.7-14.6 40.7 4.1 56.3 5.1 4.3 10.5 8 18 13.7C380.8 235.3 375.3 238.7 369.8 242M186.3 182.8c2.7-3.7 6.9-9.4 11-15.1 -3.1-17.7-19.1-16.7-35.2-21.2 8.5-4.5 13.8-7.2 18.2-9.5 -1.6-18.8-3.1-36.9-4.6-55 1.8-0.4 3.6-0.7 5.4-1.1 3.1 8.4 6.3 16.8 10 26.5 7.3-5.6 13.5-10.4 21.2-16.3 0.2 17.4-23.1 27.9-9.7 47.3 6.6-4.6 12.9-9 19.3-13.4 -16.4 20.9-12.2 40.7 2.2 57.8C211.3 182.8 198.8 182.8 186.3 182.8zM308.7 126.6l15.2 6.2 6.8-36.6 2.8 26.5 24.2-6.2 -27.6 22v9l21.4-0.6 -21.4 15.8 -6.2 28.2 -5.1-16.9 -16.3-14.6 16.3 2.3 1.7-15.2L308.7 126.6zM327.5 487c-23.4 28.3-51.9 52.3-80.1 80.1 -26.7-42.6-53.7-80.3-61.5-127.6 -8.2-50.1 17.9-108.5 61.4-134.5 41.3-24.7 86.5-6.7 103 42.7C367.2 397.7 361.4 446.1 327.5 487zM368.6 243c-11.4 12.3-22.9 24.6-35.4 38.1 -6.4-3.2-12.8-6.3-18.8-9.3 -0.2-15 5.7-19.2 20-19.1C345.8 252.8 357.2 246.7 368.6 243M446.7 194.8c5.7 5 11.6 10.1 17.5 15.2 -22.2-5.7-38 1.3-48.2 22.6 -2.6-16.4-5.1-32.9-8.5-54.4 6.5 8.3 10.3 13.1 17.8 22.6 6-19.5 10.9-35.4 16.5-53.7 2 7.3 3.4 12.5 4.9 17.8 12.8-7.3 25.4-14.5 38-21.7 0.9 1.2 1.9 2.5 2.8 3.7 -6.3 6.8-12.5 13.7-19.7 21.5 6.7 5.5 13.2 10.8 20.5 16.8C474 189.7 456.2 171.6 446.7 194.8z' })
	                  ),
	                  'pasta': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M94.1 283.2c0-9.1 0-18.2 0-27.4 12.7 0 25.4 0 38.2 0 0 9.1 0 18.2 0 27.4C119.5 283.2 106.8 283.2 94.1 283.2zM99 269.2c-0.4 0.4-0.8 0.7-1.1 0.9 -1.1 1-1.3 1.6-0.2 2.6 1.2 1 1.3 2 0.5 3.3 -0.1 0.2-0.2 0.4-0.2 0.6 -0.4 1.4-0.2 1.7 1.2 1.8 4.3 0.2 7.9-1.3 11.2-4.1 2.3-1.9 2.8-2.1 5.2-0.1 0.1 0.1 0.2 0.2 0.3 0.2 3.2 2.7 6.8 4.1 11 3.9 1.5-0.1 1.7-0.4 1.2-1.8 -0.2-0.6-0.4-1.1-0.6-1.7 -0.4-0.8-0.3-1.3 0.5-1.8 1.2-0.7 1.3-1.5 0.5-2.7 -0.2-0.3-0.4-0.5-0.6-0.7 -0.7-0.7-0.8-1.2 0.2-1.8 1.1-0.7 1.4-1.7 0.6-2.4 -1.7-1.3-1.4-2.6-0.6-4.1 0.1-0.2 0.1-0.4 0.2-0.6 0.1-0.7-0.1-1.1-0.9-1.2 -4.1-0.3-7.7 0.8-10.9 3.4 -3.2 2.6-3.6 2.8-6.6 0.2 -2.6-2.2-5.5-3.5-8.9-3.7 -3.6-0.2-3.8 0-2.5 3.3 0.3 0.9 0.3 1.4-0.6 2 -1.3 0.8-1.3 1.5-0.4 2.7C98.1 268 98.5 268.5 99 269.2z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M66.4 313.2c-9.1-11.4-16.7-20.6-24-30.1 -16.3-21.1-15.7-33.2 6.8-47.5 15.6-10 16.1-19.4 10-35 -23.4-59.3-20.5-63 44-59.4 60.4 3.4 113.1 26.5 158.5 65.5 52.7 45.2 60.1 42.6 116.6-4.1 56.1-46.4 120.8-66.7 193.7-60.9 14.5 1.2 18.1 8.8 15.7 21.4 -0.7 3.5-1.4 7.1-3.1 10.2 -15.1 27.1-19.5 50.7 10 73.6 14.8 11.5 9.5 29.4-10.2 42 -17.2 10.9-16.3 20.3-3 32.8 4.1 3.8 7.6 8.5 10.9 13.1 14.8 20.9 13.2 34.4-8.7 47.6 -14.3 8.6-16.2 17.5-9.6 31.4 4.6 9.6 8 19.8 11.1 29.9 7.7 25.1 3.8 30.7-22 32.1 -74.9 4.2-139.2-21.6-195.9-69 -1.6-1.4-3.1-2.9-4.7-4.3 -42.6-37.1-52.3-33.1-92.6 1 -57.9 49-122.3 76-198.7 72.2 -25.4-1.3-29.9-7.9-22-32 1.1-3.4 1.9-7 3.8-9.9 14.5-22.3 12.3-40.1-9-58.5 -19.4-16.8-17-27.9 3.1-45.4C52.8 324.8 58.7 319.8 66.4 313.2zM580 359.6c-12.8-19.9-30.3-35.4-31.2-51.8 -0.9-15 16.2-31 27.2-49.7 -36.9-21.9-35.6-55.3-9.9-94.6 -12.9 0-19.7-0.1-26.6 0 -66.2 0.6-119.9 30.7-168.6 72 -41.5 35.2-66.3 34.9-108.9 1.1 -23.8-18.8-48.8-36.9-75.5-50.9 -35.3-18.5-73.9-26.5-115.6-20.3 5.7 19.1 16 36.5 14.2 52.5 -1.8 15.7-16.1 29.9-26.2 46.8 7 11.9 18.6 27.2 25.6 44.4 10.2 25-22.6 27.2-28.2 49.6 37.8 22.5 36.3 55.5 13.6 90.6 5.1 2 6.9 3.4 8.8 3.5 65.9 3.6 123.7-18.2 171.1-62.3 46.4-43.1 79.3-46 127.8-5.1 17.3 14.5 35.8 28.1 55.5 39 39.7 22 82.2 33.5 130.3 27C554.4 417.3 522.5 380.2 580 359.6z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M127.9 271.8c-3.2 1.2-1.4 3.2-0.9 5.2 -2.7 0.4-5.1-0.3-7.3-1.5 -1.1-0.6-2.2-1.4-3.1-2.2 -2.7-2.3-4.6-2.1-7.2 0.3 -2.7 2.5-5.9 3.7-9.6 3.5 -0.1 0-0.2-0.1-0.5-0.2 1.3-2 1.4-3.8-0.8-5.1 0.3-1.3 2.2-1.4 1.6-2.8 -0.4-1-1-1.8-1.4-2.5 0.6-1 1.4-1.8 1.5-2.6 0.1-0.9-0.5-1.9-0.8-3 2.3-0.3 4.5 0.1 6.5 1.1 1.5 0.8 2.9 1.8 4.3 2.9 2.4 1.9 3.8 1.9 6.1-0.1 2.7-2.3 5.8-4 9.5-4.1 0.4 0 0.8 0 1.5 0 -1.4 2.2-1.5 4.1 0.6 5.3 -0.6 1.1-1.6 2-1.5 2.8C126.2 269.8 127.2 270.7 127.9 271.8zM104.3 265.8c8.3 4 11.8 2.9 17.7-0.1C116.1 267.5 110.2 267.5 104.3 265.8zM122 272c-5.9-3.5-11.8-3.5-17.8 0C110.1 270.3 116.1 270.3 122 272z' }),
	                        _react2.default.createElement('path', { className: 'className=', d: 'M159.7 253.9c105 29 210 28.9 315-1.5C369.9 304.9 306.5 325 159.7 253.9z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M474.3 363.8c-105-30-210.2-31.4-315.5 0C263.7 302 368.8 300.8 474.3 363.8z' })
	                  ),
	                  'pizza': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M448 470c-111.6 0-223.2 0-334.9 0 0-108.5 0-217.1 0-325.8 111.6 0 223.2 0 334.9 0C448 252.7 448 361.3 448 470zM391.2 262.8c-37.5 16.5-74.7 32.9-113.3 50 15.4-39.7 30.1-77.9 44.9-116 -49.2-21.1-114.3-3.2-146.1 43.4C138 296.9 149.4 362.5 194 403.7c45.9 42.4 112.1 46 164.3 3.4C403.3 370.5 412.6 306.7 391.2 262.8zM126.2 313c1.3 9.4 2 19.2 4 28.7C149.5 432.5 235 475 305.4 460.8c38-7.7 69.9-26 93.5-57.4 16.6-22.1 26.3-47.1 30.2-74.4 3.3-23.8 0.3-46.7-9.4-68.6 -1.8-4-6-6.1-9.2-4.7 -3.6 1.6-4.9 5.3-3 9.6 9.5 21.6 12.2 44.1 7.8 67.3 -9.4 49.9-36.2 86.2-83.4 106.6 -35.1 15.1-70.2 14.7-105.6 0.7 -61.7-24.3-94-91.3-84.4-146.8 7.1-41.1 26.1-74.9 62.3-97.2 37.3-23 77-29.7 119.2-14.6 1.7 0.6 4.5 0.1 5.9-1 1.4-1.1 3-4.2 2.4-5.4 -1.3-2.6-3.5-5.4-6-6.4 -12.9-5.1-26.5-7.7-40.3-8.1 -25.2-0.8-49.2 4.5-71.8 15.7C156.8 203.8 130.9 251.2 126.2 313zM299.6 289.5c38.2-16.8 75.1-33 112.2-49.3 -14.3-30.9-36.3-52.7-67.9-65.1C329.3 213 314.7 250.5 299.6 289.5zM428.7 237.8c8 0.1 10.3-4.1 7.4-10.4 -16.8-36.3-43.6-62.3-81-77.1 -5.2-2.1-8.6-1-9.9 3 -1.4 4 0.5 6.9 5.1 9.2 9.1 4.5 18.4 8.6 26.8 14.1 21.3 13.9 36.6 33.1 47.2 56.2C425.5 235 427.8 236.8 428.7 237.8z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M517.8 229.5c40.6 83 22.8 203.5-62.1 272.7 -98.8 80.5-223.7 73.6-310.5-6.5 -84.3-77.8-105.9-201.9-32.6-309.1 60-87.9 183-121.7 276-81.9 -27.9 72-55.8 144.1-84.8 219.1C376.7 291.7 447 260.7 517.8 229.5zM230.6 178.5c0.6-17.9-13.9-33.1-31.9-33.7 -19.3-0.7-34.3 13-34.8 31.6 -0.5 18.6 14 34.2 32.2 34.6C214.2 211.5 230 196.6 230.6 178.5zM413.1 412.8c-17.2-2.5-33.1 13.9-33.5 31.9 -0.4 18.2 15.1 33.7 33.4 33.8 19 0.1 32.3-14.2 33.3-33.5C447.1 428.7 430.1 410.3 413.1 412.8zM127.9 276.8c-20.8-2.6-33.8 18.2-33.6 32.7 0.2 18 15.2 32.7 33.2 32.9 18.5 0.2 33.3-14.7 33.3-33.4C160.7 290.1 147.1 276.8 127.9 276.8zM213.6 463.1c0-19.3-13.3-33.1-31.9-33.3 -19.6-0.1-33.7 13.6-33.7 32.7 0 18.6 14.9 33.8 33.1 33.8C198.8 496.3 213.6 481.1 213.6 463.1zM331.3 373.1c-20.2 0-33.3 12.7-33.3 32.3 0 19.2 13.9 33.2 33.1 33.3 18.1 0.1 32.1-14.4 32.6-33C364.1 388 347.5 370.5 331.3 373.1zM306.2 246.8c0.1-19.4-13.7-33.2-33.1-33.1 -18.7 0-32.9 13.7-33.4 32.2 -0.5 18 14.9 33.4 33.5 33.4C291.5 279.3 306.1 265 306.2 246.8zM422.7 366.2c18.7 0.1 33.2-14.5 33.4-33.4 0.2-18.9-14.2-33.2-33.3-33.1 -18 0.1-32.1 14.1-32.2 32.2C390.4 350.9 404.7 366.2 422.7 366.2zM221.4 328.9c-13.6 0-23.5 9.6-23.6 22.8 -0.1 13.3 10.5 24 23.8 23.9 13.1-0.1 24-11.1 23.8-24.1C245.2 338.7 234.8 328.9 221.4 328.9zM501 304.4c-14.4 0-23.6 9.1-23.6 23.4 0 13.3 9.7 23.2 22.9 23.3 13.5 0.2 23.8-10 23.7-23.7C524 313.7 514.7 304.4 501 304.4zM318.2 118.1c-15-0.1-24 8.3-24 22.4 0 13.7 9.7 23.6 23.4 23.6 13.1 0 23-9.7 23.2-23C341 127.5 331.8 118.1 318.2 118.1zM362.7 526.8c13.3 0.1 24.2-10.3 24.3-23.3 0.1-12.2-10.2-22.6-22.4-22.7 -15.2-0.1-25.2 8.9-25.2 22.7C339.6 516.2 350 526.7 362.7 526.8z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M18.7 323.7C21.5 201 74.9 118 181.9 65.3c42.7-21 88-31.1 135.7-29.6 26.2 0.8 51.8 5.8 76.2 15.3 4.8 1.9 9 7.3 11.4 12.2 1.1 2.2-1.8 8.1-4.6 10.2 -2.7 2.1-8 3-11.2 1.9C309.6 46.8 234.6 59.5 164.1 103 95.9 145.1 60 208.8 46.5 286.6 28.3 391.4 89.5 518 206 563.9c66.9 26.3 133.1 27.2 199.5-1.4 89.3-38.5 139.9-107.1 157.7-201.4 8.3-43.8 3.2-86.2-14.7-127.1 -3.5-8.1-1.2-15.2 5.7-18.2 6-2.6 14 1.4 17.3 8.9 18.4 41.5 24.1 84.7 17.8 129.7 -7.2 51.7-25.6 98.9-57 140.6 -44.5 59.2-104.9 94-176.6 108.4 -133.1 26.8-294.5-53.4-331.1-225C20.8 360.5 18.7 341.2 18.7 323.7z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M344.8 279.9c28.5-73.6 56-144.5 83.8-216.1 59.7 23.4 101.2 64.6 128.3 123C486.7 217.5 416.9 248.2 344.8 279.9zM458.5 158.4c0 18.5 14.1 33.5 32 33.7 18.3 0.3 33.4-14.8 33.6-33.4 0.2-19.1-13.9-33.1-33.3-33.1C471.7 125.7 458.6 138.9 458.5 158.4zM410.3 188c-14.6-0.1-24 8.7-24.2 22.7 -0.2 13.5 9.3 23.2 22.7 23.4 14.4 0.2 23.9-9 24-22.8C432.8 197.1 424 188 410.3 188z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M588.7 182.2c-1.7-1.9-6.1-5.2-8.1-9.6 -20.1-43.6-48.9-79.9-89.2-106.1 -15.9-10.4-33.6-18.2-50.7-26.6 -8.8-4.3-12.4-9.8-9.7-17.4 2.6-7.4 8.9-9.5 18.8-5.6 70.6 27.9 121.2 77 153 145.6C608.2 174.4 603.7 182.4 588.7 182.2z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M239.2 235.8c-0.3 9.5-8.7 17.4-18.3 17.2 -9.7-0.2-17.3-8.5-17-18.3 0.3-9.8 8.2-17.1 18.4-16.7C231.8 218.3 239.5 226.4 239.2 235.8z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M335.8 359.8c9-1.3 18 8.4 17.5 17 -0.5 10.2-7.5 17.8-17.6 17.7 -9.7 0-17.9-8.2-17.7-17.9C318.2 367.2 326.7 358.5 335.8 359.8z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M184.8 287.8c10.1 0 17.3 7.1 17.4 17.1 0 9.9-7.8 17.8-17.6 17.7 -9.5-0.1-17.5-7.9-17.5-17.4C166.9 297.4 173.8 286.5 184.8 287.8z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M230.2 386.4c0 9.6-7.9 17.6-17.2 17.6 -9.6 0-17.5-8.1-17.5-17.9 0-10.1 7.5-17.4 17.8-17.3C223.1 368.9 230.2 376.2 230.2 386.4z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M292.4 338.8c8.6-1.4 17.4 7.9 17.1 17.3 -0.3 9.8-7.7 17.5-17.2 17.4 -10.2-0.1-17.5-7.5-17.5-17.6C274.8 345.6 281.8 338.8 292.4 338.8z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M279.2 272c0 9.6-7.7 17.2-17.5 17.2 -9.8 0-18-8.2-17.7-17.7 0.3-9.8 7.8-17 17.7-17C271.9 254.4 279.2 261.7 279.2 272z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M340.9 335.2c-9.5 0-17.1-8.1-17-18.2 0.1-9.5 7.5-17 17.1-17 10.1 0 17.7 7.5 17.6 17.5C358.4 327.5 350.7 335.2 340.9 335.2z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M234.3 315.4c7.1 0 12.6 5.2 12.7 12 0.1 6.9-5.6 12.7-12.6 12.8 -7 0-12.6-5.6-12.6-12.7C221.9 320.5 227.1 315.5 234.3 315.4z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M382.3 302.4c7.2 0 12.2 5 12.2 12.2 0 7.2-5.4 12.6-12.5 12.5 -7-0.1-12.1-5.3-12.1-12.4C369.8 307.3 374.7 302.4 382.3 302.4z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M285.5 203.8c7.2 0 12.1 5 12 12.2 -0.1 7-5.3 12.2-12.3 12.2 -7.2 0-12.4-5.2-12.4-12.5C272.8 208.2 277.6 203.8 285.5 203.8z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M309.1 420.2c-6.7-0.1-12.3-5.6-12.3-12.3 0-7.3 5.3-12.1 13.3-12 6.5 0.1 11.9 5.6 11.9 12C321.9 414.7 316.2 420.2 309.1 420.2z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M359.8 225.2c0-10.3 6.9-17.3 17.1-17.3 10.3 0 17.8 7.4 17.6 17.5 -0.1 9.9-8.1 17.8-17.8 17.7C367.3 242.9 359.8 235 359.8 225.2z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M334.3 240.8c7.3 0 11.9 4.8 11.9 12.3 0 7.3-5.1 12.2-12.7 12.1 -7.1-0.1-12.1-5.2-12-12.4C321.6 245.4 326.6 240.8 334.3 240.8z' })
	                  ),
	                  'seafood': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M334 402c-38 0-76 0-113.9 0 0-42.7 0-85.3 0-127.9 38 0 76 0 113.9 0C334 316.7 334 359.4 334 402zM230.6 322c3.4 0.4 6.6 0.8 10.1 1.2 -0.8 0.9-1.4 1.6-2.3 2.7 8.7 2.2 16.9 4.3 24.9 6.3 -0.2 7.5-10.2 13-3.9 22.2 -1.1-8.7 6.7-22.1 11.8-20.6 -3.1 7-9.5 13.9-1 21.8 -1.8-4.6-4.7-8.8-0.6-13.2 2.9-3.1 3-8.8 9.8-9.7 -1.8 3.7-3.7 6.4-4.2 9.3 -0.5 2.8 0.4 5.9 0.7 8.8 0.4-0.1 0.9-0.1 1.3-0.2 -1.5-7.3 2.7-16.2 9.4-19.6 4.3-2.2 5.8-5.7 5.4-10.2 -0.4-4.6-3-7.6-7.3-8.3 -4.9-0.8-10-1.5-14.8-0.8 -10 1.5-19.8 3.9-29.7 6 -0.8 0.2-1.6 0.7-2.4 0.7 -0.4 0-1.2-1-1.4-0.8C234.6 318.9 232.7 320.4 230.6 322zM287.3 333.6c5.8 4.5 10.1 9.9 8.5 16.8 -1.3 6.1-4.8 11.7-7.1 17 1.1 1.6 2.5 3.6 4.1 5.8 2.8-3.3 8.5-3.3 6.9-9.1 4.1 0.2 6.9-2.7 8.8-9.5 -1.4-0.5-2.9-1-4.9-1.7 7.6-1.8 8.6-3.3 7.5-11.4 -1.4 0-2.8 0-4.7 0 5.3-4.3 5.4-7 0.6-12.3 -1.9 1.4-3.8 2.8-5.7 4.1 5-8.3 2.7-13.1-7.8-16.4C295.1 325.8 293.9 328.7 287.3 333.6zM285.8 388.5c6.1-12 6-16.1 0.6-19.7 -2.6-1.7-12.9 0.1-15.7 3.1 2 0.2 3.6 0.4 5.6 0.6 -1 1.3-1.7 2.3-3.1 4.2 2.7-0.8 4.2-1.2 5.7-1.7 1 3.7 1.8 7 2.8 10.7 1.1-0.7 2.1-1.4 3.4-2.2C285.4 385.1 285.5 386.2 285.8 388.5z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M262.6 318.7c-2.1 1.7-3.6 3.6-4.6 3.4 -1.5-0.2-2.7-2.1-4.1-3.2 1.3-1.3 2.4-3.3 3.9-3.6C258.8 315.1 260.3 317 262.6 318.7z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M404.3 290c38.2-27.9 44.5-44.5 37.2-94.5 60.1 18.9 73 46.6 44.4 94 10.9-7.9 21.7-15.8 32.6-23.6 27.2 30 26.9 45.6-3.6 70.1 10.5 0 18.7 0 26.7 0 5.8 46.1 0.4 54.8-43.1 65.2 11.4 4 19.6 6.9 27.8 9.8 -11.1 38.4-27 55.3-50.5 54.1 8.7 32.9-23.4 33.2-39.7 51.9 -9-13-17.1-24.5-23.3-33.4 13.2-30.5 32.9-62.6 40.5-97.3C461.9 346.5 437.3 315.6 404.3 290z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M400.8 275.7c5.4-2.8 16.1-8.4 23.7-20.4 9.8-15.5 8-32.1 7.5-38.2 -1.2-14.7-6.4-26.5-15.1-34.8 -9.2-8.8-19.9-11.3-26.9-12.7 -50.4-10.2-84.9-4.6-84.9-4.6 -48.9 0.5-124 26.1-225 58.9 19.2 2.3 38.5 4.5 57.7 6.8 -9.3 2.7-12.3 3.1-26 6.7 51.8 15 103.7 30 155.5 44.9C275.3 283.5 360.4 296.8 400.8 275.7zM249.2 219.4c-10 0-18.1-8.1-18.1-18.1s8.1-18.1 18.1-18.1c10 0 18.1 8.1 18.1 18.1S259.2 219.4 249.2 219.4z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M147.2 219.2c-0.3-4.6-0.6-9.3-0.6-14 0-104.9 85-189.9 189.9-189.9 40.5 0 78 12.7 108.8 34.3 -31.7-23.8-71.1-37.9-113.8-37.9 -104.9 0-189.9 85-189.9 189.9 0 5.9 0.4 11.8 0.9 17.6H147.2z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M168.7 207.9c0.5-4.6 1.2-9.2 2.1-13.8C190.6 91.1 290.1 23.6 393 43.4c39.8 7.6 74.2 27.2 100.4 54.2C466.8 68.3 430.7 47 388.8 39c-103-19.8-202.5 47.7-222.3 150.6 -1.1 5.8-1.9 11.6-2.4 17.4L168.7 207.9z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M399.1 492c-48.6 0.1-88 4.2-91.9 23.2h44.6l-27.5 18 10.7 11.3 26.6-24.2 6.1 6.7 -26.5 24 7.1 7.5 26.3-23.9 6.1 6.7L354.6 565l7.5 7.9 25.9-23.7 6.1 6.7 -25.8 23.5 11.6 12.2 19.2-24.4v44.6c15.3-4.9 24.2-37.9 29.9-85.8L399.1 492z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M273.9 275.3c-21.2 24.1-37.3 59.3-45.8 91.1 -6.1 37.6 34.3 74.1 68.7 103 -28.4-34.3-54-67.6-53-94.3 11.4-38 37.7-78.5 58.2-99.9L273.9 275.3z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M317.9 282.9c-18.1 20.7-32 50.8-39.3 78.1 -5.2 32.2 29.4 63.6 58.9 88.3 -24.4-29.4-46.3-57.9-45.4-80.8 9.8-32.6 32.3-67.3 49.9-85.6H317.9z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M364.5 278.7c-16.8 19.2-29.6 47.1-36.4 72.4 -4.8 29.9 27.2 58.9 54.6 81.9 -22.6-27.3-42.9-53.7-42.1-74.9 9.1-30.2 29.9-62.3 46.3-79.4H364.5z' })
	                  ),
	                  // 'mineral': (
	                  //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className={'svg' + ' ' + this.props.icon}>
	                  //     <path d="M13.22,66.38c-1.68-7.56-3.36-14.89-4.87-22.25A5.25,5.25,0,0,1,9,40.64Q18.07,26,27.39,11.42A3.54,3.54,0,0,1,29.57,10c11.5-1.63,23-3.28,34.52-4.61,2.11-.24,4.43.73,6.57,1.39Q81,9.91,91.27,13.31a2.77,2.77,0,0,1,1.48,1.78c2.46,11.1,4.9,22.2,7.16,33.34.3,1.5-.24,3.26-.67,4.82C95.72,66.18,92.11,79.09,88.58,92a2.14,2.14,0,0,1-2.45,1.87c-26.33,0-52.67.07-79-.21-2.32,0-4.65-2.48-6.89-3.94C0,89.55,0,88.54.17,88,1.48,82.88,2.79,77.8,4.24,72.75A4.37,4.37,0,0,1,6,70.54C8.33,69.07,10.75,67.78,13.22,66.38ZM92.61,51.9c-5-1.34-9.81-2.68-14.66-3.92-3.17-.81-8.14,2.15-9.05,5.29-.44,1.51-.8,3-1.29,4.53a8.07,8.07,0,0,0,.79,6.51c1.44,2.81,2.54,5.8,3.79,8.7l-.23.1-6.56-11L61.12,65c4.64-3.23,4.57-8.15,5.06-12.63-3.46-2.48-6.59-2.08-9.66.23A10.51,10.51,0,0,1,54,53.89a2.26,2.26,0,0,1-1.51.13c-3.88-1.65-7.73-3.37-11.59-5.07,3.52.48,6.92,1.33,10.34,2a5.1,5.1,0,0,0,3-.26c4.21-2.08,8.34-4.32,12.5-6.5a7,7,0,0,1,5.11-.95,64.28,64.28,0,0,0,8.06.81L76.83,32.79c2,3.17,3.64,6.5,5.4,9.76.45.83,1.19,2,1.94,2.1,2.73.48,5.53.6,8.27.85a3.62,3.62,0,0,0,.13-.79q-2.16-12.29-4.32-24.57c-.28-1.6-1.33-1.39-2.49-1.22C74.67,20.62,63.58,22.27,52.49,24A4.12,4.12,0,0,0,50,25.34q-8.7,11.55-17.21,23.25a5.6,5.6,0,0,0-1,3.23c.1,3.61.79,7.23.6,10.81-.25,4.46.85,7.88,4.91,10.14a9.71,9.71,0,0,1,2.79,2.51,6.91,6.91,0,0,1,1.58,3.15c.36,3,.4,6.06.57,9.14l39.64-1.72Zm-63.33-39-17.61,29c5.42,1.66,10.56,3.3,15.75,4.75a3,3,0,0,0,2.39-1c2.64-3.2,5.15-6.51,7.67-9.81,3.19-4.19,6.34-8.4,9.58-12.7ZM8.85,90.33c8.64-.55,16.93-1,25.19-1.74,1-.1,2.51-2,2.73-3.2.68-3.8.5-7.52-4.4-8.63a1.42,1.42,0,0,1-.4-.24c-3.76-2.44-7.43-3.78-11.64-.57-2.94,2.24-7.17,2.78-8.46,7.12A74,74,0,0,1,8.85,90.33Zm70.89-75.1V14.8c-3.47-1.36-7-2.5-10.38-4.13-3.54-1.74-7.13-1.44-10.79-1.11-4.29.39-8.58.83-12.88,1.24L33.82,11.92c.17.43.18.64.28.69,5.1,2.56,10.21,5.12,15.34,7.61a3.52,3.52,0,0,0,2,.1q8.69-1.48,17.36-3C72.44,16.63,76.09,15.92,79.74,15.23ZM27.46,66.78c0-5,0-9.92-.05-14.85a2,2,0,0,0-1.12-1.43c-3.19-1.28-6.42-2.47-9.66-3.65-1.55-.56-3.13-1-5-1.64l5.4,18.69C21.19,63.14,24,66.45,27.46,66.78Zm-9.58-.1L7.42,72.19c1.61,1.44,2.84,2.65,4.21,3.68a2.13,2.13,0,0,0,1.86.25c3.08-1.62,6.09-3.36,9.4-5.22ZM6.07,74.56c-.92,4-1.78,8-2.73,11.94-.43,1.8.26,2.67,2.15,2.92C6.32,87.72,7.16,86,8,84.24c2.7-5.33,2.7-5.33-1.43-9.55C6.57,74.65,6.46,74.65,6.07,74.56Z"/>
	                  //   </svg>),
	                  // 'citrico': (
	                  //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className={'svg' + ' ' + this.props.icon}>
	                  //     <path d="M30.8,82.2V55.49l-19,11C14.87,75.66,23,82.37,30.8,82.2Zm-20-39.39a37.11,37.11,0,0,0,.08,22.07L30,53.86Zm20-17.31c-7.33-.46-16.09,6.77-19,15.75l19,11ZM33,82.12c7.23.47,16.15-6.85,19-15.68L33,55.52ZM95.2,46.9A26.51,26.51,0,0,1,86.6,39c-.22-.36-.48-.69-.72-1C79.12,28.19,69.31,22.65,58.4,18.83a89.31,89.31,0,0,0-24.18-4.39,27.48,27.48,0,0,0-21.73,8C3.65,31,.23,41.83,0,52.6c.07,11.47,2.71,20.88,9.08,29,5.54,7,12.56,11.68,21.83,11.74,13.92.09,27.19-2.75,39.38-9.67,8-4.52,14.69-10.37,18.34-19.05a3.77,3.77,0,0,1,3.55-2.75c4-.46,7.35-3.65,7.74-6.87C100.36,51.4,98.7,48.56,95.2,46.9ZM48.51,81.38a23,23,0,0,1-33.45.19c-13-13.38-13.94-38-2.18-52.95,9.65-12.25,25.79-13,36.28-1.45,6.9,7.61,9.61,16.75,9.68,26.61C58.74,64.4,55.66,73.61,48.51,81.38Zm4-16.51a35,35,0,0,0,0-22l-19,11ZM33,25.15v27l19.16-11C48.3,32.55,42.7,26.65,33,25.15Z"/>
	                  //   </svg>),
	                  // 'frutado': (
	                  //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className={'svg' + ' ' + this.props.icon}>
	                  //     <path d="M51.07,25.74c8.62-.1,16.12,1.7,22.72,6.19,9.45,6.43,13.08,15.8,11.42,26.8-2.3,15.21-9.64,27.82-22.06,37.06-7.77,5.78-15.83,5.59-23.48-.45A55.86,55.86,0,0,1,18,56.15C16.78,45,23.47,34.29,33.76,29.6A40.22,40.22,0,0,1,51.07,25.74Zm.2,55.82c-1.79-1.12-3.22-2.36-3.5-2.14a40.71,40.71,0,0,0-5.24,5.13,10.73,10.73,0,0,0,2,2.16C46.64,85.31,48.58,83.69,51.27,81.56ZM42.26,69c-.57-.34-2-1.55-2.32-1.31a32.83,32.83,0,0,0-5.08,5,4.4,4.4,0,0,0,1.87,2.39C38.09,75.65,42.42,71.29,42.26,69ZM26.1,63.72C28,61.86,29.61,60.45,31,58.87a2.17,2.17,0,0,0,.23-2c-.39-.66-1.75-1.55-1.9-1.42A48.33,48.33,0,0,0,24,60.75C23.79,60.94,25.14,62.42,26.1,63.72ZM67.21,82.15c-.87-2.48-2.14-3.5-3.69-2.56a14.83,14.83,0,0,0-4.18,4.15c-.88,1.24.84,3.63,2.06,3C63.53,85.56,65.29,83.71,67.21,82.15Zm-10-15.79C55.09,69,53.49,71,52.11,73.09a10.53,10.53,0,0,0,2.25,2,41.72,41.72,0,0,0,5.17-5.29C59.71,69.56,58.43,68.14,57.2,66.36ZM43.35,54.8c-1.55,1.89-3.44,3.61-4.53,5.74-.71,1.38,1.7,2.9,3.19,1.89a15.51,15.51,0,0,0,3.82-3.67C46.92,57.26,45.78,55.38,43.35,54.8Zm14.23,8c1.73.06,5.49-3.74,5.23-5.44-.29-1.89-1.62-2.68-3.2-1.69a14.22,14.22,0,0,0-3.8,3.69A2.18,2.18,0,0,0,57.59,62.81ZM71,76.51c2.14-2.76,3.74-4.73,5.14-6.83a9.82,9.82,0,0,0-2.23-1.94,35.58,35.58,0,0,0-5,5.08C68.57,73.12,69.8,74.58,71,76.51ZM80,58.19l-.24-1.4c-1.07-.43-2.6-1.54-3.13-1.18a19.74,19.74,0,0,0-4.47,4.5c-.17.23,2,2.63,2.08,2.57C76.29,61.31,78.16,59.73,80,58.19ZM54.42,51.56c1.73-2.13,3.3-3.91,4.61-5.87.19-.28-1.24-2.13-1.38-2.07A18.87,18.87,0,0,0,53.1,46.3a4.18,4.18,0,0,0-1.19,3C51.94,49.93,53.18,50.5,54.42,51.56Zm21.33-6.72c-.5-.33-1.84-1.5-2.08-1.3a46.47,46.47,0,0,0-5.27,5.15,5.33,5.33,0,0,0,2,2.05C71.83,51.21,75.9,47,75.74,44.84Zm-39.69,6C38,50.93,42,47,41.78,45.46c-.09-.6-.74-1.65-1-1.6A8.74,8.74,0,0,0,37,45c-1.41,1.06-3.3,2.26-2.33,4.57C34.87,50.21,35.74,50.57,36.06,50.83Z"/>
	                  //     <path d="M64.56,25c-2.71-.25-5.43-.45-8.13-.77a39.73,39.73,0,0,0-26.62,5.66,4.54,4.54,0,0,1-4.88.38c-4.17-1.85-8.46-3.42-12.89-5.19,7.81-3.63,16.34-4.33,25.56-5.19L32,10.36l.33-.73L50.12,18a40.25,40.25,0,0,1,0-5.67,46.31,46.31,0,0,1,2-9.55c.46-1.27,2.53-2.51,4-2.72,3-.43,3.95,1.23,2.41,3.91a26.11,26.11,0,0,0-3.45,14.52,68.59,68.59,0,0,1,21.81-6.73l-7.17,8Z"/>
	                  //     <path d="M64.56,25l5.19-5.29c5,.8,10,1.58,15,2.4,1,.17,2,.5,3.25.8-4.5,2.45-8.73,4.78-13,7a2.07,2.07,0,0,1-1.61,0c-2.88-1.33-5.72-2.73-8.56-4.15C64.61,25.77,64.63,25.32,64.56,25Z"/>
	                  //   </svg>),
	                  // 'especiarias': (
	                  //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className={'svg' + ' ' + this.props.icon}>
	                  //     <path d="M50.23,64.78a10.35,10.35,0,0,0,3.27,3.38c2.94,2.1,4.93,4.7,4.41,8.41s-2.35,6.78-6.16,8.2c-2.77,1-6.16-.08-7.38-2.44-1.4-2.7-.72-6.31,1.74-7.8a3.21,3.21,0,0,1,2.87.15c.44.3.17,1.76.06,2.68,0,.35-.72.61-.78,1-.11.69-.27,1.67.1,2.08a2.35,2.35,0,0,0,2.06.42c2.83-.93,4-5.74,2.07-8a6,6,0,0,0-9.06-.37,17.75,17.75,0,0,0-3.13,4.66,9.26,9.26,0,0,0,6.45,13.24,24.41,24.41,0,0,0,14.18-1c8.09-3.06,15-7.62,18.81-15.77,2.19-4.7,1.53-8.48-1.78-11.82-2.62-2.65-8.06-3.62-11.83-2.11-3.1,1.24-4.41,4.78-3.38,8.17.89,2.93,4.23,3.19,6.68,2.41.78-.25,1.23-1.51,1.83-2.3-.79-.41-1.64-1.25-2.35-1.15-1.66.25-3.06-.17-3-1.75,0-.86,1.52-2.16,2.57-2.43a5.63,5.63,0,0,1,6.63,3.12,6.25,6.25,0,0,1-2.43,7.68,9.78,9.78,0,0,1-10.07.35C59.15,72,58.12,68.82,58,65.15a10.68,10.68,0,0,0-1.08-4.6Q50.3,48.61,43.42,36.84C37.32,26.39,31.08,16,25,5.6c-1.77-3-1.66-3.09-4.83-1,2.31,4.75,4.57,9.54,6.95,14.28Q38.59,41.85,50.23,64.78ZM85.46,53.72c-6.53-7.27-13-14.64-19.51-21.89Q52.83,17.3,39.57,2.91C36.47-.45,32-.89,27.54,1.54L63.66,55.95c.89-.28,1.52-.54,2.18-.68C72,54,77.7,54.92,82,59.91s4,10.81,1.32,16.42c-5.19,10.86-21.11,19.83-33.21,19-13.85-.92-18.35-13.3-12.58-22.19a72,72,0,0,1,5.54-6.64L16.38,6.67c-1.91,2-3.68,3.58-5.12,5.43A6.92,6.92,0,0,0,10,18.42Q19.44,52.34,28.9,86.26a14.85,14.85,0,0,0,2.15,4.33c3.31,4.77,8.16,7.17,13.64,8.53C62.15,103.47,83.88,91.22,89.06,74,91.25,66.7,90.87,59.75,85.46,53.72Z"/>
	                  //   </svg>),
	                  // 'madeiras': (
	                  //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className={'svg' + ' ' + this.props.icon}>
	                  //     <path d="M99.59,57.57c-1.39-7.11-5.39-12-12.74-13.38C84,43.67,80.93,44.1,78,44.1c.3-.37.7-.93,1.17-1.43,5.37-5.66,6.47-16.23,2.38-22.8-4.23-6.78-10.22-9.2-18.86-7.64-9.93,1.79-19.87,3.6-29.81,5.31-5.92,1-10.37,4.06-13,9.42C16.17,34.3,17,41.37,21.75,48.48l-5.28.86C7.83,50.75,2.14,56.45.9,64.88c-1.77,12,6.75,23.81,21,20.58C27.2,84.27,32.6,83.55,38,82.7a3.8,3.8,0,0,1,2.63.37c4.32,3.36,9.15,3.44,14.2,2.52,10-1.8,20-3.54,30-5.39a18,18,0,0,0,5.29-1.67C97.62,74.45,101.29,66.32,99.59,57.57Zm-2.11.86c-4,.72-8,1.6-12,2.1-5.54.69-11.11,1.09-16.66,1.64-3.19.32-3.28.27-3.91-3.26a6.28,6.28,0,0,1,1.73-.54c8.75-.11,17.07-3,25.69-3.92C96.24,54,96.23,54,97.48,58.43ZM88.5,48c2.75-.32,5,1.43,6.11,4.39l-14,2.06c-1,.15-2,.35-3,.51-4.41.72-8.82,1.46-13.24,2.13a1.83,1.83,0,0,1-1.36-.53c-1-1.05-1.88-2.21-2.88-3.41a6.37,6.37,0,0,1,.91-.36c4.08-.89,8.13-1.89,12.24-2.6Q80.89,48.85,88.5,48ZM48.62,73.53c2.67,1.79,4.87,1,5.93-2.05,1.39-4.05-.63-7.57-5.17-8.62L49.11,60c2.94-.7,6.41,1.29,7.62,4.39a11.45,11.45,0,0,1-.25,9.09c-1.21,2.74-4.86,3.91-8.28,2.82-2.83-.91-5.22-4.41-5.45-8-.26-3.87,1.14-6.36,4.7-8l1.19,2.56C44.18,66.05,44.23,70.59,48.62,73.53Zm.88-9.43a4.28,4.28,0,0,1,3.25,1.56c.83,1,1.05,2.5,1.71,4.22C53.61,71,53,72.67,51.8,73.19c-.86.38-2.54-.49-3.58-1.21a4.36,4.36,0,0,1-1.57-5.37A4.53,4.53,0,0,1,49.5,64.1ZM44.73,50.19c.75-1.64.75-2,4-2,5.71,0,11-1.81,16.46-2.93a50.32,50.32,0,0,1,6.26-.52v.68ZM74.78,47.4l.14.72L57.11,51.67l-.21-1.09Zm1.91-5.59c-1,.83-2.77.93-4.19.91-5.51-.08-10.7,1.48-16,2.76a73.84,73.84,0,0,1-8.71,1.07c.88-4.27,3.65-5,7.06-5.76,7.16-1.55,14.19-3.72,21.28-5.62,1.54-.41,3.1-.75,4.85-1.17A11.89,11.89,0,0,1,76.69,41.81Zm4.85-15c.95,4.45.5,5-3.83,6.14-5.07,1.38-10,3.13-15.13,4.49-3.95,1.05-8,1.75-12.17,2.64V31.17c2.79-.5,5.67-1.46,8.54-1.45A31.32,31.32,0,0,0,74.6,26.18,41.77,41.77,0,0,1,80.69,24C81,25.15,81.37,25.95,81.54,26.77Zm-1.78-4.51c-4.38,1.71-8.68,3.59-13.13,5-2,.64-4.3.24-6.44.5-3.42.42-6.83,1-10.57,1.56l-2.25-5c4-.7,7.9-1.48,11.84-2,5.74-.83,11.51-1.44,17.24-2.28C78.34,19.73,79.41,20.2,79.77,22.26Zm-14.91-8L65,15,51.26,17.38l-.07-.61ZM49.75,19.08c7.11-.18,13.89-2.19,20.79-3.51,2.8-.54,4.58.5,6.56,2.63-4.16.65-8,1.29-11.89,1.84-5.67.8-11.37,1.4-17,2.38a4,4,0,0,1-4.68-2C45.67,19.91,47.7,19.13,49.75,19.08Zm-6.06,4.77c7.46,7.19,6.19,20-2.46,25.73-.69.45-1.46.77-2.31,1.22l-.79-1.66c2.21-2.44,4.67-4.35,6.05-6.85a14.16,14.16,0,0,0-5.21-19c-4.8-2.69-10.69-1-13.9,4-.58.9-1.1,1.83-1.71,2.84l-2-1.23C23.9,21.56,35,15.51,43.69,23.85Zm-10.14,39-1.72-3.33,4.11-1.3a12.25,12.25,0,0,1-.6,1.73C34.77,61,34.15,61.92,33.55,62.89Zm1.68,13.92-4.42,1.42,2.83-7.38ZM31.47,57.42c-1,.18-2.4-1.65-3.61-2.56l.75-1.1H39.52C38,57.14,34.43,56.9,31.47,57.42ZM27.76,41.27c3.74,5.23,9.84,4.48,12.81-1,2.56-4.7,2.3-9.42-3-13-3.29-2.22-6-1.77-8.36,1.48-.67.94-1.3,1.92-2.08,3.07l-2.23-.77A10.11,10.11,0,0,1,31.12,24a8.24,8.24,0,0,1,9.41,2.16C46,31.87,46,39,40.84,45c-1,1.12-2.2,2.25-4.16,1.65-.63-.19-1.56,1-2.38,1-5.31.25-9.86-3.86-10.5-9.47a48.26,48.26,0,0,1,0-5.16l2.7.26C25.94,36.15,25.95,38.73,27.76,41.27Zm.7-8a20.08,20.08,0,0,1,2.16-4.39c1.5-2.16,2.84-2.49,5.15-1.26,3.11,1.65,5.28,4,5.17,8.58,0,2.33-2.4,6-5.2,7.16-2.3.95-4.67,0-6.82-2.63S27.23,36.55,28.47,33.31ZM20,39.45a59.52,59.52,0,0,1,0-7l2.5.28C21,43.64,27.53,49.82,36.14,49c.69,2.08,0,2.73-2,2.82C27.59,52.14,20.86,46.38,20,39.45ZM18.39,83.63c-4.9.53-8.75-1.36-11.94-4.93-1.13-1.26-.28-1.84.83-2.57a12,12,0,0,0,11.33,4.61,10,10,0,0,0,9.09-8,20.69,20.69,0,0,0-1.7-13c-3-6-11.5-7-16.51-2A14.22,14.22,0,0,0,5.32,70.88c.23,1.35.38,2.5-1.47,2.6-2.73-4.89-.59-14.12,4.19-18,8.66-7.07,20-3.11,22.84,7.8C33.29,72.61,27.32,82.67,18.39,83.63ZM17.06,77a5.79,5.79,0,0,0,5.81-5c.84-4.12-.55-7.86-2.2-11.46-.93-2-3.62-2.52-6-1.52-3.78,1.62-5.89,5.63-5.52,10.84.12,1.64-.18,2.58-2.1,2.44-1.88-7,1.1-13.58,7-15.8a8.32,8.32,0,0,1,10.06,3.15A16.4,16.4,0,0,1,25.9,73.91c-1.13,3.29-3.85,5-7.26,5.39-4.24.51-7.86-.57-10.33-4.47l1.57-2.19C11.51,75.53,13.75,77.17,17.06,77ZM10.52,66c.69-3,2.24-5.23,5.34-6.14,1.94-.57,3.47,0,4.2,1.85.9,2.27,1.5,4.66,2.27,7.13-.58,1.87-.78,3.83-1.75,5.28-1.59,2.38-5.33,2.49-7.69.4C10.33,72.26,9.77,69.27,10.52,66ZM27.89,82l-.28-.86c2.83-.89,5.65-1.82,8.51-2.59.3-.08.88.87,1.65,1.68Zm12.44-2.26C35.91,75.4,35,70.13,36,64.59a14.48,14.48,0,0,1,8.48-11.16c.87,1.11,1.1,1.84-.2,2.75-7,4.88-9.15,14.79-2.16,22.14ZM39.25,67.22c.07-3.3,2.58-8.78,6.85-10.42l.73,2.07L46,58.15c-1,1.45-2.2,2.83-3.1,4.36-2.23,3.81-1.72,7.62.47,11.23a8.12,8.12,0,0,0,13.71.78c4.38-7.07.54-14.84-8-16.36l-.17-2a2.65,2.65,0,0,1,.73-.3,9.38,9.38,0,0,1,7.92,3.63c3.45,4.22,4.78,8.86,2.57,14.07-2.86,6.73-10,7.95-16.12,3.7C40.14,74.61,39.17,71.13,39.25,67.22Zm19,13.67c-5,3.88-11.31,4.09-16,.33l.83-1.8c5.61,2,11.17,3.21,15.85-1.45,3.85-3.83,4.65-8.87,2.88-13.85-2-5.78-5.87-9.86-12.92-9.67v-2c5.23-1.11,10.92,2.19,13.6,7.25A17.12,17.12,0,0,1,58.23,80.89ZM61,82.11l-.19-.7c8.52-3.09,17.55-3.35,26.38-4.74l.14.73Zm28.44-7.22c-7.64.73-15.24,1.92-22.86,2.95-.91.12-1.8.38-3.08.66a9.43,9.43,0,0,0,1.12-2.18c.67-3.82,2.9-4.62,6.64-4.73,8.13-.24,16.24-1.24,24.57-2C94.21,71.95,93.16,74.54,89.45,74.89Zm7.83-9.31a2.91,2.91,0,0,1-1.9,1.7,77.48,77.48,0,0,1-8.68,1.35c-5.86.54-11.74.92-17.61,1.35-.76.06-1.53,0-2.47,0V64.5l31.23-3.79A32.23,32.23,0,0,1,97.28,65.58ZM47.83,88.11h4.22v-.46H47.84ZM12,88l0,.42,6.17-.4-.06-.64ZM34.11,40.51c2,0,3.52-2.09,3.56-5s-1-4.42-3-4.46c-2.12,0-4,2.18-4,4.87C30.64,38.33,32.27,40.5,34.11,40.51Zm.49-8.56c1.33,0,2.2,1.39,2.22,3.51s-1.19,4.23-2.61,4c-1.83-.26-2.46-1.7-2.52-3.36C31.61,34.11,33.18,31.94,34.59,31.95ZM17.41,71.6a36.54,36.54,0,0,0,1.41-3.87,18,18,0,0,0-.88-3.21c-.94-1.89-2.21-2.1-3.71-.79a6.5,6.5,0,0,0-.63,8.3C14.94,73.59,16.51,73.46,17.41,71.6Zm-2.65-7.2c.9-1,1.61-.71,2.23.28,1.29,2.07.57,5.84-1.43,7.55A5.23,5.23,0,0,1,14.76,64.41Z"/>
	                  //   </svg>),
	
	                  'chocolate': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'chocolate-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M69.27,90.25c-9.67,0-19.34,0-29,0-5.21,0-10.41.25-15.62.29-4.64,0-5.81-.95-5.77-4.82.1-9.86.36-19.72.37-29.57,0-9.24-.28-18.48-.37-27.72-.06-6.25,0-12.5,0-18.74,0-3.58,1.21-4.58,5.39-4.64,1.15,0,2.31.09,3.44,0,2.55-.24,3.64.6,4.21,2.8,1.19,4.62,7.42,6.69,12.08,4,2.22-1.27,3.39-1.16,5.14.59,4.26,4.25,9.8,5.64,16.06,3.82,2.71-.79,4-.49,4.82,1.9,1.49,4.2,4.71,7.36,8.83,10a4.76,4.76,0,0,1,2.1,3.39c.07,8.19-.23,16.39-.22,24.58,0,9.78.23,19.57.3,29.35,0,4.27-1,5-6.1,5.06H69.27ZM23,25V37.73H38V25ZM57.48,37.8V25h-15V37.8ZM38,54.23V41.46H23V54.23ZM57.5,41.45H42.43V54.16H57.5Zm4.32,0V54.17h15V41.44ZM38.07,70.67V57.89H23V70.67ZM57.5,57.88H42.43V70.59H57.5Zm4.32,0V70.6h15V57.87ZM38,87.11V74.32H23V87.11ZM57.5,74.31H42.43V87H57.5ZM76.88,87.1V74.34h-15V87.1ZM61.83,25.17V37.73h15C78,29.14,71.65,23.79,61.83,25.17ZM38,21.35c.59-3.08.57-5.24-3.65-6.23a8.87,8.87,0,0,1-5.16-4.27C27.81,8,25.74,8.22,23.05,8.62V21.35Zm20.05-.1c-.67-.73-.81-1-1-1.11-3.4-1.62-6.8-3.24-10.24-4.8a2.93,2.93,0,0,0-1.67-.13c-3.1.69-3.65,2.13-2.41,6Z' })
	                  ),
	                  'cakes': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'cakes-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M98,41.87V77.6a6.79,6.79,0,0,1-2.09,1.14C86.79,80,77.64,81.22,68.51,82.45l-36.82,5q-12.94,1.75-25.88,3.5c-1.36.19-2.53.12-3.29-1V55.6c.65-.48,1.26-1,2-1.43q16-9.63,31.95-19.26a2.81,2.81,0,0,0,1.13-1.31c1.21-3.25,3.69-5.42,7.5-6.52l1.11-.35a6.51,6.51,0,0,0-5.33-4.23,28.42,28.42,0,0,0-3.44-.18c-1.28-.06-2.12-.71-2.14-1.65S36,19,37.18,18.94c6.44-.5,11.14,2.26,12.8,6.78.1.26.21.52.34.86,2-1.21,3.94-2.28,5.74-3.49a3.39,3.39,0,0,1,3.79-.16q18.22,8.88,36.49,17.7A10.62,10.62,0,0,1,98,41.87ZM6.54,79l26.22-3.9L80.06,68c1.38-.21,2.38.33,2.6,1.36s-.57,1.74-1.89,1.95c-2.77.43-5.55.83-8.33,1.24L11.66,81.68c-1.7.25-3.4.53-5,.78v4.82a6,6,0,0,0,.7,0l37.9-5.1q19.83-2.67,39.66-5.34c1-.13,1.32-.37,1.31-1.24,0-7.37,0-14.73,0-22.1,0-.35,0-.69-.07-1.1l-23.27,3.5L26,61.45q-9.33,1.41-18.65,2.84c-.3,0-.77.34-.77.53-.06,1.63,0,3.27,0,4.93.44,0,.72,0,1-.06l30-4.48,42.35-6.35c1.45-.22,2.51.33,2.72,1.37s-.61,1.76-2,2-2.51.36-3.76.55L34.41,69.12q-13.49,2-27,4.06c-.33.05-.83.44-.84.68C6.51,75.53,6.54,77.21,6.54,79Zm87.32-3.4a1.82,1.82,0,0,0,.1-.33q0-15.64,0-31.28a1.4,1.4,0,0,0-.75-1c-2.77-1.39-5.57-2.73-8.36-4.08Q72,32.72,59.08,26.5c-.35-.17-.92-.41-1.16-.29-1.13.57-2.18,1.26-3.3,1.94,5.13,3.27,5.79,7.74,4.45,11.1-1.46,3.65-5.59,6.27-10,6.42-5.28.18-9-2.05-11.64-7.16L13.3,53a1.37,1.37,0,0,0,.82.09l21.6-3.14,39.69-5.76c2.15-.31,4.3-.66,6.46-.91a1.9,1.9,0,0,1,2.25,1.39c.17.84-.45,1.61-1.54,1.88a9.25,9.25,0,0,1-.93.17L51.72,51.07,13.44,56.62l-6.81,1v3.24c.36,0,.64,0,.91-.06l28.27-4.26,51.37-7.78c2.11-.32,3,.31,3,2.11q0,12,0,23.92v1.29ZM48.46,42.27c3.95,0,7.2-2.74,7.25-6.08S52.4,30,48.44,30s-7.27,2.78-7.26,6.16S44.4,42.28,48.46,42.27Z' })
	                  ),
	                  'fruit': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'fruit-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M44.3,16.87a11.5,11.5,0,0,1,3.22-8.66,4.57,4.57,0,0,1,7.36.85c.59,1,.11,1.39-.45,2-4.2,4.25-4.82,9.33-3.55,14.91.27,1.2,1.25,3.09-1,3.44A3.07,3.07,0,0,1,46.35,27C45.32,23.65,44.11,20.38,44.3,16.87Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M70.53,33.61A25.73,25.73,0,0,0,59.89,32c-6.42.31-12.84,1.57-17.93,0C21.76,31.67,12.07,45.45,18.51,63.5A78.91,78.91,0,0,0,30.95,85.27c4.31,5.56,8.7,7.07,15.1,4.48a10.23,10.23,0,0,1,8.5.14c4.84,2,9.68,1.45,13.25-2.76,7-8.32,12.74-17.52,15.43-28.29C86.06,47.5,80.93,37.63,70.53,33.61Zm7.28,28.15C75,69.59,70.46,76.41,65.48,83c-3.19,4.21-7.15,3.62-11,1.56-2.91-1.56-5.2-1.77-8.27-.14-5.9,3.12-8.49,2.25-12.5-3.09A76.06,76.06,0,0,1,22.69,62c-5.4-14.63,1.92-24.89,18.83-24.65,5.43,1.82,12.12.33,18.86.1C75.75,37,83,47.35,77.81,61.76Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M49.37,66.06c-3.61-1.69-8.08-.43-8.68-5.15-.27-2.18,1.83-3.56,3.75-3.29C48.72,58.22,48.58,61.94,49.37,66.06Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M53.76,65.33c-1.62.55-2-.28-1.8-1.64.48-2.66.92-5.61,4.21-6.07,2.27-.32,4.35,1.21,4.14,3.51C60,64.85,56.25,64.37,53.76,65.33Z' })
	                  ),
	                  'ice-cream': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'ice-cream-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M52.87,5a50.9,50.9,0,0,1,5,1.72C63.38,9.24,67,13.31,68,19.41a3.15,3.15,0,0,0,1.15,1.86c7.41,5.18,9.51,10.32,7.67,19,.06.12.09.31.18.36,4,2.06,4.52,4.82,1.2,7.87q-10.6,9.75-21.47,19.19c-1.35,1.18-3.23,1.76-5,2.71V87.45c2.23,0,4.37-.1,6.49,0a3.64,3.64,0,0,1,2.5,1.06c.32.46-.33,1.6-.54,2.44H39.54c-.22-.84-.88-2-.55-2.44a3.62,3.62,0,0,1,2.5-1.07c2.12-.15,4.25,0,6.49,0V70c-3.89-.58-6.41-3.51-9.21-6Q30.5,56.69,22.28,49.3c-.21-.19-.43-.38-.63-.58-3.47-3.38-3-6.15,1.38-8.31-1.84-6.54-.55-12.43,4.73-16.84a14.12,14.12,0,0,0,4.77-7.05c2-6.15,6.81-9.48,12.94-11,.47-.12.92-.31,1.38-.46ZM76.72,44.73l-.28-.53H22.57a32.35,32.35,0,0,0,2.17,2.47q9.82,8.83,19.67,17.61a7.73,7.73,0,0,0,10.85,0q9.86-8.77,19.68-17.6A23.93,23.93,0,0,0,76.72,44.73ZM40.4,40.29c4,0,8-.09,12,0a2.15,2.15,0,0,0,2.51-1.95,11.65,11.65,0,0,0-2.65-11,15.89,15.89,0,0,0-22.4-1A11.73,11.73,0,0,0,26.16,38c.36,1.62,1,2.4,2.85,2.32C32.8,40.18,36.6,40.29,40.4,40.29ZM53.53,23.44c4.88,4.77,6.43,10.33,4.69,16.86h11c4.21,0,4.77-.55,4.77-4.87a12.07,12.07,0,0,0-.34-3C71.59,24.49,61.75,20,53.53,23.44ZM64.2,19.21C63.07,13,56.67,8.43,49.72,8.56S36.44,13.28,35.57,19.19a21.43,21.43,0,0,1,13.82,1.47,1.58,1.58,0,0,0,1.19-.07A21.33,21.33,0,0,1,64.2,19.21Z' })
	                  ),
	                  'pies': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'pies-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M58.89,90.2c-2.26.45-4.59,1.52-6.76,1.24-6-.78-12.09-.28-18.19-2.27-4.57-1.49-8.59-3.87-12.88-5.75a11.76,11.76,0,0,1-4.88-4.91C11.87,70.86,7.83,63,3.73,55.27c-1.66-3.15-2.8-6.34-.15-9.62a2.38,2.38,0,0,0,.17-1.55A8.66,8.66,0,0,1,9.85,34.3,4,4,0,0,0,12,32.72a9,9,0,0,1,7.69-4.83,9.4,9.4,0,0,0,2.85-1c1.62-.73,3.14-1.92,4.81-2.25,4-.8,8.16-1.74,12.23-1.61,3.48.11,6.88.17,10.37,0a113.78,113.78,0,0,1,13.75.82c3.24.28,6.57.95,9.86,1.43a35,35,0,0,1,13.16,5.22c2.47,1.56,4.6,4,7.15,5.75a7.39,7.39,0,0,1,3,7.88,2.45,2.45,0,0,0,.27,1.73c2.14,2.74,1.8,5.74.37,8.44C93,62.74,88.56,71.16,83.62,79.27c-1.35,2.23-4.21,3.6-6.6,5C71.39,87.46,65.48,90,58.89,90.2ZM26,62.36l-.06,0c.6,1.45,1.11,3,1.81,4.35,2.76,5.48,8.89,6.37,13,1.94.46-.5,1-.94,1.47-1.39a5.78,5.78,0,0,1,.84.67c5,6.39,9.07,6.52,14.45.4,1-1.13,1.55-1.07,2.5.13,3.84,4.86,10.34,3.72,12.61-2.15.45-1.16.8-2.37,1.2-3.55.61.16,1,.13,1.1.3,1.88,2.42,4.24,3.72,7,2.2s4-4.14,3.32-7.52C85,56.11,85.86,56,87,56.27a15.59,15.59,0,0,0,3.69.46A5.61,5.61,0,0,0,96,52.62c.8-2.23,1-4.35-1.22-6a2.32,2.32,0,0,1-.37-1.91c1.07-4.53-.58-7.41-4.88-8.51-.75-.19-1.82-.69-2-1.3-1.08-3.5-3.75-4.12-6.69-4.58A7.28,7.28,0,0,1,77.59,29c-2.24-1.72-4.59-2.69-7.24-1.44-1.49.7-2.49.36-3.92-.38-1.82-.94-4.17-1.77-6-1.37a11.7,11.7,0,0,1-7-.37c-2.06-.73-4.64.18-7,.33-1.15.07-2.41.41-3.44,0-3.13-1.11-6.07-1.36-9,.55a3.13,3.13,0,0,1-2.21.31c-3.34-.78-6.12.24-8.72,2.42a4.92,4.92,0,0,1-3,1.05c-3.14,0-5.54,1.23-6.7,4.13a2.76,2.76,0,0,1-2.67,2.12c-2.67.24-5.56,3-5.37,5.39s1,4.93-1.41,6.82c-.25.19-.22.9-.17,1.35.4,3.77,2.53,8.31,8,6.93a8.05,8.05,0,0,1,1.86,0A41,41,0,0,0,14.52,61c1.64,5.07,6.26,6.11,9.78,2.3A6,6,0,0,1,26,62.36Zm33.23,8.9L56.66,88.88c3.15-.58,5.85-.95,8.48-1.62a3.86,3.86,0,0,0,2.5-1.88c1.47-4.42,2.68-8.93,4.1-13.86C67.27,74.09,63.32,74.67,59.27,71.26Zm-29.39,1c1.34,4.28,2.7,7.84,3.55,11.52a5.66,5.66,0,0,0,5.18,4.77,41.28,41.28,0,0,0,5.73.05L41.55,71C37.88,73.63,34.31,74.46,29.88,72.29Zm27.18.16c-4.42,3-8.62,3-13.19-.13.84,5.44,1.56,10.4,2.41,15.34a2.28,2.28,0,0,0,1.46,1.54,21.68,21.68,0,0,0,5.3,0,2.58,2.58,0,0,0,1.76-1.66C55.65,82.65,56.3,77.69,57.06,72.45ZM17.7,68.09c2.15,4.5,4.29,9.34,6.74,14,1.5,2.86,4.15,4.11,7.71,4.32L25.71,66.67Zm64.89.16-7.45-1.3-5.41,18.7c3.15-1.17,6-1.79,7.36-4.52C79.15,76.93,80.8,72.5,82.59,68.25Zm-74.76-9C11.31,65.86,14.56,72.16,18,78.35c.72,1.3,2.15,2.17,3.25,3.23l.51-.5L11.51,59.28ZM88.3,59,80.11,79.46,81,80,92.49,59Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M26,62.36A58.36,58.36,0,0,1,19,59.06a33.78,33.78,0,0,1-7.24-5.67c-4.24-4.72-3.85-10.5.71-14.89,4.29-4.13,9.64-6,15.2-7.24,16.28-3.5,32.55-3.65,48.59,1.34a32.39,32.39,0,0,1,10,5.28c5.55,4.29,5.84,10.77,1.12,16.06-4,4.54-9.35,6.83-14.91,8.42a83.49,83.49,0,0,1-43,.69c-1.13-.27-2.27-.49-3.4-.73Zm23.76-32c-6.39.72-12.81,1.24-19.16,2.23a34.17,34.17,0,0,0-15.22,5.85c-5.83,4.27-6.29,10.17-.84,14.9a29.58,29.58,0,0,0,9,5.43,74.15,74.15,0,0,0,52.31,0,29.62,29.62,0,0,0,8.78-5.24c5.71-4.85,5.3-11-.86-15.23a31.09,31.09,0,0,0-7-3.53C68.1,31.65,59,31,49.8,30.4Z' })
	                  ),
	                  'pastry': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'pastery-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M14.78,43.69c4.7-6.92,11-8.87,19.22-6.29a15.26,15.26,0,0,1,6.48-13.82C45,20.17,50,20.43,55.2,24.46c.55-.75,1.05-1.52,1.65-2.22,5-5.81,9.95-11.63,15-17.38.75-.85,2-1.91,2.89-1.85a6.5,6.5,0,0,1,3.8,1.87c.3.3-.67,2.74-1.49,3-9.12,3.14-13.44,10.83-18.73,18,5.31,1.89,9.13,4.71,9,10.87C75,35,81,37,85.13,43.46c2-.38,3.8-.81,5.66-1.06S93.67,43,93.13,45c-3.24,11.72-6.42,23.45-9.8,35.13-1,3.39-3.94,5.27-7.06,6.77-5.83,2.81-12.13,3.77-18.52,4.26-9.93.76-19.78.38-29.33-2.65a23.26,23.26,0,0,1-7.71-3.7,15.06,15.06,0,0,1-4.78-6.7c-3.2-10.41-5.93-21-8.84-31.46-1.11-4-.17-5,4.06-4C12.3,42.86,13.42,43.28,14.78,43.69ZM56,88.09c.41-5.79.71-11,1.22-16.25.07-.76,1.14-1.42,1.74-2.13a19.58,19.58,0,0,1,1.48,2.37c.18.39-.07,1-.1,1.44-.28,4.63-.55,9.25-.84,14,1.15-.08,1.93-.1,2.71-.18,6.87-.7,6.87-.71,8.31-7.26.79-3.61,1.45-7.25,2.4-10.81.24-.89,1.36-1.56,2.08-2.32.42,1,.89,2,1.23,3.07.1.31-.19.74-.27,1.12-.91,4.34-1.82,8.69-2.76,13.22,5-1.75,6.75-3.59,7.94-7.9Q85,62.68,88.77,48.9c.24-.88.37-1.8.59-2.87A10.26,10.26,0,0,0,82,51.54c-1,2-2,2.13-4,1C72.42,49.43,66.38,51,63,56.23c-1.67,2.58-2.29,2.63-4.33.42-4.8-5.21-12-5.31-16.82-.23C39.39,59,39.19,59,37.13,56a10.91,10.91,0,0,0-14.94-3.41c-2,1.18-2.92.92-4-1A10.83,10.83,0,0,0,10.7,46a11.65,11.65,0,0,0,.18,1.26Q15.08,62.64,19.28,78c.9,3.27,3.62,4.6,6.89,6.14-1.06-4.91-2.13-9.33-2.9-13.8-.18-1,.7-2.23,1.1-3.35.74.86,1.9,1.62,2.14,2.6,1.16,4.62,2,9.3,3.11,13.94.19.83.75,2.05,1.4,2.24,2.79.8,5.67,1.28,8.89,1.95-.34-5.39-.73-10.13-.88-14.87,0-1,.65-2.83,1.26-2.95,2.08-.39,1.87,1.4,2,2.74.36,5,.73,10,1.12,15.49H56Zm-6.43-41.6a15.39,15.39,0,0,0,11.48-5.4c4.22-5.11,2.65-9.87-3.73-11.85A17,17,0,0,1,52,26.39c-2.9-2.29-5.56-2.65-8.73-.7-4.7,2.89-6.78,7.75-5.36,12.49A12.08,12.08,0,0,0,49.62,46.49Zm14.53-3,16.06,4.29,2.07-2.21c-2.25-4-5.53-6-10-6A9.28,9.28,0,0,0,64.15,43.48Zm-46.3,2.1c.89,1.9,2,2.12,3.88,1.5,4.57-1.48,9.28-2.55,13.92-3.78C30.78,37.51,22,38.57,17.85,45.58Zm27.9,4.12A13.69,13.69,0,0,0,32,47.87l7.69,5.28Zm8,0,6.38,3.53,7.07-5.13C62.37,45.46,58,47.73,53.8,49.67Z' })
	                  ),
	                  'other-swwets': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'other-desserts-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M6,56.3c8.18,7.06,17.56,9.89,27.37,10.84,8.64.83,17.38.51,26.08.75,1.53,0,2.16-.61,2.56-2A31.63,31.63,0,0,1,64,61a2.27,2.27,0,0,1,1.54-1.19,2.61,2.61,0,0,1,1.69,1A14.18,14.18,0,0,1,68.45,63c2.31,3.86,1.13,4.1,6.52,2.62,6.44-1.76,12.55-4.27,18.07-8.89.51,5.09-.8,9.09-4.57,12.16A38.23,38.23,0,0,1,71.85,76.4c-16.68,3.51-33.32,3.67-49.64-1.73a45.93,45.93,0,0,1-11.49-6.25C6.83,65.7,5.79,61.41,6,56.3Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M5.89,66.94c6.88,7.77,15.66,10.85,25,12.47C46,82,61,81.88,75.79,77.71c6.37-1.8,12.19-4.72,17-10,.69,5.08-.22,9.3-4,12.55-5.17,4.45-11.37,6.8-17.94,8.12-15.59,3.13-31.2,3.3-46.55-1.21A54.6,54.6,0,0,1,12,81.33C6.87,78.23,5.49,73.13,5.89,66.94Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M5.11,42.65c6.79,9.94,17.45,11.53,28,12.52,8.63.82,17.39.33,26.09.37a3.4,3.4,0,0,1,3,4,40.46,40.46,0,0,1-2,5.1,2.29,2.29,0,0,1-1.58,1.15c-13.67.93-27.23.49-40.21-4.48a41,41,0,0,1-9.08-5C5.22,53.3,3.73,48,5.11,42.65Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M93.67,41.54c2,8.79.1,13.36-7.3,17.16-4,2.06-8.41,3.39-12.65,5-1.32.51-2.34.34-2.94-1.19a33.79,33.79,0,0,0-1.68-3,3.5,3.5,0,0,1,2.28-4.93c3.9-1.06,7.88-1.94,11.65-3.37C87.6,49.46,91.55,46.76,93.67,41.54Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M55.48,38.7c4.08,4.78,8.14,9.27,11.78,14.07.61.81-.14,3.46-1.09,4.43-1.16,1.18-2.1-.3-2.92-1.48-2.5-3.59-5.14-7.1-7.84-10.54C53.06,42.18,53,42.24,55.48,38.7Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M53.58,36.38l-2.3,3.78C47,34.94,42.75,30,38.85,24.88c-.58-.76.32-2.64.54-4l.9,0Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M38.12,46.44C34,47,30.43,47.61,26.84,48.07a1.72,1.72,0,0,1-1.38-.64c-1-1.66-1.94-3.39-3-5.33,3.62-.57,6.92-1.13,10.25-1.56a2.17,2.17,0,0,1,1.59.79C35.53,42.85,36.66,44.47,38.12,46.44Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M64,45.06c1-.15,1.49-.22,2-.31,7.79-1.45,8-1.37,12.81,5.83-2.59.61-5,1.23-7.51,1.72a1.9,1.9,0,0,1-1.5-.54C67.91,49.68,66.12,47.53,64,45.06Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M43,48.55l5.46-.77c6.16-.88,7.15-.37,10.72,6.06-4.07,0-7.76.12-11.44-.09-.81,0-1.63-1.17-2.3-1.92C44.68,50.91,44,49.87,43,48.55Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M36.81,40c3.27-.54,6.17-1.06,9.1-1.46a2.25,2.25,0,0,1,1.69.62c1.45,1.57,2.78,3.25,4.48,5.28C48.43,45,45.21,45.52,42,46a1.62,1.62,0,0,1-1.25-.56C39.44,43.71,38.23,42,36.81,40Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M31.7,37.85c-3.45.53-6.55,1-9.67,1.44a2,2,0,0,1-1.59-.72c-.91-1.36-1.64-2.83-2.6-4.54,3.23-.5,6.15-1,9.07-1.34a2.17,2.17,0,0,1,1.59.77C29.55,34.73,30.46,36.11,31.7,37.85Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M25.12,24l8.1-2.2,5.18,6.3c-3.2.48-6,.95-8.78,1.27-.4,0-1-.51-1.3-.93C27.19,26.93,26.13,25.39,25.12,24Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M44.83,35.85c-3.26.52-6.1,1-9,1.37a2.14,2.14,0,0,1-1.62-.72c-1.09-1.33-2-2.77-3.25-4.49,3.05-.44,5.77-.89,8.51-1.17a2.61,2.61,0,0,1,1.84.82C42.53,32.89,43.54,34.27,44.83,35.85Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M18,39.94c-3.37.51-6.3,1-9.23,1.38-1.94.28-1.82-1.34-2-2.43-.28-1.36-.53-3,1.33-3.45a38.24,38.24,0,0,1,5.88-.88,2.08,2.08,0,0,1,1.48.92C16.23,36.77,16.95,38.17,18,39.94Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M9,44.08c2.22-.32,3.76-.55,5.31-.75,5.74-.74,6.32-.36,8.22,5.25C17.05,50.84,13.24,47.92,9,44.08Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M57,37.13a24,24,0,0,0,4.08-.75c4.68-1.8,6.87,1.22,9.25,4.71-2.68.46-5.15.94-7.64,1.28a2.29,2.29,0,0,1-1.7-.62C59.74,40.39,58.56,38.91,57,37.13Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M50.27,29.15a20.53,20.53,0,0,0,2.89-.5c4.64-1.6,8-.12,10.12,4.58-2.48.4-5,.86-7.58,1.19a2,2,0,0,1-1.47-.64C53,32.4,51.78,30.92,50.27,29.15Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M42.63,20.2c3.43,0,6.43-.55,9.08.18,2,.54,3.44,2.77,5.13,4.25l-.55.72c-2.34.35-4.66.79-7,1a2.9,2.9,0,0,1-2.09-.8C45.72,24,44.41,22.32,42.63,20.2Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M69.27,35.3c8.64-1.89,8.87-1.82,12.94,3.91-2.53.43-4.91.9-7.3,1.21a2.31,2.31,0,0,1-1.7-.63C71.9,38.45,70.72,37,69.27,35.3Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M76.22,43.12c8.94-1.64,8.94-1.64,12,2.73l-6.39,3.72Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M75.29,31.39c-2.74.41-5,.81-7.29,1.06a2.36,2.36,0,0,1-1.72-.57c-1.33-1.33-2.53-2.79-4.07-4.53,2.81-.46,5.22-.91,7.65-1.19.49-.06,1.17.49,1.59.92C72.65,28.33,73.75,29.65,75.29,31.39Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M43.25,53.63c-7.1.49-14.52-.81-15.64-2.81,3.83-.54,7.57-1.15,11.33-1.51.69-.06,1.59.84,2.21,1.48A26,26,0,0,1,43.25,53.63Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M91.41,37.56c-6.13,1.51-6.75,1.25-10.19-4.29,2.43-.4,4.76-.9,7.11-1.13C89.79,32,91.25,34.67,91.41,37.56Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M74.38,25.71c4.86-2,8.33.65,11.92,3.36C81,32,77.36,30.92,74.38,25.71Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M14.3,28.51l7.93-3.68,3.71,5A69.53,69.53,0,0,1,17,31C16.13,31.06,15.21,29.4,14.3,28.51Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M67.67,23.43c-3.76.18-8.14,3.51-10.82-2.53C60.6,21.74,64.68,19.66,67.67,23.43Z' })
	                  ),
	                  'juices': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'sumos-icon'
	                        ),
	                        _react2.default.createElement('path', { d: 'M65.35,88.81c-.21,3.27-2.38,4.64-5.58,4.63-7.75,0-15.49,0-23.24,0-4.44,0-5.69-1.39-6-5.87q-1.05-16.88-2.15-33.76c-.47-7.4-.94-14.8-1.43-22.57,12.84,0,25.18,0,37.52,0,1.33,0,2.66.12,4.36.2C67.68,50.86,66.57,69.84,65.35,88.81ZM64.9,35.43H39.73v4.43H35.5c-1.5-1.31.54-5.79-4.36-4.24.43,8,.84,16.11,1.31,24.2.5,8.67,1.14,17.34,1.54,26,.12,2.64.73,3.86,3.73,3.78,7.84-.21,15.68-.07,23.93-.07Z' }),
	                        _react2.default.createElement('path', { d: 'M50.76,29.83a24.16,24.16,0,0,0,2-3.4,15.09,15.09,0,0,1,16-9.94c6.31.57,11.65,5.55,13,12.19s-2.5,13.68-9.33,16.74a7.46,7.46,0,0,0-3,2.88C78.43,48.1,85.29,40,85,30.86a18,18,0,0,0-18.3-17.47c-9.06.09-16.86,7.2-17.1,15.59Z' }),
	                        _react2.default.createElement('path', { d: 'M33.61,29.5h4.52c-.63-3.14-.75-6.24-1.95-8.83a8.41,8.41,0,0,0-4.85-4.17A59.75,59.75,0,0,0,19.28,15C18.22,15,17.09,16.3,16,17a16.44,16.44,0,0,0,3,2.56c.9.45,2.12.25,3.2.37C31.17,20.85,31.17,20.85,33.61,29.5Z' }),
	                        _react2.default.createElement('path', { d: 'M66.16,17.14l-8.59,3.75L66.16,30Z' }),
	                        _react2.default.createElement('path', { d: 'M68.41,17.3c-.17,1.7-.3,2.49-.31,3.28,0,2.82,0,5.64,0,9.06L75.7,20.7Z' }),
	                        _react2.default.createElement('path', { d: 'M69.85,31.73h11.2L78.6,23.68Z' }),
	                        _react2.default.createElement('path', { d: 'M81,33.69H70.85l-.55.82,7.4,5.17-.49,1.19Z' }),
	                        _react2.default.createElement('path', { d: 'M62.72,29.13l-6.56-6.57-3,6.57Z' }),
	                        _react2.default.createElement('path', { d: 'M75.39,42.63l-5.24-4.76-.44,6.7Z' }),
	                        _react2.default.createElement('path', { d: 'M63.07,42.15c-.83,13.79-1.6,27.32-2.6,40.83-.07.91-1.9,2.38-3,2.42-6.34.24-12.7.17-19.05.13-2.41,0-3-1.46-3.15-3.73-.29-6.65-.85-13.28-1.26-19.92-.4-6.48-.76-13-1.15-19.74ZM45.34,65.48a2.53,2.53,0,0,0-.39,1.14C41.65,80,39.63,76.75,53.11,80.45c.95.26,2.45-1.09,3.52-1.92.42-.32.39-1.26.51-1.92.55-3,2.46-7.78,1.36-8.62-2.92-2.24-7.16-2.78-11.2-4.11A22.16,22.16,0,0,0,45.34,65.48ZM57.59,55.41C53,47.54,53,47.48,45,52.3c-1.33.8-3.38,3-3.15,3.39A22.35,22.35,0,0,0,47.15,62c1.48,1.11,3.86,1,5.94,1.46C57.7,63.29,59.91,59.4,57.59,55.41ZM40.7,59.27l-5.35,5.27,6.2,6.52C42.85,66.44,45.06,62.61,40.7,59.27Z' })
	                  ),
	                  'beers': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'cerveja-icon'
	                        ),
	                        _react2.default.createElement('path', { d: 'M29.14,44.22l.25-.09c2.44-.79,4.53-.35,6.93.8,9.15,4.4,18.28,4,27.16-1a1.63,1.63,0,0,1,2.61,1.44q0,19.22,0,38.44c0,2.18-.62,2.89-2.81,3.31a85.19,85.19,0,0,1-31.75,0,2.68,2.68,0,0,1-2.5-3q0-15.13.11-30.25C29.15,50.66,29.14,47.48,29.14,44.22Zm1.09,1.59c0,3.65,0,7.4,0,11.14.06,9.11.16,18.21.19,27.32a1.63,1.63,0,0,0,1.37,1.83c4.6,1.4,9.27,1.25,14.22.82-2-.52-3.81-.93-5.56-1.43a4.09,4.09,0,0,1-3.15-3.75,84.12,84.12,0,0,1-.8-9.2c.06-7.61.38-15.22.55-22.83,0-.59-.13-1.51-.51-1.73C34.63,46.88,33.07,44.75,30.23,45.81Z' }),
	                        _react2.default.createElement('path', { d: 'M22.69,43.4l3.94.79q0,4.15,0,8.3c0,5.24,0,10.47,0,15.71s0,10.29,0,15.44c0,3.43,1.53,5.24,4.88,5.85a89.08,89.08,0,0,0,32.07,0c3.4-.62,4.93-2.46,4.93-6q0-18.3,0-36.59c0-.71,0-1.42,0-2.11,4.1,0,8.07-.28,12,.07,4.65.42,7.71,4.21,7.75,8.9q0,6.72,0,13.43a8.71,8.71,0,0,1-9.07,9c-2.15,0-4.3,0-6.62,0,0,2.67,0,5.18,0,7.68a9.19,9.19,0,0,1-7.92,9.52,92.93,92.93,0,0,1-29.49.71c-1.68-.24-3.37-.46-5-.81a9,9,0,0,1-7.51-8.92c-.08-13.43,0-26.87,0-40.3A4.9,4.9,0,0,1,22.69,43.4Zm49.91,5.38V72.19H79c3.18,0,5.15-1.83,5.19-5,.06-4.47.05-8.95,0-13.42a4.76,4.76,0,0,0-4.66-5C77.28,48.68,75,48.78,72.61,48.78Z' }),
	                        _react2.default.createElement('path', { d: 'M41.31,5a13.58,13.58,0,0,1,8.42,3.42,2.63,2.63,0,0,0,2.5.62A14.68,14.68,0,0,1,68,16.13a2,2,0,0,0,2.08,1.1,11.72,11.72,0,0,1,4,22.75,11.39,11.39,0,0,1-9.41-.66,1.43,1.43,0,0,0-1.75.13,24.22,24.22,0,0,1-28.26-.15,1.84,1.84,0,0,0-2.1-.13A11.68,11.68,0,0,1,20.38,19.51a16,16,0,0,1,4-2.22,2.26,2.26,0,0,0,1.54-1.63C27.77,9.3,33.6,5,41.31,5ZM20.2,28.41a15.92,15.92,0,0,0,.38,2.26,7.59,7.59,0,0,0,10.81,4.59c1.72-.82,3.36-1.08,4.9.18a17.36,17.36,0,0,0,9.11,4.14c5.6.65,10.88,0,15.45-3.68a4.17,4.17,0,0,1,5.26-.41,7.44,7.44,0,0,0,7.37.32,7.68,7.68,0,0,0-3.85-14.55,4.58,4.58,0,0,1-4.87-2.67,10.69,10.69,0,0,0-12.41-5.43,4.64,4.64,0,0,1-4.55-1,13.09,13.09,0,0,0-3.46-2.25A10.73,10.73,0,0,0,29.78,17c-.62,2.19-1.65,3.55-4,4.09A7.6,7.6,0,0,0,20.2,28.41Z' })
	                  ),
	                  'sodas': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'refrigerantes-icon'
	                        ),
	                        _react2.default.createElement('path', { d: 'M33.35,42C34.73,37.52,36.66,35.32,41,36a54.35,54.35,0,0,0,7.82.07V34.42H35.14l-.08-1.55a17.14,17.14,0,0,1,3.41-.77c4-.09,7.92.09,11.87-.11a4.29,4.29,0,0,0,3.16-1.66c2.66-5.11,3.73-5.69,9.88-4.14-.44,1-.8,2-1.27,2.88s-1,1.62-1.68,2.73l5,.46c.92,3,1.67,5.38,2.33,7.74.52,1.86,1.33,3.75,1.34,5.64.12,13.36.08,26.73.07,40.09,0,5-2.68,7.59-7.68,7.59-7.3,0-14.61.16-21.9-.1-1.94-.07-3.84-1.42-5.75-2.18l.42-1.51h14.5l0-1.16H33V43.26H48.82L48.88,42Z' }),
	                        _react2.default.createElement('path', { d: 'M33.08,16.81,33.94,13c5,1.38,9.87,2.63,14.64,4.1a3.28,3.28,0,0,1,1.59,2.21C51,23,51.6,26.79,52.37,31l-3.68.18c-.25-.57-.53-.9-.52-1.21.24-8.12-4.44-11.39-11.81-12.11A17.69,17.69,0,0,1,33.08,16.81Z' })
	                  ),
	                  'water': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'agua-icon'
	                        ),
	                        _react2.default.createElement('path', { d: 'M65,60.08q0,12.73,0,25.46a9.73,9.73,0,0,1-1.44,5.28,9,9,0,0,1-4.06,3.58,9.14,9.14,0,0,1-3.72.76c-5,0-10.07,0-15.11,0a9,9,0,0,1-5.91-2,9.34,9.34,0,0,1-3-4.46,9.84,9.84,0,0,1-.45-3.12q0-8.88,0-17.75,0-13.55,0-27.1c0-2.11,0-4.23,0-6.34A8.16,8.16,0,0,1,32,31.1a28.89,28.89,0,0,1,3.81-6.21c1.6-2.09,3.26-4.14,4.9-6.2a9.86,9.86,0,0,1,1.18-1.3,1.52,1.52,0,0,1,.91-.32c1.21,0,2.42,0,3.64,0,2.26,0,4.52,0,6.78,0a1.76,1.76,0,0,1,1.5.69c1.54,1.87,3.13,3.7,4.62,5.62a49,49,0,0,1,4.17,6.16A10.83,10.83,0,0,1,65,35.75c-.05.7,0,1.42,0,2.13Q65,49,65,60.08ZM62.64,42c0-.12,0-.18,0-.24,0-2.51,0-5,0-7.54a4.42,4.42,0,0,0-.15-1A12.78,12.78,0,0,0,61,29.86a48.86,48.86,0,0,0-4.21-6c-1.15-1.45-2.37-2.83-3.56-4.23a.57.57,0,0,0-.38-.19H43.42a.48.48,0,0,0-.34.12c-1.1,1.29-2.23,2.57-3.28,3.9s-2.17,2.79-3.17,4.26a39.92,39.92,0,0,0-2.34,4,5.78,5.78,0,0,0-.72,2.33c-.09,2.51,0,5,0,7.54,0,.14,0,.28,0,.45Zm-29.1,32.6c0,.23,0,.41,0,.58,0,3.33,0,6.67,0,10a11.41,11.41,0,0,0,.21,2.07,6.71,6.71,0,0,0,2.6,4.11,6.47,6.47,0,0,0,4.09,1.33H55.8a6.43,6.43,0,0,0,3.92-1.25,6.93,6.93,0,0,0,2.93-5.74c.05-3.55,0-7.09,0-10.64v-.45Zm14.55-4.43a12,12,0,0,0,.41-24C41.94,46,36.8,51.48,36.67,58A11.76,11.76,0,0,0,48.09,70.22Z' }),
	                        _react2.default.createElement('path', { d: 'M54.3,14.56H42c0-.14,0-.28,0-.42,0-2,0-3.91,0-5.86A3.12,3.12,0,0,1,45.05,5h6.09a3.14,3.14,0,0,1,3.15,3.32q0,2.89,0,5.78Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M62.64,42H33.57c0-.17,0-.31,0-.45,0-2.51-.06-5,0-7.54a5.78,5.78,0,0,1,.72-2.33,39.92,39.92,0,0,1,2.34-4c1-1.47,2.07-2.88,3.17-4.26s2.18-2.61,3.28-3.9a.48.48,0,0,1,.34-.12H52.8a.57.57,0,0,1,.38.19c1.2,1.4,2.42,2.78,3.56,4.23a48.86,48.86,0,0,1,4.21,6,12.78,12.78,0,0,1,1.57,3.41,4.42,4.42,0,0,1,.15,1c0,2.51,0,5,0,7.54C62.66,41.87,62.65,41.93,62.64,42ZM60.33,39.6c0-.11,0-.17,0-.24,0-1.71,0-3.42,0-5.13a2.52,2.52,0,0,0-.27-1.11c-.65-1.21-1.31-2.42-2-3.56s-1.59-2.19-2.37-3.29a.54.54,0,0,0-.5-.27H41.1a.61.61,0,0,0-.44.14c-.88,1.19-1.76,2.39-2.59,3.61a28.39,28.39,0,0,0-1.51,2.49,4.07,4.07,0,0,0-.6,1.62c-.09,1.88-.06,3.77-.08,5.65,0,0,0,0,0,.09Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M33.54,74.65H62.67v.45c0,3.55,0,7.1,0,10.64a6.93,6.93,0,0,1-2.93,5.74,6.43,6.43,0,0,1-3.92,1.25H40.46a6.47,6.47,0,0,1-4.09-1.33,6.71,6.71,0,0,1-2.6-4.11,11.41,11.41,0,0,1-.21-2.07c0-3.33,0-6.67,0-10C33.54,75.06,33.54,74.88,33.54,74.65Zm2.35,2.44a.71.71,0,0,0,0,.12c0,2.88,0,5.76,0,8.63A4.32,4.32,0,0,0,39,90.11a7.89,7.89,0,0,0,2.16.21c4.92,0,9.84,0,14.76,0a4.12,4.12,0,0,0,2.64-.93,4.68,4.68,0,0,0,1.76-3.9c0-2.68,0-5.36,0-8,0-.12,0-.23,0-.37Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M48.09,70.22A11.76,11.76,0,0,1,36.67,58c.12-6.5,5.27-12,11.83-11.74a12,12,0,0,1-.41,24Zm10.11-12A10.1,10.1,0,1,0,48.08,68.79,10.34,10.34,0,0,0,58.21,58.23Z' }),
	                        _react2.default.createElement('path', { d: 'M60.33,39.6H35.91s0-.07,0-.09c0-1.88,0-3.77.08-5.65a4.07,4.07,0,0,1,.6-1.62,28.39,28.39,0,0,1,1.51-2.49c.84-1.23,1.71-2.42,2.59-3.61A.61.61,0,0,1,41.1,26H55.16a.54.54,0,0,1,.5.27c.78,1.1,1.63,2.16,2.37,3.29s1.4,2.35,2,3.56a2.52,2.52,0,0,1,.27,1.11c0,1.71,0,3.42,0,5.13C60.35,39.43,60.34,39.49,60.33,39.6Z' }),
	                        _react2.default.createElement('path', { d: 'M35.9,77.09H60.33c0,.14,0,.25,0,.37,0,2.68,0,5.36,0,8a4.68,4.68,0,0,1-1.76,3.9,4.12,4.12,0,0,1-2.64.93c-4.92,0-9.84,0-14.76,0A7.89,7.89,0,0,1,39,90.11a4.32,4.32,0,0,1-3.17-4.26c-.06-2.88,0-5.76,0-8.63A.71.71,0,0,1,35.9,77.09Z' }),
	                        _react2.default.createElement('path', { d: 'M58.21,58.23a10.1,10.1,0,1,1-10.1-10.57A10.32,10.32,0,0,1,58.21,58.23Zm-2.85,4.83-.49-.13a11.84,11.84,0,0,0-6.79.4,9.69,9.69,0,0,1-6.1.08l-1-.28c1.83,2.81,4.33,4.29,7.57,4.12A8.44,8.44,0,0,0,55.35,63.07ZM48.48,50.9a3.32,3.32,0,0,0-.28.28,14.48,14.48,0,0,0-2,3.45,5.53,5.53,0,0,0-.2,4.24,2.59,2.59,0,0,0,4.14,1,3.39,3.39,0,0,0,1-2.9,8,8,0,0,0-1.08-3.43C49.6,52.63,49,51.79,48.48,50.9Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M55.35,63.07a8.44,8.44,0,0,1-6.77,4.19c-3.24.18-5.74-1.3-7.57-4.12l1,.28a9.69,9.69,0,0,0,6.1-.08,11.84,11.84,0,0,1,6.79-.4Z' })
	                  ),
	                  'hot-drinks': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'hot-drinks-icon'
	                        ),
	                        _react2.default.createElement('path', { d: 'M48.28,48.59c6.68,0,13.38-.35,20,.11a68.94,68.94,0,0,1,15.16,2.76c6.46,2,8.61,8.56,5.24,14.5s-9,7.82-15.1,9.32a11.47,11.47,0,0,0-5.52,3.21c-3.59,4-7.52,6.85-13.15,6.69-6-.18-12,.16-17.83-.57-2.67-.33-5.56-2.2-7.55-4.18-7.71-7.63-11-17.34-12.23-27.92-.41-3.61,1.87-3.93,4.51-3.93Zm26.3,20.26.75,1.1c2.59-1.74,5.58-3.12,7.62-5.36,1.22-1.35,1.86-4.47,1.12-6s-3.51-2.25-5.48-3.37' }),
	                        _react2.default.createElement('path', { d: 'M75.15,83.53C76,82,76,82,75.18,81.25s-1.54-1.36-2.32-2L71.58,78.1c3.88-.83,10.68,1.78,11.3,4.74a5.83,5.83,0,0,1-2.25,5c-4.56,2.74-10,3.94-15.24,4.87A102,102,0,0,1,24,91.54a34.72,34.72,0,0,1-9.42-3.76c-3.4-2-3.42-4.91-.07-7a32.87,32.87,0,0,1,5.65-2.66.92.92,0,0,1,1.08,1.38l-1.32,1.87a1.58,1.58,0,0,0,.34,2.17,14.63,14.63,0,0,0,5.05,2.87,99.74,99.74,0,0,0,45.12.06' }),
	                        _react2.default.createElement('path', { d: 'M51.71,44.43c7.11-6.83,4.79-12.39-1.18-18-3.23-3-2.51-7.06-.3-10.57A20.28,20.28,0,0,1,55.8,10a10.73,10.73,0,0,1-.56,2.19C52.89,17,54.12,20.62,57.89,24.3,64.37,30.64,61.4,41.34,51.71,44.43Z' }),
	                        _react2.default.createElement('path', { d: 'M43.65,16.26c-3.05,5.74-.85,9.38,3.68,12.83,3.59,2.73,3.9,6,1.14,9.69-1.83,2.47-4.42,4.38-7,6.83-.46-1.23-.68-1.54-.61-1.66,4.67-7.15,4.67-7.15-1.43-13.36-3.53-3.59-3.5-6.43.26-10.7A50.36,50.36,0,0,1,43.65,16.26Z' })
	                  ),
	                  'sangria': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'sangria-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M35.76,5.18c.89,3.35,1.85,6.53,2.52,9.77.29,1.39.85,1.61,2.09,1.61,10.75,0,21.51-.06,32.26,0,1.45,0,2-.39,2.24-1.8a10.4,10.4,0,0,1,.81-2.49C77,9,78.57,8.11,82,8.61c-.73-1.89-1.85-3.2-4-3.31-.78,0-1.56-.12-2.34-.13h-40Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M76.19,91.86h-34v2.66h34Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2',
	                              d: 'M16.15,41.42a22.65,22.65,0,0,1,3-11.08,14,14,0,0,1,5.48-5.74c4.16-2.22,9.35-.49,11,3.63.62,1.6,1.63,2.06,3.13,1.44a2.63,2.63,0,0,0,1.63-3.49c-2-4-6.06-8.24-12.26-7.62a15.82,15.82,0,0,0-9.72,4.88c-6.86,6.81-8.57,15.11-6.55,24.29C14.1,58.1,20.07,66.28,27.66,73.41a2.5,2.5,0,0,0,3.52,0,3.48,3.48,0,0,0-.2-5.62,41.08,41.08,0,0,1-8.24-8.38C18.84,54,16.35,48.09,16.15,41.42Z' }),
	                        _react2.default.createElement('path', { d: 'M76.61,95H41.87c-.09-.12-.21-.2-.2-.26.34-2-.8-3.06-2.33-4.17-5.08-3.69-7.67-8.86-8.37-15,0-.31-.07-.62-.13-1.1-2,.5-3.12-.68-4.34-1.87-6.07-6-11-12.71-13.68-20.92-2.38-7.31-2.85-14.6.67-21.72,2.41-4.87,5.9-8.73,11-10.85S34.32,18,38.24,21.89c.19.19.29.46.61.59-.38-6-2-11.69-3.8-17.47H76.41c4.11,0,5.47.94,6.7,4.72a2.17,2.17,0,0,1-.52-.07c-2.71-1.1-4.57-.66-5.69,2a25.59,25.59,0,0,0-2.12,8c-.6,9.08-.38,18.15,3.16,26.75,1.42,3.45,3.31,6.71,4.8,10.14,2.7,6.22,4,12.68,2.65,19.48a28.76,28.76,0,0,1-7.17,13.87,4.64,4.64,0,0,0-1.51,4A4.49,4.49,0,0,1,76.61,95ZM64.81,83.49l-1.06.11a5.75,5.75,0,0,0-1.21.23,14.55,14.55,0,0,0-1.51.84,7.37,7.37,0,0,0,1.11,1.48,7.63,7.63,0,0,0,6.63,1.62A8.2,8.2,0,0,0,72.3,73.32c-1.14-1-1.76-.72-2.09.77-.19.85-.29,1.73-.4,2.6C69.44,79.63,68.27,82,65.24,83,65.07,83.1,65,83.34,64.81,83.49ZM39.57,30.09c-2.28.52-3.46.32-4.2-2a5.5,5.5,0,0,0-3.5-3.34A8,8,0,0,0,22.56,27a20.35,20.35,0,0,0-5.33,17c1.25,9.38,6.31,16.6,13.43,22.54.09.07.25.07.33.09.32-1.19.59-2.35,1-3.48,1.91-5.89,4-11.73,5.74-17.66A51.23,51.23,0,0,0,39.57,30.09ZM35.77,5.41c.89,3.35,1.86,6.53,2.54,9.77.29,1.39.86,1.61,2.1,1.61,10.82,0,21.63-.06,32.45,0,1.45,0,2.06-.39,2.25-1.8a10.35,10.35,0,0,1,.82-2.49c1.37-3.29,2.89-4.17,6.38-3.67-.74-1.89-1.86-3.2-4-3.31-.78,0-1.57-.12-2.35-.13H35.77Zm-19.23,36a22.65,22.65,0,0,1,3-11.08A14,14,0,0,1,25,24.6c4.16-2.22,9.35-.49,11,3.63.62,1.6,1.63,2.06,3.13,1.44a2.63,2.63,0,0,0,1.63-3.49c-2-4-6.06-8.24-12.26-7.62a15.82,15.82,0,0,0-9.72,4.88c-6.86,6.81-8.57,15.11-6.55,24.29C14.49,58.1,20.46,66.28,28,73.41a2.5,2.5,0,0,0,3.52,0,3.48,3.48,0,0,0-.2-5.62,41.08,41.08,0,0,1-8.24-8.38C19.23,54,16.73,48.09,16.53,41.42ZM48,37h0c-.6,0-1.21,0-1.8,0-3.1.23-4.7,2.06-4.13,5.1A14.88,14.88,0,0,0,44,47c1.53,2.52,4.07,3.18,6.31,1.84a8,8,0,0,0,3.2-4.56c1.7-4.89,0-7.29-5.17-7.26ZM76.19,91.86h-34v2.66h34Zm-3.31-64.5a7.87,7.87,0,1,0-7.81,7.91A7.92,7.92,0,0,0,72.88,27.36ZM43.44,85.56A7.46,7.46,0,1,0,36,78,7.45,7.45,0,0,0,43.44,85.56ZM72.75,68.62a6.44,6.44,0,1,0-6.36-6.49A6.46,6.46,0,0,0,72.75,68.62ZM58.7,75c2.74,0,5.61-2.14,5.54-4.07s-3.17-4.85-5-4.83-3.95,3-3.92,5.68A3,3,0,0,0,58.7,75Zm-.59-33.29a7.88,7.88,0,0,0,1,7.89,8.24,8.24,0,0,0,9.25,2.67c2.72-.92,5-3.72,5.14-6.21-4.46,4.59-6.73,5.64-10.28,4.25C59.51,48.85,58.12,45.7,58.11,41.72Zm-4,18.82a6.66,6.66,0,0,0-8.3-5c-3.57.88-6,4.88-4.88,8.26a4,4,0,0,0,.8,1.06l.25-.23c-1.08-.92-.28-4,1.54-5.88C46.51,55.61,50.28,56.26,54.12,60.54Z' }),
	                        _react2.default.createElement('path', { d: 'M63.75,83.6l1.06-.11a6.38,6.38,0,0,0,5.31-5.79c.1-.73.17-1.47.32-2.19s.37-1.24.6-2a8,8,0,0,1,1.54,9.27,7.23,7.23,0,0,1-8.41,3.14,9.94,9.94,0,0,1-2.08-1.16Z' }),
	                        _react2.default.createElement('path', { d: 'M65.45,26.21V20.59l4,1.61Z' }),
	                        _react2.default.createElement('path', { d: 'M65.46,34.3V28.94l3.71,3.77Z' }),
	                        _react2.default.createElement('path', { d: 'M58.2,26.88,59.77,23l3.79,3.85Z' }),
	                        _react2.default.createElement('path', { d: 'M63.91,27.9l-4.15,3.82L58.15,27.9Z' }),
	                        _react2.default.createElement('path', { d: 'M66.2,27.84h5.64l-1.61,4Z' }),
	                        _react2.default.createElement('path', { d: 'M70.33,23.24l1.55,3.68H66.46Z' }),
	                        _react2.default.createElement('path', { d: 'M64.55,34.23l-3.94-1.59,3.94-3.77Z' }),
	                        _react2.default.createElement('path', { d: 'M64.52,26.28l-4-4.05,4-1.68Z' }),
	                        _react2.default.createElement('path', { d: 'M43.93,79.42l3.66,3.65-3.66,1.59Z' }),
	                        _react2.default.createElement('path', { d: 'M44,71.66l3.68,1.5L44,76.67Z' }),
	                        _react2.default.createElement('path', { d: 'M43.09,71.55V77l-3.46-3.94Z' }),
	                        _react2.default.createElement('path', { d: 'M42.13,77.67H37l1.47-3.85Z' }),
	                        _react2.default.createElement('path', { d: 'M43.09,79.47V84.6L39.3,83.11Z' }),
	                        _react2.default.createElement('path', { d: 'M44.61,77.63,48.4,74,50,77.63Z' }),
	                        _react2.default.createElement('path', { d: 'M45,78.6h5L48.5,82.2Z' }),
	                        _react2.default.createElement('path', { d: 'M38.45,82,37,78.64h5.17Z' }),
	                        _react2.default.createElement('path', { d: 'M71.64,61.81H67.22l1.27-3.2Z' }),
	                        _react2.default.createElement('path', { d: 'M69.4,57.85l3-1.28v4.64Z' }),
	                        _react2.default.createElement('path', { d: 'M72.4,67.77l-3.18-1.29,3.18-3.33Z' }),
	                        _react2.default.createElement('path', { d: 'M73.69,61.82l3.38-3.28,1.33,3.28Z' }),
	                        _react2.default.createElement('path', { d: 'M78.36,62.62l-1.25,3.16L74,62.62Z' }),
	                        _react2.default.createElement('path', { d: 'M73.21,67.76V63.2l3.15,3.27Z' }),
	                        _react2.default.createElement('path', { d: 'M67.16,62.57h4.11l-2.84,2.88Z' }),
	                        _react2.default.createElement('path', { d: 'M73.2,60.8V56.6l3.12,1.25Z' })
	                  ),
	                  'other-drinks': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'other-beverages-icon'
	                        ),
	                        _react2.default.createElement('path', { d: 'M6.72,18.07H49c-.93,7.29-2,14.29-2.67,21.34q-2,21.61-3.55,43.26c-.51,7.14-.83,7.67-7.83,7.67-5.37,0-10.73,0-16.1,0-4.33,0-5.26-.89-5.62-5.17-1.44-16.9-2.79-33.81-4.32-50.7C8.44,29,7.49,23.64,6.72,18.07Zm3.93,3.4c0,.67,0,1.14,0,1.61,1.68,15.39,3.42,30.78,5,46.18.3,2.94,2.12,4.53,4.49,4.72A96.37,96.37,0,0,0,35,74c3.54-.26,5.12-2.66,5.41-6.41.8-10.33,2-20.64,3-30.95.53-5,1.2-10.05,1.85-15.42H12.61C12,21.28,11.42,21.39,10.65,21.47Z' }),
	                        _react2.default.createElement('path', { d: 'M19.28,34h22c-.85,8.29-1.71,16.34-2.5,24.39-.31,3.11-.58,6.22-.69,9.34-.08,2.38-1.17,4-3.46,4.11A120.93,120.93,0,0,1,21.23,72c-1.13-.05-3-1.54-3.14-2.53C16.82,57.77,15.81,46,14.74,34.22l1.12-.52a11.25,11.25,0,0,1,1.33,3.12c.86,9,1.6,17.91,2.35,26.87.08,1,0,2,0,3l1.14,0Z' }),
	                        _react2.default.createElement('path', { d: 'M58.38,90.42c-.23-2.89.9-4,3.68-3.86,10.43.58,9.41-1.57,9.36-9.65,0-4.87.19-9.76-.11-14.61-.11-1.78-1.39-3.5-2.16-5.23a1.65,1.65,0,0,0-.53-.52c-15-11.67-17-26.66-11.4-43.73.63-1.9,1.4-2.55,3.37-2.54,9.25.09,18.49,0,27.74.1,1,0,2.64.72,2.87,1.45,2.6,8.52,4.74,17.09,2.29,26.1-2,7.33-6.51,12.88-12.17,17.57a9.67,9.67,0,0,0-3.94,8.69c.3,5.61.05,11.24.09,16.86,0,4.35,1.17,5.45,5.61,5.55a30.55,30.55,0,0,0,3.75,0c2.76-.28,3.94.88,3.65,3.84ZM60.16,14c-.74,6.15-1.69,11.91-2,17.71a21.66,21.66,0,0,0,1.54,8c2.36,6.78,8.09,11,14.53,11.08s12.12-3.87,14.86-10.64c3.36-8.28,1.62-16.47-.67-24.59a3.17,3.17,0,0,0-2.48-1.51C77.69,14,69.45,14,60.16,14Z' }),
	                        _react2.default.createElement('path', { d: 'M74.5,22c3.74,0,7.49-.15,11.21.1.95.06,2.61,1.43,2.58,2.14C88.05,29.5,88.26,35,86.78,40c-1.67,5.64-6.37,8.88-12.56,8.81-6-.07-10.56-3.37-12.14-8.86-1.43-5-1.24-10.48-1.46-15.76,0-.69,1.69-2,2.66-2.09C67,21.82,70.76,22,74.5,22Z' })
	                  ),
	                  'other-dishes': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'other-food-icon'
	                        ),
	                        _react2.default.createElement('path', { d: 'M50.33,37c6.07-5.83,4.09-10.58-1-15.37-2.76-2.6-2.14-6-.25-9a17.32,17.32,0,0,1,4.75-5,9.16,9.16,0,0,1-.48,1.87c-2,4.07-1,7.19,2.26,10.34C61.14,25.22,58.6,34.36,50.33,37Z' }),
	                        _react2.default.createElement('path', { d: 'M43.45,12.95c-2.61,4.9-.73,8,3.14,11,3.06,2.33,3.33,5.09,1,8.27C46,34.28,43.79,35.91,41.62,38c-.39-1-.58-1.32-.52-1.42,4-6.1,4-6.1-1.22-11.41-3-3.07-3-5.49.22-9.13A43,43,0,0,1,43.45,12.95Z' }),
	                        _react2.default.createElement('path', { d: 'M87,76.86A35,35,0,0,0,72.15,54.53a47.77,47.77,0,0,0-5.32-2.85L55.42,47.6c.16-4-2.19-7.31-5.76-7.52a8.82,8.82,0,0,0-4.35,1.19c-2.67,1.41-2.73,4.14-2.67,6.7C20.2,51.72,10.1,70.13,11.26,79.71c.32,0,.67.08,1,.08q12.55,0,25.09,0a9.73,9.73,0,0,0,1.82-.35,11.19,11.19,0,0,0,2,.35q21.91,0,43.82,0c.68,0,1.37-.06,2.11-.1,0-.57.08-1,.05-1.39A10.15,10.15,0,0,0,87,76.86ZM49,43.7c1.65-.13,2.16,1.11,2.28,2.42.17,1.87-4.23,2.06-4.68.14C46.39,44.72,47.52,43.82,49,43.7ZM83.4,77.23c-1.46.36-1.71-.85-1.95-1.9-1.41-6.25-5.32-10.94-9.92-15C69.15,58.25,66,57,63.18,55.42c-1.74-2.24,1.68-4.13,5.19-1.82a43.94,43.94,0,0,1,11.19,9.71,29.32,29.32,0,0,1,5.24,11.13C85.17,75.83,84.81,76.88,83.4,77.23Z' }),
	                        _react2.default.createElement('path', { d: 'M94.39,81.62q-27.71,0-55.42,0a13.14,13.14,0,0,0-2.41.45,5.34,5.34,0,0,0-1.47-.45q-15.92,0-31.83,0a11,11,0,0,0-1.8.32c2.82,4.56,3.4,6,8.7,5.92,6.18-.11,12.37,0,18.55,0a17.26,17.26,0,0,0,2.45-.35,13.26,13.26,0,0,0,2.18.36c18.05,0,36.1-.12,54.15.11,4.62.06,7-2.35,9.51-6A22.28,22.28,0,0,0,94.39,81.62Z' })
	                  ),
	                  'body-1': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'leve-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M42.85,76.13l4.45-.21c-2.52,2.35-5.31,3.93-8.44,4-8.47.24-12.9,5.19-15.61,12.48A11.82,11.82,0,0,1,22.44,94c-.08.14-.21.24-.53.23C29,77.72,38.51,62.6,47.73,47.24c-2.41,3.61-4.86,7.19-7.21,10.84s-4.69,7.41-7,11.16S29,76.92,26.64,81C23.57,76.07,24,71,25,65.61l1.67,1.75c.08-.29.17-.44.14-.55a8.41,8.41,0,0,1,.91-7.31c3.51-5.74,7.2-11.36,10.82-17l.73.18.49,4.92,1.16-8.67,1,1.62c3.31-7.7,6.89-15.2,13.67-20.81l.78,1.93c.2-.18.34-.25.4-.36,2.74-5.4,7.4-8.87,12.35-11.91,2.14-1.31,4.61,0,5.86,2.42,1.68,3.32,1.31,6.83.19,10.11-1.32,3.89-3.21,7.59-4.86,11.36-.42,1-1.35,1.55-.78,3.06.27.72-1.22,2.54-2.31,3.25-2.09,1.37-4.46,2.3-6.62,3.79l7.91-2.64a15.16,15.16,0,0,1-.76,2C64.07,49.29,60.5,56,56.56,62.44A69.78,69.78,0,0,1,48.71,73C47.31,74.5,44.87,75.09,42.85,76.13Z' })
	                  ),
	                  'body-2': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'balanca-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M45.09,32.52,24.93,36.88c12.58-11,31-11.42,47-1-2.63-.36-5.27-.64-7.88-1.11-3.12-.56-6.21-1.27-10-2.06V77.88L74.75,92.09H24.82c5-4,20.55-14.14,20.55-14.14S45.09,45,45.09,32.52Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M37.85,66c-10,7.81-19.54,8.08-32.26.63,1.91-3.47,3.82-7,5.76-10.48C13.2,52.81,17.69,45,21.5,42.6,18.91,47.94,13.7,57.75,10.66,64H32.5c-2.92-6.14-8.35-15.84-11-21.41C22.07,42.32,33.89,59.3,37.85,66Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M49.14,26.63c-3.48-5-7.34-8.17-6.87-10.44.64-3.11,4.56-5.55,7.08-8.28,2.59,2.75,6.63,5.21,7.28,8.36C57.09,18.49,52.94,21.66,49.14,26.63Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M94.41,64.92c-10,7.81-19.54,8.08-32.26.63,1.91-3.47,3.82-7,5.76-10.48,1.85-3.34,6.33-11.13,10.15-13.55-2.59,5.34-7.8,15.15-10.84,21.41H89.06c-2.92-6.14-8.35-15.84-11-21.41C78.63,41.24,90.45,58.21,94.41,64.92Z' })
	                  ),
	                  'body-3': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'peso-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M70.73,42.28H60.25l.67-.67a15.33,15.33,0,0,0,4.21-14.36C63.46,18.92,56.64,14,47.9,14.68S32.42,22.92,33.82,33a15.19,15.19,0,0,0,5,9.27H28.31L14.17,88.69l3.46,3.4H82.28l2.89-2.55Zm-21.24-20a8.67,8.67,0,0,1,8.25,8.54,8.72,8.72,0,0,1-8.49,8.33,8.76,8.76,0,0,1-8.32-8.4A8.66,8.66,0,0,1,49.5,22.26Z' })
	                  ),
	                  'sweetness-1': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'seco-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M16.91,95.45c1.7-.61,3.38-1.31,5.11-1.81a90.3,90.3,0,0,1,17.74-3,2.09,2.09,0,0,0,.28,0L37.89,65.62c-1.37.11-2.87.24-4.36.33-3.4.22-6.6-.3-9.18-2.78A11.33,11.33,0,0,1,21,56.29c-.58-4.43-1-8.89-1.35-13.35a78.58,78.58,0,0,1-.16-7.88,17.31,17.31,0,0,1,.67-3.7,2.43,2.43,0,0,1,2.09-1.93,11.06,11.06,0,0,1,2.33-.14A2,2,0,0,1,26.47,31c.64,2.72,1.27,5.44,1.84,8.17.71,3.39,1.34,6.8,2,10.19.5,2.43,1.61,3.31,4.11,3.22,1.14,0,2.27-.15,3.57-.25,0-1.64-.05-3.21,0-4.77.23-5.68.42-11.35.77-17,.27-4.41.75-8.81,1.18-13.2a11.49,11.49,0,0,1,.62-2.52,6.77,6.77,0,0,1,5.53-4.58,23.79,23.79,0,0,1,7.77-.14,5.93,5.93,0,0,1,5.29,4.92,68.56,68.56,0,0,1,1.36,8.42c.5,4.87.82,9.75,1.24,14.63a.89.89,0,0,0,.52.66,32.33,32.33,0,0,0,3.26.23,2.63,2.63,0,0,0,2.75-1.81c.54-1.55.93-3.15,1.34-4.75C70.46,29.26,71.23,26,72,22.8c.48-1.9,1.17-2.55,2.69-2.55,2.4,0,3.61.68,4,2.64a29.94,29.94,0,0,1,.6,6.4c-.2,4.27-.58,8.54-1.12,12.78a16.27,16.27,0,0,1-1.63,5c-1.72,3.51-4.76,5.17-8.59,5.35-1.81.08-3.62-.13-5.58-.21a222.25,222.25,0,0,1-2.51,38.34c1.83.2,3.58.35,5.31.58a74.24,74.24,0,0,1,17.19,4c.25.1.49.24.74.36Z' })
	                  ),
	                  'sweetness-2': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'meio-seco-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M68.29,30a6.1,6.1,0,0,0,.82.05,28.63,28.63,0,0,1,6,1A30.54,30.54,0,0,1,81.93,34a35.58,35.58,0,0,1,4.25,2.83,4.3,4.3,0,0,1,1.73,3.91,4.39,4.39,0,0,1-7.08,3,26.93,26.93,0,0,0-4.92-3A20.27,20.27,0,0,0,70.53,39a21,21,0,0,0-4.08-.25,33.26,33.26,0,0,0-9,1.74c-2.36.75-4.66,1.66-6.95,2.58-2.47,1-4.92,2-7.42,3a59.81,59.81,0,0,1-6.87,2.15,36.43,36.43,0,0,1-4.7.82,28,28,0,0,1-4.61.11,24.61,24.61,0,0,1-8.81-2.2,25.9,25.9,0,0,1-4.46-2.57,4.38,4.38,0,0,1,1.26-7.78,4.16,4.16,0,0,1,3.72.57,19.74,19.74,0,0,0,4.09,2.21,15.89,15.89,0,0,0,4.36,1,19.81,19.81,0,0,0,4.56-.18,38.59,38.59,0,0,0,7.08-1.87c2.39-.84,4.74-1.81,7.08-2.76C48,34.67,50.14,33.8,52.33,33a57.39,57.39,0,0,1,7.55-2.21,36.35,36.35,0,0,1,4.56-.68c.52,0,1-.08,1.55-.1,0,0,.1,0,.14,0Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M83.64,78.62a4.38,4.38,0,0,1-2.71-.87,28.41,28.41,0,0,0-4.55-2.88,20.14,20.14,0,0,0-9.68-2.15,28.17,28.17,0,0,0-5.91.82,57.54,57.54,0,0,0-7.07,2.26c-2.68,1-5.32,2.14-8,3.2-2.36.94-4.74,1.83-7.18,2.54a44.64,44.64,0,0,1-5.09,1.19,29.18,29.18,0,0,1-6.26.37A24.3,24.3,0,0,1,18,80.84a27.65,27.65,0,0,1-4.38-2.54,4.38,4.38,0,0,1,1.78-7.88,4.28,4.28,0,0,1,3.26.71,19.85,19.85,0,0,0,3.58,2,15.79,15.79,0,0,0,4.39,1.14,18.9,18.9,0,0,0,4.15,0,33.75,33.75,0,0,0,6.88-1.62c2-.66,4-1.44,5.93-2.23,2.43-1,4.85-2,7.3-2.91A68.43,68.43,0,0,1,58,65.19a42.34,42.34,0,0,1,4.25-.87,33.19,33.19,0,0,1,5.25-.38,29,29,0,0,1,7.3,1,30.56,30.56,0,0,1,7.19,3,35.37,35.37,0,0,1,4.2,2.81,4.28,4.28,0,0,1,1.72,3.92,4.36,4.36,0,0,1-3.76,3.92Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M87.93,57a4.45,4.45,0,0,1-3.71,4.62A4.21,4.21,0,0,1,81,60.8a32.13,32.13,0,0,0-3.6-2.38,21.2,21.2,0,0,0-6-2.26,20.1,20.1,0,0,0-3.26-.4,24.86,24.86,0,0,0-5.4.4,44.81,44.81,0,0,0-7.09,2c-2.43.86-4.8,1.84-7.19,2.81-2.88,1.17-5.76,2.33-8.72,3.28a45.38,45.38,0,0,1-5.55,1.42q-1.58.29-3.19.43a28.47,28.47,0,0,1-3.44.09A24.65,24.65,0,0,1,23,65.56a25.53,25.53,0,0,1-8-3.35,11.9,11.9,0,0,1-1.61-1.1,4.38,4.38,0,0,1,2.09-7.67,4.15,4.15,0,0,1,3.21.71,19.32,19.32,0,0,0,4,2.19,15.83,15.83,0,0,0,4,1,18.9,18.9,0,0,0,4.26,0A31.88,31.88,0,0,0,36.56,56c2.06-.63,4.07-1.39,6.06-2.19,2.87-1.14,5.71-2.35,8.61-3.43a62.14,62.14,0,0,1,8.09-2.49,38.58,38.58,0,0,1,4.5-.75A32.59,32.59,0,0,1,67.75,47a28.93,28.93,0,0,1,11.75,2.7,34.32,34.32,0,0,1,6.77,4.16A4.14,4.14,0,0,1,87.93,57Z' })
	                  ),
	                  'sweetness-3': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'doce-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M11.21,54.85a8.87,8.87,0,0,1,1-.85c5.61-3.38,11.22-6.74,16.82-10.12a1.06,1.06,0,0,0,.41-.77c0-2,0-4,0-5.94a1.37,1.37,0,0,1,.73-1.31c5.88-3.51,11.76-7,17.62-10.56a2,2,0,0,1,2.36,0c5.83,3.54,11.7,7,17.56,10.52a1.37,1.37,0,0,1,.75,1.3c0,2,0,4,0,5.94a1.13,1.13,0,0,0,.45.82Q77.47,49,86,54.11a1.43,1.43,0,0,1,.79,1.35q0,10.17,0,20.34A1.46,1.46,0,0,1,86,77.17L68,88a1.44,1.44,0,0,1-1.63-.09c-5.56-3.35-11.14-6.68-16.69-10a1.19,1.19,0,0,0-1.43,0c-5.56,3.36-11.13,6.69-16.69,10a1.46,1.46,0,0,1-1.75,0L12.17,76.09a10.12,10.12,0,0,1-1-.83ZM33.13,37a4,4,0,0,0,.31.25Q41,41.76,48.51,46.29a.92.92,0,0,0,1.1-.1l14.55-8.74c.21-.12.4-.27.65-.44-.16-.12-.25-.2-.35-.26-5-3-10-6-15-9a1.19,1.19,0,0,0-1,.06c-2.5,1.46-5,3-7.45,4.45ZM50.25,66.48a3.35,3.35,0,0,0,.32-.14q7.53-4.52,15.07-9c.43-.25.42-.57.42-.95q0-8.22,0-16.44c0-.21,0-.42-.05-.69l-.41.22q-7.43,4.46-14.87,8.91a1,1,0,0,0-.52,1c0,5.51,0,11,0,16.52C50.22,66,50.24,66.22,50.25,66.48ZM68.5,84.75a1.85,1.85,0,0,0,.27-.08q7.57-4.54,15.13-9.1a1.14,1.14,0,0,0,.42-.84c0-5.54,0-11.07,0-16.61a5.25,5.25,0,0,0-.06-.56,1.21,1.21,0,0,0-.21.06Q76.5,62.17,68.92,66.7c-.43.25-.42.56-.42.95q0,6.21,0,12.42C68.5,81.61,68.5,83.15,68.5,84.75ZM32,39.2a3.45,3.45,0,0,0,0,.35c0,5.28,0,10.56,0,15.85a1.19,1.19,0,0,0,.51.8Q39.79,61.13,47.15,66c.17.12.37.21.58.33,0-.17,0-.25,0-.32,0-5.61,0-11.22,0-16.84a1.13,1.13,0,0,0-.5-.79c-3-1.85-6.08-3.67-9.13-5.5ZM13.69,57.49c0,.22,0,.32,0,.42,0,5.26,0,10.51,0,15.77a1.19,1.19,0,0,0,.5.81q7.33,4.93,14.69,9.81c.18.12.37.21.58.33a1.57,1.57,0,0,0,0-.23c0-5.66,0-11.33,0-17a1.06,1.06,0,0,0-.49-.72c-3-1.85-6.08-3.67-9.13-5.5ZM31.93,84.73a1.12,1.12,0,0,0,.28-.06q7.6-4.55,15.2-9.13a.9.9,0,0,0,.36-.65c0-1.7,0-3.4,0-5.1a.86.86,0,0,0-.31-.61q-4.07-2.75-8.17-5.45a.88.88,0,0,0-.73,0c-2,1-4,2-6,3a1,1,0,0,0-.64,1c0,5.43,0,10.86,0,16.3C31.93,84.25,31.93,84.47,31.93,84.73Zm28.24-21.3c-3.19,1.91-6.39,3.82-9.57,5.77a1,1,0,0,0-.37.72c0,1.6,0,3.2,0,4.8a1,1,0,0,0,.54,1Q58.1,80,65.43,84.46c.18.11.37.19.63.32,0-5.88,0-11.64,0-17.4a1,1,0,0,0-.45-.67C63.8,65.6,62,64.52,60.17,63.43ZM29.49,46.48,14.82,55.29l.63.4c4.76,2.86,9.53,5.7,14.27,8.6a1.82,1.82,0,0,0,2.12.08c1.53-.86,3.14-1.6,4.8-2.43-2.12-1.42-4.13-2.79-6.18-4.1a1.9,1.9,0,0,1-1-1.81c0-2.87,0-5.74,0-8.6C29.49,47.16,29.49,46.89,29.49,46.48ZM62.54,62c1.46.88,2.81,1.66,4.13,2.5a1,1,0,0,0,1.24,0q7.26-4.39,14.54-8.74c.21-.13.41-.27.71-.47L68.5,46.49c0,3.39-.1,6.61,0,9.83a3,3,0,0,1-1.85,3.24C65.3,60.24,64,61.13,62.54,62Z' })
	                  ),
	                  'vodka': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'vodka-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M48.3,65.47c0,7.82,0,15.64,0,23.46a15.38,15.38,0,0,1-.65,4.44,5.05,5.05,0,0,1-5.1,3.74c-4.73.06-9.47.07-14.2,0A5.21,5.21,0,0,1,23,92.79a17.18,17.18,0,0,1-.49-4.27c0-15.23,0-30.46-.06-45.68,0-4.35,1.17-8.15,4.28-11.18a11.38,11.38,0,0,0,3.49-9.23c-.21-5.78.07-11.58.06-17.38,0-1.5.5-2.11,2-2,2.05.09,4.12.1,6.17,0,1.52-.07,2,.48,2,2,0,6.34.17,12.69.12,19A8.13,8.13,0,0,0,43,30.39c4.11,3.92,5.59,8.65,5.35,14.3C48.07,51.6,48.3,58.54,48.3,65.47ZM46.61,44.81c0-1-.05-1.85,0-2.66.38-5.25-2.82-8.84-6.23-11.93-1.26-1.14-4.12-.53-6.25-.68a13.4,13.4,0,0,0-2.46,0,2.34,2.34,0,0,0-1.42.58A65.54,65.54,0,0,0,26,35.41c-2,2.85-2,6.09-1.6,9.4ZM24.29,79.5c0,3.65-.06,7.19,0,10.73,0,2.08,1.84,3,3.56,1.75a19.89,19.89,0,0,0,2.91-2.88c3.35-3.64,5.91-3.64,9.3,0a19.21,19.21,0,0,0,3.09,3c1.52,1,3.3.24,3.36-1.46.12-3.67,0-7.35,0-11.12ZM46.11,49.31H24.73v8.57c2.26.69,3.73.33,4.39-2.15a7.6,7.6,0,0,1,2-3,5.59,5.59,0,0,1,8.54.06,7.9,7.9,0,0,1,2,3c.69,2.48,2.22,2.69,4.39,2.1ZM24.65,74l.12.73H46.16l.09-.72-4.08-.5,0-.77,4.07-.39c0-1.66,0-3.22,0-4.79,0-.39-.08-.79-.12-1.14-2.18-.6-3.72-.37-4.43,2.09a7.8,7.8,0,0,1-2.06,3,5.56,5.56,0,0,1-8.24.12,7.8,7.8,0,0,1-2.21-3.15c-.72-2.53-2.31-2.6-4.44-2.1v5.89l3.88.56-.08.66ZM43.1,61.13H27.62l.15,2.14H43.1ZM30.66,57.92h9.56c-1.08-3.19-2.83-5-4.77-5S31.58,54.83,30.66,57.92Zm.07,8.43c.81,3.08,2.72,5,4.8,4.93s3.94-2.13,4.54-5c-2.54,0-5,0-7.56,0C31.92,66.25,31.33,66.32,30.73,66.35Zm1-38.73h7.46l-.46-3.34H32.16c-.13.24-.24.35-.25.48C31.84,25.64,31.8,26.52,31.73,27.62Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M60.18,61.45H79.9c0,.85.12,1.57.12,2.3q0,13.57,0,27.13c0,4.88-1.39,6.24-6.23,6.24-2.95,0-5.89.06-8.84,0s-4.7-1.5-4.73-4.32C60.12,82.44,60.18,72.1,60.18,61.45Zm1.63,9.85c0,4,.05,7.76,0,11.53a5.32,5.32,0,0,0,2.62,4.8c3.13,2.08,8.3,2.16,11.3-.07,1.08-.8,2.35-2.16,2.43-3.34.29-4.27.11-8.57.11-12.92Zm.13-8v6.11H78.21V63.28Zm0,24.73c0,1.78-.1,3.4,0,5a2.34,2.34,0,0,0,2.44,2.32c3.83.05,7.67.11,11.5-.1a3.1,3.1,0,0,0,2.18-2,26.46,26.46,0,0,0,.1-5.22C72.69,91.91,67.37,91.88,61.91,88Z' })
	                  ),
	                  'gin': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'gin-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M49.41,97c1.26-1,2-1.63,3-2.24a4.22,4.22,0,0,1,1.52-.41c8.56-1.14,12.19-4.46,12.17-9.13a76.91,76.91,0,0,0-1-14c-.35-1.83-2.22-3.85-4.48-5.22-9.77-5.95-13-12.95-11.51-20.78.81-4.27,2-8.51,3-12.77.26-1.18,1.11-1.6,3.29-1.58,9.79.07,19.58,0,29.37.07.95,0,2.59.49,2.72.88,2.3,6.93,4.6,13.88,3.12,21-.94,4.54-4,8.6-9.61,11.86-5.14,3-7.11,6.47-7.11,10.47,0,3.65-.14,7.31.09,11,.25,4,3.34,6.83,10.57,8,2.4.38,5.27.75,5,2.93ZM88.16,47.21H51.66c-.28,5.38.87,10.34,7.41,14.47a19.4,19.4,0,0,0,21.54.06C87.22,57.63,88.41,52.66,88.16,47.21Zm-3-14.6H54.67L51.6,45.35H88.18ZM65.53,66.43c.82,1.45,2.25,2.89,2.35,4.36A120,120,0,0,1,68.2,88c-.24,3.21-3.44,5.79-9.29,6.94-.29.06-.47.31-.75.51H81.67c-5-1.19-8.63-3.11-9.57-6.08-2.47-7.76-2.53-15.48,2-22.94Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M11.53,62.75c0-9.42.06-18.85,0-28.27,0-2.41.68-3.84,3-4.87,5.48-2.4,7.4-7.13,7.51-12.79.06-3.2.1-6.41,0-9.62,0-1.56.53-2,2-2,2.24.1,4.49.08,6.73,0,1.34,0,1.77.48,1.78,1.8,0,4.23,0,8.47.33,12.67.38,4.84,3.16,8.17,7.54,10.08A3.78,3.78,0,0,1,43,33.75c0,19.23,0,38.47,0,57.7,0,4-1.36,5.29-5.35,5.29q-10.39,0-20.77,0c-3.94,0-5.31-1.33-5.33-5.34C11.5,81.85,11.53,72.3,11.53,62.75Zm8.41,3.31c0,5.34,0,10.52.05,15.7a2.27,2.27,0,0,0,1.18,1.51A13.14,13.14,0,0,0,33,83.5,2.34,2.34,0,0,0,34.61,81c-.08-3.72,0-7.43,0-11.15,0-1.25,0-2.5,0-3.79Zm0-10.82h14.4a2.49,2.49,0,0,0,.2-.62c0-5.7,0-11.4,0-17.1A2,2,0,0,0,33.67,36a12.92,12.92,0,0,0-12.83,0A1.85,1.85,0,0,0,20,37.38C19.92,43.26,19.94,49.14,19.94,55.24ZM37.8,56.69h-21v8h21Zm2.89,38.07c-2.45-1.15-4.52-1.76-6.18-3-4.92-3.57-9.61-3.51-14.51,0-1.65,1.19-3.71,1.8-6.1,2.91C22.95,94.87,31.61,94.85,40.69,94.77ZM36,55.25l.71.08A6.08,6.08,0,0,0,37,54c0-5.83.05-11.67,0-17.5a3,3,0,0,0-1.19-2c-4.56-3.4-12.46-3.37-17,0a2.81,2.81,0,0,0-1.14,1.81c-.08,6-.06,11.92,0,17.88,0,.36.33.72.51,1.07l.53-.13c0-.67.09-1.34.09-2,0-5.19,0-10.38,0-15.57A2.55,2.55,0,0,1,20.13,35a14.58,14.58,0,0,1,14.33,0,2.42,2.42,0,0,1,1.38,2.47c-.06,5.26,0,10.51,0,15.77C35.83,53.94,35.92,54.59,36,55.25ZM18.72,66.11l-.77-.16a8.21,8.21,0,0,0-.38,1.71c0,4.88-.06,9.75,0,14.63a3.24,3.24,0,0,0,1.09,2.2C23.2,88,31.29,88,35.83,84.5a3,3,0,0,0,1.1-2c.09-5.07.06-10.13,0-15.2A5.08,5.08,0,0,0,36.58,66L36,66c0,.65-.14,1.3-.14,1.95,0,4.49-.06,9,0,13.47a2.66,2.66,0,0,1-1.58,2.75,14.66,14.66,0,0,1-13.33.36,3.34,3.34,0,0,1-2.28-3.69c.19-3.07.05-6.16.05-9.23Q18.72,68.88,18.72,66.11ZM31.18,20.3H23.36l-.83,3.26H32Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M22.12,72.18V70.31H32.43l.13,1.87Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M32.16,75.36H22.74C23.53,74.39,30.41,74.25,32.16,75.36Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M22.75,76.59h9V77h-9Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M18.83,62.32V59.11H35.71v3.22Z' })
	                  ),
	                  'rum': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'rum-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M29.61,96c-2.78,0-5.56,0-8.34,0-4,0-6.15-1.5-6.92-5.49-.86-4.42-1.44-8.92-1.9-13.4-.77-7.53-1.37-15.08-2-22.63C9.87,47.74,12,42.17,17.61,38.14c3.64-2.59,5-6.15,4.84-10.66-.14-3.85.49-7.73.71-11.6a46.66,46.66,0,0,0-.06-4.69c-.05-1.19.31-1.84,1.63-1.82q4.9.06,9.8,0c1.17,0,1.55.5,1.59,1.64.2,6.06.53,12.12.69,18.19A10,10,0,0,0,40,36.65a8.93,8.93,0,0,0,1.07,1c6.7,4.46,8.56,11,7.78,18.54C47.69,67.09,46.57,78,45.25,88.91,44.57,94.44,42.51,96,36.91,96h-7.3Zm0-9.61c2.64,0,5.28,0,7.92,0,2.2-.05,3.71-1.25,3.92-3.27.76-7.6,1.69-15.19,2.07-22.8A13.74,13.74,0,0,0,29.47,46,13.85,13.85,0,0,0,15.67,60.6c.48,7.41,1.38,14.79,2.18,22.17.25,2.36,1.7,3.55,4.09,3.6C24.5,86.42,27.07,86.38,29.64,86.38Zm4.77-67.3c-3,0-5.65,0-8.28,0-.41,0-1.13.29-1.17.54-.42,2.53-.74,5.08-1.1,7.73H35.36Zm-14.92,75H39.73a38,38,0,0,1-4-2.76c-4.46-4-7.76-4-12.24,0A39.34,39.34,0,0,1,19.5,94.06Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M84.71,95.91H59.54l-.44-.51a11.14,11.14,0,0,1,2.22-2.15c1.39-.75,3-1.1,4.43-1.77,2.63-1.22,3.62-3.41,3.68-6.24s-1.38-4.38-3.76-5.4c-1.08-.46-2.17-.92-3.25-1.41-6.28-2.89-9.13-7.24-7.81-14,1.38-7.05,3.72-13.92,5.73-20.84a2,2,0,0,1,1.54-.91c6.88-.06,13.76-.07,20.64,0a2.28,2.28,0,0,1,1.72,1.23c1.84,6,4,12,5.21,18.12,1.77,9-.62,13.47-8.33,16.77-.77.33-1.53.67-2.3,1-2.51,1-4,2.7-3.9,5.53s1.19,5.12,3.95,6.29c1.4.6,2.92,1,4.26,1.66a10.54,10.54,0,0,1,2.11,2Zm2.8-35.06a71.29,71.29,0,0,0-4.89-16c-.17-.36-1.06-.55-1.62-.56-5.9,0-11.81,0-17.71,0a1.66,1.66,0,0,0-1.91,1.4c-1.14,3.86-2.39,7.68-3.57,11.53-.35,1.15-.58,2.33-.89,3.58ZM64.9,94.26H79.63c-2.95-1.49-5.36-3.19-6.11-6.54s-.34-6.13,2.35-8.46H68.65C72.86,83.41,72.09,91.23,64.9,94.26Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2',
	                              d: 'M29.64,86.38c-2.57,0-5.14,0-7.71,0-2.39,0-3.83-1.24-4.09-3.6-.8-7.38-1.7-14.76-2.18-22.17A13.85,13.85,0,0,1,29.47,46,13.74,13.74,0,0,1,43.55,60.29c-.39,7.62-1.31,15.21-2.07,22.8-.2,2-1.71,3.22-3.92,3.27C34.92,86.42,32.28,86.38,29.64,86.38Zm.14-1.26h7.5c1.69,0,2.82-.68,3-2.48.7-7.39,1.62-14.78,2-22.19a12.49,12.49,0,0,0-13-13.22A12.64,12.64,0,0,0,16.92,60.84c.54,7.2,1.4,14.37,2.12,21.55a2.71,2.71,0,0,0,3,2.73Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M29.78,85.12H22.07a2.71,2.71,0,0,1-3-2.73c-.72-7.18-1.58-14.36-2.12-21.55A12.64,12.64,0,0,1,29.33,47.23a12.49,12.49,0,0,1,13,13.22c-.41,7.41-1.32,14.79-2,22.19-.17,1.8-1.3,2.48-3,2.48Zm9.37-12.88.59-6.35H19.51l.65,6.35Zm-9.54-7.95A4.29,4.29,0,1,0,25.35,60,4.35,4.35,0,0,0,29.62,64.29ZM19.7,59.5l.61.18A7,7,0,0,0,21,58.32c1.19-4.44,4.37-7.06,8.61-7.07s7.31,2.56,8.6,7.08c.13.45.68.79,1,1.18A4.78,4.78,0,0,0,39.49,58a10.1,10.1,0,0,0-9.72-8.19,10.24,10.24,0,0,0-9.93,7.71A12.52,12.52,0,0,0,19.7,59.5Zm2.6,16.26v.46H37v-.46Zm3,2.25c1.91,1.08,7,1,8.22,0Zm.59,2.36v.43h7.4l0-.43Z' })
	                  ),
	                  'whiskey': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'whiskey-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M29.69,96c-3.14,0-6.28,0-9.43,0s-4.2-1-4.25-4.2c-.12-8.62-.13-17.25-.29-25.87-.17-9.11-.35-18.22-.75-27.32a7.88,7.88,0,0,1,4.27-7.91,26.3,26.3,0,0,0,2.3-1.54,5.35,5.35,0,0,0,2.36-4.74c-.11-5.09-.14-10.17-.29-15.26,0-1.59.43-2.21,2.09-2.14,2.71.12,5.42.09,8.13,0,1.39,0,1.84.52,1.8,1.86-.13,5-.13,10.05-.31,15.08a6,6,0,0,0,3,5.7c.36.23.72.48,1.1.68,3.51,1.86,5.09,4.61,4.81,8.73-.41,6.14-.46,12.3-.57,18.45-.2,11.38-.31,22.77-.48,34.15,0,3.33-1,4.28-4.31,4.32-3.08,0-6.16,0-9.24,0Zm-12-6.42c-.34,4.75-.21,4.89,4.2,4.89H37.72c3.92,0,4.09-.18,4-4a4,4,0,0,0-.13-.68l-.27.53c-1.73-.6-3.48-1.12-5.17-1.82a16,16,0,0,1-2.3-1.52,7.26,7.26,0,0,0-8.63.07c-.66.45-1.33.88-2,1.36C21.58,89.58,19.82,90.3,17.64,89.56ZM39.17,62.94c0-5.25,0-10.23,0-15.21,0-1.72,0-3.46-.09-5.17a6.71,6.71,0,0,0-6.34-6.11c-2-.11-3.94-.1-5.91,0a6.7,6.7,0,0,0-6.67,6.76c-.11,6.15-.09,12.3-.11,18.46a8.34,8.34,0,0,0,.19,1.3Zm-19,19.77H39V66.9H20.17ZM25.5,19.9v6.2h8.23V19.9Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M79.5,64.68c1.68,7.81,1.59,15.52,2.08,23.17.34,5.41-2.4,8.12-7.85,8.14q-8.59,0-17.18,0c-5.44,0-8.11-2.71-7.86-8.13.28-6.09.72-12.17,1.13-18.25.09-1.32.34-2.63.52-3.94s1.15-1.07,2-1.07L76,64.68Zm-28.1,9.74H79.18c-.09-1.92-.19-3.69-.25-5.47-.11-3.14-.22-3.23-3.28-3.15s-6.15.11-9.22.14c-4.55,0-9.1,0-13.64.13a1.89,1.89,0,0,0-1.33,1.27C51.32,69.65,51.39,72,51.39,74.42Zm-1,12.71c-.66,4.45,1.06,7.1,5,7.22,6.52.2,13,.21,19.56,0,4-.14,5.76-2.92,4.92-7-1.55,1.79-3.57,2-5.71,2-6.15,0-12.31,0-18.46,0A6.1,6.1,0,0,1,50.39,87.13Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2',
	                              d: 'M39.17,62.94H20.23a8.34,8.34,0,0,1-.19-1.3c0-6.15,0-12.31.11-18.46a6.7,6.7,0,0,1,6.67-6.76c2-.08,3.95-.08,5.91,0a6.71,6.71,0,0,1,6.34,6.11c.14,1.72.09,3.45.09,5.17C39.17,52.72,39.17,57.7,39.17,62.94Zm-18-1h16.7a2.56,2.56,0,0,0,.2-.63c0-6.22,0-12.44-.12-18.65a5.44,5.44,0,0,0-5.18-5.11c-1.78-.11-3.57-.07-5.36,0-3.9,0-6.14,2.31-6.17,6.24,0,4.56,0,9.11-.06,13.67C21.17,58.91,21.18,60.37,21.18,62Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2', d: 'M20.17,82.72V66.9H39V82.72Zm17.7-1.09V68H21.32V81.63Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M21.18,62c0-1.6,0-3.06,0-4.52,0-4.56,0-9.11.06-13.67,0-3.94,2.27-6.2,6.17-6.24,1.79,0,3.58-.07,5.36,0A5.44,5.44,0,0,1,38,42.69c.14,6.22.1,12.44.12,18.65a2.56,2.56,0,0,1-.2.63Zm8.46-21.3A5.76,5.76,0,0,0,24,46.53a5.85,5.85,0,0,0,5.74,5.41,5.92,5.92,0,0,0,5.57-5.76A5.79,5.79,0,0,0,29.64,40.67ZM24,56.59H35.48l-.14-1.88c-3.57,0-7,0-10.33,0C23.58,54.68,23.47,55.32,24,56.59Zm2.19,1-.31.48c.38.31.75.86,1.14.89a50.73,50.73,0,0,0,5.17,0c.33,0,.63-.49,1-.76-.3-.21-.59-.6-.89-.61C30.24,57.57,28.22,57.6,26.2,57.6Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M37.86,81.63H21.32V68H37.86ZM23.33,75.11H35.85V71.32c-3.43,0-6.73,0-10,0-2.78,0-2.82,0-2.65,2.71C23.19,74.38,23.27,74.73,23.33,75.11Zm.74,2.3.47.54c3.12,0,6.24,0,9.36,0,.38,0,.74-.49,1.11-.75-.34-.23-.68-.66-1-.67-2.94-.05-5.88-.06-8.82,0C24.8,76.51,24.44,77.09,24.07,77.41Z' })
	                  ),
	                  'tequila': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'tequila-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M18.47,74.35c0-5.32.05-10.63,0-15.95-.08-6.1-.28-12.2-.39-18.3,0-2.85.64-3.71,3.34-4.55l.19-.05c7.09-2.11,7.53-2.72,7.55-10.2,0-5.09.1-10.18,0-15.27,0-1.58.52-2.08,2.05-2,2.76.09,5.52.07,8.28,0,1.35,0,1.84.45,1.83,1.83,0,5.81,0,11.63,0,17.44,0,4.84,1.34,6.54,6.06,7.81.63.17,1.27.32,1.9.52,2.49.8,3.13,1.66,3.13,4.3q0,24.64,0,49.29A14.73,14.73,0,0,1,52,92.9,4.94,4.94,0,0,1,46.88,97c-7.76.06-15.51.07-23.27,0-3.42,0-5.44-2.47-5.5-6.62-.09-5.32,0-10.65,0-16Zm32.37-9.41h0c0-8.21-.06-16.41,0-24.62,0-2-.75-2.91-2.55-3.29-.77-.16-1.52-.41-2.27-.63a8.15,8.15,0,0,1-5.38-4A2.29,2.29,0,0,0,39,31.51c-2.49-.1-5-.1-7.48,0a3.51,3.51,0,0,0-1.65,1,45.88,45.88,0,0,1-4.5,3.58c-1.2.72-2.8.75-4.08,1.37a2.92,2.92,0,0,0-1.54,1.92c-.25,3.79-.39,7.59-.38,11.39,0,6.42.24,12.83.29,19.24.06,6.57,0,13.14,0,19.71,0,2.62,1.46,4.1,4.07,3.83a20.89,20.89,0,0,0,5.11-1.33,17.4,17.4,0,0,1,12.69,0,21.45,21.45,0,0,0,4.91,1.34c2.86.34,4.34-1.08,4.35-3.93C50.86,81.37,50.84,73.16,50.84,64.95ZM39.66,27H30.85v2.67h8.81Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M82,65c-.57,3.6-1.18,6.94-1.61,10.3-.69,5.34-1.26,10.7-1.88,16-.1.85-.18,1.7-.35,2.53-.44,2.19-1.41,3-3.67,3.05-2.76,0-5.52,0-8.28,0-2.93,0-4-1-4.31-3.95-.53-4.77-.95-9.55-1.55-14.3-.47-3.71-1.16-7.39-1.74-11.09-.13-.83-.17-1.68-.27-2.6ZM77.31,86.73c-4.89,2.87-9.56,2.69-14.43.15.23,2.27.41,4.36.66,6.44a2,2,0,0,0,2.19,2c2.89,0,5.78,0,8.67,0a1.87,1.87,0,0,0,2.13-1.82C76.79,91.31,77,89.1,77.31,86.73Zm2.78-20.22H60L60.81,71H79.32Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M23.47,67.83c0-5.12,0-10.24,0-15.36.05-4.66,5.92-10.27,10.59-10.08a17.64,17.64,0,0,1,5.91.84c5.13,2.12,6.85,6.34,6.83,11.71,0,9.39.22,18.78.32,28.18,0,3.64-.91,4.56-4.52,4.56q-7.49,0-15,0c-3.16,0-4.17-1-4.18-4.08,0-5.26,0-10.52,0-15.77Zm13.06-6.18A3.83,3.83,0,0,0,38,61.27c1.79-1.43,3.41-3.1,5.3-4.36s2-3,1.68-5.32c-.68.82-1.16,1.42-1.66,2l-6.82,8.11c1.87-3.66,3.72-7.33,5.61-11,1.49-2.88,1.47-3-1.47-4.9C39.08,50.92,37.56,56,36.07,61.05,36,61.2,36.36,61.45,36.53,61.65Zm-2.67-.09c1.82.43.77-1,.66-1.29-.8-2.62-1.76-5.19-2.58-7.81C31.26,50.24,30.7,48,30,45.56L27.29,48l1.14,2.32,5.48,11.27-8.17-9.77-.55.24c.36,1.31.32,3,1.15,3.87A70.32,70.32,0,0,0,33,61.7C33.15,61.82,33.57,61.61,33.86,61.56ZM44.93,77.19V63.71H25.64V77.19ZM35,61.62l.39,0L37,44.22c-3.74-.79-3.82-.66-3.44,2.82C34.09,51.89,34.53,56.76,35,61.62Zm7,22.55v-.34H28.53v.34ZM28.54,81.94v.24H42v-.24Zm-2.89-23.7c-.36,2.52,3.29,4.48,6.5,3.68ZM39.24,61.5l.29.72c1.46-.44,2.92-.92,4.39-1.32s1.22-1.34,1-2.51c-1.2.63-2.13,1.09-3,1.59S40.11,61,39.24,61.5Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M27.28,69.77c-.5-4-.5-4,3.27-4l12.19,0a3.63,3.63,0,0,1,.55.12v3.84Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M41.33,72.83H29.48c.18-.35.34-.91.5-.91,3.59,0,7.17,0,10.76.07C40.84,72,40.94,72.26,41.33,72.83Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M39.35,75c-2.53,0-5.06,0-7.58,0a2.75,2.75,0,0,1-.72-.21c.69-1.1.69-1.11,7-.91a6.74,6.74,0,0,1,1.59.45Z' })
	                  ),
	                  'liquor': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'liquer-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M28.65,25.92c.24-3.6.58-7.19.7-10.79.08-2.39-.13-4.8-.28-7.19-.08-1.35.34-2,1.8-1.93,2.21.08,4.43,0,6.65,0,1.08,0,1.61.4,1.57,1.54-.08,2.34-.2,4.69-.12,7,.25,7.47.45,14.95,1,22.4a10.52,10.52,0,0,0,4.7,8.15c7.8,5.16,9.12,12.43,7.28,20.86s-3.56,16.67-5.49,25c-1,4.15-1.94,4.72-6.18,4.73s-8.73,0-13.1,0c-3.1,0-4.34-.64-5-3.59C19.89,82,17.7,71.93,15.81,61.78c-1.13-6.08.74-11.33,6-15,5-3.52,7.05-8.44,7.06-14.38q0-3.22,0-6.45Zm5.26,60.94h4.63c3.31,0,3.78-.3,4.55-3.53,1.24-5.22,2.39-10.46,3.54-15.7a5.78,5.78,0,0,0,.17-2.57,20.7,20.7,0,0,0-6.39-10.95,9.36,9.36,0,0,0-8.25-2.24c-5,1-11.57,9.19-10.78,14.19,1,6.34,2.72,12.57,4.19,18.83a2.54,2.54,0,0,0,2.89,2C30.29,86.82,32.1,86.86,33.91,86.86Zm3.61-52.72V27.75H30.65v6.39Zm0-16h-6.8v3.41h6.8Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M78.88,95.6H61.4a1.79,1.79,0,0,1,1.41-2.5c4.44-1.22,5.44-4.27,5.11-8.46-.39-4.88-.25-9.81-.67-14.69a7.27,7.27,0,0,0-2-4.57c-4.63-3.93-5.8-8.72-4.8-14.49,1.11-6.4,1.93-12.86,2.91-19.48H76.8c.11,1.94.09,4,.36,5.92.61,4.52,1.29,9,2.06,13.53,1,5.62.11,10.57-4.68,14.28-1.81,1.4-2.25,3.44-2.32,5.58C72,76.09,72,81.47,71.73,86.83a5.1,5.1,0,0,0,3.62,5.57,6.59,6.59,0,0,1,2,1A12.56,12.56,0,0,1,78.88,95.6ZM76.1,44.07l-1-11H64.53l-1,11ZM65.79,93.84h8c-3-1.58-3.87-4-3.72-7.12.17-3.75-.06-7.52.18-11.26.22-3.49-.22-7.15,1.89-10.42H67.86A34.31,34.31,0,0,1,69,70.27c.3,4.95.43,9.91.56,14.87C69.64,88.59,69.84,92.14,65.79,93.84Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2',
	                              d: 'M33.91,86.86c-1.81,0-3.63,0-5.44,0a2.54,2.54,0,0,1-2.89-2c-1.47-6.26-3.19-12.49-4.19-18.83-.79-5,5.81-13.19,10.78-14.19a9.36,9.36,0,0,1,8.25,2.24,20.7,20.7,0,0,1,6.39,10.95,5.78,5.78,0,0,1-.17,2.57c-1.15,5.24-2.3,10.48-3.54,15.7-.77,3.23-1.24,3.53-4.55,3.53Zm.14-1.22a38.73,38.73,0,0,1,4.42,0c2.08.24,3-.59,3.47-2.6,1-4.59,2.12-9.14,3.12-13.72A10.5,10.5,0,0,0,45.5,65a18.08,18.08,0,0,0-5.63-9.78,8.25,8.25,0,0,0-11.5,0c-3.07,2.63-4.69,6.14-5.79,9.93a2.92,2.92,0,0,0,0,1.39c1.3,5.82,2.63,11.63,3.94,17.45a2,2,0,0,0,2.29,1.71C30.56,85.58,32.31,85.65,34.05,85.64Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2',
	                              d: 'M65.79,93.84c4-1.69,3.85-5.25,3.76-8.7-.13-5-.26-9.92-.56-14.87A34.31,34.31,0,0,0,67.86,65h4.31c-2.11,3.27-1.67,6.92-1.89,10.42-.24,3.74,0,7.51-.18,11.26-.14,3.12.74,5.54,3.72,7.12Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M34.05,85.65c-1.74,0-3.49-.06-5.23,0A2,2,0,0,1,26.53,84c-1.31-5.82-2.64-11.63-3.94-17.45a2.92,2.92,0,0,1,0-1.39c1.1-3.79,2.72-7.3,5.79-9.93a8.25,8.25,0,0,1,11.5,0A18.08,18.08,0,0,1,45.5,65a10.5,10.5,0,0,1-.43,4.35c-1,4.58-2.15,9.13-3.12,13.72-.42,2-1.39,2.84-3.47,2.6A38.23,38.23,0,0,0,34.05,85.65ZM42.72,73c.08-2.12.78-4.22.08-5.62a9.4,9.4,0,0,0-7-4.94c-4.11-.73-7.24,1.08-9.95,4-2,2.16-.23,4.13-.14,6.32C31.78,68,36.75,68.22,42.72,73ZM37.41,57.63a3.31,3.31,0,0,0-6.61-.16,3.31,3.31,0,1,0,6.61.16Zm3.35,19.81V75.27H27.43v2.16Zm-6.94,3.29h0c1.48,0,3,.06,4.43,0,.47,0,.9-.48,1.35-.74-.41-.22-.82-.62-1.23-.63q-4.33-.08-8.66,0c-.38,0-.76.46-1.13.71.4.22.8.62,1.21.64C31.13,80.78,32.48,80.73,33.82,80.73Zm.32,1.41c-.94,0-1.88,0-2.81,0-.3,0-.57.38-.85.58.29.27.57.77.86.78,1.87.07,3.75.06,5.62,0,.26,0,.51-.44.77-.68-.26-.23-.5-.64-.78-.67C36,82.09,35.08,82.14,34.15,82.14Z' })
	                  ),
	                  'aperitive': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 100 100', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'aperitive-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M17.51,65.64c0-7.52.05-15,0-22.57a15.54,15.54,0,0,1,3.16-9.77A13.82,13.82,0,0,1,22,31.54a12.76,12.76,0,0,0,3.75-12.37c-.84-3.93,0-7.79-.51-11.65-.13-1,.25-1.55,1.42-1.52,2.7.06,5.4,0,8.1,0,1.06,0,1.39.46,1.38,1.44,0,1.86.07,3.72,0,5.57q-.23,4.93-.63,9.85a9,9,0,0,0,2.14,6.46c1.29,1.68,2.61,3.34,3.81,5.09a13.92,13.92,0,0,1,2.4,8.09c0,15.2,0,30.41,0,45.61a25,25,0,0,1-.25,3.8c-.41,2.64-1.82,4-4.49,4q-8.42.13-16.84,0c-2.71,0-4.21-1.51-4.45-4.24-.22-2.47-.23-5-.25-7.45C17.49,78,17.51,71.84,17.51,65.64Zm1.33.16c0,3,0,5.93,0,8.89,0,5.45,0,10.9.18,16.35.05,2.1,1.8,3,3.7,2.1a23,23,0,0,0,2.65-1.74c3.6-2.47,7-2.46,10.62,0a18.58,18.58,0,0,0,2.94,1.85,2.28,2.28,0,0,0,3.36-1.92,25.81,25.81,0,0,0,.21-3.48c0-14.61-.11-29.23.08-43.84a17.25,17.25,0,0,0-4.73-12.22,2.21,2.21,0,0,0-1.47-.63c-3.81-.05-7.62,0-11.43,0a1.84,1.84,0,0,0-1.26.41c-2.76,3.23-5,6.66-4.89,11.2C18.92,50.45,18.83,58.13,18.83,65.81ZM33.66,22.89h-6l-2.18,6.83H35.79Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M75.32,95.91H56.71c.6-.8.88-1.46,1.38-1.78a11.7,11.7,0,0,1,2.49-1,4.93,4.93,0,0,0,3.54-4.29c.63-5.38.91-10.79-.27-16.11a14.94,14.94,0,0,0-2.61-5.51c-4.36-5.85-8.93-11.55-13.57-17.51H84.85c-.37.5-.67.94-1,1.36C80,56,76.29,61,72.28,65.81a17.09,17.09,0,0,0-4.17,10.88c-.09,3.65,0,7.3.18,10.95a5.74,5.74,0,0,0,4.52,5.8,5.57,5.57,0,0,1,1.75.73,7.12,7.12,0,0,1,1.16,1.38ZM77.49,57.4,77.18,57H55.38l-.31.36c2.95,3.36,5.79,6.82,8.88,10,1.94,2,2.84,2,4.8,0C71.81,64.21,74.59,60.75,77.49,57.4Zm4.75-6.45H50.34c1.21,1.56,2.24,2.95,3.36,4.26a1.84,1.84,0,0,0,1.27.4q11.36,0,22.72,0A2,2,0,0,0,79,55C80.09,53.79,81.06,52.47,82.24,50.95ZM71.78,94.62c-3.42-2-4.29-3.12-4.72-6.13a24.92,24.92,0,0,1-.3-3.47c0-5.1-.46-10.25,1.28-15H64.58a.67.67,0,0,0,0,.28c1.87,6.07,1.4,12.25.85,18.42a6.07,6.07,0,0,1-4.13,5.53c-.1,0-.16.22-.27.4Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2',
	                              d: 'M18.83,65.81c0-7.68.09-15.35,0-23-.07-4.54,2.12-8,4.89-11.2a1.84,1.84,0,0,1,1.26-.41c3.81,0,7.62,0,11.43,0a2.21,2.21,0,0,1,1.47.63A17.25,17.25,0,0,1,42.58,44c-.18,14.61-.06,29.22-.08,43.84a25.81,25.81,0,0,1-.21,3.48,2.28,2.28,0,0,1-3.36,1.92A18.58,18.58,0,0,1,36,91.42c-3.58-2.47-7-2.48-10.62,0a23,23,0,0,1-2.65,1.74c-1.9.95-3.65,0-3.7-2.1-.14-5.45-.14-10.9-.18-16.35C18.82,71.74,18.83,68.77,18.83,65.81ZM40.66,53l-2.44-.19C37.63,47.85,35,45,31,44.85c-4.23-.18-6.85,2.41-8,8L20.71,53c-.26,3-.7,6-.7,8.9,0,3.74.42,7.47.58,11.21.09,2.2,0,4.41,0,6.64h20c.37-5.3-.11-10.52.6-15.75C41.71,60.46,40.91,56.76,40.66,53Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2', d: 'M33.66,22.89l2.12,6.83H25.53l2.18-6.83Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M40.66,53c.24,3.77,1.05,7.48.58,11-.7,5.23-.23,10.45-.6,15.75h-20c0-2.23.07-4.44,0-6.64-.15-3.74-.57-7.48-.58-11.21,0-2.93.44-5.86.7-8.9L23,52.83c1.14-5.56,3.76-8.16,8-8,4,.17,6.63,3,7.22,7.95Zm-.39,11.87V58.68H21v6.18Zm-1.5,12.9H22.4V65.86c-.9.86-1.16,10.68-.56,12.91H39.56V66l-.76,0C38.74,69.9,38.82,73.8,38.76,77.77Zm-13.56-23c0-1-.06-1.84,0-2.72a5.48,5.48,0,0,1,10.95.24c0,.82,0,1.65,0,2.5L38.6,55l.5,2.64.53-.12c0-.36.1-.71.11-1.07,0-.78,0-1.56,0-2.42l-2.44-.2c-1-5.7-2.73-8-6.43-7.94a8,8,0,0,0-4,1.26c-2.36,1.5-2.84,4-2.69,6.67L21.57,54c.26,1.25-.52,2.55.85,3.9l.21-3ZM35.85,68.46H25.5V70.6H35.85ZM34.3,51.69c-.14-2.43-1.74-3.87-3.94-3.71a3.4,3.4,0,0,0-3.24,3.71ZM26.57,72.63v.29H34.8v-.29Zm0,1.24v.25h8.24v-.25Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2', d: 'M40.27,64.86H21V58.68H40.27Zm-1.47-4H22.54v2.23H38.8Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2',
	                              d: 'M38.76,77.77c.05-4,0-7.87,0-11.76l.76,0V78.77H21.84c-.61-2.23-.34-12.06.56-12.92V77.77Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2',
	                              d: 'M25.2,54.76,22.63,55l-.21,3C21,56.6,21.83,55.3,21.57,54l2.63-.22c-.15-2.65.33-5.17,2.69-6.67a8,8,0,0,1,4-1.26c3.7-.06,5.46,2.24,6.43,7.94l2.44.2c0,.85,0,1.63,0,2.42,0,.36-.07.71-.11,1.07l-.53.12L38.6,55l-2.44-.21c0-.85,0-1.68,0-2.5A5.48,5.48,0,0,0,25.21,52C25.14,52.92,25.2,53.81,25.2,54.76Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2', d: 'M35.85,68.46V70.6H25.5V68.46Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2', d: 'M34.3,51.69H27.12A3.4,3.4,0,0,1,30.36,48C32.56,47.82,34.16,49.26,34.3,51.69Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2', d: 'M26.57,72.63H34.8v.29H26.58Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2', d: 'M26.56,73.87H34.8v.25H26.57Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M38.8,60.86v2.23H22.54V60.86Z' })
	                  ),
	                  'brandy-cognac': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1',
	                              'data-name': 'Camada 1',
	                              xmlns: 'http://www.w3.org/2000/svg',
	                              viewBox: '0 0 100 100',
	                              className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'brandy-cognac-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M26.75,29c0-6.15,0-12.3,0-18.45,0-1.6.51-2.13,2.07-2,2.1.11,4.2,0,6.3,0,2.52,0,2.53,0,2.52,2.45,0,9.33.11,18.67-.14,28-.14,5.17,1.73,8.88,6.09,11.57a33.24,33.24,0,0,1,5.06,4,16.56,16.56,0,0,1,5.2,16.18,116.35,116.35,0,0,1-6.64,21.07c-1.2,3-3.32,4.26-6.58,4.18-5.7-.14-11.41-.12-17.11,0-3,.06-5.08-1.16-6.21-3.91-2.92-7.11-5.72-14.3-6.81-21.94-1-7.3,1.49-13.3,7.62-17.63,1.42-1,2.8-2.07,4.23-3.05a10.26,10.26,0,0,0,4.5-9.11c0-3.78,0-7.57,0-11.35Zm5.33,57.12H40.9c2.63,0,3-.22,3.66-2.73,1.4-5.09,2.78-10.18,4.07-15.29a2.46,2.46,0,0,0-.57-2c-8.5-8.51-23.5-8.51-31.89,0a2.1,2.1,0,0,0-.56,1.65C17,73.21,18.52,78.64,20,84.09a2.48,2.48,0,0,0,2.74,2C25.83,86.09,29,86.12,32.08,86.12ZM20.51,94a11,11,0,0,0,2.28.44q9.35.06,18.69,0a10.93,10.93,0,0,0,2.35-.49C36.13,89.09,28.26,89,20.51,94Zm16-48.8-.72-5.87H28.46l-.67,5.87Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M86.64,95.9H58.76c-.46-1.41.29-2.09,1.41-2.45,1.54-.48,3.14-.79,4.68-1.28a13.3,13.3,0,0,0,3.29-1.39,3.45,3.45,0,0,0-.39-6.13C66.41,84,64.95,83.57,63.55,83c-7.17-2.81-10-8.95-7.14-16.13a73.82,73.82,0,0,1,4.91-9.17,2.33,2.33,0,0,1,1.74-.88c6.42-.06,12.85-.05,19.27,0a2.07,2.07,0,0,1,1.51.64c2.57,3.77,5,7.63,5.92,12.21a11.1,11.1,0,0,1-6.54,12.69c-1.63.75-3.34,1.32-5,2a3.63,3.63,0,0,0,0,7c2.08.73,4.26,1.22,6.37,1.88C85.75,93.59,87,94,86.64,95.9Zm1.7-27.56C86.46,65,84.84,62,83.08,59.06a2.46,2.46,0,0,0-1.84-.71c-5.77-.05-11.53,0-17.3,0-.5,0-1.23.08-1.46.4a36.28,36.28,0,0,0-5.05,9.6ZM82.2,94.43c-2.12-.82-3.9-1.36-5.53-2.18a4.68,4.68,0,0,1-2.6-4.4c0-2.06,1.07-3.44,2.74-4.7-1.56.07-2.87.17-4.18.17s-2.56-.1-4.08-.17c.34.32.5.48.67.62,3,2.48,2.76,6.63-.63,8.52a29,29,0,0,1-4.18,1.56c-.32.12-.62.27-1.33.58Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2',
	                              d: 'M32.08,86.12c-3.12,0-6.24,0-9.36,0a2.48,2.48,0,0,1-2.74-2c-1.45-5.44-3-10.87-4.36-16.33a2.1,2.1,0,0,1,.56-1.65c8.39-8.49,23.39-8.49,31.89,0a2.46,2.46,0,0,1,.57,2C47.34,73.22,46,78.31,44.56,83.4c-.69,2.51-1,2.72-3.66,2.73H32.08Zm0-1.09c3,0,6-.05,9,0a2,2,0,0,0,2.33-1.67c1.32-5,2.71-10.08,4-15.13A2,2,0,0,0,47,66.59a21.84,21.84,0,0,0-29.57-.06,2.24,2.24,0,0,0-.54,1.84c1.27,5,2.65,10,4,15a2,2,0,0,0,2.28,1.74C26.12,85,29.12,85,32.13,85Z' }),
	                        _react2.default.createElement('path', { className: 'cls-2', d: 'M36.55,45.2H27.79l.67-5.87h7.37Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M32.13,85c-3,0-6-.06-9,0a2,2,0,0,1-2.28-1.74c-1.32-5-2.7-10-4-15a2.24,2.24,0,0,1,.54-1.84A21.84,21.84,0,0,1,47,66.59a2,2,0,0,1,.49,1.66c-1.29,5.06-2.68,10.08-4,15.13a2,2,0,0,1-2.33,1.67C38.13,85,35.13,85,32.13,85Zm.07-1.16c2.88,0,5.76.06,8.63-.05a2.12,2.12,0,0,0,1.58-1.15c1.36-4.66,2.62-9.34,3.82-14A2,2,0,0,0,45.68,67a20.57,20.57,0,0,0-27-.06,2.16,2.16,0,0,0-.58,1.78c1.17,4.65,2.47,9.26,3.67,13.9a1.49,1.49,0,0,0,1.75,1.32C26.44,83.83,29.32,83.87,32.19,83.87Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M32.23,63.89A4.93,4.93,0,0,1,37.44,69a5.39,5.39,0,0,1-5.28,5.29,5.3,5.3,0,0,1-5.28-5.08C26.88,65.89,28.88,63.88,32.23,63.89Zm2.86,5A3,3,0,0,0,32,66.08a2.79,2.79,0,0,0-2.69,3,2.86,2.86,0,0,0,3,2.84A3,3,0,0,0,35.09,68.91Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M42.41,76v2.39H21.94V76Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M23.34,80H41v.35H23.34Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1', d: 'M36.33,82.83H28v-.37h8.32Z' })
	                  ),
	                  'no-alcohol': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 100 100', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'sem-alcool-icon'
	                        ),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M50.19,96a45.61,45.61,0,1,1-.08-91.22A45.92,45.92,0,0,1,96,50.36C96,75.38,75.43,95.93,50.19,96Zm-27-14.76c10.94,9.19,23.6,12.56,37.53,8.59,16.34-4.64,26.67-15.62,29.74-32.45,2.33-12.74,0-23-9.24-33.53-4.91,4.51-16.92,15.5-16.92,15.5l.13-7.88S72.54,23.92,77,19.9c-15.67-15.38-42.68-13.57-58,3.67C3.48,41.15,7.92,66.31,19.33,77.08l13.15-12.2L32,72.22C31.11,73.11,24.47,79.89,23.21,81.24Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M60.55,41.52c-.07-2.43-2.07-5.3-4-7.06a6.66,6.66,0,0,1-2.63-5.83c.15-3.9,0-7.82,0-12,0-.33-.4-.4-.43-.43a19.32,19.32,0,0,0-3.39-.1,19.18,19.18,0,0,0-3.39.1s-.43.12-.43.43c0,4.16-.12,8.06,0,12a6.64,6.64,0,0,1-2.63,5.83c-1.93,1.75-3.93,4.63-4,7.06-.38,13.38-.25,26.79-.1,40.19a3.08,3.08,0,0,0,2.94,3H57.75a3.07,3.07,0,0,0,2.94-3C60.82,68.3,61,54.9,60.55,41.52Zm-18.92-.64c.61-2.46,2-5.21,6.25-7.22V29.9h2.5v5a8.11,8.11,0,0,0-5.9,5.95V47H41.63Zm2.4,39H41.65V69.53H44Z' })
	                  ),
	                  'cards': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '-13192 -13008 23 23' },
	                        _react2.default.createElement(
	                              'g',
	                              { id: 'Icon_Galeria_Cinzento', 'data-name': 'Icon Galeria Cinzento', className: 'cls-1' },
	                              _react2.default.createElement('rect', { id: 'Rectangle_172',
	                                    'data-name': 'Rectangle 172',
	                                    className: 'cls-2',
	                                    width: '9.994',
	                                    height: '9.895',
	                                    transform: 'translate(-13192.09 -13008)' }),
	                              _react2.default.createElement('rect', { id: 'Rectangle_173',
	                                    'data-name': 'Rectangle 173',
	                                    className: 'cls-2',
	                                    width: '9.994',
	                                    height: '9.895',
	                                    transform: 'translate(-13178.874 -13008)' }),
	                              _react2.default.createElement('rect', { id: 'Rectangle_174',
	                                    'data-name': 'Rectangle 174',
	                                    className: 'cls-2',
	                                    width: '23.994',
	                                    height: '9.895',
	                                    transform: 'translate(-13192.874 -12994.895)' })
	                        )
	                  ),
	                  'list': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '-13192 -13036 23 23' },
	                        _react2.default.createElement(
	                              'g',
	                              { className: 'cls-1' },
	                              _react2.default.createElement('rect', { id: 'Rectangle_167',
	                                    'data-name': 'Rectangle 167',
	                                    className: 'cls-2',
	                                    width: '18.026',
	                                    height: '3.278',
	                                    transform: 'translate(-13187.026 -13036)' }),
	                              _react2.default.createElement('rect', { id: 'Rectangle_164',
	                                    'data-name': 'Rectangle 164',
	                                    className: 'cls-2',
	                                    width: '3.104',
	                                    height: '3.278',
	                                    transform: 'translate(-13192 -13036)' }),
	                              _react2.default.createElement('rect', { id: 'Rectangle_168',
	                                    'data-name': 'Rectangle 168',
	                                    className: 'cls-2',
	                                    width: '18.026',
	                                    height: '3.278',
	                                    transform: 'translate(-13187.026 -13022.852)' }),
	                              _react2.default.createElement('rect', { id: 'Rectangle_166',
	                                    'data-name': 'Rectangle 166',
	                                    className: 'cls-2',
	                                    width: '3.104',
	                                    height: '3.278',
	                                    transform: 'translate(-13192 -13022.852)' }),
	                              _react2.default.createElement('rect', { id: 'Rectangle_169',
	                                    'data-name': 'Rectangle 169',
	                                    className: 'cls-2',
	                                    width: '18.026',
	                                    height: '3.278',
	                                    transform: 'translate(-13187.026 -13029.425)' }),
	                              _react2.default.createElement('rect', { id: 'Rectangle_165',
	                                    'data-name': 'Rectangle 165',
	                                    className: 'cls-2',
	                                    width: '3.104',
	                                    height: '3.278',
	                                    transform: 'translate(-13192 -13029.425)' }),
	                              _react2.default.createElement('rect', { id: 'Rectangle_170',
	                                    'data-name': 'Rectangle 170',
	                                    className: 'cls-2',
	                                    width: '18.026',
	                                    height: '3.278',
	                                    transform: 'translate(-13187.026 -13016.278)' }),
	                              _react2.default.createElement('rect', { id: 'Rectangle_171',
	                                    'data-name': 'Rectangle 171',
	                                    className: 'cls-2',
	                                    width: '3.104',
	                                    height: '3.278',
	                                    transform: 'translate(-13192 -13016.278)' })
	                        )
	                  ),
	                  'celery-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', {
	                              d: 'M69.5,5.92A56.58,56.58,0,1,0,126.08,62.5,56.58,56.58,0,0,0,69.5,5.92Zm0,107.33A50.75,50.75,0,1,1,120.25,62.5,50.75,50.75,0,0,1,69.5,113.25Z' }),
	                        _react2.default.createElement('rect', { x: '27.28', y: '87.81', width: '29.02', height: '6.33', transform: 'translate(-52.09 56.2) rotate(-45)' }),
	                        _react2.default.createElement('rect', { x: '83.71', y: '31.22', width: '29.34', height: '6.33', transform: 'translate(4.5 79.64) rotate(-45)' }),
	                        _react2.default.createElement('path', {
	                              d: 'M72.18,70.26c5.93,6,11.79,12,17.69,18a5.22,5.22,0,0,0,1.33,1.25c.46.22,1.35.29,1.61,0a2.53,2.53,0,0,0,.4-1.78c0-.39-.55-.74-.88-1.08-6-6.16-11.92-12.47-18.17-18.39-2.62-2.49-5.94-4.3-9.09-6.16-2-1.21-4.44-1.79-6.51-3a14.32,14.32,0,0,1-4-3.39,3,3,0,0,1-.1-2.91C56.24,51,55.63,50.1,53.71,49s-2.17-3.38-.65-4.23c1.8-1,1.85-2,1.34-3.82-1-3.64.51-6.71,3.64-7.93,2.59-1,4.43,0,6.59,3.65a2,2,0,0,0,2.7,1c2-.65,3.23.37,2.85,2.51a21.85,21.85,0,0,1-1.29,3.16,2.24,2.24,0,0,0-.06,1.7,1.9,1.9,0,0,0,1.56.55c2.92-.42,3.65.08,3.74,3A11.42,11.42,0,0,1,73.87,52c-2,6.78.06,12.33,4.89,17.13L94.48,84.76c.09.09.19.26.29.27.74.07,1.47.11,2.21.16a8.92,8.92,0,0,0-.2-2.15c-.16-.47-.74-.79-1.12-1.17-4.81-4.78-9.57-9.59-14.42-14.31-4.36-4.23-6.2-9-4.55-15.16,1.44-5.41,0-8.27-3.3-10.1-.4-2.14-.46-4-1.12-5.63-.84-2.07-2.83-2.22-4.87-2.14-1.15,0-2.24-2.13-1.67-3a4.07,4.07,0,0,1,6.88.09,8.13,8.13,0,0,1,.94,2.26,1.71,1.71,0,0,0,2.34,1.54,2.06,2.06,0,0,1,2.76,2.16,15.46,15.46,0,0,1-.76,4.33c-.48,1.67-.1,2.44,1.5,2.47,2.85,0,3.42.6,2.9,3.39a69.62,69.62,0,0,1-1.92,7.52C79.1,59.45,80.25,63,83.16,66c1.41,1.48,2.94,2.86,4.43,4.26,4.39,4.11,9,8,13.14,12.37,3.62,3.76,3.28,6.39-.53,10a13.91,13.91,0,0,1-1.26,1c-2.9,2.15-4.4,2.33-7.14,0a112.62,112.62,0,0,1-8.32-8.18c-3-3.12-5.75-6.41-8.69-9.57a11.43,11.43,0,0,0-12.08-3.59c-2.5.67-5,1.41-7.51,2s-3.8-.44-3.85-3.11c0-1.65-.79-2.07-2.39-1.63a16.41,16.41,0,0,1-4.53.76A2.27,2.27,0,0,1,42,67.45c.23-1.45-.33-2.13-1.7-2.5a8.21,8.21,0,0,1-2.56-1.24c-2.86-2.1-2.68-5.76.5-7.32a11.76,11.76,0,0,1,4.73-.9c1.63-.05,3,.15,3.8-1.84.25-.65,1.66-1.09,2.56-1.13A2.16,2.16,0,0,1,51,53.92c.08,3.12,2.09,4.92,4.23,6.67l1.33,1.07-.33.45c-2-1.17-5.22-.33-5.68-4-.05-.34-1-.92-1.17-.81a2.69,2.69,0,0,0-1,1.31c-.12.28.08.71.14,1.12-2.13-.23-4.09-.54-6.06-.59-.62,0-1.25.65-1.88,1,.54.39,1,1,1.63,1.13,1.83.38,3.7.56,5.77.85a4.65,4.65,0,0,0-.56.92c-.15.71-.24,1.42-.35,2.13.75-.26,1.81-.29,2.17-.82,1-1.49,2.15-1.6,3.65-1,1.12.46,2.29.81,3.59,1.27a14.15,14.15,0,0,0-1.69,2.24,4.92,4.92,0,0,0-.13,1.82,10,10,0,0,0,1.89-.46,2.06,2.06,0,0,0,.79-.92c.86-1.51,1.88-1.89,3.47-.9.48.3,1.39-.09,2.1-.16-.36-.62-.69-1.26-1.1-1.84-.16-.24-.51-.35-.77-.53A23.29,23.29,0,0,1,72.18,70.26ZM69,50.8c.23-.42,0-1.1,0-1.66-.6.1-1.36,0-1.77.34a15.17,15.17,0,0,0-1.87,2.41,57.72,57.72,0,0,1-2.45-5.32c-.18-.48.55-1.25.75-1.91.27-.88.44-1.78.65-2.68l-2.86.68a33.36,33.36,0,0,0-1-3.57c-.23-.62-.88-1.08-1.34-1.62-.28.71-.86,1.46-.78,2.13a49.5,49.5,0,0,0,1.08,5.07,4.12,4.12,0,0,0-1.42.21,1.65,1.65,0,0,0-.73,1c0,.28.39.92.58.91,3.78-.19,3.47,3.31,5.14,5.45-.68,0-1.14-.14-1.42,0a2.28,2.28,0,0,0-1.09,1.15c-.07.3.59,1.1.89,1.09,3-.16,4.22,2,5.66,4,.36.5,1.28.61,1.94.9a6.39,6.39,0,0,0-.2-2.26,22.47,22.47,0,0,0-2.06-3A38.25,38.25,0,0,0,69,50.8Z' })
	                  ),
	                  'lupine-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', {
	                              d: 'M69.5,5.92A56.58,56.58,0,1,0,126.08,62.5,56.58,56.58,0,0,0,69.5,5.92Zm0,107.33A50.75,50.75,0,1,1,120.25,62.5,50.75,50.75,0,0,1,69.5,113.25Z' }),
	                        _react2.default.createElement('rect', { x: '29.07', y: '92.14', width: '16.76', height: '6.33', transform: 'translate(-56.42 54.4) rotate(-45)' }),
	                        _react2.default.createElement('rect', { x: '86.68', y: '29.99', width: '25.87', height: '6.33', transform: 'translate(5.73 80.15) rotate(-45)' }),
	                        _react2.default.createElement('path', {
	                              d: 'M73,55.08a14.28,14.28,0,0,1-7.59.26,24.77,24.77,0,0,1-8.65-3.77,9.34,9.34,0,0,1-4.1-7.72,24.51,24.51,0,0,1,.86-7.58A24.32,24.32,0,0,1,56,30.18a12.62,12.62,0,0,1,3-3.73,10.27,10.27,0,0,1,5.32-2,22.41,22.41,0,0,1,7.21.39,23.49,23.49,0,0,1,6,2,11.28,11.28,0,0,1,6.25,7.89,19.69,19.69,0,0,1,.42,5.52,17.46,17.46,0,0,1-2.13,7.34,15.28,15.28,0,0,1-7.84,7C73.83,54.85,73.41,55,73,55.08ZM57.75,35.44a4.1,4.1,0,0,0,.6.47c.27.14.43-.06.6-.27.73-.92,1.45-1.86,2.22-2.74a26.19,26.19,0,0,1,4.92-4.36c.43-.29.37-.74-.12-.93a1.5,1.5,0,0,0-.75-.12,10.18,10.18,0,0,0-1.73.34,7.54,7.54,0,0,0-3.89,2.59A9.18,9.18,0,0,0,58,33.9C57.87,34.38,57.83,34.88,57.75,35.44Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M72.76,69A11.72,11.72,0,0,1,73,74.58a18.25,18.25,0,0,1-1.87,5.56,17.16,17.16,0,0,1-6.65,7.07,15.05,15.05,0,0,1-16.76-1.1,24.29,24.29,0,0,1-5-4.87,13.85,13.85,0,0,1-2-3.45,8.87,8.87,0,0,1-.14-5.37,20.37,20.37,0,0,1,3-6.67A28.91,28.91,0,0,1,46,62.54a18.33,18.33,0,0,1,6.34-4.87,8.86,8.86,0,0,1,4.78-.47,20,20,0,0,1,7.59,2.9A22.91,22.91,0,0,1,70.55,65,11.74,11.74,0,0,1,72.76,69ZM53.27,60.56c-.3.13-.77.31-1.21.54a9,9,0,0,0-3.5,3.24.8.8,0,0,0,.16,1.17c.32.21.56,0,.81-.12a32.91,32.91,0,0,1,5.91-2.64c1.32-.42,2.67-.73,4-1.09.43-.12.56-.46.22-.75a2.25,2.25,0,0,0-1-.51A10.77,10.77,0,0,0,53.27,60.56Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M85.22,53.73a27.05,27.05,0,0,1,9-1.07,12.47,12.47,0,0,1,6.06,1.85,12.27,12.27,0,0,1,3.88,4.22,18.52,18.52,0,0,1,2.62,9.14,15.87,15.87,0,0,1-2.71,9.4,15,15,0,0,1-5,4.56,15.9,15.9,0,0,1-7,2,23.71,23.71,0,0,1-6.41-.32,12.07,12.07,0,0,1-4.55-1.73,9.12,9.12,0,0,1-2.9-3.47,23.23,23.23,0,0,1-2.44-9.53,22.68,22.68,0,0,1,.36-5.93,10.34,10.34,0,0,1,2.14-5,12,12,0,0,1,4.12-3C83.5,54.37,84.62,54,85.22,53.73ZM79.37,66.52c.2.37.27.72.71.73s.57-.25.71-.6c.56-1.41,1.1-2.82,1.73-4.19a29.51,29.51,0,0,1,3-4.91c.09-.12.16-.38.1-.44a.78.78,0,0,0-.52-.27,1.54,1.54,0,0,0-.74.19,9.87,9.87,0,0,0-3.59,3.14,8.17,8.17,0,0,0-1.45,5C79.29,65.65,79.35,66.13,79.37,66.52Z' })
	                  ),
	                  'soy-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', {
	                              d: 'M69.5,5.92A56.58,56.58,0,1,0,126.08,62.5,56.58,56.58,0,0,0,69.5,5.92Zm0,107.33A50.75,50.75,0,1,1,120.25,62.5,50.75,50.75,0,0,1,69.5,113.25Z' }),
	                        _react2.default.createElement('rect', { x: '28.3', y: '90.28', width: '22.04', height: '6.33', transform: 'translate(-54.56 55.17) rotate(-45)' }),
	                        _react2.default.createElement('rect', { x: '97.1', y: '25.67', width: '13.66', height: '6.33', transform: 'translate(10.05 81.94) rotate(-45)' }),
	                        _react2.default.createElement('path', {
	                              d: 'M82.28,54.43c-2.48-5.17-7.93-6.67-13.86-4.23-4.7,1.93-7.58,7.22-5.89,11.51.7,1.78,2.33,3.2,3.31,4.47-2.59,2-5.33,4.49-8.38,6.47-3.61,2.33-12.07,3-16.77-2-1.76-1.9-3.38-3.53-6.21-3.43a2.37,2.37,0,0,1-1.8-1.41,2.61,2.61,0,0,1,1.1-2c3.61-2.53,7.12-5.3,11-7.27,3-1.5,6.48-1.9,9.74-2.85,1.71-.49,3.78-.64,5-1.73,4.72-4.19,10.22-5.66,16.34-5.92a8.34,8.34,0,0,0,4.73-1.92c4.36-3.83,9.73-4.32,15-5.13,1.16-.18,2.35-.2,3.57-.3L99.1,40,104,38a45.64,45.64,0,0,0,1.13,5c2.63,7.41.93,13.46-5.28,18.39a14.68,14.68,0,0,0-3.48,4.56,26.14,26.14,0,0,1-12,11.34,47.17,47.17,0,0,0-8.08,5.21c-5.17,4-10.46,6.37-16.94,2.94-1-.53-2.48-.08-3.73-.17-.86-.06-1.71-.26-2.56-.4a6.75,6.75,0,0,1,.52-2.32A74.18,74.18,0,0,1,60,73.22c2-2.26,4.76-3.86,7.21-5.72,1-.76,2.56-1.21,3-2.19A21.09,21.09,0,0,1,82.28,54.43ZM53.52,56.29c-4.19,0-7.8,1.38-10.43,4.75-1.69,2.18-1.91,4.5-.16,6.81,1.5,2,6,3.83,7.69,3.32,1.91-.59,3.89-.93,5.8-1.48a4.77,4.77,0,0,0,1.88-1.1,8.45,8.45,0,0,0,2-8.91C59,56.77,56.33,56.32,53.52,56.29Zm33.6-7.84L86.77,48c-.39.34-.76.7-1.17,1s-.7.44-1.36.86c1.67-5.47,6-6.46,10.4-7.22a9.72,9.72,0,0,0-10.73,4c-1.58,2.24-2.15,4.56,0,7.47Zm1.37,3.28L100.25,45C96.16,43.26,90.67,46.67,88.49,51.73ZM73.64,65.33,84.9,57.66C80.18,56.64,75.54,60.15,73.64,65.33Zm-13,11.17,10.87-6.56C66.46,69.27,62.6,71.9,60.59,76.5Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M64.41,57.37c1.49-4.43,6.52-7.5,10.58-6.63.88.19,1.61,1.1,2.4,1.68-.84.5-1.68,1.43-2.53,1.44C71,53.89,67.34,54.42,64.41,57.37Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M43.49,64.38c2.08-4.78,6.23-7.38,10.6-6.78.86.12,1.62,1,2.43,1.5-.81.58-1.54,1.46-2.44,1.67-2.07.49-4.28.43-6.32,1C46.38,62.18,45.21,63.3,43.49,64.38Z' })
	                  ),
	                  'crustaceans-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', {
	                              d: 'M69.5,5.92A56.58,56.58,0,1,0,126.08,62.5,56.58,56.58,0,0,0,69.5,5.92Zm0,107.33A50.75,50.75,0,1,1,120.25,62.5,50.75,50.75,0,0,1,69.5,113.25Z' }),
	                        _react2.default.createElement('rect', { x: '27.75', y: '88.96', width: '25.78', height: '6.33', transform: 'translate(-53.24 55.72) rotate(-45)' }),
	                        _react2.default.createElement('rect', { x: '99.55', y: '24.65', width: '10.78', height: '6.33', transform: 'translate(11.07 82.36) rotate(-45)' }),
	                        _react2.default.createElement('path', {
	                              d: 'M87.56,55.86c7.07-1.51,12.36-8.36,12.36-14.34C99.92,29.69,93.16,28,93.16,28c0,12.11-3.25,14.47-3.38,14.64V33.07c-8.45,1.69-8.45,16.33-8.45,19.71a2.54,2.54,0,0,1-2.11,2.5c-1-7.46-3.48-12.13-5.7-14.92a11,11,0,0,0,2.55-6,3.37,3.37,0,1,0-3.39-.22,7.79,7.79,0,0,1-1.51,3.73,9.91,9.91,0,0,0-1.67-1.18,9.91,9.91,0,0,0-1.67,1.18,7.79,7.79,0,0,1-1.51-3.73,3.39,3.39,0,1,0-3.39.22,11,11,0,0,0,2.55,6c-2.22,2.79-4.72,7.46-5.7,14.92a2.54,2.54,0,0,1-2.11-2.5c0-3.38,0-18-8.45-19.71v9.57c-.13-.17-3.38-2.53-3.38-14.64,0,0-6.76,1.69-6.76,13.52,0,6,5.29,12.83,12.36,14.34A9.32,9.32,0,0,0,59.36,62v2.57H55.81a4.22,4.22,0,0,1-4.22-4.22H48.21a7.61,7.61,0,0,0,7.6,7.6h3.55v2.54H55.81a7.61,7.61,0,0,0-7.6,7.6h3.38a4.22,4.22,0,0,1,4.22-4.22h3.55a5.08,5.08,0,0,0,1.42,3.52,5.06,5.06,0,0,0,.84,7.73l-3.95,7.9S60.92,97,69.5,97s11.83-3.94,11.83-3.94l-4-7.9a5,5,0,0,0,.83-7.73,5,5,0,0,0,1.43-3.52h3.55a4.22,4.22,0,0,1,4.22,4.22h3.38a7.61,7.61,0,0,0-7.6-7.6H79.64V68h3.55a7.61,7.61,0,0,0,7.6-7.6H87.41a4.22,4.22,0,0,1-4.22,4.22H79.64V62a9.32,9.32,0,0,0,7.92-6.18Zm0,0' })
	                  ),
	                  'so2-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', {
	                              d: 'M69.5,5.92A56.58,56.58,0,1,0,126.08,62.5,56.58,56.58,0,0,0,69.5,5.92Zm0,107.33A50.75,50.75,0,1,1,120.25,62.5,50.75,50.75,0,0,1,69.5,113.25Z' }),
	                        _react2.default.createElement('rect', { x: '29.57', y: '93.33', width: '13.4', height: '6.33', transform: 'translate(-57.61 53.91) rotate(-45)' }),
	                        _react2.default.createElement('rect', { x: '89.59', y: '28.78', width: '22.45', height: '6.33', transform: 'translate(6.94 80.65) rotate(-45)' }),
	                        _react2.default.createElement('path', {
	                              d: 'M69.51,90.29H48.07a5.3,5.3,0,0,1-5.32-4,8.12,8.12,0,0,1,.25-3.5q1.55-7.95,3.1-15.9l1-5.11Q49.33,50.4,51.54,39a5.24,5.24,0,0,1,4.8-4.25c.25,0,.51,0,.76,0H81.86A5.13,5.13,0,0,1,87,37.87,15,15,0,0,1,87.76,41c1.27,6.36,2.51,12.73,3.77,19.1q2.35,12,4.73,23.91a5.15,5.15,0,0,1-4.76,6.23c-.27,0-.55,0-.82,0Zm11.41-3.48h9.74a4.84,4.84,0,0,0,.76,0,1.63,1.63,0,0,0,1.42-2c-.11-.59-.23-1.17-.35-1.76Q90.24,71.56,88,60.12,86,50,84,40a1.85,1.85,0,0,0-2.13-1.76H61.53c-1.56,0-3.12,0-4.68,0a1.77,1.77,0,0,0-1.92,1.61q-1,5.2-2,10.4c-.73,3.66-1.49,7.32-2.21,11-.33,1.69-.59,3.4-.92,5.1Q48,75.53,46.18,84.76a1.57,1.57,0,0,0,1.19,1.95,3.48,3.48,0,0,0,1,.1H80.92Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M69.19,53.44H81.32a3.57,3.57,0,0,1,4,3.23c.25,1.2.49,2.41.73,3.62l4,20.07a3.33,3.33,0,0,1-3.17,4.1c-3.37.06-6.75,0-10.12,0-1.08,0-2.17.06-3.26,0-1.66,0-3.32,0-5,0-1.86,0-3.72,0-5.58,0q-5.19,0-10.38,0A3.41,3.41,0,0,1,49,81.85a6.5,6.5,0,0,1,.11-2.15c.72-4.26,1.48-8.5,2.23-12.75.29-1.64.62-3.26.91-4.9.32-1.86.62-3.72.93-5.57a3.43,3.43,0,0,1,3.54-3c4.16,0,8.31,0,12.47,0Zm8.34,15.12a19.21,19.21,0,0,0-.32-2.15,5.66,5.66,0,0,0-4.4-4.53,6,6,0,0,0-6.24,2,7.67,7.67,0,0,0-1.38,6.94,5.6,5.6,0,0,0,4.57,4.62A6,6,0,0,0,76.27,73,8.08,8.08,0,0,0,77.53,68.56ZM62.39,64.69c.15-.55.29-1.15.49-1.73s0-.64-.41-.78a8.84,8.84,0,0,0-4-.34A3.9,3.9,0,0,0,55,64.49a3.4,3.4,0,0,0,1,3.88,8.64,8.64,0,0,0,1.74,1.09c.64.33,1.34.54,2,.88a1.31,1.31,0,0,1,.81,1.51A1.38,1.38,0,0,1,59.25,73a6.1,6.1,0,0,1-3.45-.47c-.2-.07-.38-.15-.6-.24-.18.73-.32,1.39-.5,2-.09.33,0,.5.3.62a8.15,8.15,0,0,0,6,.18,3.71,3.71,0,0,0,2.56-3.28,3.61,3.61,0,0,0-2-3.75c-.5-.29-1-.5-1.57-.75s-1.09-.48-1.61-.77a1,1,0,0,1-.53-1.25,1.71,1.71,0,0,1,.8-.86,2.17,2.17,0,0,1,1.21-.18C60.67,64.33,61.5,64.53,62.39,64.69Zm17.13,4.58a9.3,9.3,0,0,1,1.71-.46,1.08,1.08,0,0,1,1.14,1.55,4,4,0,0,1-.78,1.28,25.77,25.77,0,0,1-2.18,2.13A1.43,1.43,0,0,0,79,75.34c1.7,0,3.36,0,5,0a.46.46,0,0,0,.34-.27c0-.39,0-.79,0-1.25H81.51c.36-.32.6-.53.83-.75a5.74,5.74,0,0,0,1.78-2.43,2.42,2.42,0,0,0-2.27-3.32,5,5,0,0,0-1.55.18c-1.27.35-1.35.58-.81,1.74Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M74.35,68.36a6.48,6.48,0,0,1-.72,3.34,2.74,2.74,0,0,1-4.76.15A6.69,6.69,0,0,1,69,65.32a2.7,2.7,0,0,1,4.47,0A5.28,5.28,0,0,1,74.35,68.36Z' })
	                  ),
	                  'nuts-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', {
	                              d: 'M69.5,5.92A56.58,56.58,0,1,0,126.08,62.5,56.58,56.58,0,0,0,69.5,5.92Zm0,107.33A50.75,50.75,0,1,1,120.25,62.5,50.75,50.75,0,0,1,69.5,113.25Z' }),
	                        _react2.default.createElement('rect', { x: '27.06', y: '87.27', width: '30.55', height: '6.33', transform: 'translate(-51.55 56.42) rotate(-45)' }),
	                        _react2.default.createElement('rect', { x: '82.5', y: '31.72', width: '30.76', height: '6.33', transform: 'translate(4 79.43) rotate(-45)' }),
	                        _react2.default.createElement('path', {
	                              d: 'M77.69,42.89s-1.62,7.45-10.86,17S51.07,70.41,51.07,70.41c13.82,14.3,30.08,21.26,38.61,17.12A1.25,1.25,0,0,0,90,88a2.36,2.36,0,0,0,3.25-3.26.22.22,0,0,0-.09-.07c6-8.14-.61-26.4-15.46-41.77ZM82.8,62.62a1.69,1.69,0,0,1,2.88-1.77c8.11,13.24,5.37,21.47,5.25,21.82a1.64,1.64,0,0,1-2.13,1,1.4,1.4,0,0,1-.65-.4,1.68,1.68,0,0,1-.42-1.73c0-.07,2.26-7.2-4.93-18.95Zm0,0' }),
	                        _react2.default.createElement('path', {
	                              d: 'M51.15,44c-8.09,8.09-9.4,19.91-3.72,25.59,0,0,22.89-8.9,28.64-30-4.32-5.46-15.42-3.91-23.48,3a3.68,3.68,0,0,0-.31-.41,32.22,32.22,0,0,0-3.68-2.45c-.71-.42-1.45-1.1-2.33-1a3.57,3.57,0,0,0-2.57,1.2.26.26,0,0,0,0,.33,5.53,5.53,0,0,0,1.91,1.79c.59.38,1.32.12,2,.23s3,1.13,3.73,1.34l.13.06-.31.28Zm0,0' })
	                  ),
	                  'molluscs-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', {
	                              d: 'M69.5,5.92A56.58,56.58,0,1,0,126.08,62.5,56.58,56.58,0,0,0,69.5,5.92Zm0,107.33A50.75,50.75,0,1,1,120.25,62.5,50.75,50.75,0,0,1,69.5,113.25Z' }),
	                        _react2.default.createElement('rect', { x: '28.73', y: '91.3', width: '19.15', height: '6.33', transform: 'translate(-55.58 54.75) rotate(-45)' }),
	                        _react2.default.createElement('rect', { x: '88.99', y: '29.03', width: '23.16', height: '6.33', transform: 'translate(6.69 80.54) rotate(-45)' }),
	                        _react2.default.createElement('path', {
	                              d: 'M69.89,89.75h-.64a1.29,1.29,0,0,0-.19,0,4.74,4.74,0,0,1-2.39-.93L42.42,70.85A10.06,10.06,0,0,1,41,69.57a4.05,4.05,0,0,1-1-1.87c-.08-.39-.12-.8-.17-1.2s-.07-.68-.1-1V63.19a3.58,3.58,0,0,0,.09-.35c0-.25,0-.5.06-.74a2.75,2.75,0,0,1,.67-1.49,1,1,0,0,1,1.13-.31,2,2,0,0,1,.76.39,11.54,11.54,0,0,1,.9.81L59.31,78.11,62.11,81a.48.48,0,0,0,.72,0,.32.32,0,0,0,.05-.43.69.69,0,0,0-.11-.13L62,79.55,51.67,68l-7.75-8.71-1.5-1.69a2.57,2.57,0,0,1-.63-1.88A6.67,6.67,0,0,1,42.14,54q.39-1.15.84-2.28a10.57,10.57,0,0,1,.67-1.4,4.44,4.44,0,0,1,1.78-1.71,1.38,1.38,0,0,1,1.85.35,4.7,4.7,0,0,1,.5.73L64.39,79.07a.93.93,0,0,0,.11.19.32.32,0,0,0,.41.13.43.43,0,0,0,.26-.6l-.1-.19L57.19,63.47,48.57,47a5.25,5.25,0,0,1-.5-1.39,1.83,1.83,0,0,1,.39-1.65c.15-.16.29-.32.45-.47A35.25,35.25,0,0,1,53.42,40a10.13,10.13,0,0,1,1.27-.65,2.06,2.06,0,0,1,.6-.17,1,1,0,0,1,1.12.5,3.36,3.36,0,0,1,.45,1.09L60.7,55.14q2.14,8,4.28,16c.61,2.24,1.2,4.49,1.8,6.74a1.54,1.54,0,0,0,.11.3.4.4,0,0,0,.47.18.36.36,0,0,0,.26-.4,1.25,1.25,0,0,0,0-.19c-.06-.24-.11-.48-.17-.73L64.87,66.19q-1.28-5.43-2.56-10.86t-2.6-11.07L58.48,39a1.54,1.54,0,0,1,.76-1.84,4.07,4.07,0,0,1,.66-.33l1.16-.43a21.09,21.09,0,0,1,4.36-1.09c.16,0,.31,0,.46-.07h1l.16,0a1.71,1.71,0,0,1,1.41,1.24,3.83,3.83,0,0,1,.15,1.12c0,3.71.07,7.42.1,11.12l.09,10.43q.06,8,.14,16c0,.87,0,1.75,0,2.62a.5.5,0,0,0,.54.52.5.5,0,0,0,.53-.5v-.2q.06-6.15.11-12.31c0-3.08,0-6.16.08-9.24q.06-7.43.13-14.86c0-1.31,0-2.62,0-3.94a2.32,2.32,0,0,1,.2-.93,1.6,1.6,0,0,1,1.18-1l.3-.09h1l.19,0c.58.09,1.16.15,1.73.27a26.32,26.32,0,0,1,4.18,1.31,3.28,3.28,0,0,1,.71.39,1.45,1.45,0,0,1,.64,1.6c-.19.87-.4,1.73-.61,2.6q-1.36,5.85-2.75,11.7l-2.7,11.49q-1.42,6.07-2.86,12.16c-.08.36-.17.72-.25,1.08a.38.38,0,0,0,.26.47.4.4,0,0,0,.49-.23,1.29,1.29,0,0,0,.07-.21c.06-.2.11-.4.16-.6q2.49-9.31,5-18.63,2-7.46,4-14.89l.84-3.18a3,3,0,0,1,.46-1,1,1,0,0,1,1.06-.45,2.14,2.14,0,0,1,.55.15,12.27,12.27,0,0,1,1.44.75A34,34,0,0,1,90,43.33a6.56,6.56,0,0,1,.67.72A1.62,1.62,0,0,1,91,45.33,4.75,4.75,0,0,1,90.47,47L84.92,57.63,74,78.61c0,.09-.09.16-.12.25a.45.45,0,0,0,.26.53.36.36,0,0,0,.48-.19.56.56,0,0,1,.05-.08q5.79-10.26,11.6-20.52l5.1-9a3.07,3.07,0,0,1,.58-.76,1.34,1.34,0,0,1,1.47-.29,2.59,2.59,0,0,1,.61.33,4.86,4.86,0,0,1,1.55,1.73c.16.31.31.62.44.94.26.66.5,1.33.75,2a7.66,7.66,0,0,1,.52,2.21,2.39,2.39,0,0,1-.47,1.65,6,6,0,0,1-.39.49L89.19,66l-12.42,14-.54.62a.32.32,0,0,0-.08.36.48.48,0,0,0,.74.17l.18-.17c1.09-1.15,2.19-2.29,3.29-3.44l15.31-16a10.22,10.22,0,0,1,.84-.77,2,2,0,0,1,.8-.43,1.08,1.08,0,0,1,1.21.35,2.72,2.72,0,0,1,.59,1.26,8.39,8.39,0,0,1,.11,1.23c0,.79,0,1.59,0,2.38,0,.54,0,1.09-.1,1.63a4.17,4.17,0,0,1-1.05,2.38,8.64,8.64,0,0,1-1.41,1.29l-24.37,18a4.32,4.32,0,0,1-1.89.81Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M81,89.46H77.28q-.34,0-.69-.06a.82.82,0,0,1-.3-.1.63.63,0,0,1-.37-.87,1.78,1.78,0,0,1,.68-.83l.72-.52c2.68-1.89,5.35-3.79,8-5.77a12.45,12.45,0,0,1,1-.74,5.3,5.3,0,0,1,.77-.34,1.08,1.08,0,0,1,.36,0,.75.75,0,0,1,.78.53,1.72,1.72,0,0,1,.1.87c-.07.59-.16,1.18-.24,1.77l-.42,2.94c-.07.46-.16.92-.25,1.38a1.6,1.6,0,0,1-.1.31,2,2,0,0,1-1.63,1.37,9.15,9.15,0,0,1-1,.1H81Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M58.1,89.45H54.39a7.25,7.25,0,0,1-1.23-.15,1.85,1.85,0,0,1-1.36-1.15,5.15,5.15,0,0,1-.34-1.28c-.19-1.33-.38-2.65-.56-4-.07-.47-.14-.93-.18-1.4a1.94,1.94,0,0,1,0-.59.84.84,0,0,1,1.12-.7,2.22,2.22,0,0,1,.66.26,6.91,6.91,0,0,1,.86.54C56,83,58.56,84.83,61.18,86.69c.4.29.81.56,1.21.86a5.57,5.57,0,0,1,.51.46,1.73,1.73,0,0,1,.2.32.68.68,0,0,1-.43,1,2.68,2.68,0,0,1-.85.11H58.1Z' })
	                  ),
	                  'mustard-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', {
	                              d: 'M69.5,5.92A56.58,56.58,0,1,0,126.08,62.5,56.58,56.58,0,0,0,69.5,5.92Zm0,107.33A50.75,50.75,0,1,1,120.25,62.5,50.75,50.75,0,0,1,69.5,113.25Z' }),
	                        _react2.default.createElement('rect', { x: '25.77', y: '84.16', width: '39.33', height: '6.33', transform: 'translate(-48.44 57.71) rotate(-45)' }),
	                        _react2.default.createElement('rect', { x: '77.22', y: '33.9', width: '36.95', height: '6.33', transform: 'translate(1.82 78.52) rotate(-45)' }),
	                        _react2.default.createElement('path', {
	                              d: 'M81.87,57.72l15,14.53c1.41,1.37,1.43,2.38.06,3.8Q91.45,81.78,85.9,87.51c-1.21,1.25-2.3,1.27-3.56.06L51.9,58.16a2.1,2.1,0,0,1,0-3.41Q57.43,49,63,43.22c1.42-1.47,2.34-1.47,3.83,0Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M62,42.73,51.53,53.56c-1-1-2-1.87-2.92-2.89a1.3,1.3,0,0,1,.1-1.26c3-3.16,6-6.27,9-9.38a1,1,0,0,1,1.45,0C60.11,40.88,61,41.78,62,42.73Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M54.19,42.18l-3.48,3.6L48,42.27c-1-1.26-1.93-2.54-2.91-3.79a.92.92,0,0,1,.08-1.42c.44-.45.83-.76,1.46-.3C49.11,38.56,51.61,40.34,54.19,42.18Z' })
	                  ),
	                  'fish-intolerance-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', {
	                              d: 'M69.5,5.92A56.58,56.58,0,1,0,126.08,62.5,56.58,56.58,0,0,0,69.5,5.92Zm0,107.33A50.75,50.75,0,1,1,120.25,62.5,50.75,50.75,0,0,1,69.5,113.25Z' }),
	                        _react2.default.createElement('rect', { x: '28.3', y: '90.28', width: '22.04', height: '6.33', transform: 'translate(-54.56 55.17) rotate(-45)' }),
	                        _react2.default.createElement('rect', { x: '80.04', y: '32.74', width: '33.65', height: '6.33', transform: 'translate(2.98 79.01) rotate(-45)' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M100.77,62.5a14.32,14.32,0,0,0,5.45-11.26,15.22,15.22,0,0,0-.11-1.79,13.53,13.53,0,0,0-1.81-.12,13.16,13.16,0,0,0-13,10.91h0c-2.49-3.19-8.89-8.1-16.44-11.67h0l5.39-8.23c-11.79-3.81-18.52,4-18.52,4h0a29.87,29.87,0,0,0-4.18-.32,19.76,19.76,0,0,0-4.93.63,30.49,30.49,0,0,1,0,35.64,19.76,19.76,0,0,0,4.93.63,29.87,29.87,0,0,0,4.18-.32h0s6.73,7.84,18.52,4l-5.39-8.23h0c7.54-3.57,14-8.48,16.44-11.67h0a13.16,13.16,0,0,0,13,10.91,13.53,13.53,0,0,0,1.81-.12,15.22,15.22,0,0,0,.11-1.79A14.34,14.34,0,0,0,100.77,62.5Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M48.44,46.24c-10,4.88-15.66,16.26-15.66,16.26s5.65,11.38,15.66,16.26a26.15,26.15,0,0,0,0-32.52ZM45.9,60.71a2.15,2.15,0,1,1,2.15-2.15A2.16,2.16,0,0,1,45.9,60.71Z' })
	                  ),
	                  'sesame-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', {
	                              d: 'M69.5,5.92A56.58,56.58,0,1,0,126.08,62.5,56.58,56.58,0,0,0,69.5,5.92Zm0,107.33A50.75,50.75,0,1,1,120.25,62.5,50.75,50.75,0,0,1,69.5,113.25Z' }),
	                        _react2.default.createElement('rect', { x: '27.72', y: '88.86', width: '26.04', height: '6.33', transform: 'translate(-53.14 55.76) rotate(-45)' }),
	                        _react2.default.createElement('rect', { x: '96.5', y: '25.92', width: '14.36', height: '6.33', transform: 'translate(9.8 81.83) rotate(-45)' }),
	                        _react2.default.createElement('path', {
	                              d: 'M69.51,61C63.18,65.88,58,71.07,56.81,78,56,83,57.58,87.74,62.17,91.6a11.15,11.15,0,0,0,15-.22c4.23-3.78,5.78-8.33,5.11-13.14C81.28,71.19,75.91,65.91,69.51,61Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M71.35,57.22c6.93,4,13.7,6.9,20.5,5.37,5-1.13,8.78-4.4,10.64-10.1A11.16,11.16,0,0,0,96.64,38.7c-5.09-2.5-9.89-2.22-14.1.21C76.38,42.47,73.51,49.43,71.35,57.22Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M67.65,57.22c-6.93,4-13.7,6.9-20.5,5.37-5-1.13-8.78-4.4-10.64-10.1A11.16,11.16,0,0,1,42.36,38.7c5.09-2.5,9.89-2.22,14.1.21C62.62,42.47,65.49,49.43,67.65,57.22Z' })
	                  ),
	                  'lactose-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M314.1 588.2C159.9 588.6 37.8 468.1 36.3 314 34.8 160.7 158.9 36.3 313.6 36.2 466 36.2 591.1 160.3 591.3 312 591.5 463.4 466.8 587.8 314.1 588.2zM152 499.8c66.2 55.6 141.6 75 225.9 51 98.9-28.1 161.4-94.5 180-196.4 14.1-77.1-0.3-139.4-55.9-202.9 -52.1 52-77.7 77.4-77.7 77.4l-1.2-45.5c0 0 30.3-29.6 55.5-54.3 -94.8-93.1-260.6-83.7-353 20.6 -94.3 106.4-67.4 258.6 1.6 323.8 25.9-24 60.6-59.3 60.6-59.3l-2.1 51.8C180.3 471.6 159.6 491.6 152 499.8z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M263.1 379.9c0-40.9 0-81.9 0-122.9 41.9 0 83.9 0 125.9 0 0 40.9 0 81.9 0 122.9C347 379.9 305.1 379.9 263.1 379.9zM326.9 373.2c31.1 0.1 56.4-24.8 56.7-55.8 0.3-30.6-25.2-56.3-56.1-56.4 -31.5-0.1-56.7 24.9-56.7 56.2C270.8 348.4 295.5 373.1 326.9 373.2z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M348.1 300.3c5.5-5.8 10.6-11.3 15.6-16.7 13.8 11.1 21.5 42.7 2.2 65.8 -17.9 21.4-51.6 24.2-72.7 4.7 2.9-2.6 5.7-5.4 8.7-7.9 3.4-2.8 4.9-6.1 3.3-11.1 -5.4 5-10.6 9.8-16.4 15.1 -9.7-11.3-13.9-24.5-11.9-39.3 2.7-20 13.8-34 32.8-41.1 18.4-6.9 35.2-3.1 50.9 9.5 -5.8 5.3-11.3 10.3-16.9 15.3C345.6 297 346.6 298.3 348.1 300.3zM310 325.5C310 325.5 310.1 325.5 310 325.5c0 6.8 0 13.6 0 20.5 0.1 5.2 1.8 6.9 6.9 6.9 6.7 0.1 13.3 0 20 0 6 0 7-1 7.1-6.9 0-10.5-0.5-21 0.2-31.4 0.5-8.5-0.7-15.6-8.1-20.9 -2.8-2-3-4.8-0.3-7.6 2.3-2.4 1.6-4.5-1.7-4.7 -4.6-0.3-9.3-0.2-14 0 -2.6 0.1-4.2 2.2-2.4 3.9 4.9 4.7 1.8 7.7-1.7 10.5 -4.8 3.9-6.7 8.6-6.1 14.8C310.5 315.4 310 320.5 310 325.5z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M320.5 295c1.4 3 2.9 4.9 2.5 5.7 -0.9 1.8-2.9 3-4.5 4.4 -0.9-1.3-2.8-2.8-2.6-3.7C316.6 299.5 318.3 298 320.5 295z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M363.2 178.4c-16-11.3-17.2-27.5-1.6-43.5 13.1-13.5 9-25.6-9.7-26.9 -26.5-1.9-53.3-1.1-79.9-0.3 -14.7 0.5-23.8 12.9-13.7 22.5 27.9 26.8 10.2 43.8-9.7 60 -27.4 22.3-38.5 49-34.6 84.6 3 28.2 0.6 57.1 0.6 85.6 0.1 0 0.1 0 0.2 0 0 39-0.3 78.1 0.1 117.1 0.3 29.5 10.3 39.4 39.4 39.7 38.1 0.3 76.1 0.2 114.2 0 34.5-0.1 40.3-5.7 40.4-39.4 0.2-60-2.6-120.1 0.9-179.9C412.6 249.4 405.8 208.5 363.2 178.4zM292.8 218.4c-7.6 13.1-21.7 19.1-31.6 13.3 -9.9-5.7-11.8-21-4.3-34.1 7.6-13.1 21.7-19.1 31.6-13.3C298.4 190 300.3 205.3 292.8 218.4z' })
	                  ),
	                  'vegetarian': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M342.5 405.2c-65.4 0-130.8 0-196.4 0 0-71.9 0-143.7 0-215.8 65.4 0 130.9 0 196.4 0C342.5 261.3 342.5 333.2 342.5 405.2zM263.3 294c0.8 0.2 1.7 0.5 2.5 0.7 0.9-2.2 2.6-4.5 2.6-6.7 0-9.9-0.5-19.9-0.6-29.8 0-2.1 1.4-4.2 2-6.3 0.4-1.7 1.4-4.3 0.7-5.2 -5.6-7.1-12.5-12.5-21.4-15.9 -2.1 7.2-5 14.3 0.3 20.7 2.2 2.7 3.1 5 3 8.2 -0.1 2.7-0.3 5.6 0.2 8.2 0.6 2.8 2 5.4 3.1 8 0.6-0.2 1.2-0.4 1.7-0.6 0-6.6 0-13.2 0-19.6 4.7-1.5 5.9 0.5 5.9 4.4C263.2 271.4 263.3 282.7 263.3 294zM226.9 303.3c0.5 0.2 0.9 0.4 1.4 0.7 1-2 2.8-3.9 3-5.9 0.9-8.7 1.2-17.4 2.2-26.1 0.3-2.6 2-5 2.9-7.5 0.5-1.3 1.5-3.1 1-3.9 -4.5-7.3-10.6-13-18.5-17.2 -2.6 6.1-5.9 12.1-2.5 17.3 3.7 5.6 2.5 10.9 2.4 16.5 0 2.8 1.2 5.7 1.8 8.5 0.5-0.1 1-0.2 1.5-0.3 0.6-6.1 1.2-12.1 1.9-18.4 2 0.2 3.5 0.3 5.6 0.5C228.6 279.6 227.8 291.5 226.9 303.3zM252 324.4c-0.6 0.2-1.2 0.3-1.8 0.5 -1.7 11.3-3.5 22.6-5 33.9 -0.5 3.3 1.2 5.6 4.5 6.4 2.2 0.5 4.4 0.8 6.6 1.1 4.2 0.7 6.6-1.2 7.2-5.3 0.9-6.4 1.6-12.9 2.4-19.3 0.1-0.5-0.1-1-0.2-1.7 -1.5 0.4-2.9 0.7-4.1 1 -1 7.3-1.9 14.1-2.9 21.2 -3.5-0.7-5.9-1.2-8.8-1.7 0.3-2 0.5-3.7 0.7-5.3 1.1-8 2.5-15.9 3.3-23.9C253.9 329 252.6 326.7 252 324.4zM207.3 363.3c2.3-9.5 4.5-18 6.3-26.7 0.4-2-0.7-4.3-1.2-6.4 -0.5 0.1-1 0.2-1.6 0.3 -2.6 10.3-5.4 20.5-7.5 30.9 -0.4 1.8 1.7 4.8 3.5 6.3 1.5 1.3 4.2 1.4 6.3 1.8 3.4 0.7 5.7-0.9 6.5-4.2 1.5-6.3 2.9-12.6 4.4-19 -0.5-0.2-1-0.4-1.5-0.6 -7.4 4.2-3.2 14.1-8.3 19.7C212.3 364.7 210.1 364.1 207.3 363.3zM250.1 227.4c4.4 2.5 8.2 4.7 12 6.9 1.6-1.6 3.3-3 4.7-4.6 0.8-0.9 1.8-2.5 1.5-3.2 -2.5-5.7-5.4-11.4-8.8-18.3C256 215.6 253.1 221.4 250.1 227.4zM231 248.1c2.1-2.4 6.2-5 5.9-6.8 -1-5.6-3.7-10.9-6.3-17.7 -4.2 6.6-7.4 11.7-10.6 16.8C223.8 243.1 227 245.3 231 248.1zM270.6 326c-0.5-0.4-0.9-0.8-1.4-1.1 -3 2.1-6.1 4.1-9 6.5 -2 1.7-2.9 4-0.4 6.1 2.5 2.1 4.9 1.4 6.3-1.3C268 332.8 269.2 329.3 270.6 326zM270.4 294.6c-0.4-0.4-0.9-0.9-1.3-1.3 -2.6 2.7-5.4 5.2-7.7 8.2 -1.8 2.3-1.9 5.3 1.4 6.1 1.5 0.4 4.6-1.2 5.3-2.6C269.4 301.7 269.7 298 270.4 294.6zM251.3 309.8c-0.6 0.3-1.1 0.6-1.7 0.9 0.6 3.7 0.8 7.5 2 10.9 0.5 1.4 3.4 2.9 4.9 2.6 3-0.5 3.5-3.3 2-5.6C256.5 315.4 253.8 312.7 251.3 309.8zM252.9 274.2c-0.7 0.2-1.3 0.3-2 0.5 0 3.8-0.4 7.7 0.2 11.4 0.2 1.4 2.9 3.3 4.4 3.3 2.8-0.1 4.1-2.5 2.8-5.2C256.7 280.7 254.8 277.5 252.9 274.2zM256.9 291.8c-1.8 0-3.1 0-5.1 0 2.1 6.3-3.7 13.5 4 19.6C256.2 304.1 256.5 298.1 256.9 291.8zM213.6 316.8c-0.4 0.2-0.8 0.4-1.3 0.5 0 3.2-0.5 6.5 0.2 9.4 0.4 1.5 3.3 3.6 4.8 3.4 3.1-0.4 3.2-3.2 1.7-5.6C217.4 321.9 215.4 319.4 213.6 316.8zM218.4 283.8c-0.6 0.1-1.2 0.2-1.8 0.4 -0.5 3.5-1.3 7-1.2 10.5 0 1.2 2.5 2.4 3.8 3.6 1.1-1.4 3.2-3.1 3-4.2C221.4 290.5 219.7 287.1 218.4 283.8zM232.5 304.2c-0.4-0.3-0.8-0.7-1.3-1 -2.5 2.1-5.2 4.1-7.5 6.5 -1.9 1.9-2.3 4.3 0.5 6 2.8 1.7 4.6 0.1 5.5-2.3C230.9 310.3 231.6 307.2 232.5 304.2zM229.7 333.3c-0.4-0.3-0.7-0.6-1.1-1 -2.9 1.6-5.8 3-8.5 4.8 -2.2 1.5-3.1 3.7-0.9 6 2.4 2.4 4.5 0.9 5.9-1.1C226.9 339.3 228.2 336.2 229.7 333.3zM268.5 310c-0.5-0.3-1-0.7-1.5-1 -1.2 1.3-3.2 2.4-3.4 3.8 -0.7 4.3-0.7 8.8-1 13.9C270.8 322.5 266.3 315.2 268.5 310zM217.8 299.4c-0.6 0.3-1.3 0.7-1.9 1 0.7 5.6-4.6 11.6 1.5 18.1 1-5.8 1.9-10.4 2.4-15.1C219.9 302.2 218.5 300.8 217.8 299.4zM229.7 318.1c-5.4 0.5-7 4.7-6.5 15C230.2 330 226.8 323.1 229.7 318.1zM271.8 243c0.4-0.2 0.8-0.4 1.2-0.6 -0.8-3.7-1.6-7.3-2.7-12.2 -2.4 2.7-4 4.4-5.6 6.1C267.4 238.9 269.6 241 271.8 243zM238.7 257c0.4-0.1 0.8-0.3 1.2-0.4 -0.5-3.5-0.9-7-1.5-11.6 -2.5 2.3-4 3.7-5.6 5.2C235 252.7 236.9 254.8 238.7 257z' }),
	                        _react2.default.createElement('path', { d: 'M387.1 325.7c0-37.4-0.2-74.7 0.1-112.1 0.1-13.1-3.9-19.7-19.5-14.7 0 21.2 0 43.1 0 64.9 -1.9 0.7-14-15.4-15.9-24.6 -1.8-8.7-1-18.1-0.7-27.1 0.3-10.5-2.5-18.3-9.8-27.1 -17.5-21.3-8.1-44.8-1.1-68.7 29.3 11.3 52.2 29.3 70.6 52.7 2.5 3.2-0.7 11.5-2.2 17.3 -1.8 7.1-6.6 14-6.6 21 0.1 32.9 2.1 65.7 1.9 98.6C404 313.3 389.8 326.5 387.1 325.7z' }),
	                        _react2.default.createElement('path', { d: 'M266.7 356.5c2.9-39.2 5.7-78.4 8.6-118.5 -6.8-0.6-11.7-1-18.4-1.6 -2.1 20.9-4.2 40.9-6.2 61 -1.7 0.4-11.1-17.7-10.9-27.1 0.3-18.7 4-36.1-8-54.7 -11.2-17.2-0.1-37.1 8.4-57.4 26.2 13.9 46.3 32.7 61.3 57 1.6 2.6-1.7 8.6-3.3 12.8 -3.1 8.4-8.7 16.4-9.7 24.9 -3.1 28.7-4.1 57.6-7.2 86.3C280.6 345.9 268.3 357.2 266.7 356.5z' }),
	                        _react2.default.createElement('path', { d: 'M355.4 448.8c-2.7 26.4-7.1 52.7-10.8 79 -0.8 5.5-1.5 10.9-2.4 17.6 9.5 1.9 17.6 3.5 29.1 5.7 3.2-23.3 6.3-45.9 9.6-70 4.1-1 14.7 0.7 14.5 2.3 -2.6 21.3-5.1 42.7-7.9 64 -1.8 13.7-9.9 19.7-23.7 17.6 -7.3-1.1-14.6-2.1-21.7-3.6 -11.2-2.4-16.6-10.1-15-21.1 5.2-37.5 11.1-74.9 16.7-112.3C345.6 427.4 356.1 441.6 355.4 448.8z' }),
	                        _react2.default.createElement('path', { d: 'M202 555.1c8.9 2.5 16.4 4.5 23.3 6.5 16-14.2 8.8-59 27.6-65.3 1.7 0.7 3.3 1.4 5 2.1 -4.8 20.9-9.3 41.9-14.4 62.7 -2.7 11-10.2 16.1-21.6 13.8 -7.2-1.4-15.9-1.6-21-5.9 -5.8-4.9-12.8-14.6-11.6-20.7 6.9-34.3 16.2-68.1 24.7-102.1 1.7-0.3 10.3 13.8 9 20.4C217 495.4 209.5 523.8 202 555.1z' }),
	                        _react2.default.createElement('path', { d: 'M343.5 105.2c9.7-19.6 19.4-39 31.6-63.6 11.2 23 20.6 41.6 29 60.6 1.1 2.4-2.5 7.7-5.1 10.6 -4.7 5.4-10.3 10.1-15.7 15.2C370.6 120.7 358 113.5 343.5 105.2z' }),
	                        _react2.default.createElement('path', { d: 'M280.3 173.8c-13.2-9.3-23.8-16.7-36.3-25.5 10.6-16.8 21.2-33.8 35-55.7 8.5 22.5 17.5 40 20.8 58.6C300.9 157.3 287.4 166.1 280.3 173.8z' }),
	                        _react2.default.createElement('path', { d: 'M365.4 328.1c-1.2 20.6-1.8 31-3.2 55.2 -25.3-20-6.3-44-13.2-64.8C355.5 318.5 359.4 328.1 365.4 328.1z' }),
	                        _react2.default.createElement('path', { d: 'M251.2 325.6c0.8 3.7-2 12.4-9.9 13.9 -9.1 0.6-12.4-7.8-12.5-11.9 -0.5-11.5 4.3-39.7 5.3-39.9C235.1 287.5 248.6 313.9 251.2 325.6z' }),
	                        _react2.default.createElement('path', { d: 'M373.7 295.9c1.6 3.9 0.1 14.2-8.3 17.2 -10 2.3-15.1-6.3-16.1-10.8 -2.6-12.6-2.6-44.8-1.5-45.2C348.7 256.7 368.6 283.5 373.7 295.9z' }),
	                        _react2.default.createElement('path', { d: 'M369 411.1c1.7 4.1 0.1 14.8-8.7 18 -10.4 2.4-15.8-6.6-16.8-11.3 -2.8-13.2-2.7-46.7-1.6-47.2C343 370.2 363.7 398.1 369 411.1z' }),
	                        _react2.default.createElement('path', { d: 'M253.2 383.5c-2.3 3-3.3 12.2 3.2 16.7 8.1 4.3 14.5-1.9 16.3-5.6 5.2-10.2 12.5-37.9 11.7-38.5C283.6 355.6 260.4 374 253.2 383.5z' }),
	                        _react2.default.createElement('path', { d: 'M377.6 356.4c-2.6 3.4-3.8 13.8 3.7 19.1 9.2 4.9 16.5-2.2 18.6-6.4 5.9-11.7 14.3-43.2 13.3-43.9C412.3 324.5 385.8 345.5 377.6 356.4z' }),
	                        _react2.default.createElement('path', { d: 'M371.5 455.6c-2.7 3-4.6 12.7 2 18.2 8.3 5.3 15.7-0.9 18-4.6 6.4-10.5 16.6-39.6 15.8-40.3C406.5 428.2 380 446 371.5 455.6z' }),
	                        _react2.default.createElement('path', { d: 'M238.4 474c-2.8 2.6-5.3 11.4 0.4 17 7.2 5.6 14.6 0.5 17-2.8 6.8-9.2 18.7-35.3 18-36C273.1 451.5 247.1 465.8 238.4 474z' }),
	                        _react2.default.createElement('path', { d: 'M238.6 431c1 3.7-1.5 12.5-9.3 14.3 -9.1 0.9-12.6-7.3-13-11.4 -0.9-11.4 2.8-39.8 3.8-40.1C221 393.6 235.5 419.5 238.6 431z' }),
	                        _react2.default.createElement('path', { d: 'M404.2 378.5c-7 17.3 7.7 41.4-19.3 55.2 1-17.1 1-31.8 3.2-46.1C388.7 383 402.5 377.3 404.2 378.5z' }),
	                        _react2.default.createElement('path', { d: 'M243.1 356.7c-1.5 15.5-4.7 30.9-7.9 50.1 -20.4-21.5-2.7-41.2-5.1-59.7C232.3 345.9 243.5 352.6 243.1 356.7z' }),
	                        _react2.default.createElement('path', { d: 'M275.8 405.2c-9.5 16.7 1.9 39.6-21.5 49.6C252.7 420.9 258 406.8 275.8 405.2z' }),
	                        _react2.default.createElement('path', { d: 'M415.1 157c-7.3-6.9-14.5-13.7-23.3-22 5.3-5.8 10.3-11.3 18.4-20.2C413.8 130.9 416.5 156.4 415.1 157z' }),
	                        _react2.default.createElement('path', { d: 'M305.7 203.1c-6.1-7-12.3-14-19.8-22.6 5.2-4.9 10.2-9.5 18.5-17.2C306.5 178.6 307 202.7 305.7 203.1z' })
	                  ),
	                  'vegan': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M412.4 362c-61.4 0-122.7 0-184 0 0-58.6 0-117.2 0-175.8 61.4 0 122.7 0 184 0C412.4 244.8 412.4 303.5 412.4 362zM338.8 262.2c-3.2-0.3-6.3-0.4-9.3-0.8 -1-0.1-2.6-0.6-2.9-1.3 -1.1-3.2-2.6-6.5-2.6-9.7 0.4-17.8-11.6-29.1-29.3-27.3 -1.9 0.2-4.1-0.1-5.8-0.9 -9.5-4.6-18.7-4.2-27.1 2.3 -8.5 6.6-11.3 15.5-8.9 26.1 0.3 1.5 0.1 3.9-0.9 5 -14.1 14.5-6 40.1 16 42.5 1.4 0.1 3 1.4 3.8 2.6 7.9 12.8 19.2 16.7 33 11.5 1.4-0.5 4.3-0.1 5.1 1 3.9 4.9 7.5 10.1 11 15.4 1.5 2.3 2.6 4.1 5.9 3.7 3.4-0.3 4-2.4 4.9-4.9 2.4-6.2 5.1-12.3 7.8-18.3 1.3-3 3.5-3.9 6.9-4.1 13.7-0.9 22.8-10.5 23.9-24.3 0.1-1.9 1.4-4.1 2.8-5.5 8.6-8.6 10.7-21.6 3.9-31.5 -2.6-3.8-3.8-7.7-4.6-12.1 -1.7-9.9-7.8-16.3-17.2-19.2 -9.5-2.9-18-0.5-25 6.5 -2.5 2.6-4.5 5.4-8.5 5.9 -1 0.1-2.3 2.3-2.5 3.8 -0.2 0.8 1.2 2.4 2.2 2.9 3.1 1.4 9.8-1.1 11.7-4 4.8-7.3 12.3-10.3 19.9-8.1 7.8 2.3 12.4 9.3 12.7 17.9 0.1 2.4 1.2 5.2 2.8 7 7.5 8.3 6.8 20-2.2 26.5 -3.1 2.2-4 4.4-3.7 8.1 0.7 7.3-2.5 13.1-9 16.5 -6.5 3.4-12.7 2.6-18.9-1.5 -2.8-1.8-6.1-3-9.3-3.8 -1.3-0.3-3.1 1.2-4.7 1.9 0.8 1.7 1.2 3.8 2.5 4.8 1.6 1.3 4 1.6 6.3 2.5 -1.6 4.4-3.1 8.5-4.5 12.4 -10.5-7.2-8.3-18.2-4.8-26.4 3.2-7.5 7.9-14.1 7.1-22.7 9.7 0.1 11.6 2 12.7 10.3 0.7 5.3 2.2 10.5 3.4 15.8 0.8-6.6-3.1-13.8 4.4-18.9 -1.5 0.5-2.9 1-5 1.7 0.3-4.2-0.4-8.2 1.1-11.2 1.3-2.7 4.9-4.2 7.6-6.3 -2 0-4.2 0-7.2 0 1.6-6.2 3-11.8 4.5-17.5 -0.3-0.1-0.5-0.2-0.8-0.2 -1.8 3.6-3.6 7.1-5.5 10.9 -2.6-3-4.9-5.7-7.2-8.3C338.5 246.4 343.3 253.4 338.8 262.2z' }),
	                        _react2.default.createElement('path', { d: 'M412.3 266.2c19.1-37.3 3.4-68.8-16-97.7 9.7 11.2 19.4 22.3 30.4 34.9 4.7-18.9 21-40.8 26.5-44.6 -8.7 18.3-15 41.6-18.7 73.5 12.6-5.8 25.2-6.5 33.8-6.5 -10.8 2.9-27.6 3.8-33 14.9 -6.1 12.5-5.6 44.1-6.9 61.6 8.9-5.8 18.7-2.6 25.4-3.1 -10.5 2.7-17 4.5-25.1 10.4 -4.7 19.9-2.7 42.9 2 67.6 -7-21.5-11.3-43.9-14.2-66.2 -4.5-34.7-12.7-42.7-53.2-43.3 3.4 36-16.3 63.8-29.6 95.2 -14.6 34.3-23.6 80.7 20.3 110.8 9.6-13.7 17.1-30.1 18.7-51.9 -9.8-3.6-19.7-5-26.5-10.4 -5.5-4.3-12.7-8.3-10.6-20.2 3.7-5.9 14-9.2 19.5-7.8 13.6 3.3 27.5 8.3 39.1 15.9 25.8 17 52.1 20.5 79.3 6.1 27.3-14.5 40.7-38.6 37.9-69.4 -1.4-15.5 2.6-24.8 15.5-34 38-27.4 40.9-76.5 9.4-111.2 -6.8-7.5-11.6-19.4-11.9-29.5 -1-36.4-20.5-65.6-53.1-75.3 -31.8-9.4-63.3 3.3-83.4 33.8 -7.9 12-36.2 22.3-49.1 16.6 -4.3-1.9-9.9-8.7-9.3-12.2 1.2-6 6.3-15.2 10.6-15.8 16.9-2.1 25.2-13.8 35.9-24.6 29.1-29.4 65-39.7 104.8-27.4 39.4 12.2 65 39.3 72.1 80.6 3.2 18.5 8.3 34.6 19.3 50.7 28.4 41.3 19.8 96.1-16.4 132 -5.9 5.8-11.2 15-11.8 23 -4.5 57.8-42.7 98.3-100.1 102 -14 0.9-23.4 4.8-28.8 17.2 -11.2 25.5-22.5 51-32.6 77 -4.1 10.5-6.6 19.2-20.7 20.7 -13.9 1.4-18.4-6.1-24.7-15.7 -14.4-22.2-29.5-44-45.9-64.6 -3.6-4.5-15.4-6.4-21.5-4.2 -57.7 21.8-105.1 5.3-138.3-48.3 -3.1-5.1-10.2-10.2-15.9-10.8 -92.4-9.8-126.3-117.3-67-178.2 4.2-4.3 5.3-14.3 3.8-20.8 -9.8-44.4 1.8-81.8 37.4-109.6 35-27.3 73.5-28.9 113.6-9.7 7.2 3.4 16.4 4.8 24.4 3.9 74.1-7.8 124.4 39.5 122.7 114.4 -0.3 13.5 6.1 27.4 10.8 40.7 1.1 3 7.7 5 12.1 5.6C385.6 262.6 400.4 263.6 412.3 266.2zM149.9 382.6c1.9 6.5 3.4 11.8 5.1 17.2 12.1 39 48.8 61 87 52.1 38.8-9 61.7-46.1 55.5-87.2 -1.1-7.1 3-17.6 8.3-22.6 28.4-26.7 34.5-59.6 17.5-93.9 -4.3-8.7-6.4-20.3-4.9-29.9 8.2-54.2-40.4-99.3-92.3-83.2 -13.5 4.2-21.8 2.3-32.8-5.5 -24.3-17.3-57.6-16.3-81 0.2 -26.1 18.3-37.8 48.9-29.3 79.5 3 10.8 8.6 20.9 13.4 32.2 -36.1 21.7-56.1 51.8-41.6 93.7C70.1 379.4 106.4 389.3 149.9 382.6z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M276.2 290c-10.4 1.6-19-0.8-22.7-11.3 -3.4-10 1.3-17.2 9.9-22.3 -1.1-2.7-2.5-5.1-3.2-7.7 -2-7.3 0.8-14.6 7-19 5.6-3.9 13.5-4.2 19.3 0 2.6 1.9 4.6 2.3 7.8 1.3 12.4-3.8 24 6.9 22 19.8 -0.3 2.3 0.1 5 1.2 7.1 4 8.2 2.6 16-4.2 22.4 -1.3 1.2-2.2 3.7-2 5.4 1.5 9.8-4 18.6-13.2 20.8 -9.1 2.1-17.9-3.1-20.7-12.4C277 292.8 276.7 291.5 276.2 290zM292.6 256.5c-4.4-5.9-8.5-11.3-12.6-16.8 -0.4 0.2-0.7 0.5-1.1 0.7 2.1 3.8 4.2 7.6 6.6 12 -2.7-0.1-4.5-0.3-6.3-0.3 -1.7 0-3.3 0.1-5 0.2 8.6 1.8 16.3 4 17 14.9 -2.5 0.8-5 1.5-8.9 2.7 11.1 0.7 11.2 0.7 12.9 10.2 0.8 4.7 1.5 9.4 2.2 14.2 1.1-7.3 2.2-14.4 3.2-20.8 0 0-1.1 0.8-2.4 1.8 -1.3-4.5-3.7-8.7-3.4-12.7 0.3-3.7 3.4-7.1 5.3-10.8C297.8 253.4 295.2 255 292.6 256.5z' }),
	                        _react2.default.createElement('path', { d: 'M218.8 242.2c10.6-6.6 21.4-13.2 31.7-19.6 -11.3 13.7-21.2 30.1-22.4 45.5 -1.2 16.6 7.5 30.1 13.1 49.1 13.8-18.3 26.1-23.2 30.8-25.4 -8.3 8.8-25.5 24.8-29 39.5 -5.7 21.9-1.4 52.8-4 69.6 -3.1-20-5.7-39.8-9.3-59.4 -8.3-46.7-8.1-47.2-54.1-42.7 12.7-7.7 23.4-9.8 37.4-11.4 -1.3-21.1-9.2-45-17.1-53.9 -31.4-8.3-63.1-3.8-80.1-0.3 7.4-2.7 34.4-9.7 46.9-9.1 7.6 0.1 20-0.2 31.2 0.4 -8.3-22.7-23.8-46.9-27.8-52.5C185.7 190.2 202.6 213.7 218.8 242.2z' })
	                  ),
	                  'sugar-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M426 389c-43 0-86 0-129 0 0-41 0-82 0-123 43 0 86 0 129 0C426 307 426 348 426 389zM417.9 328.2c1.6-29.9-23.6-57.5-56.2-57.4 -31.2 0.1-57 25.7-56.4 56.6 0.7 34.1 29 55.9 57.2 55.9C391.6 383.2 419.7 356.2 417.9 328.2z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M577.6 317.5c8.6 132.2-124 259.8-261.9 260 -133.2 0.2-266.8-102.8-270-263.9 -2.9-145.9 119-267 266.4-267.4C466.1 45.7 585.2 176.1 577.6 317.5zM158 490.7c82.3 85.9 237.6 77.4 325.4-13.3 99.7-102.9 80.7-249.7 5.5-322.4 -29.1 31.3-60.8 60.2-90.5 92.1 -8.1-8.5-13.3-14-22.9-24 32.5-29.6 62.2-60.2 93.8-89.1 -100.2-92.6-258-76.9-343.1 28.5 -83.1 102.9-60.9 242.2 11.3 305.1 25.9-27.8 54.2-53.9 81.6-83.3 7.4 8.3 12.8 14.3 21 23.4C211.1 435.4 185.8 464.4 158 490.7z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M328.5 364.3c5.9-5.6 11.8-11.2 17.9-17 -1.7-1.9-2.9-3.2-4.4-5 -5.8 6.2-11.3 12.1-16.8 18 -15.3-13.3-20.4-43.2-2.8-65 18-22.3 51.8-25.3 73-5.7 -6.7 6.1-13.4 12.2-20.3 18.5 2 2.1 3.1 3.3 4.8 5.1 6.3-6.8 12.5-13.4 18.6-20 15.9 15.4 20.5 47-0.6 68.8C379.3 381.3 345.9 382.5 328.5 364.3zM383.9 332c0-11.1-8.8-22.2-19.7-24.8 -15.9-3.7-28.4 9.1-23.6 24.4 3.1 9.9 9.8 16.3 20.1 18.6C373.3 353.1 383.9 344.8 383.9 332zM356.7 302.8c-2.2-3.1-3.4-6.8-5.6-7.5 -2.2-0.7-5.3 1.7-8 2.8 -3.7-0.2-9.1-1.2-11 1 -2.2 2.4-1.3 7.6-1.9 12.7 -0.5 1-3.1 4.3-2.3 5.6 1.5 2.6 4.9 4 8.4 6.5C338 311.4 344.9 305.6 356.7 302.8zM393 346.1c0.7-1.7 2.9-4.5 2.5-6.7 -0.8-3.5-4.4-4.4-8.2-4.2 -2 10.9-9 16.7-20.5 19.5 2.2 3.1 3.5 6.7 5.9 7.6 1.8 0.7 5-1.7 7.5-2.8 3.7 0.1 8.9 1.1 11-1C393.3 356.3 392.4 351.1 393 346.1z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M417 335.2c-0.1 60.5-50 99.6-109.6 86.4 -49-10.9-80.5-41.1-95.1-88.1C189.7 261 248.7 200.7 324 218.3 375.2 230.2 417 282.8 417 335.2zM298 253.1c-5.8-13.3-21.9-18.7-35.2-13 -13.6 5.9-22.4 16.7-19.6 26.3 2.4 8.6 14.1 18.5 23.1 20.3 15.5 3.1 35.8-15.3 33.2-29.1C299.1 256 298.7 254.5 298 253.1z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M356 310.9c0.7 1 2.6 2.7 3 4.6 0.5 2.9-3.8 6.8-7 6.2 -1.9-0.4-4.4-2.5-4.9-4.3C346.2 314.4 350.7 310.8 356 310.9z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M204.1 247.8c-0.3-0.5-0.5-1.1-0.9-1.6 0.7 0 1.3-0.1 2-0.1 3.4-5.5 7.4-10.8 12.1-15.7 6.2-6.5 13.2-11.9 20.4-16.2 0 0 0-0.1 0-0.1 0 0 0.1 0 0.1 0.1 15-8.9 31.4-12.9 46.7-11.8 2.6-5.3 3.8-11.4 3.1-17.7 -2-17.4-17.7-29.9-35.1-27.9 -14.4 1.7-25.4 12.7-27.6 26.4 -1.4-1.3-2.8-2.6-4.3-3.8 -18-13.7-42.4-12-54.6 4 -11.3 14.8-8.1 36.5 6.8 50.5 -7.1 1.5-13.8 5.5-18.7 11.8 -10.4 13.6-8.2 32.8 4.9 42.8 9.7 7.4 22.6 7.7 32.9 1.9C191.9 276.2 196 261.4 204.1 247.8z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M385.5 426.3c0.5 0.3 1.1 0.5 1.6 0.9 0-0.7 0.1-1.3 0.1-2 5.5-3.4 10.8-7.4 15.7-12.1 6.6-6.2 12-13.1 16.3-20.4 0 0 0.1 0 0.1 0 0 0 0-0.1-0.1-0.1 8.9-15 13-31.4 11.9-46.7 5.3-2.6 11.4-3.8 17.7-3.1 17.4 2 29.9 17.8 27.8 35.2 -1.7 14.4-12.8 25.4-26.4 27.6 1.3 1.4 2.6 2.8 3.8 4.4 13.7 18 11.9 42.4-4.1 54.6 -14.8 11.3-36.5 8-50.5-6.9 -1.5 7.1-5.5 13.8-11.8 18.7 -13.6 10.4-32.8 8.2-42.8-5 -7.4-9.7-7.7-22.6-1.9-32.9C357 438.4 371.8 434.3 385.5 426.3z' })
	                  ),
	                  'spicy-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { d: 'M312.1 587.8C157.9 588.2 35.8 467.7 34.3 313.6 32.8 160.3 156.9 35.9 311.6 35.8c152.4 0 277.5 124.1 277.7 275.8C589.5 463 464.8 587.4 312.1 587.8zM150 499.5c66.2 55.6 141.6 75 225.9 51 98.9-28.1 161.4-94.5 180-196.4C570 277 559.3 219 503.7 155.5c-52.1 52-130.8 127.3-130.8 127.3l-18.9-31.3c0 0 100.5-96.2 124.9-121.4-94.8-93.1-262.7-85-355.1 19.3C29.4 255.8 56.3 408 125.3 473.2c25.9-24 103-99.9 103-99.9l27.3 23C250.2 401.7 157.6 491.3 150 499.5z' }),
	                        _react2.default.createElement('path', { d: 'M252.1 219.8c16.8-0.4 24.1 2.3 38.6 7.4 18.4 6.4 27.3 23 35.7 39.3 9.8 19 18.6 38.6 29.5 57 24.2 41 58.9 67.3 107.6 72.5 8.5 0.9 17 3.4 25.2 6.2 3.2 1.1 6.8 4.6 7.7 7.7 0.5 1.7-3.8 5.8-6.7 7.3-23.5 12.5-48.9 16.1-74.9 14.3-58.6-4-104.6-34.2-146.2-72.6-13.9-12.8-27.8-25.8-39.7-40.4-19.3-23.7-22.7-52.2-20.3-81.9 0.3-4-2.3-8.6-4.5-12.4-9.4-16.6-20.3-32.6-28.4-49.8-5.8-12.3-0.9-24.5 9.2-28.9 3.2-1.4 7.7-0.9 11.1 0.1 1 0.3 1.2 5.7 0.6 8.6-4.8 22.9 4.5 47.3 19.5 56.8 7 6 16.1 6.7 26.8 8.1C246.2 219.5 247.1 219.6 252.1 219.8zM191.1 149.3c-9.5 0.1-14.7 10.4-11.7 20.9 8.5 19.4 18.8 34.8 30.7 53.3 2.3 4.2 3.8 7.8 4 14.4-1.5 9.4-2.1 17.9-0.4 26.9 12.9-18.8 30.2-30.1 49.3-40.4-9.1-0.3-16.1-0.5-25.7-1.1-16.3-1.8-22.6-5.7-30.8-14.5-6.4-8.5-11.9-18.3-14.9-30.9C189.4 163 193.5 156.8 191.1 149.3z' })
	                  ),
	                  'peanuts-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M314.1 587.2C159.9 587.6 37.8 467.1 36.3 313 34.8 159.7 158.9 35.3 313.6 35.2 466 35.2 591.1 159.3 591.3 311 591.5 462.4 466.8 586.8 314.1 587.2zM152 498.8c66.2 55.6 141.6 75 225.9 51 98.9-28.1 161.4-94.5 180-196.4 14.1-77.1-0.3-139.4-55.9-202.9 -52.1 52-117 117.1-117 117.1l-15.3-32c0 0 83.8-82.7 109-107.5 -94.8-93.1-260.6-83.7-353 20.6 -94.3 106.4-67.4 258.6 1.6 323.8C153.2 448.7 232 370 232 370l14.5 35.5C241 410.9 159.6 490.6 152 498.8z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M346 395c-46.3 0-92.7 0-139 0 0-42 0-84 0-126 46.3 0 92.7 0 139 0C346 311 346 353 346 395zM276.7 389.2c31.1 0.2 56.5-24.6 56.6-55.7 0.2-31.4-24.4-56.3-55.5-56.5 -31.8-0.2-56.9 24.7-57.2 56.1C220.3 363.8 246.5 389.5 276.7 389.2z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M310.7 296.2c-6.4 6.1-12.8 12.1-19.1 18.3 -3.8 3.7-3.7 3.7-0.6 9.9 3.9-4.3 7.6-8.4 11.3-12.4 3.7-4 7.5-8 11.2-11.9 17.8 12.8 18.4 46.4 1.9 65.8 -18.3 21.4-52.3 23.7-71.8 4.2 6.5-6.2 13-12.4 19.4-18.7 3.4-3.3 3.3-3.4 0.6-8.4 -7.6 8.2-15 16.3-22.5 24.3 -19.2-17.5-18.9-49-1.4-68.1C260.2 276.9 293 278.7 310.7 296.2zM266 299.5c-6.9 0.1-13 4.3-15.5 10.6 -2.6 6.6-1.1 14.4 5.1 18.8 8.9 6.3 14.4 14.1 16.2 25.1 1.3 7.7 8.4 12.6 15.8 12.8 6.8 0.2 13.6-4.4 15.9-10.8 2.7-7.3 0.9-14.8-5.8-19.4 -8.5-5.8-13.5-13.2-15.1-23.4C281.2 304.5 274.2 299.4 266 299.5z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M257.8 306.6c0.7 1.6 2.3 3.4 2 4.7 -0.4 1.6-2.4 2.8-3.7 4.1 -1.1-1.2-3.1-2.5-3-3.5 0.3-1.9 1.8-3.7 2.8-5.5C256.6 306.5 257.2 306.6 257.8 306.6z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M264.1 308.6c-1.2-1.8-2.7-3.3-2.4-3.9 0.5-1.2 2.1-1.9 3.2-2.8 0.8 1 2.2 2.1 2.1 3.1C267 305.9 265.6 306.9 264.1 308.6z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M421.9 335.6c-47.1-32.4-75-73.4-84.3-130.6 -7.8-48-46.9-76.3-92.7-75.8 -38.3 0.4-72.5 23.8-86.3 59 -14.5 37-5.9 80.2 28.7 104.8 49.5 35.3 80 78.6 90 139.8 7 42.9 46.9 70.1 88.3 71.1 37.9 0.9 75.5-24.7 88.7-60.2C469.4 403.2 459.2 361.2 421.9 335.6zM212.2 202.9c-3 14.8-14.7 24.9-26.1 22.6 -11.4-2.3-18.2-16.2-15.1-31 3-14.8 14.7-24.9 26.1-22.6C208.5 174.2 215.3 188.1 212.2 202.9zM219.8 150.3c5.8-8.6 17-11.2 25.1-5.8 8.1 5.4 9.9 16.8 4.1 25.4s-17 11.2-25.1 5.8C215.8 170.3 214 159 219.8 150.3zM250.9 211.3c-4.1 6.1-12 7.9-17.7 4.1 -5.7-3.8-7-11.8-2.9-17.9 4.1-6.1 12-7.9 17.7-4.1C253.7 197.2 255 205.2 250.9 211.3z' })
	                  ),
	                  'eggs-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M233 223c46 0 92 0 138 0 0 41.3 0 82.7 0 124 -46 0-92 0-138 0C233 305.7 233 264.3 233 223zM357.1 286c-0.1-31.2-25-56-56.3-56 -31.1 0-56.5 25.3-56.4 56.1 0.1 31.1 25.3 56.1 56.3 56.2C332.6 342.2 357.2 317.6 357.1 286z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M276.3 305.9c-4.5 5-8.3 9.3-12.2 13.6 -16-14.6-20-46.7 0.2-68.2 18.4-19.5 52.5-21 70.1-2.3 -3.6 3.4-7.1 7-10.9 10.2 -3.2 2.7-3.8 5.2 0.1 8.6 4.7-5.2 9.4-10.5 14-15.7 18.3 17.2 17.5 49.1 0.4 68 -19.4 21.2-52.6 20.6-70.5 3.2 4.2-3.5 8.3-6.9 12.5-10.4 -0.3-0.4-0.6-0.8-0.8-1.3C278.4 310.1 277.6 308.5 276.3 305.9zM278.3 292.3c0 1-0.1 2 0 3 1 12.6 9.3 21.8 20.1 22.5 12 0.8 22.1-6.2 24.3-17.7 2.6-13.7-0.1-26.5-8.4-37.8 -7.8-10.6-17.9-10.6-26-0.3C281.3 270.9 278.8 281.3 278.3 292.3z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M297.2 261.5c0.9 1.6 2.6 3.2 2.7 4.9 0.1 3.2-1.7 6-5.3 5.7 -1.3-0.1-3.7-3-3.5-4 0.7-2.5 2.6-4.6 4-6.8C295.8 261.4 296.5 261.4 297.2 261.5z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M312.1 587.8C157.9 588.2 35.8 467.7 34.3 313.6 32.8 160.3 156.9 35.9 311.6 35.8c152.4 0 277.5 124.1 277.7 275.8C589.5 463 464.8 587.4 312.1 587.8zM150 499.5c66.2 55.6 141.6 75 225.9 51 98.9-28.1 161.4-94.5 180-196.4C570 277 555.6 214.7 500 151.2c-52.1 52-62.5 65.3-62.5 65.3l-17.4-28.7c0 0 31.4-34.2 56.6-59 -94.8-93.1-260.6-83.7-353 20.6 -94.3 106.4-67.4 258.6 1.6 323.8 25.9-24 39-37.6 39-37.6l19.5 30.2C178.3 471.2 157.6 491.3 150 499.5z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M387.5 176.5c-44.4-60.3-101.7-60.2-148-1.6 -39.6 50.3-53.7 109.5-56.6 172 0 5.7-0.4 11.4 0.1 17 5.8 71.4 52.7 123.9 114.4 128 68 4.6 125.5-35.2 138.1-100.7C450.3 313.7 434.7 240.6 387.5 176.5zM295.3 217.3c-5.3 16.6-19.6 26.8-32 22.9 -12.4-4-18.2-20.6-12.9-37.2 5.3-16.6 19.6-26.8 32-22.9C294.8 184 300.6 200.7 295.3 217.3z' })
	                  ),
	                  'gluten-free': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 623.6 623.6', className: 'svg' + ' ' + _this.props.icon },
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M238 365c-44 0-88 0-132 0 0-41.7 0-83.3 0-125 44 0 88 0 132 0C238 281.7 238 323.3 238 365zM170.3 246.9c-31.2 0-55.8 24.9-56.4 55.9 -0.5 26.4 23.4 57.9 59 56.3 29.9-1.4 54.7-28.7 54.1-56.5C226.3 271.9 201.5 246.9 170.3 246.9z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M137.5 340.8c1.7-5.4 11.6-6.6 5.3-16.3 -3.3 4.5-6.3 8.5-9.2 12.5 -19-19.6-17.8-50.7 1.5-70 18.4-18.4 50.4-19.3 68.5-1.5 -4.7 4.1-9.4 8.2-14.2 12.3 0.3 0.4 0.6 0.8 0.9 1.3 0.9 1.5 1.8 3 3.2 5.3 4.6-5.3 9.1-10.3 13.4-15.3 16.4 15.4 19.4 47.1 1.5 67.2C188 359.2 154.4 357 137.5 340.8zM191.5 322.3c-12.9 2.3-19.4 8.4-19.9 18.6 -0.1 1.2 1.4 3.6 2.4 3.7 5.2 0.5 10.1-0.7 13.3-5C191 334.6 194.1 329.2 191.5 322.3zM169.6 337.3c-0.9-13.6-10.7-22.2-21.9-19.7C148.2 333.1 156.6 340.8 169.6 337.3zM172.7 322.3c11.4 2.8 19.7-6.3 17.2-18.8C179.5 302.9 171.4 311.8 172.7 322.3zM170.6 316.5c0.8-10.9-7-18.7-17.9-18.2C150.5 310.1 158.3 318.3 170.6 316.5zM155.1 277.6c-2.7 10.2 2.5 18.8 11.4 19.5 3.6 0.3 4.3-1.2 4.1-4.3C169.9 284.6 164.5 279.2 155.1 277.6zM187.7 283.7c-11.3 1.4-17.7 9.7-14.9 19C182.3 304.9 190.7 295.5 187.7 283.7zM173.6 261.3c-8.8 7.8-8.9 16.7-0.4 24.2C181.9 277.9 182.2 269.2 173.6 261.3z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M302 489.7c-67.4 18.3-111.1-21.5-113.8-102.3C246.7 374.5 297.2 419.2 302 489.7z' }),
	                        _react2.default.createElement('path', { className: 'className=', d: 'M318 412c-6.5-54.8 35.5-100.9 89.1-97.7C420.4 379.1 377.1 426.6 318 412z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M313.3 523.9c-7.5-62.7 40.6-115.4 101.9-111.8C430.5 486.2 381 540.5 313.3 523.9z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M307.1 381.7c-63.9 9.2-104.4-33-93-94.7C271 284.6 311.3 325.1 307.1 381.7z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M396 211.5c15.7 61.5-28.2 110-77.2 98.7C304.2 262.1 337.3 218.9 396 211.5z' }),
	                        _react2.default.createElement('path', { className: 'st0',
	                              d: 'M172.7 264.1c1.4 2.5 2.7 3.8 2.5 4.7 -0.4 1.4-1.8 2.6-2.8 3.9 -0.8-1-2.4-2-2.3-3C170.1 268.3 171.3 266.9 172.7 264.1z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M312.1 589.2C157.9 589.6 35.8 469.1 34.3 315 32.8 161.7 156.9 37.3 311.6 37.2 464 37.2 589.1 161.3 589.3 313 589.5 464.4 464.8 588.8 312.1 589.2zM148.8 499.9c66.2 55.6 142.8 76 227.1 52 98.9-28.1 161.4-94.5 180-196.4 14.1-77.1-0.3-139.4-55.9-202.9 -29.7 27.3-82.2 75.3-82.2 75.3l-6.4-41.4c0 0 35.9-33.5 63-57.8 -94.8-93.1-258.3-82.1-350.7 22.2 -94.3 106.4-67.4 258.6 1.6 323.8 25.9-24 45.4-40.7 45.4-40.7l9.3 32.8C174.5 472.1 156.4 491.7 148.8 499.9z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M322.6 95.1c-45.9 40.2-46.3 86.6-2.3 125.7C365.9 181.6 367.2 136.5 322.6 95.1zM318.9 153.6c-8.2 0-14.9-8.8-14.9-19.7 0-10.9 6.7-19.7 14.9-19.7 8.2 0 14.9 8.8 14.9 19.7C333.8 144.7 327.1 153.6 318.9 153.6z' }),
	                        _react2.default.createElement('path', { className: 'className=',
	                              d: 'M307.2 258.9c-3.8-42.6-31.5-70.5-80.4-79 -14.1 52.9 13.2 97.4 59.2 101.3C304.9 282.9 308.7 274.9 307.2 258.9zM252.4 223.9c-6.9 3.3-16-1.5-20.3-10.5 -4.3-9.1-2.1-19.1 4.8-22.3 6.9-3.3 16 1.5 20.3 10.5C261.5 210.7 259.3 220.7 252.4 223.9z' })
	                  ),
	                  'celery': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Aipo'
	                        ),
	                        _react2.default.createElement('path', { d: 'M71.42,71.89c6.42,6.47,12.78,13,19.17,19.52A5.84,5.84,0,0,0,92,92.77c.51.23,1.47.31,1.74,0a2.7,2.7,0,0,0,.44-1.93c0-.42-.59-.81-1-1.18C86.72,83,80.34,76.16,73.57,69.74c-2.84-2.7-6.44-4.65-9.86-6.67-2.21-1.31-4.81-1.95-7.05-3.21a15.48,15.48,0,0,1-4.34-3.67A3.27,3.27,0,0,1,52.21,53c1.93-2,1.28-3-.81-4.18s-2.35-3.67-.7-4.59c1.95-1.09,2-2.19,1.45-4.14-1.13-3.94.55-7.27,3.94-8.59,2.81-1.1,4.81,0,7.15,4a2.12,2.12,0,0,0,2.93,1.05c2.22-.7,3.5.41,3.09,2.73a24.59,24.59,0,0,1-1.41,3.43,2.47,2.47,0,0,0-.06,1.83,2,2,0,0,0,1.69.6c3.17-.46,4,.09,4.05,3.23a12.06,12.06,0,0,1-.28,3.75c-2.2,7.35.06,13.37,5.31,18.57q8.52,8.46,17,16.94c.1.1.21.28.32.3.8.08,1.59.12,2.39.18a9.51,9.51,0,0,0-.22-2.34c-.17-.5-.8-.85-1.22-1.27C91.66,79.3,86.5,74.08,81.23,69c-4.73-4.59-6.72-9.72-4.93-16.43,1.56-5.86.06-9-3.58-10.95-.43-2.33-.5-4.34-1.21-6.1-.91-2.25-3.07-2.41-5.29-2.32-1.24.05-2.42-2.31-1.81-3.26a4.41,4.41,0,0,1,7.46.1,8.44,8.44,0,0,1,1,2.45,1.86,1.86,0,0,0,2.55,1.67,2.23,2.23,0,0,1,3,2.34,16.71,16.71,0,0,1-.82,4.7c-.52,1.81-.11,2.65,1.62,2.68,3.08,0,3.71.65,3.14,3.68a76.63,76.63,0,0,1-2.08,8.15c-1.38,4.52-.14,8.32,3,11.61,1.54,1.6,3.19,3.1,4.81,4.62,4.76,4.46,9.72,8.72,14.24,13.4,3.93,4.08,3.56,6.93-.57,10.83a14.77,14.77,0,0,1-1.37,1.13c-3.14,2.32-4.77,2.52-7.74,0a120.87,120.87,0,0,1-9-8.87c-3.21-3.38-6.23-7-9.41-10.37-3.58-3.85-7.93-5.28-13.09-3.89-2.71.73-5.4,1.53-8.14,2.13s-4.12-.48-4.17-3.37c0-1.78-.86-2.25-2.59-1.77a17.79,17.79,0,0,1-4.91.82,2.46,2.46,0,0,1-2.61-3.09c.25-1.57-.36-2.31-1.84-2.72a8.62,8.62,0,0,1-2.77-1.34c-3.1-2.27-2.9-6.24.54-7.93a12.71,12.71,0,0,1,5.13-1c1.76,0,3.28.16,4.12-2,.27-.7,1.79-1.18,2.77-1.22a2.35,2.35,0,0,1,1.76,1.52c.09,3.39,2.26,5.33,4.59,7.23l1.44,1.16-.35.49c-2.15-1.27-5.67-.36-6.17-4.31,0-.37-1-1-1.26-.88a2.88,2.88,0,0,0-1.08,1.42c-.13.31.08.77.15,1.21-2.31-.25-4.44-.58-6.57-.64-.67,0-1.36.71-2,1.09.59.42,1.12,1.09,1.77,1.22,2,.41,4,.61,6.25.93a4.52,4.52,0,0,0-.61,1c-.16.76-.25,1.54-.37,2.31.81-.28,2-.32,2.35-.89,1.1-1.61,2.33-1.74,4-1.06,1.21.51,2.47.89,3.88,1.38a16,16,0,0,0-1.83,2.42,5.35,5.35,0,0,0-.14,2,11.52,11.52,0,0,0,2.05-.5,2.28,2.28,0,0,0,.86-1c.93-1.64,2-2.05,3.76-1,.52.32,1.5-.09,2.27-.17-.39-.67-.74-1.36-1.19-2-.18-.26-.55-.38-.84-.57A25.2,25.2,0,0,1,71.42,71.89ZM67.93,50.8c.25-.46,0-1.19,0-1.8-.65.11-1.47,0-1.92.37A15.64,15.64,0,0,0,64,52c-1-2.11-2-3.89-2.66-5.77-.19-.52.6-1.35.82-2.07.29-.95.47-1.93.7-2.9l-3.1.73a36,36,0,0,0-1-3.86,6.94,6.94,0,0,0-1.46-1.76c-.3.77-.93,1.59-.85,2.31a53.71,53.71,0,0,0,1.17,5.49,4.52,4.52,0,0,0-1.53.23,1.75,1.75,0,0,0-.8,1.12c0,.31.42,1,.63,1,4.09-.21,3.76,3.59,5.57,5.9-.74,0-1.24-.15-1.54,0a2.51,2.51,0,0,0-1.19,1.26c-.07.32.64,1.19,1,1.17,3.21-.17,4.57,2.11,6.13,4.28.39.55,1.39.66,2.11,1a7,7,0,0,0-.22-2.45,25.73,25.73,0,0,0-2.22-3.28A42.77,42.77,0,0,0,67.93,50.8Z' })
	                  ),
	                  'lupine': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Tremo\xE7os'
	                        ),
	                        _react2.default.createElement('path', { d: 'M72.38,61.81a14.49,14.49,0,0,1-7.67.27A25.09,25.09,0,0,1,56,58.27a9.43,9.43,0,0,1-4.15-7.8,25.17,25.17,0,0,1,.87-7.66,24.7,24.7,0,0,1,2.52-6.15,13,13,0,0,1,3-3.77,10.37,10.37,0,0,1,5.38-2,22.85,22.85,0,0,1,7.28.39,23.82,23.82,0,0,1,6,2.06,11.4,11.4,0,0,1,6.32,8,19.55,19.55,0,0,1,.42,5.58,17.56,17.56,0,0,1-2.15,7.41,15.46,15.46,0,0,1-7.92,7.12C73.22,61.59,72.8,61.69,72.38,61.81ZM57,42a3.89,3.89,0,0,0,.6.47c.28.14.44-.06.61-.27.74-.93,1.47-1.88,2.25-2.77a26.29,26.29,0,0,1,5-4.4.5.5,0,0,0-.12-.95,1.62,1.62,0,0,0-.76-.12,10.71,10.71,0,0,0-1.74.35,7.62,7.62,0,0,0-3.93,2.61,9.25,9.25,0,0,0-1.64,3.52C57.08,40.9,57,41.4,57,42Z' }),
	                        _react2.default.createElement('path', { d: 'M72.14,75.89a12,12,0,0,1,.27,5.63,18.65,18.65,0,0,1-1.89,5.62,17.33,17.33,0,0,1-6.72,7.14,15.07,15.07,0,0,1-8.56,2,15.35,15.35,0,0,1-8.38-3.14,25.19,25.19,0,0,1-5.1-4.92,14.1,14.1,0,0,1-2-3.49,8.86,8.86,0,0,1-.14-5.42,20.56,20.56,0,0,1,3.06-6.74,29.75,29.75,0,0,1,2.44-3.24,18.55,18.55,0,0,1,6.41-4.93A8.92,8.92,0,0,1,56.33,64,20.25,20.25,0,0,1,64,66.89a23.38,23.38,0,0,1,5.91,5A11.84,11.84,0,0,1,72.14,75.89Zm-19.7-8.53c-.3.13-.77.31-1.22.54a9.18,9.18,0,0,0-3.53,3.27.81.81,0,0,0,.16,1.18c.32.22.57,0,.82-.12a32.7,32.7,0,0,1,6-2.66c1.33-.43,2.7-.74,4.06-1.1.43-.12.56-.46.22-.75a2.42,2.42,0,0,0-1-.52A10.92,10.92,0,0,0,52.44,67.36Z' }),
	                        _react2.default.createElement('path', { d: 'M84.73,60.45a27.38,27.38,0,0,1,9.12-1.08A12.55,12.55,0,0,1,100,61.24a12.4,12.4,0,0,1,3.92,4.26,18.65,18.65,0,0,1,2.65,9.24,16,16,0,0,1-2.73,9.5,15.29,15.29,0,0,1-5,4.61,16.2,16.2,0,0,1-7.1,2,24,24,0,0,1-6.48-.32,12.12,12.12,0,0,1-4.6-1.75,9.28,9.28,0,0,1-2.93-3.51,25.61,25.61,0,0,1-2.1-15.62,10.41,10.41,0,0,1,2.16-5,12.1,12.1,0,0,1,4.16-3C83,61.1,84.12,60.69,84.73,60.45ZM78.82,73.37c.2.38.27.73.71.74s.58-.25.72-.61c.56-1.42,1.11-2.84,1.74-4.23a30.49,30.49,0,0,1,3-5c.09-.12.16-.38.1-.45a.8.8,0,0,0-.52-.27,1.69,1.69,0,0,0-.75.19A10,10,0,0,0,80.19,67,8.26,8.26,0,0,0,78.73,72C78.74,72.5,78.79,73,78.82,73.37Z' })
	                  ),
	                  'soy': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Soja'
	                        ),
	                        _react2.default.createElement('path', { d: 'M81.15,55.13c-3-6.34-9.71-8.18-17-5.19C58.41,52.31,54.89,58.79,57,64c.86,2.18,2.86,3.92,4.05,5.48C57.85,72,54.49,75,50.74,77.44,46.33,80.3,36,81.19,30.2,75c-2.15-2.33-4.14-4.33-7.61-4.21A2.88,2.88,0,0,1,20.39,69a3.2,3.2,0,0,1,1.35-2.48c4.42-3.1,8.73-6.49,13.51-8.91,3.64-1.83,7.94-2.33,11.93-3.48,2.09-.6,4.63-.79,6.12-2.12,5.78-5.14,12.53-6.93,20-7.26a10.13,10.13,0,0,0,5.8-2.35c5.34-4.69,11.93-5.29,18.43-6.29,1.42-.22,2.87-.24,4.37-.36l-.16,1.68,6-2.5A55.68,55.68,0,0,0,109.17,41c3.21,9.09,1.13,16.5-6.47,22.54a17.83,17.83,0,0,0-4.27,5.59,32,32,0,0,1-14.69,13.9,58,58,0,0,0-9.9,6.37C67.5,94.38,61,97.24,53.09,93c-1.21-.64-3-.1-4.57-.21-1.05-.07-2.1-.32-3.14-.49A8.5,8.5,0,0,1,46,89.49c2.52-3.86,4.85-7.92,7.89-11.34,2.47-2.77,5.84-4.73,8.84-7,1.23-.93,3.14-1.48,3.71-2.69C69.5,62,74.45,57.75,81.15,55.13ZM45.92,57.4c-5.13,0-9.56,1.69-12.78,5.83-2.07,2.66-2.33,5.51-.2,8.34,1.84,2.44,7.37,4.69,9.43,4.06,2.34-.72,4.76-1.13,7.11-1.81a5.9,5.9,0,0,0,2.3-1.34c2.81-2.63,3.9-7.56,2.39-10.92C52.57,58,49.36,57.44,45.92,57.4Zm41.17-9.6-.42-.53c-.48.42-.94.86-1.44,1.24s-.85.55-1.67,1.06c2.05-6.7,7.29-7.92,12.75-8.84a11.9,11.9,0,0,0-13.15,4.83c-1.94,2.74-2.63,5.6,0,9.16Zm1.68,4,14.4-8.25C98.16,41.44,91.44,45.62,88.77,51.82ZM70.57,68.48l13.81-9.4C78.58,57.84,72.9,62.13,70.57,68.48Zm-16,13.68,13.31-8C61.78,73.3,57,76.53,54.59,82.16Z' }),
	                        _react2.default.createElement('path', { d: 'M59.26,58.73c1.82-5.44,8-9.2,13-8.13,1.08.23,2,1.35,2.94,2.06-1,.62-2.07,1.75-3.1,1.76C67.31,54.46,62.85,55.11,59.26,58.73Z' }),
	                        _react2.default.createElement('path', { d: 'M33.64,67.32c2.54-5.86,7.63-9,13-8.31,1.06.15,2,1.2,3,1.84-1,.71-1.89,1.79-3,2-2.54.6-5.25.52-7.74,1.24C37.18,64.63,35.74,66,33.64,67.32Z' })
	                  ),
	                  'crustaceans': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Crustaceos'
	                        ),
	                        _react2.default.createElement('path', { d: 'M90.69,57.75C98.94,56,105.11,48,105.11,41c0-13.81-7.89-15.78-7.89-15.78,0,14.13-3.79,16.89-3.94,17.09V31.15c-9.86,2-9.86,19.06-9.86,23a3,3,0,0,1-2.46,2.91c-1.14-8.71-4.06-14.16-6.65-17.42a12.72,12.72,0,0,0,3-6.95,3.94,3.94,0,1,0-4-.26,9.05,9.05,0,0,1-1.77,4.35,11.16,11.16,0,0,0-1.94-1.38,11.14,11.14,0,0,0-1.94,1.38,9.07,9.07,0,0,1-1.77-4.35,3.95,3.95,0,1,0-4,.26,12.73,12.73,0,0,0,3,6.95c-2.59,3.26-5.51,8.71-6.65,17.42a3,3,0,0,1-2.46-2.91c0-3.94,0-21-9.86-23V42.33c-.16-.21-3.94-3-3.94-17.09,0,0-7.89,2-7.89,15.78,0,7,6.17,15,14.42,16.74A10.87,10.87,0,0,0,57.77,65v3H53.63A4.94,4.94,0,0,1,48.7,63H44.76a8.88,8.88,0,0,0,8.87,8.88h4.14v3H53.63a8.88,8.88,0,0,0-8.87,8.88H48.7a4.94,4.94,0,0,1,4.93-4.93h4.14a5.9,5.9,0,0,0,1.66,4.11,5.91,5.91,0,0,0,1,9l-4.61,9.21s3.79,4.6,13.81,4.6,13.81-4.6,13.81-4.6L78.81,92a5.91,5.91,0,0,0,1-9,5.89,5.89,0,0,0,1.66-4.11h4.14a4.94,4.94,0,0,1,4.93,4.93h3.94a8.89,8.89,0,0,0-8.87-8.87H81.44v-3h4.14A8.88,8.88,0,0,0,94.46,63H90.51A4.94,4.94,0,0,1,85.58,68H81.44V65a10.87,10.87,0,0,0,9.25-7.21Zm0,0' })
	                  ),
	                  'so2': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Frutos de Casca Rija'
	                        ),
	                        _react2.default.createElement('path', { d: 'M86.34,40.27s-1.86,8.54-12.46,19.51S55.8,71.84,55.8,71.84c15.86,16.41,34.51,24.38,44.29,19.64a1.48,1.48,0,0,0,.36.52,2.71,2.71,0,0,0,3.74-3.73.22.22,0,0,0-.11-.09c6.94-9.34-.7-30.29-17.74-47.92ZM92.2,62.9a1.93,1.93,0,0,1,.63-2.66,2,2,0,0,1,2.68.64c9.3,15.18,6.16,24.63,6,25a1.89,1.89,0,0,1-2.45,1.18,1.59,1.59,0,0,1-.74-.46,1.94,1.94,0,0,1-.49-2c0-.09,2.59-8.27-5.65-21.74Zm0,0' }),
	                        _react2.default.createElement('path', { d: 'M55.89,41.49c-9.28,9.28-10.78,22.84-4.27,29.36,0,0,26.26-10.21,32.86-34.38C79.53,30.21,66.79,32,57.55,40a5.59,5.59,0,0,0-.36-.46A35.59,35.59,0,0,0,53,36.68c-.82-.49-1.66-1.26-2.68-1.18a4.08,4.08,0,0,0-2.95,1.37.29.29,0,0,0,0,.38,6.22,6.22,0,0,0,2.19,2c.67.44,1.52.15,2.3.27s3.5,1.29,4.28,1.54l.15.06-.36.32Zm0,0' })
	                  ),
	                  'nuts': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Frutos de Casca Rija'
	                        ),
	                        _react2.default.createElement('path', { d: 'M86.34,40.27s-1.86,8.54-12.46,19.51S55.8,71.84,55.8,71.84c15.86,16.41,34.51,24.38,44.29,19.64a1.48,1.48,0,0,0,.36.52,2.71,2.71,0,0,0,3.74-3.73.22.22,0,0,0-.11-.09c6.94-9.34-.7-30.29-17.74-47.92ZM92.2,62.9a1.93,1.93,0,0,1,.63-2.66,2,2,0,0,1,2.68.64c9.3,15.18,6.16,24.63,6,25a1.89,1.89,0,0,1-2.45,1.18,1.59,1.59,0,0,1-.74-.46,1.94,1.94,0,0,1-.49-2c0-.09,2.59-8.27-5.65-21.74Zm0,0' }),
	                        _react2.default.createElement('path', { d: 'M55.89,41.49c-9.28,9.28-10.78,22.84-4.27,29.36,0,0,26.26-10.21,32.86-34.38C79.53,30.21,66.79,32,57.55,40a5.59,5.59,0,0,0-.36-.46A35.59,35.59,0,0,0,53,36.68c-.82-.49-1.66-1.26-2.68-1.18a4.08,4.08,0,0,0-2.95,1.37.29.29,0,0,0,0,.38,6.22,6.22,0,0,0,2.19,2c.67.44,1.52.15,2.3.27s3.5,1.29,4.28,1.54l.15.06-.36.32Zm0,0' })
	                  ),
	                  'molluscs': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Moluscos'
	                        ),
	                        _react2.default.createElement('path', { d: 'M70,98H69.2L69,98a5.67,5.67,0,0,1-2.85-1.11l-29-21.41a11.23,11.23,0,0,1-1.68-1.53,4.77,4.77,0,0,1-1.16-2.23c-.1-.47-.15-1-.2-1.43S34,69.46,34,69V66.33a3.63,3.63,0,0,0,.1-.42c0-.29,0-.59.08-.88A3.26,3.26,0,0,1,35,63.24a1.25,1.25,0,0,1,1.35-.37,2.39,2.39,0,0,1,.91.47,12.78,12.78,0,0,1,1.07,1l19,19.83,3.34,3.48a.57.57,0,0,0,.86,0,.37.37,0,0,0,.06-.51,1.25,1.25,0,0,0-.13-.16l-1-1.1L48.21,72.07,39,61.66l-1.78-2a3,3,0,0,1-.75-2.23,7.87,7.87,0,0,1,.41-2.05q.47-1.37,1-2.71a12.87,12.87,0,0,1,.8-1.68,5.32,5.32,0,0,1,2.13-2,1.66,1.66,0,0,1,2.21.42,5.36,5.36,0,0,1,.6.88L63.39,85.29c0,.08.08.16.13.23a.4.4,0,0,0,.49.16.52.52,0,0,0,.31-.72c0-.08-.08-.16-.12-.24L54.8,66.66,44.51,46.93a6.16,6.16,0,0,1-.6-1.66,2.17,2.17,0,0,1,.47-2,6.79,6.79,0,0,1,.53-.56,41.8,41.8,0,0,1,5.39-4.14,12.85,12.85,0,0,1,1.52-.78,2.94,2.94,0,0,1,.71-.2,1.25,1.25,0,0,1,1.34.6,4.19,4.19,0,0,1,.53,1.31L59,56.71l5.11,19.12,2.15,8a1.56,1.56,0,0,0,.13.36.48.48,0,0,0,.56.22.42.42,0,0,0,.31-.48,1.35,1.35,0,0,0,0-.23l-.2-.86-3-13-3-13L57.81,43.72l-1.47-6.27a1.84,1.84,0,0,1,.91-2.2,5.18,5.18,0,0,1,.79-.39c.46-.18.92-.35,1.39-.51A25,25,0,0,1,64.63,33l.55-.09h1.24l.19.06a2,2,0,0,1,1.68,1.48,4.49,4.49,0,0,1,.18,1.34q.06,6.64.12,13.28.05,6.23.11,12.45.08,9.55.16,19.1,0,1.57,0,3.13a.61.61,0,0,0,.65.62.59.59,0,0,0,.63-.6c0-.08,0-.16,0-.24q.07-7.35.13-14.7,0-5.52.09-11,.08-8.87.16-17.74,0-2.35.06-4.7a3.09,3.09,0,0,1,.24-1.12,1.94,1.94,0,0,1,1.41-1.23l.36-.1h1.24l.22.05c.69.11,1.39.19,2.07.33a31.18,31.18,0,0,1,5,1.56,4.12,4.12,0,0,1,.85.46,1.73,1.73,0,0,1,.76,1.91c-.23,1-.48,2.07-.72,3.11l-3.28,14L75.53,68.08,72.12,82.6c-.1.43-.21.86-.3,1.29a.45.45,0,0,0,.31.56.49.49,0,0,0,.59-.27,1.47,1.47,0,0,0,.08-.25l.19-.71,6-22.25,4.75-17.78c.34-1.26.67-2.53,1-3.8a3.59,3.59,0,0,1,.55-1.24,1.23,1.23,0,0,1,1.26-.53,2.48,2.48,0,0,1,.65.18,15.55,15.55,0,0,1,1.73.89A41.23,41.23,0,0,1,94,42.61a7,7,0,0,1,.8.86A2,2,0,0,1,95.2,45,5.83,5.83,0,0,1,94.55,47L87.91,59.69,74.85,84.74a1.94,1.94,0,0,0-.14.29.52.52,0,0,0,.31.63.42.42,0,0,0,.57-.22l.06-.1L89.5,60.85l6.09-10.78a3.59,3.59,0,0,1,.69-.91A1.59,1.59,0,0,1,98,48.81a3.26,3.26,0,0,1,.73.39,5.84,5.84,0,0,1,1.86,2.07c.19.37.37.74.52,1.12.31.79.6,1.59.9,2.38a9.12,9.12,0,0,1,.61,2.64,2.84,2.84,0,0,1-.55,2c-.15.2-.3.39-.47.57L93,69.66,78.18,86.32l-.65.73a.41.41,0,0,0-.1.44.58.58,0,0,0,.89.2l.21-.21,3.93-4.1,18.28-19.06a12.57,12.57,0,0,1,1-.92,2.63,2.63,0,0,1,1-.52,1.29,1.29,0,0,1,1.44.42,3.19,3.19,0,0,1,.71,1.51,9,9,0,0,1,.13,1.47q0,1.42,0,2.84c0,.65,0,1.3-.12,1.95a5,5,0,0,1-1.25,2.85,11,11,0,0,1-1.68,1.53L72.84,97a5.21,5.21,0,0,1-2.26,1Z' }),
	                        _react2.default.createElement('path', { d: 'M83.17,97.69H78.79a6.85,6.85,0,0,1-.82-.07,1.31,1.31,0,0,1-.36-.11.76.76,0,0,1-.44-1,2.16,2.16,0,0,1,.81-1l.87-.61c3.19-2.26,6.38-4.53,9.5-6.9.41-.31.82-.61,1.26-.88a5.35,5.35,0,0,1,.91-.4,1.33,1.33,0,0,1,.44-.06.9.9,0,0,1,.93.63,2.11,2.11,0,0,1,.12,1c-.09.7-.19,1.41-.29,2.11-.17,1.17-.33,2.34-.51,3.51-.08.55-.19,1.11-.29,1.66a2.48,2.48,0,0,1-.12.37,2.35,2.35,0,0,1-2,1.64,8.16,8.16,0,0,1-1.23.12c-1.48,0-3,0-4.44,0Z' }),
	                        _react2.default.createElement('path', { d: 'M55.89,97.68c-1.48,0-3,0-4.44,0A7.8,7.8,0,0,1,50,97.5a2.21,2.21,0,0,1-1.63-1.37,5.89,5.89,0,0,1-.4-1.54q-.34-2.37-.68-4.74c-.08-.56-.16-1.11-.21-1.67a2.31,2.31,0,0,1,0-.7,1,1,0,0,1,1.34-.84,3.28,3.28,0,0,1,.8.31,8.07,8.07,0,0,1,1,.65c3,2.33,6.17,4.55,9.29,6.78.48.34,1,.67,1.45,1a5,5,0,0,1,.61.56,1.41,1.41,0,0,1,.24.37.8.8,0,0,1-.51,1.22,3,3,0,0,1-1,.13H55.89Z' })
	                  ),
	                  'mustard': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Mustarda'
	                        ),
	                        _react2.default.createElement('path', { d: 'M87.49,60.46l20.42,19.74c1.92,1.86,2,3.23.09,5.16q-7.52,7.79-15,15.57c-1.65,1.7-3.13,1.73-4.83.09L46.79,61c-1.6-1.55-1.61-3-.06-4.63L61.86,40.76c1.92-2,3.19-2,5.21,0Z' }),
	                        _react2.default.createElement('path', { d: 'M60.5,40.1,46.29,54.81c-1.36-1.32-2.75-2.54-4-3.92a1.78,1.78,0,0,1,.13-1.72c4-4.29,8.15-8.5,12.25-12.73a1.29,1.29,0,0,1,2,0C57.93,37.58,59.16,38.81,60.5,40.1Z' }),
	                        _react2.default.createElement('path', { d: 'M49.89,39.35l-4.72,4.88-3.69-4.76c-1.32-1.72-2.62-3.45-4-5.15a1.26,1.26,0,0,1,.11-1.92c.6-.61,1.13-1,2-.41C43,34.43,46.4,36.85,49.89,39.35Z' })
	                  ),
	                  'fish-intolerance': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Peixe'
	                        ),
	                        _react2.default.createElement('path', {
	                              d: 'M107.62,65.5A16.68,16.68,0,0,0,114,52.4a16.88,16.88,0,0,0-.13-2.08A15.34,15.34,0,0,0,96.63,62.87h0c-2.9-3.71-10.35-9.43-19.13-13.59h0l6.28-9.58C70,35.27,62.22,44.4,62.22,44.4h0A33.7,33.7,0,0,0,57.36,44a23.16,23.16,0,0,0-5.74.73,35.49,35.49,0,0,1,0,41.49,23.16,23.16,0,0,0,5.74.73,33.7,33.7,0,0,0,4.87-.37h0S70,95.73,83.77,91.3l-6.28-9.58h0c8.79-4.16,16.24-9.88,19.13-13.59h0a15.34,15.34,0,0,0,17.21,12.56A16.89,16.89,0,0,0,114,78.6,16.68,16.68,0,0,0,107.62,65.5Z' }),
	                        _react2.default.createElement('path', {
	                              d: 'M46.7,46.57C35.06,52.26,28.48,65.5,28.48,65.5S35.06,78.74,46.7,84.43a30.44,30.44,0,0,0,0-37.85Zm-3,16.85a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,43.75,63.42Z' })
	                  ),
	                  'sesame': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Sementes de Sesamo'
	                        ),
	                        _react2.default.createElement('path', { d: 'M69.72,62.63c-6.33,4.91-11.56,10.1-12.7,17-.84,5.08.78,9.79,5.36,13.65a11.15,11.15,0,0,0,15-.23c4.23-3.78,5.78-8.33,5.11-13.14C81.49,72.85,76.12,67.57,69.72,62.63Z' }),
	                        _react2.default.createElement('path', { d: 'M71.56,58.88c6.93,4,13.71,6.9,20.51,5.37,5-1.13,8.78-4.4,10.63-10.1a11.15,11.15,0,0,0-5.85-13.79c-5.09-2.5-9.89-2.22-14.1.21C76.6,44.12,73.73,51.09,71.56,58.88Z' }),
	                        _react2.default.createElement('path', { d: 'M67.87,58.88c-6.93,4-13.71,6.9-20.51,5.37-5-1.13-8.78-4.4-10.63-10.1a11.15,11.15,0,0,1,5.85-13.79c5.09-2.5,9.89-2.22,14.1.21C62.83,44.12,65.7,51.09,67.87,58.88Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M45.46,44.31a26.47,26.47,0,0,1-3.8,2.51c-.21.1-1.63-1.56-1.49-1.77a10.55,10.55,0,0,1,2.67-2.82C43,42.11,44.1,43.21,45.46,44.31Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M90,43.93a26.47,26.47,0,0,1-4.52.56,3.9,3.9,0,0,1-.54-2.25,10.55,10.55,0,0,1,3.65-1.33C88.79,40.87,89.26,42.34,90,43.93Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M64.68,86.1a26.47,26.47,0,0,1,2,4.11c.06.22-1.77,1.39-2,1.23a10.55,10.55,0,0,1-2.42-3C62.15,88.21,63.4,87.3,64.68,86.1Z' })
	                  ),
	                  'lactose': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Lactose'
	                        ),
	                        _react2.default.createElement('path', {
	                              d: 'M51.29,72.9h0c0,6.66,0,13.31,0,20,0,5.56,1.7,7.25,7,7.28,6.82,0,13.64-.11,20.45.05,4.62.11,6.66-1.71,6.58-6.48-.18-10.81-.51-21.65.09-32.44.46-8.34-.87-15.26-8.11-20.41-2.74-2-3.09-4.76-.31-7.56,2.28-2.28,1.67-4.52-1.58-4.78a112.15,112.15,0,0,0-14.46,0c-2.62.14-3.79,2.53-2,4.15,4.58,4.17,2.14,7-1.24,9.71-5.07,4-7.33,8.93-6.6,15.55C51.73,62.87,51.29,67.91,51.29,72.9Z' }),
	                        _react2.default.createElement('path', { d: 'M51.29,72.9c0-5,.44-10-.11-15-.73-6.62,1.52-11.51,6.6-15.55,3.38-2.69,5.82-5.54,1.24-9.71-1.78-1.62-.62-4,2-4.15a112.15,112.15,0,0,1,14.46,0c3.24.25,3.85,2.49,1.58,4.78-2.79,2.79-2.44,5.6.31,7.56,7.23,5.15,8.57,12.07,8.11,20.41-.6,10.78-.27,21.62-.09,32.44.08,4.77-2,6.59-6.58,6.48-6.81-.16-13.64,0-20.45-.05-5.34,0-7-1.73-7-7.28-.05-6.65,0-13.31,0-20Zm14.84-25C63.85,46,62,44.19,61.75,44.4a17.66,17.66,0,0,0-4.47,4.72c-.23.36,2.14,3.13,2.49,3C61.72,51.22,63.41,49.79,66.13,47.88Z' }),
	                        _react2.default.createElement('path', { className: 'cls-1',
	                              d: 'M66.13,47.88c-2.72,1.9-4.41,3.34-6.36,4.21-.36.16-2.72-2.61-2.49-3a17.66,17.66,0,0,1,4.47-4.72C62,44.19,63.85,46,66.13,47.88Z' })
	                  ),
	                  'sugar': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'A\xE7ucar'
	                        ),
	                        _react2.default.createElement('path', {
	                              d: 'M52.12,32.63C47.46,33,42,31.85,40.4,33.84c-2.23,2.77-1.57,7.87-2.14,12-.57,2.22-3.1,5.52-2.32,6.79,1.58,2.56,5,4,8.39,6.49C46,46.34,53.18,40.53,65.06,37.74c-2.48-3.23-3.85-6.67-6.17-7.51C57,29.53,53.94,31.91,52.12,32.63Zm48.94,48.61c.71-1.75,3.2-4.94,2.43-6.67-1.06-2.38-4.59-3.67-7.94-6-2.21,12.59-9.26,18.56-21,21.18,2.53,3.34,3.9,6.85,6.26,7.72,1.87.69,4.93-1.84,7.46-2.95,3.73.31,9,1.22,11-.93S100.53,86.14,101.07,81.24Z' }),
	                        _react2.default.createElement('path', { d: 'M92,67.29C91.89,79.7,81.2,88.12,69,85.44c-10.52-2.32-17.44-8.68-20.48-18.85-2.11-7.05-1.15-13.91,4.25-19.47,5.54-5.71,12.5-6.58,19.81-4.79C83.58,45,92,56.11,92,67.29ZM63.82,45.94c-5.28,0-9.57,3.69-8.68,6.68a7.15,7.15,0,0,0,4.55,4.1c3.38.75,7.93-3.27,7.29-6.34C66.58,48.47,64.54,46.9,63.82,45.94Z' }),
	                        _react2.default.createElement('path', { d: 'M52.12,32.63c1.82-.73,4.85-3.1,6.77-2.41,2.32.84,3.69,4.29,6.17,7.51C53.18,40.53,46,46.34,44.33,59.09c-3.44-2.49-6.81-3.94-8.39-6.49-.78-1.26,1.75-4.57,2.32-6.79.58-4.1-.09-9.19,2.14-12C42,31.85,47.46,33,52.12,32.63Z' }),
	                        _react2.default.createElement('path', { d: 'M101.07,81.24c-.54,4.9.36,10.08-1.79,12.3s-7.3,1.24-11,.93c-2.53,1.1-5.6,3.64-7.46,2.95-2.35-.87-3.73-4.38-6.26-7.72,11.78-2.61,18.83-8.58,21-21.18,3.35,2.38,6.87,3.66,7.94,6C104.27,76.31,101.78,79.49,101.07,81.24Z' })
	                  ),
	                  'spicy': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Picante'
	                        ),
	                        _react2.default.createElement('path', { d: 'M37.81,40.58,34.54,25l2-.31c0,1.67,0,3.33,0,5,.09,7.07,4.72,12.13,11.67,12.38,10.13.35,17.47,4.32,21.3,14.31A66.85,66.85,0,0,0,77.43,71c5.65,8,13.29,13.14,23.28,14.44a25.13,25.13,0,0,1,8.72,3c-8.86,6.63-18.4,6.9-28.13,4.23-16-4.38-27.94-14.81-37.6-27.57-3.17-4.19-3.18-10.81-4.56-16.33-.5-2-.78-4.06-1.16-6.1l4.39,8.85,8.41-7Z' })
	                  ),
	                  'peanuts': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Amendoins e Frutos Secos'
	                        ),
	                        _react2.default.createElement('path', {
	                              d: 'M59.35,24.81c-8.27.29-14.3,3.57-17.87,10.8-4.32,8.76-2.08,18.17,6.93,24.58s15,14.41,16.1,25.67A10.67,10.67,0,0,0,65.2,88C68,96.43,75,101.88,83.34,102.13a19.72,19.72,0,0,0,18.35-12.27c3.18-8.33,1.21-17.08-6.4-22.32-9.86-6.79-15.7-15.36-17.64-27.34C76.11,30.64,68.16,24.92,59.35,24.81Z' }),
	                        _react2.default.createElement('path', { d: 'M59.35,24.81c8.81.12,16.76,5.83,18.3,15.39,1.94,12,7.78,20.55,17.64,27.34,7.61,5.24,9.58,14,6.4,22.32a19.72,19.72,0,0,1-18.35,12.27C75,101.88,68,96.43,65.2,88a10.67,10.67,0,0,1-.69-2.17c-1.08-11.26-7-19.21-16.1-25.67S37.16,44.36,41.48,35.6C45,28.38,51.08,25.09,59.35,24.81ZM46.26,43.63l2.17.11c1.11-1.77,3.08-3.54,3.06-5.3s-2.14-3.27-3.34-4.91c-1.5,1.85-3.52,3.52-4.28,5.64C43.49,40.23,45.39,42.11,46.26,43.63ZM57.23,26c-1.77,2.38-3.32,3.61-3.49,5-.1.82,2,2.68,3.1,2.66s2.76-1.69,3-2.87S58.61,28.37,57.23,26Z' })
	                  ),
	                  'eggs': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Ovos'
	                        ),
	                        _react2.default.createElement('path', { d: 'M42.93,67.9c.73-11.54,3.65-23.44,11.88-33.4C63.38,24.15,74,23.73,82.39,34,93.07,47.13,96.5,62.56,93,79,90.16,92,78.41,99.59,65.12,98.28,53,97.09,43.83,86.41,42.94,72.34,42.87,71.22,42.93,70.09,42.93,67.9ZM60.58,47.55l2.54.1c1.46-2.63,3.45-5.13,4.1-7.95.25-1.1-2.52-4.13-3.91-4.13-3.88,0-6.12,2.94-5.87,6.69C57.55,44.09,59.47,45.79,60.58,47.55Z' })
	                  ),
	                  'gluten': _react2.default.createElement(
	                        'svg',
	                        { id: 'Camada_1', 'data-name': 'Camada 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 139 125' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'Gluten'
	                        ),
	                        _react2.default.createElement('path', { d: 'M91.17,81.68c2.38,7-.65,12.58-4.48,17.57-3.25,4.24-8.28,5.42-13.43,4.78-.9-.11-2.23-2.57-2.15-3.86C71.66,91.82,77.14,83.16,91.17,81.68Z' }),
	                        _react2.default.createElement('path', { d: 'M69,96.72C56.48,100.52,48.36,93.27,47,77,58.21,74.06,69.08,83.76,69,96.72Z' }),
	                        _react2.default.createElement('path', { d: 'M89.45,62.74c2.25,13-5.85,21.77-17.28,19.06C70.8,71.4,78.53,62.72,89.45,62.74Z' }),
	                        _react2.default.createElement('path', { d: 'M70.12,76C57.78,77.66,50.43,70.11,52,57.77,62.7,56.64,71,64.86,70.12,76Z' }),
	                        _react2.default.createElement('path', { d: 'M54.73,36.84C64.4,38.94,69.36,44,70.18,52.2c.35,3.51-.76,4.76-4.47,4.35C56.82,55.54,51.61,46.66,54.73,36.84Z' }),
	                        _react2.default.createElement('path', { d: 'M87.15,42.93C90.5,53.6,82.48,64.62,72.2,62.09,69.72,52.54,75.64,44.83,87.15,42.93Z' }),
	                        _react2.default.createElement('path', { d: 'M72.58,45.2c-8.52-8.72-8.32-17,.32-24.44C81.65,27.32,81.61,36.71,72.58,45.2Zm4.27-14.78-1.6-2.58c-1-.83-2.43-2.54-2.82-2.32-1.21.67-2.68,2-2.77,3.21a4,4,0,0,0,2.51,3.12C73.64,32.05,75.28,31,76.85,30.42Z' })
	                  ),
	                  'arrow': _react2.default.createElement(
	                        'svg',
	                        (_React$createElement = { xmlns: 'http://www.w3.org/2000/svg' }, _defineProperty(_React$createElement, 'xmlns', 'http://www.w3.org/1999/xlink'), _defineProperty(_React$createElement, 'viewBox', '0 0 477.175 477.175'), _React$createElement),
	                        _react2.default.createElement('path', { d: 'M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z' })
	                  ),
	                  'wine-type-1': _react2.default.createElement(
	                        'svg',
	                        { id: 'Capa_1', 'data-name': 'Capa 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 419.14 419.14' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'wine-glasse-red'
	                        ),
	                        _react2.default.createElement('circle', { style: { 'fill': '#891313' }, cx: '209.57', cy: '209.57', r: '155.24' }),
	                        _react2.default.createElement('path', { style: { 'fill': '#fff' },
	                              d: 'M267.91,162.1c.08-17.58-6.1-42.2-15.75-62.73L251.52,98l-83.34-.36L167.52,99c-9.83,20.44-16.22,45-16.29,62.59-.13,30.38,19,53.43,46.9,58.41a4.79,4.79,0,0,0-.28,1.36l0,11.31a4.8,4.8,0,0,0,3,4.48c0,.26,0,.49,0,.76,0,4.76,2.29,34.83,4.42,61.66,0,0,0,.07,0,.12s0,.25.06.39c.15,1.85.29,3.69.44,5.49-.4,5.9-4.55,5.83-7.68,10.9l-22-.1a4.83,4.83,0,0,0-4.85,4.81l75.43.33a4.82,4.82,0,0,0-4.8-4.85l-22-.1c-3.09-5.11-7.24-5.08-7.57-11,.16-1.82.33-3.63.48-5.48,0-.14,0-.26.07-.38s0-.09,0-.12c2.37-26.81,4.94-56.85,5-61.62,0-.27,0-.5,0-.76a4.8,4.8,0,0,0,3.08-4.45l0-11.31a4.79,4.79,0,0,0-.27-1.36C248.42,215.37,267.78,192.48,267.91,162.1Zm-96.69-59.63,77.2.34a178.54,178.54,0,0,1,9.79,27.52l-89-.39c-6.91,21.92-9.72,41.8,0,62.62q.93,2,2,4t2.21,3.82c-12.78-10-16.83-25.31-17.35-39.22C156.25,144.91,162.27,121.59,171.23,102.48Z' })
	                  ),
	                  'wine-type-2': _react2.default.createElement(
	                        'svg',
	                        { id: 'Capa_1', 'data-name': 'Capa 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 419.14 419.14' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'wine-glasse-white'
	                        ),
	                        _react2.default.createElement('circle', { style: { 'fill': '#f4ca19' }, cx: '209.57', cy: '209.57', r: '155.24' }),
	                        _react2.default.createElement('path', { style: { 'fill': '#fff' },
	                              d: 'M267.91,162.1c.08-17.58-6.1-42.2-15.75-62.73L251.52,98l-83.34-.36L167.52,99c-9.83,20.44-16.22,45-16.29,62.59-.13,30.38,19,53.43,46.9,58.41a4.79,4.79,0,0,0-.28,1.36l0,11.31a4.8,4.8,0,0,0,3,4.48c0,.26,0,.49,0,.76,0,4.76,2.29,34.83,4.42,61.66,0,0,0,.07,0,.12s0,.25.06.39c.15,1.85.29,3.69.44,5.49-.4,5.9-4.55,5.83-7.68,10.9l-22-.1a4.83,4.83,0,0,0-4.85,4.81l75.43.33a4.82,4.82,0,0,0-4.8-4.85l-22-.1c-3.09-5.11-7.24-5.08-7.57-11,.16-1.82.33-3.63.48-5.48,0-.14,0-.26.07-.38s0-.09,0-.12c2.37-26.81,4.94-56.85,5-61.62,0-.27,0-.5,0-.76a4.8,4.8,0,0,0,3.08-4.45l0-11.31a4.79,4.79,0,0,0-.27-1.36C248.42,215.37,267.78,192.48,267.91,162.1Zm-96.69-59.63,77.2.34a178.54,178.54,0,0,1,9.79,27.52l-89-.39c-6.91,21.92-9.72,41.8,0,62.62q.93,2,2,4t2.21,3.82c-12.78-10-16.83-25.31-17.35-39.22C156.25,144.91,162.27,121.59,171.23,102.48Z' })
	                  ),
	                  'wine-type-3': _react2.default.createElement(
	                        'svg',
	                        { id: 'Capa_1', 'data-name': 'Capa 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 419.14 419.14' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'wine-glasse-rose'
	                        ),
	                        _react2.default.createElement('circle', { style: { 'fill': '#ef7b7b' }, cx: '209.57', cy: '209.57', r: '155.24' }),
	                        _react2.default.createElement('path', { style: { 'fill': '#fff' },
	                              d: 'M267.91,162.1c.08-17.58-6.1-42.2-15.75-62.73L251.52,98l-83.34-.36L167.52,99c-9.83,20.44-16.22,45-16.29,62.59-.13,30.38,19,53.43,46.9,58.41a4.79,4.79,0,0,0-.28,1.36l0,11.31a4.8,4.8,0,0,0,3,4.48c0,.26,0,.49,0,.76,0,4.76,2.29,34.83,4.42,61.66,0,0,0,.07,0,.12s0,.25.06.39c.15,1.85.29,3.69.44,5.49-.4,5.9-4.55,5.83-7.68,10.9l-22-.1a4.83,4.83,0,0,0-4.85,4.81l75.43.33a4.82,4.82,0,0,0-4.8-4.85l-22-.1c-3.09-5.11-7.24-5.08-7.57-11,.16-1.82.33-3.63.48-5.48,0-.14,0-.26.07-.38s0-.09,0-.12c2.37-26.81,4.94-56.85,5-61.62,0-.27,0-.5,0-.76a4.8,4.8,0,0,0,3.08-4.45l0-11.31a4.79,4.79,0,0,0-.27-1.36C248.42,215.37,267.78,192.48,267.91,162.1Zm-96.69-59.63,77.2.34a178.54,178.54,0,0,1,9.79,27.52l-89-.39c-6.91,21.92-9.72,41.8,0,62.62q.93,2,2,4t2.21,3.82c-12.78-10-16.83-25.31-17.35-39.22C156.25,144.91,162.27,121.59,171.23,102.48Z' })
	                  ),
	                  'wine-type-4': _react2.default.createElement(
	                        'svg',
	                        { id: 'Capa_1', 'data-name': 'Capa 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 419.14 419.14' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'wine-glasse-green'
	                        ),
	                        _react2.default.createElement('circle', { style: { 'fill': '#98FB98' }, cx: '209.57', cy: '209.57', r: '155.24' }),
	                        _react2.default.createElement('path', { style: { 'fill': '#fff' },
	                              d: 'M267.91,162.1c.08-17.58-6.1-42.2-15.75-62.73L251.52,98l-83.34-.36L167.52,99c-9.83,20.44-16.22,45-16.29,62.59-.13,30.38,19,53.43,46.9,58.41a4.79,4.79,0,0,0-.28,1.36l0,11.31a4.8,4.8,0,0,0,3,4.48c0,.26,0,.49,0,.76,0,4.76,2.29,34.83,4.42,61.66,0,0,0,.07,0,.12s0,.25.06.39c.15,1.85.29,3.69.44,5.49-.4,5.9-4.55,5.83-7.68,10.9l-22-.1a4.83,4.83,0,0,0-4.85,4.81l75.43.33a4.82,4.82,0,0,0-4.8-4.85l-22-.1c-3.09-5.11-7.24-5.08-7.57-11,.16-1.82.33-3.63.48-5.48,0-.14,0-.26.07-.38s0-.09,0-.12c2.37-26.81,4.94-56.85,5-61.62,0-.27,0-.5,0-.76a4.8,4.8,0,0,0,3.08-4.45l0-11.31a4.79,4.79,0,0,0-.27-1.36C248.42,215.37,267.78,192.48,267.91,162.1Zm-96.69-59.63,77.2.34a178.54,178.54,0,0,1,9.79,27.52l-89-.39c-6.91,21.92-9.72,41.8,0,62.62q.93,2,2,4t2.21,3.82c-12.78-10-16.83-25.31-17.35-39.22C156.25,144.91,162.27,121.59,171.23,102.48Z' })
	                  ),
	                  'wine-type-5': _react2.default.createElement(
	                        'svg',
	                        { id: 'Capa_1', 'data-name': 'Capa 1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 419.14 419.14' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'wine-glasse-champagne'
	                        ),
	                        _react2.default.createElement('circle', { style: { 'fill': '#d1b459' }, cx: '209.57', cy: '209.57', r: '155.24' }),
	                        _react2.default.createElement(
	                              'g',
	                              { transform: 'matrix(0.48189901,0,0,0.48189901,-13.369027,7.9579463)' },
	                              _react2.default.createElement('path', {
	                                    d: 'm 582.48,615.58 c -2.03,-6.08 -0.46,-10.16 5.85,-13.4 5.47,-2.8 11.27,-4.94 16.83,-7.57 8.37,-3.96 10.13,-7.56 8.53,-16.71 -6.14,-35.09 -15.87,-69.3 -25.6,-103.51 -1.27,-4.47 -2.98,-8.84 -4.03,-13.36 -5.49,-23.55 -20.52,-41.49 -34.94,-59.8 C 538,387.11 526.4,373.34 517.28,357.75 505.76,338.07 498.47,316.65 491.5,295.1 c -8.45,-26.13 -13.85,-53.03 -20.41,-79.65 -0.86,-3.5 0.31,-4.31 3.15,-5.06 25.2,-6.67 50.39,-13.41 75.58,-20.15 5.62,-1.5 11.23,-3.02 16.81,-4.63 2.75,-0.79 4.14,-0.18 5.06,2.83 10.6,34.65 21.32,69.26 27.49,105.08 4.39,25.48 4.75,50.86 0.66,76.45 -3.12,19.51 -6.28,39.06 -7.19,58.86 -0.5,10.82 2.44,21.1 4.82,31.43 8.65,37.59 18.51,74.86 31.15,111.34 3.98,11.49 7.52,13.59 19.86,12.02 4.78,-0.61 9.59,-0.93 14.39,-1.42 5.48,-0.56 9.74,1.35 12.61,6.12 0,1 0,2 0,3 -14.77,3.86 -29.55,7.72 -44.32,11.57 -16.22,4.23 -32.45,8.46 -48.68,12.69 z m -39.2,-347.06 c 10.66,0 21.33,0.01 31.99,0 6,-0.01 5.86,0.01 4.59,-5.74 -4.55,-20.62 -11.42,-40.61 -16.77,-61.01 -0.84,-3.2 -2.24,-5.31 -6.68,-4.06 -22.7,6.39 -45.49,12.47 -68.31,18.43 -3.03,0.79 -3.56,1.67 -2.87,4.68 5.24,22.84 10.81,45.59 17.29,68.13 11.26,39.15 29.16,74.62 56.52,105.06 2.9,3.23 5.86,6.39 9.73,8.52 1.76,0.97 3.55,1.85 5.66,1.67 1.2,-0.1 2.46,-0.36 2.95,-1.5 0.5,-1.16 -0.75,-1.67 -1.43,-2.34 -9.34,-9.32 -17.29,-19.82 -25.44,-30.14 -22.81,-28.91 -33.44,-63.3 -43.78,-97.81 -1.02,-3.41 0.65,-3.95 3.55,-3.93 11,0.1 22,0.04 33,0.04 z',
	                                    style: { 'fill': '#fff' } }),
	                              _react2.default.createElement('path', {
	                                    d: 'm 341.23,429.12 c -0.26,-18.01 -2.74,-35.84 -6.02,-53.47 -6.59,-35.41 -3.36,-70.19 4.39,-104.94 6.2,-27.79 14.99,-54.83 22.92,-82.13 1.07,-3.67 3.02,-3.47 5.97,-2.67 30.48,8.21 60.99,16.33 91.5,24.46 2.48,0.66 4.11,1.48 3.34,4.74 -8.79,37.04 -17.26,74.12 -30.74,109.91 -10.46,27.77 -27.11,51.38 -45.58,74.07 -9.57,11.75 -19.18,23.53 -26.76,36.7 -7.72,13.4 -11.06,28.5 -15.31,43.14 -9.16,31.61 -17.69,63.4 -23.88,95.77 -2.38,12.45 -0.46,16.5 11.12,21.39 4.6,1.94 9.25,3.78 13.69,6.05 3.61,1.85 6.68,4.36 6.84,9.08 0.12,3.57 -0.96,4.8 -4.69,3.78 -17.14,-4.7 -34.33,-9.23 -51.5,-13.83 -11.23,-3.01 -22.46,-6.02 -33.69,-9.04 -4.39,-1.18 -4.93,-2.79 -2.08,-6.31 2.02,-2.5 4.73,-3.44 7.9,-3.61 6.21,-0.32 12.28,0.79 18.36,1.65 10.05,1.43 14.87,-1.1 18.1,-10.51 15,-43.78 26.94,-88.4 36.04,-133.77 0.67,-3.36 0.08,-6.97 0.08,-10.46 z m 19.64,-24.8 c -2.6,-7.44 -3.73,-14.28 -4.93,-21.11 -2.91,-16.56 -5.56,-33.18 -5.1,-50.01 0.52,-19.49 4.14,-38.63 8.01,-57.71 0.7,-3.47 2.18,-4.4 5.65,-4.38 22.32,0.17 44.64,-0.05 66.95,0.21 4.43,0.05 6.08,-1.48 6.99,-5.54 3.27,-14.58 6.63,-29.15 10.39,-43.61 1.09,-4.19 0.02,-5.5 -3.87,-6.51 -22.49,-5.85 -44.95,-11.85 -67.37,-17.95 -3.23,-0.88 -4.77,-0.42 -5.75,3.03 -4.53,15.98 -9.62,31.8 -13.88,47.84 -6.53,24.59 -11.84,49.41 -13.77,74.89 -1.19,15.74 0.52,31.22 2.75,46.69 1.18,8.21 1.81,16.55 4.54,24.46 1.46,4.25 3.13,8.51 9.39,9.7 z',
	                                    style: { 'fill': '#fff' } }),
	                              _react2.default.createElement('path', {
	                                    id: 'path17',
	                                    d: 'm 470.61,172.33 c -0.01,8.33 0,16.66 -0.01,24.99 0,2.44 -0.2,4.91 -3.49,4.95 -3.2,0.04 -3.67,-2.23 -3.67,-4.79 0.01,-17.16 0.01,-34.32 -0.01,-51.48 0,-2.63 0.56,-4.75 3.77,-4.65 3.31,0.11 3.42,2.54 3.42,4.99 -0.01,8.66 -0.01,17.32 -0.01,25.99 z',
	                                    style: { 'fill': '#fff' } }),
	                              _react2.default.createElement('path', {
	                                    id: 'path19',
	                                    d: 'm 481.07,202.3 c -3.33,0.14 -4.75,-2.85 -2.79,-6.48 4.51,-8.33 9.18,-16.56 13.8,-24.82 1.78,-3.19 3.57,-6.38 5.41,-9.53 1.21,-2.08 2.93,-3.4 5.34,-2.08 2.42,1.33 2.21,3.58 1.08,5.63 -6.5,11.78 -13.08,23.52 -19.65,35.26 -0.68,1.21 -1.68,2.05 -3.19,2.02 z',
	                                    style: { 'fill': '#fff' } }),
	                              _react2.default.createElement('path', {
	                                    id: 'path21',
	                                    d: 'm 431.45,159.53 c 3.41,-0.55 4.53,0.63 5.38,2.16 6.44,11.45 12.86,22.91 19.29,34.36 1.22,2.18 1.23,4.3 -0.96,5.7 -2.3,1.47 -4.3,0.29 -5.47,-1.77 -6.64,-11.72 -13.25,-23.45 -19.67,-35.29 -1.45,-2.66 -0.18,-4.69 1.43,-5.16 z',
	                                    style: { 'fill': '#fff' } })
	                        )
	                  ),
	                  'wine-type-6': _react2.default.createElement(
	                        'svg',
	                        { xmlns: 'http://www.w3.org/2000/svg', id: 'Capa_1', 'data-name': 'Capa 1', viewBox: '0 0 419.14 419.14' },
	                        _react2.default.createElement(
	                              'title',
	                              null,
	                              'magnum'
	                        ),
	                        _react2.default.createElement('circle', { style: { 'fill': '#6C6A6A' }, cx: '209.57', cy: '209.57', r: '155.24', id: 'circle4' }),
	                        _react2.default.createElement('g', {
	                              id: 'g23',
	                              transform: 'matrix(0.48189901,0,0,0.48189901,-13.369027,7.9579463)' }),
	                        _react2.default.createElement('path', {
	                              d: 'm 221.4889,99.452067 c 0.0606,16.040073 -0.25451,32.080143 0.32722,48.108093 0.1515,4.19333 1.7755,9.08958 4.84778,12.37394 21.02721,22.64516 16.80965,17.76103 17.0581,44.18746 0.2848,30.6864 0.0727,61.37886 0.0606,92.06527 0,9.00474 -3.20559,11.51346 -14.44031,11.51346 -13.39197,0 -26.77789,0 -40.16986,0 -7.94429,0 -12.04672,-2.95108 -12.06489,-9.21077 -0.0848,-37.93382 -0.32723,-75.87371 0.35146,-113.80147 0.0909,-5.03563 3.71461,-11.02869 8.09578,-14.83419 11.65283,-10.11973 15.0584,-21.49381 13.89493,-34.80095 -1.03015,-11.81645 -0.14543,-23.73591 -0.10302,-35.606903 z m -33.49811,194.686573 1.11498,0.0667 a 22.887549,22.887549 0 0 0 0.73323,-3.79944 c 0.812,-32.32253 1.97547,-64.65112 2.09666,-96.95546 0.0606,-8.67146 2.90867,-15.94918 8.64116,-22.90573 l 4.68416,-5.69008 c -10.05913,6.9202 -19.62136,14.22216 -19.6759,25.62654 -0.15755,25.09935 -0.21209,50.20476 0.13331,75.3041 0.12726,9.43498 1.47857,18.8942 2.2724,28.35341 z',
	                              id: 'path10',
	                              style: { 'strokeWidth': 0.60597163, 'fill': '#ffffff' } })
	                  ),
	                  'sulfites-free': _react2.default.createElement(
	                        'svg',
	                        { id: 'Capa_1', viewBox: '0 0 512 512', width: '36px', xmlns: 'http://www.w3.org/2000/svg' },
	                        _react2.default.createElement(
	                              'g',
	                              null,
	                              _react2.default.createElement('path', { d: 'm346.672 257.748c-20.394-31.004-31.174-67.008-31.174-104.119v-63.285h31.419v-90.344h-181.834v90.344h31.419v63.285c0 37.111-10.78 73.115-31.174 104.119l-114.092 173.453v80.799h409.528v-80.799zm-151.476-197.517v-30.118h121.607v30.117h-121.607zm31.419 93.398v-63.285h58.77v63.285c0 43.009 12.493 84.736 36.128 120.668l3.184 4.84h-137.394l3.184-4.84c23.635-35.932 36.128-77.659 36.128-120.668zm204.035 328.258h-349.3v-41.67l86.145-130.966h177.01l86.146 130.966v41.67z' }),
	                              _react2.default.createElement('path', { d: 'm194.993 366.47c0-2.724 2.497-4.994 10.329-4.994 6.924 0 14.302 1.93 22.134 5.903l8.06-19.411c-8.287-4.654-19.297-6.924-29.967-6.924-24.632 0-37.005 12.032-37.005 26.788 0 29.626 43.929 21.567 43.929 31.556 0 2.724-2.724 4.314-10.329 4.314-8.74 0-18.729-2.838-26.221-7.265l-8.627 19.524c7.945 4.881 21.34 8.173 34.621 8.173 24.632 0 37.004-12.26 37.004-26.789 0-29.286-43.928-21.34-43.928-30.875z' }),
	                              _react2.default.createElement('path', { d: 'm297.038 341.044c-25.881 0-44.837 17.48-44.837 41.545s18.956 41.545 44.837 41.545c25.88 0 44.836-17.481 44.836-41.545s-18.955-41.545-44.836-41.545zm0 61.409c-9.876 0-17.821-7.492-17.821-19.864 0-12.373 7.945-19.864 17.821-19.864 9.875 0 17.821 7.492 17.821 19.864 0 12.373-7.946 19.864-17.821 19.864z' }),
	                              _react2.default.createElement('path', { d: 'm358.59 425.928c1.393-2.786 4.047-4.312 6.832-4.312 2.985 0 4.511 1.393 4.511 3.648 0 1.592-.464 3.383-3.648 6.368l-16.783 15.522v9.619h37.214v-12.139h-15.655l6.634-6.036c6.766-6.103 7.96-10.216 7.96-14.793 0-8.823-7.761-14.527-18.773-14.527-10.017 0-16.717 4.378-20.1 10.747z' })
	                        )
	                  ),
	                  'sulfites': _react2.default.createElement(
	                        'svg',
	                        { id: 'Capa_1', viewBox: '0 0 512 512', width: '36px', xmlns: 'http://www.w3.org/2000/svg' },
	                        _react2.default.createElement(
	                              'g',
	                              null,
	                              _react2.default.createElement('path', { d: 'm346.672 257.748c-20.394-31.004-31.174-67.008-31.174-104.119v-63.285h31.419v-90.344h-181.834v90.344h31.419v63.285c0 37.111-10.78 73.115-31.174 104.119l-114.092 173.453v80.799h409.528v-80.799zm-151.476-197.517v-30.118h121.607v30.117h-121.607zm31.419 93.398v-63.285h58.77v63.285c0 43.009 12.493 84.736 36.128 120.668l3.184 4.84h-137.394l3.184-4.84c23.635-35.932 36.128-77.659 36.128-120.668zm204.035 328.258h-349.3v-41.67l86.145-130.966h177.01l86.146 130.966v41.67z' }),
	                              _react2.default.createElement('path', { d: 'm194.993 366.47c0-2.724 2.497-4.994 10.329-4.994 6.924 0 14.302 1.93 22.134 5.903l8.06-19.411c-8.287-4.654-19.297-6.924-29.967-6.924-24.632 0-37.005 12.032-37.005 26.788 0 29.626 43.929 21.567 43.929 31.556 0 2.724-2.724 4.314-10.329 4.314-8.74 0-18.729-2.838-26.221-7.265l-8.627 19.524c7.945 4.881 21.34 8.173 34.621 8.173 24.632 0 37.004-12.26 37.004-26.789 0-29.286-43.928-21.34-43.928-30.875z' }),
	                              _react2.default.createElement('path', { d: 'm297.038 341.044c-25.881 0-44.837 17.48-44.837 41.545s18.956 41.545 44.837 41.545c25.88 0 44.836-17.481 44.836-41.545s-18.955-41.545-44.836-41.545zm0 61.409c-9.876 0-17.821-7.492-17.821-19.864 0-12.373 7.945-19.864 17.821-19.864 9.875 0 17.821 7.492 17.821 19.864 0 12.373-7.946 19.864-17.821 19.864z' }),
	                              _react2.default.createElement('path', { d: 'm358.59 425.928c1.393-2.786 4.047-4.312 6.832-4.312 2.985 0 4.511 1.393 4.511 3.648 0 1.592-.464 3.383-3.648 6.368l-16.783 15.522v9.619h37.214v-12.139h-15.655l6.634-6.036c6.766-6.103 7.96-10.216 7.96-14.793 0-8.823-7.761-14.527-18.773-14.527-10.017 0-16.717 4.378-20.1 10.747z' })
	                        )
	                  )
	
	            };
	            return _this;
	      }
	
	      _createClass(SvgIcons, [{
	            key: 'chooseIcon',
	            value: function chooseIcon(icon) {
	                  return this.icons[icon];
	            }
	      }, {
	            key: 'render',
	            value: function render() {
	                  return _react2.default.createElement(
	                        'span',
	                        null,
	                        this.chooseIcon(this.props.icon)
	                  );
	            }
	      }]);
	
	      return SvgIcons;
	}(_react2.default.PureComponent);
	
	SvgIcons.propTypes = {
	      icon: _react.PropTypes.string
	};
	exports.default = SvgIcons;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Empty = function (_React$PureComponent) {
	  _inherits(Empty, _React$PureComponent);
	
	  function Empty() {
	    _classCallCheck(this, Empty);
	
	    return _possibleConstructorReturn(this, (Empty.__proto__ || Object.getPrototypeOf(Empty)).apply(this, arguments));
	  }
	
	  _createClass(Empty, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'empty list-item' },
	        _react2.default.createElement('img', { src: __webpack_require__(57) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'item-info' },
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'empty-title' },
	            function (message) {
	              return _react2.default.createElement(
	                'h3',
	                { className: 'item-title empty-title' },
	                message
	              );
	            }
	          ),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'empty-text' },
	            function (message) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'empty-text' },
	                message
	              );
	            }
	          )
	        )
	      );
	    }
	  }]);
	
	  return Empty;
	}(_react2.default.PureComponent);
	
	exports.default = Empty;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/placeholder_prato.jpg";

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(407);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(468);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 59 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactInputAutosize = __webpack_require__(302);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(26);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _defaultArrowRenderer = __webpack_require__(141);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultFilterOptions = __webpack_require__(79);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(80);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultClearRenderer = __webpack_require__(142);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _Option = __webpack_require__(139);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(140);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Copyright (c) 2017 Jed Watson.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleRequired', 'handleTouchOutside', 'handleTouchMove', 'handleTouchStart', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleValueClick', 'getOptionLabel', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: this.handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: this.handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
					menuNode.scrollTop = focusedOptionNode.offsetTop;
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					return;
				}
	
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// TODO: This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				if (!this.state.isOpen) {
					return;
				}
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi,
						inputValue: this.handleInputValueChange('')
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
				var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
				this.setState({
					isFocused: true,
					isOpen: isOpen
				});
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					isOpen: true,
					isPseudoFocused: false,
					inputValue: newInputValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						return;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							return;
						}
						event.preventDefault();
						this.selectFocusedOption();
						return;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						return;
						break;
					case 27:
						// escape
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							return;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							return;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						this.focusPreviousOption();
						break;
					case 40:
						// down
						this.focusNextOption();
						break;
					case 33:
						// page up
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							return;
						}
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							return;
						}
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						return;
					default:
						return;
				}
				event.preventDefault();
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'handleRequired',
			value: function handleRequired(value, multi) {
				if (!value) return true;
				return multi ? value.length === 0 : Object.keys(value).length === 0;
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param	{String|Number|Array}	value		- the value of the select input
	   * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value, nextProps) {
				var _this2 = this;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return _this2.expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = this.expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
	
			/**
	   * Retrieve a value from the given options and valueKey
	   * @param	{String|Number|Array}	value	- the selected value(s)
	   * @param	{Object}		props	- the Select component's props (or nextProps)
	   */
	
		}, {
			key: 'expandValue',
			value: function expandValue(value, props) {
				var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
				if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
				var options = props.options,
				    valueKey = props.valueKey;
	
				if (!options) return;
				for (var i = 0; i < options.length; i++) {
					if (String(options[i][valueKey]) === String(value)) return options[i];
				}
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this3 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = this.handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.onChange) {
					if (this.props.simpleValue && value) {
						value = this.props.multi ? value.map(function (i) {
							return i[_this3.props.valueKey];
						}).join(this.props.delimiter) : value[this.props.valueKey];
					}
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this4 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				if (this.props.multi) {
					var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this4.getValueArray(_this4.props.value);
						if (valueArray.some(function (i) {
							return i[_this4.props.valueKey] === value[_this4.props.valueKey];
						})) {
							_this4.removeValue(value);
						} else {
							_this4.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this4.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this5 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this5.props.valueKey] !== value[_this5.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				event.stopPropagation();
				event.preventDefault();
				this.setValue(this.getResetValue());
				this.setState({
					isOpen: false,
					inputValue: this.handleInputValueChange('')
				}, this.focus);
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						inputValue: '',
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
					});
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var potentialIndex = focusedIndex + this.props.pageSize;
					if (potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this6 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					return !this.state.inputValue ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								id: _this6._instancePrefix + '-value-' + i,
								instancePrefix: _this6._instancePrefix,
								disabled: _this6.props.disabled || value.clearableValue === false,
								key: 'value-' + i + '-' + value[_this6.props.valueKey],
								onClick: onClick,
								onRemove: _this6.removeValue,
								value: value
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (!this.state.inputValue) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							id: this._instancePrefix + '-value-item',
							disabled: this.props.disabled,
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this7 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = !!this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
				var inputProps = _extends({}, this.props.inputProps, {
					role: 'combobox',
					'aria-expanded': '' + isOpen,
					'aria-owns': ariaOwns,
					'aria-haspopup': '' + isOpen,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-label': this.props['aria-label'],
					className: className,
					tabIndex: this.props.tabIndex,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this7.input = _ref;
					},
					required: this.state.required,
					value: this.state.inputValue
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var _props$inputProps = this.props.inputProps,
					    inputClassName = _props$inputProps.inputClassName,
					    divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						role: 'combobox',
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-labelledby': this.props['aria-labelledby'],
						'aria-label': this.props['aria-label'],
						className: className,
						tabIndex: this.props.tabIndex || 0,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this7.input = _ref2;
						},
						'aria-disabled': '' + !!this.props.disabled,
						style: { border: 0, width: 1, display: 'inline-block' } }));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap' },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
						'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
						onMouseDown: this.clearValue,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEndClearValue
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						valueKey: this.props.valueKey,
						trimFilter: this.props.trimFilter
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						selectValue: this.selectValue,
						removeValue: this.removeValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey,
						onOptionRef: this.onOptionRef
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this8 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this8.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						type: 'hidden',
						ref: function ref(_ref3) {
							return _this8.value = _ref3;
						},
						name: this.props.name,
						value: value,
						disabled: this.props.disabled });
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', { key: 'hidden.' + index,
						type: 'hidden',
						ref: 'value' + index,
						name: _this8.props.name,
						value: stringifyValue(item[_this8.props.valueKey]),
						disabled: _this8.props.disabled });
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this9 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this9.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref4) {
								return _this9.menu = _ref4;
							}, role: 'listbox', tabIndex: -1, className: 'Select-menu', id: this._instancePrefix + '-list',
							style: this.props.menuStyle,
							onScroll: this.handleMenuScroll,
							onMouseDown: this.handleMouseDownOnMenu },
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this10 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'Select--multi': this.props.multi,
					'Select--single': !this.props.multi,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'has-value': valueArray.length,
					'Select--rtl': this.props.rtl
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this10.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this10.control = _ref6;
							},
							className: 'Select-control',
							style: this.props.style,
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchStart: this.handleTouchStart,
							onTouchMove: this.handleTouchMove
						},
						_react2.default.createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	;
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onSelectResetsInput: true,
		onCloseResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 61 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getHostProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var hostProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        hostProps[key] = props[key];
	      }
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventConstants = __webpack_require__(27);
	var EventPluginRegistry = __webpack_require__(84);
	var ReactEventEmitterMixin = __webpack_require__(372);
	var ViewportMetrics = __webpack_require__(162);
	
	var getVendorPrefixedEventName = __webpack_require__(403);
	var isEventSupported = __webpack_require__(101);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(49);
	var ViewportMetrics = __webpack_require__(162);
	
	var getEventModifierState = __webpack_require__(99);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 64 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	var DOMNamespaces = __webpack_require__(83);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(97);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	var isFunction = __webpack_require__(15);
	
	module.exports = irreducible('Function', isFunction);


/***/ },
/* 67 */
/***/ function(module, exports) {

	module.exports = function isBoolean(x) {
	  return x === true || x === false;
	};

/***/ },
/* 68 */
/***/ function(module, exports) {

	module.exports = function isString(x) {
	  return typeof x === 'string';
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RestaurantError = function (_React$Component) {
	  _inherits(RestaurantError, _React$Component);
	
	  function RestaurantError() {
	    _classCallCheck(this, RestaurantError);
	
	    return _possibleConstructorReturn(this, (RestaurantError.__proto__ || Object.getPrototypeOf(RestaurantError)).apply(this, arguments));
	  }
	
	  _createClass(RestaurantError, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.lang = this.props.next.params.lang;
	      this.restaurant = this.props.next.params.restaurant;
	
	      if (this.props.view === 'api') {
	        this.lang = this.props.lang;
	        this.restaurant = this.props.restaurant;
	      }
	
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(
	      //title
	      'Pickly',
	      //view
	      'error',
	      //back button or not
	      true);
	    }
	    // todo something is wrong in this props
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var anchor_url = '';
	
	      if (this.props.restaurant === '') {
	        anchor_url = 'https://picklyapp.com/';
	      } else {
	        anchor_url = '/' + this.lang + ('/' + this.restaurant);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'restaurant-error error-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'error-content' },
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'error_home_title1' },
	              function (message) {
	                return _react2.default.createElement(
	                  'h2',
	                  null,
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'error_home_title2' },
	              function (message) {
	                return _react2.default.createElement(
	                  'h4',
	                  null,
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'error_home_text' },
	              function (message) {
	                return _react2.default.createElement(
	                  'p',
	                  null,
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'btn secondary-btn big-btn',
	                href: anchor_url },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'error_home_link' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RestaurantError;
	}(_react2.default.Component);
	
	RestaurantError.propTypes = {
	  lang: _react.PropTypes.string,
	  next: _react.PropTypes.object,
	  restaurant: _react.PropTypes.string,
	  view: _react.PropTypes.string,
	  view_info: _react.PropTypes.func
	};
	exports.default = RestaurantError;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _favCheck = __webpack_require__(72);
	
	var _universalCookie = __webpack_require__(45);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cookies = new _universalCookie2.default();
	
	var favBtn = function (_React$Component) {
	  _inherits(favBtn, _React$Component);
	
	  function favBtn(props) {
	    _classCallCheck(this, favBtn);
	
	    var _this = _possibleConstructorReturn(this, (favBtn.__proto__ || Object.getPrototypeOf(favBtn)).call(this, props));
	
	    _this.favsTotal = 0;
	    _this.state = {
	      favToggle: false
	    };
	
	    _this.saveCookie = _this.saveCookie.bind(_this);
	    return _this;
	  }
	
	  _createClass(favBtn, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ favToggle: (0, _favCheck.favCheck)(this.props.pk, this.props.itemType) });
	
	      if (cookies.get('shortlist') === undefined) {
	        var cookieString = 'food=&drink=';
	        cookies.set('shortlist', cookieString, { path: this.props.restaurant + '/', maxAge: 1300 });
	      }
	      if (this.props.favList === true) {
	        this.setState({ favToggle: true });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      //VERIFIES IF THE USER CAME FROM THE LIST OR ANOTHER ITEM, EITHER WAY THE PK SHOULD BE DIFFERENT
	      if (prevProps.pk !== this.props.pk) {
	        if (cookies.get('shortlist') === undefined) {
	          var cookieString = 'food=&drink=';
	          cookies.set('shortlist', cookieString, { path: this.props.restaurant + '/', maxAge: 1300 });
	        }
	      }
	    }
	  }, {
	    key: 'saveCookie',
	    value: function saveCookie() {
	      var itemId = String(this.props.pk);
	      var itemType = this.props.itemType;
	
	      //Get the cookie and store it into an array
	      //ex: food=1,2,3&drink=4,5,6 becomes favList=["food=1,2,3", "drink=4,5,6"]
	      var favList = cookies.get('shortlist').split('&');
	      var drinkArray = [];
	      var foodArray = [];
	      var index = null;
	
	      //Build the food and drink arrays from the cookie info
	      //Firstly, get a substring from the cookie with the values from drinks and food
	      //ex: favList=["food=1,2,3", "drink=4,5,6"] become "1,2,3" and "4,5,6"
	      var foodString = favList[0].substring(favList[0].indexOf('=') + 1);
	      var drinkString = favList[1].substring(favList[1].indexOf('=') + 1);
	
	      //TOGGLE, if the status is true sets to false, vice-versa
	      this.setState({ favToggle: !this.state.favToggle });
	      //Then split the substring into an array we can work with
	      //ex: "1,2,3" becomes foodArray=[1,2,3]
	
	
	      if (foodString.length > 0) {
	        foodArray = foodString.split(',');
	      }
	      if (drinkString.length > 0) {
	        drinkArray = drinkString.split(',');
	      }
	
	      //Check if the selected item is already in array
	      //If true, it is removed, if false it is added
	      //Checking for food
	      if (itemType === 'food') {
	        index = foodArray.indexOf(itemId);
	
	        if (index === -1) {
	          foodArray.push(itemId);
	        } else {
	          foodArray.splice(index, 1);
	        }
	      }
	      //And for drinks
	      else {
	          index = drinkArray.indexOf(itemId);
	          if (index === -1) {
	            drinkArray.push(itemId);
	          } else {
	            drinkArray.splice(index, 1);
	          }
	        }
	
	      this.favsTotal = foodArray.length + drinkArray.length;
	      cookies.set('favsTotal', this.favsTotal, { path: this.props.restaurant + '/', maxAge: 1300 });
	
	      //Finally, convert and then add both arrays into a final string that we can save into the cookie.
	      var cookieString = 'food=' + foodArray.toString() + '&drink=' + drinkArray.toString();
	
	      cookies.set('shortlist', cookieString, { path: this.props.restaurant + '/', maxAge: 1300 });
	      if (typeof this.props.onClick === 'function') {
	        this.props.onClick(this.favsTotal);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      //this.setState({favToggle: favCheck(this.props.pk, this.props.itemType)});
	
	      return _react2.default.createElement('button', { className: 'fav-btn btn ' + (0, _favCheck.favCheck)(this.props.pk, this.props.itemType), onClick: this.saveCookie });
	    }
	  }]);
	
	  return favBtn;
	}(_react2.default.Component);
	
	favBtn.propTypes = {
	  itemType: _react.PropTypes.string,
	  onClick: _react.PropTypes.func,
	  pk: _react.PropTypes.number,
	  restaurant: _react.PropTypes.string,
	  favList: _react.PropTypes.bool
	};
	exports.default = favBtn;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_React$PureComponent) {
	  _inherits(ListItem, _React$PureComponent);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  _createClass(ListItem, [{
	    key: 'checkWineProps',
	    value: function checkWineProps() {
	
	      if (this.props.itemType === 'wine') {
	        // IT's a WINE
	        if (this.props.list !== 'true') {
	          // NOT A LIST
	          return _react2.default.createElement(
	            'div',
	            { className: 'wine-props' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'type' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'h4',
	                    { className: 'prop-label' },
	                    message
	                  );
	                }
	              ),
	              this.props.type
	            ),
	            this.props.region ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'region' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'h4',
	                    { className: 'prop-label' },
	                    message
	                  );
	                }
	              ),
	              this.props.region.name,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'contry-code' },
	                this.props.region.country_code
	              )
	            ) : null
	          );
	        } else {
	          // ITs BEING RENDERED IN A LIST
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              { className: 'type' },
	              this.props.type
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'region' },
	              this.props.region.name,
	              ',',
	              _react2.default.createElement(
	                'span',
	                { className: 'contry-code' },
	                this.props.region.country_code
	              )
	            )
	          );
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: this.props.gallery, alt: this.props.name, className: 'item-thumbnail' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'item-info' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'item-title' },
	            this.props.name,
	            this.props.price ? _react2.default.createElement(
	              'span',
	              { className: 'price' },
	              this.props.price,
	              '\u20AC',
	              this.props.unit === 'Kg' ? '/Kg' : null
	            ) : _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'price_under_request' },
	              function (message) {
	                return _react2.default.createElement(
	                  'span',
	                  { className: 'price' },
	                  message
	                );
	              }
	            )
	          ),
	          this.props.list !== 'true' ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.description } }) : null,
	          this.checkWineProps()
	        )
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react2.default.PureComponent);
	
	ListItem.propTypes = {
	  body: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  gallery: _react.PropTypes.string,
	  itemType: _react.PropTypes.string,
	  list: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  price: _react.PropTypes.string,
	  region: _react.PropTypes.object,
	  sweetness: _react.PropTypes.string,
	  template: _react.PropTypes.string,
	  type: _react.PropTypes.string,
	  unit: _react.PropTypes.string
	};
	exports.default = ListItem;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.favCheck = favCheck;
	
	var _universalCookie = __webpack_require__(45);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cookies = new _universalCookie2.default();
	
	function favCheck(itemId, itemType) {
	  itemId = String(itemId);
	
	  //Get the cookie and store it into an array
	  //ex: food=1,2,3&drink=4,5,6 becomes favList=["food=1,2,3", "drink=4,5,6"]
	  if (cookies.get('shortlist') !== undefined) {
	    var favList = cookies.get('shortlist').split('&');
	    var drinkArray = [];
	    var foodArray = [];
	    var index = null;
	
	    //Build the food and drink arrays from the cookie info
	    //Firstly, get a substring from the cookie with the values from drinks and food
	    //ex: favList=["food=1,2,3", "drink=4,5,6"] become "1,2,3" and "4,5,6"
	    var foodString = favList[0].substring(favList[0].indexOf('=') + 1);
	    var drinkString = favList[1].substring(favList[1].indexOf('=') + 1);
	
	    //Then split the substring into an array we can work with
	    //ex: "1,2,3" becomes foodArray=[1,2,3]
	    if (foodString.length > 0) {
	      foodArray = foodString.split(',');
	    }
	    if (drinkString.length > 0) {
	      drinkArray = drinkString.split(',');
	    }
	
	    //Check if the selected item is already in array
	    //Checking for food
	    if (itemType === 'food') {
	      index = foodArray.indexOf(itemId);
	      return index !== -1;
	    }
	    //And for drinks
	    else {
	        index = drinkArray.indexOf(itemId);
	        return index !== -1;
	      }
	  }
	  // NO COOKIES WERE SET YET
	  return false;
	}

/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(76);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(22);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(330);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(60);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(137);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(332);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(138);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(140);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(139);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(80);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(141);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(142);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(79);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(143);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(333);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterOptions(options, filterValue, excludeOptions, props) {
		var _this = this;
	
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
			if (!filterValue) return true;
			var valueTest = String(option[props.valueKey]);
			var labelTest = String(option[props.labelKey]);
	
			if (props.ignoreAccents) {
				if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
			return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	}
	
	exports.default = filterOptions;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(26);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    instancePrefix = _ref.instancePrefix,
		    labelKey = _ref.labelKey,
		    onFocus = _ref.onFocus,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey,
		    onOptionRef = _ref.onOptionRef;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] == option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					}
				},
				optionRenderer(option, i)
			);
		});
	}
	
	exports.default = menuRenderer;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(145);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (!props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(42);
	var Danger = __webpack_require__(347);
	var ReactMultiChildUpdateTypes = __webpack_require__(158);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInstrumentation = __webpack_require__(21);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(97);
	var setInnerHTML = __webpack_require__(65);
	var setTextContent = __webpack_require__(171);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventConstants = __webpack_require__(27);
	var ReactErrorUtils = __webpack_require__(91);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 86 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactPropTypes = __webpack_require__(160);
	var ReactPropTypeLocations = __webpack_require__(94);
	var ReactPropTypesSecret = __webpack_require__(95);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactNoopUpdateQueue = __webpack_require__(92);
	
	var canDefineProperty = __webpack_require__(164);
	var emptyObject = __webpack_require__(39);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentTreeHook
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(36);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var itemMap;
	var rootIDSet;
	
	var itemByKey;
	var rootByKey;
	
	if (canUseCollections) {
	  itemMap = new Map();
	  rootIDSet = new Set();
	} else {
	  itemByKey = {};
	  rootByKey = {};
	}
	
	var unmountedIDs = [];
	
	// Use non-numeric keys to prevent V8 performance issues:
	// https://github.com/facebook/react/pull/7232
	function getKeyFromID(id) {
	  return '.' + id;
	}
	function getIDFromKey(key) {
	  return parseInt(key.substr(1), 10);
	}
	
	function get(id) {
	  if (canUseCollections) {
	    return itemMap.get(id);
	  } else {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  }
	}
	
	function remove(id) {
	  if (canUseCollections) {
	    itemMap['delete'](id);
	  } else {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  }
	}
	
	function create(id, element, parentID) {
	  var item = {
	    element: element,
	    parentID: parentID,
	    text: null,
	    childIDs: [],
	    isMounted: false,
	    updateCount: 0
	  };
	
	  if (canUseCollections) {
	    itemMap.set(id, item);
	  } else {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  }
	}
	
	function addRoot(id) {
	  if (canUseCollections) {
	    rootIDSet.add(id);
	  } else {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  }
	}
	
	function removeRoot(id) {
	  if (canUseCollections) {
	    rootIDSet['delete'](id);
	  } else {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  }
	}
	
	function getRegisteredIDs() {
	  if (canUseCollections) {
	    return Array.from(itemMap.keys());
	  } else {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  }
	}
	
	function getRootIDs() {
	  if (canUseCollections) {
	    return Array.from(rootIDSet.keys());
	  } else {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  }
	}
	
	function purgeDeep(id) {
	  var item = get(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    remove(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + name + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = get(id);
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = get(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent ID is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    create(id, element, parentID);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = get(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = get(id);
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = get(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = get(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = get(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var type = topElement.type;
	      var name = typeof type === 'function' ? type.displayName || type.name : type;
	      var owner = topElement._owner;
	      info += describeComponentFrame(name || 'Unknown', topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = get(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = get(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = get(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = get(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = get(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRegisteredIDs: getRegisteredIDs,
	
	  getRootIDs: getRootIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(56);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 95 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypesSecret
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(24);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 99 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactElement = __webpack_require__(23);
	
	var getIteratorFn = __webpack_require__(167);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(86);
	var warning = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var emptyFunction = __webpack_require__(18);
	var warning = __webpack_require__(5);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	
	module.exports = irreducible('Any', function () { return true; });


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	var isString = __webpack_require__(68);
	
	module.exports = irreducible('String', isString);


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var isFunction = __webpack_require__(15);
	var getTypeName = __webpack_require__(13);
	var isIdentity = __webpack_require__(32);
	var isObject = __webpack_require__(33);
	var create = __webpack_require__(29);
	var is = __webpack_require__(30);
	
	function getDefaultName(domain, codomain) {
	  return '{[key: ' + getTypeName(domain) + ']: ' + getTypeName(codomain) + '}';
	}
	
	function dict(domain, codomain, name) {
	
	  if (false) {
	    assert(isFunction(domain), function () { return 'Invalid argument domain ' + assert.stringify(domain) + ' supplied to dict(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isFunction(codomain), function () { return 'Invalid argument codomain ' + assert.stringify(codomain) + ' supplied to dict(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to dict(domain, codomain, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(domain, codomain);
	  var domainNameCache = getTypeName(domain);
	  var codomainNameCache = getTypeName(codomain);
	  var identity = isIdentity(domain) && isIdentity(codomain);
	
	  function Dict(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value; // just trust the input if elements must not be hydrated
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isObject(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    var idempotent = true; // will remain true if I can reutilise the input
	    var ret = {}; // make a temporary copy, will be discarded if idempotent remains true
	    for (var k in value) {
	      if (value.hasOwnProperty(k)) {
	        k = create(domain, k, (  false ? path.concat(domainNameCache) : null ));
	        var actual = value[k];
	        var instance = create(codomain, actual, (  false ? path.concat(k + ': ' + codomainNameCache) : null ));
	        idempotent = idempotent && ( actual === instance );
	        ret[k] = instance;
	      }
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  Dict.meta = {
	    kind: 'dict',
	    domain: domain,
	    codomain: codomain,
	    name: name,
	    identity: identity
	  };
	
	  Dict.displayName = displayName;
	
	  Dict.is = function (x) {
	    if (!isObject(x)) {
	      return false;
	    }
	    for (var k in x) {
	      if (x.hasOwnProperty(k)) {
	        if (!is(k, domain) || !is(x[k], codomain)) {
	          return false;
	        }
	      }
	    }
	    return true;
	  };
	
	  Dict.update = function (instance, patch) {
	    return Dict(assert.update(instance, patch));
	  };
	
	  return Dict;
	}
	
	dict.getDefaultName = getDefaultName;
	module.exports = dict;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var isNil = __webpack_require__(25);
	var assert = __webpack_require__(8);
	
	// safe mixin, cannot override props unless specified
	module.exports = function mixin(target, source, overwrite) {
	  if (isNil(source)) { return target; }
	  for (var k in source) {
	    if (source.hasOwnProperty(k)) {
	      if (overwrite !== true) {
	        if (false) {
	          assert(!target.hasOwnProperty(k) || target[k] === source[k], function () { return 'Invalid call to mixin(target, source, [overwrite]): cannot overwrite property "' + k + '" of target object'; });
	        }
	      }
	      target[k] = source[k];
	    }
	  }
	  return target;
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var isFunction = __webpack_require__(15);
	var forbidNewOperator = __webpack_require__(51);
	var isIdentity = __webpack_require__(32);
	var create = __webpack_require__(29);
	var is = __webpack_require__(30);
	var getTypeName = __webpack_require__(13);
	var getFunctionName = __webpack_require__(52);
	
	function getDefaultName(type, predicate) {
	  return '{' + getTypeName(type) + ' | ' + getFunctionName(predicate) + '}';
	}
	
	function refinement(type, predicate, name) {
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + assert.stringify(type) + ' supplied to refinement(type, predicate, [name]) combinator (expected a type)'; });
	    assert(isFunction(predicate), function () { return 'Invalid argument predicate supplied to refinement(type, predicate, [name]) combinator (expected a function)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to refinement(type, predicate, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(type, predicate);
	  var identity = isIdentity(type);
	
	  function Refinement(value, path) {
	
	    if (false) {
	      if (identity) {
	        forbidNewOperator(this, Refinement);
	      }
	      path = path || [displayName];
	    }
	
	    var x = create(type, value, path);
	
	    if (false) {
	      assert(predicate(x), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return x;
	  }
	
	  Refinement.meta = {
	    kind: 'subtype',
	    type: type,
	    predicate: predicate,
	    name: name,
	    identity: identity
	  };
	
	  Refinement.displayName = displayName;
	
	  Refinement.is = function (x) {
	    return is(x, type) && predicate(x);
	  };
	
	  Refinement.update = function (instance, patch) {
	    return Refinement(assert.update(instance, patch));
	  };
	
	  return Refinement;
	}
	
	refinement.getDefaultName = getDefaultName;
	module.exports = refinement;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(434).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110).setImmediate, __webpack_require__(110).clearImmediate))

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(4);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _FeedbackRadios = __webpack_require__(112);
	
	var _FeedbackRadios2 = _interopRequireDefault(_FeedbackRadios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Feedback = function (_React$Component) {
	  _inherits(Feedback, _React$Component);
	
	  function Feedback(props) {
	    _classCallCheck(this, Feedback);
	
	    var _this = _possibleConstructorReturn(this, (Feedback.__proto__ || Object.getPrototypeOf(Feedback)).call(this, props));
	
	    _this.state = {
	      back: "",
	      howRecommend: 0,
	      howLike: 0,
	      message: "",
	      likeError: '',
	      recommendError: '',
	      sent: ''
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(Feedback, [{
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var target = event.target;
	      var value = target.value;
	      var name = target.name;
	      this.setState(_defineProperty({}, name, value));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      if (this.state.howLike === 0) {
	        this.setState({ likeError: 'active' });
	      } else if (this.state.howRecommend === 0) {
	        this.setState({ recommendError: 'active' });
	      } else {
	        (0, _apiData.ajaxPost)(_settings.API + this.props.match.params.lang + '/api/' + this.props.match.params.restaurant + '/feedback/', { 'recommend': this.state.howRecommend, 'like': this.state.howLike, 'message': this.state.message }, this);
	        this.setState({ sent: 'sent' });
	      }
	      event.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pickly-feedback-wrapper feedback-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: "feedback-form-wrapper " + this.state.sent },
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'feedback-title' },
	            function (message) {
	              return _react2.default.createElement(
	                'h3',
	                { className: 'feedback-title' },
	                message
	              );
	            }
	          ),
	          _react2.default.createElement(
	            'h5',
	            { className: 'feedback-subtitle' },
	            'Pickly App'
	          ),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'feedback-intro' },
	            function (message) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'intro-text' },
	                message
	              );
	            }
	          ),
	          _react2.default.createElement(
	            'form',
	            { className: 'pickly-feedback feedback-form', onSubmit: this.handleSubmit },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'feedback-improve' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'h5',
	                    null,
	                    message,
	                    '*'
	                  );
	                }
	              ),
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'feedback-error' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    { className: 'error-msg' + ' ' + _this2.state.likeError },
	                    message
	                  );
	                }
	              ),
	              _react2.default.createElement(_FeedbackRadios2.default, { name: 'improve' })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'feedback-recommend' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'h5',
	                    null,
	                    message,
	                    '*'
	                  );
	                }
	              ),
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'feedback-error' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    { className: 'error-msg' + ' ' + _this2.state.recommendError },
	                    message
	                  );
	                }
	              ),
	              _react2.default.createElement(_FeedbackRadios2.default, { name: 'recommend' })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'feedback-msg' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'label',
	                    { className: 'feedback-msg-label', htmlFor: 'message' },
	                    message
	                  );
	                }
	              ),
	              _react2.default.createElement('textarea', { name: 'message', id: 'message', value: this.state.message, onChange: this.handleChange }),
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'feedback-submit' },
	                function (message) {
	                  return _react2.default.createElement('input', { className: 'btn', type: 'submit', value: message });
	                }
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'thanks ' + this.state.sent },
	          _react2.default.createElement('img', { src: __webpack_require__(57) }),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'feedback-thanks-title' },
	            function (message) {
	              return _react2.default.createElement(
	                'h3',
	                null,
	                message
	              );
	            }
	          ),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'feedback-thanks-text' },
	            function (message) {
	              return _react2.default.createElement(
	                'p',
	                null,
	                message
	              );
	            }
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'thanks-btn btn',
	              to: '/' + this.props.lang + '/' + this.props.restaurant + '/' },
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'nav_home' },
	              function (message) {
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  message
	                );
	              }
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Feedback;
	}(_react2.default.Component);
	
	Feedback.propTypes = {
	  lang: _react.PropTypes.string,
	  match: _react.PropTypes.object,
	  restaurant: _react.PropTypes.string
	};
	exports.default = Feedback;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedbackRadios = function (_React$PureComponent) {
	  _inherits(FeedbackRadios, _React$PureComponent);
	
	  function FeedbackRadios() {
	    _classCallCheck(this, FeedbackRadios);
	
	    return _possibleConstructorReturn(this, (FeedbackRadios.__proto__ || Object.getPrototypeOf(FeedbackRadios)).apply(this, arguments));
	  }
	
	  _createClass(FeedbackRadios, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement("input", { type: "radio", name: this.props.name, value: "1", id: "horrible-" + this.props.name, onChange: this.handleChange }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "horrible-" + this.props.name, className: "option horrible" },
	            _react2.default.createElement(
	              "span",
	              { className: "sr-only" },
	              "1"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement("input", { type: "radio", name: this.props.name, value: "2", id: "bad-" + this.props.name, onChange: this.handleChange }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "bad-" + this.props.name, className: "option bad" },
	            _react2.default.createElement(
	              "span",
	              { className: "sr-only" },
	              "2"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement("input", { type: "radio", name: this.props.name, value: "3", id: "neutral" + this.props.name, onChange: this.handleChange }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "neutral" + this.props.name, className: "option neutral" },
	            _react2.default.createElement(
	              "span",
	              { className: "sr-only" },
	              "3"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement("input", { type: "radio", name: this.props.name, value: "4", id: "good-" + this.props.name, onChange: this.handleChange }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "good-" + this.props.name, className: "option good" },
	            _react2.default.createElement(
	              "span",
	              { className: "sr-only" },
	              "4"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement("input", { type: "radio", name: this.props.name, value: "5", id: "great-" + this.props.name, onChange: this.handleChange }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "great-" + this.props.name, className: "option great" },
	            _react2.default.createElement(
	              "span",
	              { className: "sr-only" },
	              "5"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FeedbackRadios;
	}(_react2.default.PureComponent);
	
	FeedbackRadios.propTypes = {
	  name: _react.PropTypes.string
	};
	exports.default = FeedbackRadios;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(4);
	
	var _reactSelect = __webpack_require__(78);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _SideNav = __webpack_require__(201);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _NavBtn = __webpack_require__(199);
	
	var _NavBtn2 = _interopRequireDefault(_NavBtn);
	
	var _Overlay = __webpack_require__(219);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Languages = __webpack_require__(196);
	
	var _Languages2 = _interopRequireDefault(_Languages);
	
	var _ListViewIcon = __webpack_require__(197);
	
	var _ListViewIcon2 = _interopRequireDefault(_ListViewIcon);
	
	var _ListViewValue = __webpack_require__(198);
	
	var _ListViewValue2 = _interopRequireDefault(_ListViewValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopBar = function (_React$Component) {
	  _inherits(TopBar, _React$Component);
	
	  function TopBar(props) {
	    _classCallCheck(this, TopBar);
	
	    var _this = _possibleConstructorReturn(this, (TopBar.__proto__ || Object.getPrototypeOf(TopBar)).call(this, props));
	
	    _this.state = {
	      navToggle: 'inactive',
	      toggle: 'inactive',
	      overlay: 'inactive'
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(TopBar, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (e.target.dataset.value === 'nav') {
	        if (this.state.navToggle === 'inactive') {
	          this.setState({ navToggle: 'active', overlay: 'active', toggle: 'inactive' });
	        } else {
	          this.setState({ navToggle: 'inactive', overlay: 'inactive' });
	        }
	      } else {
	        this.setState({ toggle: 'inactive', overlay: 'inactive', navToggle: 'inactive' });
	      }
	    }
	  }, {
	    key: 'sortTitle',
	    value: function sortTitle() {
	      if (!this.props.title) {
	        return null;
	        // return (
	        //   <Link className="pickly-logo"
	        //         to={'/' + this.props.lang + '/' + this.props.restaurant}>
	        //     <img src={require('../../images/logo.png')}/>
	        //   </Link>
	        // );
	      } else {
	        return _react2.default.createElement(
	          'h2',
	          { className: 'bar-title' },
	          this.props.title
	        );
	      }
	    }
	  }, {
	    key: 'checkBack',
	    value: function checkBack() {
	      if (this.props.back_btn === true) {
	        return _react2.default.createElement('button', { className: 'btn back-btn', onClick: this.props.history.goBack });
	      } else {
	        return _react2.default.createElement(_NavBtn2.default, { toggle: this.state.navToggle, onClick: this.handleClick });
	      }
	    }
	  }, {
	    key: 'viewSort',
	    value: function viewSort() {
	      var _this2 = this;
	
	      if (this.props.viewToggle) {
	        return _react2.default.createElement(_reactSelect2.default, {
	          className: 'list-view-toggle topbar-select',
	          searchable: false,
	          name: 'view-toggle-field',
	          clearable: false,
	          arrowRenderer: null,
	          value: this.props.viewToggle,
	          placeholder: this.props.viewToggle,
	          onChange: function onChange(e) {
	            return _this2.props.viewSort(e.value);
	          },
	          options: [{ value: 'list', label: 'list' }, { value: 'cards', label: 'cards' }],
	          optionComponent: _ListViewIcon2.default,
	          valueComponent: _ListViewValue2.default
	        });
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'fixed top-bar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content-wrapper' },
	          this.checkBack(),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'pickly-logo-desktop',
	              to: '/' + this.props.lang + '/' + this.props.restaurant },
	            _react2.default.createElement('img', { src: __webpack_require__(251) })
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'bar-title restaurant-name' },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/' + this.props.lang + '/' + this.props.restaurant },
	              this.props.name
	            )
	          ),
	          this.props.view === 'detail' ? _react2.default.createElement(
	            'h2',
	            { className: 'bar-title category-name' },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/' + this.props.lang + '/' + this.props.restaurant + '/items/' + this.props.category + '/' },
	              this.props.catName
	            )
	          ) : null,
	          this.sortTitle(),
	          _react2.default.createElement(
	            'div',
	            { className: 'mobile-languages' },
	            _react2.default.createElement(_Languages2.default, { languages: this.props.languages,
	              restaurant: this.props.restaurant,
	              lang: this.props.lang,
	              pathname: this.props.pathname, match: this.props.match })
	          ),
	          this.viewSort()
	        ),
	        this.props.view !== 'error' ? _react2.default.createElement(
	          'div',
	          { className: "side-nav" + " " + this.state.navToggle, id: 'sideNav' },
	          _react2.default.createElement(
	            _SideNav2.default,
	            { restaurant: this.props.restaurant,
	              name: this.props.name, city: this.props.city, onClick: this.handleClick,
	              country: this.props.country, lang: this.props.lang,
	              social: this.props.social, wine: this.props.wine_slug, view: this.props.view,
	              'package': this.props.package },
	            _react2.default.createElement(
	              'div',
	              { className: 'desktop-languages' },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'desktop_languages' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'h5',
	                    { className: 'desktop-languages-title' },
	                    message
	                  );
	                }
	              ),
	              _react2.default.createElement(_Languages2.default, { languages: this.props.languages,
	                restaurant: this.props.restaurant,
	                lang: this.props.lang,
	                pathname: this.props.pathname, match: this.props.match })
	            )
	          )
	        ) : null,
	        _react2.default.createElement(_Overlay2.default, { onClick: this.handleClick, toggle: this.state.overlay })
	      );
	    }
	  }]);
	
	  return TopBar;
	}(_react2.default.Component);
	
	TopBar.propTypes = {
	  back_btn: _react.PropTypes.bool,
	  catName: _react.PropTypes.string,
	  category: _react.PropTypes.string,
	  city: _react.PropTypes.string,
	  country: _react.PropTypes.string,
	  history: _react.PropTypes.object,
	  lang: _react.PropTypes.string,
	  languages: _react.PropTypes.array,
	  match: _react.PropTypes.object,
	  name: _react.PropTypes.string,
	  package: _react.PropTypes.number,
	  pathname: _react.PropTypes.string,
	  restaurant: _react.PropTypes.string,
	  social: _react.PropTypes.object,
	  title: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
	  view: _react.PropTypes.string,
	  viewToggle: _react.PropTypes.string,
	  viewSort: _react.PropTypes.func,
	  wine_slug: _react.PropTypes.string
	};
	exports.default = TopBar;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventItem = function (_React$PureComponent) {
	  _inherits(EventItem, _React$PureComponent);
	
	  function EventItem() {
	    _classCallCheck(this, EventItem);
	
	    return _possibleConstructorReturn(this, (EventItem.__proto__ || Object.getPrototypeOf(EventItem)).apply(this, arguments));
	  }
	
	  _createClass(EventItem, [{
	    key: 'handleLoading',
	    value: function handleLoading() {
	      this.props.loading();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: this.props.image, alt: this.props.name, className: 'item-thumbnail',
	          onLoad: this.handleLoading.bind(this), onError: this.handleLoading.bind(this) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'item-info' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'item-title' },
	            this.props.name
	          ),
	          _react2.default.createElement(
	            'h6',
	            { className: 'start-date price' },
	
	            // Only print the Intl object after receiving the updated props
	            this.props.start.length > 0 ? _react2.default.createElement(_reactIntl.FormattedDate, { value: new Date(this.props.start),
	              year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'long' }) : ''
	          ),
	          this.props.list === 'true' ? null : _react2.default.createElement(
	            'p',
	            null,
	            this.props.description
	          )
	        )
	      );
	    }
	  }]);
	
	  return EventItem;
	}(_react2.default.PureComponent);
	
	EventItem.propTypes = {
	  description: _react.PropTypes.string,
	  image: _react.PropTypes.string,
	  list: _react.PropTypes.string,
	  loading: _react.PropTypes.func,
	  name: _react.PropTypes.string,
	  start: _react.PropTypes.string
	};
	exports.default = EventItem;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuItem = function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem() {
	    _classCallCheck(this, MenuItem);
	
	    return _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).apply(this, arguments));
	  }
	
	  _createClass(MenuItem, [{
	    key: 'render',
	    value: function render() {
	      var url = '/' + this.props.lang + '/' + this.props.restaurant + '/items/' + this.props.slug + '-' + this.props.pk;
	      if (this.props.template === 'wine') {
	        url = '/' + this.props.lang + '/' + this.props.restaurant + '/wine/' + this.props.slug + '-' + this.props.pk;
	      }
	      return _react2.default.createElement(
	        _reactRouterDom.Link,
	        { className: 'menu-item',
	          to: url },
	        _react2.default.createElement('img', { src: this.props.picture }),
	        _react2.default.createElement(
	          'h4',
	          { className: 'menu-item-title' },
	          this.props.name
	        )
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react2.default.Component);
	
	MenuItem.propTypes = {
	  lang: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  picture: _react.PropTypes.string,
	  pk: _react.PropTypes.number,
	  restaurant: _react.PropTypes.string,
	  slug: _react.PropTypes.string,
	  template: _react.PropTypes.string
	};
	exports.default = MenuItem;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SmallCard = function (_React$PureComponent) {
	  _inherits(SmallCard, _React$PureComponent);
	
	  function SmallCard() {
	    _classCallCheck(this, SmallCard);
	
	    return _possibleConstructorReturn(this, (SmallCard.__proto__ || Object.getPrototypeOf(SmallCard)).apply(this, arguments));
	  }
	
	  _createClass(SmallCard, [{
	    key: 'checkDescription',
	    value: function checkDescription() {
	      var desc = this.props.description;
	      var response = this.props.wineType;
	      //if there is an item description, 
	      if (desc) {
	        // clean html tags
	        desc = desc.replace(/<[^>]+>/g, '');
	        //truncate it to 7 words
	        desc = desc.split(" ").splice(0, 7).join(" ");
	        response = desc;
	      }
	
	      return response ? _react2.default.createElement(
	        'p',
	        { className: 'description' },
	        response
	      ) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/' + this.props.lang + '/' + this.props.restaurant + '/items/' + this.props.cat + '/' + this.props.slug + '-' + this.props.pk + '/',
	          className: 'small-card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'small-thumb' },
	          _react2.default.createElement('img', { src: this.props.photo })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item-content' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'small-item-title' },
	            this.props.name
	          ),
	          this.checkDescription(),
	          this.props.price ? _react2.default.createElement(
	            'span',
	            { className: 'price' },
	            this.props.price,
	            '\u20AC'
	          ) : _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'price_under_request' },
	            function (message) {
	              return _react2.default.createElement(
	                'span',
	                { className: 'price' },
	                message
	              );
	            }
	          )
	        )
	      );
	    }
	  }]);
	
	  return SmallCard;
	}(_react2.default.PureComponent);
	
	SmallCard.propTypes = {
	  cat: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  lang: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  photo: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
	  pk: _react.PropTypes.number,
	  price: _react.PropTypes.number,
	  restaurant: _react.PropTypes.string,
	  slug: _react.PropTypes.string,
	  wineType: _react.PropTypes.string
	};
	exports.default = SmallCard;

/***/ },
/* 117 */
/***/ function(module, exports) {

	
	
	
	/*
	* @version    1.0.4
	* @date       2015-03-13
	* @stability  3 - Stable
	* @author     Lauri Rooden <lauri@rooden.ee>
	* @license    MIT License
	*/
	
	
	// In browser `this` refers to the window object,
	// in NodeJS `this` refers to the exports.
	
	this.cookie = function(name, value, ttl, path, domain, secure) {
	
		if (arguments.length > 1) {
			return document.cookie = name + "=" + encodeURIComponent(value) +
				(ttl ? "; expires=" + new Date(+new Date()+(ttl*1000)).toUTCString() : "") +
				(path   ? "; path=" + path : "") +
				(domain ? "; domain=" + domain : "") +
				(secure ? "; secure" : "")
		}
	
		return decodeURIComponent((("; "+document.cookie).split("; "+name+"=")[1]||"").split(";")[0])
	}


/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(18);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 121 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 122 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(22);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(58);
	
	var _PathUtils = __webpack_require__(40);
	
	var _createTransitionManager = __webpack_require__(74);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(22);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(58);
	
	var _PathUtils = __webpack_require__(40);
	
	var _createTransitionManager = __webpack_require__(74);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(40);
	
	var _LocationUtils = __webpack_require__(58);
	
	var _createTransitionManager = __webpack_require__(74);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(263)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(471);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ },
/* 127 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ },
/* 128 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 129 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(128),
	    isArray = __webpack_require__(129);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var arrayMap = __webpack_require__(281),
	    baseDifference = __webpack_require__(282),
	    baseFlatten = __webpack_require__(283),
	    bindCallback = __webpack_require__(286),
	    pickByArray = __webpack_require__(290),
	    pickByCallback = __webpack_require__(291),
	    keysIn = __webpack_require__(130),
	    restParam = __webpack_require__(293);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 * Property names may be specified as individual arguments or as arrays of
	 * property names. If `predicate` is provided it is invoked for each property
	 * of `object` omitting the properties `predicate` returns truthy for. The
	 * predicate is bound to `thisArg` and invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to omit, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.omit(object, 'age');
	 * // => { 'user': 'fred' }
	 *
	 * _.omit(object, _.isNumber);
	 * // => { 'user': 'fred' }
	 */
	var omit = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  if (typeof props[0] != 'function') {
	    var props = arrayMap(baseFlatten(props), String);
	    return pickByArray(object, baseDifference(keysIn(object), props));
	  }
	  var predicate = bindCallback(props[0], props[1], 3);
	  return pickByCallback(object, function(value, key, object) {
	    return !predicate(value, key, object);
	  });
	});
	
	module.exports = omit;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodashOmit = __webpack_require__(131);
	
	var _lodashOmit2 = _interopRequireDefault(_lodashOmit);
	
	var _classnames = __webpack_require__(26);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tcombReact = __webpack_require__(172);
	
	var _styleUtils = __webpack_require__(299);
	
	var _styleUtils2 = _interopRequireDefault(_styleUtils);
	
	_tcombReact.t['interface'].strict = true;
	
	var Props = {
	  message: _tcombReact.t.maybe(_tcombReact.t.String),
	  onAccept: _tcombReact.t.Function,
	  link: _tcombReact.t.maybe(_tcombReact.t['interface']({
	    msg: _tcombReact.t.maybe(_tcombReact.t.String),
	    url: _tcombReact.t.String,
	    target: _tcombReact.t.maybe(_tcombReact.t.enums.of(['_blank', '_self', '_parent', '_top', 'framename']))
	  })),
	  buttonMessage: _tcombReact.t.maybe(_tcombReact.t.String),
	  closeIcon: _tcombReact.t.maybe(_tcombReact.t.String),
	  disableStyle: _tcombReact.t.maybe(_tcombReact.t.Boolean),
	  styles: _tcombReact.t.maybe(_tcombReact.t.Object),
	  className: _tcombReact.t.maybe(_tcombReact.t.String)
	};
	
	exports.Props = Props;
	/** React Cookie banner template
	 * @param message - message written inside default cookie banner
	 * @param onAccept - called when user accepts cookies
	 * @param link - object with infos used to render a link to your cookie-policy page
	 * @param buttonMessage - message written inside the button of the default cookie banner
	 * @param closeIcon - className passed to close-icon
	 * @param disableStyle - pass `true` if you want to disable default style
	 * @param styles - object with custom styles used to overwrite default ones
	 */
	
	var BannerContent = (function (_React$Component) {
	  _inherits(BannerContent, _React$Component);
	
	  function BannerContent() {
	    var _this = this;
	
	    _classCallCheck(this, _BannerContent);
	
	    _React$Component.apply(this, arguments);
	
	    this.getStyle = function (style) {
	      var _props = _this.props;
	      var disableStyle = _props.disableStyle;
	      var styles = _props.styles;
	
	      if (!disableStyle) {
	        // apply custom styles if available
	        return _extends({}, _styleUtils2['default'].getStyle(style), styles[style]);
	      }
	    };
	
	    this.templateCloseIcon = function (_ref) {
	      var className = _ref.className;
	      var onClick = _ref.onClick;
	      var style = _ref.style;
	      return _react2['default'].createElement('i', { className: className, onClick: onClick, style: style });
	    };
	
	    this.templateCloseButton = function (_ref2) {
	      var buttonMessage = _ref2.buttonMessage;
	      var onClick = _ref2.onClick;
	      var style = _ref2.style;
	      return _react2['default'].createElement(
	        'div',
	        _extends({ className: 'button-close' }, { onClick: onClick, style: style }),
	        buttonMessage
	      );
	    };
	
	    this.templateLink = function (_ref3) {
	      var link = _ref3.link;
	      var style = _ref3.style;
	
	      if (link) {
	        var href = link.url;
	        var target = link.target;
	        var msg = link.msg;
	
	        return _react2['default'].createElement(
	          'a',
	          _extends({ className: 'cookie-link' }, { href: href, target: target, style: style }),
	          msg || 'Learn more'
	        );
	      }
	    };
	  }
	
	  BannerContent.prototype.getLocals = function getLocals() {
	    var getStyle = this.getStyle;
	    var _props2 = this.props;
	    var onAccept = _props2.onAccept;
	    var className = _props2.className;
	    var message = _props2.message;
	    var link = _props2.link;
	    var closeIcon = _props2.closeIcon;
	    var buttonMessage = _props2.buttonMessage;
	
	    var wrapperProps = _objectWithoutProperties(_props2, ['onAccept', 'className', 'message', 'link', 'closeIcon', 'buttonMessage']);
	
	    return {
	      message: message,
	      cookieMessageStyle: getStyle('message'),
	      wrapperProps: _extends({}, _lodashOmit2['default'](wrapperProps, Object.keys(Props)), {
	        className: _classnames2['default']('react-cookie-banner', className),
	        style: getStyle('banner')
	      }),
	      linkProps: {
	        link: link,
	        style: getStyle('link')
	      },
	      closeButtonProps: !closeIcon && {
	        buttonMessage: buttonMessage,
	        onClick: onAccept,
	        style: getStyle('button')
	      },
	      closeIconProps: !!closeIcon && {
	        className: closeIcon,
	        onClick: onAccept,
	        style: getStyle('icon')
	      }
	    };
	  };
	
	  BannerContent.prototype.render = function render() {
	    var _getLocals = this.getLocals();
	
	    var message = _getLocals.message;
	    var cookieMessageStyle = _getLocals.cookieMessageStyle;
	    var wrapperProps = _getLocals.wrapperProps;
	    var linkProps = _getLocals.linkProps;
	    var closeButtonProps = _getLocals.closeButtonProps;
	    var closeIconProps = _getLocals.closeIconProps;
	
	    return _react2['default'].createElement(
	      'div',
	      wrapperProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'cookie-message', style: cookieMessageStyle },
	        message,
	        this.templateLink(linkProps)
	      ),
	      closeButtonProps && this.templateCloseButton(closeButtonProps),
	      closeIconProps && this.templateCloseIcon(closeIconProps)
	    );
	  };
	
	  _createClass(BannerContent, null, [{
	    key: 'defaultProps',
	    value: {
	      buttonMessage: 'Got it',
	      styles: {}
	    },
	    enumerable: true
	  }]);
	
	  var _BannerContent = BannerContent;
	  BannerContent = _tcombReact.props(Props, { strict: false })(BannerContent) || BannerContent;
	  return BannerContent;
	})(_react2['default'].Component);
	
	exports['default'] = BannerContent;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceCheck = exports.lazyload = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _event = __webpack_require__(311);
	
	var _scrollParent = __webpack_require__(312);
	
	var _scrollParent2 = _interopRequireDefault(_scrollParent);
	
	var _debounce = __webpack_require__(310);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _throttle = __webpack_require__(313);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _decorator = __webpack_require__(309);
	
	var _decorator2 = _interopRequireDefault(_decorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
	var LISTEN_FLAG = 'data-lazyload-listened';
	var listeners = [];
	var pending = [];
	
	// try to handle passive events
	var passiveEventSupported = false;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passiveEventSupported = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {}
	// if they are supported, setup the optional params
	// IMPORTANT: FALSE doubles as the default CAPTURE value!
	var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;
	
	/**
	 * Check if `component` is visible in overflow container `parent`
	 * @param  {node} component React component
	 * @param  {node} parent    component's scroll parent
	 * @return {bool}
	 */
	var checkOverflowVisible = function checkOverflowVisible(component, parent) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  var parentTop = void 0;
	  var parentHeight = void 0;
	
	  try {
	    var _parent$getBoundingCl = parent.getBoundingClientRect();
	
	    parentTop = _parent$getBoundingCl.top;
	    parentHeight = _parent$getBoundingCl.height;
	  } catch (e) {
	    parentTop = defaultBoundingClientRect.top;
	    parentHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  // calculate top and height of the intersection of the element's scrollParent and viewport
	  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
	  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
	
	  // check whether the element is visible in the intersection
	  var top = void 0;
	  var height = void 0;
	
	  try {
	    var _node$getBoundingClie = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie.top;
	    height = _node$getBoundingClie.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    height = defaultBoundingClientRect.height;
	  }
	
	  var offsetTop = top - intersectionTop; // element's top relative to intersection
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
	};
	
	/**
	 * Check if `component` is visible in document
	 * @param  {node} component React component
	 * @return {bool}
	 */
	var checkNormalVisible = function checkNormalVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  // If this element is hidden by css rules somehow, it's definitely invisible
	  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;
	
	  var top = void 0;
	  var elementHeight = void 0;
	
	  try {
	    var _node$getBoundingClie2 = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie2.top;
	    elementHeight = _node$getBoundingClie2.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    elementHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
	};
	
	/**
	 * Detect if element is visible in viewport, if so, set `visible` state to true.
	 * If `once` prop is provided true, remove component as listener after checkVisible
	 *
	 * @param  {React} component   React component that respond to scroll and resize
	 */
	var checkVisible = function checkVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	  if (!node) {
	    return;
	  }
	
	  var parent = (0, _scrollParent2.default)(node);
	  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
	  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
	  if (visible) {
	    // Avoid extra render if previously is visible
	    if (!component.visible) {
	      if (component.props.once) {
	        pending.push(component);
	      }
	
	      component.visible = true;
	      component.forceUpdate();
	    }
	  } else if (!(component.props.once && component.visible)) {
	    component.visible = false;
	    if (component.props.unmountIfInvisible) {
	      component.forceUpdate();
	    }
	  }
	};
	
	var purgePending = function purgePending() {
	  pending.forEach(function (component) {
	    var index = listeners.indexOf(component);
	    if (index !== -1) {
	      listeners.splice(index, 1);
	    }
	  });
	
	  pending = [];
	};
	
	var lazyLoadHandler = function lazyLoadHandler() {
	  for (var i = 0; i < listeners.length; ++i) {
	    var listener = listeners[i];
	    checkVisible(listener);
	  }
	  // Remove `once` component in listeners
	  purgePending();
	};
	
	// Depending on component's props
	var delayType = void 0;
	var finalLazyLoadHandler = null;
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.visible = false;
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof process !== 'undefined' && ("production") !== 'production') {
	        if (_react2.default.Children.count(this.props.children) > 1) {
	          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
	        }
	
	        if (this.props.wheel) {
	          // eslint-disable-line
	          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
	        }
	
	        // Warn the user if placeholder and height is not specified and the rendered height is 0
	        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
	          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
	        }
	      }
	
	      // It's unlikely to change delay type on the fly, this is mainly
	      // designed for tests
	      var needResetFinalLazyLoadHandler = false;
	      if (this.props.debounce !== undefined && delayType === 'throttle') {
	        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
	        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      }
	
	      if (needResetFinalLazyLoadHandler) {
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        finalLazyLoadHandler = null;
	      }
	
	      if (!finalLazyLoadHandler) {
	        if (this.props.debounce !== undefined) {
	          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
	          delayType = 'debounce';
	        } else if (this.props.throttle !== undefined) {
	          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
	          delayType = 'throttle';
	        } else {
	          finalLazyLoadHandler = lazyLoadHandler;
	        }
	      }
	
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
	          if (listenerCount === 1) {
	            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	          }
	          parent.setAttribute(LISTEN_FLAG, listenerCount);
	        }
	      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
	        var _props = this.props,
	            scroll = _props.scroll,
	            resize = _props.resize;
	
	
	        if (scroll) {
	          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        }
	
	        if (resize) {
	          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        }
	      }
	
	      listeners.push(this);
	      checkVisible(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return this.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
	          if (listenerCount === 0) {
	            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	            parent.removeAttribute(LISTEN_FLAG);
	          } else {
	            parent.setAttribute(LISTEN_FLAG, listenerCount);
	          }
	        }
	      }
	
	      var index = listeners.indexOf(this);
	      if (index !== -1) {
	        listeners.splice(index, 1);
	      }
	
	      if (listeners.length === 0) {
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	LazyLoad.propTypes = {
	  once: _propTypes2.default.bool,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	  overflow: _propTypes2.default.bool,
	  resize: _propTypes2.default.bool,
	  scroll: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  placeholder: _propTypes2.default.node,
	  unmountIfInvisible: _propTypes2.default.bool
	};
	
	LazyLoad.defaultProps = {
	  once: false,
	  offset: 0,
	  overflow: false,
	  resize: false,
	  scroll: true,
	  unmountIfInvisible: false
	};
	
	var lazyload = exports.lazyload = _decorator2.default;
	exports.default = LazyLoad;
	exports.forceCheck = lazyLoadHandler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(22);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(136);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(22);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(77);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Select = __webpack_require__(60);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(143);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    multi = _props3.multi,
				    onChange = _props3.onChange,
				    placeholder = _props3.placeholder,
				    value = _props3.value;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;
	
	function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	}

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Select = __webpack_require__(60);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _defaultFilterOptions = __webpack_require__(79);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(80);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options,
				    shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    options = _props2.options,
				    promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option, event) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    newOptionCreator = _props4.newOptionCreator,
				    shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption', 'ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	;
	
	function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	function isValidNewOption(_ref4) {
		var label = _ref4.label;
	
		return !!label;
	};
	
	function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
		return option;
	};
	
	function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	}
	
	function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
		}
	
		return false;
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(26);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'blockEvent',
			value: function blockEvent(event) {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.tagName !== 'A' || !('href' in event.target)) {
					return;
				}
				if (event.target.target) {
					window.open(event.target.href, event.target.target);
				} else {
					window.location.href = event.target.href;
				}
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: this.blockEvent,
						onClick: this.blockEvent },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	;
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(26);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	;
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = arrowRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = clearRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = stripDiacritics;
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }
	
	  return targetLeft;
	};

/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(35);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInstrumentation = __webpack_require__(21);
	
	var quoteAttributeValueForBrowser = __webpack_require__(405);
	var warning = __webpack_require__(5);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(35);
	var ReactElement = __webpack_require__(23);
	
	var emptyFunction = __webpack_require__(18);
	var traverseAllChildren = __webpack_require__(103);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(88);
	var ReactElement = __webpack_require__(23);
	var ReactPropTypeLocations = __webpack_require__(94);
	var ReactPropTypeLocationNames = __webpack_require__(93);
	var ReactNoopUpdateQueue = __webpack_require__(92);
	
	var emptyObject = __webpack_require__(39);
	var invariant = __webpack_require__(2);
	var keyMirror = __webpack_require__(56);
	var keyOf = __webpack_require__(34);
	var warning = __webpack_require__(5);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var DisabledInputUtils = __webpack_require__(61);
	var LinkedValueUtils = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(24);
	
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 153 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactHostComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var invariant = __webpack_require__(2);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(366);
	
	var containsNode = __webpack_require__(240);
	var focusNode = __webpack_require__(120);
	var getActiveElement = __webpack_require__(121);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(42);
	var DOMProperty = __webpack_require__(43);
	var ReactBrowserEventEmitter = __webpack_require__(62);
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMContainerInfo = __webpack_require__(359);
	var ReactDOMFeatureFlags = __webpack_require__(362);
	var ReactElement = __webpack_require__(23);
	var ReactFeatureFlags = __webpack_require__(154);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(21);
	var ReactMarkupChecksum = __webpack_require__(375);
	var ReactReconciler = __webpack_require__(44);
	var ReactUpdateQueue = __webpack_require__(96);
	var ReactUpdates = __webpack_require__(24);
	
	var emptyObject = __webpack_require__(39);
	var instantiateReactComponent = __webpack_require__(169);
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(65);
	var shouldUpdateReactComponent = __webpack_require__(102);
	var warning = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(56);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactElement = __webpack_require__(23);
	
	var invariant = __webpack_require__(2);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(23);
	var ReactPropTypeLocationNames = __webpack_require__(93);
	var ReactPropTypesSecret = __webpack_require__(95);
	
	var emptyFunction = __webpack_require__(18);
	var getIteratorFn = __webpack_require__(167);
	var warning = __webpack_require__(5);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new PropTypeError('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 161 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.3.2';

/***/ },
/* 162 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 165 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getHostComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(159);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var ReactCompositeComponent = __webpack_require__(355);
	var ReactEmptyComponent = __webpack_require__(153);
	var ReactHostComponent = __webpack_require__(155);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? nextDebugID++ : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 170 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	var escapeTextContentForBrowser = __webpack_require__(64);
	var setInnerHTML = __webpack_require__(65);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var t = __webpack_require__(410);
	
	function getMessage(errors, what, displayName, type) {
	  return [
	    'Invalid ' + what + ' supplied to ' + displayName + ', should be a ' + t.getTypeName(type) + '.\n',
	    'Detected errors (' + errors.length + '):\n'
	  ].concat(errors.map(function (e, i) {
	    return ' ' + (i + 1) + '. ' + e.message;
	  })).join('\n') + '\n\n';
	}
	
	//
	// main function
	//
	
	function getPropTypes(type, options) {
	
	  // getPropTypes can also accept a dictionary prop -> type
	  if (t.Object.is(type)) {
	    type = t.struct(type);
	  }
	
	  var isSubtype = ( type.meta.kind === 'subtype' );
	
	  // here type should be a struct or a subtype of a struct
	  if (false) {
	    t.assert(
	      t.isType(type),
	      '[tcomb-react] Invalid argument type supplied to propTypes()'
	    );
	  }
	
	  var propTypes = {};
	  var innerType = isSubtype ? type.meta.type : type;
	
	  if (innerType.meta.kind === 'struct' || innerType.meta.kind === 'interface') {
	    var props = innerType.meta.props;
	
	    Object.keys(props).forEach(function (k) {
	
	      var propType = props[k];
	      var checkPropType;
	
	      if (false) {
	
	        // React custom prop validators
	        // see http://facebook.github.io/react/docs/reusable-components.html
	        checkPropType = function (values, prop, displayName) {
	
	          var value = values[prop];
	          var validationResult = t.validate(value, propType);
	
	          if (!validationResult.isValid()) {
	
	            var message = getMessage(validationResult.errors, 'prop ' + t.stringify(prop), displayName, propType);
	
	            // add a readable entry in the call stack
	            // when "Pause on exceptions" and "Pause on Caught Exceptions"
	            // are enabled in Chrome DevTools
	            checkPropType.displayName = message;
	
	            t.fail(message);
	          }
	        };
	      } else {
	        checkPropType = function () {};
	      }
	
	      // attach the original tcomb definition, so other components can read it
	      // via `propTypes.whatever.tcomb`
	      checkPropType.tcomb = propType;
	
	      propTypes[k] = checkPropType;
	    });
	
	    if (false) {
	      options = options || {};
	      // allows to opt-out additional props check
	      if (options.strict !== false) {
	        propTypes.__strict__ = function (values, prop, displayName) {
	          var extra = [];
	          for (var k in values) {
	            // __strict__ and __subtype__ keys are excluded in order to support the React context feature
	            if (k !== '__strict__' && k !== '__subtype__' && values.hasOwnProperty(k) && !props.hasOwnProperty(k)) {
	              extra.push(k);
	            }
	          }
	          if (extra.length > 0) {
	            t.fail('Invalid additional prop(s):\n\n' + t.stringify(extra) + '\n\nsupplied to ' + displayName + '.');
	          }
	        };
	      }
	    }
	
	  }
	  else {
	    if (false) {
	      propTypes.__generictype__ = function (values, prop, displayName) {
	        var validationResult = t.validate(values, innerType);
	        if (!validationResult.isValid()) {
	          t.fail(getMessage(validationResult.errors, 'props', displayName, innerType));
	        }
	      };
	    }
	  }
	
	  if (isSubtype) {
	    if (false) {
	      propTypes.__subtype__ = function (values, prop, displayName) {
	        if (!type.meta.predicate(values)) {
	          t.fail('Invalid props:\n\n' + t.stringify(values) + '\n\nsupplied to ' + displayName + ', should be a ' + t.getTypeName(type) + ' subtype.');
	        }
	      };
	    } else {
	      propTypes.__subtype__ = function () {};
	    }
	
	    // attach the original predicate, so other components can read it
	    // via `propTypes.__subtype__.predicate`
	    propTypes.__subtype__.predicate = type.meta.predicate;
	  }
	
	  return propTypes;
	}
	
	//
	// ES7 decorator
	//
	
	function es7PropsDecorator(type, options) {
	  return function (Component) {
	    Component.propTypes = getPropTypes(type, options);
	  };
	}
	
	//
	// Built-in types
	//
	
	var ReactElement = t.irreducible('ReactElement', React.isValidElement);
	var ReactNode = t.irreducible('ReactNode', function (x) {
	  return t.Str.is(x) || t.Num.is(x) || ReactElement.is(x) || t.list(ReactNode).is(x);
	});
	var ReactChild = t.irreducible('ReactChild', function(x) {
	  return ReactNode.is(x) || t.Bool.is(x) || t.Nil.is(x);
	});
	var ReactChildren = t.irreducible('ReactChildren', function(x) {
	  return ReactChild.is(x) || t.list(ReactChildren).is(x);
	});
	
	t.ReactElement = ReactElement; // deprecated
	t.ReactNode = ReactNode; // deprecated
	t.ReactChild = ReactChild; // deprecated
	t.ReactChildren = ReactChildren; // deprecated
	
	module.exports = {
	  t: t, // deprecated
	  propTypes: getPropTypes,
	  props: es7PropsDecorator,
	  ReactElement: ReactElement,
	  ReactNode: ReactNode,
	  ReactChild: ReactChild,
	  ReactChildren: ReactChildren,
	  ReactElementT: ReactElement,
	  ReactNodeT: ReactNode,
	  ReactChildT: ReactChild,
	  ReactChildrenT: ReactChildren
	};


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	var isBoolean = __webpack_require__(67);
	
	module.exports = irreducible('Boolean', isBoolean);


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	var isNil = __webpack_require__(25);
	
	module.exports = irreducible('Nil', isNil);


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	var isNumber = __webpack_require__(179);
	
	module.exports = irreducible('Number', isNumber);


/***/ },
/* 176 */
/***/ function(module, exports) {

	function assign(x, y) {
	  for (var k in y) {
	    if (y.hasOwnProperty(k)) {
	      x[k] = y[k];
	    }
	  }
	  return x;
	}
	
	module.exports = assign;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isFunction = __webpack_require__(15);
	var isArray = __webpack_require__(31);
	var mixin = __webpack_require__(108);
	var isStruct = __webpack_require__(428);
	var isInterface = __webpack_require__(426);
	var isObject = __webpack_require__(33);
	var refinement = __webpack_require__(109);
	var decompose = __webpack_require__(420);
	
	function compose(predicates, unrefinedType, name) {
	  var result = predicates.reduce(function (type, predicate) {
	    return refinement(type, predicate);
	  }, unrefinedType);
	  if (name) {
	    result.displayName = name;
	    result.meta.name = name;
	  }
	  return result;
	}
	
	function getProps(type) {
	  return isObject(type) ? type : type.meta.props;
	}
	
	function getDefaultProps(type) {
	  return isObject(type) ? null : type.meta.defaultProps;
	}
	
	function pushAll(arr, elements) {
	  Array.prototype.push.apply(arr, elements);
	}
	
	function extend(combinator, mixins, options) {
	  if (false) {
	    assert(isFunction(combinator), function () { return 'Invalid argument combinator supplied to extend(combinator, mixins, options), expected a function'; });
	    assert(isArray(mixins), function () { return 'Invalid argument mixins supplied to extend(combinator, mixins, options), expected an array'; });
	  }
	  var props = {};
	  var prototype = {};
	  var predicates = [];
	  var defaultProps = {};
	  mixins.forEach(function (x, i) {
	    var decomposition = decompose(x);
	    var unrefinedType = decomposition.unrefinedType;
	    if (false) {
	      assert(isObject(unrefinedType) || isStruct(unrefinedType) || isInterface(unrefinedType), function () { return 'Invalid argument mixins[' + i + '] supplied to extend(combinator, mixins, options), expected an object, struct, interface or a refinement (of struct or interface)'; });
	    }
	    pushAll(predicates, decomposition.predicates);
	    mixin(props, getProps(unrefinedType));
	    mixin(prototype, unrefinedType.prototype);
	    mixin(defaultProps, getDefaultProps(unrefinedType), true);
	  });
	  options = combinator.getOptions(options);
	  options.defaultProps = mixin(defaultProps, options.defaultProps, true);
	  var result = compose(predicates, combinator(props, {
	    strict: options.strict,
	    defaultProps: options.defaultProps
	  }), options.name);
	  mixin(result.prototype, prototype);
	  return result;
	}
	
	module.exports = extend;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var getTypeName = __webpack_require__(13);
	
	function getDefaultInterfaceName(props) {
	  return '{' + Object.keys(props).map(function (prop) {
	    return prop + ': ' + getTypeName(props[prop]);
	  }).join(', ') + '}';
	}
	
	module.exports = getDefaultInterfaceName;


/***/ },
/* 179 */
/***/ function(module, exports) {

	module.exports = function isNumber(x) {
	  return typeof x === 'number' && isFinite(x) && !isNaN(x);
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(16);
	
	module.exports = function isUnion(x) {
	  return isType(x) && ( x.meta.kind === 'union' );
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var isFunction = __webpack_require__(15);
	var getTypeName = __webpack_require__(13);
	var isIdentity = __webpack_require__(32);
	var create = __webpack_require__(29);
	var is = __webpack_require__(30);
	var isArray = __webpack_require__(31);
	
	function getDefaultName(type) {
	  return 'Array<' + getTypeName(type) + '>';
	}
	
	function list(type, name) {
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + assert.stringify(type) + ' supplied to list(type, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to list(type, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(type);
	  var typeNameCache = getTypeName(type);
	  var identity = isIdentity(type); // the list is identity iif type is identity
	
	  function List(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value; // just trust the input if elements must not be hydrated
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isArray(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an array of ' + typeNameCache + ')'; });
	    }
	
	    var idempotent = true; // will remain true if I can reutilise the input
	    var ret = []; // make a temporary copy, will be discarded if idempotent remains true
	    for (var i = 0, len = value.length; i < len; i++ ) {
	      var actual = value[i];
	      var instance = create(type, actual, (  false ? path.concat(i + ': ' + typeNameCache) : null ));
	      idempotent = idempotent && ( actual === instance );
	      ret.push(instance);
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  List.meta = {
	    kind: 'list',
	    type: type,
	    name: name,
	    identity: identity
	  };
	
	  List.displayName = displayName;
	
	  List.is = function (x) {
	    return isArray(x) && x.every(function (e) {
	      return is(e, type);
	    });
	  };
	
	  List.update = function (instance, patch) {
	    return List(assert.update(instance, patch));
	  };
	
	  return List;
	}
	
	list.getDefaultName = getDefaultName;
	module.exports = list;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var getFunctionName = __webpack_require__(52);
	
	function replacer(key, value) {
	  if (typeof value === 'function') {
	    return getFunctionName(value);
	  }
	  return value;
	}
	
	module.exports = function stringify(x) {
	  try { // handle "Converting circular structure to JSON" error
	    return JSON.stringify(x, replacer, 2);
	  }
	  catch (e) {
	    return String(x);
	  }
	};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var isFunction = __webpack_require__(15);
	var getTypeName = __webpack_require__(13);
	var isIdentity = __webpack_require__(32);
	var isArray = __webpack_require__(31);
	var create = __webpack_require__(29);
	var is = __webpack_require__(30);
	
	function getDefaultName(types) {
	  return '[' + types.map(getTypeName).join(', ') + ']';
	}
	
	function tuple(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction), function () { return 'Invalid argument types ' + assert.stringify(types) + ' supplied to tuple(types, [name]) combinator (expected an array of types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to tuple(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(types);
	  var identity = types.every(isIdentity);
	
	  function Tuple(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value;
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isArray(value) && value.length === types.length, function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an array of length ' + types.length + ')'; });
	    }
	
	    var idempotent = true;
	    var ret = [];
	    for (var i = 0, len = types.length; i < len; i++) {
	      var expected = types[i];
	      var actual = value[i];
	      var instance = create(expected, actual, (  false ? path.concat(i + ': ' + getTypeName(expected)) : null ));
	      idempotent = idempotent && ( actual === instance );
	      ret.push(instance);
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  Tuple.meta = {
	    kind: 'tuple',
	    types: types,
	    name: name,
	    identity: identity
	  };
	
	  Tuple.displayName = displayName;
	
	  Tuple.is = function (x) {
	    return isArray(x) &&
	      x.length === types.length &&
	      types.every(function (type, i) {
	        return is(x[i], type);
	      });
	  };
	
	  Tuple.update = function (instance, patch) {
	    return Tuple(assert.update(instance, patch));
	  };
	
	  return Tuple;
	}
	
	tuple.getDefaultName = getDefaultName;
	module.exports = tuple;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./ Aipo e produtos à base de aipo.svg": 437,
		"./ Soja e produtos à base de soja.svg": 438,
		"./Crustáceos e produtos à base de crustáceos.svg": 439,
		"./Dióxido de enxofre.svg": 440,
		"./Frutos de casca rija.svg": 441,
		"./Moluscos e produtos à base de moluscos.svg": 442,
		"./Mostarda e produtos à base de mostarda.svg": 443,
		"./Peixes e produtos à base de peixe.svg": 444,
		"./Sementes de sésamo e produtos à base de sementes de sésamo.svg": 445,
		"./Tremoço e produtos à base de tremoço.svg": 446,
		"./bad.svg": 447,
		"./cards.svg": 448,
		"./de.svg": 449,
		"./en.svg": 450,
		"./es.svg": 451,
		"./excelent.svg": 452,
		"./fr.svg": 453,
		"./good.svg": 454,
		"./it.svg": 455,
		"./list.svg": 456,
		"./my-pick-nav.svg": 457,
		"./my-pick_actives.svg": 458,
		"./my-pick_inactive.svg": 459,
		"./nav.svg": 460,
		"./nav2.svg": 461,
		"./nl.svg": 462,
		"./ok.svg": 463,
		"./pickly-white.svg": 464,
		"./pt.svg": 465,
		"./terrible.svg": 466
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 184;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _Restaurant = __webpack_require__(209);
	
	var _Restaurant2 = _interopRequireDefault(_Restaurant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseLayout = function BaseLayout() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/:lang/:restaurant?', component: _Restaurant2.default })
	  );
	};
	// import App from "./components/App";
	exports.default = BaseLayout;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(4);
	
	var _Feedback = __webpack_require__(111);
	
	var _Feedback2 = _interopRequireDefault(_Feedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPickly = function (_React$Component) {
	  _inherits(AboutPickly, _React$Component);
	
	  function AboutPickly(props) {
	    _classCallCheck(this, AboutPickly);
	
	    var _this = _possibleConstructorReturn(this, (AboutPickly.__proto__ || Object.getPrototypeOf(AboutPickly)).call(this, props));
	
	    _this.state = {
	      data: {}
	    };
	    return _this;
	  }
	
	  _createClass(AboutPickly, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _apiData.ajaxGetHTML)(_settings.API + this.props.match.params.lang + '/content/2/', this);
	
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(
	      //title
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'nav-pickly' },
	        function (message) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            message
	          );
	        }
	      ),
	      //view
	      'pickly',
	      //back button or not
	      false);
	    }
	
	    // shouldComponentUpdate(nextProps) {
	    //   // return (this.props.matchparams !== nextProps.matchparams);
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.data !== '{"status": "error"}' ? _react2.default.createElement('div', { className: 'static-content', dangerouslySetInnerHTML: { __html: this.state.data } }) : null,
	        _react2.default.createElement(_Feedback2.default, { lang: this.props.match.params.lang, restaurant: this.props.slug })
	      );
	    }
	  }]);
	
	  return AboutPickly;
	}(_react2.default.Component);
	
	AboutPickly.propTypes = {
	  match: _react.PropTypes.object,
	  slug: _react.PropTypes.string,
	  view_info: _react.PropTypes.func
	};
	exports.default = AboutPickly;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cookies = function (_React$Component) {
	  _inherits(Cookies, _React$Component);
	
	  function Cookies(props) {
	    _classCallCheck(this, Cookies);
	
	    var _this = _possibleConstructorReturn(this, (Cookies.__proto__ || Object.getPrototypeOf(Cookies)).call(this, props));
	
	    _this.state = {
	      data: ''
	    };
	    return _this;
	  }
	
	  _createClass(Cookies, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _apiData.ajaxGetHTML)(_settings.API + this.props.match.params.lang + '/content/3/', this);
	
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(
	      //title
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'cookies-title' },
	        function (message) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            message
	          );
	        }
	      ),
	      //view
	      'cookies',
	      //back button or not
	      true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.data !== '{"status": "error"}' ? _react2.default.createElement('div', { className: 'static-content', dangerouslySetInnerHTML: { __html: this.state.data } }) : null
	      );
	    }
	  }]);
	
	  return Cookies;
	}(_react2.default.Component);
	
	Cookies.propTypes = {
	  match: _react.PropTypes.object,
	  view_info: _react.PropTypes.func
	};
	exports.default = Cookies;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Terms = function (_React$Component) {
	  _inherits(Terms, _React$Component);
	
	  function Terms(props) {
	    _classCallCheck(this, Terms);
	
	    var _this = _possibleConstructorReturn(this, (Terms.__proto__ || Object.getPrototypeOf(Terms)).call(this, props));
	
	    _this.state = {
	      data: ''
	    };
	    return _this;
	  }
	
	  _createClass(Terms, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _apiData.ajaxGetHTML)(_settings.API + this.props.match.params.lang + '/content/1/', this);
	
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(
	      //title
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'terms-title' },
	        function (message) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            message
	          );
	        }
	      ),
	      //view
	      'terms',
	      //back button or not
	      false);
	    }
	
	    // shouldComponentUpdate(nextProps) {
	    //     return this.props.match.params !== nextProps.match.params;
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.data !== '{"status": "error"}' ? _react2.default.createElement('div', { className: 'static-content', dangerouslySetInnerHTML: { __html: this.state.data } }) : null
	      );
	    }
	  }]);
	
	  return Terms;
	}(_react2.default.Component);
	
	Terms.propTypes = {
	  match: _react.PropTypes.object,
	  view_info: _react.PropTypes.func
	};
	exports.default = Terms;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _universalCookie = __webpack_require__(45);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cookies = new _universalCookie2.default();
	
	var BottomBar = function (_React$PureComponent) {
	  _inherits(BottomBar, _React$PureComponent);
	
	  function BottomBar() {
	    _classCallCheck(this, BottomBar);
	
	    return _possibleConstructorReturn(this, (BottomBar.__proto__ || Object.getPrototypeOf(BottomBar)).apply(this, arguments));
	  }
	
	  _createClass(BottomBar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'nav',
	        { className: 'bottom-bar' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'bottom-link nav-home' + (this.props.view === 'home' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_home' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'bottom-link nav-menu' + (this.props.view === 'menu' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + '/menu' },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_menu' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ),
	          this.props.package === 1 && this.props.wine_slug ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'bottom-link nav-wines' + (this.props.view === 'wines' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + this.props.wine_slug },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_wines' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'bottom-link nav-featured' + (this.props.view === 'featured' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + '/items/featured/' },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_suggestions' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'bottom-link nav-shortlist' + (this.props.view === 'shortlist' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + '/items/shortlist' },
	              cookies.get('favsTotal') > 0 ? _react2.default.createElement(
	                'sup',
	                null,
	                cookies.get('favsTotal')
	              ) : null,
	              'myPick'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BottomBar;
	}(_react2.default.PureComponent);
	
	BottomBar.propTypes = {
	  lang: _react.PropTypes.string,
	  restaurant: _react.PropTypes.string,
	  view: _react.PropTypes.string,
	  wine_slug: _react.PropTypes.string,
	  package: _react.PropTypes.number
	};
	exports.default = BottomBar;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Filter = function (_React$Component) {
	  _inherits(Filter, _React$Component);
	
	  function Filter() {
	    _classCallCheck(this, Filter);
	
	    return _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).apply(this, arguments));
	  }
	
	  _createClass(Filter, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.active !== nextProps.active;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'button',
	        { className: 'filter' + ' ' + this.props.slug + ' ' + (this.props.active ? 'active' : null),
	          onClick: this.props.onClick.bind(this, this.props.id, this.props.filterType) },
	        this.props.children,
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.name
	        )
	      );
	    }
	  }]);
	
	  return Filter;
	}(_react2.default.Component);
	
	Filter.propTypes = {
	  active: _react.PropTypes.bool,
	  children: _react.PropTypes.object,
	  filterType: _react.PropTypes.string,
	  id: _react.PropTypes.number,
	  name: _react.PropTypes.string,
	  onClick: _react.PropTypes.func,
	  slug: _react.PropTypes.string
	};
	exports.default = Filter;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterBtn = function (_React$PureComponent) {
	  _inherits(FilterBtn, _React$PureComponent);
	
	  function FilterBtn() {
	    _classCallCheck(this, FilterBtn);
	
	    return _possibleConstructorReturn(this, (FilterBtn.__proto__ || Object.getPrototypeOf(FilterBtn)).apply(this, arguments));
	  }
	
	  _createClass(FilterBtn, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'a',
	        { className: 'filter-btn' + ' ' + this.props.toggle, 'data-value': 'filters',
	          onClick: function onClick(e) {
	            return _this2.props.onClick(e);
	          } },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'filters' },
	          function (message) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              message
	            );
	          }
	        )
	      );
	    }
	  }]);
	
	  return FilterBtn;
	}(_react2.default.PureComponent);
	
	FilterBtn.propTypes = {
	  onClick: _react.PropTypes.func,
	  toggle: _react.PropTypes.string
	};
	exports.default = FilterBtn;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterGroup = function (_React$PureComponent) {
	  _inherits(FilterGroup, _React$PureComponent);
	
	  function FilterGroup() {
	    _classCallCheck(this, FilterGroup);
	
	    return _possibleConstructorReturn(this, (FilterGroup.__proto__ || Object.getPrototypeOf(FilterGroup)).apply(this, arguments));
	  }
	
	  _createClass(FilterGroup, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // render all filters in array
	      var filters = this.props.listFilters.map(function (filter, index) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'filter-group', key: _this2.props.filterTitle + '-' + index },
	          filter
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.filterTemplate + ' filter-wrapper' },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: "filter-group-" + this.props.filterTitle },
	          function (message) {
	            return _react2.default.createElement(
	              'h5',
	              { className: 'filter-title' },
	              message
	            );
	          }
	        ),
	        filters
	      );
	    }
	  }]);
	
	  return FilterGroup;
	}(_react2.default.PureComponent);
	
	FilterGroup.propTypes = {
	  listFilters: _react.PropTypes.array,
	  filterTitle: _react.PropTypes.string
	};
	exports.default = FilterGroup;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _FilterGroup = __webpack_require__(192);
	
	var _FilterGroup2 = _interopRequireDefault(_FilterGroup);
	
	var _Filter = __webpack_require__(190);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _SvgIcons = __webpack_require__(54);
	
	var _SvgIcons2 = _interopRequireDefault(_SvgIcons);
	
	var _reactSelect = __webpack_require__(78);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterMenu = function (_React$Component) {
	  _inherits(FilterMenu, _React$Component);
	
	  function FilterMenu() {
	    _classCallCheck(this, FilterMenu);
	
	    return _possibleConstructorReturn(this, (FilterMenu.__proto__ || Object.getPrototypeOf(FilterMenu)).apply(this, arguments));
	  }
	
	  _createClass(FilterMenu, [{
	    key: 'checkIfActive',
	
	
	    // check if icon should be active or not
	    value: function checkIfActive(id, group) {
	      return this.props.activeFilters[group].indexOf(id) !== -1;
	    }
	
	    // render icon filters
	
	  }, {
	    key: 'listFilters',
	    value: function listFilters(group) {
	      var _this2 = this;
	
	      var filter_list = this.props.filters;
	      var free = '';
	      var name_variable = 'name';
	      if (group === 'diets') {
	        free = '-free';
	        name_variable = 'filter_name';
	      }
	      if (filter_list) {
	        return filter_list[group].map(function (filter) {
	          return _react2.default.createElement(
	            _Filter2.default,
	            { key: group + '-' + filter.id, slug: filter.slug,
	              className: 'filter' + group, filterType: group, name: filter[name_variable], id: filter.id,
	              onClick: _this2.props.handleClickFilter, active: _this2.checkIfActive(filter.id, group) },
	            _react2.default.createElement(_SvgIcons2.default, { icon: filter.slug + free })
	          );
	        });
	      }
	    }
	
	    // render select filters
	
	  }, {
	    key: 'listSelect',
	    value: function listSelect(option) {
	      if (this.props.filters) {
	        return this.props.filters[option].map(function (item) {
	          return {
	            value: item.id,
	            label: item.name,
	            key: 'region-' + item.id,
	            filter: option
	          };
	        });
	      }
	    }
	  }, {
	    key: 'setPlaceholders',
	    value: function setPlaceholders(option) {
	      return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: option + "_default_option" },
	        function (message) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            message
	          );
	        }
	      );
	    }
	  }, {
	    key: 'filtersRender',
	    value: function filtersRender(template) {
	      var _this3 = this;
	
	      if (template === "") {
	        return null;
	      }
	
	      if (template === 'wine') {
	        // CHECKING IF IT IS A WINE ITEM
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_FilterGroup2.default, {
	            filterTemplate: 'wine',
	            listFilters: [_react2.default.createElement(_reactSelect2.default, { key: '0', options: this.listSelect('wine_type'),
	              clearable: false,
	              id: 'wine_type',
	              name: 'type',
	              value: Number(this.props.activeFilters.wine_type[0]),
	              onChange: function onChange(e) {
	                return _this3.props.handleSelectFilter(e.value, 'wine_type');
	              },
	              searchable: false,
	              placeholder: this.setPlaceholders("type") }), _react2.default.createElement(_reactSelect2.default, { key: '1', options: this.listSelect('wine_regions'),
	              clearable: false,
	              id: 'wine_regions',
	              name: 'region',
	              value: Number(this.props.activeFilters.wine_regions[0]),
	              onChange: function onChange(e) {
	                return _this3.props.handleSelectFilter(e.value, 'wine_regions');
	              },
	              searchable: false,
	              placeholder: this.setPlaceholders("region") })],
	            filterTitle: 'region-type' }),
	          _react2.default.createElement(_FilterGroup2.default, { filterTemplate: 'wine', listFilters: [this.listFilters("sweetness"), this.listFilters("body")],
	            filterTitle: 'characteristics' })
	        );
	      } else {
	        // CHECKING IF ITS NOT A WINE ITEM
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_FilterGroup2.default, { listFilters: [this.listFilters("ingredients")], filterTitle: 'ingredients' }),
	          this.props.filters.diets.length > 0 ? _react2.default.createElement(_FilterGroup2.default, { listFilters: [this.listFilters("diets")], filterTitle: 'diets' }) : null
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: "filters-header " + this.props.toggle },
	          _react2.default.createElement(
	            'div',
	            { className: 'results' },
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'filters' },
	              function (message) {
	                return _react2.default.createElement(
	                  'h4',
	                  null,
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'filter-results', values: { results: this.props.itemNumber || '0' } })
	          ),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'filter-clear-button' },
	            function (message) {
	              return _react2.default.createElement(
	                'button',
	                { className: 'clear-btn',
	                  'data-value': 'clear', onClick: _this4.props.clearAllFilters.bind(_this4) },
	                message
	              );
	            }
	          ),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'filter-apply-button' },
	            function (message) {
	              return _react2.default.createElement(
	                'button',
	                { className: 'apply-btn',
	                  'data-value': 'apply', onClick: _this4.props.handleClick },
	                message
	              );
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "filter-menu " + this.props.toggle, id: 'filterMenu' },
	          this.filtersRender(this.props.template)
	        )
	      );
	    }
	  }]);
	
	  return FilterMenu;
	}(_react2.default.Component);
	
	FilterMenu.propTypes = {
	  activeFilters: _react.PropTypes.object,
	  clearAllFilters: _react.PropTypes.func,
	  filters: _react.PropTypes.object,
	  handleClick: _react.PropTypes.func,
	  handleClickFilter: _react.PropTypes.func,
	  handleSelectFilter: _react.PropTypes.func,
	  itemNumber: _react.PropTypes.number,
	  template: _react.PropTypes.string,
	  toggle: _react.PropTypes.string
	};
	exports.default = FilterMenu;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Flags = function (_React$PureComponent) {
	  _inherits(Flags, _React$PureComponent);
	
	  function Flags(props) {
	    _classCallCheck(this, Flags);
	
	    var _this = _possibleConstructorReturn(this, (Flags.__proto__ || Object.getPrototypeOf(Flags)).call(this, props));
	
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    return _this;
	  }
	
	  _createClass(Flags, [{
	    key: "handleMouseDown",
	    value: function handleMouseDown(event) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.props.onSelect(this.props.option, event);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "icon-value-option", onMouseDown: this.handleMouseDown },
	        _react2.default.createElement(
	          "span",
	          { className: "icon-value-label" },
	          this.props.option.label
	        ),
	        _react2.default.createElement("img", { className: "lang-flag", src: __webpack_require__(184)("./" + this.props.option.label + '.svg') })
	      );
	    }
	  }]);
	
	  return Flags;
	}(_react2.default.PureComponent);
	
	Flags.propTypes = {
	  option: _react.PropTypes.object.isRequired,
	  onSelect: _react.PropTypes.func
	};
	exports.default = Flags;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FlagsValue = function (_React$PureComponent) {
	  _inherits(FlagsValue, _React$PureComponent);
	
	  function FlagsValue() {
	    _classCallCheck(this, FlagsValue);
	
	    return _possibleConstructorReturn(this, (FlagsValue.__proto__ || Object.getPrototypeOf(FlagsValue)).apply(this, arguments));
	  }
	
	  _createClass(FlagsValue, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "Select-value icon-value" },
	        _react2.default.createElement(
	          "span",
	          { className: "Select-value-label" },
	          _react2.default.createElement("img", { className: "lang-flag", src: __webpack_require__(184)("./" + this.props.value.label + '.svg') })
	        )
	      );
	    }
	  }]);
	
	  return FlagsValue;
	}(_react2.default.PureComponent);
	
	FlagsValue.propTypes = {
	  value: _react.PropTypes.object
	};
	exports.default = FlagsValue;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactSelect = __webpack_require__(78);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _Flags = __webpack_require__(194);
	
	var _Flags2 = _interopRequireDefault(_Flags);
	
	var _FlagsValue = __webpack_require__(195);
	
	var _FlagsValue2 = _interopRequireDefault(_FlagsValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Languages = function (_React$Component) {
	  _inherits(Languages, _React$Component);
	
	  function Languages(props) {
	    _classCallCheck(this, Languages);
	
	    var _this = _possibleConstructorReturn(this, (Languages.__proto__ || Object.getPrototypeOf(Languages)).call(this, props));
	
	    _this.state = {
	      path: ""
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Languages, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.path) {
	        this.setState({ path: '' });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(value) {
	      this.setState({ path: '/' + value.value + '/' + this.props.match.params.restaurant });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var listLanguages = void 0;
	      if (this.props.languages) {
	        listLanguages = this.props.languages.map(function (item) {
	          return {
	            value: item.code,
	            key: 'lang-' + item.code,
	            label: item.code
	          };
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'languages' },
	        this.state.path ? _react2.default.createElement(_reactRouterDom.Redirect, { to: this.state.path, push: true }) : _react2.default.createElement(_reactSelect2.default, {
	          className: 'topbar-select',
	          searchable: false,
	          name: 'select-filter',
	          clearable: false,
	          arrowRenderer: null,
	          value: this.props.lang,
	          placeholder: this.props.lang,
	          onChange: this.handleChange,
	          options: listLanguages,
	          optionComponent: _Flags2.default,
	          valueComponent: _FlagsValue2.default
	        })
	      );
	    }
	  }]);
	
	  return Languages;
	}(_react2.default.Component);
	
	Languages.propTypes = {
	  lang: _react.PropTypes.string,
	  languages: _react.PropTypes.array,
	  match: _react.PropTypes.object
	};
	exports.default = Languages;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _SvgIcons = __webpack_require__(54);
	
	var _SvgIcons2 = _interopRequireDefault(_SvgIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListViewIcon = function (_React$PureComponent) {
	  _inherits(ListViewIcon, _React$PureComponent);
	
	  function ListViewIcon(props) {
	    _classCallCheck(this, ListViewIcon);
	
	    var _this = _possibleConstructorReturn(this, (ListViewIcon.__proto__ || Object.getPrototypeOf(ListViewIcon)).call(this, props));
	
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    return _this;
	  }
	
	  _createClass(ListViewIcon, [{
	    key: 'handleMouseDown',
	    value: function handleMouseDown(event) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.props.onSelect(this.props.option, event);
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      if (this.props.option.label === 'list') {
	        return _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'toggle_list' },
	          function (message) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              message
	            );
	          }
	        );
	      }
	      return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'toggle_cards' },
	        function (message) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            message
	          );
	        }
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'icon-value-option', onMouseDown: this.handleMouseDown },
	        _react2.default.createElement(
	          'span',
	          { className: 'icon-value-label' },
	          this.renderLabel()
	        ),
	        _react2.default.createElement(_SvgIcons2.default, { icon: this.props.option.label })
	      );
	    }
	  }]);
	
	  return ListViewIcon;
	}(_react2.default.PureComponent);
	
	ListViewIcon.propTypes = {
	  option: _react.PropTypes.object.isRequired,
	  onSelect: _react.PropTypes.func
	};
	exports.default = ListViewIcon;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgIcons = __webpack_require__(54);
	
	var _SvgIcons2 = _interopRequireDefault(_SvgIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListViewValue = function (_React$PureComponent) {
	  _inherits(ListViewValue, _React$PureComponent);
	
	  function ListViewValue() {
	    _classCallCheck(this, ListViewValue);
	
	    return _possibleConstructorReturn(this, (ListViewValue.__proto__ || Object.getPrototypeOf(ListViewValue)).apply(this, arguments));
	  }
	
	  _createClass(ListViewValue, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "Select-value icon-value" },
	        _react2.default.createElement(
	          "span",
	          { className: "Select-value-label" },
	          _react2.default.createElement(_SvgIcons2.default, { icon: this.props.value.label })
	        )
	      );
	    }
	  }]);
	
	  return ListViewValue;
	}(_react2.default.PureComponent);
	
	ListViewValue.propTypes = {
	  value: _react.PropTypes.object
	};
	exports.default = ListViewValue;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavBtn = function (_React$PureComponent) {
	  _inherits(NavBtn, _React$PureComponent);
	
	  function NavBtn() {
	    _classCallCheck(this, NavBtn);
	
	    return _possibleConstructorReturn(this, (NavBtn.__proto__ || Object.getPrototypeOf(NavBtn)).apply(this, arguments));
	  }
	
	  _createClass(NavBtn, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement("button", { className: "nav-btn btn " + this.props.toggle, href: "#",
	        onClick: function onClick(e) {
	          return _this2.props.onClick(e);
	        }, "data-value": "nav" });
	    }
	  }]);
	
	  return NavBtn;
	}(_react2.default.PureComponent);
	
	NavBtn.propTypes = {
	  onClick: _react.PropTypes.func,
	  toggle: _react.PropTypes.string
	};
	
	exports.default = NavBtn;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(4);
	
	var _universalCookie = __webpack_require__(45);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cookies = new _universalCookie2.default();
	
	var NavItems = function (_React$Component) {
	  _inherits(NavItems, _React$Component);
	
	  function NavItems() {
	    _classCallCheck(this, NavItems);
	
	    return _possibleConstructorReturn(this, (NavItems.__proto__ || Object.getPrototypeOf(NavItems)).apply(this, arguments));
	  }
	
	  _createClass(NavItems, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'nav',
	        { className: 'main-nav' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'nav-link nav-home' + (this.props.view === 'home' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_home' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'nav-link nav-menu' + (this.props.view === 'menu' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + '/menu' },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_menu' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ),
	          this.props.package === 1 && this.props.wine_slug ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'nav-link nav-wines' + (this.props.view === 'wines' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + this.props.wine_slug },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_wines' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'nav-link nav-suggestions' + (this.props.view === 'featured' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + '/items/featured/' },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_suggestions' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'nav-link nav-shortlist' + (this.props.view === 'shortlist' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + '/items/shortlist' },
	              cookies.get('favsTotal') > 0 ? _react2.default.createElement(
	                'sup',
	                null,
	                cookies.get('favsTotal')
	              ) : null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'myPick'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'nav-link nav-about' + (this.props.view === 'about' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + '/about' },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_about' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'nav-link nav-events' + (this.props.view === 'events' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + '/events' },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_events' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ),
	          this.props.mode !== 'kiosk' ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'nav-link nav-feedback' + (this.props.view === 'feedback' ? ' active' : ''),
	                to: '/' + this.props.lang + '/' + this.props.restaurant + '/restaurant-feedback/' },
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav-feedback' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return NavItems;
	}(_react2.default.Component);
	
	NavItems.propTypes = {
	  lang: _react.PropTypes.string,
	  mode: _react.PropTypes.string,
	  onClick: _react.PropTypes.func,
	  restaurant: _react.PropTypes.string,
	  view: _react.PropTypes.string,
	  wine_slug: _react.PropTypes.string,
	  package: _react.PropTypes.number
	};
	exports.default = NavItems;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(4);
	
	var _Logo = __webpack_require__(207);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _NavItems = __webpack_require__(200);
	
	var _NavItems2 = _interopRequireDefault(_NavItems);
	
	var _Social = __webpack_require__(202);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SideNav = function (_React$PureComponent) {
	  _inherits(SideNav, _React$PureComponent);
	
	  function SideNav(props) {
	    _classCallCheck(this, SideNav);
	
	    var _this = _possibleConstructorReturn(this, (SideNav.__proto__ || Object.getPrototypeOf(SideNav)).call(this, props));
	
	    _this.mode = (0, _settings.modeCheck)("mode");
	
	    return _this;
	  }
	
	  _createClass(SideNav, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'side-nav-logo' },
	          _react2.default.createElement('button', { className: 'back-btn', onClick: this.props.onClick, 'data-value': 'nav' }),
	          _react2.default.createElement(_Logo2.default, { name: this.props.name, city: this.props.city, country: this.props.country })
	        ),
	        _react2.default.createElement(_NavItems2.default, { restaurant: this.props.restaurant, lang: this.props.lang, wine_slug: this.props.wine,
	          view: this.props.view, mode: this.mode, 'package': this.props.package }),
	        this.mode !== 'kiosk' ? _react2.default.createElement(
	          _Social2.default,
	          { social: this.props.social, view: this.props.view },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'terms-link', to: '/' + this.props.lang + '/' + this.props.restaurant + '/terms' },
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'terms-title' },
	              function (message) {
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  message
	                );
	              }
	            )
	          )
	        ) : null,
	        this.props.children
	      );
	    }
	  }]);
	
	  return SideNav;
	}(_react2.default.PureComponent);
	
	SideNav.propTypes = {
	  children: _react.PropTypes.object,
	  city: _react.PropTypes.string,
	  country: _react.PropTypes.string,
	  lang: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  onClick: _react.PropTypes.func,
	  package: _react.PropTypes.number,
	  restaurant: _react.PropTypes.string,
	  social: _react.PropTypes.object,
	  view: _react.PropTypes.string,
	  wine: _react.PropTypes.string
	};
	exports.default = SideNav;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Social = function (_React$Component) {
	  _inherits(Social, _React$Component);
	
	  function Social(props) {
	    _classCallCheck(this, Social);
	
	    var _this = _possibleConstructorReturn(this, (Social.__proto__ || Object.getPrototypeOf(Social)).call(this, props));
	
	    _this.empty = '';
	
	    return _this;
	  }
	
	  _createClass(Social, [{
	    key: 'checkSocial',
	    value: function checkSocial() {
	      this.social = this.props.social;
	      var value = [];
	      for (var key in this.social) {
	        if (this.social[key] !== '') {
	          value.push(key);
	        }
	      }
	      if (value.length !== 0) {
	        this.empty = 'active';
	      }
	      return value;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var socials = this.checkSocial().map(function (item) {
	        return _this2.social[item] ? _react2.default.createElement(
	          'li',
	          { key: 'social-' + item },
	          _react2.default.createElement('a', { target: '_blank', href: _this2.social[item], className: "social social-" + item })
	        ) : null;
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'social-wrapper' + ' ' + this.empty },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'follow_text' },
	          function (message) {
	            return _react2.default.createElement(
	              'h5',
	              null,
	              message,
	              ':'
	            );
	          }
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'inline-list' },
	          socials
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Social;
	}(_react2.default.Component);
	
	Social.propTypes = {
	  children: _react.PropTypes.object,
	  social: _react.PropTypes.object
	};
	
	exports.default = Social;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _PreLoader = __webpack_require__(37);
	
	var _PreLoader2 = _interopRequireDefault(_PreLoader);
	
	var _imagesLoadCheck = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Slider from 'react-slick';
	
	var About = function (_React$Component) {
	  _inherits(About, _React$Component);
	
	  function About(props) {
	    _classCallCheck(this, About);
	
	    var _this = _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, props));
	
	    _this.addThis = '';
	
	    _this.state = {
	      loading: 'loading',
	      data: { gallery: [], description: '', name: '' },
	      detail_width: 0
	    };
	
	    _this.handleLoading = _this.handleLoading.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(About, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.lang = this.props.match.params.lang;
	      this.restaurant = this.props.match.params.restaurant;
	
	      this.updateDimensions();
	      window.addEventListener("resize", this.updateDimensions);
	      (0, _apiData.ajaxGet)(_settings.API + this.lang + '/api/restaurant/' + this.restaurant + '/about/', this);
	      this.handleLoading();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props.name !== nextProps.name || this.state !== nextState;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevState) {
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      if (this.state.data.name) {
	        this.props.view_info(this.state.data.name, 'about', false);
	      }
	      //NEED THIS TO FORCE ADDTHIS TO LOAD
	      if (prevState.addthis !== this.addThis) {
	        // eslint-disable-next-line
	        if (typeof addthis.layers.refresh !== 'undefined') {
	          // eslint-disable-next-line
	          addthis.layers.refresh();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions);
	    }
	  }, {
	    key: 'handleLoading',
	    value: function handleLoading() {
	      this.setState({
	        loading: (0, _imagesLoadCheck.imagesLoaded)(this.list)
	      });
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      if (window.innerWidth > 1024) {
	        this.setState({ detail_width: window.innerWidth - 120 });
	      } else {
	        this.setState({ detail_width: window.innerWidth });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_PreLoader2.default, { loading: this.state.loading }),
	        _react2.default.createElement(
	          'div',
	          { className: 'item-detail content-wrapper about ' + this.state.loading,
	            style: { width: this.state.detail_width } },
	          _react2.default.createElement(
	            'div',
	            { className: 'detail-half' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card main-card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'list-item', ref: function ref(el) {
	                    return _this2.list = el;
	                  } },
	                this.props.background ? _react2.default.createElement('img', { className: 'hero-image', src: this.props.background, alt: '' }) : null
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'detail-half' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'item-title' },
	                this.state.data.name
	              ),
	              _react2.default.createElement('div', { ref: 'addthis', className: 'addthis_inline_share_toolbox' }),
	              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.data.description } })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return About;
	}(_react2.default.Component);
	
	About.propTypes = {
	  background: _react.PropTypes.string,
	  match: _react.PropTypes.object,
	  name: _react.PropTypes.string,
	  view_info: _react.PropTypes.func
	};
	exports.default = About;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(4);
	
	var _EventItem = __webpack_require__(114);
	
	var _EventItem2 = _interopRequireDefault(_EventItem);
	
	var _SmallEventCard = __webpack_require__(212);
	
	var _SmallEventCard2 = _interopRequireDefault(_SmallEventCard);
	
	var _Error = __webpack_require__(53);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _PreLoader = __webpack_require__(37);
	
	var _PreLoader2 = _interopRequireDefault(_PreLoader);
	
	var _imagesLoadCheck = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventDetail = function (_React$Component) {
	  _inherits(EventDetail, _React$Component);
	
	  function EventDetail(props) {
	    _classCallCheck(this, EventDetail);
	
	    var _this = _possibleConstructorReturn(this, (EventDetail.__proto__ || Object.getPrototypeOf(EventDetail)).call(this, props));
	
	    _this.category = '';
	    _this.event = '';
	    _this.addThis = '';
	
	    // const now = Date.now();
	    _this.state = {
	      data: { start: '' },
	      loading: 'loading'
	    };
	    _this.handleLoading = _this.handleLoading.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.lang = this.props.match.params.lang;
	      this.restaurant = this.props.match.params.restaurant;
	      this.slug = this.props.slug;
	
	      this.updateDimensions();
	      window.addEventListener("resize", this.updateDimensions);
	
	      (0, _apiData.ajaxGet)(_settings.API + this.lang + '/api/' + this.restaurant + '/events/' + this.slug.split("-").pop() + '/', this);
	
	      this.addThis = 'true';
	
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(
	      //title
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'detail_title' },
	        function (message) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            message
	          );
	        }
	      ),
	      //view
	      'events',
	      //back button or not
	      true);
	    }
	
	    //NEED THIS TO FORCE ADDTHIS TO LOAD
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevState) {
	      if (prevState.addthis !== this.addThis) {
	        // eslint-disable-next-line
	        if (typeof addthis.layers.refresh !== 'undefined') {
	          // eslint-disable-next-line
	          addthis.layers.refresh();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions);
	    }
	  }, {
	    key: 'handleLoading',
	    value: function handleLoading() {
	      var galleryElement = this.refs.detail;
	      this.setState({
	        loading: (0, _imagesLoadCheck.imagesLoaded)(galleryElement)
	      });
	    }
	  }, {
	    key: 'checkOtherEvents',
	    value: function checkOtherEvents() {
	      var _this2 = this;
	
	      if (this.state.data.hasOwnProperty('next_events') && this.state.data.next_events.length > 0) {
	        var listEvents = this.state.data.next_events.map(function (item) {
	          return _react2.default.createElement(_SmallEventCard2.default, { key: 'related-match-' + item.pk, name: item.title, lang: _this2.lang,
	            start: item.start, description: item.description, photo: item.photo,
	            slug: item.slug, rest: _this2.restaurant, pk: item.pk, cat: item.category });
	        });
	        return _react2.default.createElement(
	          'div',
	          { className: 'suggested-area' },
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'other_events' },
	            function (message) {
	              return _react2.default.createElement(
	                'h6',
	                null,
	                message
	              );
	            }
	          ),
	          listEvents
	        );
	      }
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      if (window.innerWidth > 1024) {
	        this.setState({ detail_width: window.innerWidth - 120 });
	      } else {
	        this.setState({ detail_width: window.innerWidth });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      // CHECKING FOR ERRORS FROM THE API
	      if (this.state.data.status !== "error") {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_PreLoader2.default, { loading: this.state.loading }),
	          _react2.default.createElement(
	            'div',
	            { className: 'item-detail content-wrapper ' + this.state.loading,
	              style: { width: this.state.detail_width }, ref: 'detail', onLoad: this.handleLoading.bind(this) },
	            _react2.default.createElement(
	              'div',
	              { className: 'btn-wrapper' },
	              _react2.default.createElement('button', { className: 'btn body-back-btn', onClick: this.props.history.goBack })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'detail-half' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card main-card' },
	                _react2.default.createElement(_EventItem2.default, { name: this.state.data.title, image: this.state.data.display_image,
	                  description: this.state.data.description, itemSlug: this.slug, list: 'false',
	                  loading: this.handleLoading, lang: this.lang, start: this.state.data.start,
	                  end: this.state.data.end
	                }),
	                _react2.default.createElement('div', { ref: 'addthis', className: 'addthis_inline_share_toolbox' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'detail-half' },
	              _react2.default.createElement(
	                'div',
	                { className: 'suggested-area' },
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'event_link' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'h6',
	                      null,
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { className: 'event-link', target: '_blank', href: this.state.data.url },
	                  this.state.data.url
	                )
	              ),
	              this.checkOtherEvents()
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(_Error2.default, { restaurant: this.restaurant, lang: this.lang });
	    }
	  }]);
	
	  return EventDetail;
	}(_react2.default.Component);
	
	EventDetail.propTypes = {
	  history: _react.PropTypes.object,
	  match: _react.PropTypes.object,
	  slug: _react.PropTypes.string,
	  view_info: _react.PropTypes.func
	};
	exports.default = EventDetail;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Error = __webpack_require__(53);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(4);
	
	var _EventItem = __webpack_require__(114);
	
	var _EventItem2 = _interopRequireDefault(_EventItem);
	
	var _Empty = __webpack_require__(55);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _PreLoader = __webpack_require__(37);
	
	var _PreLoader2 = _interopRequireDefault(_PreLoader);
	
	var _imagesLoadCheck = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventList = function (_React$Component) {
	  _inherits(EventList, _React$Component);
	
	  function EventList(props) {
	    _classCallCheck(this, EventList);
	
	    var _this = _possibleConstructorReturn(this, (EventList.__proto__ || Object.getPrototypeOf(EventList)).call(this, props));
	
	    _this.lang = '';
	    _this.restaurant = '';
	    _this.state = {
	      data: [],
	      list_width: 0,
	      loading: 'loading'
	    };
	    _this.handleLoading = _this.handleLoading.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    return _this;
	  }
	
	  _createClass(EventList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.lang = this.props.match.params.lang;
	      this.restaurant = this.props.match.params.restaurant;
	
	      this.updateDimensions();
	      (0, _apiData.ajaxGet)(_settings.API + this.lang + '/api/' + this.restaurant + '/events/', this);
	      window.addEventListener("resize", this.updateDimensions);
	
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(
	      //title
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'list_event_title' },
	        function (message) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            message
	          );
	        }
	      ),
	      //view
	      'events',
	      //back button or not
	      true);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions);
	    }
	  }, {
	    key: 'handleLoading',
	    value: function handleLoading() {
	      var galleryElement = this.refs.list;
	      this.setState({
	        loading: (0, _imagesLoadCheck.imagesLoaded)(galleryElement)
	      });
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      // CHECKING FOR ERRORS FROM THE API
	      // API GAVE ME AN ERROR :(
	      if (this.state.data.status === "error") {
	        return _react2.default.createElement(_Error2.default, { restaurant: this.restaurant, lang: this.lang });
	      }
	      var listEvents = '';
	
	      // CHECK IF API RESPONSE HAS ARRIVED
	      // CHECK IF THERE ARE ANY RESULTS IN THE RESPONSE
	      if (this.state.data.length > 0) {
	        // FOUND THE RESULTS, MAPPING THEM HERE AND RENDERING FURTHER BELOW
	        listEvents = this.state.data.map(function (item) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'list-item', key: item.id },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/' + _this2.lang + '/' + _this2.restaurant + '/events/' + item.slug },
	              _react2.default.createElement(_EventItem2.default, { name: item.title, slug: item.slug,
	                image: item.display_image, description: item.description,
	                start: item.start, list: 'true', pk: item.id,
	                end: item.end, loading: _this2.handleLoading, template: "event"
	              })
	            )
	          );
	        });
	        return _react2.default.createElement(
	          'div',
	          { className: 'item-list ' + this.state.loading, style: { width: this.state.list_width }, ref: 'list' },
	          _react2.default.createElement('button', { className: 'btn body-back-btn', onClick: this.props.history.goBack }),
	          _react2.default.createElement(
	            'div',
	            { className: 'list-wrapper' },
	            listEvents
	          )
	        );
	      } else {
	        // NO RESULTS WERE FOUND, RENDER A MSG
	        return _react2.default.createElement(
	          'div',
	          { className: 'item-list loaded' },
	          _react2.default.createElement(_Empty2.default, null)
	        );
	      }
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      if (window.innerWidth > 1024) {
	        this.setState({ list_width: window.innerWidth - 120 });
	      } else {
	        this.setState({ list_width: window.innerWidth });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // FOUND THE RESULTS RENDERING THE MAPPED ITEMS HERE
	      return _react2.default.createElement(
	        'div',
	        { className: 'content-wrapper' },
	        _react2.default.createElement(_PreLoader2.default, null),
	        this.renderResults()
	      );
	    }
	  }]);
	
	  return EventList;
	}(_react2.default.Component);
	
	EventList.propTypes = {
	  history: _react.PropTypes.object,
	  match: _react.PropTypes.object,
	  view_info: _react.PropTypes.func
	};
	exports.default = EventList;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LikeBtn = function (_React$Component) {
	  _inherits(LikeBtn, _React$Component);
	
	  function LikeBtn(props) {
	    _classCallCheck(this, LikeBtn);
	
	    var _this = _possibleConstructorReturn(this, (LikeBtn.__proto__ || Object.getPrototypeOf(LikeBtn)).call(this, props));
	
	    _this.toggle = 'inactive';
	
	    _this.state = {
	      // data object needed by ajaxPost
	      data: { like: 0 }
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(LikeBtn, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setState({ data: { like: this.props.likes } });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextState) {
	      return this.state.data.like !== nextState.like;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var like = void 0;
	
	      if (this.toggle === 'inactive') {
	        this.toggle = 'active';
	        like = true;
	      } else if (this.toggle === 'active') {
	        this.toggle = 'inactive';
	        like = false;
	      }
	      // makes the post and sets data to re-render (setState)
	      (0, _apiData.ajaxPost)(_settings.API + this.props.lang + '/api/' + this.props.restSlug + '/items/' + this.props.catSlug.split("-").pop() + '/' + this.props.itemSlug.split("-").pop() + '/like/', { like: like }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'recommend-box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'recommend-text' },
	          this.props.itemType === 'food' ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'recommend_title' },
	              function (message) {
	                return _react2.default.createElement(
	                  'h4',
	                  null,
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'recommend-total', values: { total: String(this.state.data.like) } })
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'recommend_title_drink' },
	              function (message) {
	                return _react2.default.createElement(
	                  'h4',
	                  null,
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'recommend-total_drink', values: { total: String(this.state.data.like) } })
	          )
	        ),
	        _react2.default.createElement('button', { className: 'likes ' + this.toggle, onClick: this.handleClick })
	      );
	    }
	  }]);
	
	  return LikeBtn;
	}(_react2.default.Component);
	
	LikeBtn.propTypes = {
	  catSlug: _react.PropTypes.string,
	  itemSlug: _react.PropTypes.string,
	  lang: _react.PropTypes.string,
	  likes: _react.PropTypes.number,
	  restSlug: _react.PropTypes.string
	};
	exports.default = LikeBtn;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logo = function (_React$PureComponent) {
	  _inherits(Logo, _React$PureComponent);
	
	  function Logo() {
	    _classCallCheck(this, Logo);
	
	    return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
	  }
	
	  _createClass(Logo, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "logo-wrapper" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          this.props.name
	        ),
	        _react2.default.createElement(
	          "h5",
	          null,
	          this.props.city,
	          ", ",
	          this.props.country
	        )
	      );
	    }
	  }]);
	
	  return Logo;
	}(_react2.default.PureComponent);
	
	Logo.propTypes = {
	  city: _react.PropTypes.string,
	  country: _react.PropTypes.string,
	  name: _react.PropTypes.string
	};
	exports.default = Logo;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(4);
	
	var _MenuItem = __webpack_require__(115);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menus = function (_React$Component) {
	  _inherits(Menus, _React$Component);
	
	  function Menus(props) {
	    _classCallCheck(this, Menus);
	
	    var _this = _possibleConstructorReturn(this, (Menus.__proto__ || Object.getPrototypeOf(Menus)).call(this, props));
	
	    _this.state = {
	      data: [],
	      menu_width: 0
	    };
	
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    return _this;
	  }
	
	  _createClass(Menus, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.lang = this.props.match.params.lang;
	      this.restaurant = this.props.match.params.restaurant;
	
	      (0, _apiData.ajaxGet)(_settings.API + this.lang + '/api/' + this.restaurant + '/items/category/', this);
	
	      window.addEventListener("resize", this.updateDimensions);
	      window.addEventListener("load", this.updateDimensions);
	      this.updateDimensions();
	
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(_react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'nav_menu' },
	        function (message) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            message
	          );
	        }
	      ), "menu", false, '');
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions);
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var sideNavWidth = document.getElementById('sideNav').offsetWidth;
	      if (window.innerWidth > 1024) {
	        this.setState({ menu_width: window.innerWidth - sideNavWidth });
	      } else {
	        this.setState({ menu_width: window.innerWidth });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var width = {
	        width: this.state.menu_width
	      };
	
	      var listcats = this.state.data.map(function (item) {
	        return _react2.default.createElement(
	          'li',
	          { key: item.id },
	          _react2.default.createElement(_MenuItem2.default, { parent: item.parent,
	            restaurant: _this2.restaurant, lang: _this2.lang,
	            category: item.name, picture: item.photo,
	            name: item.name, slug: item.slug, pk: item.id,
	            template: item.template })
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'content-wrapper' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'menu-list', style: width },
	            listcats
	          )
	        )
	      );
	    }
	  }]);
	
	  return Menus;
	}(_react2.default.Component);
	
	Menus.propTypes = {
	  match: _react.PropTypes.object,
	  view_info: _react.PropTypes.func
	};
	exports.default = Menus;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(300);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(4);
	
	var _reactCookieBanner = __webpack_require__(298);
	
	var _reactCookieBanner2 = _interopRequireDefault(_reactCookieBanner);
	
	var _universalCookie = __webpack_require__(45);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _TopBar = __webpack_require__(113);
	
	var _TopBar2 = _interopRequireDefault(_TopBar);
	
	var _BottomBar = __webpack_require__(189);
	
	var _BottomBar2 = _interopRequireDefault(_BottomBar);
	
	__webpack_require__(236);
	
	var _ItemList = __webpack_require__(218);
	
	var _ItemList2 = _interopRequireDefault(_ItemList);
	
	var _RestaurantHome = __webpack_require__(211);
	
	var _RestaurantHome2 = _interopRequireDefault(_RestaurantHome);
	
	var _Menus = __webpack_require__(208);
	
	var _Menus2 = _interopRequireDefault(_Menus);
	
	var _EmptyPage = __webpack_require__(216);
	
	var _EmptyPage2 = _interopRequireDefault(_EmptyPage);
	
	var _EventDetail = __webpack_require__(204);
	
	var _EventDetail2 = _interopRequireDefault(_EventDetail);
	
	var _ShortList = __webpack_require__(220);
	
	var _ShortList2 = _interopRequireDefault(_ShortList);
	
	var _EventList = __webpack_require__(205);
	
	var _EventList2 = _interopRequireDefault(_EventList);
	
	var _Feedback = __webpack_require__(111);
	
	var _Feedback2 = _interopRequireDefault(_Feedback);
	
	var _ItemDetail = __webpack_require__(217);
	
	var _ItemDetail2 = _interopRequireDefault(_ItemDetail);
	
	var _About = __webpack_require__(203);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _RestaurantFeedback = __webpack_require__(210);
	
	var _RestaurantFeedback2 = _interopRequireDefault(_RestaurantFeedback);
	
	var _Terms = __webpack_require__(188);
	
	var _Terms2 = _interopRequireDefault(_Terms);
	
	var _AboutPickly = __webpack_require__(186);
	
	var _AboutPickly2 = _interopRequireDefault(_AboutPickly);
	
	var _Cookies = __webpack_require__(187);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	var _RestaurantError = __webpack_require__(69);
	
	var _RestaurantError2 = _interopRequireDefault(_RestaurantError);
	
	var _Error = __webpack_require__(53);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _PreLoader = __webpack_require__(37);
	
	var _PreLoader2 = _interopRequireDefault(_PreLoader);
	
	var _de = __webpack_require__(303);
	
	var _de2 = _interopRequireDefault(_de);
	
	var _pt = __webpack_require__(308);
	
	var _pt2 = _interopRequireDefault(_pt);
	
	var _es = __webpack_require__(304);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _nl = __webpack_require__(307);
	
	var _nl2 = _interopRequireDefault(_nl);
	
	var _fr = __webpack_require__(305);
	
	var _fr2 = _interopRequireDefault(_fr);
	
	var _it = __webpack_require__(306);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _enUs = __webpack_require__(274);
	
	var _enUs2 = _interopRequireDefault(_enUs);
	
	var _ptPt = __webpack_require__(279);
	
	var _ptPt2 = _interopRequireDefault(_ptPt);
	
	var _esEs = __webpack_require__(275);
	
	var _esEs2 = _interopRequireDefault(_esEs);
	
	var _frFr = __webpack_require__(276);
	
	var _frFr2 = _interopRequireDefault(_frFr);
	
	var _deDe = __webpack_require__(273);
	
	var _deDe2 = _interopRequireDefault(_deDe);
	
	var _nlNl = __webpack_require__(278);
	
	var _nlNl2 = _interopRequireDefault(_nlNl);
	
	var _itIt = __webpack_require__(277);
	
	var _itIt2 = _interopRequireDefault(_itIt);
	
	var _WineFilterList = __webpack_require__(222);
	
	var _WineFilterList2 = _interopRequireDefault(_WineFilterList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	(0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_pt2.default), _toConsumableArray(_es2.default), _toConsumableArray(_fr2.default), _toConsumableArray(_de2.default), _toConsumableArray(_nl2.default), _toConsumableArray(_it2.default)));
	
	var view_cookies = new _universalCookie2.default();
	
	var Restaurant = function (_React$Component) {
	  _inherits(Restaurant, _React$Component);
	
	  function Restaurant(props) {
	    _classCallCheck(this, Restaurant);
	
	    var _this = _possibleConstructorReturn(this, (Restaurant.__proto__ || Object.getPrototypeOf(Restaurant)).call(this, props));
	
	    _this.setInfo = function (title, view, back, view_toggle) {
	      if (_this.state.title !== title || _this.state.view !== view || _this.state.back !== back) {
	        if (view_toggle === 'default') {
	          if (view_cookies.get('list_view') === undefined) {
	            _this.setState({ title: title, view: view, back_btn: back, view_toggle: _this.state.data.default_list_view });
	          } else {
	            _this.setState({ title: title, view: view, back_btn: back, view_toggle: view_cookies.get('list_view') });
	          }
	        } else {
	          _this.setState({ title: title, view: view, back_btn: back, view_toggle: view_toggle });
	        }
	      }
	    };
	
	    _this.redirect = true;
	    _this.lang = "";
	
	    _this.state = {
	      data: {
	        introOptions: [],
	        status: '',
	        default_list_view: '',
	        simple_theme: false,
	        background: '',
	        button1_title: '',
	        button1_link: '',
	        button2_title: '',
	        button2_link: '',
	        button3_title: '',
	        button3_link: ''
	      },
	      social: {},
	      languages: [],
	      mode: '',
	      view: 'home',
	      title: '',
	      back_btn: false,
	      view_toggle: '',
	      favsTotal: null
	    };
	
	    _this.handleViewSort = _this.handleViewSort.bind(_this);
	    _this.refreshFav = _this.refreshFav.bind(_this);
	    return _this;
	  }
	
	  _createClass(Restaurant, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.rest_slug = this.props.match.params.restaurant;
	
	      // check if url have language parameter if not redirect to default language url
	      if (this.rest_slug && this.props.match.params.lang.length === 2) {
	        // pathname without language
	        this.pathname = this.props.location.pathname.substring(4);
	        this.lang = this.props.match.params.lang;
	
	        // get languages available for this restaurant
	        (0, _apiData.ajaxGet)(_settings.API + 'api/restaurant/' + this.rest_slug + '/languages/', this);
	      } else {
	        this.pathname = this.props.location.pathname;
	        this.rest_slug = this.props.match.params.lang;
	        this.lang = navigator.languages.length > 0 ? navigator.languages[0] : navigator.language || navigator.userLanguage;
	        this.lang = this.lang.substring(0, 2);
	        this.props.history.push('/' + this.lang + this.pathname);
	
	        // get languages available for this restaurant
	        (0, _apiData.ajaxGet)(_settings.API + 'api/restaurant/' + this.rest_slug + '/languages/', this);
	
	        //view_cookies.set('list_view', this.state.data.default_list_view, {path: '/', maxAge: 1300});
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // run after receive the language api call on component didMount
	      if (this.redirect) {
	        this.checkRestaurantLanguage();
	      }
	      if (this.lang !== this.props.match.params.lang) {
	        this.lang = this.props.match.params.lang;
	        this.getData(this.lang);
	      }
	      /*
	          if (cookies.get('list_view') !== undefined) {
	      
	          }*/
	    }
	  }, {
	    key: 'cookieMessageTrans',
	    value: function cookieMessageTrans() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'p',
	        { className: 'terms-notice' },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'cookie-notice' },
	          function (message) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              message
	            );
	          }
	        ),
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'cookie-link' },
	          function (message) {
	            return _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/' + _this2.lang + '/' + _this2.rest_slug + '/cookies-usage' },
	              message
	            );
	          }
	        )
	      );
	    }
	  }, {
	    key: 'handleViewSort',
	    value: function handleViewSort(list_view) {
	      this.setState({ view_toggle: list_view });
	      view_cookies.set('list_view', list_view, { path: this.rest_slug + '/', maxAge: 1300 });
	    }
	
	    // check language for ReactINTL double check the default language
	
	  }, {
	    key: 'checkLanguage',
	    value: function checkLanguage() {
	      var languages = ['en', 'pt', 'es', 'fr', 'de', 'nl', 'it'];
	      var currentLangIndex = languages.indexOf(this.props.match.params.lang);
	      var locales = [['en', _enUs2.default], ['pt', _ptPt2.default], ['es', _esEs2.default], ['fr', _frFr2.default], ['de', _deDe2.default], ['nl', _nlNl2.default], ['it', _itIt2.default]];
	
	      // check if language in url is available for the app, if not render default language present in index 0 of array
	      if (currentLangIndex !== -1) {
	        return { locale: locales[currentLangIndex][0], messages: locales[currentLangIndex][1] };
	      }
	      return { locale: locales[0][0].toUpperCase(), messages: locales[0][1] };
	    }
	
	    // Check if the language in url are available for Restaurant
	
	  }, {
	    key: 'checkRestaurantLanguage',
	    value: function checkRestaurantLanguage() {
	      var lang = "";
	
	      // check if already received the api data
	      if (this.state.data.languages) {
	        // check if the language selected is in the available languages of restaurant
	        for (var i = 0, l = this.state.data.languages.length; i < l; i++) {
	          if (this.lang === this.state.data.languages[i].code) {
	            lang = this.lang;
	            break;
	          }
	        }
	        //re render new data based on language
	        this.getData(lang);
	      }
	    }
	
	    // Get Restaurant data From API
	
	  }, {
	    key: 'getData',
	    value: function getData(language) {
	      // turn off pre loader
	      this.redirect = false;
	
	      // re render info about restaurant based on language, if there' no language, than render with default language
	      if (language) {
	        (0, _apiData.ajaxGet)(_settings.API + language + '/api/restaurant/' + this.rest_slug + '/', this);
	      } else {
	        this.props.history.push('/' + this.state.data.default_language.code + this.pathname);
	        (0, _apiData.ajaxGet)(_settings.API + this.state.data.default_language.code + '/api/restaurant/' + this.rest_slug + '/', this);
	      }
	    }
	  }, {
	    key: 'refreshFav',
	    value: function refreshFav(total) {
	      this.setState({ favsTotal: total });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // CHECKING FOR ERRORS FROM THE API
	      var wine_url = '/empty';
	
	      if (this.state.data.wine_slug !== null) {
	        wine_url = '/wine/' + this.state.data.wine_slug;
	      }
	
	      if (this.redirect) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_PreLoader2.default, { loading: 'loading' })
	        );
	      }
	
	      if (this.state.data.status !== "error") {
	        return _react2.default.createElement(
	          _reactIntl.IntlProvider,
	          { locale: this.checkLanguage().locale, messages: this.checkLanguage().messages },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { title: this.state.data.name + ' @ Pickly', meta: [{ name: "description", content: "" }] }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_TopBar2.default, _extends({ restaurant: this.state.data.slug, name: this.state.data.name,
	                city: this.state.data.city, country: this.state.data.country, lang: this.props.match.params.lang,
	                social: this.state.data.social, view: this.state.view, languages: this.state.data.languages,
	                title: this.state.title, wine_slug: wine_url, 'package': this.state.data.package,
	                back_btn: this.state.back_btn, viewToggle: this.state.view_toggle, viewSort: this.handleViewSort,
	                history: this.props.history }, this.props.location, {
	                match: this.props.match })),
	              _react2.default.createElement(_reactCookieBanner2.default, { disableStyle: true,
	                message: this.cookieMessageTrans(),
	                onAccept: function onAccept() {},
	                cookie: 'user-has-accepted-cookies',
	                buttonMessage: 'Ok'
	              }),
	              _react2.default.createElement(
	                _reactRouterDom.Switch,
	                null,
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant',
	                  render: function render() {
	                    return _react2.default.createElement(_RestaurantHome2.default, {
	                      categories: _this3.state.data.categories,
	                      city: _this3.state.data.city,
	                      country: _this3.state.data.country,
	                      history: _this3.props.history,
	                      intro_options: _this3.state.data.intro_options,
	                      match: _this3.props.match,
	                      name: _this3.state.data.name,
	                      'package': _this3.state.data.package,
	                      slug: _this3.state.data.slug,
	                      view_info: _this3.setInfo,
	                      logo: _this3.state.data.logo,
	                      simpleTheme: _this3.state.data.simple_theme,
	                      wineSlug: wine_url,
	                      backgroundImage: _this3.state.data.background,
	                      button1Title: _this3.state.data.button1_title,
	                      button1Link: _this3.state.data.button1_link,
	                      button2Title: _this3.state.data.button2_title,
	                      button2Link: _this3.state.data.button2_link,
	                      button3Title: _this3.state.data.button3_title,
	                      button3Link: _this3.state.data.button3_link
	
	                    });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/empty',
	                  render: function render() {
	                    return _react2.default.createElement(_EmptyPage2.default, { view_info: _this3.setInfo });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/terms',
	                  render: function render() {
	                    return _react2.default.createElement(_Terms2.default, { view_info: _this3.setInfo, match: _this3.props.match });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/pickly',
	                  render: function render() {
	                    return _react2.default.createElement(_AboutPickly2.default, { view_info: _this3.setInfo, match: _this3.props.match,
	                      slug: _this3.state.data.slug });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/cookies-usage',
	                  render: function render() {
	                    return _react2.default.createElement(_Cookies2.default, { view_info: _this3.setInfo, match: _this3.props.match });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/menu',
	                  render: function render() {
	                    return _react2.default.createElement(_Menus2.default, { view_info: _this3.setInfo, match: _this3.props.match });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/about',
	                  render: function render() {
	                    return _react2.default.createElement(_About2.default, { view_info: _this3.setInfo, match: _this3.props.match });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/events',
	                  render: function render() {
	                    return _react2.default.createElement(_EventList2.default, { view_info: _this3.setInfo, history: _this3.props.history,
	                      match: _this3.props.match });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/events/:event',
	                  render: function render(props) {
	                    return _react2.default.createElement(_EventDetail2.default, { view_info: _this3.setInfo,
	                      history: _this3.props.history,
	                      match: _this3.props.match,
	                      slug: props.match.params.event });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/feedback', component: _Feedback2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/restaurant-feedback',
	                  render: function render() {
	                    return _react2.default.createElement(_RestaurantFeedback2.default, { view_info: _this3.setInfo, match: _this3.props.match });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/items/featured',
	                  render: function render() {
	                    return _react2.default.createElement(_ItemList2.default, { view_info: _this3.setInfo,
	                      viewToggle: _this3.state.view_toggle,
	                      category: _this3.state.data.category,
	                      history: _this3.props.history,
	                      location: _this3.props.location,
	                      match: _this3.props.match,
	                      wine_slug: _this3.state.data.wine_slug,
	                      favsTotal: _this3.refreshFav });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/items/shortlist',
	                  render: function render() {
	                    return _react2.default.createElement(_ShortList2.default, { view_info: _this3.setInfo,
	                      viewToggle: _this3.state.view_toggle,
	                      match: _this3.props.match,
	                      wine_slug: _this3.state.data.wine_slug,
	                      history: _this3.props.history,
	                      favsTotal: _this3.refreshFav });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/items/:category',
	                  render: function render(props) {
	                    return _react2.default.createElement(_ItemList2.default, { view_info: _this3.setInfo,
	                      category: props.match.params.category,
	                      viewToggle: _this3.state.view_toggle,
	                      history: _this3.props.history,
	                      location: _this3.props.location,
	                      match: _this3.props.match,
	                      wine_slug: _this3.state.data.wine_slug,
	                      favsTotal: _this3.refreshFav });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/items/filter/:filter',
	                  render: function render(props) {
	                    return _react2.default.createElement(_ItemList2.default, { view_info: _this3.setInfo,
	                      filter: props.match.params.filter,
	                      viewToggle: _this3.state.view_toggle,
	                      history: _this3.props.history,
	                      location: _this3.props.location,
	                      match: _this3.props.match,
	                      wine_slug: _this3.state.data.wine_slug,
	                      favsTotal: _this3.refreshFav });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/items/:category/:item',
	                  render: function render(props) {
	                    return _react2.default.createElement(_ItemDetail2.default, { view_info: _this3.setInfo,
	                      item: props.match.params.item,
	                      category: props.match.params.category,
	                      history: _this3.props.history,
	                      match: _this3.props.match,
	                      'package': _this3.state.data.package,
	                      wine_slug: _this3.state.data.wine_slug,
	                      favsTotal: _this3.refreshFav });
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/wine/:category/',
	                  render: function render(props) {
	                    return _react2.default.createElement(_WineFilterList2.default, _extends({}, props, { view_info: _this3.setInfo }));
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:lang/:restaurant/wine/:category/:winetype',
	                  render: function render(props) {
	                    return _react2.default.createElement(_WineFilterList2.default, _extends({}, props, { view_info: _this3.setInfo }));
	                  }
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, { render: function render() {
	                    return _react2.default.createElement(_RestaurantError2.default, { lang: _this3.props.match.lang,
	                      next: _this3.props.next,
	                      restaurant: _this3.state.data.name,
	                      view: '',
	                      view_info: _this3.setInfo });
	                  }, status: 404 })
	              ),
	              _react2.default.createElement(_BottomBar2.default, { restaurant: this.state.data.slug,
	                lang: this.props.match.params.lang,
	                view: this.state.view,
	                wine_slug: wine_url,
	                'package': this.state.data.package,
	                favsTotal: this.state.favsTotal })
	            )
	          )
	        );
	      }
	      //API GAVE ME AN ERROR :(
	      else {
	          return _react2.default.createElement(_Error2.default, { restaurant: '', lang: this.lang });
	        }
	    }
	  }]);
	
	  return Restaurant;
	}(_react2.default.Component);
	
	Restaurant.propTypes = {
	  history: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  match: _react.PropTypes.object
	};
	exports.default = Restaurant;
	/*
	
	if (process.env.NODE_ENV !== 'production') {
	  const {whyDidYouUpdate} = require('why-did-you-update');
	  whyDidYouUpdate(React, {exclude: /^FormattedMessage|Link|Route|Router|IntlProvider|FormattedDate/});
	}

	*/

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(4);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _FeedbackRadios = __webpack_require__(112);
	
	var _FeedbackRadios2 = _interopRequireDefault(_FeedbackRadios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RestaurantFeedback = function (_React$Component) {
	  _inherits(RestaurantFeedback, _React$Component);
	
	  function RestaurantFeedback(props) {
	    _classCallCheck(this, RestaurantFeedback);
	
	    var _this = _possibleConstructorReturn(this, (RestaurantFeedback.__proto__ || Object.getPrototypeOf(RestaurantFeedback)).call(this, props));
	
	    _this.current_stage = 0;
	
	    _this.state = {
	      back: "",
	      choice: null,
	      presentation: null,
	      tasty: null,
	      speed: null,
	      waiters: null,
	      overall: null,
	      deco: null,
	      price: null,
	      recommend: null,
	      error: true,
	      comments: '',
	      sent: '',
	      stage: 0
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.moveNext = _this.moveNext.bind(_this);
	    _this.movePrev = _this.movePrev.bind(_this);
	    return _this;
	  }
	
	  _createClass(RestaurantFeedback, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(
	      //title
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'nav-feedback' },
	        function (message) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            message
	          );
	        }
	      ),
	      //view
	      'feedback',
	      //back button or not
	      false);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return this.state.stage !== 0;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var target = event.target;
	      var value = target.value;
	      var name = target.name;
	
	      if (name === 'comments') {
	        this.setState(_defineProperty({}, name, value));
	      } else {
	        this.setState(_defineProperty({}, name, Number(value)));
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      (0, _apiData.ajaxPost)(_settings.API + this.props.match.params.lang + '/api/restaurant/' + this.props.match.params.restaurant + '/feedback/', { 'choice': this.state.choice, 'presentation': this.state.presentation, 'tasty': this.state.tasty,
	        'speed': this.state.speed, 'waiters': this.state.waiters, 'overall': this.state.overall,
	        'deco': this.state.deco, 'price': this.state.price, 'recommend': this.state.recommend,
	        'comments': this.state.comments }, this);
	
	      this.setState({ sent: 'sent' });
	      event.preventDefault();
	    }
	  }, {
	    key: 'moveNext',
	    value: function moveNext() {
	      this.current_stage = this.state.stage;
	      this.current_stage++;
	
	      this.setState({ stage: this.current_stage });
	      document.getElementById("tieredForm").className += " stage-" + this.current_stage;
	    }
	  }, {
	    key: 'movePrev',
	    value: function movePrev() {
	      this.current_stage = this.state.stage;
	
	      if (this.current_stage > 0) {
	        document.getElementById("tieredForm").classList.remove("stage-" + this.current_stage);
	        this.current_stage--;
	        this.setState({ stage: this.current_stage });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'feedback-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: "feedback-form-wrapper " + this.state.sent },
	          _react2.default.createElement(
	            'form',
	            { className: 'restaurant-feedback feedback-form', onSubmit: this.handleSubmit },
	            _react2.default.createElement(
	              'div',
	              { id: 'tieredForm' },
	              _react2.default.createElement(
	                'fieldset',
	                { className: 'form-step stage-0' },
	                _react2.default.createElement('img', { src: __webpack_require__(57) }),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'restaurant-feedback-title' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'h2',
	                      { className: 'feedback-title' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'restaurant-feedback-intro' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'intro-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  'footer',
	                  null,
	                  _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    { id: 'restaurant-feedback-intro-btn' },
	                    function (message) {
	                      return _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'btn feedback-btn', onClick: _this2.moveNext },
	                        message
	                      );
	                    }
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'fieldset',
	                { className: 'form-step' },
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'food-feedback-title' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'h2',
	                      { className: 'feedback-title' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'food-feedback-intro' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'intro-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'choice-question' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'question-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(_FeedbackRadios2.default, { name: 'choice' }),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'presentation-question' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'question-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(_FeedbackRadios2.default, { name: 'presentation' }),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'tasty-question' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'question-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(_FeedbackRadios2.default, { name: 'tasty' }),
	                _react2.default.createElement(
	                  'footer',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'stage-meter stage-' + this.state.stage },
	                    this.state.stage,
	                    '/3'
	                  ),
	                  _react2.default.createElement('a', { href: '#', type: 'button', className: 'slick-arrow slick-prev', onClick: this.movePrev }),
	                  _react2.default.createElement('a', { href: '#', type: 'button', className: 'slick-arrow slick-next', onClick: this.moveNext })
	                )
	              ),
	              _react2.default.createElement(
	                'fieldset',
	                { className: 'form-step' },
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'service-feedback-title' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'h2',
	                      { className: 'feedback-title' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'food-feedback-intro' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'intro-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'speed-question' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'question-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(_FeedbackRadios2.default, { name: 'speed' }),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'waiters-question' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'question-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(_FeedbackRadios2.default, { name: 'waiters' }),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'overall-question' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'question-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(_FeedbackRadios2.default, { name: 'overall' }),
	                _react2.default.createElement(
	                  'footer',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'stage-meter stage-' + this.state.stage },
	                    this.state.stage,
	                    '/3'
	                  ),
	                  _react2.default.createElement('a', { href: '#', type: 'button', className: 'slick-arrow slick-prev', onClick: this.movePrev }),
	                  _react2.default.createElement('a', { href: '#', type: 'button', className: 'slick-arrow slick-next', onClick: this.moveNext })
	                )
	              ),
	              _react2.default.createElement(
	                'fieldset',
	                { className: 'form-step' },
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'global-feedback-title' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'h2',
	                      { className: 'feedback-title' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'food-feedback-intro' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'intro-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'deco-question' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'question-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(_FeedbackRadios2.default, { name: 'deco' }),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'price-question' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'question-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(_FeedbackRadios2.default, { name: 'price' }),
	                _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  { id: 'recommend-question' },
	                  function (message) {
	                    return _react2.default.createElement(
	                      'p',
	                      { className: 'question-text' },
	                      message
	                    );
	                  }
	                ),
	                _react2.default.createElement(_FeedbackRadios2.default, { name: 'recommend' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'comments-area' },
	                  _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    { id: 'comments-question' },
	                    function (message) {
	                      return _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'comments' },
	                        message
	                      );
	                    }
	                  ),
	                  _react2.default.createElement('textarea', { name: 'comments', id: 'comments', value: this.state.comments, onChange: this.handleChange })
	                ),
	                _react2.default.createElement(
	                  'footer',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'stage-meter stage-' + this.state.stage },
	                    this.state.stage,
	                    '/3'
	                  ),
	                  _react2.default.createElement('button', { type: 'button', className: 'slick-arrow slick-prev', onClick: this.movePrev }),
	                  _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    { id: 'feedback-submit' },
	                    function (message) {
	                      return _react2.default.createElement('input', { className: 'btn', type: 'submit', value: message });
	                    }
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'thanks ' + this.state.sent },
	          _react2.default.createElement('img', { src: __webpack_require__(57) }),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'feedback-thanks-title' },
	            function (message) {
	              return _react2.default.createElement(
	                'h3',
	                null,
	                message
	              );
	            }
	          ),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'feedback-thanks-text' },
	            function (message) {
	              return _react2.default.createElement(
	                'p',
	                null,
	                message
	              );
	            }
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'thanks-btn btn',
	              to: '/' + this.props.match.params.lang + '/' + this.props.match.params.restaurant + '/' },
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'nav_home' },
	              function (message) {
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  message
	                );
	              }
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RestaurantFeedback;
	}(_react2.default.Component);
	
	RestaurantFeedback.propTypes = {
	  match: _react.PropTypes.object,
	  view_info: _react.PropTypes.func
	};
	exports.default = RestaurantFeedback;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactSlick = __webpack_require__(337);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import HomeForm from './HomeForm';
	
	
	var RestaurantHome = function (_React$Component) {
	  _inherits(RestaurantHome, _React$Component);
	
	  function RestaurantHome(props) {
	    _classCallCheck(this, RestaurantHome);
	
	    var _this = _possibleConstructorReturn(this, (RestaurantHome.__proto__ || Object.getPrototypeOf(RestaurantHome)).call(this, props));
	
	    _this.settings = {
	      dots: true,
	      slidesToShow: 3,
	      slidesToScroll: 1,
	      autoplay: true,
	      autoplaySpeed: 5000,
	      draggable: false,
	      infinite: true,
	      responsive: [{
	        breakpoint: 900,
	        settings: {
	          slidesToShow: 1,
	          slidesToScroll: 1,
	          dots: false
	
	        }
	      }, {
	        breakpoint: 1024,
	        settings: {
	          dots: false
	        }
	      }]
	    };
	
	    return _this;
	  }
	
	  _createClass(RestaurantHome, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info('', "home", false, '');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // Slick slider settings
	      var listImages = {};
	
	      if (this.props.categories && this.props.categories.length !== 0) {
	        // FOUND THE RESULTS, MAPPING THEM HERE AND RENDERING FURTHER BELOW
	        listImages = this.props.categories.map(function (item) {
	          var url = '/' + _this2.props.match.params.lang + '/' + _this2.props.slug + '/items/' + item.slug + '-' + item.id;
	          if (item.template === 'wine') {
	            url = '/' + _this2.props.match.params.lang + '/' + _this2.props.slug + '/wine/' + item.slug + '-' + item.id;
	          }
	          return _react2.default.createElement(
	            _reactRouterDom.Link,
	            { key: 'categories-' + item.id, to: url },
	            _react2.default.createElement(
	              'div',
	              { className: 'caption' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                item.name
	              )
	            ),
	            _react2.default.createElement('img', { src: item.photo, alt: item.name })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'home' },
	        _react2.default.createElement(
	          'div',
	          { className: 'home-wrapper', style: this.props.simpleTheme ? { background: 'url(' + this.props.backgroundImage + ') no-repeat center', boxShadow: 'inset 0 0 0 2000px rgba(0, 0, 0, 0.3)', backgroundSize: 'cover' } : null },
	          !this.props.simpleTheme && this.props.categories && this.props.categories.length !== 0 ? _react2.default.createElement(
	            'div',
	            { className: 'slider-container category-slider' },
	            _react2.default.createElement(
	              _reactSlick2.default,
	              this.settings,
	              listImages
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: this.props.simpleTheme ? "start-simple" : "start" },
	            _react2.default.createElement('img', { src: this.props.logo }),
	            _react2.default.createElement(
	              'h1',
	              null,
	              this.props.name
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'location' },
	              this.props.city,
	              ', ',
	              this.props.country
	            )
	          ),
	          this.props.simpleTheme ? _react2.default.createElement(
	            'div',
	            { className: 'start-buttons' },
	            this.props.button1Link ? _react2.default.createElement(
	              'a',
	              { className: 'primary-home-btn home-btn btn',
	                href: this.props.button1Link },
	              this.props.button1Title || _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_menu' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            ) : _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'primary-home-btn home-btn btn',
	                to: '/' + this.props.match.params.lang + '/' + this.props.match.params.restaurant + '/menu' },
	              this.props.button1Title || _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_menu' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            ),
	            this.props.button2Link ? _react2.default.createElement(
	              'a',
	              { className: 'secondary-home-btn home-btn btn',
	                href: this.props.button2Link },
	              this.props.button2Title || _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_wines' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            ) : _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'secondary-home-btn home-btn btn',
	                to: '/' + this.props.match.params.lang + '/' + this.props.match.params.restaurant + this.props.wineSlug },
	              this.props.button2Title || _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_wines' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            ),
	            this.props.button3Link ? _react2.default.createElement(
	              'a',
	              { className: 'tertiary-home-btn home-btn btn',
	                href: this.props.button3Link },
	              this.props.button3Title || _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_suggestions' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            ) : _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'tertiary-home-btn home-btn btn',
	                to: '/' + this.props.match.params.lang + '/' + this.props.match.params.restaurant + '/items/featured/' },
	              this.props.button3Title || _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'nav_suggestions' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    message
	                  );
	                }
	              )
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return RestaurantHome;
	}(_react2.default.Component);
	
	RestaurantHome.propTypes = {
	  categories: _react.PropTypes.array,
	  city: _react.PropTypes.string,
	  country: _react.PropTypes.string,
	  history: _react.PropTypes.object,
	  intro_options: _react.PropTypes.array,
	  match: _react.PropTypes.object,
	  name: _react.PropTypes.string,
	  package: _react.PropTypes.number,
	  slug: _react.PropTypes.string,
	  view_info: _react.PropTypes.func,
	  logo: _react.PropTypes.string,
	  simpleTheme: _react.PropTypes.bool,
	  wineSlug: _react.PropTypes.string,
	  backgroundImage: _react.PropTypes.string,
	  button1Title: _react.PropTypes.string,
	  button1Link: _react.PropTypes.string,
	  button2Title: _react.PropTypes.string,
	  button2Link: _react.PropTypes.string,
	  button3Title: _react.PropTypes.string,
	  button3Link: _react.PropTypes.string
	};
	exports.default = RestaurantHome;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SmallEventCard = function (_React$Component) {
	  _inherits(SmallEventCard, _React$Component);
	
	  function SmallEventCard() {
	    _classCallCheck(this, SmallEventCard);
	
	    return _possibleConstructorReturn(this, (SmallEventCard.__proto__ || Object.getPrototypeOf(SmallEventCard)).apply(this, arguments));
	  }
	
	  _createClass(SmallEventCard, [{
	    key: 'render',
	
	    /*
	      constructor(props) {
	        super(props);
	        this.state = {
	          description: ''
	        };
	      }
	    */
	
	    /*  componentDidUpdate(prevProps) {
	        if(prevProps.description !== this.state.description){
	          this.setState({description: this.props.description});
	        }
	      }*/
	
	    /*  checkDescription() {
	        var desc = this.state.description;
	         //if there is an item description, truncate it to 7 words
	        if(desc) {
	          desc = desc.split(" ").splice(0,7).join(" ");
	          return  (<p className="description">{desc}</p>)
	        }
	        else if(this.props.wineType) {
	          return (<p className="description">{this.props.wineType}</p>)
	        }
	        else {
	          return null
	        }
	      }*/
	
	    value: function render() {
	
	      return _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/' + this.props.lang + '/' + this.props.rest + '/items/' + this.props.cat + '/' + this.props.slug + '-' + this.props.pk + '/',
	          className: 'small-card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'small-thumb' },
	          _react2.default.createElement('img', { src: this.props.photo })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item-content' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'small-item-title' },
	            this.props.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'start-date price' },
	            _react2.default.createElement(_reactIntl.FormattedDate, { value: new Date(this.props.start), year: 'numeric',
	              month: 'numeric', day: 'numeric', weekday: 'long' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SmallEventCard;
	}(_react2.default.Component);
	
	SmallEventCard.propTypes = {
	  cat: _react.PropTypes.string,
	  lang: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  photo: _react.PropTypes.string,
	  pk: _react.PropTypes.number,
	  rest: _react.PropTypes.string,
	  slug: _react.PropTypes.string,
	  start: _react.PropTypes.string
	};
	exports.default = SmallEventCard;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	var _StaticSmallCard = __webpack_require__(221);
	
	var _StaticSmallCard2 = _interopRequireDefault(_StaticSmallCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Accordeon = function (_React$Component) {
	  _inherits(Accordeon, _React$Component);
	
	  function Accordeon(props) {
	    _classCallCheck(this, Accordeon);
	
	    var _this = _possibleConstructorReturn(this, (Accordeon.__proto__ || Object.getPrototypeOf(Accordeon)).call(this, props));
	
	    _this.state = {
	      toggle: 'inactive'
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Accordeon, [{
	    key: 'handleClick',
	    value: function handleClick() {
	
	      if (this.state.toggle === 'inactive') {
	        this.setState({ toggle: 'expanded' });
	      } else if (this.state.toggle === 'expanded') {
	        this.setState({ toggle: 'inactive' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var listRelated = this.props.related.map(function (item) {
	        return _react2.default.createElement(_StaticSmallCard2.default, { key: 'side-' + item.id, name: item.title, price: item.price,
	          description: item.description, photo: item.photo });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'accordeon', className: 'accordeon ' + this.state.toggle },
	        _react2.default.createElement(
	          'div',
	          { className: 'accordeon-title', onClick: this.handleClick },
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'suggested_extras' },
	            function (message) {
	              return _react2.default.createElement(
	                'span',
	                null,
	                message
	              );
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'accordeon-items' },
	          listRelated
	        )
	      );
	    }
	  }]);
	
	  return Accordeon;
	}(_react2.default.Component);
	
	Accordeon.propTypes = {
	  related: _react.PropTypes.object
	};
	exports.default = Accordeon;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CatCta = function (_React$PureComponent) {
	  _inherits(CatCta, _React$PureComponent);
	
	  function CatCta() {
	    _classCallCheck(this, CatCta);
	
	    return _possibleConstructorReturn(this, (CatCta.__proto__ || Object.getPrototypeOf(CatCta)).apply(this, arguments));
	  }
	
	  _createClass(CatCta, [{
	    key: 'render',
	    value: function render() {
	      var isEmpty = __webpack_require__(292);
	      return _react2.default.createElement(
	        'div',
	        { className: 'cta-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cta-thumb' },
	          _react2.default.createElement('img', { src: this.props.cta.image, alt: this.props.cta.name })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cta-item-info' },
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'cta_title' },
	            function (message) {
	              return _react2.default.createElement(
	                'h5',
	                { className: 'cta-item-title' },
	                message
	              );
	            }
	          ),
	          !isEmpty(this.props.cta) ? _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'cta-btn', to: '/' + this.props.lang + '/' + this.props.restSlug + '/items/' + this.props.cta.slug + '-' + this.props.cta.id + '/' },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.props.cta.name
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return CatCta;
	}(_react2.default.PureComponent);
	
	CatCta.propTypes = {
	  cta: _react.PropTypes.object,
	  lang: _react.PropTypes.string,
	  restSlug: _react.PropTypes.string
	};
	exports.default = CatCta;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmptyFav = function (_React$PureComponent) {
	  _inherits(EmptyFav, _React$PureComponent);
	
	  function EmptyFav() {
	    _classCallCheck(this, EmptyFav);
	
	    return _possibleConstructorReturn(this, (EmptyFav.__proto__ || Object.getPrototypeOf(EmptyFav)).apply(this, arguments));
	  }
	
	  _createClass(EmptyFav, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'empty list-item' },
	        _react2.default.createElement('img', { src: __webpack_require__(252) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'item-info' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'item-title empty-title' },
	            'myPick'
	          ),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'mypick-text' },
	            function (message) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'empty-text' },
	                message
	              );
	            }
	          )
	        )
	      );
	    }
	  }]);
	
	  return EmptyFav;
	}(_react2.default.PureComponent);
	
	exports.default = EmptyFav;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Empty = __webpack_require__(55);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmptyPage = function (_React$PureComponent) {
	  _inherits(EmptyPage, _React$PureComponent);
	
	  function EmptyPage() {
	    _classCallCheck(this, EmptyPage);
	
	    return _possibleConstructorReturn(this, (EmptyPage.__proto__ || Object.getPrototypeOf(EmptyPage)).apply(this, arguments));
	  }
	
	  _createClass(EmptyPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(
	      //title
	      '',
	      //view
	      'list',
	      //back button or not
	      true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'content-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'item-list loaded' },
	          _react2.default.createElement(_Empty2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return EmptyPage;
	}(_react2.default.PureComponent);
	
	EmptyPage.propTypes = {
	  view_info: _react.PropTypes.func
	};
	exports.default = EmptyPage;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _ListItem = __webpack_require__(71);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _FavBtn = __webpack_require__(70);
	
	var _FavBtn2 = _interopRequireDefault(_FavBtn);
	
	var _CatCta = __webpack_require__(214);
	
	var _CatCta2 = _interopRequireDefault(_CatCta);
	
	var _SmallCard = __webpack_require__(116);
	
	var _SmallCard2 = _interopRequireDefault(_SmallCard);
	
	var _Accordeon = __webpack_require__(213);
	
	var _Accordeon2 = _interopRequireDefault(_Accordeon);
	
	var _Error = __webpack_require__(53);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _LikeBtn = __webpack_require__(206);
	
	var _LikeBtn2 = _interopRequireDefault(_LikeBtn);
	
	var _PreLoader = __webpack_require__(37);
	
	var _PreLoader2 = _interopRequireDefault(_PreLoader);
	
	var _imagesLoadCheck = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemDetail = function (_React$Component) {
	  _inherits(ItemDetail, _React$Component);
	
	  function ItemDetail(props) {
	    _classCallCheck(this, ItemDetail);
	
	    var _this = _possibleConstructorReturn(this, (ItemDetail.__proto__ || Object.getPrototypeOf(ItemDetail)).call(this, props));
	
	    _this.state = {
	      data: {
	        gallery: [],
	        extras: [],
	        related_drink: [],
	        sugested_food: [],
	        alternative: [],
	        like: 0,
	        cta: {},
	        status: '',
	        unity: '',
	        diet: null
	      },
	      toggle: 'inactive',
	      loading: 'loading',
	      addthis: 'true',
	      detail_width: 0,
	      mode: (0, _settings.modeCheck)("mode"),
	      favToggle: false
	    };
	
	    _this.handleLoading = _this.handleLoading.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.favsTotal = _this.favsTotal.bind(_this);
	    return _this;
	  }
	
	  _createClass(ItemDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.lang = this.props.match.params.lang;
	      this.restId = this.props.match.params.restaurant;
	      this.catSlug = this.props.category;
	      this.itemSlug = this.props.item;
	
	      (0, _apiData.ajaxGet)(_settings.API + this.lang + '/api/' + this.restId + '/items/' + this.catSlug.split("-").pop() + '/' + this.itemSlug.split("-").pop() + '/', this);
	
	      window.addEventListener("resize", this.updateDimensions);
	      this.updateDimensions();
	
	      var detailTitle = _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'detail_title' },
	        function (message) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            message
	          );
	        }
	      );
	
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(detailTitle, 'detail', true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.match.params !== nextProps.match.params) {
	        var category = nextProps.category;
	        var item = nextProps.item;
	
	        (0, _apiData.ajaxGet)(_settings.API + this.lang + '/api/' + this.restId + '/items/' + category.split("-").pop() + '/' + item.split("-").pop() + '/', this);
	
	        this.setState({ addthis: 'true' });
	      }
	    }
	
	    //NEED THIS TO FORCE ADDTHIS TO LOAD
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevState) {
	      // eslint-disable-next-line
	      if (prevState.addthis !== this.state.addthis && typeof addthis.layers.refresh !== 'undefined') {
	        // eslint-disable-next-line
	        addthis.layers.refresh();
	      }
	      window.addEventListener("load", this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions);
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	
	      var sideNavWidth = document.getElementById('sideNav').offsetWidth;
	
	      if (window.innerWidth > 1024) {
	        this.setState({ detail_width: document.body.clientWidth - sideNavWidth });
	      } else {
	        this.setState({ detail_width: document.body.clientWidth });
	      }
	    }
	  }, {
	    key: 'typeCheck',
	    value: function typeCheck() {
	      var _this2 = this;
	
	      var listRelated = [];
	
	      if (this.state.data.item_type === 'food' && this.props.wine_slug) {
	        listRelated = this.state.data.related_drink.map(function (item) {
	          return _react2.default.createElement(_SmallCard2.default, { key: 'drink-match-' + item.id, name: item.title,
	            price: item.price,
	            description: item.description, photo: item.photo, lang: _this2.lang,
	            slug: item.slug, rest: _this2.restId, pk: item.id, cat: item.category,
	            wineType: item.wine_type });
	        });
	
	        listRelated.unshift(_react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { key: 'drinks-title', id: 'suggested_wines' },
	          function (message) {
	            return _react2.default.createElement(
	              'h6',
	              null,
	              message
	            );
	          }
	        ));
	
	        listRelated.push(_react2.default.createElement(
	          'div',
	          { className: 'link-all-area', key: 'drinks-link-all' },
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'drinks-link-all' },
	            function (message) {
	              return _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/' + _this2.lang + '/' + _this2.restId + '/items/' + _this2.props.wine_slug },
	                message
	              );
	            }
	          )
	        ));
	      } else {
	        listRelated = this.state.data.sugested_food && this.state.data.sugested_food.map(function (item) {
	          return _react2.default.createElement(_SmallCard2.default, { key: 'related-match-' + item.pk, name: item.title,
	            price: item.price,
	            description: item.description, photo: item.photo, lang: _this2.lang,
	            slug: item.slug, rest: _this2.restId, pk: item.pk, cat: item.category });
	        });
	
	        listRelated && listRelated.unshift(_react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { key: 'related-foods-title', id: 'related_dishes' },
	          function (message) {
	            return _react2.default.createElement(
	              'h6',
	              null,
	              message
	            );
	          }
	        ));
	      }
	      return { listRelated: listRelated };
	    }
	
	    /* DOES IT HAVE EXTRAS ? */
	
	  }, {
	    key: 'checkExtras',
	    value: function checkExtras() {
	      if (this.state.data.hasOwnProperty('extras') && this.state.data.extras.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'card' },
	          _react2.default.createElement(_Accordeon2.default, { related: this.state.data.extras })
	        );
	      }
	      return null;
	    }
	
	    /* DOES THE RELATED CTA CATEGORY EXIST? */
	
	  }, {
	    key: 'checkCta',
	    value: function checkCta() {
	      if (this.state.data.hasOwnProperty('cta') && this.state.data.cta && this.props.package === 1) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'divider-cta' },
	          _react2.default.createElement(_CatCta2.default, { lang: this.lang, restSlug: this.restId, cta: this.state.data.cta })
	        );
	      }
	      return null;
	    }
	
	    /* DOES IT HAVE RELATED ITEMS ? */
	
	    // todo smallcard should have the map inside we just pass the objects to map, key prefix lang and restid
	
	  }, {
	    key: 'checkAlternative',
	    value: function checkAlternative() {
	      var _this3 = this;
	
	      if (this.state.data.hasOwnProperty('alternative') && this.state.data.alternative.length > 0) {
	        var listAlternative = this.state.data.alternative.map(function (item) {
	          return _react2.default.createElement(_SmallCard2.default, { key: 'related-match-' + item.pk, name: item.title, lang: _this3.lang,
	            price: item.price, description: item.description, photo: item.photo,
	            slug: item.slug, restaurant: _this3.restId, pk: item.pk, cat: item.category });
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'suggested-area' },
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'related_products' },
	            function (message) {
	              return _react2.default.createElement(
	                'h6',
	                null,
	                message
	              );
	            }
	          ),
	          listAlternative
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'handleLoading',
	    value: function handleLoading() {
	      this.setState({
	        loading: (0, _imagesLoadCheck.imagesLoaded)(this.detail)
	      });
	    }
	  }, {
	    key: 'favsTotal',
	    value: function favsTotal(total) {
	      this.setState({
	        favToggle: !this.state.favToggle
	      });
	      this.props.favsTotal(total);
	    }
	  }, {
	    key: 'renderDiets',
	    value: function renderDiets() {
	      return this.state.data.diet.map(function (item) {
	        return _react2.default.createElement(
	          'div',
	          { key: item.slug, className: 'list-icons-item' },
	          _react2.default.createElement(
	            'span',
	            null,
	            item.name
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var width = {
	        width: this.state.detail_width
	      };
	
	      // CHECKING FOR ERRORS FROM THE API
	      if (this.state.data.status === "error") {
	        return _react2.default.createElement(_Error2.default, { restaurant: this.restId, lang: this.lang });
	      }
	
	      var relatedInfo = this.typeCheck();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_PreLoader2.default, { loading: this.state.loading }),
	        _react2.default.createElement(
	          'div',
	          { className: 'item-detail content-wrapper ' + this.state.loading, style: width, onLoad: this.handleLoading },
	          _react2.default.createElement(
	            'div',
	            { className: 'btn-wrapper' },
	            _react2.default.createElement('button', { className: 'btn body-back-btn', onClick: this.props.history.goBack })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'detail-half' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card main-card', ref: function ref(el) {
	                  _this4.detail = el;
	                } },
	              _react2.default.createElement(_ListItem2.default, { name: this.state.data.title,
	                gallery: this.state.data.gallery[0],
	                description: this.state.data.description,
	                price: this.state.data.price, likes: this.state.data.like,
	                restSlug: this.restId, catSlug: this.catSlug,
	                itemSlug: this.itemSlug, list: 'false',
	                region: this.state.data.wine_region,
	                type: this.state.data.wine_type, itemType: this.state.data.item_type,
	                loading: this.handleLoading, lang: this.lang, body: this.state.data.body,
	                sweetness: this.state.data.sweetness, pk: this.state.data.id, unit: this.state.data.unit
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'list-icons' },
	                this.state.data.diet !== null ? this.renderDiets() : null
	              ),
	              _react2.default.createElement(_FavBtn2.default, { itemType: this.state.data.item_type, pk: this.state.data.id, onClick: this.favsTotal }),
	              this.state.mode !== 'kiosk' ? _react2.default.createElement('div', { ref: 'addthis', className: 'addthis_inline_share_toolbox' }) : null,
	              _react2.default.createElement(_LikeBtn2.default, { likes: this.state.data.like, restSlug: this.state.restSlug, catSlug: this.catSlug,
	                itemSlug: this.itemSlug, lang: this.lang, itemType: this.state.data.item_type })
	            ),
	            this.checkExtras()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'detail-half' },
	            relatedInfo.listRelated && relatedInfo.listRelated.length > 0 && this.props.package === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'suggested-area' },
	              relatedInfo.listRelated
	            ) : null,
	            this.checkCta(),
	            this.checkAlternative()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ItemDetail;
	}(_react2.default.Component);
	
	ItemDetail.propTypes = {
	  category: _react.PropTypes.string,
	  history: _react.PropTypes.object,
	  item: _react.PropTypes.string,
	  match: _react.PropTypes.object,
	  package: _react.PropTypes.number,
	  view_info: _react.PropTypes.func,
	  wine_slug: _react.PropTypes.string,
	  favsTotal: _react.PropTypes.func
	};
	exports.default = ItemDetail;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _reactLazyload = __webpack_require__(133);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _apiData = __webpack_require__(12);
	
	var _imagesLoadCheck = __webpack_require__(38);
	
	var _settings = __webpack_require__(11);
	
	var _favCheck = __webpack_require__(72);
	
	var _ListItem = __webpack_require__(71);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _SmallCard = __webpack_require__(116);
	
	var _SmallCard2 = _interopRequireDefault(_SmallCard);
	
	var _FavBtn = __webpack_require__(70);
	
	var _FavBtn2 = _interopRequireDefault(_FavBtn);
	
	var _FilterBtn = __webpack_require__(191);
	
	var _FilterBtn2 = _interopRequireDefault(_FilterBtn);
	
	var _FilterMenu = __webpack_require__(193);
	
	var _FilterMenu2 = _interopRequireDefault(_FilterMenu);
	
	var _RestaurantError = __webpack_require__(69);
	
	var _RestaurantError2 = _interopRequireDefault(_RestaurantError);
	
	var _Empty = __webpack_require__(55);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _PreLoader = __webpack_require__(37);
	
	var _PreLoader2 = _interopRequireDefault(_PreLoader);
	
	var _MenuItem = __webpack_require__(115);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	__webpack_require__(467);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemList = function (_React$Component) {
	  _inherits(ItemList, _React$Component);
	
	  function ItemList(props) {
	    _classCallCheck(this, ItemList);
	
	    var _this = _possibleConstructorReturn(this, (ItemList.__proto__ || Object.getPrototypeOf(ItemList)).call(this, props));
	
	    _this.view = 'list';
	    _this.list = null;
	    _this.itemNumber = 0;
	    _this.activeFilters = { ingredients: [], wine_type: [], body: [], wine_regions: [], sweetness: [], diets: [] };
	
	    _this.state = {
	      toggle: 'inactive',
	      data: { products: null, ingredients: [], diets: [], status: '', choosen_filters: [], filters: {}, template: '', subcategories: [] },
	      clear_list: false,
	      loading: 'loading',
	      list_width: 0
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleFavs = _this.handleFavs.bind(_this);
	    _this.handleLoading = _this.handleLoading.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    return _this;
	  }
	
	  _createClass(ItemList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // get url query params
	      this.query = new URLSearchParams(this.props.location.search);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var p = _step.value;
	
	          if (p[1]) {
	            this.activeFilters[p[0]] = p[1].split(',').map(function (item) {
	              return parseInt(item, 10);
	            });
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.lang = this.props.match.params.lang;
	      this.restaurant = this.props.match.params.restaurant;
	      this.cat = this.props.category;
	      this.getData();
	      window.addEventListener("resize", this.updateDimensions);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // if url changes then we need to re render data
	      if (prevProps.location.pathname !== this.props.location.pathname) {
	        this.getData();
	      }
	
	      if (prevState.data.products !== this.state.data.products) {
	        this.itemNumber = this.state.data.products.length;
	        if (this.state.data.template === 'wine') {
	          this.view = 'wines';
	        }
	        this.updateDimensions();
	        // Sending view info to Restaurant.js to feed the Top and Bottom bars
	        this.props.view_info(this.state.data.category, this.view, true, 'default');
	      }
	
	      this.query = new URLSearchParams(this.props.location.search);
	      (0, _reactLazyload.forceCheck)();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions);
	    }
	  }, {
	    key: 'handleLoading',
	    value: function handleLoading() {
	      this.setState({
	        loading: (0, _imagesLoadCheck.imagesLoaded)(this.list)
	      });
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      var sideNavWidth = document.getElementById('sideNav').offsetWidth;
	      var filtersWidth = document.getElementById('filterMenu').offsetWidth;
	
	      if (window.innerWidth > 1024) {
	        if (this.state.data.filters && this.state.data.filters.length !== 0 && this.state.data.template !== 'wine') {
	          this.setState({ list_width: window.innerWidth - (sideNavWidth + filtersWidth) });
	        } else {
	          this.setState({ list_width: window.innerWidth - sideNavWidth });
	        }
	      } else {
	        this.setState({ list_width: window.innerWidth });
	      }
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var listProps = this.props;
	      var endpoint = '';
	      this.cat = listProps.category;
	
	      // if there's filters apply them to endpoint
	      var query = '?';
	      var filter_query = ['ingredients', 'diets', 'body', 'sweetness', 'wine_regions', 'wine_type'];
	      for (var i = 0; i < filter_query.length; i++) {
	        if (this.activeFilters[filter_query[i]]) {
	          query += '&' + filter_query[i] + '=' + this.activeFilters[filter_query[i]];
	        }
	      }
	
	      // category, filter and featured endpoints
	      if (listProps.category) {
	        endpoint = '/' + this.cat.split("-").pop() + '/' + query;
	      } else if (listProps.filter) {
	        endpoint = '/filter/' + listProps.filter.split("-").pop() + '/' + query;
	      } else {
	        endpoint = '/featured/';
	        this.view = 'featured';
	      }
	
	      // API call
	      (0, _apiData.ajaxGet)(_settings.API + this.lang + '/api/' + this.restaurant + '/items' + endpoint, this);
	    }
	
	    // we need an arrow function here because 'this' were the one passed by the onclick child <Filter>, and we need 'this'
	    // of this class
	
	  }, {
	    key: 'handleClickFilter',
	    value: function handleClickFilter(id, type) {
	
	      // check if clicked filter already exists in active filter
	      var filterExistsIndex = this.activeFilters[type].indexOf(id);
	
	      // if filter is active remove if not add it
	      if (filterExistsIndex === -1) {
	        this.activeFilters[type].push(id);
	      } else {
	        this.activeFilters[type].splice(filterExistsIndex, 1);
	      }
	
	      // update browser url
	      this.updateBrowserUrl();
	    }
	  }, {
	    key: 'handleSelectFilter',
	    value: function handleSelectFilter(id, type) {
	
	      this.activeFilters[type] = [id];
	
	      // update browser url
	      this.updateBrowserUrl();
	    }
	  }, {
	    key: 'handleFavs',
	    value: function handleFavs(total) {
	      this.props.favsTotal(total);
	    }
	
	    //HANDLING THE FILTER BTN TOGGLE
	
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      if (this.state.toggle === 'inactive') {
	        this.setState({ toggle: 'active', overlay: 'active', navToggle: 'inactive' });
	      } else {
	        this.setState({ toggle: 'inactive', overlay: 'inactive' });
	      }
	    }
	  }, {
	    key: 'clearAllFilters',
	    value: function clearAllFilters() {
	      for (var item in this.activeFilters) {
	        this.activeFilters[item] = [];
	      }
	      this.updateBrowserUrl();
	    }
	  }, {
	    key: 'updateBrowserUrl',
	    value: function updateBrowserUrl() {
	      var _this2 = this;
	
	      var query = '?' + Object.keys(this.activeFilters).map(function (items) {
	        return encodeURIComponent(items) + '=' + encodeURIComponent(_this2.activeFilters[items]);
	      }).join('&');
	      var path = this.props.location.pathname + query;
	      this.props.history.push(path);
	
	      // call getData with the new filters
	      this.getData();
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this3 = this;
	
	      var width = {
	        width: this.state.list_width
	      };
	
	      // CHECKING FOR ERRORS FROM THE API
	      // API GAVE ME AN ERROR :(
	      if (this.state.data.status === "error") {
	        return _react2.default.createElement(_RestaurantError2.default, { restaurant: this.restaurant, lang: this.lang, wine_slug: this.props.wine_slug, view: 'api' });
	      }
	
	      // CHECK IF API RESPONSE HAS ARRIVED to avoid a flash of no product
	      //CHECK IF THERE ARE ANY RESULTS IN THE RESPONSE
	      var listProducts = this.state.data.products.map(function (item) {
	        // FOUND THE RESULTS, MAPPING THEM HERE AND RENDERING FURTHER BELOW
	        if (_this3.props.viewToggle === "cards") {
	          return _react2.default.createElement(
	            _reactLazyload2.default,
	            { key: item.slug + '-' + item.id, height: 250 },
	            _react2.default.createElement(
	              'div',
	              { className: 'list-item' },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/' + _this3.lang + '/' + _this3.restaurant + '/items/' + item.category + '/' + item.slug + '-' + item.id },
	                _react2.default.createElement(_ListItem2.default, { name: item.title,
	                  gallery: item.gallery[0], description: item.description,
	                  price: item.price, list: 'true', itemType: item.item_type,
	                  region: item.wine_region,
	                  type: item.wine_type, template: _this3.state.data.template,
	                  unit: item.unit
	                })
	              ),
	              _react2.default.createElement(_FavBtn2.default, { restaurant: _this3.restaurant, itemType: item.item_type, pk: item.id, onClick: _this3.handleFavs })
	            )
	          );
	        } else if (_this3.props.viewToggle === "tiles") {
	          return _react2.default.createElement(
	            _reactLazyload2.default,
	            { key: item.slug + '-' + item.id, height: 250 },
	            _react2.default.createElement(
	              'div',
	              { className: 'list-tile' },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/' + _this3.lang + '/' + _this3.restaurant + '/items/' + item.category + '/' + item.slug + '-' + item.id },
	                _react2.default.createElement(_ListItem2.default, { name: item.title,
	                  gallery: item.gallery[0], description: item.description,
	                  price: item.price, likes: item.like, list: 'true', itemType: item.item_type,
	                  category: item.category, region: item.wine_region,
	                  type: item.wine_type, template: _this3.state.data.template, pk: item.id,
	                  favList: (0, _favCheck.favCheck)(item.id, item.item_type), unit: item.unity
	                })
	              ),
	              _react2.default.createElement(_FavBtn2.default, { restaurant: _this3.restaurant, itemType: item.item_type, pk: item.id, onClick: _this3.handleFavs })
	            )
	          );
	        }
	        return _react2.default.createElement(
	          _reactLazyload2.default,
	          { key: item.slug + '-' + item.id, height: 50 },
	          _react2.default.createElement(
	            'div',
	            { className: 'list-smallcard' },
	            _react2.default.createElement(_SmallCard2.default, { name: item.title, photo: item.gallery_small[0],
	              price: Number(item.price), lang: _this3.lang, slug: item.slug, restaurant: _this3.restaurant,
	              pk: item.id, cat: item.category }),
	            _react2.default.createElement(_FavBtn2.default, { itemType: item.item_type, pk: item.id, onClick: _this3.handleFavs })
	          )
	        );
	      });
	
	      var listSubcategories = this.state.data.subcategories && this.state.data.subcategories.map(function (item) {
	        return _react2.default.createElement(
	          _reactLazyload2.default,
	          { key: item.slug + '-' + item.id, height: 250 },
	          _react2.default.createElement(
	            'div',
	            { className: 'list-item' },
	            _react2.default.createElement(_MenuItem2.default, { parent: item.parent,
	              restaurant: _this3.restaurant, lang: _this3.lang,
	              category: item.name, picture: item.photo,
	              name: item.name, slug: item.slug, pk: item.id,
	              template: item.template })
	          )
	        );
	      });
	
	      if (this.state.data.products.length > 0 || this.state.data.subcategories && this.state.data.subcategories.length > 0) {
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'item-list ' + this.state.loading + ' ' + this.state.toggle, style: width,
	            ref: function ref(el) {
	              _this3.list = el;
	            } },
	          _react2.default.createElement('button', { className: 'btn body-back-btn', onClick: this.props.history.goBack }),
	          _react2.default.createElement(
	            'div',
	            { className: 'list-wrapper', onLoad: this.handleLoading },
	            listSubcategories,
	            listProducts
	          ),
	          _react2.default.createElement(_FilterBtn2.default, { toggle: this.state.toggle, onClick: this.handleClick })
	        );
	      } else {
	        // NO RESULTS WERE FOUND, RENDER A MSG
	        return _react2.default.createElement(
	          'div',
	          { className: "item-list " + this.state.loading, style: width, onLoad: this.handleLoading, ref: function ref(el) {
	              _this3.list = el;
	            } },
	          _react2.default.createElement(_Empty2.default, null),
	          _react2.default.createElement(_FilterBtn2.default, { toggle: this.state.toggle, onClick: this.handleClick })
	        );
	      }
	    }
	  }, {
	    key: 'hasFilters',
	    value: function hasFilters() {
	      if (this.state.data.filters && Object.keys(this.state.data.filters).length !== 0 && this.state.data.template !== 'wine') {
	        return 'with-filters';
	      }
	      return 'no-filters';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      // FOUND THE RESULTS RENDERING THE MAPPED ITEMS HERE
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'content-wrapper ' + this.hasFilters() },
	        _react2.default.createElement(_PreLoader2.default, { loading: this.state.loading }),
	        this.state.data.products !== null ? this.renderResults() : null,
	        _react2.default.createElement(_FilterMenu2.default, { filters: this.state.data.filters,
	          activeFilters: this.activeFilters,
	          template: this.state.data.template,
	          toggle: this.state.toggle,
	          handleClickFilter: function handleClickFilter(id, type) {
	            return _this4.handleClickFilter(id, type);
	          },
	          handleSelectFilter: function handleSelectFilter(id, type) {
	            return _this4.handleSelectFilter(id, type);
	          },
	          clearAllFilters: function clearAllFilters() {
	            return _this4.clearAllFilters();
	          },
	          handleClick: this.handleClick,
	          itemNumber: this.itemNumber
	        })
	      );
	    }
	  }]);
	
	  return ItemList;
	}(_react2.default.Component);
	
	ItemList.propTypes = {
	  category: _react.PropTypes.string,
	  history: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  match: _react.PropTypes.object,
	  view_info: _react.PropTypes.func,
	  wine_slug: _react.PropTypes.string,
	  viewToggle: _react.PropTypes.string,
	  favsTotal: _react.PropTypes.func
	};
	exports.default = ItemList;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_React$PureComponent) {
	  _inherits(Overlay, _React$PureComponent);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
	  }
	
	  _createClass(Overlay, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement("div", { className: "overlay" + " " + this.props.toggle, "data-value": "overlay",
	        onClick: function onClick(e) {
	          return _this2.props.onClick(e);
	        } });
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.PureComponent);
	
	Overlay.propTypes = {
	  onClick: _react.PropTypes.func,
	  toggle: _react.PropTypes.string
	};
	exports.default = Overlay;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _universalCookie = __webpack_require__(45);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _settings = __webpack_require__(11);
	
	var _apiData = __webpack_require__(12);
	
	var _favCheck = __webpack_require__(72);
	
	var _imagesLoadCheck = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(4);
	
	var _RestaurantError = __webpack_require__(69);
	
	var _RestaurantError2 = _interopRequireDefault(_RestaurantError);
	
	var _ListItem = __webpack_require__(71);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _FavBtn = __webpack_require__(70);
	
	var _FavBtn2 = _interopRequireDefault(_FavBtn);
	
	var _EmptyFav = __webpack_require__(215);
	
	var _EmptyFav2 = _interopRequireDefault(_EmptyFav);
	
	var _PreLoader = __webpack_require__(37);
	
	var _PreLoader2 = _interopRequireDefault(_PreLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cookies = new _universalCookie2.default();
	
	var ShortList = function (_React$Component) {
	  _inherits(ShortList, _React$Component);
	
	  function ShortList(props) {
	    _classCallCheck(this, ShortList);
	
	    var _this = _possibleConstructorReturn(this, (ShortList.__proto__ || Object.getPrototypeOf(ShortList)).call(this, props));
	
	    _this.list = '';
	
	    _this.state = {
	      toggle: 'inactive',
	      data: { products: null, status: '' },
	      clear_list: false,
	      loading: 'loading',
	      list_width: 0,
	      favList: []
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleFavs = _this.handleFavs.bind(_this);
	    _this.handleLoading = _this.handleLoading.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.getData = _this.getData.bind(_this);
	    return _this;
	  }
	
	  _createClass(ShortList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.lang = this.props.match.params.lang;
	      this.restId = this.props.match.params.restaurant;
	      if (cookies.get('shortlist') !== undefined) {
	        this.setState({ FavList: cookies.get('shortlist') });
	      }
	      this.getData();
	
	      window.addEventListener("resize", this.updateDimensions);
	      this.updateDimensions();
	      // Sending view info to Restaurant.js to feed the Top and Bottom bars
	      this.props.view_info(
	      //title
	      'myPick',
	      //view
	      'shortlist',
	      //back button or not
	      false);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props !== nextProps || this.state !== nextState;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.updateDimensions);
	    }
	  }, {
	    key: 'handleLoading',
	    value: function handleLoading() {
	      this.setState({
	        loading: (0, _imagesLoadCheck.imagesLoaded)(this.list)
	      });
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      if (window.innerWidth > 1024) {
	        if (this.state.data.filters && this.state.data.filters.length !== 0) {
	          this.setState({ list_width: window.innerWidth - 420 });
	        } else {
	          this.setState({ list_width: window.innerWidth - 120 });
	        }
	      }
	      this.setState({ list_width: window.innerWidth });
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      //TODO: Fazer com que deixe de ser necessário chamar a API quando se "desfavorita" um item
	      //CHECKING IF THERE WERE NEW PROPS; WHICH MEANT THE USER WENT FROM LIST TO LIST, NEED TO MAKE SURE API CALL IS MADE
	      //WITH THE NEW PROPS
	      var query = '?' + cookies.get('shortlist');
	      (0, _apiData.ajaxGet)(_settings.API + this.lang + '/api/' + this.restId + '/items/favourites/' + query, this);
	    }
	
	    //HANDLING THE FILTER BTN TOGGLE
	
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      if (this.state.toggle === 'inactive') {
	        this.setState({ toggle: 'active', overlay: 'active', navToggle: 'inactive' });
	      } else {
	        this.setState({ toggle: 'inactive', overlay: 'inactive' });
	      }
	    }
	  }, {
	    key: 'handleFavs',
	    value: function handleFavs(total) {
	      this.props.favsTotal(total);
	    }
	  }, {
	    key: 'mapItemArray',
	    value: function mapItemArray(item_list) {
	      var _this2 = this;
	
	      return item_list.map(function (item) {
	        var fav = (0, _favCheck.favCheck)(item.id, item.item_type);
	        return _react2.default.createElement(
	          'div',
	          { className: 'list-item' + ' ' + fav, key: item.id },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/' + _this2.lang + '/' + _this2.restId + '/items/' + item.category + '/' + item.slug + '-' + item.id },
	            _react2.default.createElement(_ListItem2.default, { name: item.title,
	              gallery: item.gallery[0], description: item.description,
	              price: item.price, likes: item.like, list: 'true', itemType: item.item_type,
	              category: item.category, region: item.wine_region,
	              type: item.wine_type, template: _this2.state.data.template, pk: item.id,
	              favList: fav, unit: item.unit
	            })
	          ),
	          _react2.default.createElement(_FavBtn2.default, { itemType: item.item_type, pk: item.id, onClick: _this2.handleFavs })
	        );
	      });
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this3 = this;
	
	      var width = {
	        width: this.state.list_width
	      };
	      var listFood = [];
	      var listDrink = [];
	
	      //CHECK IF THERE ARE ANY RESULTS IN THE RESPONSE
	      if (this.state.data.products.food.length > 0 || this.state.data.products.drink.length > 0) {
	        // CHECK IF API RESPONSE HAS ARRIVED
	        // FOUND THE RESULTS, MAPPING THEM HERE AND RENDERING
	        listFood = this.mapItemArray(this.state.data.products.food);
	        listDrink = this.mapItemArray(this.state.data.products.drink);
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'item-list shortlist ' + this.state.loading + ' ' + this.state.toggle,
	            style: width, onLoad: this.handleLoading, ref: function ref(el) {
	              _this3.list = el;
	            } },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'myPick'
	          ),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'mypick-text' },
	            function (message) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'empty-text' },
	                message
	              );
	            }
	          ),
	          _react2.default.createElement('button', { className: 'btn body-back-btn', onClick: this.props.history.goBack }),
	          this.state.data.products.food.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'list-wrapper' },
	            listFood
	          ) : null,
	          this.state.data.products.drink.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'list-wrapper' },
	            listDrink
	          ) : null
	        );
	      } else {
	        // NO RESULTS WERE FOUND, RENDER A MSG
	        return _react2.default.createElement(
	          'div',
	          { className: "item-list " + this.state.loading, style: width, onLoad: this.handleLoading,
	            ref: function ref(el) {
	              _this3.list = el;
	            } },
	          _react2.default.createElement(_EmptyFav2.default, null)
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // CHECKING FOR ERRORS FROM THE API
	      if (this.state.data.status === "error") {
	        return _react2.default.createElement(_RestaurantError2.default, { restaurant: this.restId,
	          lang: this.lang,
	          wine_slug: this.props.wine_slug,
	          view: 'api' });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'content-wrapper' },
	        _react2.default.createElement(_PreLoader2.default, { loading: this.state.loading }),
	        this.state.data.products !== null ? this.renderResults() : null
	      );
	    }
	  }]);
	
	  return ShortList;
	}(_react2.default.Component);
	
	ShortList.propTypes = {
	  history: _react.PropTypes.object,
	  match: _react.PropTypes.object,
	  view_info: _react.PropTypes.func,
	  wine_slug: _react.PropTypes.string,
	  favsTotal: _react.PropTypes.func
	};
	exports.default = ShortList;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StaticSmallCard = function (_React$Component) {
	  _inherits(StaticSmallCard, _React$Component);
	
	  function StaticSmallCard() {
	    _classCallCheck(this, StaticSmallCard);
	
	    return _possibleConstructorReturn(this, (StaticSmallCard.__proto__ || Object.getPrototypeOf(StaticSmallCard)).apply(this, arguments));
	  }
	
	  _createClass(StaticSmallCard, [{
	    key: 'render',
	    value: function render() {
	      var desc = this.props.description;
	      //if there is an item description, truncate it to 7 words
	      if (desc) {
	        desc = desc.split(" ").splice(0, 7).join(" ");
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'small-card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'small-thumb' },
	          _react2.default.createElement('img', { src: this.props.photo })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item-content' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'small-item-title' },
	            this.props.name
	          ),
	          this.props.price ? _react2.default.createElement(
	            'span',
	            { className: 'price' },
	            this.props.price,
	            '\u20AC'
	          ) : _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'price_under_request' },
	            function (message) {
	              return _react2.default.createElement(
	                'span',
	                { className: 'price' },
	                message
	              );
	            }
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'description' },
	            desc
	          )
	        )
	      );
	    }
	  }]);
	
	  return StaticSmallCard;
	}(_react2.default.Component);
	
	StaticSmallCard.propTypes = {
	  description: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  photo: _react.PropTypes.string,
	  price: _react.PropTypes.number
	};
	exports.default = StaticSmallCard;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _apiData = __webpack_require__(12);
	
	var _settings = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _SvgIcons = __webpack_require__(54);
	
	var _SvgIcons2 = _interopRequireDefault(_SvgIcons);
	
	var _Empty = __webpack_require__(55);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WineFilterList = function (_React$Component) {
	  _inherits(WineFilterList, _React$Component);
	
	  function WineFilterList(props) {
	    _classCallCheck(this, WineFilterList);
	
	    var _this = _possibleConstructorReturn(this, (WineFilterList.__proto__ || Object.getPrototypeOf(WineFilterList)).call(this, props));
	
	    _this.state = {
	      data: null
	    };
	
	    return _this;
	  }
	
	  _createClass(WineFilterList, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	
	      this.lang = this.props.match.params.lang;
	      this.restaurant = this.props.match.params.restaurant;
	      this.category = this.props.match.params.category;
	
	      this.getData(this.props);
	      this.props.view_info('', 'wines', true, '');
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      if (this.props.location.pathname !== nextProps.location.pathname) {
	        this.getData(nextProps);
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "getData",
	    value: function getData(props) {
	      if (!props.match.params.winetype) {
	        (0, _apiData.ajaxGet)(_settings.API + this.lang + '/api/' + this.restaurant + '/items/' + this.category + '/wine/', this);
	      } else {
	        (0, _apiData.ajaxGet)(_settings.API + this.lang + '/api/' + this.restaurant + '/items/' + this.category + '/wine/' + props.match.params.winetype + '/', this);
	      }
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this2 = this;
	
	      if (this.state.data.length === 0) {
	        return _react2.default.createElement(_Empty2.default, null);
	      }
	
	      return this.state.data.map(function (item) {
	        var url = '/' + _this2.lang + '/' + _this2.restaurant + '/wine/' + _this2.category + '/' + item.id;
	        var icon = _react2.default.createElement(_SvgIcons2.default, { icon: "wine-type-" + item.id });
	
	        if (item.id === 4 || item.id === 6) {
	          url = '/' + _this2.lang + '/' + _this2.restaurant + '/items/' + _this2.category + '/?wine_type=' + item.id;
	        }
	        if (_this2.props.match.params.winetype) {
	          url = '/' + _this2.lang + '/' + _this2.restaurant + '/items/' + _this2.category + '/?wine_type=' + _this2.props.match.params.winetype + '&wine_regions=' + item.id;
	          icon = _react2.default.createElement(
	            "span",
	            { style: { "fontSize": 50 } },
	            item.name[0]
	          );
	        }
	
	        return _react2.default.createElement(
	          "div",
	          { className: "list-smallcard-filter", key: item.id },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: url, className: "small-card" },
	            _react2.default.createElement(
	              "div",
	              { className: "small-thumb-bg" },
	              icon
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "item-content" },
	              _react2.default.createElement(
	                "h4",
	                { className: "small-item-title" },
	                item.name
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "arrow" },
	              _react2.default.createElement(_SvgIcons2.default, { icon: "arrow" })
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "item-list-filters loaded" },
	        this.state.data !== null ? this.renderItems() : null
	      );
	    }
	  }]);
	
	  return WineFilterList;
	}(_react2.default.Component);
	
	WineFilterList.propTypes = {
	  match: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  view_info: _react.PropTypes.func
	};
	exports.default = WineFilterList;

/***/ },
/* 223 */
/***/ function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ },
/* 224 */
/***/ function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(227);
	
	var emptyObject = __webpack_require__(39);
	var _invariant = __webpack_require__(2);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(225);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 227 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(230);
	var isArguments = __webpack_require__(229);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 229 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 230 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(233);
	var each = __webpack_require__(118).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(231);
	var Util = __webpack_require__(118);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 233 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(232);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 236 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 237 */
236,
/* 238 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(238);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(248);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var createArrayFromMixed = __webpack_require__(241);
	var getMarkupWrap = __webpack_require__(243);
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 244 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 245 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(245);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 247 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(247);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 249 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "favicon.ico";

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/logo.png";

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/placeholder-my-pick.jpg";

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(58);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(40);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(123);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(124);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(125);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(256)['default'];
	exports['default'] = exports;


/***/ },
/* 255 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Function.prototype.bind implementation from Mozilla Developer Network:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	"use strict";
	
	var bind = Function.prototype.bind || function (oThis) {
	    if (typeof this !== 'function') {
	      // closest thing possible to the ECMAScript 5
	      // internal IsCallable function
	      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	    }
	
	    var aArgs   = Array.prototype.slice.call(arguments, 1),
	        fToBind = this,
	        fNOP    = function() {},
	        fBound  = function() {
	          return fToBind.apply(this instanceof fNOP
	                 ? this
	                 : oThis,
	                 aArgs.concat(Array.prototype.slice.call(arguments)));
	        };
	
	    if (this.prototype) {
	      // native functions don't have a prototype
	      fNOP.prototype = this.prototype;
	    }
	    fBound.prototype = new fNOP();
	
	    return fBound;
	};
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jshint esnext: true */
	
	"use strict";
	var src$es5$$ = __webpack_require__(255);
	exports["default"] = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = src$es5$$.objCreate(null);
	
	    return function () {
	        var args    = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format  = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') { return; }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && typeof input === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys  = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key  = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i]  = prop;
	    }
	
	    return props;
	}
	
	//# sourceMappingURL=memoizer.js.map

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(258)['default'];
	exports['default'] = exports;


/***/ },
/* 258 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  /*
	   * Generated by PEG.js 0.8.0.
	   *
	   * http://pegjs.majda.cz/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function SyntaxError(message, expected, found, offset, line, column) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.offset   = offset;
	    this.line     = line;
	    this.column   = column;
	
	    this.name     = "SyntaxError";
	  }
	
	  peg$subclass(SyntaxError, Error);
	
	  function parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = [],
	        peg$c1 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements
	                };
	            },
	        peg$c2 = peg$FAILED,
	        peg$c3 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c4 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText
	                };
	            },
	        peg$c5 = /^[^ \t\n\r,.+={}#]/,
	        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c7 = "{",
	        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c9 = null,
	        peg$c10 = ",",
	        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c12 = "}",
	        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c14 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2]
	                };
	            },
	        peg$c15 = "number",
	        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c17 = "date",
	        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c19 = "time",
	        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c21 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2]
	                };
	            },
	        peg$c22 = "plural",
	        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                };
	            },
	        peg$c25 = "selectordinal",
	        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c27 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                }
	            },
	        peg$c28 = "select",
	        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c30 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options
	                };
	            },
	        peg$c31 = "=",
	        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c33 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern
	                };
	            },
	        peg$c34 = "offset:",
	        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c36 = function(number) {
	                return number;
	            },
	        peg$c37 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options
	                };
	            },
	        peg$c38 = { type: "other", description: "whitespace" },
	        peg$c39 = /^[ \t\n\r]/,
	        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c41 = { type: "other", description: "optionalWhitespace" },
	        peg$c42 = /^[0-9]/,
	        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c44 = /^[0-9a-f]/i,
	        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c46 = "0",
	        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c48 = /^[1-9]/,
	        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c50 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
	        peg$c53 = "\\\\",
	        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c55 = function() { return '\\'; },
	        peg$c56 = "\\#",
	        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c58 = function() { return '\\#'; },
	        peg$c59 = "\\{",
	        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c61 = function() { return '\u007B'; },
	        peg$c62 = "\\}",
	        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c64 = function() { return '\u007D'; },
	        peg$c65 = "\\u",
	        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c67 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c68 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$reportedPos      = 0,
	        peg$cachedPos        = 0,
	        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$reportedPos, peg$currPos);
	    }
	
	    function offset() {
	      return peg$reportedPos;
	    }
	
	    function line() {
	      return peg$computePosDetails(peg$reportedPos).line;
	    }
	
	    function column() {
	      return peg$computePosDetails(peg$reportedPos).column;
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        peg$reportedPos
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(message, null, peg$reportedPos);
	    }
	
	    function peg$computePosDetails(pos) {
	      function advance(details, startPos, endPos) {
	        var p, ch;
	
	        for (p = startPos; p < endPos; p++) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	        }
	      }
	
	      if (peg$cachedPos !== pos) {
	        if (peg$cachedPos > pos) {
	          peg$cachedPos = 0;
	          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
	        }
	        advance(peg$cachedPosDetails, peg$cachedPos, pos);
	        peg$cachedPos = pos;
	      }
	
	      return peg$cachedPosDetails;
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, pos) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      var posDetails = peg$computePosDetails(pos),
	          found      = pos < input.length ? input.charAt(pos) : null;
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        pos,
	        posDetails.line,
	        posDetails.column
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$c2;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$c2;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$c2;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c4(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c5.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c6); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c5.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	          }
	        } else {
	          s1 = peg$c2;
	        }
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c7;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c8); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c10;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c11); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$c2;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$c2;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = peg$c9;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c12;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c14(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c15) {
	        s1 = peg$c15;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c16); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c17) {
	          s1 = peg$c17;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c18); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c19) {
	            s1 = peg$c19;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c20); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c10;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$c2;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$c2;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$c2;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = peg$c9;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c21(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c28) {
	        s1 = peg$c28;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$c2;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c30(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c31;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$c2;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c7;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c8); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c12;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$reportedPos = s0;
	                      s1 = peg$c33(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c34) {
	        s1 = peg$c34;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c36(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = peg$c9;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$c2;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c37(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c39.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c40); }
	          }
	        }
	      } else {
	        s0 = peg$c2;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c41); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c42.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c43); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c44.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c45); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c46;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c47); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c48.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c49); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	        if (s2 !== peg$FAILED) {
	          s2 = input.substring(s1, peg$currPos);
	        }
	        s1 = s2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c50(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c51.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c52); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c53) {
	          s1 = peg$c53;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c54); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$reportedPos = s0;
	          s1 = peg$c55();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c56) {
	            s1 = peg$c56;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c57); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c58();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c59) {
	              s1 = peg$c59;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c60); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$reportedPos = s0;
	              s1 = peg$c61();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c62) {
	                s1 = peg$c62;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c63); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c64();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c65) {
	                  s1 = peg$c65;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$c2;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$c2;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$c2;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s3 = input.substring(s2, peg$currPos);
	                  }
	                  s2 = s3;
	                  if (s2 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c67(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c68(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
	    }
	  }
	
	  return {
	    SyntaxError: SyntaxError,
	    parse:       parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ },
/* 259 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value) {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(127), src$es5$$ = __webpack_require__(262), src$compiler$$ = __webpack_require__(259), intl$messageformat$parser$$ = __webpack_require__(257);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	        return messageFormat._format(pattern, values);
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	            throw new Error('A value must be provided for: ' + id);
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 261 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(127);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 263 */
[474, 260, 261],
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(269)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(472);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(126), src$diff$$ = __webpack_require__(266), src$es5$$ = __webpack_require__(268);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45,  // seconds to minute
	        minute: 45,  // minutes to hour
	        hour  : 22,  // hours to day
	        day   : 26,  // days to month
	        month : 11   // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	
	    for (i = 0, l = FIELDS.length; i < l; i += 1) {
	        units = FIELDS[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 266 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second     : second,
	        minute     : minute,
	        hour       : hour,
	        day        : day,
	        week       : week,
	        month      : month,
	        year       : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ },
/* 267 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 268 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 269 */
[474, 265, 267],
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
	global.IntlPolyfill = __webpack_require__(271);
	
	// Require all locale data for `Intl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	__webpack_require__(470);
	
	// hack to export the polyfill as global Intl if needed
	if (!global.Intl) {
	    global.Intl = global.IntlPolyfill;
	    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
	}
	
	// providing an idiomatic api for the nodejs version of this module
	module.exports = global.IntlPolyfill;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 271 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty$1 = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty$1,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	var realDefineProp = function () {
	    var sentinel = function sentinel() {};
	    try {
	        Object.defineProperty(sentinel, 'a', {
	            get: function get() {
	                return 1;
	            }
	        });
	        Object.defineProperty(sentinel, 'prototype', { writable: false });
	        return sentinel.a === 1 && sentinel.prototype instanceof Object;
	    } catch (e) {
	        return false;
	    }
	}();
	
	// Need a workaround for getters in ES3
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	// We use this a lot (and need it for proto-less objects)
	var hop = Object.prototype.hasOwnProperty;
	
	// Naive defineProperty for compatibility
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
	};
	
	// Array.prototype.indexOf, as good as we need it to be
	var arrIndexOf = Array.prototype.indexOf || function (search) {
	    /*jshint validthis:true */
	    var t = this;
	    if (!t.length) return -1;
	
	    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
	        if (t[i] === search) return i;
	    }
	
	    return -1;
	};
	
	// Create an object with the specified prototype (2nd arg required for Record)
	var objCreate = Object.create || function (proto, props) {
	    var obj = void 0;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (var k in props) {
	        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
	    }
	
	    return obj;
	};
	
	// Snapshot some (hopefully still) native built-ins
	var arrSlice = Array.prototype.slice;
	var arrConcat = Array.prototype.concat;
	var arrPush = Array.prototype.push;
	var arrJoin = Array.prototype.join;
	var arrShift = Array.prototype.shift;
	
	// Naive Function.prototype.bind for compatibility
	var fnBind = Function.prototype.bind || function (thisObj) {
	    var fn = this,
	        args = arrSlice.call(arguments, 1);
	
	    // All our (presently) bound functions have either 1 or 0 arguments. By returning
	    // different function signatures, we can pass some tests in ES3 environments
	    if (fn.length === 1) {
	        return function () {
	            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	        };
	    }
	    return function () {
	        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	    };
	};
	
	// Object housing internal properties for constructors
	var internals = objCreate(null);
	
	// Keep internal properties internal
	var secret = Math.random();
	
	// Helper functions
	// ================
	
	/**
	 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
	 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
	 * causing issue #62.
	 */
	function log10Floor(n) {
	    // ES6 provides the more accurate Math.log10
	    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));
	
	    var x = Math.round(Math.log(n) * Math.LOG10E);
	    return x - (Number('1e' + x) > n);
	}
	
	/**
	 * A map that doesn't contain Object in its prototype chain
	 */
	function Record(obj) {
	    // Copy only own properties over unless this object is already a Record instance
	    for (var k in obj) {
	        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
	    }
	}
	Record.prototype = objCreate(null);
	
	/**
	 * An ordered list
	 */
	function List() {
	    defineProperty(this, 'length', { writable: true, value: 0 });
	
	    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
	}
	List.prototype = objCreate(null);
	
	/**
	 * Constructs a regular expression to restore tainted RegExp properties
	 */
	function createRegExpRestore() {
	    if (internals.disableRegExpRestore) {
	        return function () {/* no-op */};
	    }
	
	    var regExpCache = {
	        lastMatch: RegExp.lastMatch || '',
	        leftContext: RegExp.leftContext,
	        multiline: RegExp.multiline,
	        input: RegExp.input
	    },
	        has = false;
	
	    // Create a snapshot of all the 'captured' properties
	    for (var i = 1; i <= 9; i++) {
	        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
	    }return function () {
	        // Now we've snapshotted some properties, escape the lastMatch string
	        var esc = /[.?*+^$[\]\\(){}|-]/g,
	            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
	            reg = new List();
	
	        // If any of the captured strings were non-empty, iterate over them all
	        if (has) {
	            for (var _i = 1; _i <= 9; _i++) {
	                var m = regExpCache['$' + _i];
	
	                // If it's empty, add an empty capturing group
	                if (!m) lm = '()' + lm;
	
	                // Else find the string in lm and escape & wrap it to capture it
	                else {
	                        m = m.replace(esc, '\\$&');
	                        lm = lm.replace(m, '(' + m + ')');
	                    }
	
	                // Push it to the reg and chop lm to make sure further groups come after
	                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
	                lm = lm.slice(lm.indexOf('(') + 1);
	            }
	        }
	
	        var exprStr = arrJoin.call(reg, '') + lm;
	
	        // Shorten the regex by replacing each part of the expression with a match
	        // for a string of that exact length.  This is safe for the type of
	        // expressions generated above, because the expression matches the whole
	        // match string, so we know each group and each segment between capturing
	        // groups can be matched by its length alone.
	        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
	            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
	        });
	
	        // Create the regular expression that will reconstruct the RegExp properties
	        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');
	
	        // Set the lastIndex of the generated expression to ensure that the match
	        // is found in the correct index.
	        expr.lastIndex = regExpCache.leftContext.length;
	
	        expr.exec(regExpCache.input);
	    };
	}
	
	/**
	 * Mimics ES5's abstract ToObject() function
	 */
	function toObject(arg) {
	    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');
	
	    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
	    return Object(arg);
	}
	
	function toNumber(arg) {
	    if (typeof arg === 'number') return arg;
	    return Number(arg);
	}
	
	function toInteger(arg) {
	    var number = toNumber(arg);
	    if (isNaN(number)) return 0;
	    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
	    if (number < 0) return Math.floor(Math.abs(number)) * -1;
	    return Math.floor(Math.abs(number));
	}
	
	function toLength(arg) {
	    var len = toInteger(arg);
	    if (len <= 0) return 0;
	    if (len === Infinity) return Math.pow(2, 53) - 1;
	    return Math.min(len, Math.pow(2, 53) - 1);
	}
	
	/**
	 * Returns "internal" properties for an object
	 */
	function getInternalProperties(obj) {
	    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);
	
	    return objCreate(null);
	}
	
	/**
	* Defines regular expressions for various operations related to the BCP 47 syntax,
	* as defined at http://tools.ietf.org/html/bcp47#section-2.1
	*/
	
	// extlang       = 3ALPHA              ; selected ISO 639 codes
	//                 *2("-" 3ALPHA)      ; permanently reserved
	var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';
	
	// language      = 2*3ALPHA            ; shortest ISO 639 code
	//                 ["-" extlang]       ; sometimes followed by
	//                                     ; extended language subtags
	//               / 4ALPHA              ; or reserved for future use
	//               / 5*8ALPHA            ; or registered language subtag
	var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';
	
	// script        = 4ALPHA              ; ISO 15924 code
	var script = '[a-z]{4}';
	
	// region        = 2ALPHA              ; ISO 3166-1 code
	//               / 3DIGIT              ; UN M.49 code
	var region = '(?:[a-z]{2}|\\d{3})';
	
	// variant       = 5*8alphanum         ; registered variants
	//               / (DIGIT 3alphanum)
	var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';
	
	//                                     ; Single alphanumerics
	//                                     ; "x" reserved for private use
	// singleton     = DIGIT               ; 0 - 9
	//               / %x41-57             ; A - W
	//               / %x59-5A             ; Y - Z
	//               / %x61-77             ; a - w
	//               / %x79-7A             ; y - z
	var singleton = '[0-9a-wy-z]';
	
	// extension     = singleton 1*("-" (2*8alphanum))
	var extension = singleton + '(?:-[a-z0-9]{2,8})+';
	
	// privateuse    = "x" 1*("-" (1*8alphanum))
	var privateuse = 'x(?:-[a-z0-9]{1,8})+';
	
	// irregular     = "en-GB-oed"         ; irregular tags do not match
	//               / "i-ami"             ; the 'langtag' production and
	//               / "i-bnn"             ; would not otherwise be
	//               / "i-default"         ; considered 'well-formed'
	//               / "i-enochian"        ; These tags are all valid,
	//               / "i-hak"             ; but most are deprecated
	//               / "i-klingon"         ; in favor of more modern
	//               / "i-lux"             ; subtags or subtag
	//               / "i-mingo"           ; combination
	//               / "i-navajo"
	//               / "i-pwn"
	//               / "i-tao"
	//               / "i-tay"
	//               / "i-tsu"
	//               / "sgn-BE-FR"
	//               / "sgn-BE-NL"
	//               / "sgn-CH-DE"
	var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';
	
	// regular       = "art-lojban"        ; these tags match the 'langtag'
	//               / "cel-gaulish"       ; production, but their subtags
	//               / "no-bok"            ; are not extended language
	//               / "no-nyn"            ; or variant subtags: their meaning
	//               / "zh-guoyu"          ; is defined by their registration
	//               / "zh-hakka"          ; and all of these are deprecated
	//               / "zh-min"            ; in favor of a more modern
	//               / "zh-min-nan"        ; subtag or sequence of subtags
	//               / "zh-xiang"
	var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';
	
	// grandfathered = irregular           ; non-redundant tags registered
	//               / regular             ; during the RFC 3066 era
	var grandfathered = '(?:' + irregular + '|' + regular + ')';
	
	// langtag       = language
	//                 ["-" script]
	//                 ["-" region]
	//                 *("-" variant)
	//                 *("-" extension)
	//                 ["-" privateuse]
	var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';
	
	// Language-Tag  = langtag             ; normal language tags
	//               / privateuse          ; private use tag
	//               / grandfathered       ; grandfathered tags
	var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');
	
	// Match duplicate variants in a language tag
	var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');
	
	// Match duplicate singletons in a language tag (except in private use)
	var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');
	
	// Match all extension sequences
	var expExtSequences = RegExp('-' + extension, 'ig');
	
	// Default locale is the first-added locale data for us
	var defaultLocale = void 0;
	function setDefaultLocale(locale) {
	    defaultLocale = locale;
	}
	
	// IANA Subtag Registry redundant tag and subtag maps
	var redundantTags = {
	    tags: {
	        "art-lojban": "jbo",
	        "i-ami": "ami",
	        "i-bnn": "bnn",
	        "i-hak": "hak",
	        "i-klingon": "tlh",
	        "i-lux": "lb",
	        "i-navajo": "nv",
	        "i-pwn": "pwn",
	        "i-tao": "tao",
	        "i-tay": "tay",
	        "i-tsu": "tsu",
	        "no-bok": "nb",
	        "no-nyn": "nn",
	        "sgn-BE-FR": "sfb",
	        "sgn-BE-NL": "vgt",
	        "sgn-CH-DE": "sgg",
	        "zh-guoyu": "cmn",
	        "zh-hakka": "hak",
	        "zh-min-nan": "nan",
	        "zh-xiang": "hsn",
	        "sgn-BR": "bzs",
	        "sgn-CO": "csn",
	        "sgn-DE": "gsg",
	        "sgn-DK": "dsl",
	        "sgn-ES": "ssp",
	        "sgn-FR": "fsl",
	        "sgn-GB": "bfi",
	        "sgn-GR": "gss",
	        "sgn-IE": "isg",
	        "sgn-IT": "ise",
	        "sgn-JP": "jsl",
	        "sgn-MX": "mfs",
	        "sgn-NI": "ncs",
	        "sgn-NL": "dse",
	        "sgn-NO": "nsl",
	        "sgn-PT": "psr",
	        "sgn-SE": "swl",
	        "sgn-US": "ase",
	        "sgn-ZA": "sfs",
	        "zh-cmn": "cmn",
	        "zh-cmn-Hans": "cmn-Hans",
	        "zh-cmn-Hant": "cmn-Hant",
	        "zh-gan": "gan",
	        "zh-wuu": "wuu",
	        "zh-yue": "yue"
	    },
	    subtags: {
	        BU: "MM",
	        DD: "DE",
	        FX: "FR",
	        TP: "TL",
	        YD: "YE",
	        ZR: "CD",
	        heploc: "alalc97",
	        'in': "id",
	        iw: "he",
	        ji: "yi",
	        jw: "jv",
	        mo: "ro",
	        ayx: "nun",
	        bjd: "drl",
	        ccq: "rki",
	        cjr: "mom",
	        cka: "cmr",
	        cmk: "xch",
	        drh: "khk",
	        drw: "prs",
	        gav: "dev",
	        hrr: "jal",
	        ibi: "opa",
	        kgh: "kml",
	        lcq: "ppr",
	        mst: "mry",
	        myt: "mry",
	        sca: "hle",
	        tie: "ras",
	        tkk: "twm",
	        tlw: "weo",
	        tnf: "prs",
	        ybd: "rki",
	        yma: "lrr"
	    },
	    extLang: {
	        aao: ["aao", "ar"],
	        abh: ["abh", "ar"],
	        abv: ["abv", "ar"],
	        acm: ["acm", "ar"],
	        acq: ["acq", "ar"],
	        acw: ["acw", "ar"],
	        acx: ["acx", "ar"],
	        acy: ["acy", "ar"],
	        adf: ["adf", "ar"],
	        ads: ["ads", "sgn"],
	        aeb: ["aeb", "ar"],
	        aec: ["aec", "ar"],
	        aed: ["aed", "sgn"],
	        aen: ["aen", "sgn"],
	        afb: ["afb", "ar"],
	        afg: ["afg", "sgn"],
	        ajp: ["ajp", "ar"],
	        apc: ["apc", "ar"],
	        apd: ["apd", "ar"],
	        arb: ["arb", "ar"],
	        arq: ["arq", "ar"],
	        ars: ["ars", "ar"],
	        ary: ["ary", "ar"],
	        arz: ["arz", "ar"],
	        ase: ["ase", "sgn"],
	        asf: ["asf", "sgn"],
	        asp: ["asp", "sgn"],
	        asq: ["asq", "sgn"],
	        asw: ["asw", "sgn"],
	        auz: ["auz", "ar"],
	        avl: ["avl", "ar"],
	        ayh: ["ayh", "ar"],
	        ayl: ["ayl", "ar"],
	        ayn: ["ayn", "ar"],
	        ayp: ["ayp", "ar"],
	        bbz: ["bbz", "ar"],
	        bfi: ["bfi", "sgn"],
	        bfk: ["bfk", "sgn"],
	        bjn: ["bjn", "ms"],
	        bog: ["bog", "sgn"],
	        bqn: ["bqn", "sgn"],
	        bqy: ["bqy", "sgn"],
	        btj: ["btj", "ms"],
	        bve: ["bve", "ms"],
	        bvl: ["bvl", "sgn"],
	        bvu: ["bvu", "ms"],
	        bzs: ["bzs", "sgn"],
	        cdo: ["cdo", "zh"],
	        cds: ["cds", "sgn"],
	        cjy: ["cjy", "zh"],
	        cmn: ["cmn", "zh"],
	        coa: ["coa", "ms"],
	        cpx: ["cpx", "zh"],
	        csc: ["csc", "sgn"],
	        csd: ["csd", "sgn"],
	        cse: ["cse", "sgn"],
	        csf: ["csf", "sgn"],
	        csg: ["csg", "sgn"],
	        csl: ["csl", "sgn"],
	        csn: ["csn", "sgn"],
	        csq: ["csq", "sgn"],
	        csr: ["csr", "sgn"],
	        czh: ["czh", "zh"],
	        czo: ["czo", "zh"],
	        doq: ["doq", "sgn"],
	        dse: ["dse", "sgn"],
	        dsl: ["dsl", "sgn"],
	        dup: ["dup", "ms"],
	        ecs: ["ecs", "sgn"],
	        esl: ["esl", "sgn"],
	        esn: ["esn", "sgn"],
	        eso: ["eso", "sgn"],
	        eth: ["eth", "sgn"],
	        fcs: ["fcs", "sgn"],
	        fse: ["fse", "sgn"],
	        fsl: ["fsl", "sgn"],
	        fss: ["fss", "sgn"],
	        gan: ["gan", "zh"],
	        gds: ["gds", "sgn"],
	        gom: ["gom", "kok"],
	        gse: ["gse", "sgn"],
	        gsg: ["gsg", "sgn"],
	        gsm: ["gsm", "sgn"],
	        gss: ["gss", "sgn"],
	        gus: ["gus", "sgn"],
	        hab: ["hab", "sgn"],
	        haf: ["haf", "sgn"],
	        hak: ["hak", "zh"],
	        hds: ["hds", "sgn"],
	        hji: ["hji", "ms"],
	        hks: ["hks", "sgn"],
	        hos: ["hos", "sgn"],
	        hps: ["hps", "sgn"],
	        hsh: ["hsh", "sgn"],
	        hsl: ["hsl", "sgn"],
	        hsn: ["hsn", "zh"],
	        icl: ["icl", "sgn"],
	        ils: ["ils", "sgn"],
	        inl: ["inl", "sgn"],
	        ins: ["ins", "sgn"],
	        ise: ["ise", "sgn"],
	        isg: ["isg", "sgn"],
	        isr: ["isr", "sgn"],
	        jak: ["jak", "ms"],
	        jax: ["jax", "ms"],
	        jcs: ["jcs", "sgn"],
	        jhs: ["jhs", "sgn"],
	        jls: ["jls", "sgn"],
	        jos: ["jos", "sgn"],
	        jsl: ["jsl", "sgn"],
	        jus: ["jus", "sgn"],
	        kgi: ["kgi", "sgn"],
	        knn: ["knn", "kok"],
	        kvb: ["kvb", "ms"],
	        kvk: ["kvk", "sgn"],
	        kvr: ["kvr", "ms"],
	        kxd: ["kxd", "ms"],
	        lbs: ["lbs", "sgn"],
	        lce: ["lce", "ms"],
	        lcf: ["lcf", "ms"],
	        liw: ["liw", "ms"],
	        lls: ["lls", "sgn"],
	        lsg: ["lsg", "sgn"],
	        lsl: ["lsl", "sgn"],
	        lso: ["lso", "sgn"],
	        lsp: ["lsp", "sgn"],
	        lst: ["lst", "sgn"],
	        lsy: ["lsy", "sgn"],
	        ltg: ["ltg", "lv"],
	        lvs: ["lvs", "lv"],
	        lzh: ["lzh", "zh"],
	        max: ["max", "ms"],
	        mdl: ["mdl", "sgn"],
	        meo: ["meo", "ms"],
	        mfa: ["mfa", "ms"],
	        mfb: ["mfb", "ms"],
	        mfs: ["mfs", "sgn"],
	        min: ["min", "ms"],
	        mnp: ["mnp", "zh"],
	        mqg: ["mqg", "ms"],
	        mre: ["mre", "sgn"],
	        msd: ["msd", "sgn"],
	        msi: ["msi", "ms"],
	        msr: ["msr", "sgn"],
	        mui: ["mui", "ms"],
	        mzc: ["mzc", "sgn"],
	        mzg: ["mzg", "sgn"],
	        mzy: ["mzy", "sgn"],
	        nan: ["nan", "zh"],
	        nbs: ["nbs", "sgn"],
	        ncs: ["ncs", "sgn"],
	        nsi: ["nsi", "sgn"],
	        nsl: ["nsl", "sgn"],
	        nsp: ["nsp", "sgn"],
	        nsr: ["nsr", "sgn"],
	        nzs: ["nzs", "sgn"],
	        okl: ["okl", "sgn"],
	        orn: ["orn", "ms"],
	        ors: ["ors", "ms"],
	        pel: ["pel", "ms"],
	        pga: ["pga", "ar"],
	        pks: ["pks", "sgn"],
	        prl: ["prl", "sgn"],
	        prz: ["prz", "sgn"],
	        psc: ["psc", "sgn"],
	        psd: ["psd", "sgn"],
	        pse: ["pse", "ms"],
	        psg: ["psg", "sgn"],
	        psl: ["psl", "sgn"],
	        pso: ["pso", "sgn"],
	        psp: ["psp", "sgn"],
	        psr: ["psr", "sgn"],
	        pys: ["pys", "sgn"],
	        rms: ["rms", "sgn"],
	        rsi: ["rsi", "sgn"],
	        rsl: ["rsl", "sgn"],
	        sdl: ["sdl", "sgn"],
	        sfb: ["sfb", "sgn"],
	        sfs: ["sfs", "sgn"],
	        sgg: ["sgg", "sgn"],
	        sgx: ["sgx", "sgn"],
	        shu: ["shu", "ar"],
	        slf: ["slf", "sgn"],
	        sls: ["sls", "sgn"],
	        sqk: ["sqk", "sgn"],
	        sqs: ["sqs", "sgn"],
	        ssh: ["ssh", "ar"],
	        ssp: ["ssp", "sgn"],
	        ssr: ["ssr", "sgn"],
	        svk: ["svk", "sgn"],
	        swc: ["swc", "sw"],
	        swh: ["swh", "sw"],
	        swl: ["swl", "sgn"],
	        syy: ["syy", "sgn"],
	        tmw: ["tmw", "ms"],
	        tse: ["tse", "sgn"],
	        tsm: ["tsm", "sgn"],
	        tsq: ["tsq", "sgn"],
	        tss: ["tss", "sgn"],
	        tsy: ["tsy", "sgn"],
	        tza: ["tza", "sgn"],
	        ugn: ["ugn", "sgn"],
	        ugy: ["ugy", "sgn"],
	        ukl: ["ukl", "sgn"],
	        uks: ["uks", "sgn"],
	        urk: ["urk", "ms"],
	        uzn: ["uzn", "uz"],
	        uzs: ["uzs", "uz"],
	        vgt: ["vgt", "sgn"],
	        vkk: ["vkk", "ms"],
	        vkt: ["vkt", "ms"],
	        vsi: ["vsi", "sgn"],
	        vsl: ["vsl", "sgn"],
	        vsv: ["vsv", "sgn"],
	        wuu: ["wuu", "zh"],
	        xki: ["xki", "sgn"],
	        xml: ["xml", "sgn"],
	        xmm: ["xmm", "ms"],
	        xms: ["xms", "sgn"],
	        yds: ["yds", "sgn"],
	        ysl: ["ysl", "sgn"],
	        yue: ["yue", "zh"],
	        zib: ["zib", "sgn"],
	        zlm: ["zlm", "ms"],
	        zmi: ["zmi", "ms"],
	        zsl: ["zsl", "sgn"],
	        zsm: ["zsm", "ms"]
	    }
	};
	
	/**
	 * Convert only a-z to uppercase as per section 6.1 of the spec
	 */
	function toLatinUpperCase(str) {
	    var i = str.length;
	
	    while (i--) {
	        var ch = str.charAt(i);
	
	        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
	    }
	
	    return str;
	}
	
	/**
	 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
	 * argument (which must be a String value)
	 *
	 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
	 *   2.1, or successor,
	 * - does not include duplicate variant subtags, and
	 * - does not include duplicate singleton subtags.
	 *
	 * The abstract operation returns true if locale can be generated from the ABNF
	 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
	 * contain duplicate variant or singleton subtags (other than as a private use
	 * subtag). It returns false otherwise. Terminal value characters in the grammar are
	 * interpreted as the Unicode equivalents of the ASCII octet values given.
	 */
	function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
	    // represents a well-formed BCP 47 language tag as specified in RFC 5646
	    if (!expBCP47Syntax.test(locale)) return false;
	
	    // does not include duplicate variant subtags, and
	    if (expVariantDupes.test(locale)) return false;
	
	    // does not include duplicate singleton subtags.
	    if (expSingletonDupes.test(locale)) return false;
	
	    return true;
	}
	
	/**
	 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
	 * regularized form of the locale argument (which must be a String value that is
	 * a structurally valid BCP 47 language tag as verified by the
	 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
	 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
	 * into canonical form, and to regularize the case of the subtags, but does not
	 * take the steps to bring a language tag into “extlang form” and to reorder
	 * variant subtags.
	
	 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
	 * may include canonicalization rules for the extension subtag sequences they
	 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
	 * Implementations are allowed, but not required, to apply these additional rules.
	 */
	function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
	    var match = void 0,
	        parts = void 0;
	
	    // A language tag is in 'canonical form' when the tag is well-formed
	    // according to the rules in Sections 2.1 and 2.2
	
	    // Section 2.1 says all subtags use lowercase...
	    locale = locale.toLowerCase();
	
	    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
	    // appear at the start of the tag nor occur after singletons.  Such two-letter
	    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
	    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
	    parts = locale.split('-');
	    for (var i = 1, max = parts.length; i < max; i++) {
	        // Two-letter subtags are all uppercase
	        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();
	
	        // Four-letter subtags are titlecase
	        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
	
	            // Is it a singleton?
	            else if (parts[i].length === 1 && parts[i] !== 'x') break;
	    }
	    locale = arrJoin.call(parts, '-');
	
	    // The steps laid out in RFC 5646 section 4.5 are as follows:
	
	    // 1.  Extension sequences are ordered into case-insensitive ASCII order
	    //     by singleton subtag.
	    if ((match = locale.match(expExtSequences)) && match.length > 1) {
	        // The built-in sort() sorts by ASCII order, so use that
	        match.sort();
	
	        // Replace all extensions with the joined, sorted array
	        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
	    }
	
	    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
	    //     Value', if there is one.
	    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];
	
	    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
	    //     For extlangs, the original primary language subtag is also
	    //     replaced if there is a primary language subtag in the 'Preferred-
	    //     Value'.
	    parts = locale.split('-');
	
	    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
	        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
	            parts[_i] = redundantTags.extLang[parts[_i]][0];
	
	            // For extlang tags, the prefix needs to be removed if it is redundant
	            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
	                parts = arrSlice.call(parts, _i++);
	                _max -= 1;
	            }
	        }
	    }
	
	    return arrJoin.call(parts, '-');
	}
	
	/**
	 * The DefaultLocale abstract operation returns a String value representing the
	 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
	 * host environment’s current locale.
	 */
	function /* 6.2.4 */DefaultLocale() {
	    return defaultLocale;
	}
	
	// Sect 6.3 Currency Codes
	// =======================
	
	var expCurrencyCode = /^[A-Z]{3}$/;
	
	/**
	 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
	 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
	 * code. The following steps are taken:
	 */
	function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
	    // 1. Let `c` be ToString(currency)
	    var c = String(currency);
	
	    // 2. Let `normalized` be the result of mapping c to upper case as described
	    //    in 6.1.
	    var normalized = toLatinUpperCase(c);
	
	    // 3. If the string length of normalized is not 3, return false.
	    // 4. If normalized contains any character that is not in the range "A" to "Z"
	    //    (U+0041 to U+005A), return false.
	    if (expCurrencyCode.test(normalized) === false) return false;
	
	    // 5. Return true
	    return true;
	}
	
	var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below
	
	function /* 9.2.1 */CanonicalizeLocaleList(locales) {
	    // The abstract operation CanonicalizeLocaleList takes the following steps:
	
	    // 1. If locales is undefined, then a. Return a new empty List
	    if (locales === undefined) return new List();
	
	    // 2. Let seen be a new empty List.
	    var seen = new List();
	
	    // 3. If locales is a String value, then
	    //    a. Let locales be a new array created as if by the expression new
	    //    Array(locales) where Array is the standard built-in constructor with
	    //    that name and locales is the value of locales.
	    locales = typeof locales === 'string' ? [locales] : locales;
	
	    // 4. Let O be ToObject(locales).
	    var O = toObject(locales);
	
	    // 5. Let lenValue be the result of calling the [[Get]] internal method of
	    //    O with the argument "length".
	    // 6. Let len be ToUint32(lenValue).
	    var len = toLength(O.length);
	
	    // 7. Let k be 0.
	    var k = 0;
	
	    // 8. Repeat, while k < len
	    while (k < len) {
	        // a. Let Pk be ToString(k).
	        var Pk = String(k);
	
	        // b. Let kPresent be the result of calling the [[HasProperty]] internal
	        //    method of O with argument Pk.
	        var kPresent = Pk in O;
	
	        // c. If kPresent is true, then
	        if (kPresent) {
	            // i. Let kValue be the result of calling the [[Get]] internal
	            //     method of O with argument Pk.
	            var kValue = O[Pk];
	
	            // ii. If the type of kValue is not String or Object, then throw a
	            //     TypeError exception.
	            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');
	
	            // iii. Let tag be ToString(kValue).
	            var tag = String(kValue);
	
	            // iv. If the result of calling the abstract operation
	            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
	            //     the argument, is false, then throw a RangeError exception.
	            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");
	
	            // v. Let tag be the result of calling the abstract operation
	            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
	            //    argument.
	            tag = CanonicalizeLanguageTag(tag);
	
	            // vi. If tag is not an element of seen, then append tag as the last
	            //     element of seen.
	            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
	        }
	
	        // d. Increase k by 1.
	        k++;
	    }
	
	    // 9. Return seen.
	    return seen;
	}
	
	/**
	 * The BestAvailableLocale abstract operation compares the provided argument
	 * locale, which must be a String value with a structurally valid and
	 * canonicalized BCP 47 language tag, against the locales in availableLocales and
	 * returns either the longest non-empty prefix of locale that is an element of
	 * availableLocales, or undefined if there is no such element. It uses the
	 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
	 */
	function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
	    // 1. Let candidate be locale
	    var candidate = locale;
	
	    // 2. Repeat
	    while (candidate) {
	        // a. If availableLocales contains an element equal to candidate, then return
	        // candidate.
	        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;
	
	        // b. Let pos be the character index of the last occurrence of "-"
	        // (U+002D) within candidate. If that character does not occur, return
	        // undefined.
	        var pos = candidate.lastIndexOf('-');
	
	        if (pos < 0) return;
	
	        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
	        //    then decrease pos by 2.
	        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;
	
	        // d. Let candidate be the substring of candidate from position 0, inclusive,
	        //    to position pos, exclusive.
	        candidate = candidate.substring(0, pos);
	    }
	}
	
	/**
	 * The LookupMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The following steps are taken:
	 */
	function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
	    // 1. Let i be 0.
	    var i = 0;
	
	    // 2. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	
	    // 3. Let availableLocale be undefined.
	    var availableLocale = void 0;
	
	    var locale = void 0,
	        noExtensionsLocale = void 0;
	
	    // 4. Repeat while i < len and availableLocale is undefined:
	    while (i < len && !availableLocale) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position i.
	        locale = requestedLocales[i];
	
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. Increase i by 1.
	        i++;
	    }
	
	    // 5. Let result be a new Record.
	    var result = new Record();
	
	    // 6. If availableLocale is not undefined, then
	    if (availableLocale !== undefined) {
	        // a. Set result.[[locale]] to availableLocale.
	        result['[[locale]]'] = availableLocale;
	
	        // b. If locale and noExtensionsLocale are not the same String value, then
	        if (String(locale) !== String(noExtensionsLocale)) {
	            // i. Let extension be the String value consisting of the first
	            //    substring of locale that is a Unicode locale extension sequence.
	            var extension = locale.match(expUnicodeExSeq)[0];
	
	            // ii. Let extensionIndex be the character position of the initial
	            //     "-" of the first Unicode locale extension sequence within locale.
	            var extensionIndex = locale.indexOf('-u-');
	
	            // iii. Set result.[[extension]] to extension.
	            result['[[extension]]'] = extension;
	
	            // iv. Set result.[[extensionIndex]] to extensionIndex.
	            result['[[extensionIndex]]'] = extensionIndex;
	        }
	    }
	    // 7. Else
	    else
	        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
	        //    operation (defined in 6.2.4).
	        result['[[locale]]'] = DefaultLocale();
	
	    // 8. Return result
	    return result;
	}
	
	/**
	 * The BestFitMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The algorithm is implementation dependent, but should produce results
	 * that a typical user of the requested locales would perceive as at least as
	 * good as those produced by the LookupMatcher abstract operation. Options
	 * specified through Unicode locale extension sequences must be ignored by the
	 * algorithm. Information about such subsequences is returned separately.
	 * The abstract operation returns a record with a [[locale]] field, whose value
	 * is the language tag of the selected locale, which must be an element of
	 * availableLocales. If the language tag of the request locale that led to the
	 * selected locale contained a Unicode locale extension sequence, then the
	 * returned record also contains an [[extension]] field whose value is the first
	 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
	 * is the index of the first Unicode locale extension sequence within the request
	 * locale language tag.
	 */
	function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
	    return LookupMatcher(availableLocales, requestedLocales);
	}
	
	/**
	 * The ResolveLocale abstract operation compares a BCP 47 language priority list
	 * requestedLocales against the locales in availableLocales and determines the
	 * best available language to meet the request. availableLocales and
	 * requestedLocales must be provided as List values, options as a Record.
	 */
	function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	    if (availableLocales.length === 0) {
	        throw new ReferenceError('No locale data has been provided for this object yet.');
	    }
	
	    // The following steps are taken:
	    // 1. Let matcher be the value of options.[[localeMatcher]].
	    var matcher = options['[[localeMatcher]]'];
	
	    var r = void 0;
	
	    // 2. If matcher is "lookup", then
	    if (matcher === 'lookup')
	        // a. Let r be the result of calling the LookupMatcher abstract operation
	        //    (defined in 9.2.3) with arguments availableLocales and
	        //    requestedLocales.
	        r = LookupMatcher(availableLocales, requestedLocales);
	
	        // 3. Else
	    else
	        // a. Let r be the result of calling the BestFitMatcher abstract
	        //    operation (defined in 9.2.4) with arguments availableLocales and
	        //    requestedLocales.
	        r = BestFitMatcher(availableLocales, requestedLocales);
	
	    // 4. Let foundLocale be the value of r.[[locale]].
	    var foundLocale = r['[[locale]]'];
	
	    var extensionSubtags = void 0,
	        extensionSubtagsLength = void 0;
	
	    // 5. If r has an [[extension]] field, then
	    if (hop.call(r, '[[extension]]')) {
	        // a. Let extension be the value of r.[[extension]].
	        var extension = r['[[extension]]'];
	        // b. Let split be the standard built-in function object defined in ES5,
	        //    15.5.4.14.
	        var split = String.prototype.split;
	        // c. Let extensionSubtags be the result of calling the [[Call]] internal
	        //    method of split with extension as the this value and an argument
	        //    list containing the single item "-".
	        extensionSubtags = split.call(extension, '-');
	        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
	        //    internal method of extensionSubtags with argument "length".
	        extensionSubtagsLength = extensionSubtags.length;
	    }
	
	    // 6. Let result be a new Record.
	    var result = new Record();
	
	    // 7. Set result.[[dataLocale]] to foundLocale.
	    result['[[dataLocale]]'] = foundLocale;
	
	    // 8. Let supportedExtension be "-u".
	    var supportedExtension = '-u';
	    // 9. Let i be 0.
	    var i = 0;
	    // 10. Let len be the result of calling the [[Get]] internal method of
	    //     relevantExtensionKeys with argument "length".
	    var len = relevantExtensionKeys.length;
	
	    // 11 Repeat while i < len:
	    while (i < len) {
	        // a. Let key be the result of calling the [[Get]] internal method of
	        //    relevantExtensionKeys with argument ToString(i).
	        var key = relevantExtensionKeys[i];
	        // b. Let foundLocaleData be the result of calling the [[Get]] internal
	        //    method of localeData with the argument foundLocale.
	        var foundLocaleData = localeData[foundLocale];
	        // c. Let keyLocaleData be the result of calling the [[Get]] internal
	        //    method of foundLocaleData with the argument key.
	        var keyLocaleData = foundLocaleData[key];
	        // d. Let value be the result of calling the [[Get]] internal method of
	        //    keyLocaleData with argument "0".
	        var value = keyLocaleData['0'];
	        // e. Let supportedExtensionAddition be "".
	        var supportedExtensionAddition = '';
	        // f. Let indexOf be the standard built-in function object defined in
	        //    ES5, 15.4.4.14.
	        var indexOf = arrIndexOf;
	
	        // g. If extensionSubtags is not undefined, then
	        if (extensionSubtags !== undefined) {
	            // i. Let keyPos be the result of calling the [[Call]] internal
	            //    method of indexOf with extensionSubtags as the this value and
	            // an argument list containing the single item key.
	            var keyPos = indexOf.call(extensionSubtags, key);
	
	            // ii. If keyPos ≠ -1, then
	            if (keyPos !== -1) {
	                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
	                //    result of calling the [[Get]] internal method of
	                //    extensionSubtags with argument ToString(keyPos +1) is greater
	                //    than 2, then
	                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
	                    // a. Let requestedValue be the result of calling the [[Get]]
	                    //    internal method of extensionSubtags with argument
	                    //    ToString(keyPos + 1).
	                    var requestedValue = extensionSubtags[keyPos + 1];
	                    // b. Let valuePos be the result of calling the [[Call]]
	                    //    internal method of indexOf with keyLocaleData as the
	                    //    this value and an argument list containing the single
	                    //    item requestedValue.
	                    var valuePos = indexOf.call(keyLocaleData, requestedValue);
	
	                    // c. If valuePos ≠ -1, then
	                    if (valuePos !== -1) {
	                        // i. Let value be requestedValue.
	                        value = requestedValue,
	                        // ii. Let supportedExtensionAddition be the
	                        //     concatenation of "-", key, "-", and value.
	                        supportedExtensionAddition = '-' + key + '-' + value;
	                    }
	                }
	                // 2. Else
	                else {
	                        // a. Let valuePos be the result of calling the [[Call]]
	                        // internal method of indexOf with keyLocaleData as the this
	                        // value and an argument list containing the single item
	                        // "true".
	                        var _valuePos = indexOf(keyLocaleData, 'true');
	
	                        // b. If valuePos ≠ -1, then
	                        if (_valuePos !== -1)
	                            // i. Let value be "true".
	                            value = 'true';
	                    }
	            }
	        }
	        // h. If options has a field [[<key>]], then
	        if (hop.call(options, '[[' + key + ']]')) {
	            // i. Let optionsValue be the value of options.[[<key>]].
	            var optionsValue = options['[[' + key + ']]'];
	
	            // ii. If the result of calling the [[Call]] internal method of indexOf
	            //     with keyLocaleData as the this value and an argument list
	            //     containing the single item optionsValue is not -1, then
	            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
	                // 1. If optionsValue is not equal to value, then
	                if (optionsValue !== value) {
	                    // a. Let value be optionsValue.
	                    value = optionsValue;
	                    // b. Let supportedExtensionAddition be "".
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        // i. Set result.[[<key>]] to value.
	        result['[[' + key + ']]'] = value;
	
	        // j. Append supportedExtensionAddition to supportedExtension.
	        supportedExtension += supportedExtensionAddition;
	
	        // k. Increase i by 1.
	        i++;
	    }
	    // 12. If the length of supportedExtension is greater than 2, then
	    if (supportedExtension.length > 2) {
	        // a.
	        var privateIndex = foundLocale.indexOf("-x-");
	        // b.
	        if (privateIndex === -1) {
	            // i.
	            foundLocale = foundLocale + supportedExtension;
	        }
	        // c.
	        else {
	                // i.
	                var preExtension = foundLocale.substring(0, privateIndex);
	                // ii.
	                var postExtension = foundLocale.substring(privateIndex);
	                // iii.
	                foundLocale = preExtension + supportedExtension + postExtension;
	            }
	        // d. asserting - skipping
	        // e.
	        foundLocale = CanonicalizeLanguageTag(foundLocale);
	    }
	    // 13. Set result.[[locale]] to foundLocale.
	    result['[[locale]]'] = foundLocale;
	
	    // 14. Return result.
	    return result;
	}
	
	/**
	 * The LookupSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
	 * Locales appear in the same order in the returned list as in requestedLocales.
	 * The following steps are taken:
	 */
	function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
	    // 1. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	    // 2. Let subset be a new empty List.
	    var subset = new List();
	    // 3. Let k be 0.
	    var k = 0;
	
	    // 4. Repeat while k < len
	    while (k < len) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position k.
	        var locale = requestedLocales[k];
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. If availableLocale is not undefined, then append locale to the end of
	        //    subset.
	        if (availableLocale !== undefined) arrPush.call(subset, locale);
	
	        // e. Increment k by 1.
	        k++;
	    }
	
	    // 5. Let subsetArray be a new Array object whose elements are the same
	    //    values in the same order as the elements of subset.
	    var subsetArray = arrSlice.call(subset);
	
	    // 6. Return subsetArray.
	    return subsetArray;
	}
	
	/**
	 * The BestFitSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the Best Fit Matcher
	 * algorithm. Locales appear in the same order in the returned list as in
	 * requestedLocales. The steps taken are implementation dependent.
	 */
	function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
	    // ###TODO: implement this function as described by the specification###
	    return LookupSupportedLocales(availableLocales, requestedLocales);
	}
	
	/**
	 * The SupportedLocales abstract operation returns the subset of the provided BCP
	 * 47 language priority list requestedLocales for which availableLocales has a
	 * matching locale. Two algorithms are available to match the locales: the Lookup
	 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
	 * best-fit algorithm. Locales appear in the same order in the returned list as
	 * in requestedLocales. The following steps are taken:
	 */
	function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = void 0,
	        subset = void 0;
	
	    // 1. If options is not undefined, then
	    if (options !== undefined) {
	        // a. Let options be ToObject(options).
	        options = new Record(toObject(options));
	        // b. Let matcher be the result of calling the [[Get]] internal method of
	        //    options with argument "localeMatcher".
	        matcher = options.localeMatcher;
	
	        // c. If matcher is not undefined, then
	        if (matcher !== undefined) {
	            // i. Let matcher be ToString(matcher).
	            matcher = String(matcher);
	
	            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
	            //     exception.
	            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
	        }
	    }
	    // 2. If matcher is undefined or "best fit", then
	    if (matcher === undefined || matcher === 'best fit')
	        // a. Let subset be the result of calling the BestFitSupportedLocales
	        //    abstract operation (defined in 9.2.7) with arguments
	        //    availableLocales and requestedLocales.
	        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
	        // 3. Else
	    else
	        // a. Let subset be the result of calling the LookupSupportedLocales
	        //    abstract operation (defined in 9.2.6) with arguments
	        //    availableLocales and requestedLocales.
	        subset = LookupSupportedLocales(availableLocales, requestedLocales);
	
	    // 4. For each named own property name P of subset,
	    for (var P in subset) {
	        if (!hop.call(subset, P)) continue;
	
	        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
	        //    method of subset with P.
	        // b. Set desc.[[Writable]] to false.
	        // c. Set desc.[[Configurable]] to false.
	        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
	        //    and true as arguments.
	        defineProperty(subset, P, {
	            writable: false, configurable: false, value: subset[P]
	        });
	    }
	    // "Freeze" the array so no new elements can be added
	    defineProperty(subset, 'length', { writable: false });
	
	    // 5. Return subset
	    return subset;
	}
	
	/**
	 * The GetOption abstract operation extracts the value of the property named
	 * property from the provided options object, converts it to the required type,
	 * checks whether it is one of a List of allowed values, and fills in a fallback
	 * value if necessary.
	 */
	function /*9.2.9 */GetOption(options, property, type, values, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Assert: type is "boolean" or "string".
	        // b. If type is "boolean", then let value be ToBoolean(value).
	        // c. If type is "string", then let value be ToString(value).
	        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;
	
	        // d. If values is not undefined, then
	        if (values !== undefined) {
	            // i. If values does not contain an element equal to value, then throw a
	            //    RangeError exception.
	            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
	        }
	
	        // e. Return value.
	        return value;
	    }
	    // Else return fallback.
	    return fallback;
	}
	
	/**
	 * The GetNumberOption abstract operation extracts a property value from the
	 * provided options object, converts it to a Number value, checks whether it is
	 * in the allowed range, and fills in a fallback value if necessary.
	 */
	function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Let value be ToNumber(value).
	        value = Number(value);
	
	        // b. If value is NaN or less than minimum or greater than maximum, throw a
	        //    RangeError exception.
	        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');
	
	        // c. Return floor(value).
	        return Math.floor(value);
	    }
	    // 3. Else return fallback.
	    return fallback;
	}
	
	// 8 The Intl Object
	var Intl = {};
	
	// 8.2 Function Properties of the Intl Object
	
	// 8.2.1
	// @spec[tc39/ecma402/master/spec/intl.html]
	// @clause[sec-intl.getcanonicallocales]
	function getCanonicalLocales(locales) {
	    // 1. Let ll be ? CanonicalizeLocaleList(locales).
	    var ll = CanonicalizeLocaleList(locales);
	    // 2. Return CreateArrayFromList(ll).
	    {
	        var result = [];
	
	        var len = ll.length;
	        var k = 0;
	
	        while (k < len) {
	            result[k] = ll[k];
	            k++;
	        }
	        return result;
	    }
	}
	
	Object.defineProperty(Intl, 'getCanonicalLocales', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: getCanonicalLocales
	});
	
	// Currency minor units output from get-4217 grunt task, formatted
	var currencyMinorUnits = {
	    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
	    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
	    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
	};
	
	// Define the NumberFormat constructor internally so it cannot be tainted
	function NumberFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.NumberFormat(locales, options);
	    }
	
	    return InitializeNumberFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'NumberFormat', {
	    configurable: true,
	    writable: true,
	    value: NumberFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(Intl.NumberFormat, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeNumberFormat accepts the arguments
	 * numberFormat (which must be an object), locales, and options. It initializes
	 * numberFormat as a NumberFormat object.
	 */
	function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(numberFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
	    // value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(numberFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. If options is undefined, then
	    if (options === undefined)
	        // a. Let options be the result of creating a new object as if by the
	        // expression new Object() where Object is the standard built-in constructor
	        // with that name.
	        options = {};
	
	        // 5. Else
	    else
	        // a. Let options be ToObject(options).
	        options = toObject(options);
	
	    // 6. Let opt be a new Record.
	    var opt = new Record(),
	
	
	    // 7. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
	    //    a List containing the two String values "lookup" and "best fit", and
	    //    "best fit".
	    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 8. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 9. Let NumberFormat be the standard built-in object that is the initial value
	    //    of Intl.NumberFormat.
	    // 10. Let localeData be the value of the [[localeData]] internal property of
	    //     NumberFormat.
	    var localeData = internals.NumberFormat['[[localeData]]'];
	
	    // 11. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //     internal property of NumberFormat, and localeData.
	    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 12. Set the [[locale]] internal property of numberFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
	    //     of r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let s be the result of calling the GetOption abstract operation with the
	    //     arguments options, "style", "string", a List containing the three String
	    //     values "decimal", "percent", and "currency", and "decimal".
	    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');
	
	    // 16. Set the [[style]] internal property of numberFormat to s.
	    internal['[[style]]'] = s;
	
	    // 17. Let c be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currency", "string", undefined, and undefined.
	    var c = GetOption(options, 'currency', 'string');
	
	    // 18. If c is not undefined and the result of calling the
	    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
	    //     argument c is false, then throw a RangeError exception.
	    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");
	
	    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
	    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');
	
	    var cDigits = void 0;
	
	    // 20. If s is "currency", then
	    if (s === 'currency') {
	        // a. Let c be the result of converting c to upper case as specified in 6.1.
	        c = c.toUpperCase();
	
	        // b. Set the [[currency]] internal property of numberFormat to c.
	        internal['[[currency]]'] = c;
	
	        // c. Let cDigits be the result of calling the CurrencyDigits abstract
	        //    operation (defined below) with argument c.
	        cDigits = CurrencyDigits(c);
	    }
	
	    // 21. Let cd be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currencyDisplay", "string", a List containing the
	    //     three String values "code", "symbol", and "name", and "symbol".
	    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');
	
	    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
	    //     numberFormat to cd.
	    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;
	
	    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
	    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
	    //     and 1.
	    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);
	
	    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
	    internal['[[minimumIntegerDigits]]'] = mnid;
	
	    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
	    //     be 0.
	    var mnfdDefault = s === 'currency' ? cDigits : 0;
	
	    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
	    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);
	
	    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
	    internal['[[minimumFractionDigits]]'] = mnfd;
	
	    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
	    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
	    //     be max(mnfd, 3).
	    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);
	
	    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
	    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);
	
	    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
	    internal['[[maximumFractionDigits]]'] = mxfd;
	
	    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
	    //     with argument "minimumSignificantDigits".
	    var mnsd = options.minimumSignificantDigits;
	
	    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
	    //     with argument "maximumSignificantDigits".
	    var mxsd = options.maximumSignificantDigits;
	
	    // 33. If mnsd is not undefined or mxsd is not undefined, then:
	    if (mnsd !== undefined || mxsd !== undefined) {
	        // a. Let mnsd be the result of calling the GetNumberOption abstract
	        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
	        //    and 1.
	        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);
	
	        // b. Let mxsd be the result of calling the GetNumberOption abstract
	        //     operation with arguments options, "maximumSignificantDigits", mnsd,
	        //     21, and 21.
	        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);
	
	        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
	        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
	        //    numberFormat to mxsd.
	        internal['[[minimumSignificantDigits]]'] = mnsd;
	        internal['[[maximumSignificantDigits]]'] = mxsd;
	    }
	    // 34. Let g be the result of calling the GetOption abstract operation with the
	    //     arguments options, "useGrouping", "boolean", undefined, and true.
	    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);
	
	    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
	    internal['[[useGrouping]]'] = g;
	
	    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 37. Let patterns be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "patterns".
	    var patterns = dataLocaleData.patterns;
	
	    // 38. Assert: patterns is an object (see 11.2.3)
	
	    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
	    //     patterns with argument s.
	    var stylePatterns = patterns[s];
	
	    // 40. Set the [[positivePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "positivePattern".
	    internal['[[positivePattern]]'] = stylePatterns.positivePattern;
	
	    // 41. Set the [[negativePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "negativePattern".
	    internal['[[negativePattern]]'] = stylePatterns.negativePattern;
	
	    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
	    //     true.
	    internal['[[initializedNumberFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return numberFormat;
	}
	
	function CurrencyDigits(currency) {
	    // When the CurrencyDigits abstract operation is called with an argument currency
	    // (which must be an upper case String value), the following steps are taken:
	
	    // 1. If the ISO 4217 currency and funds code list contains currency as an
	    // alphabetic code, then return the minor unit value corresponding to the
	    // currency from the list; else return 2.
	    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
	}
	
	/* 11.2.3 */internals.NumberFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
	 * following steps are taken:
	 */
	/* 11.2.2 */
	defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * NumberFormat object.
	 */
	/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatNumber
	});
	
	function GetFormatNumber() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 11.3_b
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this NumberFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 1, that takes the argument value and
	        //    performs the following steps:
	        var F = function F(value) {
	            // i. If value is not provided, then let value be undefined.
	            // ii. Let x be ToNumber(value).
	            // iii. Return the result of calling the FormatNumber abstract
	            //      operation (defined below) with arguments this and x.
	            return FormatNumber(this, /* x = */Number(value));
	        };
	
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');
	
	    var x = Number(value);
	    return FormatNumberToParts(this, x);
	}
	
	Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
	    configurable: true,
	    enumerable: false,
	    writable: true,
	    value: formatToParts
	});
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumbertoparts]
	 */
	function FormatNumberToParts(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be ArrayCreate(0).
	    var result = [];
	    // 3. Let n be 0.
	    var n = 0;
	    // 4. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Let O be ObjectCreate(%ObjectPrototype%).
	        var O = {};
	        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
	        O.type = part['[[type]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
	        O.value = part['[[value]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
	        result[n] = O;
	        // a. Increment n by 1.
	        n += 1;
	    }
	    // 5. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-partitionnumberpattern]
	 */
	function PartitionNumberPattern(numberFormat, x) {
	
	    var internal = getInternalProperties(numberFormat),
	        locale = internal['[[dataLocale]]'],
	        nums = internal['[[numberingSystem]]'],
	        data = internals.NumberFormat['[[localeData]]'][locale],
	        ild = data.symbols[nums] || data.symbols.latn,
	        pattern = void 0;
	
	    // 1. If x is not NaN and x < 0, then:
	    if (!isNaN(x) && x < 0) {
	        // a. Let x be -x.
	        x = -x;
	        // a. Let pattern be the value of numberFormat.[[negativePattern]].
	        pattern = internal['[[negativePattern]]'];
	    }
	    // 2. Else,
	    else {
	            // a. Let pattern be the value of numberFormat.[[positivePattern]].
	            pattern = internal['[[positivePattern]]'];
	        }
	    // 3. Let result be a new empty List.
	    var result = new List();
	    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
	    var beginIndex = pattern.indexOf('{', 0);
	    // 5. Let endIndex be 0.
	    var endIndex = 0;
	    // 6. Let nextIndex be 0.
	    var nextIndex = 0;
	    // 7. Let length be the number of code units in pattern.
	    var length = pattern.length;
	    // 8. Repeat while beginIndex is an integer index into pattern:
	    while (beginIndex > -1 && beginIndex < length) {
	        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
	        endIndex = pattern.indexOf('}', beginIndex);
	        // a. If endIndex = -1, throw new Error exception.
	        if (endIndex === -1) throw new Error();
	        // a. If beginIndex is greater than nextIndex, then:
	        if (beginIndex > nextIndex) {
	            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
	            var literal = pattern.substring(nextIndex, beginIndex);
	            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
	        }
	        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // a. If p is equal "number", then:
	        if (p === "number") {
	            // i. If x is NaN,
	            if (isNaN(x)) {
	                // 1. Let n be an ILD String value indicating the NaN value.
	                var n = ild.nan;
	                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
	            }
	            // ii. Else if isFinite(x) is false,
	            else if (!isFinite(x)) {
	                    // 1. Let n be an ILD String value indicating infinity.
	                    var _n = ild.infinity;
	                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
	                }
	                // iii. Else,
	                else {
	                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
	                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;
	
	                        var _n2 = void 0;
	                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
	                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
	                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
	                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
	                        }
	                        // 3. Else,
	                        else {
	                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
	                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
	                            }
	                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
	                        if (numSys[nums]) {
	                            (function () {
	                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
	                                var digits = numSys[nums];
	                                // a. Replace each digit in n with the value of digits[digit].
	                                _n2 = String(_n2).replace(/\d/g, function (digit) {
	                                    return digits[digit];
	                                });
	                            })();
	                        }
	                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
	                        else _n2 = String(_n2); // ###TODO###
	
	                        var integer = void 0;
	                        var fraction = void 0;
	                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
	                        var decimalSepIndex = _n2.indexOf('.', 0);
	                        // 7. If decimalSepIndex > 0, then:
	                        if (decimalSepIndex > 0) {
	                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
	                            integer = _n2.substring(0, decimalSepIndex);
	                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
	                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
	                        }
	                        // 8. Else:
	                        else {
	                                // a. Let integer be n.
	                                integer = _n2;
	                                // a. Let fraction be undefined.
	                                fraction = undefined;
	                            }
	                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
	                        if (internal['[[useGrouping]]'] === true) {
	                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
	                            var groupSepSymbol = ild.group;
	                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
	                            var groups = [];
	                            // ----> implementation:
	                            // Primary group represents the group closest to the decimal
	                            var pgSize = data.patterns.primaryGroupSize || 3;
	                            // Secondary group is every other group
	                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
	                            // Group only if necessary
	                            if (integer.length > pgSize) {
	                                // Index of the primary grouping separator
	                                var end = integer.length - pgSize;
	                                // Starting index for our loop
	                                var idx = end % sgSize;
	                                var start = integer.slice(0, idx);
	                                if (start.length) arrPush.call(groups, start);
	                                // Loop to separate into secondary grouping digits
	                                while (idx < end) {
	                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
	                                    idx += sgSize;
	                                }
	                                // Add the primary grouping digits
	                                arrPush.call(groups, integer.slice(end));
	                            } else {
	                                arrPush.call(groups, integer);
	                            }
	                            // a. Assert: The number of elements in groups List is greater than 0.
	                            if (groups.length === 0) throw new Error();
	                            // a. Repeat, while groups List is not empty:
	                            while (groups.length) {
	                                // i. Remove the first element from groups and let integerGroup be the value of that element.
	                                var integerGroup = arrShift.call(groups);
	                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
	                                // iii. If groups List is not empty, then:
	                                if (groups.length) {
	                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
	                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
	                                }
	                            }
	                        }
	                        // 10. Else,
	                        else {
	                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
	                            }
	                        // 11. If fraction is not undefined, then:
	                        if (fraction !== undefined) {
	                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
	                            var decimalSepSymbol = ild.decimal;
	                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
	                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
	                        }
	                    }
	        }
	        // a. Else if p is equal "plusSign", then:
	        else if (p === "plusSign") {
	                // i. Let plusSignSymbol be the ILND String representing the plus sign.
	                var plusSignSymbol = ild.plusSign;
	                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
	            }
	            // a. Else if p is equal "minusSign", then:
	            else if (p === "minusSign") {
	                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
	                    var minusSignSymbol = ild.minusSign;
	                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
	                }
	                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
	                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
	                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
	                        var percentSignSymbol = ild.percentSign;
	                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
	                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
	                    }
	                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
	                    else if (p === "currency" && internal['[[style]]'] === "currency") {
	                            // i. Let currency be the value of numberFormat.[[currency]].
	                            var currency = internal['[[currency]]'];
	
	                            var cd = void 0;
	
	                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
	                            if (internal['[[currencyDisplay]]'] === "code") {
	                                // 1. Let cd be currency.
	                                cd = currency;
	                            }
	                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
	                            else if (internal['[[currencyDisplay]]'] === "symbol") {
	                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
	                                    cd = data.currencies[currency] || currency;
	                                }
	                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
	                                else if (internal['[[currencyDisplay]]'] === "name") {
	                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
	                                        cd = currency;
	                                    }
	                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
	                        }
	                        // a. Else,
	                        else {
	                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
	                                var _literal = pattern.substring(beginIndex, endIndex);
	                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
	                            }
	        // a. Set nextIndex to endIndex + 1.
	        nextIndex = endIndex + 1;
	        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    // 9. If nextIndex is less than length, then:
	    if (nextIndex < length) {
	        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
	        var _literal2 = pattern.substring(nextIndex, length);
	        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
	    }
	    // 10. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumber]
	 */
	function FormatNumber(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be an empty String.
	    var result = '';
	    // 3. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Set result to a String value produced by concatenating result and part.[[value]].
	        result += part['[[value]]'];
	    }
	    // 4. Return result.
	    return result;
	}
	
	/**
	 * When the ToRawPrecision abstract operation is called with arguments x (which
	 * must be a finite non-negative number), minPrecision, and maxPrecision (both
	 * must be integers between 1 and 21) the following steps are taken:
	 */
	function ToRawPrecision(x, minPrecision, maxPrecision) {
	    // 1. Let p be maxPrecision.
	    var p = maxPrecision;
	
	    var m = void 0,
	        e = void 0;
	
	    // 2. If x = 0, then
	    if (x === 0) {
	        // a. Let m be the String consisting of p occurrences of the character "0".
	        m = arrJoin.call(Array(p + 1), '0');
	        // b. Let e be 0.
	        e = 0;
	    }
	    // 3. Else
	    else {
	            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
	            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
	            //    possible. If there are two such sets of e and n, pick the e and n for
	            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
	            e = log10Floor(Math.abs(x));
	
	            // Easier to get to m from here
	            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));
	
	            // b. Let m be the String consisting of the digits of the decimal
	            //    representation of n (in order, with no leading zeroes)
	            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
	        }
	
	    // 4. If e ≥ p, then
	    if (e >= p)
	        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
	        return m + arrJoin.call(Array(e - p + 1 + 1), '0');
	
	        // 5. If e = p-1, then
	    else if (e === p - 1)
	            // a. Return m.
	            return m;
	
	            // 6. If e ≥ 0, then
	        else if (e >= 0)
	                // a. Let m be the concatenation of the first e+1 characters of m, the character
	                //    ".", and the remaining p–(e+1) characters of m.
	                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);
	
	                // 7. If e < 0, then
	            else if (e < 0)
	                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
	                    //    character "0", and the string m.
	                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;
	
	    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
	    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
	        // a. Let cut be maxPrecision – minPrecision.
	        var cut = maxPrecision - minPrecision;
	
	        // b. Repeat while cut > 0 and the last character of m is "0":
	        while (cut > 0 && m.charAt(m.length - 1) === '0') {
	            //  i. Remove the last character from m.
	            m = m.slice(0, -1);
	
	            //  ii. Decrease cut by 1.
	            cut--;
	        }
	
	        // c. If the last character of m is ".", then
	        if (m.charAt(m.length - 1) === '.')
	            //    i. Remove the last character from m.
	            m = m.slice(0, -1);
	    }
	    // 9. Return m.
	    return m;
	}
	
	/**
	 * @spec[tc39/ecma402/master/spec/numberformat.html]
	 * @clause[sec-torawfixed]
	 * When the ToRawFixed abstract operation is called with arguments x (which must
	 * be a finite non-negative number), minInteger (which must be an integer between
	 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
	 * 20) the following steps are taken:
	 */
	function ToRawFixed(x, minInteger, minFraction, maxFraction) {
	    // 1. Let f be maxFraction.
	    var f = maxFraction;
	    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
	    var n = Math.pow(10, f) * x; // diverging...
	    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
	    var m = n === 0 ? "0" : n.toFixed(0); // divering...
	
	    {
	        // this diversion is needed to take into consideration big numbers, e.g.:
	        // 1.2344501e+37 -> 12344501000000000000000000000000000000
	        var idx = void 0;
	        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
	        if (exp) {
	            m = m.slice(0, idx).replace('.', '');
	            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
	        }
	    }
	
	    var int = void 0;
	    // 4. If f ≠ 0, then
	    if (f !== 0) {
	        // a. Let k be the number of characters in m.
	        var k = m.length;
	        // a. If k ≤ f, then
	        if (k <= f) {
	            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
	            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
	            // ii. Let m be the concatenation of Strings z and m.
	            m = z + m;
	            // iii. Let k be f+1.
	            k = f + 1;
	        }
	        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
	        var a = m.substring(0, k - f),
	            b = m.substring(k - f, m.length);
	        // a. Let m be the concatenation of the three Strings a, ".", and b.
	        m = a + "." + b;
	        // a. Let int be the number of characters in a.
	        int = a.length;
	    }
	    // 5. Else, let int be the number of characters in m.
	    else int = m.length;
	    // 6. Let cut be maxFraction – minFraction.
	    var cut = maxFraction - minFraction;
	    // 7. Repeat while cut > 0 and the last character of m is "0":
	    while (cut > 0 && m.slice(-1) === "0") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	        // a. Decrease cut by 1.
	        cut--;
	    }
	    // 8. If the last character of m is ".", then
	    if (m.slice(-1) === ".") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	    }
	    // 9. If int < minInteger, then
	    if (int < minInteger) {
	        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
	        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
	        // a. Let m be the concatenation of Strings z and m.
	        m = _z + m;
	    }
	    // 10. Return m.
	    return m;
	}
	
	// Sect 11.3.2 Table 2, Numbering systems
	// ======================================
	var numSys = {
	    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
	    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
	    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
	    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
	    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
	    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
	    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
	    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
	    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
	    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
	    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
	    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
	    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
	    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
	    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
	    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
	    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
	    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
	    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
	    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
	    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
	    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
	};
	
	/**
	 * This function provides access to the locale and formatting options computed
	 * during initialization of the object.
	 *
	 * The function returns a new object whose properties and attributes are set as
	 * if constructed by an object literal assigning to each of the following
	 * properties the value of the corresponding internal property of this
	 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
	 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
	 * useGrouping. Properties whose corresponding internal properties are not present
	 * are not assigned.
	 */
	/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
	    configurable: true,
	    writable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	/* jslint esnext: true */
	
	// Match these datetime components in a CLDR pattern, except those in single quotes
	var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	// trim patterns after transformations
	var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	// Skip over patterns with these datetime components because we don't have data
	// to back them up:
	// timezone, weekday, amoung others
	var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string
	
	var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
	var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];
	
	function isDateFormatOnly(obj) {
	    for (var i = 0; i < tmKeys.length; i += 1) {
	        if (obj.hasOwnProperty(tmKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function isTimeFormatOnly(obj) {
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (obj.hasOwnProperty(dtKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
	    var o = { _: {} };
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (dateFormatObj[dtKeys[i]]) {
	            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
	        }
	        if (dateFormatObj._[dtKeys[i]]) {
	            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
	        }
	    }
	    for (var j = 0; j < tmKeys.length; j += 1) {
	        if (timeFormatObj[tmKeys[j]]) {
	            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
	        }
	        if (timeFormatObj._[tmKeys[j]]) {
	            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
	        }
	    }
	    return o;
	}
	
	function computeFinalPatterns(formatObj) {
	    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
	    //  'In patterns, two single quotes represents a literal single quote, either
	    //   inside or outside single quotes. Text within single quotes is not
	    //   interpreted in any way (except for two adjacent single quotes).'
	    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
	        return literal ? literal : "'";
	    });
	
	    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
	    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
	    return formatObj;
	}
	
	function expDTComponentsMeta($0, formatObj) {
	    switch ($0.charAt(0)) {
	        // --- Era
	        case 'G':
	            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{era}';
	
	        // --- Year
	        case 'y':
	        case 'Y':
	        case 'u':
	        case 'U':
	        case 'r':
	            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{year}';
	
	        // --- Quarter (not supported in this polyfill)
	        case 'Q':
	        case 'q':
	            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{quarter}';
	
	        // --- Month
	        case 'M':
	        case 'L':
	            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{month}';
	
	        // --- Week (not supported in this polyfill)
	        case 'w':
	            // week of the year
	            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{weekday}';
	        case 'W':
	            // week of the month
	            formatObj.week = 'numeric';
	            return '{weekday}';
	
	        // --- Day
	        case 'd':
	            // day of the month
	            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{day}';
	        case 'D': // day of the year
	        case 'F': // day of the week
	        case 'g':
	            // 1..n: Modified Julian day
	            formatObj.day = 'numeric';
	            return '{day}';
	
	        // --- Week Day
	        case 'E':
	            // day of the week
	            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'e':
	            // local day of the week
	            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'c':
	            // stand alone local day of the week
	            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	
	        // --- Period
	        case 'a': // AM, PM
	        case 'b': // am, pm, noon, midnight
	        case 'B':
	            // flexible day periods
	            formatObj.hour12 = true;
	            return '{ampm}';
	
	        // --- Hour
	        case 'h':
	        case 'H':
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	        case 'k':
	        case 'K':
	            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	
	        // --- Minute
	        case 'm':
	            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{minute}';
	
	        // --- Second
	        case 's':
	            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{second}';
	        case 'S':
	        case 'A':
	            formatObj.second = 'numeric';
	            return '{second}';
	
	        // --- Timezone
	        case 'z': // 1..3, 4: specific non-location format
	        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	        case 'O': // 1, 4: miliseconds in day short, long
	        case 'v': // 1, 4: generic non-location format
	        case 'V': // 1, 2, 3, 4: time zone ID or city
	        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	        case 'x':
	            // 1, 2, 3, 4: The ISO8601 varios formats
	            // this polyfill only supports much, for now, we are just doing something dummy
	            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
	            return '{timeZoneName}';
	    }
	}
	
	/**
	 * Converts the CLDR availableFormats into the objects and patterns required by
	 * the ECMAScript Internationalization API specification.
	 */
	function createDateTimeFormat(skeleton, pattern) {
	    // we ignore certain patterns that are unsupported to avoid this expensive op.
	    if (unwantedDTCs.test(pattern)) return undefined;
	
	    var formatObj = {
	        originalPattern: pattern,
	        _: {}
	    };
	
	    // Replace the pattern string with the one required by the specification, whilst
	    // at the same time evaluating it for the subsets and formats
	    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj._);
	    });
	
	    // Match the skeleton string with the one required by the specification
	    // this implementation is based on the Date Field Symbol Table:
	    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	    // Note: we are adding extra data to the formatObject even though this polyfill
	    //       might not support it.
	    skeleton.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj);
	    });
	
	    return computeFinalPatterns(formatObj);
	}
	
	/**
	 * Processes DateTime formats from CLDR to an easier-to-parse format.
	 * the result of this operation should be cached the first time a particular
	 * calendar is analyzed.
	 *
	 * The specification requires we support at least the following subsets of
	 * date/time components:
	 *
	 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
	 *   - 'weekday', 'year', 'month', 'day'
	 *   - 'year', 'month', 'day'
	 *   - 'year', 'month'
	 *   - 'month', 'day'
	 *   - 'hour', 'minute', 'second'
	 *   - 'hour', 'minute'
	 *
	 * We need to cherry pick at least these subsets from the CLDR data and convert
	 * them into the pattern objects used in the ECMA-402 API.
	 */
	function createDateTimeFormats(formats) {
	    var availableFormats = formats.availableFormats;
	    var timeFormats = formats.timeFormats;
	    var dateFormats = formats.dateFormats;
	    var result = [];
	    var skeleton = void 0,
	        pattern = void 0,
	        computed = void 0,
	        i = void 0,
	        j = void 0;
	    var timeRelatedFormats = [];
	    var dateRelatedFormats = [];
	
	    // Map available (custom) formats into a pattern for createDateTimeFormats
	    for (skeleton in availableFormats) {
	        if (availableFormats.hasOwnProperty(skeleton)) {
	            pattern = availableFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                // in some cases, the format is only displaying date specific props
	                // or time specific props, in which case we need to also produce the
	                // combined formats.
	                if (isDateFormatOnly(computed)) {
	                    dateRelatedFormats.push(computed);
	                } else if (isTimeFormatOnly(computed)) {
	                    timeRelatedFormats.push(computed);
	                }
	            }
	        }
	    }
	
	    // Map time formats into a pattern for createDateTimeFormats
	    for (skeleton in timeFormats) {
	        if (timeFormats.hasOwnProperty(skeleton)) {
	            pattern = timeFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                timeRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // Map date formats into a pattern for createDateTimeFormats
	    for (skeleton in dateFormats) {
	        if (dateFormats.hasOwnProperty(skeleton)) {
	            pattern = dateFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                dateRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // combine custom time and custom date formats when they are orthogonals to complete the
	    // formats supported by CLDR.
	    // This Algo is based on section "Missing Skeleton Fields" from:
	    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
	    for (i = 0; i < timeRelatedFormats.length; i += 1) {
	        for (j = 0; j < dateRelatedFormats.length; j += 1) {
	            if (dateRelatedFormats[j].month === 'long') {
	                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
	            } else if (dateRelatedFormats[j].month === 'short') {
	                pattern = formats.medium;
	            } else {
	                pattern = formats.short;
	            }
	            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
	            computed.originalPattern = pattern;
	            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
	            result.push(computeFinalPatterns(computed));
	        }
	    }
	
	    return result;
	}
	
	// this represents the exceptions of the rule that are not covered by CLDR availableFormats
	// for single property configurations, they play no role when using multiple properties, and
	// those that are not in this table, are not exceptions or are not covered by the data we
	// provide.
	var validSyntheticProps = {
	    second: {
	        numeric: 's',
	        '2-digit': 'ss'
	    },
	    minute: {
	        numeric: 'm',
	        '2-digit': 'mm'
	    },
	    year: {
	        numeric: 'y',
	        '2-digit': 'yy'
	    },
	    day: {
	        numeric: 'd',
	        '2-digit': 'dd'
	    },
	    month: {
	        numeric: 'L',
	        '2-digit': 'LL',
	        narrow: 'LLLLL',
	        short: 'LLL',
	        long: 'LLLL'
	    },
	    weekday: {
	        narrow: 'ccccc',
	        short: 'ccc',
	        long: 'cccc'
	    }
	};
	
	function generateSyntheticFormat(propName, propValue) {
	    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
	        var _ref2;
	
	        return _ref2 = {
	            originalPattern: validSyntheticProps[propName][propValue],
	            _: defineProperty$1({}, propName, propValue),
	            extendedPattern: "{" + propName + "}"
	        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
	    }
	}
	
	// An object map of date component keys, saves using a regex later
	var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });
	
	/**
	 * Returns a string for a date component, resolved using multiple inheritance as specified
	 * as specified in the Unicode Technical Standard 35.
	 */
	function resolveDateString(data, ca, component, width, key) {
	    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
	    // 'In clearly specified instances, resources may inherit from within the same locale.
	    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
	    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],
	
	
	    // "sideways" inheritance resolves strings when a key doesn't exist
	    alts = {
	        narrow: ['short', 'long'],
	        short: ['long', 'narrow'],
	        long: ['short', 'narrow']
	    },
	
	
	    //
	    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];
	
	    // `key` wouldn't be specified for components 'dayPeriods'
	    return key !== null ? resolved[key] : resolved;
	}
	
	// Define the DateTimeFormat constructor internally so it cannot be tainted
	function DateTimeFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.DateTimeFormat(locales, options);
	    }
	    return InitializeDateTimeFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'DateTimeFormat', {
	    configurable: true,
	    writable: true,
	    value: DateTimeFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(DateTimeFormatConstructor, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
	 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
	 * DateTimeFormat object.
	 */
	function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(dateTimeFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
	    //    value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(dateTimeFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined below) with arguments options, "any", and "date".
	    options = ToDateTimeOptions(options, 'any', 'date');
	
	    // 5. Let opt be a new Record.
	    var opt = new Record();
	
	    // 6. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
	    //    containing the two String values "lookup" and "best fit", and "best fit".
	    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 7. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 8. Let DateTimeFormat be the standard built-in object that is the initial
	    //    value of Intl.DateTimeFormat.
	    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need
	
	    // 9. Let localeData be the value of the [[localeData]] internal property of
	    //    DateTimeFormat.
	    var localeData = DateTimeFormat['[[localeData]]'];
	
	    // 10. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //      internal property of DateTimeFormat, and localeData.
	    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
	    //     r.[[ca]].
	    internal['[[calendar]]'] = r['[[ca]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
	    //     r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let tz be the result of calling the [[Get]] internal method of options with
	    //     argument "timeZone".
	    var tz = options.timeZone;
	
	    // 16. If tz is not undefined, then
	    if (tz !== undefined) {
	        // a. Let tz be ToString(tz).
	        // b. Convert tz to upper case as described in 6.1.
	        //    NOTE: If an implementation accepts additional time zone values, as permitted
	        //          under certain conditions by the Conformance clause, different casing
	        //          rules apply.
	        tz = toLatinUpperCase(tz);
	
	        // c. If tz is not "UTC", then throw a RangeError exception.
	        // ###TODO: accept more time zones###
	        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
	    }
	
	    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
	    internal['[[timeZone]]'] = tz;
	
	    // 18. Let opt be a new Record.
	    opt = new Record();
	
	    // 19. For each row of Table 3, except the header row, do:
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop)) continue;
	
	        // 20. Let prop be the name given in the Property column of the row.
	        // 21. Let value be the result of calling the GetOption abstract operation,
	        //     passing as argument options, the name given in the Property column of the
	        //     row, "string", a List containing the strings given in the Values column of
	        //     the row, and undefined.
	        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);
	
	        // 22. Set opt.[[<prop>]] to value.
	        opt['[[' + prop + ']]'] = value;
	    }
	
	    // Assigned a value below
	    var bestFormat = void 0;
	
	    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 24. Let formats be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "formats".
	    //     Note: we process the CLDR formats into the spec'd structure
	    var formats = ToDateTimeFormats(dataLocaleData.formats);
	
	    // 25. Let matcher be the result of calling the GetOption abstract operation with
	    //     arguments options, "formatMatcher", "string", a List containing the two String
	    //     values "basic" and "best fit", and "best fit".
	    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');
	
	    // Optimization: caching the processed formats as a one time operation by
	    // replacing the initial structure from localeData
	    dataLocaleData.formats = formats;
	
	    // 26. If matcher is "basic", then
	    if (matcher === 'basic') {
	        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
	        //     operation (defined below) with opt and formats.
	        bestFormat = BasicFormatMatcher(opt, formats);
	
	        // 28. Else
	    } else {
	        {
	            // diverging
	            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
	        }
	        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
	        //     abstract operation (defined below) with opt and formats.
	        bestFormat = BestFitFormatMatcher(opt, formats);
	    }
	
	    // 30. For each row in Table 3, except the header row, do
	    for (var _prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, _prop)) continue;
	
	        // a. Let prop be the name given in the Property column of the row.
	        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
	        //    bestFormat with argument prop.
	        // c. If pDesc is not undefined, then
	        if (hop.call(bestFormat, _prop)) {
	            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
	            //    with argument prop.
	            var p = bestFormat[_prop];
	            {
	                // diverging
	                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
	            }
	
	            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
	            internal['[[' + _prop + ']]'] = p;
	        }
	    }
	
	    var pattern = void 0; // Assigned a value below
	
	    // 31. Let hr12 be the result of calling the GetOption abstract operation with
	    //     arguments options, "hour12", "boolean", undefined, and undefined.
	    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	
	    // 32. If dateTimeFormat has an internal property [[hour]], then
	    if (internal['[[hour]]']) {
	        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
	        //    internal method of dataLocaleData with argument "hour12".
	        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;
	
	        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
	        internal['[[hour12]]'] = hr12;
	
	        // c. If hr12 is true, then
	        if (hr12 === true) {
	            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
	            //    dataLocaleData with argument "hourNo0".
	            var hourNo0 = dataLocaleData.hourNo0;
	
	            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
	            internal['[[hourNo0]]'] = hourNo0;
	
	            // iii. Let pattern be the result of calling the [[Get]] internal method of
	            //      bestFormat with argument "pattern12".
	            pattern = bestFormat.pattern12;
	        }
	
	        // d. Else
	        else
	            // i. Let pattern be the result of calling the [[Get]] internal method of
	            //    bestFormat with argument "pattern".
	            pattern = bestFormat.pattern;
	    }
	
	    // 33. Else
	    else
	        // a. Let pattern be the result of calling the [[Get]] internal method of
	        //    bestFormat with argument "pattern".
	        pattern = bestFormat.pattern;
	
	    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
	    internal['[[pattern]]'] = pattern;
	
	    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
	    //     true.
	    internal['[[initializedDateTimeFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return dateTimeFormat;
	}
	
	/**
	 * Several DateTimeFormat algorithms use values from the following table, which provides
	 * property names and allowable values for the components of date and time formats:
	 */
	var dateTimeComponents = {
	    weekday: ["narrow", "short", "long"],
	    era: ["narrow", "short", "long"],
	    year: ["2-digit", "numeric"],
	    month: ["2-digit", "numeric", "narrow", "short", "long"],
	    day: ["2-digit", "numeric"],
	    hour: ["2-digit", "numeric"],
	    minute: ["2-digit", "numeric"],
	    second: ["2-digit", "numeric"],
	    timeZoneName: ["short", "long"]
	};
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeFormats(formats) {
	    if (Object.prototype.toString.call(formats) === '[object Array]') {
	        return formats;
	    }
	    return createDateTimeFormats(formats);
	}
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeOptions(options, required, defaults) {
	    // 1. If options is undefined, then let options be null, else let options be
	    //    ToObject(options).
	    if (options === undefined) options = null;else {
	        // (#12) options needs to be a Record, but it also needs to inherit properties
	        var opt2 = toObject(options);
	        options = new Record();
	
	        for (var k in opt2) {
	            options[k] = opt2[k];
	        }
	    }
	
	    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
	    var create = objCreate;
	
	    // 3. Let options be the result of calling the [[Call]] internal method of create with
	    //    undefined as the this value and an argument list containing the single item
	    //    options.
	    options = create(options);
	
	    // 4. Let needDefaults be true.
	    var needDefaults = true;
	
	    // 5. If required is "date" or "any", then
	    if (required === 'date' || required === 'any') {
	        // a. For each of the property names "weekday", "year", "month", "day":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
	    }
	
	    // 6. If required is "time" or "any", then
	    if (required === 'time' || required === 'any') {
	        // a. For each of the property names "hour", "minute", "second":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
	    }
	
	    // 7. If needDefaults is true and defaults is either "date" or "all", then
	    if (needDefaults && (defaults === 'date' || defaults === 'all'))
	        // a. For each of the property names "year", "month", "day":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.year = options.month = options.day = 'numeric';
	
	    // 8. If needDefaults is true and defaults is either "time" or "all", then
	    if (needDefaults && (defaults === 'time' || defaults === 'all'))
	        // a. For each of the property names "hour", "minute", "second":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.hour = options.minute = options.second = 'numeric';
	
	    // 9. Return options.
	    return options;
	}
	
	/**
	 * When the BasicFormatMatcher abstract operation is called with two arguments options and
	 * formats, the following steps are taken:
	 */
	function BasicFormatMatcher(options, formats) {
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, property) ? format[property] : undefined;
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        // 5. If delta = 2, decrease score by longMorePenalty.
	                        if (delta === 2) score -= longMorePenalty;
	
	                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
	                        else if (delta === 1) score -= shortMorePenalty;
	
	                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
	                            else if (delta === -1) score -= shortLessPenalty;
	
	                                // 8. Else if delta = -2, decrease score by longLessPenalty.
	                                else if (delta === -2) score -= longLessPenalty;
	                    }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/**
	 * When the BestFitFormatMatcher abstract operation is called with two arguments options
	 * and formats, it performs implementation dependent steps, which should return a set of
	 * component representations that a typical user of the selected locale would perceive as
	 * at least as good as the one returned by BasicFormatMatcher.
	 *
	 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
	 * with the addition of bonus points awarded where the requested format is of
	 * the same data type as the potentially matching format.
	 *
	 * This algo relies on the concept of closest distance matching described here:
	 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
	 * Typically a “best match” is found using a closest distance match, such as:
	 *
	 * Symbols requesting a best choice for the locale are replaced.
	 *      j → one of {H, k, h, K}; C → one of {a, b, B}
	 * -> Covered by cldr.js matching process
	 *
	 * For fields with symbols representing the same type (year, month, day, etc):
	 *     Most symbols have a small distance from each other.
	 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
	 *     -> Covered by cldr.js matching process
	 *
	 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
	 *         MMM ≅ MMMM
	 *         MM ≅ M
	 *     Numeric and text fields are given a larger distance from each other.
	 *         MMM ≈ MM
	 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
	 *         d ≋ D; ...
	 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
	 *
	 *
	 * For example,
	 *
	 *     { month: 'numeric', day: 'numeric' }
	 *
	 * should match
	 *
	 *     { month: '2-digit', day: '2-digit' }
	 *
	 * rather than
	 *
	 *     { month: 'short', day: 'numeric' }
	 *
	 * This makes sense because a user requesting a formatted date with numeric parts would
	 * not expect to see the returned format containing narrow, short or long part names
	 */
	function BestFitFormatMatcher(options, formats) {
	    /** Diverging: this block implements the hack for single property configuration, eg.:
	     *
	     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
	     *
	     * should produce a single digit with the day of the month. This is needed because
	     * CLDR `availableFormats` data structure doesn't cover these cases.
	     */
	    {
	        var optionsPropNames = [];
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            if (options['[[' + property + ']]'] !== undefined) {
	                optionsPropNames.push(property);
	            }
	        }
	        if (optionsPropNames.length === 1) {
	            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
	            if (_bestFormat) {
	                return _bestFormat;
	            }
	        }
	    }
	
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    var patternPenalty = 2;
	
	    var hour12Penalty = 1;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var _property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, _property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + _property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, _property) ? format[_property] : undefined;
	
	            // Diverging: using the default properties produced by the pattern/skeleton
	            // to match it with user options, and apply a penalty
	            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
	            if (optionsProp !== patternProp) {
	                score -= patternPenalty;
	            }
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        {
	                            // diverging from spec
	                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
	                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
	                            } else {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
	                            }
	                        }
	                    }
	        }
	
	        {
	            // diverging to also take into consideration differences between 12 or 24 hours
	            // which is special for the best fit only.
	            if (format._.hour12 !== options.hour12) {
	                score -= hour12Penalty;
	            }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/* 12.2.3 */internals.DateTimeFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['ca', 'nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
	 * following steps are taken:
	 */
	/* 12.2.2 */
	defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * DateTimeFormat object.
	 */
	/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatDateTime
	});
	
	function GetFormatDateTime() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 12.3_b
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 0, that takes the argument date and
	        //    performs the following steps:
	        var F = function F() {
	            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	            //   i. If date is not provided or is undefined, then let x be the
	            //      result as if by the expression Date.now() where Date.now is
	            //      the standard built-in function defined in ES5, 15.9.4.4.
	            //  ii. Else let x be ToNumber(date).
	            // iii. Return the result of calling the FormatDateTime abstract
	            //      operation (defined below) with arguments this and x.
	            var x = date === undefined ? Date.now() : toNumber(date);
	            return FormatDateTime(this, x);
	        };
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts$1() {
	    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');
	
	    var x = date === undefined ? Date.now() : toNumber(date);
	    return FormatToPartsDateTime(this, x);
	}
	
	Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
	    enumerable: false,
	    writable: true,
	    configurable: true,
	    value: formatToParts$1
	});
	
	function CreateDateTimeParts(dateTimeFormat, x) {
	    // 1. If x is not a finite Number, then throw a RangeError exception.
	    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');
	
	    var internal = dateTimeFormat.__getInternalProperties(secret);
	
	    // Creating restore point for properties on the RegExp object... please wait
	    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this
	
	    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
	    var locale = internal['[[locale]]'];
	
	    // 3. Let nf be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
	    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    var nf = new Intl.NumberFormat([locale], { useGrouping: false });
	
	    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
	    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
	    // 11.1.3.
	    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });
	
	    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
	    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
	    // and the value of the [[timeZone]] internal property of dateTimeFormat.
	    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);
	
	    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
	    var pattern = internal['[[pattern]]'];
	
	    // 7.
	    var result = new List();
	
	    // 8.
	    var index = 0;
	
	    // 9.
	    var beginIndex = pattern.indexOf('{');
	
	    // 10.
	    var endIndex = 0;
	
	    // Need the locale minus any extensions
	    var dataLocale = internal['[[dataLocale]]'];
	
	    // Need the calendar data from CLDR
	    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
	    var ca = internal['[[calendar]]'];
	
	    // 11.
	    while (beginIndex !== -1) {
	        var fv = void 0;
	        // a.
	        endIndex = pattern.indexOf('}', beginIndex);
	        // b.
	        if (endIndex === -1) {
	            throw new Error('Unclosed pattern');
	        }
	        // c.
	        if (beginIndex > index) {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(index, beginIndex)
	            });
	        }
	        // d.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // e.
	        if (dateTimeComponents.hasOwnProperty(p)) {
	            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
	            var f = internal['[[' + p + ']]'];
	            //  ii. Let v be the value of tm.[[<p>]].
	            var v = tm['[[' + p + ']]'];
	            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
	            if (p === 'year' && v <= 0) {
	                v = 1 - v;
	            }
	            //  iv. If p is "month", then increase v by 1.
	            else if (p === 'month') {
	                    v++;
	                }
	                //   v. If p is "hour" and the value of the [[hour12]] internal property of
	                //      dateTimeFormat is true, then
	                else if (p === 'hour' && internal['[[hour12]]'] === true) {
	                        // 1. Let v be v modulo 12.
	                        v = v % 12;
	                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
	                        //    dateTimeFormat is true, then let v be 12.
	                        if (v === 0 && internal['[[hourNo0]]'] === true) {
	                            v = 12;
	                        }
	                    }
	
	            //  vi. If f is "numeric", then
	            if (f === 'numeric') {
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    (defined in 11.3.2) with arguments nf and v.
	                fv = FormatNumber(nf, v);
	            }
	            // vii. Else if f is "2-digit", then
	            else if (f === '2-digit') {
	                    // 1. Let fv be the result of calling the FormatNumber abstract operation
	                    //    with arguments nf2 and v.
	                    fv = FormatNumber(nf2, v);
	                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
	                    //    containing the last two characters.
	                    if (fv.length > 2) {
	                        fv = fv.slice(-2);
	                    }
	                }
	                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
	                //     value representing f in the desired form; the String value depends upon
	                //     the implementation and the effective locale and calendar of
	                //     dateTimeFormat. If p is "month", then the String value may also depend
	                //     on whether dateTimeFormat has a [[day]] internal property. If p is
	                //     "timeZoneName", then the String value may also depend on the value of
	                //     the [[inDST]] field of tm.
	                else if (f in dateWidths) {
	                        switch (p) {
	                            case 'month':
	                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
	                                break;
	
	                            case 'weekday':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
	                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
	                                } catch (e) {
	                                    throw new Error('Could not find weekday data for locale ' + locale);
	                                }
	                                break;
	
	                            case 'timeZoneName':
	                                fv = ''; // ###TODO
	                                break;
	
	                            case 'era':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
	                                } catch (e) {
	                                    throw new Error('Could not find era data for locale ' + locale);
	                                }
	                                break;
	
	                            default:
	                                fv = tm['[[' + p + ']]'];
	                        }
	                    }
	            // ix
	            arrPush.call(result, {
	                type: p,
	                value: fv
	            });
	            // f.
	        } else if (p === 'ampm') {
	            // i.
	            var _v = tm['[[hour]]'];
	            // ii./iii.
	            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
	            // iv.
	            arrPush.call(result, {
	                type: 'dayPeriod',
	                value: fv
	            });
	            // g.
	        } else {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(beginIndex, endIndex + 1)
	            });
	        }
	        // h.
	        index = endIndex + 1;
	        // i.
	        beginIndex = pattern.indexOf('{', index);
	    }
	    // 12.
	    if (endIndex < pattern.length - 1) {
	        arrPush.call(result, {
	            type: 'literal',
	            value: pattern.substr(endIndex + 1)
	        });
	    }
	    // 13.
	    return result;
	}
	
	/**
	 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
	 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
	 * value), it returns a String value representing x (interpreted as a time value as
	 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
	 * options of dateTimeFormat.
	 */
	function FormatDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = '';
	
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result += part.value;
	    }
	    return result;
	}
	
	function FormatToPartsDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = [];
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result.push({
	            type: part.type,
	            value: part.value
	        });
	    }
	    return result;
	}
	
	/**
	 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
	 * timeZone, the following steps are taken:
	 */
	function ToLocalTime(date, calendar, timeZone) {
	    // 1. Apply calendrical calculations on date for the given calendar and time zone to
	    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
	    //    The calculations should use best available information about the specified
	    //    calendar and time zone. If the calendar is "gregory", then the calculations must
	    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
	    //    bound by the restrictions on the use of best available information on time zones
	    //    for local time zone adjustment and daylight saving time adjustment imposed by
	    //    ES5, 15.9.1.7 and 15.9.1.8.
	    // ###TODO###
	    var d = new Date(date),
	        m = 'get' + (timeZone || '');
	
	    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
	    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
	    //    calculated value.
	    return new Record({
	        '[[weekday]]': d[m + 'Day'](),
	        '[[era]]': +(d[m + 'FullYear']() >= 0),
	        '[[year]]': d[m + 'FullYear'](),
	        '[[month]]': d[m + 'Month'](),
	        '[[day]]': d[m + 'Date'](),
	        '[[hour]]': d[m + 'Hours'](),
	        '[[minute]]': d[m + 'Minutes'](),
	        '[[second]]': d[m + 'Seconds'](),
	        '[[inDST]]': false // ###TODO###
	    });
	}
	
	/**
	 * The function returns a new object whose properties and attributes are set as if
	 * constructed by an object literal assigning to each of the following properties the
	 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
	 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
	 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
	 * properties are not present are not assigned.
	 */
	/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 12.3_b
	        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	var ls = Intl.__localeSensitiveProtos = {
	    Number: {},
	    Date: {}
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.2.1 */ls.Number.toLocaleString = function () {
	    // Satisfy test 13.2.1_1
	    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');
	
	    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
	    // 2. If locales is not provided, then let locales be undefined.
	    // 3. If options is not provided, then let options be undefined.
	    // 4. Let numberFormat be the result of creating a new object as if by the
	    //    expression new Intl.NumberFormat(locales, options) where
	    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    // 5. Return the result of calling the FormatNumber abstract operation
	    //    (defined in 11.3.2) with arguments numberFormat and x.
	    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.3.1 */ls.Date.toLocaleString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
	    options = ToDateTimeOptions(options, 'any', 'all');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleDateString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.2 */ls.Date.toLocaleDateString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0],
	
	
	    // 4. If options is not provided, then let options be undefined.
	    options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
	    options = ToDateTimeOptions(options, 'date', 'date');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleTimeString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
	    options = ToDateTimeOptions(options, 'time', 'time');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
	        // Need this here for IE 8, to avoid the _DontEnum_ bug
	        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });
	
	        for (var k in ls.Date) {
	            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
	        }
	    }
	});
	
	/**
	 * Can't really ship a single script with data for hundreds of locales, so we provide
	 * this __addLocaleData method as a means for the developer to add the data on an
	 * as-needed basis
	 */
	defineProperty(Intl, '__addLocaleData', {
	    value: function value(data) {
	        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");
	
	        addLocaleData(data, data.locale);
	    }
	});
	
	function addLocaleData(data, tag) {
	    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
	    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");
	
	    var locale = void 0,
	        locales = [tag],
	        parts = tag.split('-');
	
	    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
	    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);
	
	    while (locale = arrShift.call(locales)) {
	        // Add to NumberFormat internal properties as per 11.2.3
	        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
	        internals.NumberFormat['[[localeData]]'][locale] = data.number;
	
	        // ...and DateTimeFormat internal properties as per 12.2.3
	        if (data.date) {
	            data.date.nu = data.number.nu;
	            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
	            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
	        }
	    }
	
	    // If this is the first set of locale data added, make it the default
	    if (defaultLocale === undefined) setDefaultLocale(tag);
	}
	
	defineProperty(Intl, '__disableRegExpRestore', {
	    value: function value() {
	        internals.disableRegExpRestore = true;
	    }
	});
	
	module.exports = Intl;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 273 */
/***/ function(module, exports) {

	module.exports = {
		"INLINE": "Testesssss",
		"nav_home": "Start",
		"nav_menu": "Speisekarte",
		"nav_about": "Restaurant",
		"nav_wines": "Wein",
		"nav_suggestions": "Vorschläge",
		"nav_events": "Veranstaltungen",
		"nav-feedback": "Deine Meinung",
		"follow_text": "Folge uns",
		"desktop_languages": "Sprachen",
		"intro_default_option": "Filtermenü nach:",
		"suggested_extras": "Empfohlene Beilagen",
		"suggested_wines": "Empfohlene Weine",
		"cta_title": "Sehen Sie unsere Auswahl an ",
		"cta_btn": "Sehen",
		"related_products": "Ähnliche Produkte",
		"error_home_link": "Zurück zum Start",
		"error_home_title1": "Hmm...",
		"error_home_title2": "Die gesuchte Seite wurde nicht gefunden.",
		"error_home_text": "Versuchen Sie, die Adresse neu zu schreiben, oder versuchen Sie es später erneut.",
		"detail_title": "im Detail",
		"list_event_title": "Veranstaltungen",
		"event_link": "Offizielle Seite",
		"other_events": "Andere Ereignisse",
		"filters": "Filter",
		"filter-group-region-type": "Weinsorte und Region",
		"region_default_option": "Wählen Sie eine Region",
		"filter-group-type": "Typ",
		"type_default_option": "Wählen Sie einen Typ",
		"filter-group-flavour": "Geschmack",
		"filter-group-characteristics": "Weineigenschaften",
		"sweetness_default_option": "Säure",
		"filter-group-body": "Körper",
		"body_default_option": "Wähle den Körper",
		"filter-group-ingredients": "Hauptzutaten",
		"filter-group-diets": "Unverträglichkeiten",
		"filter-results": "{results} Ergebnisse",
		"filter-clear-button": "Filter löschen",
		"filter-apply-button": "Bewerben",
		"related_dishes": "Empfohlene Gerichte",
		"empty-title": "Keine Ergebnisse",
		"empty-text": "Derzeit liegen uns keine Ergebnisse vor. Bitte versuchen Sie es erneut mit neuen Parametern.",
		"feedback-title": "Hilf uns zu verbessern",
		"feedback-intro": "Hinterlassen Sie uns Ihre Kritik und Meinungen, damit wir Pickly für Sie verbessern können.",
		"feedback-improve": "Hat Pickly Ihr Restauranterlebnis verbessert?",
		"feedback-error": "Bitte wähle eine Option aus",
		"feedback-harder": "Kompliziert",
		"feedback-no-help": "Hat nicht geholfen",
		"feedback-indiferent": "Gleichgültig",
		"feedback-helped": "Hat geholfen",
		"feedback-helped-a-lot": "Hat mir sehr geholfen",
		"feedback-recommend": "Würden Sie anderen Restaurants empfehlen, Pickly zu verwenden?",
		"feedback-no-recommend": "Ich empfehle nicht",
		"feedback-recommend-neutral": "Gleichgültig",
		"feedback-recommend-yes": "ich empfehle",
		"feedback-msg": "Hinterlassen Sie uns Ihre Meinung zu Ihrer Erfahrung und wie Sie glauben, dass wir die Anwendung verbessern könnten. (Optional)",
		"feedback-submit": "Einreichen",
		"feedback-thanks-title": "Vielen Dank",
		"feedback-thanks-text": "Vielen Dank, dass Sie uns bei der Verbesserung helfen! Sie können mit der Schaltfläche unten zum Anfang zurückkehren.",
		"restaurant-feedback-title": "Ihre Meinung ist wichtig.",
		"restaurant-feedback-subtitle": "Hilf uns zu verbessern.",
		"restaurant-feedback-intro": "Erzählen Sie uns anhand eines kurzen Fragebogens von Ihren Erfahrungen in unserem Restaurant und bewerten Sie den Service, das Essen und die Umwelt.",
		"restaurant-feedback-intro-btn": "Feedback geben",
		"food-feedback-title": "Lebensmittelbewertung",
		"food-feedback-intro": "Geben Sie Ihre Meinung ab und helfen Sie uns, uns zu verbessern.",
		"choice-question": "Die Speisekarte hatte eine gute Auswahl an Gerichten",
		"presentation-question": "Die Gerichte hatten eine gute Präsentation",
		"tasty-question": "Das Essen war lecker und gut zubereitet",
		"service-feedback-title": "SERVICE-Bewertung",
		"speed-question": "Sie haben unsere Anfrage schnell bearbeitet",
		"waiters-question": "Die Angestellten waren freundlich und aufmerksam",
		"overall-question": "Insgesamt war der Service gut",
		"global-feedback-title": "GLOBALE Bewertung",
		"deco-question": "Das Restaurant hatte eine gute Atmosphäre und Einrichtung",
		"price-question": "Das Preis / Leistungsverhältnis war gut",
		"recommend-question": "Würde das Restaurant einem Freund empfehlen",
		"comments-question": "Kommentare und Vorschläge",
		"recommend_title": "Würden Sie dieses Gericht empfehlen?",
		"recommend-total": "{total} Kunden empfehlen dieses Gericht.",
		"type": "typ",
		"body": "körper",
		"region": "region",
		"accidity": "säure",
		"mypick-text": "Mit myPick wählen Sie Ihre Lieblingsgerichte, Getränke und Desserts für diese Mahlzeit aus. Dann fragen Sie einfach den Kellner.",
		"cookie-notice": "Durch die Nutzung dieser Website stimmen Sie der Verwendung von Cookies für Analysen und Statistiken zu.",
		"terms-title": "Geschäftsbedingungen",
		"price_under_request": "Preis auf anfrage"
	};

/***/ },
/* 274 */
/***/ function(module, exports) {

	module.exports = {
		"INLINE": "Hello World",
		"nav_home": "Home",
		"nav_about": "Restaurant",
		"nav_menu": "Menu",
		"nav_wines": "Wines",
		"nav_suggestions": "Suggestions",
		"nav_events": "Events",
		"about-title": "About us",
		"nav-feedback": "Feedback",
		"nav-pickly": "About Pickly",
		"follow_text": "Follow us on",
		"desktop_languages": "Languages",
		"intro_default_option": "Filter menu by:",
		"suggested_extras": "Suggested extras",
		"suggested_wines": "Suggested Wines",
		"cta_title": "Check our selection of ",
		"cta_btn": "See our",
		"related_products": "Related products",
		"error_home_link": "Start over",
		"error_home_title1": "Hmm...",
		"error_home_title2": "We couldn't locate the page you were looking for.",
		"error_home_text": "Please check the address or try again later.",
		"detail_title": "in detail",
		"list_event_title": "Events",
		"event_link": "Official website",
		"other_events": "Other Events",
		"filter-group-region-type": "Wine Type and Region",
		"region_default_option": "Choose a region",
		"filters": "Filters",
		"filter-group-type": "Type",
		"type_default_option": "Choose a type",
		"filter-group-flavour": "Flavour",
		"filter-group-characteristics": "Wine Features",
		"sweetness_default_option": "Choose how sweet",
		"filter-group-body": "Body",
		"body_default_option": "Choose a body",
		"filter-group-ingredients": "Main Ingredients",
		"filter-group-diets": "Intolerances",
		"filter-results": "{results} results",
		"filter-clear-button": "Clear filters",
		"filter-apply-button": "Apply",
		"related_dishes": "Related Dishes",
		"empty-title": "No results found",
		"empty-text": "We couldn't find results to meet your search criteria, please try again with different filters",
		"feedback-title": "Help us Improve",
		"feedback-intro": "We kindly ask you to answer this brief evaluation survey. You can also report your reviews and opinions.",
		"feedback-improve": "Did Pickly improve your experience in the restaurant?",
		"feedback-error": "Please select an option",
		"feedback-harder": "Made it Harder",
		"feedback-no-help": "Didn't Help",
		"feedback-indiferent": "Indiferent",
		"feedback-helped": "Helped",
		"feedback-helped-a-lot": "Helped a lot",
		"feedback-recommend": "Would you recommend Pickly to other restaurants?",
		"feedback-no-recommend": "Don't Recommend",
		"feedback-recommend-neutral": "Indiferent",
		"feedback-recommend-yes": "Recommend",
		"feedback-msg": "Would you like to make any suggestion to upgrade the app and/or Pickly’s service? (optional)",
		"feedback-submit": "Submit",
		"feedback-thanks-title": "Thank you",
		"feedback-thanks-text": "Thank you for helping us improve. You can go back to the homepage through the button below.",
		"restaurant-feedback-title": "Your opinion is important.",
		"restaurant-feedback-subtitle": "Help us to improve.",
		"restaurant-feedback-intro": "Tell us about your experience in our restaurant, evaluating the service, food and ambience, through a brief survey.",
		"restaurant-feedback-intro-btn": "Give Feedback",
		"food-feedback-title": "FOOD Evaluation",
		"food-feedback-intro": "Help us improve.",
		"choice-question": "The menu had a nice selection of food",
		"presentation-question": "Good presentation on the items",
		"tasty-question": "Food was tasty and well cooked",
		"service-feedback-title": "SERVICE Evaluation",
		"speed-question": "Restaurant was quick to process our order",
		"waiters-question": "The waiting service was good",
		"overall-question": "overall the service was good",
		"global-feedback-title": "GENERAL Evaluation",
		"deco-question": "Restaurant has a nice deco and atmosphere",
		"price-question": "Good value for money",
		"recommend-question": "Would you recommend the restaurant to a friend?",
		"comments-question": "Comments and suggestions",
		"type": "type",
		"body": "body",
		"region": "region",
		"accidity": "accidity",
		"recommend_title": "Would you recommend this dish?",
		"recommend_title_drink": "Would you recommend this drink?",
		"recommend-total": "{total} clients recommend this dish.",
		"recommend-total_drink": "{total} clients recommend this drink.",
		"mypick-text": "Use myPick to choose your favorite dishes, drinks and deserts for this meal. Then, just ask the waiter.",
		"cookie-notice": "By using this website you agree with the use of cookies for analytics.",
		"cookie-link": "Read more",
		"terms-title": "Terms and conditions",
		"cookies-title": "Cookies Policy",
		"drinks-link-all": "See all",
		"toggle_list": "List",
		"toggle_cards": "Cards",
		"price_under_request": "Price under request"
	};

/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports = {
		"INLINE": "Testito",
		"nav_home": "Inicio",
		"nav_menu": "Ementa",
		"nav_about": "Restaurante",
		"nav_wines": "Vinos",
		"nav_suggestions": "Sugerencias",
		"nav_events": "Eventos",
		"nav-feedback": "Su opinión",
		"nav-pickly": "Acerca de Pickly",
		"follow_text": "Síguenos",
		"desktop_languages": "Idiomas",
		"intro_default_option": "Filtrar el menú por:",
		"suggested_extras": "Acompañamientos sugeridos",
		"suggested_wines": "Vinos sugeridos",
		"cta_title": "Vea nuestra selección de",
		"cta_btn": "Ver",
		"related_products": "Productos Similares",
		"error_home_link": "Volver al principio",
		"error_home_title1": "Hmm ... que bonito",
		"error_home_title2": "No se pudo encontrar la página que busca.",
		"error_home_text": "Intente reescribir la dirección o inténtelo de nuevo más tarde.",
		"detail_title": "en detalle",
		"list_event_title": "Eventos",
		"event_link": "Página oficial",
		"other_events": "Otros eventos",
		"filters": "Filtros",
		"filter-group-region-type": "Tipo de Vino y Región",
		"region_default_option": "Elija una región",
		"filter-group-type": "Tipo",
		"type_default_option": "Elija un tipo",
		"filter-group-flavour": "Sabor",
		"filter-group-characteristics": "Características del vino",
		"sweetness_default_option": "Acidez",
		"filter-group-body": "Cuerpo",
		"body_default_option": "Elija el cuerpo",
		"filter-group-ingredientes": "Ingredientes Principales",
		"filter-group-diets": "Intolerancias",
		"filter-results": "{results} resultados",
		"filter-clear-button": "Borrar filtros",
		"filter-apply-button": "Aplicar",
		"related_dishes": "Platos sugeridos",
		"empty-title": "Sin resultados",
		"empty-text": "Por el momento no tenemos resultados para presentarle, por favor inténtelo de nuevo con nuevos parámetros.",
		"feedback-title": "Ayúdanos a mejorar",
		"feedback-intro": "Déjanos tus críticas y opiniones para poder mejorar Pickly para ti.",
		"feedback-improve": "Pickly ha mejorado su experiencia en el restaurante?",
		"feedback-error": "Por favor elija una opción",
		"feedback-harder": "Complicó",
		"feedback-no-help": "No ayudó",
		"feedback-indiferent": "Indiferente",
		"feedback-assistance": "Ayudó",
		"feedback-assistance-a-lot": "Ayudó Bastante",
		"feedback-recommend": "¿Recomendar a otros restaurantes a usar Pickly?",
		"feedback-no-recommend": "No recomiendo",
		"feedback-recommend-neutral": "Indiferente",
		"feedback-recommend-yes": "Recomiendo",
		"feedback-msg": "Déjanos tu opinión sobre tu experiencia y cómo crees que podríamos mejorar la aplicación (opcional)",
		"feedback-submit": "Enviar",
		"feedback-thanks-title": "Gracias",
		"feedback-thanks-text": "Gracias por ayudarnos a mejorar! Puede volver al principio a través del botón de abajo.",
		"restaurant-feedback-title": "Su opinión es importante.",
		"restaurant-feedback-subtitle": "Ayúdanos a mejorar.",
		"restaurant-feedback-intro": "Cuéntanos cómo fue tu experiencia en nuestro restaurante, evaluando el servicio, la comida y el ambiente, a través de un breve cuestionario.",
		"restaurant-feedback-intro-btn": "Dar Feedback",
		"food-feedback-title": "Evaluación de la COMIDA",
		"food-feedback-intro": "Dé su opinión y ayúdanos a mejorar.",
		"choice-question": "El menú tenía una buena selección de platos",
		"presentation-question": "Los platos tenían una buena presentación",
		"tasty-question": "La comida era sabrosa y bien confeccionada",
		"service-feedback-title": "Evaluación del servicio",
		"speed-question": "Fueron rápidos a tratar nuestra petición",
		"waiters-question": "Los empleados fueron simpáticos y atenciosos",
		"overall-question": "En general, el servicio fue bueno",
		"global-feedback-title": "Evaluación GLOBAL",
		"deco-question": "El restaurante tenía un buen ambiente y decoración",
		"price-question": "La relación precio / calidad fue buena",
		"recommend-question": "Recomendaría el restaurante a un amigo",
		"comments-question": "Comentarios y sugerencias",
		"recommend_title": "¿Recomendar este plato?",
		"recommend_title_drink": "¿Recomendar esta bebida?",
		"recommend-total": "{total} los clientes recomiendan este plato.",
		"recommend-total_drink": "{total} los clientes recomiendan esta bebida.",
		"type": "tipo",
		"body": "cuerpo",
		"region": "región",
		"accidity": "acidez",
		"mypick-text": "Con myPick selecciona los platos, las bebidas y los postres preferidos para esta comida, luego es sólo pedir al camarero.",
		"cookie-notice": "Al utilizar este sitio estará permitiendo el uso de cookies para análisis y estadística.",
		"cookie-link": "Más información",
		"terms-title": "Términos y condiciones",
		"cookies-title": "Política de cookies",
		"drinks-link-all": "Ver todos",
		"toggle_list": "Lista",
		"toggle_cards": "Cartas",
		"price_under_request": "Precio bajo consulta"
	};

/***/ },
/* 276 */
/***/ function(module, exports) {

	module.exports = {
		"INLINE": "Test",
		"nav_home": "Accueil",
		"nav_menu": "Ementa",
		"nav_about": "Restaurant",
		"nav_wines": "Vins",
		"nav_suggestions": "Suggestions",
		"nav_events": "Evénements",
		"nav-feedback": "Votre opinion",
		"nav-pickly": "À propos de Pickly",
		"follow_text": "Suivez-nous",
		"desktop_languages": "Langues",
		"intro_default_option": "Filtrez le menu par:",
		"suggested_extras": "Accompagnements suggérés",
		"suggested_wines": "Vins suggérés",
		"cta_title": "Voir notre sélection de",
		"cta_btn": "Vue",
		"related_products": "Produits similaires",
		"error_home_link": "Retour au début",
		"error_home_title1": "Hmm ... c'est gentil",
		"error_home_title2": "La page que vous cherchez n'a pas pu être trouvée.",
		"error_home_text": "Essayez de réécrire l'adresse ou réessayez plus tard.",
		"detail_title": "en détail",
		"list_event_title": "Evénements",
		"event_link": "Site officiel",
		"other_events": "Autres événements",
		"filters": "Filtres",
		"filter-group-region-type": "Type de vin et région",
		"region_default_option": "Choisissez une région",
		"filter-group-type": "Type",
		"type_default_option": "Choisir un type",
		"filter-group-flavour": "saveur",
		"filter-group-feature": "Caractéristiques du vin",
		"sweetness_default_option": "Acidité",
		"filter-group-body": "Corps",
		"body_default_option": "Choisir le corps",
		"filter-group-ingredients": "Ingrédients principaux",
		"filter-group-diets": "Intolérances",
		"filter-results": "résultats {results}",
		"filter-clear-button": "Effacer les filtres",
		"filter-apply-button": "Appliquer",
		"related_dishes": "Plats suggérés",
		"empty-title": "Aucun résultat",
		"empty-text": "Nous n'avons actuellement aucun résultat pour vous, veuillez réessayer avec de nouveaux paramètres.",
		"feedback-title": "Aidez-nous à améliorer",
		"feedback-intro": "Laissez-nous vos critiques et vos opinions afin que nous puissions améliorer Pickly pour vous.",
		"feedback-improve": "Pickly a-t-il amélioré votre expérience de restauration?",
		"feedback-error": "Veuillez choisir une option",
		"feedback-hard": "Compliqué",
		"feedback-no-help": "Ça n'a pas aidé",
		"feedback-indiferent": "Indifférent",
		"feedback-assistance": "Aidé",
		"feedback-assistance-a-lot": "Aidé suffisamment",
		"feedback-recommend": "Recommanderiez-vous à d'autres restaurants d'utiliser Pickly?",
		"feedback-no-recommend": "Ne pas recommander",
		"feedback-recommend-neutral": "Indifférent",
		"feedback-recommend-yes": "Je recommande",
		"feedback-msg": "Laissez-nous votre avis sur votre expérience et comment vous pensez que nous pourrions améliorer l'application (facultatif)",
		"feedback-submit": "Soumettre",
		"feedback-thanks-title": "Merci",
		"feedback-thanks-text": "Merci de nous aider à améliorer! Vous pouvez revenir au début en cliquant sur le bouton ci-dessous.",
		"restaurant-feedback-title": "Votre opinion compte.",
		"restaurant-feedback-subtitle": "Aidez-nous à nous améliorer.",
		"restaurant-feedback-intro": "Parlez-nous de votre expérience dans notre restaurant, en évaluant le service, la nourriture et l'environnement à travers un court questionnaire.",
		"restaurant-feedback-intro-btn": "Donnez votre avis",
		"food-feedback-title": "ALIMENTATION",
		"feed-feedback-intro": "Donnez votre avis et aidez-nous à nous améliorer.",
		"choice-question": "Le menu proposait une bonne sélection de plats",
		"presentation-question": "Les plats ont une bonne présentation",
		"tasty-question": "La nourriture était savoureuse et bien faite",
		"service-feedback-title": "Evaluation du SERVICE",
		"speed-question": "Ils ont rapidement répondu à notre demande",
		"waiters-question": "Les employés étaient amicaux et attentionnés",
		"overall-question": "Globalement, le service était bon",
		"global-feedback-title": "Évaluation GLOBALE",
		"deco-question": "Le restaurant avait une bonne ambiance et un décor",
		"price-question": "Le rapport qualité / prix était bon",
		"recommend-question": "Je recommande le restaurant à un ami",
		"comments-question": "Commentaires et suggestions",
		"recommend_title": "Recommanderiez-vous ce plat?",
		"recommend_title_drink": "Recommanderiez-vous cette boisson??",
		"recommend-total": "{total} les clients recommandent ce plat.",
		"recommend-total_drink": "{total} les clients recommandent cette boisson.",
		"type": "type",
		"body": "corps",
		"region": "région",
		"accidity": "acidité",
		"mypick-text": "Avec myPick, sélectionnez les plats, les boissons et les desserts préférés pour ce repas, puis demandez au serveur.",
		"cookie-notice": "En utilisant ce site, vous acceptez l'utilisation de cookies pour l'analyse et les statistiques.",
		"cookie-link": "Plus d'infos",
		"terms-title": "Termes et conditions",
		"cookies-title": "Politique de cookies",
		"drinks-link-all": "Voir tout",
		"toggle_list": "Liste",
		"toggle_cards": "Cartes",
		"price_under_request": "Preis auf Anfrage"
	};

/***/ },
/* 277 */
/***/ function(module, exports) {

	module.exports = {
		"INLINE": "Testesssss",
		"nav_home": "Inizio",
		"nav_menu": "Menù",
		"nav_about": "Ristorante",
		"nav_wines": "Vino",
		"nav_suggestions": "Suggerimenti",
		"nav_events": "Eventi",
		"nav-feedback": "Tua opinione",
		"follow_text": "Seguici",
		"desktop_languages": "Le lingue",
		"intro_default_option": "Filtra menu per:",
		"suggested_extras": "Contorni suggeriti",
		"suggested_wines": "Vini suggeriti",
		"cta_title": "Vedi la nostra selezione di ",
		"cta_btn": "Vedere",
		"related_products": "Prodotti Simili",
		"error_home_link": "Torna all'inizio",
		"error_home_title1": "Hmm...",
		"error_home_title2": "Impossibile trovare la pagina che stai cercando.",
		"error_home_text": "Prova a riscrivere l'indirizzo o riprova più tardi.",
		"detail_title": "nei dettagli",
		"list_event_title": "Eventi",
		"event_link": "Pagina ufficiale",
		"other_events": "Altri eventi",
		"filters": "Filtri",
		"filter-group-region-type": "Tipo di vino e regione",
		"region_default_option": "Scegli una regione",
		"filter-group-type": "Genere",
		"type_default_option": "Scegli un tipo",
		"filter-group-flavour": "Gusto",
		"filter-group-characteristics": "Caratteristiche del vino",
		"sweetness_default_option": "Acidità",
		"filter-group-body": "Corpo",
		"body_default_option": "Scegli il corpo",
		"filter-group-ingredients": "Ingredienti principali",
		"filter-group-diets": "intolleranze",
		"filter-results": "{results} risultati",
		"filter-clear-button": "Cancella filtri",
		"filter-apply-button": "Applicare",
		"related_dishes": "Piatti Consigliati",
		"empty-title": "Nessun risultato",
		"empty-text": "Al momento non abbiamo risultati da mostrarti, per favore riprova con nuovi parametri.",
		"feedback-title": "Aiutaci a migliorare",
		"feedback-intro": "Lasciaci le tue critiche e opinioni in modo che possiamo migliorare Pickly per te.",
		"feedback-improve": "Pickly ha migliorato la tua esperienza al ristorante?",
		"feedback-error": "Per favore, scegli un'opzione",
		"feedback-harder": "Complicato",
		"feedback-no-help": "Non ha aiutato",
		"feedback-indiferent": "Indifferente",
		"feedback-helped": "Aiutato",
		"feedback-helped-a-lot": "Aiutato molto",
		"feedback-recommend": "Consiglieresti ad altri ristoranti di usare Pickly?",
		"feedback-no-recommend": "Non lo consiglio",
		"feedback-recommend-neutral": "Indifferente",
		"feedback-recommend-yes": "Io raccomando",
		"feedback-msg": "Lasciaci la tua opinione sulla tua esperienza e su come pensi che potremmo migliorare l'applicazione. (opzionale) ",
		"feedback-submit": "Invia",
		"feedback-thanks-title": "Grazie",
		"feedback-thanks-text": "Grazie per aiutarci a migliorare! Puoi tornare all'inizio usando il pulsante qui sotto.",
		"restaurant-feedback-title": "La tua opinione è importante",
		"restaurant-feedback-subtitle": "Aiutaci a migliorare.",
		"restaurant-feedback-intro": "Raccontaci della tua esperienza nel nostro ristorante, valutando il servizio, il cibo e l'ambiente, attraverso un breve questionario.",
		"restaurant-feedback-intro-btn": "Dare un feedback",
		"food-feedback-title": "Valutazione degli alimenti",
		"food-feedback-intro": "Dai la tua opinione e aiutaci a migliorare.",
		"choice-question": "Il menu offriva una buona selezione di piatti",
		"presentation-question": "I piatti hanno avuto una buona presentazione",
		"tasty-question": "Il cibo era gustoso e ben preparato",
		"service-feedback-title": "Valutazione del SERVIZIO",
		"speed-question": "Sono stati rapidi nel gestire la nostra richiesta",
		"waiters-question": "I dipendenti erano cordiali e attenti",
		"overall-question": "Nel complesso, il servizio è stato buono",
		"global-feedback-title": "Valutazione GLOBALE",
		"deco-question": "Il ristorante aveva una buona atmosfera e arredamento",
		"price-question": "Il rapporto qualità / prezzo era buono",
		"recommend-question": "Consiglierei il ristorante ad un amico",
		"comments-question": "Commenti e suggerimenti",
		"recommend_title": "Consiglieresti questo piatto?",
		"recommend-total": "{total} i clienti raccomandano questo piatto.",
		"type": "genere",
		"body": "corpo",
		"region": "regione",
		"accidity": "acidità",
		"mypick-text": "Con myPick selezioni i tuoi piatti, bevande e dessert preferiti per questo pasto. Quindi basta chiedere al cameriere.",
		"cookie-notice": "Utilizzando questo sito, acconsenti all'uso dei cookie per analisi e statistiche.",
		"terms-title": "Termini e condizioni",
		"price_under_request": "Prezzo su richiesta"
	};

/***/ },
/* 278 */
/***/ function(module, exports) {

	module.exports = {
		"INLINE": "Testesssss",
		"nav_home": "Begin",
		"nav_menu": "Menu",
		"nav_about": "Restaurant",
		"nav_wines": "Wijn",
		"nav_suggestions": "Suggesties",
		"nav_events": "Evenementen",
		"nav-feedback": "Jouw mening",
		"follow_text": "Volg ons",
		"desktop_languages": "Talen",
		"intro_default_option": "Filter menu op:",
		"suggested_extras": "Voorgestelde bijgerechten",
		"suggested_wines": "Voorgestelde wijnen",
		"cta_title": "Zie onze selectie van ",
		"cta_btn": "Zien",
		"related_products": "Vergelijkbare producten",
		"error_home_link": "Terug naar start",
		"error_home_title1": "Hmm...",
		"error_home_title2": "De pagina die u zoekt, is niet gevonden.",
		"error_home_text": "Probeer het adres te herschrijven of probeer het later opnieuw.",
		"detail_title": "In detail",
		"list_event_title": "Evenementen",
		"event_link": "Officiële Pagina",
		"other_events": "Andere evenementen",
		"filters": "Filters",
		"filter-group-region-type": "Type wijn en regio",
		"region_default_option": "Kies een regio",
		"filter-group-type": "Type",
		"type_default_option": "Kies een type",
		"filter-group-flavour": "Smaak",
		"filter-group-characteristics": "Wijnkenmerken",
		"sweetness_default_option": "Zuurgraad",
		"filter-group-body": "Lichaam",
		"body_default_option": "Kies het lichaam",
		"filter-group-ingredients": "Hoofdingrediënten",
		"filter-group-diets": "Intoleranties",
		"filter-results": "{results} resultaten",
		"filter-clear-button": "Filters wissen",
		"filter-apply-button": "Toepassen",
		"related_dishes": "Voorgestelde gerechten",
		"empty-title": "Geen resultaten",
		"empty-text": "We hebben momenteel geen resultaten om weer te geven. Probeer het opnieuw met nieuwe parameters.",
		"feedback-title": "Help ons verbeteren",
		"feedback-intro": "Laat ons uw kritiek en meningen achter, zodat we Pickly voor u kunnen verbeteren.",
		"feedback-improve": "Heeft Pickly uw restaurantervaring verbeterd?",
		"feedback-error": "Kies een optie alstublieft",
		"feedback-harder": "Ingewikkeld",
		"feedback-no-help": "Heeft niet geholpen",
		"feedback-indiferent": "Onverschillig",
		"feedback-helped": "Hielp",
		"feedback-helped-a-lot": "Veel geholpen",
		"feedback-recommend": "Zou je andere restaurants aanbevelen om Pickly te gebruiken?",
		"feedback-no-recommend": "Ik raad het niet aan",
		"feedback-recommend-neutral": "Onverschillig",
		"feedback-recommend-yes": "ik raad aan",
		"feedback-msg": "Laat ons uw mening achter over uw ervaring en hoe u denkt dat we de applicatie kunnen verbeteren. (optioneel)",
		"feedback-submit": "Verzenden",
		"feedback-thanks-title": "Dank u",
		"feedback-thanks-text": "Bedankt voor je hulp bij het verbeteren! Via onderstaande knop kunt u terugkeren naar het begin.",
		"restaurant-feedback-title": "Jouw mening is belangrijk.",
		"restaurant-feedback-subtitle": "Help ons verbeteren.",
		"restaurant-feedback-intro": "Vertel ons over uw ervaringen in ons restaurant en evalueer de service, het eten en het milieu door middel van een korte vragenlijst.",
		"restaurant-feedback-intro-btn": "Geef feedback",
		"food-feedback-title": "Beoordeling van voedsel",
		"food-feedback-intro": "Geef uw mening en help ons verbeteren.",
		"choice-question": "Het menu had een goede selectie aan gerechten",
		"presentation-question": "Os pratos tinham uma boa apresentação",
		"tasty-question": "De gerechten hadden een goede presentatie",
		"service-feedback-title": "SERVICE Evaluatie",
		"speed-question": "Ze behandelden ons verzoek snel",
		"waiters-question": "De medewerkers waren vriendelijk en attent",
		"overall-question": "Over het algemeen was de service goed",
		"global-feedback-title": "GLOBALE Evaluatie",
		"deco-question": "Het restaurant had een goede sfeer en inrichting",
		"price-question": "De prijs / kwaliteitverhouding was goed",
		"recommend-question": "Zou het restaurant aanbevelen aan een vriend",
		"comments-question": "Commentaar en suggesties",
		"recommend_title": "Zou je dit gerecht aanbevelen?",
		"recommend-total": "{total} klanten bevelen dit gerecht aan.",
		"type": "type",
		"body": "lichaam",
		"region": "regio",
		"accidity": "zuurgraad",
		"mypick-text": "Met myPick selecteer je jouw favoriete gerechten, drankjes en desserts voor deze maaltijd. Vraag het dan aan de ober.",
		"cookie-notice": "Door deze site te gebruiken, gaat u akkoord met het gebruik van cookies voor analyse en statistieken.",
		"terms-title": "Voorwaarden",
		"price_under_request": "Prijs op aanvraag"
	};

/***/ },
/* 279 */
/***/ function(module, exports) {

	module.exports = {
		"INLINE": "Teste",
		"nav_home": "Início",
		"nav_menu": "Menu",
		"nav_about": "Restaurante",
		"nav_wines": "Vinhos",
		"nav_suggestions": "Sugestões",
		"nav_events": "Eventos",
		"nav-feedback": "A sua opinião",
		"nav-pickly": "Sobre a Pickly",
		"follow_text": "Siga-nos",
		"desktop_languages": "Idiomas",
		"intro_default_option": "Filtrar ementa por:",
		"suggested_extras": "Acompanhamentos sugeridos",
		"suggested_wines": "Vinhos sugeridos",
		"cta_title": "Veja a nossa selecção de ",
		"cta_btn": "Ver",
		"related_products": "Produtos Similares",
		"error_home_link": "Voltar ao início",
		"error_home_title1": "Hmm...",
		"error_home_title2": "Não foi possível encontrar a página que procura.",
		"error_home_text": "Experimente reescrever o endereço ou tente de novo mais tarde.",
		"detail_title": "em detalhe",
		"list_event_title": "Eventos",
		"event_link": "Página oficial",
		"other_events": "Outros eventos",
		"filters": "Filtros",
		"filter-group-region-type": "Tipo de Vinho e Região",
		"region_default_option": "Escolha uma região",
		"filter-group-type": "Tipo",
		"type_default_option": "Escolha um tipo",
		"filter-group-flavour": "Sabor",
		"filter-group-characteristics": "Características do vinho",
		"sweetness_default_option": "Acidez",
		"filter-group-body": "Corpo",
		"body_default_option": "Escolha o corpo",
		"filter-group-ingredients": "Ingredientes Principais",
		"filter-group-diets": "Intolerâncias",
		"filter-results": "{results} resultados",
		"filter-clear-button": "Limpar Filtros",
		"filter-apply-button": "Aplicar",
		"related_dishes": "Pratos Sugeridos",
		"empty-title": "Sem resultados",
		"empty-text": "De momento não temos resultados para lhe apresentar, por favor tente novamente com novos parâmetros.",
		"feedback-title": "Ajude-nos a melhorar",
		"feedback-intro": "Pedimos-lhe que por favor responda a este pequeno questionário de avaliação, onde poderá expôr as suas opiniões e críticas.",
		"feedback-improve": "A Pickly melhorou a sua experiência no restaurante?",
		"feedback-error": "Por favor escolha uma opção",
		"feedback-harder": "Complicou",
		"feedback-no-help": "Não ajudou",
		"feedback-indiferent": "Indiferente",
		"feedback-helped": "Ajudou",
		"feedback-helped-a-lot": "Ajudou Bastante",
		"feedback-recommend": "Recomendaria a Pickly a outros restaurantes?",
		"feedback-no-recommend": "Não Recomendo",
		"feedback-recommend-neutral": "Indiferente",
		"feedback-recommend-yes": "Recomendo",
		"feedback-msg": "Gostaria de deixar alguma sugestão ou crítica para melhor a aplicação e/ou o serviço da Pickly? (opcional)",
		"feedback-submit": "Enviar",
		"feedback-thanks-title": "Obrigado",
		"feedback-thanks-text": "Obrigado por nos ajudar a melhorar! Pode voltar ao início através do botão abaixo.",
		"restaurant-feedback-title": "A sua opinião é importante.",
		"restaurant-feedback-subtitle": "Ajude-nos a melhorar.",
		"restaurant-feedback-intro": "Conte-nos como foi a sua experiência no nosso restaurante, avaliando o serviço, a comida e o ambiente, através de um breve questionário.",
		"restaurant-feedback-intro-btn": "Dar Feedback",
		"food-feedback-title": "Avaliação da COMIDA",
		"food-feedback-intro": "Dê a sua opinião e ajude-nos a melhorar.",
		"choice-question": "O menu tinha uma boa seleção de pratos",
		"presentation-question": "Os pratos tinham uma boa apresentação",
		"tasty-question": "A comida era saborosa e bem confeccionada",
		"service-feedback-title": "Avaliação do SERVIÇO",
		"speed-question": "Foram rápidos a tratar o nosso pedido",
		"waiters-question": "Os empregados foram simpáticos e atenciosos",
		"overall-question": "Em geral, o serviço foi bom",
		"global-feedback-title": "Avaliação GLOBAL",
		"deco-question": "O restaurante tinha um bom ambiente e decoração",
		"price-question": "A relação preço/qualidade foi boa",
		"recommend-question": "Recomendaria o restaurante a um amigo",
		"comments-question": "Comentários e sugestões",
		"recommend_title": "Recomendaria este prato?",
		"recommend_title_drink": "Recomendaria esta bebida?",
		"recommend-total": "{total} clientes recomendam este prato.",
		"recommend-total_drink": "{total} clientes recomendam esta bebida.",
		"type": "tipo",
		"body": "corpo",
		"region": "região",
		"accidity": "acidez",
		"mypick-text": "Com o myPick seleciona os pratos, bebidas e sobremesas preferidos para esta refeição. Depois, é só pedir ao empregado de mesa.",
		"cookie-notice": "Ao utilizar este site estará a consentir a utilização de cookies para análise e estatística.",
		"cookie-link": "Saiba mais",
		"terms-title": "Termos e condições",
		"cookies-title": "Política de cookies",
		"drinks-link-all": "Ver todos",
		"toggle_list": "Lista",
		"toggle_cards": "Cartas",
		"price_under_request": "Preço sob consulta"
	};

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(409);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 281 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseIndexOf = __webpack_require__(285),
	    cacheIndexOf = __webpack_require__(287),
	    createCache = __webpack_require__(288);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(128),
	    isArray = __webpack_require__(129);
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 284 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ },
/* 285 */
/***/ function(module, exports) {

	/**
	 * lodash 3.1.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 * If `fromRight` is provided elements of `array` are iterated from right to left.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 286 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = bindCallback;


/***/ },
/* 287 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = cacheIndexOf;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(289);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 289 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },
/* 290 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties specified
	 * by `props`.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function pickByArray(object, props) {
	  object = toObject(object);
	
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index];
	    if (key in object) {
	      result[key] = object[key];
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = pickByArray;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(284),
	    keysIn = __webpack_require__(130);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * A specialized version of `_.pick` that picks `object` properties `predicate`
	 * returns truthy for.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Object} Returns the new object.
	 */
	function pickByCallback(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key, object) {
	    if (predicate(value, key, object)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.exports = pickByCallback;


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap');
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' ||
	        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (nonEnumShadows || isPrototype(value)) {
	    return !nativeKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEmpty;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(469)(module)))

/***/ },
/* 293 */
/***/ function(module, exports) {

	/**
	 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {
	
	  // Store setTimeout reference so promise-polyfill will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var setTimeoutFunc = setTimeout;
	
	  function noop() {}
	  
	  // Polyfill for Function.prototype.bind
	  function bind(fn, thisArg) {
	    return function () {
	      fn.apply(thisArg, arguments);
	    };
	  }
	
	  function Promise(fn) {
	    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
	    if (typeof fn !== 'function') throw new TypeError('not a function');
	    this._state = 0;
	    this._handled = false;
	    this._value = undefined;
	    this._deferreds = [];
	
	    doResolve(fn, this);
	  }
	
	  function handle(self, deferred) {
	    while (self._state === 3) {
	      self = self._value;
	    }
	    if (self._state === 0) {
	      self._deferreds.push(deferred);
	      return;
	    }
	    self._handled = true;
	    Promise._immediateFn(function () {
	      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	      if (cb === null) {
	        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	        return;
	      }
	      var ret;
	      try {
	        ret = cb(self._value);
	      } catch (e) {
	        reject(deferred.promise, e);
	        return;
	      }
	      resolve(deferred.promise, ret);
	    });
	  }
	
	  function resolve(self, newValue) {
	    try {
	      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
	      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	        var then = newValue.then;
	        if (newValue instanceof Promise) {
	          self._state = 3;
	          self._value = newValue;
	          finale(self);
	          return;
	        } else if (typeof then === 'function') {
	          doResolve(bind(then, newValue), self);
	          return;
	        }
	      }
	      self._state = 1;
	      self._value = newValue;
	      finale(self);
	    } catch (e) {
	      reject(self, e);
	    }
	  }
	
	  function reject(self, newValue) {
	    self._state = 2;
	    self._value = newValue;
	    finale(self);
	  }
	
	  function finale(self) {
	    if (self._state === 2 && self._deferreds.length === 0) {
	      Promise._immediateFn(function() {
	        if (!self._handled) {
	          Promise._unhandledRejectionFn(self._value);
	        }
	      });
	    }
	
	    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	      handle(self, self._deferreds[i]);
	    }
	    self._deferreds = null;
	  }
	
	  function Handler(onFulfilled, onRejected, promise) {
	    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	    this.promise = promise;
	  }
	
	  /**
	   * Take a potentially misbehaving resolver function and make sure
	   * onFulfilled and onRejected are only called once.
	   *
	   * Makes no guarantees about asynchrony.
	   */
	  function doResolve(fn, self) {
	    var done = false;
	    try {
	      fn(function (value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      }, function (reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      });
	    } catch (ex) {
	      if (done) return;
	      done = true;
	      reject(self, ex);
	    }
	  }
	
	  Promise.prototype['catch'] = function (onRejected) {
	    return this.then(null, onRejected);
	  };
	
	  Promise.prototype.then = function (onFulfilled, onRejected) {
	    var prom = new (this.constructor)(noop);
	
	    handle(this, new Handler(onFulfilled, onRejected, prom));
	    return prom;
	  };
	
	  Promise.all = function (arr) {
	    var args = Array.prototype.slice.call(arr);
	
	    return new Promise(function (resolve, reject) {
	      if (args.length === 0) return resolve([]);
	      var remaining = args.length;
	
	      function res(i, val) {
	        try {
	          if (val && (typeof val === 'object' || typeof val === 'function')) {
	            var then = val.then;
	            if (typeof then === 'function') {
	              then.call(val, function (val) {
	                res(i, val);
	              }, reject);
	              return;
	            }
	          }
	          args[i] = val;
	          if (--remaining === 0) {
	            resolve(args);
	          }
	        } catch (ex) {
	          reject(ex);
	        }
	      }
	
	      for (var i = 0; i < args.length; i++) {
	        res(i, args[i]);
	      }
	    });
	  };
	
	  Promise.resolve = function (value) {
	    if (value && typeof value === 'object' && value.constructor === Promise) {
	      return value;
	    }
	
	    return new Promise(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  Promise.reject = function (value) {
	    return new Promise(function (resolve, reject) {
	      reject(value);
	    });
	  };
	
	  Promise.race = function (values) {
	    return new Promise(function (resolve, reject) {
	      for (var i = 0, len = values.length; i < len; i++) {
	        values[i].then(resolve, reject);
	      }
	    });
	  };
	
	  // Use polyfill for setImmediate for performance gains
	  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
	    function (fn) {
	      setTimeoutFunc(fn, 0);
	    };
	
	  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	    if (typeof console !== 'undefined' && console) {
	      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	    }
	  };
	
	  /**
	   * Set the immediate function to execute callbacks
	   * @param fn {function} Function to execute
	   * @deprecated
	   */
	  Promise._setImmediateFn = function _setImmediateFn(fn) {
	    Promise._immediateFn = fn;
	  };
	
	  /**
	   * Change the function to execute on unhandled rejection
	   * @param {function} fn Function to execute on unhandled rejection
	   * @deprecated
	   */
	  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	    Promise._unhandledRejectionFn = fn;
	  };
	  
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Promise;
	  } else if (!root.Promise) {
	    root.Promise = Promise;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110).setImmediate))

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	var invariant = __webpack_require__(2);
	var ReactPropTypesSecret = __webpack_require__(296);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 296 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodashOmit = __webpack_require__(131);
	
	var _lodashOmit2 = _interopRequireDefault(_lodashOmit);
	
	var _tcombReact = __webpack_require__(172);
	
	var _browserCookieLite = __webpack_require__(117);
	
	var _BannerContent = __webpack_require__(132);
	
	var _BannerContent2 = _interopRequireDefault(_BannerContent);
	
	_tcombReact.t['interface'].strict = true;
	
	var Props = _extends({}, _BannerContent.Props, {
	  children: _tcombReact.t.maybe(_tcombReact.t.union([_tcombReact.t.ReactChildren, _tcombReact.t.Function])),
	  onAccept: _tcombReact.t.maybe(_tcombReact.t.Function),
	  cookie: _tcombReact.t.maybe(_tcombReact.t.String),
	  cookieExpiration: _tcombReact.t.maybe(_tcombReact.t.union([_tcombReact.t.Integer, _tcombReact.t['interface']({
	    years: _tcombReact.t.maybe(_tcombReact.t.Number),
	    days: _tcombReact.t.maybe(_tcombReact.t.Number),
	    hours: _tcombReact.t.maybe(_tcombReact.t.Number)
	  })])),
	  cookiePath: _tcombReact.t.maybe(_tcombReact.t.String),
	  dismissOnScroll: _tcombReact.t.maybe(_tcombReact.t.Boolean),
	  dismissOnScrollThreshold: _tcombReact.t.maybe(_tcombReact.t.Number)
	});
	
	/** React Cookie banner dismissable with just a scroll!
	 * @param children - custom component rendered if user has not accepted cookies
	 * @param message - message written inside default cookie banner
	 * @param onAccept - called when user accepts cookies
	 * @param link - object with infos used to render a link to your cookie-policy page
	 * @param buttonMessage - message written inside the button of the default cookie banner
	 * @param cookie - cookie-key used to save user's decision about you cookie-policy
	 * @param cookieExpiration - used to set the cookie expiration
	 * @param cookiePath - used to set the cookie path
	 * @param dismissOnScroll - whether the cookie banner should be dismissed on scroll or not
	 * @param dismissOnScrollThreshold -
	 *   amount of pixel the user need to scroll to dismiss the cookie banner
	 * @param closeIcon - className passed to close-icon
	 * @param disableStyle - pass `true` if you want to disable default style
	 * @param styles - object with custom styles used to overwrite default ones
	 */
	
	var CookieBanner = (function (_React$Component) {
	  _inherits(CookieBanner, _React$Component);
	
	  function CookieBanner() {
	    var _this = this;
	
	    _classCallCheck(this, _CookieBanner);
	
	    _React$Component.apply(this, arguments);
	
	    this.state = { listeningScroll: false };
	
	    this.addOnScrollListener = function (props) {
	      var _props = props || _this.props;
	      if (!_this.state.listeningScroll && !_this.hasAcceptedCookies() && _props.dismissOnScroll) {
	        if (window.attachEvent) {
	          // Internet Explorer
	          window.attachEvent('onscroll', _this.onScroll);
	        } else if (window.addEventListener) {
	          window.addEventListener('scroll', _this.onScroll, false);
	        }
	        _this.setState({ listeningScroll: true });
	      }
	    };
	
	    this.removeOnScrollListener = function () {
	      if (_this.state.listeningScroll) {
	        if (window.detachEvent) {
	          // Internet Explorer
	          window.detachEvent('onscroll', _this.onScroll);
	        } else if (window.removeEventListener) {
	          window.removeEventListener('scroll', _this.onScroll, false);
	        }
	        _this.setState({ listeningScroll: false });
	      }
	    };
	
	    this.onScroll = function () {
	      // tacit agreement buahaha! (evil laugh)
	      if (window.pageYOffset > _this.props.dismissOnScrollThreshold) {
	        _this.onAccept();
	      }
	    };
	
	    this.getSecondsSinceExpiration = function (cookieExpiration) {
	      if (_tcombReact.t.Integer.is(cookieExpiration)) {
	        return cookieExpiration;
	      }
	
	      var SECONDS_IN_YEAR = 31536000;
	      var SECONDS_IN_DAY = 86400;
	      var SECONDS_IN_HOUR = 3600;
	
	      var _cookieExpiration = _extends({
	        years: 0, days: 0, hours: 0
	      }, cookieExpiration);
	
	      var years = _cookieExpiration.years;
	      var days = _cookieExpiration.days;
	      var hours = _cookieExpiration.hours;
	
	      return years * SECONDS_IN_YEAR + days * SECONDS_IN_DAY + hours * SECONDS_IN_HOUR;
	    };
	
	    this.onAccept = function () {
	      var _props2 = _this.props;
	      var cookie = _props2.cookie;
	      var cookieExpiration = _props2.cookieExpiration;
	      var cookiePath = _props2.cookiePath;
	      var onAccept = _props2.onAccept;
	
	      _browserCookieLite.cookie(cookie, true, _this.getSecondsSinceExpiration(cookieExpiration), cookiePath);
	      onAccept({ cookie: cookie });
	
	      if (_this.state.listeningScroll) {
	        _this.removeOnScrollListener();
	      } else {
	        _this.forceUpdate();
	      }
	    };
	
	    this.hasAcceptedCookies = function () {
	      return typeof window !== 'undefined' && _browserCookieLite.cookie(_this.props.cookie);
	    };
	  }
	
	  CookieBanner.prototype.componentDidMount = function componentDidMount() {
	    this.addOnScrollListener();
	  };
	
	  CookieBanner.prototype.getLocals = function getLocals() {
	    var onAccept = this.onAccept;
	    var _props3 = this.props;
	    var message = _props3.message;
	    var link = _props3.link;
	    var buttonMessage = _props3.buttonMessage;
	    var closeIcon = _props3.closeIcon;
	    var disableStyle = _props3.disableStyle;
	    var styles = _props3.styles;
	    var className = _props3.className;
	    var children = _props3.children;
	
	    var props = _objectWithoutProperties(_props3, ['message', 'link', 'buttonMessage', 'closeIcon', 'disableStyle', 'styles', 'className', 'children']);
	
	    return {
	      children: children,
	      onAccept: onAccept,
	      hasAcceptedCookies: this.hasAcceptedCookies(),
	      bannerContentProps: _extends({}, _lodashOmit2['default'](props, Object.keys(Props)), {
	        message: message, onAccept: onAccept, link: link, buttonMessage: buttonMessage,
	        closeIcon: closeIcon, disableStyle: disableStyle, styles: styles, className: className
	      })
	    };
	  };
	
	  CookieBanner.prototype.templateChildren = function templateChildren(_ref) {
	    var children = _ref.children;
	    var onAccept = _ref.onAccept;
	
	    if (_tcombReact.t.Function.is(children)) {
	      return children(onAccept);
	    }
	    return children;
	  };
	
	  CookieBanner.prototype.render = function render() {
	    var _getLocals = this.getLocals();
	
	    var hasAcceptedCookies = _getLocals.hasAcceptedCookies;
	    var children = _getLocals.children;
	    var bannerContentProps = _getLocals.bannerContentProps;
	    var onAccept = _getLocals.onAccept;
	
	    if (hasAcceptedCookies) {
	      return null;
	    }
	
	    return children ? this.templateChildren({ children: children, onAccept: onAccept }) : _react2['default'].createElement(_BannerContent2['default'], bannerContentProps);
	  };
	
	  CookieBanner.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.dismissOnScroll) {
	      this.addOnScrollListener(nextProps);
	    } else {
	      this.removeOnScrollListener();
	    }
	  };
	
	  CookieBanner.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.removeOnScrollListener();
	  };
	
	  _createClass(CookieBanner, null, [{
	    key: 'defaultProps',
	    value: {
	      onAccept: function onAccept() {},
	      dismissOnScroll: true,
	      cookie: 'accepts-cookies',
	      cookieExpiration: { years: 1 },
	      buttonMessage: 'Got it',
	      dismissOnScrollThreshold: 0,
	      styles: {}
	    },
	    enumerable: true
	  }]);
	
	  var _CookieBanner = CookieBanner;
	  CookieBanner = _tcombReact.props(Props, { strict: false })(CookieBanner) || CookieBanner;
	  return CookieBanner;
	})(_react2['default'].Component);
	
	exports['default'] = CookieBanner;
	module.exports = exports['default'];

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _CookieBanner = __webpack_require__(297);
	
	var _CookieBanner2 = _interopRequireDefault(_CookieBanner);
	
	exports['default'] = _CookieBanner2['default'];
	
	var _browserCookieLite = __webpack_require__(117);
	
	exports.cookie = _browserCookieLite.cookie;
	
	var _BannerContent2 = __webpack_require__(132);
	
	var _BannerContent3 = _interopRequireDefault(_BannerContent2);
	
	exports.BannerContent = _BannerContent3['default'];

/***/ },
/* 299 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var styles = {
	  icon: {
	    position: 'absolute',
	    fontSize: '1em',
	    top: '50%',
	    marginTop: '-0.5em',
	    right: '1em',
	    color: 'white',
	    cursor: 'pointer'
	  },
	
	  link: {
	    color: '#F0F0F0',
	    textDecoration: 'underline',
	    marginLeft: '10px'
	  },
	
	  button: {
	    position: 'absolute',
	    top: '50%',
	    right: '35px',
	    height: '24px',
	    lineHeight: '24px',
	    marginTop: '-12px',
	    paddingLeft: '8px',
	    paddingRight: '8px',
	    opacity: '0.5',
	    backgroundColor: 'white',
	    borderRadius: '3px',
	    fontSize: '14px',
	    fontWeight: '500',
	    color: '#242424',
	    cursor: 'pointer'
	  },
	
	  message: {
	    lineHeight: '45px',
	    fontWeight: 500,
	    color: '#F0F0F0'
	  },
	
	  banner: {
	    position: 'relative',
	    textAlign: 'center',
	    backgroundColor: '#484848',
	    width: '100%',
	    height: '45px',
	    zIndex: '10000'
	  }
	};
	
	var getStyle = function getStyle(style) {
	  return styles[style];
	};
	
	exports['default'] = { getStyle: getStyle };
	module.exports = exports['default'];

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSideEffect = __webpack_require__(334);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(228);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(301);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props[property]) {
	            return props[property];
	        }
	    }
	    return null;
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, "title");
	    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");
	
	    return innermostTitle || innermostDefaultTitle || "";
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        return typeof props[tagName] !== "undefined";
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    document.title = title || document.title;
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var htmlTag = document.getElementsByTagName(tagName)[0];
	    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	        htmlTag.setAttribute(attribute, value);
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        htmlTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
	    } else {
	        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector("head");
	    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === "innerHTML") {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === "cssText") {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
	    var attributeString = generateHtmlAttributesAsString(attributes);
	    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === "innerHTML" || attribute === "cssText");
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;
	
	        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    // assigning into an array to define toString function on it
	    var initProps = _defineProperty({
	        key: title
	    }, HELMET_ATTRIBUTE, true);
	    var props = Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var mappedTag = _defineProperty({
	            key: i
	        }, HELMET_ATTRIBUTE, true);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
	                }
	            };
	        case _HelmetConstants.TAG_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return tags;
	                },
	                toString: function toString() {
	                    return generateHtmlAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var htmlAttributes = _ref.htmlAttributes,
	        title = _ref.title,
	        titleAttributes = _ref.titleAttributes,
	        baseTag = _ref.baseTag,
	        metaTags = _ref.metaTags,
	        linkTags = _ref.linkTags,
	        scriptTags = _ref.scriptTags,
	        noscriptTags = _ref.noscriptTags,
	        styleTags = _ref.styleTags;
	    return {
	        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
	        }
	
	        _createClass(HelmetWrapper, [{
	            key: "shouldComponentUpdate",
	            value: function shouldComponentUpdate(nextProps) {
	                return !(0, _deepEqual2.default)(this.props, nextProps);
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2.default.createElement(Component, this.props);
	            }
	        }], [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	            /**
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {String} title: "Title"
	             * @param {String} defaultTitle: "Default Title"
	             * @param {String} titleTemplate: "MySite.com - %s"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             */
	
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        htmlAttributes: _react2.default.PropTypes.object,
	        title: _react2.default.PropTypes.string,
	        defaultTitle: _react2.default.PropTypes.string,
	        titleTemplate: _react2.default.PropTypes.string,
	        titleAttributes: _react2.default.PropTypes.object,
	        base: _react2.default.PropTypes.object,
	        meta: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        link: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        script: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        noscript: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        style: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        onChangeClientState: _react2.default.PropTypes.func
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = mapStateOnServer({
	                htmlAttributes: {},
	                title: "",
	                titleAttributes: {},
	                baseTag: [],
	                metaTags: [],
	                linkTags: [],
	                scriptTags: [],
	                noscriptTags: [],
	                styleTags: []
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        onChangeClientState: getOnChangeClientState(propsList)
	    };
	};
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var htmlAttributes = newState.htmlAttributes,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes,
	        baseTag = newState.baseTag,
	        metaTags = newState.metaTags,
	        linkTags = newState.linkTags,
	        scriptTags = newState.scriptTags,
	        noscriptTags = newState.noscriptTags,
	        styleTags = newState.styleTags,
	        onChangeClientState = newState.onChangeClientState;
	
	
	    updateAttributes("html", htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
	
	exports.default = Helmet(HelmetSideEffects);
	module.exports = exports["default"];

/***/ },
/* 301 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var TAG_NAMES = exports.TAG_NAMES = {
	    HTML: "htmlAttributes",
	    TITLE: "title",
	    BASE: "base",
	    META: "meta",
	    LINK: "link",
	    SCRIPT: "script",
	    NOSCRIPT: "noscript",
	    STYLE: "style"
	};
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    NAME: "name",
	    CHARSET: "charset",
	    HTTPEQUIV: "http-equiv",
	    REL: "rel",
	    HREF: "href",
	    PROPERTY: "property",
	    SRC: "src",
	    INNER_HTML: "innerHTML",
	    CSS_TEXT: "cssText",
	    ITEM_PROP: "itemprop"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    "charset": "charSet",
	    "http-equiv": "httpEquiv",
	    "itemprop": "itemProp",
	    "class": "className"
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window === 'undefined' ? false : /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent);
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// allow for stepper UI on number types
				if (this.props.type === 'number') {
					newInputWidth += 16;
				}
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	;
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(newValue) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.de=t())}(this,function(){"use strict";var e=[{locale:"de",pluralRuleFunction:function(e,t){var n=String(e).split("."),a=!n[1];return t?"other":1==e&&a?"one":"other"},fields:{year:{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},month:{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},day:{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},hour:{displayName:"Stunde",relativeTime:{future:{one:"in {0} Stunde",other:"in {0} Stunden"},past:{one:"vor {0} Stunde",other:"vor {0} Stunden"}}},minute:{displayName:"Minute",relativeTime:{future:{one:"in {0} Minute",other:"in {0} Minuten"},past:{one:"vor {0} Minute",other:"vor {0} Minuten"}}},second:{displayName:"Sekunde",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sekunde",other:"in {0} Sekunden"},past:{one:"vor {0} Sekunde",other:"vor {0} Sekunden"}}}}},{locale:"de-AT",parentLocale:"de"},{locale:"de-BE",parentLocale:"de"},{locale:"de-CH",parentLocale:"de"},{locale:"de-LI",parentLocale:"de"},{locale:"de-LU",parentLocale:"de"}];return e});

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";var e=[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419"},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"Minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-HN",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-NI",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PA",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antes de ayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-US",parentLocale:"es-419"},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}];return e});

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";var e=[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relativeTime:{future:{one:"Dans {0} minute",other:"Dans {0} minutes"},past:{one:"Il y a {0} minute",other:"Il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr"},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}];return e});

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,o){ true?module.exports=o():"function"==typeof define&&define.amd?define(o):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=o())}(this,function(){"use strict";var e=[{locale:"it",pluralRuleFunction:function(e,o){var a=String(e).split("."),t=!a[1];return o?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},hour:{displayName:"ora",relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},second:{displayName:"Secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"}];return e});

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.nl=a())}(this,function(){"use strict";var e=[{locale:"nl",pluralRuleFunction:function(e,a){var n=String(e).split("."),o=!n[1];return a?"other":1==e&&o?"one":"other"},fields:{year:{displayName:"jaar",relative:{0:"dit jaar",1:"volgend jaar","-1":"vorig jaar"},relativeTime:{future:{one:"over {0} jaar",other:"over {0} jaar"},past:{one:"{0} jaar geleden",other:"{0} jaar geleden"}}},month:{displayName:"maand",relative:{0:"deze maand",1:"volgende maand","-1":"vorige maand"},relativeTime:{future:{one:"over {0} maand",other:"over {0} maanden"},past:{one:"{0} maand geleden",other:"{0} maanden geleden"}}},day:{displayName:"dag",relative:{0:"vandaag",1:"morgen",2:"overmorgen","-2":"eergisteren","-1":"gisteren"},relativeTime:{future:{one:"over {0} dag",other:"over {0} dagen"},past:{one:"{0} dag geleden",other:"{0} dagen geleden"}}},hour:{displayName:"Uur",relativeTime:{future:{one:"over {0} uur",other:"over {0} uur"},past:{one:"{0} uur geleden",other:"{0} uur geleden"}}},minute:{displayName:"minuut",relativeTime:{future:{one:"over {0} minuut",other:"over {0} minuten"},past:{one:"{0} minuut geleden",other:"{0} minuten geleden"}}},second:{displayName:"seconde",relative:{0:"nu"},relativeTime:{future:{one:"over {0} seconde",other:"over {0} seconden"},past:{one:"{0} seconde geleden",other:"{0} seconden geleden"}}}}},{locale:"nl-AW",parentLocale:"nl"},{locale:"nl-BE",parentLocale:"nl"},{locale:"nl-BQ",parentLocale:"nl"},{locale:"nl-CW",parentLocale:"nl"},{locale:"nl-SR",parentLocale:"nl"},{locale:"nl-SX",parentLocale:"nl"}];return e});

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,o){ true?module.exports=o():"function"==typeof define&&define.amd?define(o):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.pt=o())}(this,function(){"use strict";var e=[{locale:"pt",pluralRuleFunction:function(e,o){var t=String(e).split("."),a=Number(t[0])==e;return o?"other":a&&e>=0&&e<=2&&2!=e?"one":"other"},fields:{year:{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"em {0} ano",other:"em {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},month:{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"em {0} mês",other:"em {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},day:{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"em {0} dia",other:"em {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},hour:{displayName:"hora",relativeTime:{future:{one:"em {0} hora",other:"em {0} horas"},past:{one:"há {0} hora",other:"há {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"em {0} minuto",other:"em {0} minutos"},past:{one:"há {0} minuto",other:"há {0} minutos"}}},second:{displayName:"segundo",relative:{0:"agora"},relativeTime:{future:{one:"em {0} segundo",other:"em {0} segundos"},past:{one:"há {0} segundo",other:"há {0} segundos"}}}}},{locale:"pt-AO",parentLocale:"pt-PT"},{locale:"pt-PT",parentLocale:"pt",pluralRuleFunction:function(e,o){var t=String(e).split("."),a=!t[1];return o?"other":1==e&&a?"one":"other"},fields:{year:{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"dentro de {0} ano",other:"dentro de {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},month:{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"dentro de {0} mês",other:"dentro de {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},day:{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"dentro de {0} dia",other:"dentro de {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"há {0} hora",other:"há {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"há {0} minuto",other:"há {0} minutos"}}},second:{displayName:"segundo",relative:{0:"agora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"há {0} segundo",other:"há {0} segundos"}}}}},{locale:"pt-CV",parentLocale:"pt-PT"},{locale:"pt-GW",parentLocale:"pt-PT"},{locale:"pt-MO",parentLocale:"pt-PT"},{locale:"pt-MZ",parentLocale:"pt-PT"},{locale:"pt-ST",parentLocale:"pt-PT"},{locale:"pt-TL",parentLocale:"pt-PT"}];return e});

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(133);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function lazyload(WrappedComponent) {
	    return function (_Component) {
	      _inherits(LazyLoadDecorated, _Component);
	
	      function LazyLoadDecorated() {
	        _classCallCheck(this, LazyLoadDecorated);
	
	        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));
	
	        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
	        return _this;
	      }
	
	      _createClass(LazyLoadDecorated, [{
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            _index2.default,
	            options,
	            _react2.default.createElement(WrappedComponent, this.props)
	          );
	        }
	      }]);
	
	      return LazyLoadDecorated;
	    }(_react.Component);
	  };
	};

/***/ },
/* 310 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  var args = void 0;
	  var context = void 0;
	  var timestamp = void 0;
	  var result = void 0;
	
	  var later = function later() {
	    var last = +new Date() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = null;
	          args = null;
	        }
	      }
	    }
	  };
	
	  return function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = +new Date();
	
	    var callNow = immediate && !timeout;
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	
	    if (callNow) {
	      result = func.apply(context, args);
	      context = null;
	      args = null;
	    }
	
	    return result;
	  };
	}

/***/ },
/* 311 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.on = on;
	exports.off = off;
	function on(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.addEventListener) {
	    el.addEventListener(eventName, callback, opts);
	  } else if (el.attachEvent) {
	    el.attachEvent("on" + eventName, function (e) {
	      callback.call(el, e || window.event);
	    });
	  }
	}
	
	function off(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.removeEventListener) {
	    el.removeEventListener(eventName, callback, opts);
	  } else if (el.detachEvent) {
	    el.detachEvent("on" + eventName, callback);
	  }
	}

/***/ },
/* 312 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * @fileOverview Find scroll parent
	 */
	
	exports.default = function (node) {
	  if (!node) {
	    return document.documentElement;
	  }
	
	  var excludeStaticParent = node.style.position === 'absolute';
	  var overflowRegex = /(scroll|auto)/;
	  var parent = node;
	
	  while (parent) {
	    if (!parent.parentNode) {
	      return node.ownerDocument || document.documentElement;
	    }
	
	    var style = window.getComputedStyle(parent);
	    var position = style.position;
	    var overflow = style.overflow;
	    var overflowX = style['overflow-x'];
	    var overflowY = style['overflow-y'];
	
	    if (position === 'static' && excludeStaticParent) {
	      parent = parent.parentNode;
	      continue;
	    }
	
	    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return node.ownerDocument || node.documentElement || document.documentElement;
	};

/***/ },
/* 313 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throttle;
	/*eslint-disable */
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last, deferTimer;
	  return function () {
	    var context = scope || this;
	
	    var now = +new Date(),
	        args = arguments;
	    if (last && now < last + threshhold) {
	      // hold on to it
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(context, args);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(context, args);
	    }
	  };
	}

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(123);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(75);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(124);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(75);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(324);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(135);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(134);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(325);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(326);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(327);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(328);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(77);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(331);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(125);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(76);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(22);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(22);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(22);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(40);
	
	var _Router = __webpack_require__(76);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(22);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(77);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 329 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(272)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(329);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(136);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Select = __webpack_require__(60);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(137);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(138);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	;
	
	function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 333 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = trim;
	function trim(str) {
	    return str.replace(/^\s+|\s+$/g, '');
	}

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(235);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(408);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(26);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(81);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(26);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(341);

/***/ },
/* 338 */
/***/ function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    scrolling: false,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    swiping: false,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(340);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(81);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(338);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(144);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(226);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(26);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(342);
	
	var _dots = __webpack_require__(336);
	
	var _arrows = __webpack_require__(335);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  displayName: 'InnerSlider',
	
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    slide = Number(slide);
	    !isNaN(slide) && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(145);
	
	var _helpers = __webpack_require__(81);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = Number(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.scrolling) {
	      return;
	    }
	    if (this.state.animating) {
	      e.preventDefault();
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
	      this.setState({
	        scrolling: true
	      });
	      return;
	    }
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = verticalSwipeLength;
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      this.setState({
	        swiping: true
	      });
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    var wasScrolling = this.state.scrolling;
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      scrolling: false,
	      swiping: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    if (wasScrolling) {
	      return;
	    }
	
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(339);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(280);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(144);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(223);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(234);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className + ' unslicked' },
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(26);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slideClass = child.props.className || '';
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(10);
	
	var focusNode = __webpack_require__(120);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(27);
	var EventPropagators = __webpack_require__(47);
	var ExecutionEnvironment = __webpack_require__(14);
	var FallbackCompositionState = __webpack_require__(350);
	var SyntheticCompositionEvent = __webpack_require__(388);
	var SyntheticInputEvent = __webpack_require__(391);
	
	var keyOf = __webpack_require__(34);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(146);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactInstrumentation = __webpack_require__(21);
	
	var camelizeStyleName = __webpack_require__(239);
	var dangerousStyleValue = __webpack_require__(398);
	var hyphenateStyleName = __webpack_require__(246);
	var memoizeStringOnly = __webpack_require__(249);
	var warning = __webpack_require__(5);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(27);
	var EventPluginHub = __webpack_require__(46);
	var EventPropagators = __webpack_require__(47);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(24);
	var SyntheticEvent = __webpack_require__(28);
	
	var getEventTarget = __webpack_require__(100);
	var isEventSupported = __webpack_require__(101);
	var isTextInputElement = __webpack_require__(170);
	var keyOf = __webpack_require__(34);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(42);
	var ExecutionEnvironment = __webpack_require__(14);
	
	var createNodesFromMarkup = __webpack_require__(242);
	var emptyFunction = __webpack_require__(18);
	var invariant = __webpack_require__(2);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(34);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(27);
	var EventPropagators = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(10);
	var SyntheticMouseEvent = __webpack_require__(63);
	
	var keyOf = __webpack_require__(34);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(35);
	
	var getTextContentAccessor = __webpack_require__(168);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(43);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactChildren = __webpack_require__(149);
	var ReactComponent = __webpack_require__(88);
	var ReactPureComponent = __webpack_require__(378);
	var ReactClass = __webpack_require__(150);
	var ReactDOMFactories = __webpack_require__(361);
	var ReactElement = __webpack_require__(23);
	var ReactPropTypes = __webpack_require__(160);
	var ReactVersion = __webpack_require__(161);
	
	var onlyChild = __webpack_require__(404);
	var warning = __webpack_require__(5);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(44);
	
	var instantiateReactComponent = __webpack_require__(169);
	var KeyEscapeUtils = __webpack_require__(86);
	var shouldUpdateReactComponent = __webpack_require__(102);
	var traverseAllChildren = __webpack_require__(103);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(90);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('./ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(82);
	var ReactDOMIDOperations = __webpack_require__(363);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var ReactComponentEnvironment = __webpack_require__(89);
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactElement = __webpack_require__(23);
	var ReactErrorUtils = __webpack_require__(91);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(21);
	var ReactNodeTypes = __webpack_require__(159);
	var ReactPropTypeLocations = __webpack_require__(94);
	var ReactReconciler = __webpack_require__(44);
	
	var checkReactTypeSpec = __webpack_require__(397);
	var emptyObject = __webpack_require__(39);
	var invariant = __webpack_require__(2);
	var shallowEqual = __webpack_require__(73);
	var shouldUpdateReactComponent = __webpack_require__(102);
	var warning = __webpack_require__(5);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent;
	
	    if (false) {
	      renderedComponent = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedComponent = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDefaultInjection = __webpack_require__(371);
	var ReactMount = __webpack_require__(157);
	var ReactReconciler = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(24);
	var ReactVersion = __webpack_require__(161);
	
	var findDOMNode = __webpack_require__(399);
	var getHostComponentFromComposite = __webpack_require__(166);
	var renderSubtreeIntoContainer = __webpack_require__(406);
	var warning = __webpack_require__(5);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(61);
	
	/**
	 * Implements a <button> host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getHostProps: DisabledInputUtils.getHostProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var AutoFocusUtils = __webpack_require__(343);
	var CSSPropertyOperations = __webpack_require__(345);
	var DOMLazyTree = __webpack_require__(42);
	var DOMNamespaces = __webpack_require__(83);
	var DOMProperty = __webpack_require__(43);
	var DOMPropertyOperations = __webpack_require__(148);
	var EventConstants = __webpack_require__(27);
	var EventPluginHub = __webpack_require__(46);
	var EventPluginRegistry = __webpack_require__(84);
	var ReactBrowserEventEmitter = __webpack_require__(62);
	var ReactDOMButton = __webpack_require__(357);
	var ReactDOMComponentFlags = __webpack_require__(151);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMInput = __webpack_require__(364);
	var ReactDOMOption = __webpack_require__(365);
	var ReactDOMSelect = __webpack_require__(152);
	var ReactDOMTextarea = __webpack_require__(368);
	var ReactInstrumentation = __webpack_require__(21);
	var ReactMultiChild = __webpack_require__(376);
	var ReactServerRenderingTransaction = __webpack_require__(381);
	
	var emptyFunction = __webpack_require__(18);
	var escapeTextContentForBrowser = __webpack_require__(64);
	var invariant = __webpack_require__(2);
	var isEventSupported = __webpack_require__(101);
	var keyOf = __webpack_require__(34);
	var shallowEqual = __webpack_require__(73);
	var validateDOMNesting = __webpack_require__(104);
	var warning = __webpack_require__(5);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getHostProps(this, props, hostParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getHostProps(this, lastProps);
	        nextProps = ReactDOMButton.getHostProps(this, nextProps);
	        break;
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(104);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(42);
	var ReactDOMComponentTree = __webpack_require__(10);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(23);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 362 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(82);
	var ReactDOMComponentTree = __webpack_require__(10);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var DisabledInputUtils = __webpack_require__(61);
	var DOMPropertyOperations = __webpack_require__(148);
	var LinkedValueUtils = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(24);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, DisabledInputUtils.getHostProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactChildren = __webpack_require__(149);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMSelect = __webpack_require__(152);
	
	var warning = __webpack_require__(5);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  ReactChildren.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var getNodeForCharacterOffset = __webpack_require__(402);
	var getTextContentAccessor = __webpack_require__(168);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var DOMChildrenOperations = __webpack_require__(82);
	var DOMLazyTree = __webpack_require__(42);
	var ReactDOMComponentTree = __webpack_require__(10);
	
	var escapeTextContentForBrowser = __webpack_require__(64);
	var invariant = __webpack_require__(2);
	var validateDOMNesting = __webpack_require__(104);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(6);
	
	var DisabledInputUtils = __webpack_require__(61);
	var LinkedValueUtils = __webpack_require__(87);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(24);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactUpdates = __webpack_require__(24);
	var Transaction = __webpack_require__(50);
	
	var emptyFunction = __webpack_require__(18);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(344);
	var ChangeEventPlugin = __webpack_require__(346);
	var DefaultEventPluginOrder = __webpack_require__(348);
	var EnterLeaveEventPlugin = __webpack_require__(349);
	var HTMLDOMPropertyConfig = __webpack_require__(351);
	var ReactComponentBrowserEnvironment = __webpack_require__(354);
	var ReactDOMComponent = __webpack_require__(358);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMEmptyComponent = __webpack_require__(360);
	var ReactDOMTreeTraversal = __webpack_require__(369);
	var ReactDOMTextComponent = __webpack_require__(367);
	var ReactDefaultBatchingStrategy = __webpack_require__(370);
	var ReactEventListener = __webpack_require__(373);
	var ReactInjection = __webpack_require__(374);
	var ReactReconcileTransaction = __webpack_require__(379);
	var SVGDOMPropertyConfig = __webpack_require__(383);
	var SelectEventPlugin = __webpack_require__(384);
	var SimpleEventPlugin = __webpack_require__(385);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(46);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventListener = __webpack_require__(119);
	var ExecutionEnvironment = __webpack_require__(14);
	var PooledClass = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(24);
	
	var getEventTarget = __webpack_require__(100);
	var getUnboundedScrollPosition = __webpack_require__(244);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(43);
	var EventPluginHub = __webpack_require__(46);
	var EventPluginUtils = __webpack_require__(85);
	var ReactComponentEnvironment = __webpack_require__(89);
	var ReactClass = __webpack_require__(150);
	var ReactEmptyComponent = __webpack_require__(153);
	var ReactBrowserEventEmitter = __webpack_require__(62);
	var ReactHostComponent = __webpack_require__(155);
	var ReactUpdates = __webpack_require__(24);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(396);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactComponentEnvironment = __webpack_require__(89);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(21);
	var ReactMultiChildUpdateTypes = __webpack_require__(158);
	
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactReconciler = __webpack_require__(44);
	var ReactChildReconciler = __webpack_require__(353);
	
	var emptyFunction = __webpack_require__(18);
	var flattenChildren = __webpack_require__(400);
	var invariant = __webpack_require__(2);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPureComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(88);
	var ReactNoopUpdateQueue = __webpack_require__(92);
	
	var emptyObject = __webpack_require__(39);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(147);
	var PooledClass = __webpack_require__(35);
	var ReactBrowserEventEmitter = __webpack_require__(62);
	var ReactInputSelection = __webpack_require__(156);
	var ReactInstrumentation = __webpack_require__(21);
	var Transaction = __webpack_require__(50);
	var ReactUpdateQueue = __webpack_require__(96);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(377);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return (
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement.ref !== prevElement.ref ||
	    // If owner changes but we have an unchanged function ref, don't update refs
	    typeof nextElement.ref === 'string' && nextElement._owner !== prevElement._owner
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(35);
	var Transaction = __webpack_require__(50);
	var ReactInstrumentation = __webpack_require__(21);
	var ReactServerUpdateQueue = __webpack_require__(382);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerUpdateQueue
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(96);
	var Transaction = __webpack_require__(50);
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  /* :: transaction: Transaction; */
	
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 383 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(27);
	var EventPropagators = __webpack_require__(47);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInputSelection = __webpack_require__(156);
	var SyntheticEvent = __webpack_require__(28);
	
	var getActiveElement = __webpack_require__(121);
	var isTextInputElement = __webpack_require__(170);
	var keyOf = __webpack_require__(34);
	var shallowEqual = __webpack_require__(73);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventConstants = __webpack_require__(27);
	var EventListener = __webpack_require__(119);
	var EventPropagators = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(10);
	var SyntheticAnimationEvent = __webpack_require__(386);
	var SyntheticClipboardEvent = __webpack_require__(387);
	var SyntheticEvent = __webpack_require__(28);
	var SyntheticFocusEvent = __webpack_require__(390);
	var SyntheticKeyboardEvent = __webpack_require__(392);
	var SyntheticMouseEvent = __webpack_require__(63);
	var SyntheticDragEvent = __webpack_require__(389);
	var SyntheticTouchEvent = __webpack_require__(393);
	var SyntheticTransitionEvent = __webpack_require__(394);
	var SyntheticUIEvent = __webpack_require__(49);
	var SyntheticWheelEvent = __webpack_require__(395);
	
	var emptyFunction = __webpack_require__(18);
	var getEventCharCode = __webpack_require__(98);
	var invariant = __webpack_require__(2);
	var keyOf = __webpack_require__(34);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(63);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(49);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(49);
	
	var getEventCharCode = __webpack_require__(98);
	var getEventKey = __webpack_require__(401);
	var getEventModifierState = __webpack_require__(99);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(49);
	
	var getEventModifierState = __webpack_require__(99);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(63);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 396 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule checkReactTypeSpec
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactPropTypeLocationNames = __webpack_require__(93);
	var ReactPropTypesSecret = __webpack_require__(95);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(90);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = require('./ReactComponentTreeHook');
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(146);
	var warning = __webpack_require__(5);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInstanceMap = __webpack_require__(48);
	
	var getHostComponentFromComposite = __webpack_require__(166);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(86);
	var traverseAllChildren = __webpack_require__(103);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(90);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(98);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 402 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactElement = __webpack_require__(23);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(64);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(157);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 407 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 408 */
/***/ function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ },
/* 409 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var t = __webpack_require__(411);
	var stringify = t.stringify;
	
	var noobj = {};
	
	var ValidationError = t.struct({
	  message: t.Any,
	  actual: t.Any,
	  expected: t.Any,
	  path: t.list(t.union([t.String, t.Number]))
	}, 'ValidationError');
	
	function getDefaultValidationErrorMessage(actual, expected, path) {
	  var expectedName = t.getTypeName(expected);
	  var to = path.length ? '/' + path.join('/') + ': ' + expectedName : expectedName;
	  return 'Invalid value ' + stringify(actual) + ' supplied to ' + to;
	}
	
	function getValidationErrorMessage(actual, expected, path, context) {
	  if (t.Function.is(expected.getValidationErrorMessage)) {
	    return expected.getValidationErrorMessage(actual, path, context);
	  }
	  else {
	    return getDefaultValidationErrorMessage(actual, expected, path);
	  }
	}
	
	ValidationError.of = function (actual, expected, path, context) {
	  return new ValidationError({
	    message: getValidationErrorMessage(actual, expected, path, context),
	    actual: actual,
	    expected: expected,
	    path: path
	  });
	};
	
	var ValidationResult = t.struct({
	  errors: t.list(ValidationError),
	  value: t.Any
	}, 'ValidationResult');
	
	ValidationResult.prototype.isValid = function () {
	  return !(this.errors.length);
	};
	
	ValidationResult.prototype.firstError = function () {
	  return this.isValid() ? null : this.errors[0];
	};
	
	ValidationResult.prototype.toString = function () {
	  if (this.isValid()) {
	    return '[ValidationResult, true, ' + stringify(this.value) + ']';
	  }
	  else {
	    return '[ValidationResult, false, (' + this.errors.map(function (err) {
	      return stringify(err.message);
	    }).join(', ') + ')]';
	  }
	};
	
	function validate(x, type, options) {
	  options = options || {};
	  var path = t.Array.is(options) ? options : options.path || [];
	  return new ValidationResult(recurse(x, type, path, options));
	}
	
	function recurse(x, type, path, options) {
	  if (t.isType(type)) {
	    return validators[type.meta.kind](x, type, path, options);
	  }
	  else {
	    return validators.es6classes(x, type, path, options);
	  }
	}
	
	var validators = validate.validators = {};
	
	validators.es6classes = function validateES6Classes(x, type, path, options) {
	  return {
	    value: x,
	    errors: x instanceof type ? [] : [ValidationError.of(x, type, path, options.context)]
	  };
	};
	
	// irreducibles and enums
	validators.irreducible =
	validators.enums = function validateIrreducible(x, type, path, options) {
	  return {
	    value: x,
	    errors: type.is(x) ? [] : [ValidationError.of(x, type, path, options.context)]
	  };
	};
	
	validators.list = function validateList(x, type, path, options) {
	
	  // x should be an array
	  if (!t.Array.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	  }
	
	  var ret = {value: [], errors: []};
	  // every item should be of type `type.meta.type`
	  for (var i = 0, len = x.length; i < len; i++ ) {
	    var item = recurse(x[i], type.meta.type, path.concat(i), options);
	    ret.value[i] = item.value;
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	validators.subtype = function validateSubtype(x, type, path, options) {
	
	  // x should be a valid inner type
	  var ret = recurse(x, type.meta.type, path, options);
	  if (ret.errors.length) {
	    return ret;
	  }
	
	  // x should satisfy the predicate
	  if (!type.meta.predicate(ret.value)) {
	    ret.errors = [ValidationError.of(x, type, path, options.context)];
	  }
	
	  return ret;
	
	};
	
	validators.maybe = function validateMaybe(x, type, path, options) {
	  return t.Nil.is(x) ?
	    {value: x, errors: []} :
	    recurse(x, type.meta.type, path, options);
	};
	
	validators.struct = function validateStruct(x, type, path, options) {
	
	  // x should be an object
	  if (!t.Object.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	  }
	
	  // [optimization]
	  if (type.is(x)) {
	    return {value: x, errors: []};
	  }
	
	  var ret = {value: {}, errors: []};
	  var props = type.meta.props;
	  var defaultProps = type.meta.defaultProps || noobj;
	  // every item should be of type `props[name]`
	  for (var name in props) {
	    if (props.hasOwnProperty(name)) {
	      var actual = x[name];
	      // apply defaults
	      if (actual === undefined) {
	        actual = defaultProps[name];
	      }
	      var prop = recurse(actual, props[name], path.concat(name), options);
	      ret.value[name] = prop.value;
	      ret.errors = ret.errors.concat(prop.errors);
	    }
	  }
	  var strict = options.hasOwnProperty('strict') ? options.strict : type.meta.strict;
	  if (strict) {
	    for (var field in x) {
	      if (x.hasOwnProperty(field) && !props.hasOwnProperty(field)) {
	        ret.errors.push(ValidationError.of(x[field], t.Nil, path.concat(field), options.context));
	      }
	    }
	  }
	  if (!ret.errors.length) {
	    ret.value = new type(ret.value);
	  }
	  return ret;
	};
	
	validators.tuple = function validateTuple(x, type, path, options) {
	
	  var types = type.meta.types;
	  var len = types.length;
	
	  // x should be an array of at most `len` items
	  if (!t.Array.is(x) || x.length > len) {
	    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	  }
	
	  var ret = {value: [], errors: []};
	  // every item should be of type `types[i]`
	  for (var i = 0; i < len; i++) {
	    var item = recurse(x[i], types[i], path.concat(i), options);
	    ret.value[i] = item.value;
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	validators.dict = function validateDict(x, type, path, options) {
	
	  // x should be an object
	  if (!t.Object.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	  }
	
	  var ret = {value: {}, errors: []};
	  // every key should be of type `domain`
	  // every value should be of type `codomain`
	  for (var k in x) {
	    if (x.hasOwnProperty(k)) {
	      var subpath = path.concat(k);
	      var key = recurse(k, type.meta.domain, subpath, options);
	      var item = recurse(x[k], type.meta.codomain, subpath, options);
	      ret.value[k] = item.value;
	      ret.errors = ret.errors.concat(key.errors, item.errors);
	    }
	  }
	  return ret;
	};
	
	validators.union = function validateUnion(x, type, path, options) {
	  var ctor = type.dispatch(x);
	  return t.Function.is(ctor) ?
	    recurse(x, ctor, path.concat(type.meta.types.indexOf(ctor)), options) :
	    {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	};
	
	validators.intersection = function validateIntersection(x, type, path, options) {
	
	  var types = type.meta.types;
	  var len = types.length;
	
	  var ret = {value: x, errors: []};
	  var nrOfStructs = 0;
	  // x should be of type `types[i]` for all i
	  for (var i = 0; i < len; i++) {
	    if (types[i].meta.kind === 'struct') {
	      nrOfStructs++;
	    }
	    var item = recurse(x, types[i], path, options);
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  if (nrOfStructs > 1) {
	    ret.errors.push(ValidationError.of(x, type, path, options.context));
	  }
	  return ret;
	};
	
	validators['interface'] = function validateInterface(x, type, path, options) { // eslint-disable-line dot-notation
	
	  // x should be an object
	  if (!t.Object.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	  }
	
	  var ret = {value: {}, errors: []};
	  var props = type.meta.props;
	  // every item should be of type `props[name]`
	  for (var name in props) {
	    var prop = recurse(x[name], props[name], path.concat(name), options);
	    ret.value[name] = prop.value;
	    ret.errors = ret.errors.concat(prop.errors);
	  }
	  var strict = options.hasOwnProperty('strict') ? options.strict : type.meta.strict;
	  if (strict) {
	    for (var field in x) {
	      if (!props.hasOwnProperty(field) && !t.Nil.is(x[field])) {
	        ret.errors.push(ValidationError.of(x[field], t.Nil, path.concat(field), options.context));
	      }
	    }
	  }
	  return ret;
	};
	
	t.mixin(t, {
	  ValidationError: ValidationError,
	  ValidationResult: ValidationResult,
	  validate: validate
	});
	
	module.exports = t;


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/*! @preserve
	 *
	 * tcomb.js - Type checking and DDD for JavaScript
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2014-2016 Giulio Canti
	 *
	 */
	
	// core
	var t = __webpack_require__(8);
	
	// types
	t.Any = __webpack_require__(105);
	t.Array = __webpack_require__(412);
	t.Boolean = __webpack_require__(173);
	t.Date = __webpack_require__(413);
	t.Error = __webpack_require__(414);
	t.Function = __webpack_require__(66);
	t.Nil = __webpack_require__(174);
	t.Number = __webpack_require__(175);
	t.Integer = __webpack_require__(415);
	t.IntegerT = t.Integer;
	t.Object = __webpack_require__(416);
	t.RegExp = __webpack_require__(417);
	t.String = __webpack_require__(106);
	t.Type = __webpack_require__(418);
	t.TypeT = t.Type;
	
	// short alias are deprecated
	t.Arr = t.Array;
	t.Bool = t.Boolean;
	t.Dat = t.Date;
	t.Err = t.Error;
	t.Func = t.Function;
	t.Num = t.Number;
	t.Obj = t.Object;
	t.Re = t.RegExp;
	t.Str = t.String;
	
	// combinators
	t.dict = __webpack_require__(107);
	t.declare = __webpack_require__(419);
	t.enums = __webpack_require__(421);
	t.irreducible = __webpack_require__(17);
	t.list = __webpack_require__(181);
	t.maybe = __webpack_require__(430);
	t.refinement = __webpack_require__(109);
	t.struct = __webpack_require__(431);
	t.tuple = __webpack_require__(183);
	t.union = __webpack_require__(432);
	t.func = __webpack_require__(423);
	t.intersection = __webpack_require__(425);
	t.subtype = t.refinement;
	t.inter = __webpack_require__(424); // IE8 alias
	t['interface'] = t.inter;
	
	// functions
	t.assert = t;
	t.update = __webpack_require__(433);
	t.mixin = __webpack_require__(108);
	t.isType = __webpack_require__(16);
	t.is = __webpack_require__(30);
	t.getTypeName = __webpack_require__(13);
	t.match = __webpack_require__(429);
	
	module.exports = t;


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	var isArray = __webpack_require__(31);
	
	module.exports = irreducible('Array', isArray);


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	
	module.exports = irreducible('Date', function (x) { return x instanceof Date; });


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	
	module.exports = irreducible('Error', function (x) { return x instanceof Error; });


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var refinement = __webpack_require__(109);
	var Number = __webpack_require__(175);
	
	module.exports = refinement(Number, function (x) { return x % 1 === 0; }, 'Integer');


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	var isObject = __webpack_require__(33);
	
	module.exports = irreducible('Object', isObject);


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	
	module.exports = irreducible('RegExp', function (x) { return x instanceof RegExp; });


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(17);
	var isType = __webpack_require__(16);
	
	module.exports = irreducible('Type', isType);

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var isType = __webpack_require__(16);
	var isNil = __webpack_require__(25);
	var mixin = __webpack_require__(108);
	var getTypeName = __webpack_require__(13);
	var isUnion = __webpack_require__(180);
	
	// All the .declare-d types should be clearly different from each other thus they should have
	// different names when a name was not explicitly provided.
	var nextDeclareUniqueId = 1;
	
	module.exports = function declare(name) {
	  if (false) {
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + name + ' supplied to declare([name]) (expected a string)'; });
	  }
	
	  var type;
	
	  function Declare(value, path) {
	    if (false) {
	      assert(!isNil(type), function () { return 'Type declared but not defined, don\'t forget to call .define on every declared type'; });
	      if (isUnion(type)) {
	        assert(type.dispatch === Declare.dispatch, function () { return 'Please define the custom ' + name + '.dispatch function before calling ' + name + '.define()'; });
	      }
	    }
	    return type(value, path);
	  }
	
	  Declare.define = function (spec) {
	    if (false) {
	      assert(isType(spec), function () { return 'Invalid argument type ' + assert.stringify(spec) +  ' supplied to define(type) (expected a type)'; });
	      assert(isNil(type), function () { return 'Declare.define(type) can only be invoked once'; });
	      // assert(isNil(spec.meta.name) && Object.keys(spec.prototype).length === 0, function () { return 'Invalid argument type ' + assert.stringify(spec) + ' supplied to define(type) (expected a fresh, unnamed type)'; });
	    }
	
	    if (isUnion(spec) && Declare.hasOwnProperty('dispatch')) {
	      spec.dispatch = Declare.dispatch;
	    }
	    type = spec;
	    mixin(Declare, type, true); // true because it overwrites Declare.displayName
	    if (name) {
	      type.displayName = Declare.displayName = name;
	      Declare.meta.name = name;
	    }
	    Declare.meta.identity = type.meta.identity;
	    Declare.prototype = type.prototype;
	    return Declare;
	  };
	
	  Declare.displayName = name || ( getTypeName(Declare) + "$" + nextDeclareUniqueId++ );
	  // in general I can't say if this type will be an identity, for safety setting to false
	  Declare.meta = { identity: false };
	  Declare.prototype = null;
	  return Declare;
	};


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(16);
	
	function isRefinement(type) {
	  return isType(type) && type.meta.kind === 'subtype';
	}
	
	function getPredicates(type) {
	  return isRefinement(type) ?
	    [type.meta.predicate].concat(getPredicates(type.meta.type)) :
	    [];
	}
	
	function getUnrefinedType(type) {
	  return isRefinement(type) ?
	    getUnrefinedType(type.meta.type) :
	    type;
	}
	
	function decompose(type) {
	  return {
	    predicates: getPredicates(type),
	    unrefinedType: getUnrefinedType(type)
	  };
	}
	
	module.exports = decompose;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var forbidNewOperator = __webpack_require__(51);
	var isString = __webpack_require__(68);
	var isObject = __webpack_require__(33);
	
	function getDefaultName(map) {
	  return Object.keys(map).map(function (k) { return assert.stringify(k); }).join(' | ');
	}
	
	function enums(map, name) {
	
	  if (false) {
	    assert(isObject(map), function () { return 'Invalid argument map ' + assert.stringify(map) + ' supplied to enums(map, [name]) combinator (expected a dictionary of String -> String | Number)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to enums(map, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(map);
	
	  function Enums(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Enums);
	      path = path || [displayName];
	      assert(Enums.is(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected one of ' + assert.stringify(Object.keys(map)) + ')'; });
	    }
	
	    return value;
	  }
	
	  Enums.meta = {
	    kind: 'enums',
	    map: map,
	    name: name,
	    identity: true
	  };
	
	  Enums.displayName = displayName;
	
	  Enums.is = function (x) {
	    return map.hasOwnProperty(x);
	  };
	
	  return Enums;
	}
	
	enums.of = function (keys, name) {
	  keys = isString(keys) ? keys.split(' ') : keys;
	  var value = {};
	  keys.forEach(function (k) {
	    value[k] = k;
	  });
	  return enums(value, name);
	};
	
	enums.getDefaultName = getDefaultName;
	module.exports = enums;
	


/***/ },
/* 422 */
/***/ function(module, exports) {

	module.exports = function fail(message) {
	  throw new TypeError('[tcomb] ' + message);
	};

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var FunctionType = __webpack_require__(66);
	var isArray = __webpack_require__(31);
	var list = __webpack_require__(181);
	var isObject = __webpack_require__(33);
	var create = __webpack_require__(29);
	var isNil = __webpack_require__(25);
	var isBoolean = __webpack_require__(67);
	var tuple = __webpack_require__(183);
	var getFunctionName = __webpack_require__(52);
	var getTypeName = __webpack_require__(13);
	var isType = __webpack_require__(16);
	
	function getDefaultName(domain, codomain) {
	  return '(' + domain.map(getTypeName).join(', ') + ') => ' + getTypeName(codomain);
	}
	
	function isInstrumented(f) {
	  return FunctionType.is(f) && isObject(f.instrumentation);
	}
	
	function getOptionalArgumentsIndex(types) {
	  var end = types.length;
	  var areAllMaybes = false;
	  for (var i = end - 1; i >= 0; i--) {
	    var type = types[i];
	    if (!isType(type) || type.meta.kind !== 'maybe') {
	      return (i + 1);
	    } else {
	      areAllMaybes = true;
	    }
	  }
	  return areAllMaybes ? 0 : end;
	}
	
	function func(domain, codomain, name) {
	
	  domain = isArray(domain) ? domain : [domain]; // handle handy syntax for unary functions
	
	  if (false) {
	    assert(list(FunctionType).is(domain), function () { return 'Invalid argument domain ' + assert.stringify(domain) + ' supplied to func(domain, codomain, [name]) combinator (expected an array of types)'; });
	    assert(FunctionType.is(codomain), function () { return 'Invalid argument codomain ' + assert.stringify(codomain) + ' supplied to func(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to func(domain, codomain, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(domain, codomain);
	  var domainLength = domain.length;
	  var optionalArgumentsIndex = getOptionalArgumentsIndex(domain);
	
	  function FuncType(value, path) {
	
	    if (!isInstrumented(value)) { // automatically instrument the function
	      return FuncType.of(value);
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(FuncType.is(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return value;
	  }
	
	  FuncType.meta = {
	    kind: 'func',
	    domain: domain,
	    codomain: codomain,
	    name: name,
	    identity: true
	  };
	
	  FuncType.displayName = displayName;
	
	  FuncType.is = function (x) {
	    return isInstrumented(x) &&
	      x.instrumentation.domain.length === domainLength &&
	      x.instrumentation.domain.every(function (type, i) {
	        return type === domain[i];
	      }) &&
	      x.instrumentation.codomain === codomain;
	  };
	
	  FuncType.of = function (f, curried) {
	
	    if (false) {
	      assert(FunctionType.is(f), function () { return 'Invalid argument f supplied to func.of ' + displayName + ' (expected a function)'; });
	      assert(isNil(curried) || isBoolean(curried), function () { return 'Invalid argument curried ' + assert.stringify(curried) + ' supplied to func.of ' + displayName + ' (expected a boolean)'; });
	    }
	
	    if (FuncType.is(f)) { // makes FuncType.of idempotent
	      return f;
	    }
	
	    function fn() {
	      var args = Array.prototype.slice.call(arguments);
	      var argsLength = args.length;
	
	      if (false) {
	        // type-check arguments
	        var tupleLength = curried ? argsLength : Math.max(argsLength, optionalArgumentsIndex);
	        tuple(domain.slice(0, tupleLength), 'arguments of function ' + displayName)(args);
	      }
	
	      if (curried && argsLength < domainLength) {
	        if (false) {
	          assert(argsLength > 0, 'Invalid arguments.length = 0 for curried function ' + displayName);
	        }
	        var g = Function.prototype.bind.apply(f, [this].concat(args));
	        var newDomain = func(domain.slice(argsLength), codomain);
	        return newDomain.of(g, true);
	      }
	      else {
	        return create(codomain, f.apply(this, args));
	      }
	    }
	
	    fn.instrumentation = {
	      domain: domain,
	      codomain: codomain,
	      f: f
	    };
	
	    fn.displayName = getFunctionName(f);
	
	    return fn;
	
	  };
	
	  return FuncType;
	
	}
	
	func.getDefaultName = getDefaultName;
	func.getOptionalArgumentsIndex = getOptionalArgumentsIndex;
	module.exports = func;


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var String = __webpack_require__(106);
	var Function = __webpack_require__(66);
	var isBoolean = __webpack_require__(67);
	var isObject = __webpack_require__(33);
	var isNil = __webpack_require__(25);
	var create = __webpack_require__(29);
	var getTypeName = __webpack_require__(13);
	var dict = __webpack_require__(107);
	var getDefaultInterfaceName = __webpack_require__(178);
	var isIdentity = __webpack_require__(32);
	var is = __webpack_require__(30);
	var extend = __webpack_require__(177);
	var assign = __webpack_require__(176);
	
	function extendInterface(mixins, name) {
	  return extend(inter, mixins, name);
	}
	
	function getOptions(options) {
	  if (!isObject(options)) {
	    options = isNil(options) ? {} : { name: options };
	  }
	  if (!options.hasOwnProperty('strict')) {
	    options.strict = inter.strict;
	  }
	  return options;
	}
	
	function inter(props, options) {
	
	  options = getOptions(options);
	  var name = options.name;
	  var strict = options.strict;
	
	  if (false) {
	    assert(dict(String, Function).is(props), function () { return 'Invalid argument props ' + assert.stringify(props) + ' supplied to interface(props, [options]) combinator (expected a dictionary String -> Type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to interface(props, [options]) combinator (expected a string)'; });
	    assert(isBoolean(strict), function () { return 'Invalid argument strict ' + assert.stringify(strict) + ' supplied to struct(props, [options]) combinator (expected a boolean)'; });
	  }
	
	  var displayName = name || getDefaultInterfaceName(props);
	  var identity = Object.keys(props).map(function (prop) { return props[prop]; }).every(isIdentity);
	
	  function Interface(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value; // just trust the input if elements must not be hydrated
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(!isNil(value), function () { return 'Invalid value ' + value + ' supplied to ' + path.join('/'); });
	      // strictness
	      if (strict) {
	        for (var k in value) {
	          assert(props.hasOwnProperty(k), function () { return 'Invalid additional prop "' + k + '" supplied to ' + path.join('/'); });
	        }
	      }
	    }
	
	    var idempotent = true;
	    var ret = identity ? {} : assign({}, value);
	    for (var prop in props) {
	      var expected = props[prop];
	      var actual = value[prop];
	      var instance = create(expected, actual, (  false ? path.concat(prop + ': ' + getTypeName(expected)) : null ));
	      idempotent = idempotent && ( actual === instance );
	      ret[prop] = instance;
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	
	  }
	
	  Interface.meta = {
	    kind: 'interface',
	    props: props,
	    name: name,
	    identity: identity,
	    strict: strict
	  };
	
	  Interface.displayName = displayName;
	
	  Interface.is = function (x) {
	    if (isNil(x)) {
	      return false;
	    }
	    if (strict) {
	      for (var k in x) {
	        if (!props.hasOwnProperty(k)) {
	          return false;
	        }
	      }
	    }
	    for (var prop in props) {
	      if (!is(x[prop], props[prop])) {
	        return false;
	      }
	    }
	    return true;
	  };
	
	  Interface.update = function (instance, patch) {
	    return Interface(assert.update(instance, patch));
	  };
	
	  Interface.extend = function (xs, name) {
	    return extendInterface([Interface].concat(xs), name);
	  };
	
	  return Interface;
	}
	
	inter.strict = false;
	inter.getOptions = getOptions;
	inter.getDefaultName = getDefaultInterfaceName;
	inter.extend = extendInterface;
	module.exports = inter;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var isFunction = __webpack_require__(15);
	var isArray = __webpack_require__(31);
	var forbidNewOperator = __webpack_require__(32);
	var is = __webpack_require__(30);
	var getTypeName = __webpack_require__(13);
	var isIdentity = __webpack_require__(32);
	
	function getDefaultName(types) {
	  return types.map(getTypeName).join(' & ');
	}
	
	function intersection(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction) && types.length >= 2, function () { return 'Invalid argument types ' + assert.stringify(types) + ' supplied to intersection(types, [name]) combinator (expected an array of at least 2 types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to intersection(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(types);
	  var identity = types.every(isIdentity);
	
	  function Intersection(value, path) {
	
	    if (false) {
	      if (identity) {
	        forbidNewOperator(this, Intersection);
	      }
	      path = path || [displayName];
	      assert(Intersection.is(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return value;
	  }
	
	  Intersection.meta = {
	    kind: 'intersection',
	    types: types,
	    name: name,
	    identity: identity
	  };
	
	  Intersection.displayName = displayName;
	
	  Intersection.is = function (x) {
	    return types.every(function (type) {
	      return is(x, type);
	    });
	  };
	
	  Intersection.update = function (instance, patch) {
	    return Intersection(assert.update(instance, patch));
	  };
	
	  return Intersection;
	}
	
	intersection.getDefaultName = getDefaultName;
	module.exports = intersection;
	


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(16);
	
	module.exports = function isInterface(x) {
	  return isType(x) && ( x.meta.kind === 'interface' );
	};

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(16);
	
	module.exports = function isMaybe(x) {
	  return isType(x) && ( x.meta.kind === 'maybe' );
	};

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(16);
	
	module.exports = function isStruct(x) {
	  return isType(x) && ( x.meta.kind === 'struct' );
	};

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isFunction = __webpack_require__(15);
	var isType = __webpack_require__(16);
	var Any = __webpack_require__(105);
	
	module.exports = function match(x) {
	  var type, guard, f, count;
	  for (var i = 1, len = arguments.length; i < len; ) {
	    type = arguments[i];
	    guard = arguments[i + 1];
	    f = arguments[i + 2];
	
	    if (isFunction(f) && !isType(f)) {
	      i = i + 3;
	    }
	    else {
	      f = guard;
	      guard = Any.is;
	      i = i + 2;
	    }
	
	    if (false) {
	      count = (count || 0) + 1;
	      assert(isType(type), function () { return 'Invalid type in clause #' + count; });
	      assert(isFunction(guard), function () { return 'Invalid guard in clause #' + count; });
	      assert(isFunction(f), function () { return 'Invalid block in clause #' + count; });
	    }
	
	    if (type.is(x) && guard(x)) {
	      return f(x);
	    }
	  }
	  assert.fail('Match error');
	};


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var isFunction = __webpack_require__(15);
	var isMaybe = __webpack_require__(427);
	var isIdentity = __webpack_require__(32);
	var Any = __webpack_require__(105);
	var create = __webpack_require__(29);
	var Nil = __webpack_require__(174);
	var forbidNewOperator = __webpack_require__(51);
	var is = __webpack_require__(30);
	var getTypeName = __webpack_require__(13);
	
	function getDefaultName(type) {
	  return '?' + getTypeName(type);
	}
	
	function maybe(type, name) {
	
	  if (isMaybe(type) || type === Any || type === Nil) { // makes the combinator idempotent and handle Any, Nil
	    return type;
	  }
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + assert.stringify(type) + ' supplied to maybe(type, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to maybe(type, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(type);
	  var identity = isIdentity(type);
	
	  function Maybe(value, path) {
	    if (false) {
	      if (identity) {
	        forbidNewOperator(this, Maybe);
	      }
	    }
	    return Nil.is(value) ? value : create(type, value, path);
	  }
	
	  Maybe.meta = {
	    kind: 'maybe',
	    type: type,
	    name: name,
	    identity: identity
	  };
	
	  Maybe.displayName = displayName;
	
	  Maybe.is = function (x) {
	    return Nil.is(x) || is(x, type);
	  };
	
	  return Maybe;
	}
	
	maybe.getDefaultName = getDefaultName;
	module.exports = maybe;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var String = __webpack_require__(106);
	var Function = __webpack_require__(66);
	var isBoolean = __webpack_require__(67);
	var isObject = __webpack_require__(33);
	var isNil = __webpack_require__(25);
	var create = __webpack_require__(29);
	var getTypeName = __webpack_require__(13);
	var dict = __webpack_require__(107);
	var getDefaultInterfaceName = __webpack_require__(178);
	var extend = __webpack_require__(177);
	
	function getDefaultName(props) {
	  return 'Struct' + getDefaultInterfaceName(props);
	}
	
	function extendStruct(mixins, name) {
	  return extend(struct, mixins, name);
	}
	
	function getOptions(options) {
	  if (!isObject(options)) {
	    options = isNil(options) ? {} : { name: options };
	  }
	  if (!options.hasOwnProperty('strict')) {
	    options.strict = struct.strict;
	  }
	  if (!options.hasOwnProperty('defaultProps')) {
	    options.defaultProps = {};
	  }
	  return options;
	}
	
	function struct(props, options) {
	
	  options = getOptions(options);
	  var name = options.name;
	  var strict = options.strict;
	  var defaultProps = options.defaultProps;
	
	  if (false) {
	    assert(dict(String, Function).is(props), function () { return 'Invalid argument props ' + assert.stringify(props) + ' supplied to struct(props, [options]) combinator (expected a dictionary String -> Type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to struct(props, [options]) combinator (expected a string)'; });
	    assert(isBoolean(strict), function () { return 'Invalid argument strict ' + assert.stringify(strict) + ' supplied to struct(props, [options]) combinator (expected a boolean)'; });
	    assert(isObject(defaultProps), function () { return 'Invalid argument defaultProps ' + assert.stringify(defaultProps) + ' supplied to struct(props, [options]) combinator (expected an object)'; });
	  }
	
	  var displayName = name || getDefaultName(props);
	
	  function Struct(value, path) {
	
	    if (Struct.is(value)) { // implements idempotency
	      return value;
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isObject(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an object)'; });
	      // strictness
	      if (strict) {
	        for (k in value) {
	          if (value.hasOwnProperty(k)) {
	            assert(props.hasOwnProperty(k), function () { return 'Invalid additional prop "' + k + '" supplied to ' + path.join('/'); });
	          }
	        }
	      }
	    }
	
	    if (!(this instanceof Struct)) { // `new` is optional
	      return new Struct(value, path);
	    }
	
	    for (var k in props) {
	      if (props.hasOwnProperty(k)) {
	        var expected = props[k];
	        var actual = value[k];
	        // apply defaults
	        if (actual === undefined) {
	          actual = defaultProps[k];
	        }
	        this[k] = create(expected, actual, (  false ? path.concat(k + ': ' + getTypeName(expected)) : null ));
	      }
	    }
	
	    if (false) {
	      Object.freeze(this);
	    }
	
	  }
	
	  Struct.meta = {
	    kind: 'struct',
	    props: props,
	    name: name,
	    identity: false,
	    strict: strict,
	    defaultProps: defaultProps
	  };
	
	  Struct.displayName = displayName;
	
	  Struct.is = function (x) {
	    return x instanceof Struct;
	  };
	
	  Struct.update = function (instance, patch) {
	    return new Struct(assert.update(instance, patch));
	  };
	
	  Struct.extend = function (xs, name) {
	    return extendStruct([Struct].concat(xs), name);
	  };
	
	  return Struct;
	}
	
	struct.strict = false;
	struct.getOptions = getOptions;
	struct.getDefaultName = getDefaultName;
	struct.extend = extendStruct;
	module.exports = struct;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isTypeName = __webpack_require__(19);
	var isFunction = __webpack_require__(15);
	var getTypeName = __webpack_require__(13);
	var isIdentity = __webpack_require__(32);
	var isArray = __webpack_require__(31);
	var create = __webpack_require__(29);
	var is = __webpack_require__(30);
	var forbidNewOperator = __webpack_require__(51);
	var isUnion = __webpack_require__(180);
	var isNil = __webpack_require__(25);
	
	function getDefaultName(types) {
	  return types.map(getTypeName).join(' | ');
	}
	
	function union(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction) && types.length >= 2, function () { return 'Invalid argument types ' + assert.stringify(types) + ' supplied to union(types, [name]) combinator (expected an array of at least 2 types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to union(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(types);
	  var identity = types.every(isIdentity);
	
	  function Union(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value;
	      }
	    }
	
	    var type = Union.dispatch(value);
	    if (!type && Union.is(value)) {
	      return value;
	    }
	
	    if (false) {
	      if (identity) {
	        forbidNewOperator(this, Union);
	      }
	      path = path || [displayName];
	      assert(isFunction(type), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (no constructor returned by dispatch)'; });
	      path[path.length - 1] += '(' + getTypeName(type) + ')';
	    }
	
	    return create(type, value, path);
	  }
	
	  Union.meta = {
	    kind: 'union',
	    types: types,
	    name: name,
	    identity: identity
	  };
	
	  Union.displayName = displayName;
	
	  Union.is = function (x) {
	    return types.some(function (type) {
	      return is(x, type);
	    });
	  };
	
	  Union.dispatch = function (x) { // default dispatch implementation
	    for (var i = 0, len = types.length; i < len; i++ ) {
	      var type = types[i];
	      if (isUnion(type)) { // handle union of unions
	        var t = type.dispatch(x);
	        if (!isNil(t)) {
	          return t;
	        }
	      }
	      else if (is(x, type)) {
	        return type;
	      }
	    }
	  };
	
	  Union.update = function (instance, patch) {
	    return Union(assert.update(instance, patch));
	  };
	
	  return Union;
	}
	
	union.getDefaultName = getDefaultName;
	module.exports = union;
	


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(8);
	var isObject = __webpack_require__(33);
	var isFunction = __webpack_require__(15);
	var isArray = __webpack_require__(31);
	var isNumber = __webpack_require__(179);
	var assign = __webpack_require__(176);
	
	function getShallowCopy(x) {
	  if (isObject(x)) {
	    if (x instanceof Date || x instanceof RegExp) {
	      return x;
	    }
	    return assign({}, x);
	  }
	  if (isArray(x)) {
	    return x.concat();
	  }
	  return x;
	}
	
	function isCommand(k) {
	  return update.commands.hasOwnProperty(k);
	}
	
	function getCommand(k) {
	  return update.commands[k];
	}
	
	function update(instance, patch) {
	
	  if (false) {
	    assert(isObject(patch), function () { return 'Invalid argument patch ' + assert.stringify(patch) + ' supplied to function update(instance, patch): expected an object containing commands'; });
	  }
	
	  var value = instance;
	  var isChanged = false;
	  var newValue;
	  for (var k in patch) {
	    if (patch.hasOwnProperty(k)) {
	      if (isCommand(k)) {
	        newValue = getCommand(k)(patch[k], value);
	        if (newValue !== instance) {
	          isChanged = true;
	          value = newValue;
	        } else {
	          value = instance;
	        }
	      }
	      else {
	        if (value === instance) {
	          value = getShallowCopy(instance);
	        }
	        newValue = update(value[k], patch[k]);
	        isChanged = isChanged || ( newValue !== value[k] );
	        value[k] = newValue;
	      }
	    }
	  }
	  return isChanged ? value : instance;
	}
	
	// built-in commands
	
	function $apply(f, value) {
	  if (false) {
	    assert(isFunction(f), 'Invalid argument f supplied to immutability helper { $apply: f } (expected a function)');
	  }
	  return f(value);
	}
	
	function $push(elements, arr) {
	  if (false) {
	    assert(isArray(elements), 'Invalid argument elements supplied to immutability helper { $push: elements } (expected an array)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $push (expected an array)');
	  }
	  if (elements.length > 0) {
	    return arr.concat(elements);
	  }
	  return arr;
	}
	
	function $remove(keys, obj) {
	  if (false) {
	    assert(isArray(keys), 'Invalid argument keys supplied to immutability helper { $remove: keys } (expected an array)');
	    assert(isObject(obj), 'Invalid value supplied to immutability helper $remove (expected an object)');
	  }
	  if (keys.length > 0) {
	    obj = getShallowCopy(obj);
	    for (var i = 0, len = keys.length; i < len; i++ ) {
	      delete obj[keys[i]];
	    }
	  }
	  return obj;
	}
	
	function $set(value) {
	  return value;
	}
	
	function $splice(splices, arr) {
	  if (false) {
	    assert(isArray(splices) && splices.every(isArray), 'Invalid argument splices supplied to immutability helper { $splice: splices } (expected an array of arrays)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $splice (expected an array)');
	  }
	  if (splices.length > 0) {
	    arr = getShallowCopy(arr);
	    return splices.reduce(function (acc, splice) {
	      acc.splice.apply(acc, splice);
	      return acc;
	    }, arr);
	  }
	  return arr;
	}
	
	function $swap(config, arr) {
	  if (false) {
	    assert(isObject(config), 'Invalid argument config supplied to immutability helper { $swap: config } (expected an object)');
	    assert(isNumber(config.from), 'Invalid argument config.from supplied to immutability helper { $swap: config } (expected a number)');
	    assert(isNumber(config.to), 'Invalid argument config.to supplied to immutability helper { $swap: config } (expected a number)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $swap (expected an array)');
	  }
	  if (config.from !== config.to) {
	    arr = getShallowCopy(arr);
	    var element = arr[config.to];
	    arr[config.to] = arr[config.from];
	    arr[config.from] = element;
	  }
	  return arr;
	}
	
	function $unshift(elements, arr) {
	  if (false) {
	    assert(isArray(elements), 'Invalid argument elements supplied to immutability helper {$unshift: elements} (expected an array)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $unshift (expected an array)');
	  }
	  if (elements.length > 0) {
	    return elements.concat(arr);
	  }
	  return arr;
	}
	
	function $merge(whatToMerge, value) {
	  var isChanged = false;
	  var result = getShallowCopy(value);
	  for (var k in whatToMerge) {
	    if (whatToMerge.hasOwnProperty(k)) {
	      result[k] = whatToMerge[k];
	      isChanged = isChanged || ( result[k] !== value[k] );
	    }
	  }
	  return isChanged ? result : value;
	}
	
	update.commands = {
	  $apply: $apply,
	  $push: $push,
	  $remove: $remove,
	  $set: $set,
	  $splice: $splice,
	  $swap: $swap,
	  $unshift: $unshift,
	  $merge: $merge
	};
	
	module.exports = update;


/***/ },
/* 434 */
59,
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cookie = __webpack_require__(224);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _utils = __webpack_require__(436);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Cookies = function () {
	  function Cookies(cookies, hooks) {
	    _classCallCheck(this, Cookies);
	
	    this.cookies = parseCookies(cookies);
	    this.hooks = hooks;
	    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
	  }
	
	  _createClass(Cookies, [{
	    key: '_updateBrowserValues',
	    value: function _updateBrowserValues() {
	      if (!this.HAS_DOCUMENT_COOKIE) {
	        return;
	      }
	
	      this.cookies = _cookie2.default.parse(document.cookie);
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._updateBrowserValues();
	      return readCookie(this.cookies[name], options);
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this._updateBrowserValues();
	      var result = {};
	
	      for (var name in this.cookies) {
	        result[name] = readCookie(this.cookies[name], options);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'set',
	    value: function set(name, value, options) {
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        value = JSON.stringify(value);
	      }
	
	      if (this.hooks && this.hooks.onSet) {
	        this.hooks.onSet(name, value, options);
	      }
	
	      this.cookies[name] = value;
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, value, options);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove(name, options) {
	      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
	        expires: new Date(1970, 1, 1, 0, 0, 1),
	        maxAge: 0
	      });
	
	      if (this.hooks && this.hooks.onRemove) {
	        this.hooks.onRemove(name, finalOptions);
	      }
	
	      delete this.cookies[name];
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
	      }
	    }
	  }]);
	
	  return Cookies;
	}();
	
	exports.default = Cookies;
	
	
	function parseCookies(cookies) {
	  if (typeof cookies === 'string') {
	    return _cookie2.default.parse(cookies);
	  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
	    return cookies;
	  } else {
	    return {};
	  }
	}
	
	function isParsingCookie(value, doNotParse) {
	  if (typeof doNotParse === 'undefined') {
	    // We guess if the cookie start with { or [, it has been serialized
	    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
	  }
	
	  return !doNotParse;
	}
	
	function readCookie(value) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (isParsingCookie(value, options.doNotParse)) {
	    try {
	      return JSON.parse(value);
	    } catch (e) {
	      // At least we tried
	    }
	  }
	
	  return value;
	}
	module.exports = exports['default'];

/***/ },
/* 436 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.hasDocumentCookie = hasDocumentCookie;
	exports.cleanCookies = cleanCookies;
	// Can we get/set cookies on document.cookie?
	
	function hasDocumentCookie() {
	  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
	}
	
	//backwards compatibility
	var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
	
	function cleanCookies() {
	  document.cookie.split(';').forEach(function (c) {
	    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
	  });
	}

/***/ },
/* 437 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 438 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 439 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 440 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 441 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEzOSAxMjUiPgogIDx0aXRsZT5GcnV0b3MgZGUgY2FzY2EgcmlqYTwvdGl0bGU+CiAgPHBhdGgKICAgIGQ9Ik02OS41LDUuOTJBNTYuNTgsNTYuNTgsMCwxLDAsMTI2LjA4LDYyLjUsNTYuNTgsNTYuNTgsMCwwLDAsNjkuNSw1LjkyWm0wLDEwNy4zM0E1MC43NSw1MC43NSwwLDEsMSwxMjAuMjUsNjIuNSw1MC43NSw1MC43NSwwLDAsMSw2OS41LDExMy4yNVoiLz4KICA8cmVjdCB4PSIyNy4wNiIgeT0iODcuMjciIHdpZHRoPSIzMC41NSIgaGVpZ2h0PSI2LjMzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTEuNTUgNTYuNDIpIHJvdGF0ZSgtNDUpIi8+CiAgPHJlY3QgeD0iODIuNSIgeT0iMzEuNzIiIHdpZHRoPSIzMC43NiIgaGVpZ2h0PSI2LjMzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDc5LjQzKSByb3RhdGUoLTQ1KSIvPgogIDxwYXRoCiAgICBkPSJNNzcuNjksNDIuODlzLTEuNjIsNy40NS0xMC44NiwxN1M1MS4wNyw3MC40MSw1MS4wNyw3MC40MWMxMy44MiwxNC4zLDMwLjA4LDIxLjI2LDM4LjYxLDE3LjEyQTEuMjUsMS4yNSwwLDAsMCw5MCw4OGEyLjM2LDIuMzYsMCwwLDAsMy4yNS0zLjI2LjIyLjIyLDAsMCwwLS4wOS0uMDdjNi04LjE0LS42MS0yNi40LTE1LjQ2LTQxLjc3Wk04Mi44LDYyLjYyYTEuNjksMS42OSwwLDAsMSwyLjg4LTEuNzdjOC4xMSwxMy4yNCw1LjM3LDIxLjQ3LDUuMjUsMjEuODJhMS42NCwxLjY0LDAsMCwxLTIuMTMsMSwxLjQsMS40LDAsMCwxLS42NS0uNCwxLjY4LDEuNjgsMCwwLDEtLjQyLTEuNzNjMC0uMDcsMi4yNi03LjItNC45My0xOC45NVptMCwwIi8+CiAgPHBhdGgKICAgIGQ9Ik01MS4xNSw0NGMtOC4wOSw4LjA5LTkuNCwxOS45MS0zLjcyLDI1LjU5LDAsMCwyMi44OS04LjksMjguNjQtMzAtNC4zMi01LjQ2LTE1LjQyLTMuOTEtMjMuNDgsM2EzLjY4LDMuNjgsMCwwLDAtLjMxLS40MSwzMi4yMiwzMi4yMiwwLDAsMC0zLjY4LTIuNDVjLS43MS0uNDItMS40NS0xLjEtMi4zMy0xYTMuNTcsMy41NywwLDAsMC0yLjU3LDEuMi4yNi4yNiwwLDAsMCwwLC4zMyw1LjUzLDUuNTMsMCwwLDAsMS45MSwxLjc5Yy41OS4zOCwxLjMyLjEyLDIsLjIzczMsMS4xMywzLjczLDEuMzRsLjEzLjA2LS4zMS4yOFptMCwwIi8+Cjwvc3ZnPgo="

/***/ },
/* 442 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 443 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEzOSAxMjUiPgogIDx0aXRsZT5Nb3N0YXJkYSBlIHByb2R1dG9zIMOgIGJhc2UgZGUgbW9zdGFyZGE8L3RpdGxlPgogIDxwYXRoCiAgICBkPSJNNjkuNSw1LjkyQTU2LjU4LDU2LjU4LDAsMSwwLDEyNi4wOCw2Mi41LDU2LjU4LDU2LjU4LDAsMCwwLDY5LjUsNS45MlptMCwxMDcuMzNBNTAuNzUsNTAuNzUsMCwxLDEsMTIwLjI1LDYyLjUsNTAuNzUsNTAuNzUsMCwwLDEsNjkuNSwxMTMuMjVaIi8+CiAgPHJlY3QgeD0iMjUuNzciIHk9Ijg0LjE2IiB3aWR0aD0iMzkuMzMiIGhlaWdodD0iNi4zMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ4LjQ0IDU3LjcxKSByb3RhdGUoLTQ1KSIvPgogIDxyZWN0IHg9Ijc3LjIyIiB5PSIzMy45IiB3aWR0aD0iMzYuOTUiIGhlaWdodD0iNi4zMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS44MiA3OC41Mikgcm90YXRlKC00NSkiLz4KICA8cGF0aAogICAgZD0iTTgxLjg3LDU3LjcybDE1LDE0LjUzYzEuNDEsMS4zNywxLjQzLDIuMzguMDYsMy44UTkxLjQ1LDgxLjc4LDg1LjksODcuNTFjLTEuMjEsMS4yNS0yLjMsMS4yNy0zLjU2LjA2TDUxLjksNTguMTZhMi4xLDIuMSwwLDAsMSwwLTMuNDFRNTcuNDMsNDksNjMsNDMuMjJjMS40Mi0xLjQ3LDIuMzQtMS40NywzLjgzLDBaIi8+CiAgPHBhdGgKICAgIGQ9Ik02Miw0Mi43Myw1MS41Myw1My41NmMtMS0xLTItMS44Ny0yLjkyLTIuODlhMS4zLDEuMywwLDAsMSwuMS0xLjI2YzMtMy4xNiw2LTYuMjcsOS05LjM4YTEsMSwwLDAsMSwxLjQ1LDBDNjAuMTEsNDAuODgsNjEsNDEuNzgsNjIsNDIuNzNaIi8+CiAgPHBhdGgKICAgIGQ9Ik01NC4xOSw0Mi4xOGwtMy40OCwzLjZMNDgsNDIuMjdjLTEtMS4yNi0xLjkzLTIuNTQtMi45MS0zLjc5YS45Mi45MiwwLDAsMSwuMDgtMS40MmMuNDQtLjQ1LjgzLS43NiwxLjQ2LS4zQzQ5LjExLDM4LjU2LDUxLjYxLDQwLjM0LDU0LjE5LDQyLjE4WiIvPgo8L3N2Zz4K"

/***/ },
/* 444 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEzOSAxMjUiPgogIDxkZWZzPgogICAgPHN0eWxlPi5jbHMtMXtmaWxsOiMwMTAxMDE7fTwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5QZWl4ZXMgZSBwcm9kdXRvcyDDoCBiYXNlIGRlIHBlaXhlPC90aXRsZT4KICA8cGF0aAogICAgZD0iTTY5LjUsNS45MkE1Ni41OCw1Ni41OCwwLDEsMCwxMjYuMDgsNjIuNSw1Ni41OCw1Ni41OCwwLDAsMCw2OS41LDUuOTJabTAsMTA3LjMzQTUwLjc1LDUwLjc1LDAsMSwxLDEyMC4yNSw2Mi41LDUwLjc1LDUwLjc1LDAsMCwxLDY5LjUsMTEzLjI1WiIvPgogIDxyZWN0IHg9IjI4LjMiIHk9IjkwLjI4IiB3aWR0aD0iMjIuMDQiIGhlaWdodD0iNi4zMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU0LjU2IDU1LjE3KSByb3RhdGUoLTQ1KSIvPgogIDxyZWN0IHg9IjgwLjA0IiB5PSIzMi43NCIgd2lkdGg9IjMzLjY1IiBoZWlnaHQ9IjYuMzMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuOTggNzkuMDEpIHJvdGF0ZSgtNDUpIi8+CiAgPHBhdGggY2xhc3M9ImNscy0xIgogICAgICAgIGQ9Ik0xMDAuNzcsNjIuNWExNC4zMiwxNC4zMiwwLDAsMCw1LjQ1LTExLjI2LDE1LjIyLDE1LjIyLDAsMCwwLS4xMS0xLjc5LDEzLjUzLDEzLjUzLDAsMCwwLTEuODEtLjEyLDEzLjE2LDEzLjE2LDAsMCwwLTEzLDEwLjkxaDBjLTIuNDktMy4xOS04Ljg5LTguMS0xNi40NC0xMS42N2gwbDUuMzktOC4yM2MtMTEuNzktMy44MS0xOC41Miw0LTE4LjUyLDRoMGEyOS44NywyOS44NywwLDAsMC00LjE4LS4zMiwxOS43NiwxOS43NiwwLDAsMC00LjkzLjYzLDMwLjQ5LDMwLjQ5LDAsMCwxLDAsMzUuNjQsMTkuNzYsMTkuNzYsMCwwLDAsNC45My42MywyOS44NywyOS44NywwLDAsMCw0LjE4LS4zMmgwczYuNzMsNy44NCwxOC41Miw0bC01LjM5LTguMjNoMGM3LjU0LTMuNTcsMTQtOC40OCwxNi40NC0xMS42N2gwYTEzLjE2LDEzLjE2LDAsMCwwLDEzLDEwLjkxLDEzLjUzLDEzLjUzLDAsMCwwLDEuODEtLjEyLDE1LjIyLDE1LjIyLDAsMCwwLC4xMS0xLjc5QTE0LjM0LDE0LjM0LDAsMCwwLDEwMC43Nyw2Mi41WiIvPgogIDxwYXRoIGNsYXNzPSJjbHMtMSIKICAgICAgICBkPSJNNDguNDQsNDYuMjRjLTEwLDQuODgtMTUuNjYsMTYuMjYtMTUuNjYsMTYuMjZzNS42NSwxMS4zOCwxNS42NiwxNi4yNmEyNi4xNSwyNi4xNSwwLDAsMCwwLTMyLjUyWk00NS45LDYwLjcxYTIuMTUsMi4xNSwwLDEsMSwyLjE1LTIuMTVBMi4xNiwyLjE2LDAsMCwxLDQ1LjksNjAuNzFaIi8+Cjwvc3ZnPgo="

/***/ },
/* 445 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEzOSAxMjUiPgogIDx0aXRsZT5TZW1lbnRlcyBkZSBzw6lzYW1vIGUgcHJvZHV0b3Mgw6AgYmFzZSBkZSBzZW1lbnRlcyBkZSBzw6lzYW1vPC90aXRsZT4KICA8cGF0aAogICAgZD0iTTY5LjUsNS45MkE1Ni41OCw1Ni41OCwwLDEsMCwxMjYuMDgsNjIuNSw1Ni41OCw1Ni41OCwwLDAsMCw2OS41LDUuOTJabTAsMTA3LjMzQTUwLjc1LDUwLjc1LDAsMSwxLDEyMC4yNSw2Mi41LDUwLjc1LDUwLjc1LDAsMCwxLDY5LjUsMTEzLjI1WiIvPgogIDxyZWN0IHg9IjI3LjcyIiB5PSI4OC44NiIgd2lkdGg9IjI2LjA0IiBoZWlnaHQ9IjYuMzMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01My4xNCA1NS43Nikgcm90YXRlKC00NSkiLz4KICA8cmVjdCB4PSI5Ni41IiB5PSIyNS45MiIgd2lkdGg9IjE0LjM2IiBoZWlnaHQ9IjYuMzMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuOCA4MS44Mykgcm90YXRlKC00NSkiLz4KICA8cGF0aAogICAgZD0iTTY5LjUxLDYxQzYzLjE4LDY1Ljg4LDU4LDcxLjA3LDU2LjgxLDc4LDU2LDgzLDU3LjU4LDg3Ljc0LDYyLjE3LDkxLjZhMTEuMTUsMTEuMTUsMCwwLDAsMTUtLjIyYzQuMjMtMy43OCw1Ljc4LTguMzMsNS4xMS0xMy4xNEM4MS4yOCw3MS4xOSw3NS45MSw2NS45MSw2OS41MSw2MVoiLz4KICA8cGF0aAogICAgZD0iTTcxLjM1LDU3LjIyYzYuOTMsNCwxMy43LDYuOSwyMC41LDUuMzcsNS0xLjEzLDguNzgtNC40LDEwLjY0LTEwLjFBMTEuMTYsMTEuMTYsMCwwLDAsOTYuNjQsMzguN2MtNS4wOS0yLjUtOS44OS0yLjIyLTE0LjEuMjFDNzYuMzgsNDIuNDcsNzMuNTEsNDkuNDMsNzEuMzUsNTcuMjJaIi8+CiAgPHBhdGgKICAgIGQ9Ik02Ny42NSw1Ny4yMmMtNi45Myw0LTEzLjcsNi45LTIwLjUsNS4zNy01LTEuMTMtOC43OC00LjQtMTAuNjQtMTAuMUExMS4xNiwxMS4xNiwwLDAsMSw0Mi4zNiwzOC43YzUuMDktMi41LDkuODktMi4yMiwxNC4xLjIxQzYyLjYyLDQyLjQ3LDY1LjQ5LDQ5LjQzLDY3LjY1LDU3LjIyWiIvPgo8L3N2Zz4K"

/***/ },
/* 446 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 447 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjE1YTI0O30uY2xzLTJ7ZmlsbDojNGM0YzRjO30uY2xzLTIsLmNscy0ze29wYWNpdHk6MC41O30uY2xzLTN7ZmlsbDojNGI0YjRiO308L3N0eWxlPjwvZGVmcz48dGl0bGU+YmFkLWljb248L3RpdGxlPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iNTAuMjIiIGN5PSI1MC4wMSIgcj0iNDkuMDEiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik03NC43MywzNi4xM0M3NC4xLDQwLjE5LDcyLDQyLjgzLDY4LDQyLjgycy02LjY0LTIuMzgtNi41Mi02LjM5Yy4xMS0zLjUxLDIuNTItNS44LDYuMTgtNi4wNkM3MS44MywzMC4wOCw3My44OCwzMi41Miw3NC43MywzNi4xM1oiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0zMi4xMSw0M2MtMy42Ny0uNjUtNi41My0yLjI4LTYuNC02LjQ3LjEzLTQsMi42LTYuMjQsNi41OC02LjA4czYuMTMsMi43Miw2LDYuNjlDMzguMDksNDAuODcsMzUuNzUsNDIuNywzMi4xMSw0M1oiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik01MS4xLDU4LjkxYzguNTctLjU4LDE2LDMuMSwyMi4yNiw5LjQ2LDEuNSwxLjUzLDMuODgsMy4zNCwxLjgzLDUuNjYtMi4zOSwyLjctMy44My0uMjQtNS4zNS0xLjYzQzU3LjgsNjEuMzMsNDMuNDcsNjEsMzEuMTMsNzEuNjJjLTEuNzYsMS41MS0zLjY4LDQuNTctNi4wNSwxLjg4LTEuODctMi4xMiwxLTQuMTEsMi40LTUuNTJDMzMuNzksNjEuNjMsNDEuNSw1OC41Miw1MS4xLDU4LjkxWiIvPjwvc3ZnPg=="

/***/ },
/* 448 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItMTMxOTIgLTEzMDA4IDIzIDIzIj4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcC1JY29uX0dhbGVyaWFfQ2luemVudG8iPgogICAgICA8cmVjdCB4PSItMTMxOTIiIHk9Ii0xMzAwOCIgd2lkdGg9IjIzIiBoZWlnaHQ9IjIzIi8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KICA8ZyBpZD0iSWNvbl9HYWxlcmlhX0NpbnplbnRvIiBkYXRhLW5hbWU9Ikljb24gR2FsZXJpYSBDaW56ZW50byIgY2xhc3M9ImNscy0xIj4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTcyIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNzIiIGNsYXNzPSJjbHMtMiIgd2lkdGg9IjkuOTk0IiBoZWlnaHQ9IjkuODk1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMxOTIuMDkgLTEzMDA4KSIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNzMiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE3MyIgY2xhc3M9ImNscy0yIiB3aWR0aD0iOS45OTQiIGhlaWdodD0iOS44OTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzE3OC44NzQgLTEzMDA4KSIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNzQiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE3NCIgY2xhc3M9ImNscy0yIiB3aWR0aD0iMjMuOTk0IiBoZWlnaHQ9IjkuODk1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMxOTIuODc0IC0xMjk5NC44OTUpIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ },
/* 449 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwYXRoIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBkPSJNMTUuOTIzLDM0NS4wNDNDNTIuMDk0LDQ0Mi41MjcsMTQ1LjkyOSw1MTIsMjU2LDUxMnMyMDMuOTA2LTY5LjQ3MywyNDAuMDc3LTE2Ni45NTdMMjU2LDMyMi43ODMNCglMMTUuOTIzLDM0NS4wNDN6Ii8+DQo8cGF0aCBkPSJNMjU2LDBDMTQ1LjkyOSwwLDUyLjA5NCw2OS40NzIsMTUuOTIzLDE2Ni45NTdMMjU2LDE4OS4yMTdsMjQwLjA3Ny0yMi4yNjFDNDU5LjkwNiw2OS40NzIsMzY2LjA3MSwwLDI1NiwweiIvPg0KPHBhdGggc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIGQ9Ik0xNS45MjMsMTY2Ljk1N0M1LjYzMywxOTQuNjksMCwyMjQuNjg2LDAsMjU2czUuNjMzLDYxLjMxLDE1LjkyMyw4OS4wNDNoNDgwLjE1NQ0KCUM1MDYuMzY4LDMxNy4zMSw1MTIsMjg3LjMxNCw1MTIsMjU2cy01LjYzMi02MS4zMS0xNS45MjMtODkuMDQzSDE1LjkyM3oiLz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ },
/* 450 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxjaXJjbGUgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIGN4PSIyNTYiIGN5PSIyNTYiIHI9IjI1NiIvPgo8Zz4KCTxwYXRoIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBkPSJNNTIuOTIsMTAwLjE0MmMtMjAuMTA5LDI2LjE2My0zNS4yNzIsNTYuMzE4LTQ0LjEwMSw4OS4wNzdoMTMzLjE3OEw1Mi45MiwxMDAuMTQyeiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6IzAwNTJCNDsiIGQ9Ik01MDMuMTgxLDE4OS4yMTljLTguODI5LTMyLjc1OC0yMy45OTMtNjIuOTEzLTQ0LjEwMS04OS4wNzZsLTg5LjA3NSw4OS4wNzZINTAzLjE4MXoiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBkPSJNOC44MTksMzIyLjc4NGM4LjgzLDMyLjc1OCwyMy45OTMsNjIuOTEzLDQ0LjEwMSw4OS4wNzVsODkuMDc0LTg5LjA3NUw4LjgxOSwzMjIuNzg0TDguODE5LDMyMi43ODQKCQl6Ii8+Cgk8cGF0aCBzdHlsZT0iZmlsbDojMDA1MkI0OyIgZD0iTTQxMS44NTgsNTIuOTIxYy0yNi4xNjMtMjAuMTA5LTU2LjMxNy0zNS4yNzItODkuMDc2LTQ0LjEwMnYxMzMuMTc3TDQxMS44NTgsNTIuOTIxeiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6IzAwNTJCNDsiIGQ9Ik0xMDAuMTQyLDQ1OS4wNzljMjYuMTYzLDIwLjEwOSw1Ni4zMTgsMzUuMjcyLDg5LjA3Niw0NC4xMDJWMzcwLjAwNUwxMDAuMTQyLDQ1OS4wNzl6Ii8+Cgk8cGF0aCBzdHlsZT0iZmlsbDojMDA1MkI0OyIgZD0iTTE4OS4yMTcsOC44MTljLTMyLjc1OCw4LjgzLTYyLjkxMywyMy45OTMtODkuMDc1LDQ0LjEwMWw4OS4wNzUsODkuMDc1VjguODE5eiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6IzAwNTJCNDsiIGQ9Ik0zMjIuNzgzLDUwMy4xODFjMzIuNzU4LTguODMsNjIuOTEzLTIzLjk5Myw4OS4wNzUtNDQuMTAxbC04OS4wNzUtODkuMDc1VjUwMy4xODF6Ii8+Cgk8cGF0aCBzdHlsZT0iZmlsbDojMDA1MkI0OyIgZD0iTTM3MC4wMDUsMzIyLjc4NGw4OS4wNzUsODkuMDc2YzIwLjEwOC0yNi4xNjIsMzUuMjcyLTU2LjMxOCw0NC4xMDEtODkuMDc2SDM3MC4wMDV6Ii8+CjwvZz4KPGc+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRDgwMDI3OyIgZD0iTTUwOS44MzMsMjIyLjYwOWgtMjIwLjQ0aC0wLjAwMVYyLjE2N0MyNzguNDYxLDAuNzQ0LDI2Ny4zMTcsMCwyNTYsMAoJCWMtMTEuMzE5LDAtMjIuNDYxLDAuNzQ0LTMzLjM5MSwyLjE2N3YyMjAuNDR2MC4wMDFIMi4xNjdDMC43NDQsMjMzLjUzOSwwLDI0NC42ODMsMCwyNTZjMCwxMS4zMTksMC43NDQsMjIuNDYxLDIuMTY3LDMzLjM5MQoJCWgyMjAuNDRoMC4wMDF2MjIwLjQ0MkMyMzMuNTM5LDUxMS4yNTYsMjQ0LjY4MSw1MTIsMjU2LDUxMmMxMS4zMTcsMCwyMi40NjEtMC43NDMsMzMuMzkxLTIuMTY3di0yMjAuNDR2LTAuMDAxaDIyMC40NDIKCQlDNTExLjI1NiwyNzguNDYxLDUxMiwyNjcuMzE5LDUxMiwyNTZDNTEyLDI0NC42ODMsNTExLjI1NiwyMzMuNTM5LDUwOS44MzMsMjIyLjYwOXoiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiNEODAwMjc7IiBkPSJNMzIyLjc4MywzMjIuNzg0TDMyMi43ODMsMzIyLjc4NEw0MzcuMDE5LDQzNy4wMmM1LjI1NC01LjI1MiwxMC4yNjYtMTAuNzQzLDE1LjA0OC0xNi40MzUKCQlsLTk3LjgwMi05Ny44MDJoLTMxLjQ4MlYzMjIuNzg0eiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIGQ9Ik0xODkuMjE3LDMyMi43ODRoLTAuMDAyTDc0Ljk4LDQzNy4wMTljNS4yNTIsNS4yNTQsMTAuNzQzLDEwLjI2NiwxNi40MzUsMTUuMDQ4bDk3LjgwMi05Ny44MDQKCQlWMzIyLjc4NHoiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiNEODAwMjc7IiBkPSJNMTg5LjIxNywxODkuMjE5di0wLjAwMkw3NC45ODEsNzQuOThjLTUuMjU0LDUuMjUyLTEwLjI2NiwxMC43NDMtMTUuMDQ4LDE2LjQzNWw5Ny44MDMsOTcuODAzCgkJSDE4OS4yMTd6Ii8+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRDgwMDI3OyIgZD0iTTMyMi43ODMsMTg5LjIxOUwzMjIuNzgzLDE4OS4yMTlMNDM3LjAyLDc0Ljk4MWMtNS4yNTItNS4yNTQtMTAuNzQzLTEwLjI2Ni0xNi40MzUtMTUuMDQ3CgkJbC05Ny44MDIsOTcuODAzVjE4OS4yMTl6Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=="

/***/ },
/* 451 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwYXRoIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBkPSJNMCwyNTZjMCwzMS4zMTQsNS42MzMsNjEuMzEsMTUuOTIzLDg5LjA0M0wyNTYsMzY3LjMwNGwyNDAuMDc3LTIyLjI2MQ0KCUM1MDYuMzY3LDMxNy4zMSw1MTIsMjg3LjMxNCw1MTIsMjU2cy01LjYzMy02MS4zMS0xNS45MjMtODkuMDQzTDI1NiwxNDQuNjk2TDE1LjkyMywxNjYuOTU3QzUuNjMzLDE5NC42OSwwLDIyNC42ODYsMCwyNTZ6Ii8+DQo8Zz4NCgk8cGF0aCBzdHlsZT0iZmlsbDojRDgwMDI3OyIgZD0iTTQ5Ni4wNzcsMTY2Ljk1N0M0NTkuOTA2LDY5LjQ3MywzNjYuMDcxLDAsMjU2LDBTNTIuMDk0LDY5LjQ3MywxNS45MjMsMTY2Ljk1N0g0OTYuMDc3eiIvPg0KCTxwYXRoIHN0eWxlPSJmaWxsOiNEODAwMjc7IiBkPSJNMTUuOTIzLDM0NS4wNDNDNTIuMDk0LDQ0Mi41MjcsMTQ1LjkyOSw1MTIsMjU2LDUxMnMyMDMuOTA2LTY5LjQ3MywyNDAuMDc3LTE2Ni45NTdIMTUuOTIzeiIvPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ },
/* 452 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMDA5MjQ1O30uY2xzLTJ7ZmlsbDojNGI0YjRiO30uY2xzLTIsLmNscy0ze29wYWNpdHk6MC41O30uY2xzLTN7ZmlsbDojNGM0YzRjO308L3N0eWxlPjwvZGVmcz48dGl0bGU+ZXhjZWxlbnRlLWljb248L3RpdGxlPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iNDkuNzEiIGN5PSI1MC4wMSIgcj0iNDkuMDEiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik00OS43Nyw4NC4wOGMtMTIuNywwLTI1LjEzLTkuNS0yOC40My0yMS42MS0xLjI1LTQuNiwwLTcuMjksNS03LjMxcTIzLjQ5LS4xMSw0NywwYzUuMjYsMCw1LjkzLDIuOSw0LjY5LDcuMzdBMjkuNjMsMjkuNjMsMCwwLDEsNDkuNzcsODQuMDhaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNNzQuMjIsMzYuMTNjLS42NCw0LjA2LTIuNzcsNi43LTYuNjksNi42OVM2MC44OSw0MC40NCw2MSwzNi40M2MuMTEtMy41MSwyLjUyLTUuOCw2LjE4LTYuMDZDNzEuMzIsMzAuMDgsNzMuMzcsMzIuNTIsNzQuMjIsMzYuMTNaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMzEuNiw0M2MtMy42Ny0uNjUtNi41My0yLjI4LTYuNC02LjQ3LjEzLTQsMi42LTYuMjQsNi41OC02LjA4czYuMTMsMi43Miw2LDYuNjlDMzcuNTcsNDAuODcsMzUuMjQsNDIuNywzMS42LDQzWiIvPjwvc3ZnPg=="

/***/ },
/* 453 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Y2lyY2xlIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiBjeD0iMjU2IiBjeT0iMjU2IiByPSIyNTYiLz4KPHBhdGggc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIGQ9Ik01MTIsMjU2YzAtMTEwLjA3MS02OS40NzItMjAzLjkwNi0xNjYuOTU3LTI0MC4wNzd2NDgwLjE1NUM0NDIuNTI4LDQ1OS45MDYsNTEyLDM2Ni4wNzEsNTEyLDI1NnoiLz4KPHBhdGggc3R5bGU9ImZpbGw6IzAwNTJCNDsiIGQ9Ik0wLDI1NmMwLDExMC4wNzEsNjkuNDczLDIwMy45MDYsMTY2Ljk1NywyNDAuMDc3VjE1LjkyM0M2OS40NzMsNTIuMDk0LDAsMTQ1LjkyOSwwLDI1NnoiLz4KPC9zdmc+Cg=="

/***/ },
/* 454 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMzliNTRhO30uY2xzLTJ7ZmlsbDojNGM0YzRjO30uY2xzLTIsLmNscy0ze29wYWNpdHk6MC41O30uY2xzLTN7ZmlsbDojNGI0YjRiO308L3N0eWxlPjwvZGVmcz48dGl0bGU+Z29vZC1pY29uPC90aXRsZT48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjUwLjM4IiBjeT0iNTAuMDkiIHI9IjQ5LjAxIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNzQuODksMzYuMjFjLS42NCw0LjA2LTIuNzcsNi43LTYuNjksNi42OXMtNi42NC0yLjM4LTYuNTItNi4zOWMuMTEtMy41MSwyLjUyLTUuOCw2LjE4LTYuMDZDNzIsMzAuMTcsNzQsMzIuNiw3NC44OSwzNi4yMVoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0zMi4yNyw0My4xMWMtMy42Ny0uNjUtNi41My0yLjI4LTYuNC02LjQ3LjEzLTQsMi42LTYuMjQsNi41OC02LjA4czYuMTMsMi43Miw2LDYuNjlDMzguMjQsNDEsMzUuOSw0Mi43OSwzMi4yNyw0My4xMVoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik00OS41LDc4Yy04LjU3LjU4LTE2LTMuMS0yMi4yNi05LjQ2LTEuNS0xLjUzLTMuODgtMy4zNC0xLjgzLTUuNjYsMi4zOS0yLjcsMy44My4yNCw1LjM1LDEuNjMsMTIsMTEuMDcsMjYuMzYsMTEuMzYsMzguNzEuNzgsMS43Ni0xLjUxLDMuNjgtNC41Nyw2LjA1LTEuODgsMS44NywyLjEyLTEsNC4xMS0yLjQsNS41MkM2Ni44MSw3NS4zMiw1OS4xLDc4LjQzLDQ5LjUsNzhaIi8+PC9zdmc+"

/***/ },
/* 455 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxjaXJjbGUgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIGN4PSIyNTYiIGN5PSIyNTYiIHI9IjI1NiIvPg0KPHBhdGggc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIGQ9Ik01MTIsMjU2YzAtMTEwLjA3MS02OS40NzItMjAzLjkwNi0xNjYuOTU3LTI0MC4wNzd2NDgwLjE1NUM0NDIuNTI4LDQ1OS45MDYsNTEyLDM2Ni4wNzEsNTEyLDI1NnoiLz4NCjxwYXRoIHN0eWxlPSJmaWxsOiM2REE1NDQ7IiBkPSJNMCwyNTZjMCwxMTAuMDcxLDY5LjQ3MiwyMDMuOTA2LDE2Ni45NTcsMjQwLjA3N1YxNS45MjNDNjkuNDcyLDUyLjA5NCwwLDE0NS45MjksMCwyNTZ6Ii8+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ },
/* 456 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 457 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQxMi4yNSA2MjMuNjIiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+bXktcGljay1pY29uLWJyYW5jbzwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzc0Ljc5LDUyLjVhMTEuMDYsMTEuMDYsMCwwLDAtMTEuMDgtMTEuMDdINDguNTFBMTEuMDcsMTEuMDcsMCwwLDAsMzcuNDQsNTIuNTFjMCw1NS4yMSwwLDM4OCwwLDUxMy43NiwwLDMtLjI4LDYsLjUyLDguODcsMS45MSw2Ljg5LDgsOSwxNCw1LjE4YTQyLjMxLDQyLjMxLDAsMCwwLDYuNTctNS42NnE3MC42NS02OCwxNDEuMjctMTM1Ljk0YzIuMDUtMiw0LjI2LTMuOCw2LjU1LTUuODQsMi44OSwyLjczLDUuMjYsNC45Myw3LjU5LDcuMTdxNzAuNjMsNjgsMTQxLjQxLDEzNS43OWMzLjMyLDMuMTYsMTAsNi4zNiwxMy4yOSw1czYuMTEtOC4zNSw2LjEyLTEyLjg3QzM3NC44Myw0NDEuMzcsMzc0LjgsMTA3LjczLDM3NC43OSw1Mi41Wk0yNjAuMTksMjEwLjEydjM3LjY1YTE2LjQyLDE2LjQyLDAsMCwxLTE2LjQyLDE2LjQySDIwNi4xMnY1NC4wN0gxNTIuMDVWMTU2aDkxLjY3YTE2LjQ4LDE2LjQ4LDAsMCwxLDE2LjQ4LDE2LjQ4WiIvPjwvc3ZnPg=="

/***/ },
/* 458 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQxMi4yNSA2MjMuNjIiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojOGMxZTI2O30uY2xzLTJ7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+bXktcGljay1pY29uLWF0aXZvPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zNTkuMjQsMzQuODhINTNBMTIuMjcsMTIuMjcsMCwwLDAsNDAuNjgsNDcuMTVsLjEyLDUyOC40OWMzLjg5LTMuNjYsNi40NS02LDktOC40M0wxOTQsNDI4LjM2YzEwLjgtMTAuNCwxMy42Mi0xMC40MSwyNC4zOSwwTDM2Mi42Niw1NjcuMTdjMi41MiwyLjQzLDUuMDksNC44LDksOC40NmwtLjEyLTUyOC40N0ExMi4yNywxMi4yNywwLDAsMCwzNTkuMjQsMzQuODhabS05My4zLDIwNi4zOGExOC4xNiwxOC4xNiwwLDAsMS0xOC4xNiwxOC4xNkgyMDYuMTJ2NTkuODJIMTQ2LjNWMTM5Ljc4SDI0Ny43MkExOC4yMywxOC4yMywwLDAsMSwyNjUuOTQsMTU4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTI0Ny43NSwxMzkuNDlIMTQ2LjM0VjMxOC45NWg1OS44MlYyNTkuMTNoNDEuNjZBMTguMTYsMTguMTYsMCwwLDAsMjY2LDI0MVYxNTcuNzJBMTguMjMsMTguMjMsMCwwLDAsMjQ3Ljc1LDEzOS40OVpNMzkyLjY4LDI0Ljk0YTEyLjI0LDEyLjI0LDAsMCwwLTEyLjI1LTEyLjI1SDMxLjcxQTEyLjI0LDEyLjI0LDAsMCwwLDE5LjQ2LDI0Ljk0YzAsNjEuMDguMTEsNDI5LjIzLjEyLDU2OC4zOCwwLDMuMzEtLjMxLDYuNjMuNTcsOS44MSwyLjExLDcuNjMsOC44LDkuOTIsMTUuNTEsNS43M2E0Ni44MSw0Ni44MSwwLDAsMCw3LjI3LTYuMjZxNzguMTYtNzUuMTgsMTU2LjI5LTE1MC4zOWMyLjI3LTIuMTksNC43MS00LjIsNy4yNS02LjQ2LDMuMiwzLDUuODIsNS40NSw4LjQsNy45NFEyOTMsNTI4LjksMzcxLjMsNjAzLjkyYzMuNjgsMy41LDExLjExLDcsMTQuNzEsNS41NHM2Ljc2LTkuMjMsNi43Ny0xNC4yNEMzOTIuODEsNDU1LjE0LDM5Mi42OSw4NiwzOTIuNjgsMjQuOTRabS0zMCw1NDEuOTRMMjE4LjQ0LDQyOGMtMTAuNzctMTAuMzYtMTMuNTgtMTAuMzYtMjQuMzksMEw0OS43OSw1NjYuOTJjLTIuNTEsMi40MS01LjA2LDQuNzctOSw4LjQzTDQwLjcyLDQ2Ljg2QTEyLjI3LDEyLjI3LDAsMCwxLDUzLDM0LjU5SDM1OS4yOGExMi4yNywxMi4yNywwLDAsMSwxMi4yNywxMi4yN2wuMTIsNTI4LjQ3QzM2Ny43OSw1NzEuNjgsMzY1LjIyLDU2OS4zMSwzNjIuNyw1NjYuODhaIi8+PC9zdmc+"

/***/ },
/* 459 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQxMi4yNSA2MjMuNjIiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO30uY2xzLTJ7ZmlsbDojOGMxZTI2O308L3N0eWxlPjwvZGVmcz48dGl0bGU+bXktcGljay1pY29uLWRlc2F0aXZvPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zNTkuMjQsMzQuODhINTNBMTIuMjcsMTIuMjcsMCwwLDAsNDAuNjgsNDcuMTVsLjEyLDUyOC40OWMzLjg5LTMuNjYsNi40NS02LDktOC40M0wxOTQsNDI4LjM2YzEwLjgtMTAuNCwxMy42Mi0xMC40MSwyNC4zOSwwTDM2Mi42Niw1NjcuMTdjMi41MiwyLjQzLDUuMDksNC44LDksOC40NmwtLjEyLTUyOC40N0ExMi4yNywxMi4yNywwLDAsMCwzNTkuMjQsMzQuODhabS05My4zLDIwNi4zOGExOC4xNiwxOC4xNiwwLDAsMS0xOC4xNiwxOC4xNkgyMDYuMTJ2NTkuODJIMTQ2LjNWMTM5Ljc4SDI0Ny43MkExOC4yMywxOC4yMywwLDAsMSwyNjUuOTQsMTU4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTM5Mi42OCwyNC45NGExMi4yNCwxMi4yNCwwLDAsMC0xMi4yNS0xMi4yNUgzMS43MUExMi4yNCwxMi4yNCwwLDAsMCwxOS40NiwyNC45NGMwLDYxLjA4LjExLDQyOS4yMy4xMiw1NjguMzgsMCwzLjMxLS4zMSw2LjYzLjU3LDkuODEsMi4xMSw3LjYzLDguOCw5LjkyLDE1LjUxLDUuNzNhNDYuODEsNDYuODEsMCwwLDAsNy4yNy02LjI2cTc4LjE2LTc1LjE4LDE1Ni4yOS0xNTAuMzljMi4yNy0yLjE5LDQuNzEtNC4yLDcuMjUtNi40NiwzLjIsMyw1LjgyLDUuNDUsOC40LDcuOTRRMjkzLDUyOC45LDM3MS4zLDYwMy45MmMzLjY4LDMuNSwxMS4xMSw3LDE0LjcxLDUuNTRzNi43Ni05LjIzLDYuNzctMTQuMjRDMzkyLjgxLDQ1NS4xNCwzOTIuNjksODYsMzkyLjY4LDI0Ljk0Wm0tMzAsNTQxLjk0TDIxOC40NCw0MjhjLTEwLjc3LTEwLjM2LTEzLjU4LTEwLjM2LTI0LjM5LDBMNDkuNzksNTY2LjkyYy0yLjUxLDIuNDEtNS4wNiw0Ljc3LTksOC40M0w0MC43Miw0Ni44NkExMi4yNywxMi4yNywwLDAsMSw1MywzNC41OUgzNTkuMjhhMTIuMjcsMTIuMjcsMCwwLDEsMTIuMjcsMTIuMjdsLjEyLDUyOC40N0MzNjcuNzksNTcxLjY4LDM2NS4yMiw1NjkuMzEsMzYyLjcsNTY2Ljg4Wk0yNDcuNzUsMTM5LjQ5SDE0Ni4zNFYzMTguOTVoNTkuODJWMjU5LjEzaDQxLjY2QTE4LjE2LDE4LjE2LDAsMCwwLDI2NiwyNDFWMTU3LjcyQTE4LjIzLDE4LjIzLDAsMCwwLDI0Ny43NSwxMzkuNDlaIi8+PC9zdmc+"

/***/ },
/* 460 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 461 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQwIDMwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmJ1cmdlciBtZW51PC90aXRsZT48cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0MCIgaGVpZ2h0PSIzLjA1Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB5PSIxMy40NyIgd2lkdGg9IjQwIiBoZWlnaHQ9IjMuMDUiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHk9IjI2Ljk1IiB3aWR0aD0iNDAiIGhlaWdodD0iMy4wNSIvPjwvc3ZnPg=="

/***/ },
/* 462 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxjaXJjbGUgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIGN4PSIyNTYiIGN5PSIyNTYiIHI9IjI1NiIvPg0KPHBhdGggc3R5bGU9ImZpbGw6I0EyMDAxRDsiIGQ9Ik0yNTYsMEMxNDUuOTI5LDAsNTIuMDk0LDY5LjQ3MiwxNS45MjMsMTY2Ljk1N2g0ODAuMTU1QzQ1OS45MDYsNjkuNDcyLDM2Ni4wNzEsMCwyNTYsMHoiLz4NCjxwYXRoIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBkPSJNMjU2LDUxMmMxMTAuMDcxLDAsMjAzLjkwNi02OS40NzIsMjQwLjA3Ny0xNjYuOTU3SDE1LjkyM0M1Mi4wOTQsNDQyLjUyOCwxNDUuOTI5LDUxMiwyNTYsNTEyeiIvPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ },
/* 463 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmJiMDNiO30uY2xzLTJ7ZmlsbDojNGM0YzRjO30uY2xzLTIsLmNscy0ze29wYWNpdHk6MC41O30uY2xzLTN7ZmlsbDojNGI0YjRiO308L3N0eWxlPjwvZGVmcz48dGl0bGU+b2staWNvbjwvdGl0bGU+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSI0OS43MiIgY3k9IjUwLjAxIiByPSI0OS4wMSIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTc0LjIzLDM2LjEzYy0uNjQsNC4wNi0yLjc3LDYuNy02LjY5LDYuNjlTNjAuOSw0MC40NCw2MSwzNi40M2MuMTEtMy41MSwyLjUyLTUuOCw2LjE4LTYuMDZDNzEuMzMsMzAuMDgsNzMuMzgsMzIuNTIsNzQuMjMsMzYuMTNaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMzEuNjEsNDNjLTMuNjctLjY1LTYuNTMtMi4yOC02LjQtNi40Ny4xMy00LDIuNi02LjI0LDYuNTgtNi4wOHM2LjEzLDIuNzIsNiw2LjY5QzM3LjU4LDQwLjg3LDM1LjI1LDQyLjcsMzEuNjEsNDNaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNNDguOTQsNzEuNzFjLTYuMzQsMC0xMi42OC4wNi0xOSwwLTEuODQsMC00LjUyLjQ3LTQuNzMtMi4yMXMyLjQ0LTIuNzgsNC4zMi0yLjc5cTIwLjMyLS4xMiw0MC42NSwwYzEuNywwLDQsLjA1LDQuMDksMi4zMS4xMiwyLjg0LTIuNDcsMi42Ni00LjM0LDIuNjktNywuMS0xNCwwLTIxLDBaIi8+PC9zdmc+"

/***/ },
/* 464 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDUyNiA3NzAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+UHJhbmNoZXRhIDE2PC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMS44MSw0OTguNTVoMjMxLjRWMjcxLjg4SDIxLjgxWm0wLDI1MC42NmgyMzEuNFY1MTguMDhIMjEuODFabTI1MS0yNTAuNjZINDMyLjQ1YzM5LjYyLDAsNzEuNzMtMzEuNDgsNzEuNzMtNzAuM1YyNzEuODhIMjcyLjc5Wk0yMS44MSwyNTIuM2gyMzEuNFYyMC43OEgyMS44MVpNNDMyLjE5LDIwLjc4SDI3Mi43OVYyNTIuM2gyMzEuNFY5Mi43OEE3Miw3MiwwLDAsMCw0MzIuMTksMjAuNzhaIi8+PC9zdmc+"

/***/ },
/* 465 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CiAgPHBhdGggc3R5bGU9ImZpbGw6IzZEQTU0NDsiIGQ9Ik0wLDI1NmMwLDExMC4wNyw2OS40NzIsMjAzLjkwNSwxNjYuOTU1LDI0MC4wNzZsMjIuMjYyLTI0MC4wNzdMMTY2Ljk1NSwxNS45MjMKICAgIEM2OS40NzIsNTIuMDk1LDAsMTQ1LjkyOSwwLDI1NnoiLz4KICA8cGF0aCBzdHlsZT0iZmlsbDojRDgwMDI3OyIgZD0iTTUxMiwyNTZDNTEyLDExNC42MTYsMzk3LjM4NCwwLDI1NiwwYy0zMS4zMTQsMC02MS4zMTEsNS42MzMtODkuMDQ1LDE1LjkyM3Y0ODAuMTU0CiAgICBDMTk0LjY4OSw1MDYuMzY4LDIyNC42ODYsNTEyLDI1Niw1MTJDMzk3LjM4NCw1MTIsNTEyLDM5Ny4zODQsNTEyLDI1NnoiLz4KICA8Y2lyY2xlIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBjeD0iMTY2Ljk1NyIgY3k9IjI1NiIgcj0iODkuMDQzIi8+CiAgPHBhdGggc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIGQ9Ik0xMTYuODcsMjExLjQ3OHY1NS42NTJjMCwyNy42NjIsMjIuNDI0LDUwLjA4Nyw1MC4wODcsNTAuMDg3czUwLjA4Ny0yMi40MjQsNTAuMDg3LTUwLjA4N3YtNTUuNjUyCiAgICBIMTE2Ljg3eiIvPgogIDxwYXRoIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiBkPSJNMTY2Ljk1NywyODMuODI2Yy05LjIwNiwwLTE2LjY5Ni03LjQ5LTE2LjY5Ni0xNi42OTZWMjQ0Ljg3aDMzLjM5MXYyMi4yNjEKICAgIEMxODMuNjUyLDI3Ni4zMzYsMTc2LjE2MiwyODMuODI2LDE2Ni45NTcsMjgzLjgyNnoiLz4KPC9zdmc+Cg=="

/***/ },
/* 466 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZWQxYzI0O30uY2xzLTJ7ZmlsbDojNGI0YjRiO30uY2xzLTIsLmNscy0ze29wYWNpdHk6MC41O30uY2xzLTN7ZmlsbDojNGM0YzRjO308L3N0eWxlPjwvZGVmcz48dGl0bGU+dGVycmlibGUtaWNvbjwvdGl0bGU+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSI0OS42IiBjeT0iNTAuMDEiIHI9IjQ5LjAxIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNDkuNjEsNTIuMjJjMTIuNywwLDI1LjEsOS41NywyOC4zNywyMS42OSwxLjI0LDQuNjEsMCw3LjI5LTUsNy4zcS0yMy40OSwwLTQ3LS4xYy01LjI2LDAtNS45Mi0yLjkxLTQuNjctNy4zOEEyOS42MywyOS42MywwLDAsMSw0OS42MSw1Mi4yMloiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik03NC40NywzNi4xM2MtLjY0LDQuMDYtMi43Nyw2LjctNi42OSw2LjY5cy02LjY0LTIuMzgtNi41Mi02LjM5Yy4xMS0zLjUxLDIuNTItNS44LDYuMTgtNi4wNkM3MS41NiwzMC4wOCw3My42MSwzMi41Miw3NC40NywzNi4xM1oiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0zMS44NCw0M2MtMy42Ny0uNjUtNi41My0yLjI4LTYuNC02LjQ3LjEzLTQsMi42LTYuMjQsNi41OC02LjA4czYuMTMsMi43Miw2LDYuNjlDMzcuODIsNDAuODcsMzUuNDgsNDIuNywzMS44NCw0M1oiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yNy43NiwxOS4zNmMzLjczLDEuNjEsOC4zNywzLjU2LDEzLDUuNjMsMS44My44MiwxLjU3LDIuMzguODksMy44NUEyLjE1LDIuMTUsMCwwLDEsMzguNTIsMzBjLTQuNDItMS44NC04Ljg3LTMuNjItMTMuMjQtNS41Ny0xLjQ4LS42Ni0yLjM1LTEuOTQtMS41NS0zLjdDMjQuMzIsMTkuNDQsMjUuMzUsMTguODgsMjcuNzYsMTkuMzZaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNNjEuMzIsMjkuOTJjLTIuNTEuMzItMy40NS0uNC00LTEuNjZzLS40MS0yLjU5LDEtMy4xOXE2Ljg5LTMsMTMuODctNS44NGEyLjMyLDIuMzIsMCwwLDEsMy4xMSwxLjMyYy42NCwxLjIyLjksMi41Ny0uNTIsMy4yNEM3MCwyNi4wNyw2NS4xOSwyOC4xNyw2MS4zMiwyOS45MloiLz48L3N2Zz4="

/***/ },
/* 467 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 *
	 *
	 * @author Jerry Bendy <jerry@icewingcc.com>
	 * @licence MIT
	 *
	 */
	
	(function(self) {
	    'use strict';
	
	    var nativeURLSearchParams = self.URLSearchParams ? self.URLSearchParams : null,
	        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
	        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
	        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
	        __URLSearchParams__ = "__URLSearchParams__",
	        prototype = URLSearchParamsPolyfill.prototype,
	        iterable = !!(self.Symbol && self.Symbol.iterator);
	
	    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly) {
	        return;
	    }
	
	
	    /**
	     * Make a URLSearchParams instance
	     *
	     * @param {object|string|URLSearchParams} search
	     * @constructor
	     */
	    function URLSearchParamsPolyfill(search) {
	        search = search || "";
	
	        // support construct object with another URLSearchParams instance
	        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
	            search = search.toString();
	        }
	
	        this [__URLSearchParams__] = parseToDict(search);
	    }
	
	
	    /**
	     * Appends a specified key/value pair as a new search parameter.
	     *
	     * @param {string} name
	     * @param {string} value
	     */
	    prototype.append = function(name, value) {
	        appendTo(this [__URLSearchParams__], name, value);
	    };
	
	    /**
	     * Deletes the given search parameter, and its associated value,
	     * from the list of all search parameters.
	     *
	     * @param {string} name
	     */
	    prototype.delete = function(name) {
	        delete this [__URLSearchParams__] [name];
	    };
	
	    /**
	     * Returns the first value associated to the given search parameter.
	     *
	     * @param {string} name
	     * @returns {string|null}
	     */
	    prototype.get = function(name) {
	        var dict = this [__URLSearchParams__];
	        return name in dict ? dict[name][0] : null;
	    };
	
	    /**
	     * Returns all the values association with a given search parameter.
	     *
	     * @param {string} name
	     * @returns {Array}
	     */
	    prototype.getAll = function(name) {
	        var dict = this [__URLSearchParams__];
	        return name in dict ? dict [name].slice(0) : [];
	    };
	
	    /**
	     * Returns a Boolean indicating if such a search parameter exists.
	     *
	     * @param {string} name
	     * @returns {boolean}
	     */
	    prototype.has = function(name) {
	        return name in this [__URLSearchParams__];
	    };
	
	    /**
	     * Sets the value associated to a given search parameter to
	     * the given value. If there were several values, delete the
	     * others.
	     *
	     * @param {string} name
	     * @param {string} value
	     */
	    prototype.set = function set(name, value) {
	        this [__URLSearchParams__][name] = ['' + value];
	    };
	
	    /**
	     * Returns a string containg a query string suitable for use in a URL.
	     *
	     * @returns {string}
	     */
	    prototype.toString = function() {
	        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
	        for (key in dict) {
	            name = encode(key);
	            for (i = 0, value = dict[key]; i < value.length; i++) {
	                query.push(name + '=' + encode(value[i]));
	            }
	        }
	        return query.join('&');
	    };
	
	    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
	    var forSureUsePolyfill = !decodesPlusesCorrectly;
	    var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy)
	    /*
	     * Apply polifill to global object and append other prototype into it
	     */
	    self.URLSearchParams = useProxy ?
	        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
	        new Proxy(nativeURLSearchParams, {
	            construct: function(target, args) {
	                return new target((new URLSearchParamsPolyfill(args[0]).toString()));
	            }
	        }) :
	        URLSearchParamsPolyfill;
	
	
	    var USPProto = self.URLSearchParams.prototype;
	
	    USPProto.polyfill = true;
	
	    /**
	     *
	     * @param {function} callback
	     * @param {object} thisArg
	     */
	    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
	        var dict = parseToDict(this.toString());
	        Object.getOwnPropertyNames(dict).forEach(function(name) {
	            dict[name].forEach(function(value) {
	                callback.call(thisArg, value, name, this);
	            }, this);
	        }, this);
	    };
	
	    /**
	     * Sort all name-value pairs
	     */
	    USPProto.sort = USPProto.sort || function() {
	        var dict = parseToDict(this.toString()), keys = [], k, i, j;
	        for (k in dict) {
	            keys.push(k);
	        }
	        keys.sort();
	
	        for (i = 0; i < keys.length; i++) {
	            this.delete(keys[i]);
	        }
	        for (i = 0; i < keys.length; i++) {
	            var key = keys[i], values = dict[key];
	            for (j = 0; j < values.length; j++) {
	                this.append(key, values[j]);
	            }
	        }
	    };
	
	    /**
	     * Returns an iterator allowing to go through all keys of
	     * the key/value pairs contained in this object.
	     *
	     * @returns {function}
	     */
	    USPProto.keys = USPProto.keys || function() {
	        var items = [];
	        this.forEach(function(item, name) {
	            items.push([name]);
	        });
	        return makeIterator(items);
	    };
	
	    /**
	     * Returns an iterator allowing to go through all values of
	     * the key/value pairs contained in this object.
	     *
	     * @returns {function}
	     */
	    USPProto.values = USPProto.values || function() {
	        var items = [];
	        this.forEach(function(item) {
	            items.push([item]);
	        });
	        return makeIterator(items);
	    };
	
	    /**
	     * Returns an iterator allowing to go through all key/value
	     * pairs contained in this object.
	     *
	     * @returns {function}
	     */
	    USPProto.entries = USPProto.entries || function() {
	        var items = [];
	        this.forEach(function(item, name) {
	            items.push([name, item]);
	        });
	        return makeIterator(items);
	    };
	
	
	    if (iterable) {
	        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
	    }
	
	
	    function encode(str) {
	        var replace = {
	            '!': '%21',
	            "'": '%27',
	            '(': '%28',
	            ')': '%29',
	            '~': '%7E',
	            '%20': '+',
	            '%00': '\x00'
	        };
	        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
	            return replace[match];
	        });
	    }
	
	    function decode(str) {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    }
	
	    function makeIterator(arr) {
	        var iterator = {
	            next: function() {
	                var value = arr.shift();
	                return {done: value === undefined, value: value};
	            }
	        };
	
	        if (iterable) {
	            iterator[self.Symbol.iterator] = function() {
	                return iterator;
	            };
	        }
	
	        return iterator;
	    }
	
	    function parseToDict(search) {
	        var dict = {};
	
	        if (typeof search === "object") {
	            for (var i in search) {
	                if (search.hasOwnProperty(i)) {
	                    var str = typeof search [i] === 'string' ? search [i] : JSON.stringify(search [i]);
	                    appendTo(dict, i, str);
	                }
	            }
	
	        } else {
	            // remove first '?'
	            if (search.indexOf("?") === 0) {
	                search = search.slice(1);
	            }
	
	            var pairs = search.split("&");
	            for (var j = 0; j < pairs.length; j++) {
	                var value = pairs [j],
	                    index = value.indexOf('=');
	
	                if (-1 < index) {
	                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
	
	                } else {
	                    if (value) {
	                        appendTo(dict, decode(value), '');
	                    }
	                }
	            }
	        }
	
	        return dict;
	    }
	
	    function appendTo(dict, name, value) {
	        if (name in dict) {
	            dict[name].push('' + value);
	        } else {
	            dict[name] = ['' + value];
	        }
	    }
	
	})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 468 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 469 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 470 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 471 */
470,
/* 472 */
470,
/* 473 */
470,
/* 474 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(__webpack_module_template_argument_0__), src$en$$ = __webpack_require__(__webpack_module_template_argument_1__);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** assets/javascript/main.a7eb8dd02bde4a966ebb.js
 **/